//#region \0rolldown/runtime.js
var e = Object.create, t = Object.defineProperty, n = Object.getOwnPropertyDescriptor, r = Object.getOwnPropertyNames, i = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty, o = (e, t, n) => () => {
	if (n) throw n[0];
	try {
		return e && (t = e(e = 0)), t;
	} catch (e) {
		throw n = [e], e;
	}
}, s = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), c = (e, n) => {
	let r = {};
	for (var i in e) t(r, i, {
		get: e[i],
		enumerable: !0
	});
	return n || t(r, Symbol.toStringTag, { value: "Module" }), r;
}, l = (e, i, o, s) => {
	if (i && typeof i == "object" || typeof i == "function") for (var c = r(i), l = 0, u = c.length, d; l < u; l++) d = c[l], !a.call(e, d) && d !== o && t(e, d, {
		get: ((e) => i[e]).bind(null, d),
		enumerable: !(s = n(i, d)) || s.enumerable
	});
	return e;
}, u = (n, r, a) => (a = n == null ? {} : e(i(n)), l(r || !n || !n.__esModule ? t(a, "default", {
	value: n,
	enumerable: !0
}) : a, n));
//#endregion
//#region node_modules/pathseg/pathseg.js
(function() {
	typeof window > "u" || ("SVGPathSeg" in window || (window.SVGPathSeg = function(e, t, n) {
		this.pathSegType = e, this.pathSegTypeAsLetter = t, this._owningPathSegList = n;
	}, window.SVGPathSeg.prototype.classname = "SVGPathSeg", window.SVGPathSeg.PATHSEG_UNKNOWN = 0, window.SVGPathSeg.PATHSEG_CLOSEPATH = 1, window.SVGPathSeg.PATHSEG_MOVETO_ABS = 2, window.SVGPathSeg.PATHSEG_MOVETO_REL = 3, window.SVGPathSeg.PATHSEG_LINETO_ABS = 4, window.SVGPathSeg.PATHSEG_LINETO_REL = 5, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS = 6, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL = 7, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS = 8, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL = 9, window.SVGPathSeg.PATHSEG_ARC_ABS = 10, window.SVGPathSeg.PATHSEG_ARC_REL = 11, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS = 12, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL = 13, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS = 14, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL = 15, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS = 16, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL = 17, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS = 18, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL = 19, window.SVGPathSeg.prototype._segmentChanged = function() {
		this._owningPathSegList && this._owningPathSegList.segmentChanged(this);
	}, window.SVGPathSegClosePath = function(e) {
		window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CLOSEPATH, "z", e);
	}, window.SVGPathSegClosePath.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegClosePath.prototype.toString = function() {
		return "[object SVGPathSegClosePath]";
	}, window.SVGPathSegClosePath.prototype._asPathString = function() {
		return this.pathSegTypeAsLetter;
	}, window.SVGPathSegClosePath.prototype.clone = function() {
		return new window.SVGPathSegClosePath(void 0);
	}, window.SVGPathSegMovetoAbs = function(e, t, n) {
		window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_MOVETO_ABS, "M", e), this._x = t, this._y = n;
	}, window.SVGPathSegMovetoAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegMovetoAbs.prototype.toString = function() {
		return "[object SVGPathSegMovetoAbs]";
	}, window.SVGPathSegMovetoAbs.prototype._asPathString = function() {
		return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
	}, window.SVGPathSegMovetoAbs.prototype.clone = function() {
		return new window.SVGPathSegMovetoAbs(void 0, this._x, this._y);
	}, Object.defineProperty(window.SVGPathSegMovetoAbs.prototype, "x", {
		get: function() {
			return this._x;
		},
		set: function(e) {
			this._x = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegMovetoAbs.prototype, "y", {
		get: function() {
			return this._y;
		},
		set: function(e) {
			this._y = e, this._segmentChanged();
		},
		enumerable: !0
	}), window.SVGPathSegMovetoRel = function(e, t, n) {
		window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_MOVETO_REL, "m", e), this._x = t, this._y = n;
	}, window.SVGPathSegMovetoRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegMovetoRel.prototype.toString = function() {
		return "[object SVGPathSegMovetoRel]";
	}, window.SVGPathSegMovetoRel.prototype._asPathString = function() {
		return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
	}, window.SVGPathSegMovetoRel.prototype.clone = function() {
		return new window.SVGPathSegMovetoRel(void 0, this._x, this._y);
	}, Object.defineProperty(window.SVGPathSegMovetoRel.prototype, "x", {
		get: function() {
			return this._x;
		},
		set: function(e) {
			this._x = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegMovetoRel.prototype, "y", {
		get: function() {
			return this._y;
		},
		set: function(e) {
			this._y = e, this._segmentChanged();
		},
		enumerable: !0
	}), window.SVGPathSegLinetoAbs = function(e, t, n) {
		window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_ABS, "L", e), this._x = t, this._y = n;
	}, window.SVGPathSegLinetoAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegLinetoAbs.prototype.toString = function() {
		return "[object SVGPathSegLinetoAbs]";
	}, window.SVGPathSegLinetoAbs.prototype._asPathString = function() {
		return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
	}, window.SVGPathSegLinetoAbs.prototype.clone = function() {
		return new window.SVGPathSegLinetoAbs(void 0, this._x, this._y);
	}, Object.defineProperty(window.SVGPathSegLinetoAbs.prototype, "x", {
		get: function() {
			return this._x;
		},
		set: function(e) {
			this._x = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegLinetoAbs.prototype, "y", {
		get: function() {
			return this._y;
		},
		set: function(e) {
			this._y = e, this._segmentChanged();
		},
		enumerable: !0
	}), window.SVGPathSegLinetoRel = function(e, t, n) {
		window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_REL, "l", e), this._x = t, this._y = n;
	}, window.SVGPathSegLinetoRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegLinetoRel.prototype.toString = function() {
		return "[object SVGPathSegLinetoRel]";
	}, window.SVGPathSegLinetoRel.prototype._asPathString = function() {
		return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
	}, window.SVGPathSegLinetoRel.prototype.clone = function() {
		return new window.SVGPathSegLinetoRel(void 0, this._x, this._y);
	}, Object.defineProperty(window.SVGPathSegLinetoRel.prototype, "x", {
		get: function() {
			return this._x;
		},
		set: function(e) {
			this._x = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegLinetoRel.prototype, "y", {
		get: function() {
			return this._y;
		},
		set: function(e) {
			this._y = e, this._segmentChanged();
		},
		enumerable: !0
	}), window.SVGPathSegCurvetoCubicAbs = function(e, t, n, r, i, a, o) {
		window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS, "C", e), this._x = t, this._y = n, this._x1 = r, this._y1 = i, this._x2 = a, this._y2 = o;
	}, window.SVGPathSegCurvetoCubicAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegCurvetoCubicAbs.prototype.toString = function() {
		return "[object SVGPathSegCurvetoCubicAbs]";
	}, window.SVGPathSegCurvetoCubicAbs.prototype._asPathString = function() {
		return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
	}, window.SVGPathSegCurvetoCubicAbs.prototype.clone = function() {
		return new window.SVGPathSegCurvetoCubicAbs(void 0, this._x, this._y, this._x1, this._y1, this._x2, this._y2);
	}, Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x", {
		get: function() {
			return this._x;
		},
		set: function(e) {
			this._x = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y", {
		get: function() {
			return this._y;
		},
		set: function(e) {
			this._y = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x1", {
		get: function() {
			return this._x1;
		},
		set: function(e) {
			this._x1 = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y1", {
		get: function() {
			return this._y1;
		},
		set: function(e) {
			this._y1 = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "x2", {
		get: function() {
			return this._x2;
		},
		set: function(e) {
			this._x2 = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegCurvetoCubicAbs.prototype, "y2", {
		get: function() {
			return this._y2;
		},
		set: function(e) {
			this._y2 = e, this._segmentChanged();
		},
		enumerable: !0
	}), window.SVGPathSegCurvetoCubicRel = function(e, t, n, r, i, a, o) {
		window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL, "c", e), this._x = t, this._y = n, this._x1 = r, this._y1 = i, this._x2 = a, this._y2 = o;
	}, window.SVGPathSegCurvetoCubicRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegCurvetoCubicRel.prototype.toString = function() {
		return "[object SVGPathSegCurvetoCubicRel]";
	}, window.SVGPathSegCurvetoCubicRel.prototype._asPathString = function() {
		return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
	}, window.SVGPathSegCurvetoCubicRel.prototype.clone = function() {
		return new window.SVGPathSegCurvetoCubicRel(void 0, this._x, this._y, this._x1, this._y1, this._x2, this._y2);
	}, Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x", {
		get: function() {
			return this._x;
		},
		set: function(e) {
			this._x = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y", {
		get: function() {
			return this._y;
		},
		set: function(e) {
			this._y = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x1", {
		get: function() {
			return this._x1;
		},
		set: function(e) {
			this._x1 = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y1", {
		get: function() {
			return this._y1;
		},
		set: function(e) {
			this._y1 = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "x2", {
		get: function() {
			return this._x2;
		},
		set: function(e) {
			this._x2 = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegCurvetoCubicRel.prototype, "y2", {
		get: function() {
			return this._y2;
		},
		set: function(e) {
			this._y2 = e, this._segmentChanged();
		},
		enumerable: !0
	}), window.SVGPathSegCurvetoQuadraticAbs = function(e, t, n, r, i) {
		window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS, "Q", e), this._x = t, this._y = n, this._x1 = r, this._y1 = i;
	}, window.SVGPathSegCurvetoQuadraticAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegCurvetoQuadraticAbs.prototype.toString = function() {
		return "[object SVGPathSegCurvetoQuadraticAbs]";
	}, window.SVGPathSegCurvetoQuadraticAbs.prototype._asPathString = function() {
		return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x + " " + this._y;
	}, window.SVGPathSegCurvetoQuadraticAbs.prototype.clone = function() {
		return new window.SVGPathSegCurvetoQuadraticAbs(void 0, this._x, this._y, this._x1, this._y1);
	}, Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "x", {
		get: function() {
			return this._x;
		},
		set: function(e) {
			this._x = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "y", {
		get: function() {
			return this._y;
		},
		set: function(e) {
			this._y = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "x1", {
		get: function() {
			return this._x1;
		},
		set: function(e) {
			this._x1 = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegCurvetoQuadraticAbs.prototype, "y1", {
		get: function() {
			return this._y1;
		},
		set: function(e) {
			this._y1 = e, this._segmentChanged();
		},
		enumerable: !0
	}), window.SVGPathSegCurvetoQuadraticRel = function(e, t, n, r, i) {
		window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL, "q", e), this._x = t, this._y = n, this._x1 = r, this._y1 = i;
	}, window.SVGPathSegCurvetoQuadraticRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegCurvetoQuadraticRel.prototype.toString = function() {
		return "[object SVGPathSegCurvetoQuadraticRel]";
	}, window.SVGPathSegCurvetoQuadraticRel.prototype._asPathString = function() {
		return this.pathSegTypeAsLetter + " " + this._x1 + " " + this._y1 + " " + this._x + " " + this._y;
	}, window.SVGPathSegCurvetoQuadraticRel.prototype.clone = function() {
		return new window.SVGPathSegCurvetoQuadraticRel(void 0, this._x, this._y, this._x1, this._y1);
	}, Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "x", {
		get: function() {
			return this._x;
		},
		set: function(e) {
			this._x = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "y", {
		get: function() {
			return this._y;
		},
		set: function(e) {
			this._y = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "x1", {
		get: function() {
			return this._x1;
		},
		set: function(e) {
			this._x1 = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegCurvetoQuadraticRel.prototype, "y1", {
		get: function() {
			return this._y1;
		},
		set: function(e) {
			this._y1 = e, this._segmentChanged();
		},
		enumerable: !0
	}), window.SVGPathSegArcAbs = function(e, t, n, r, i, a, o, s) {
		window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_ARC_ABS, "A", e), this._x = t, this._y = n, this._r1 = r, this._r2 = i, this._angle = a, this._largeArcFlag = o, this._sweepFlag = s;
	}, window.SVGPathSegArcAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegArcAbs.prototype.toString = function() {
		return "[object SVGPathSegArcAbs]";
	}, window.SVGPathSegArcAbs.prototype._asPathString = function() {
		return this.pathSegTypeAsLetter + " " + this._r1 + " " + this._r2 + " " + this._angle + " " + (this._largeArcFlag ? "1" : "0") + " " + (this._sweepFlag ? "1" : "0") + " " + this._x + " " + this._y;
	}, window.SVGPathSegArcAbs.prototype.clone = function() {
		return new window.SVGPathSegArcAbs(void 0, this._x, this._y, this._r1, this._r2, this._angle, this._largeArcFlag, this._sweepFlag);
	}, Object.defineProperty(window.SVGPathSegArcAbs.prototype, "x", {
		get: function() {
			return this._x;
		},
		set: function(e) {
			this._x = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegArcAbs.prototype, "y", {
		get: function() {
			return this._y;
		},
		set: function(e) {
			this._y = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegArcAbs.prototype, "r1", {
		get: function() {
			return this._r1;
		},
		set: function(e) {
			this._r1 = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegArcAbs.prototype, "r2", {
		get: function() {
			return this._r2;
		},
		set: function(e) {
			this._r2 = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegArcAbs.prototype, "angle", {
		get: function() {
			return this._angle;
		},
		set: function(e) {
			this._angle = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegArcAbs.prototype, "largeArcFlag", {
		get: function() {
			return this._largeArcFlag;
		},
		set: function(e) {
			this._largeArcFlag = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegArcAbs.prototype, "sweepFlag", {
		get: function() {
			return this._sweepFlag;
		},
		set: function(e) {
			this._sweepFlag = e, this._segmentChanged();
		},
		enumerable: !0
	}), window.SVGPathSegArcRel = function(e, t, n, r, i, a, o, s) {
		window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_ARC_REL, "a", e), this._x = t, this._y = n, this._r1 = r, this._r2 = i, this._angle = a, this._largeArcFlag = o, this._sweepFlag = s;
	}, window.SVGPathSegArcRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegArcRel.prototype.toString = function() {
		return "[object SVGPathSegArcRel]";
	}, window.SVGPathSegArcRel.prototype._asPathString = function() {
		return this.pathSegTypeAsLetter + " " + this._r1 + " " + this._r2 + " " + this._angle + " " + (this._largeArcFlag ? "1" : "0") + " " + (this._sweepFlag ? "1" : "0") + " " + this._x + " " + this._y;
	}, window.SVGPathSegArcRel.prototype.clone = function() {
		return new window.SVGPathSegArcRel(void 0, this._x, this._y, this._r1, this._r2, this._angle, this._largeArcFlag, this._sweepFlag);
	}, Object.defineProperty(window.SVGPathSegArcRel.prototype, "x", {
		get: function() {
			return this._x;
		},
		set: function(e) {
			this._x = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegArcRel.prototype, "y", {
		get: function() {
			return this._y;
		},
		set: function(e) {
			this._y = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegArcRel.prototype, "r1", {
		get: function() {
			return this._r1;
		},
		set: function(e) {
			this._r1 = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegArcRel.prototype, "r2", {
		get: function() {
			return this._r2;
		},
		set: function(e) {
			this._r2 = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegArcRel.prototype, "angle", {
		get: function() {
			return this._angle;
		},
		set: function(e) {
			this._angle = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegArcRel.prototype, "largeArcFlag", {
		get: function() {
			return this._largeArcFlag;
		},
		set: function(e) {
			this._largeArcFlag = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegArcRel.prototype, "sweepFlag", {
		get: function() {
			return this._sweepFlag;
		},
		set: function(e) {
			this._sweepFlag = e, this._segmentChanged();
		},
		enumerable: !0
	}), window.SVGPathSegLinetoHorizontalAbs = function(e, t) {
		window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS, "H", e), this._x = t;
	}, window.SVGPathSegLinetoHorizontalAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegLinetoHorizontalAbs.prototype.toString = function() {
		return "[object SVGPathSegLinetoHorizontalAbs]";
	}, window.SVGPathSegLinetoHorizontalAbs.prototype._asPathString = function() {
		return this.pathSegTypeAsLetter + " " + this._x;
	}, window.SVGPathSegLinetoHorizontalAbs.prototype.clone = function() {
		return new window.SVGPathSegLinetoHorizontalAbs(void 0, this._x);
	}, Object.defineProperty(window.SVGPathSegLinetoHorizontalAbs.prototype, "x", {
		get: function() {
			return this._x;
		},
		set: function(e) {
			this._x = e, this._segmentChanged();
		},
		enumerable: !0
	}), window.SVGPathSegLinetoHorizontalRel = function(e, t) {
		window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL, "h", e), this._x = t;
	}, window.SVGPathSegLinetoHorizontalRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegLinetoHorizontalRel.prototype.toString = function() {
		return "[object SVGPathSegLinetoHorizontalRel]";
	}, window.SVGPathSegLinetoHorizontalRel.prototype._asPathString = function() {
		return this.pathSegTypeAsLetter + " " + this._x;
	}, window.SVGPathSegLinetoHorizontalRel.prototype.clone = function() {
		return new window.SVGPathSegLinetoHorizontalRel(void 0, this._x);
	}, Object.defineProperty(window.SVGPathSegLinetoHorizontalRel.prototype, "x", {
		get: function() {
			return this._x;
		},
		set: function(e) {
			this._x = e, this._segmentChanged();
		},
		enumerable: !0
	}), window.SVGPathSegLinetoVerticalAbs = function(e, t) {
		window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS, "V", e), this._y = t;
	}, window.SVGPathSegLinetoVerticalAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegLinetoVerticalAbs.prototype.toString = function() {
		return "[object SVGPathSegLinetoVerticalAbs]";
	}, window.SVGPathSegLinetoVerticalAbs.prototype._asPathString = function() {
		return this.pathSegTypeAsLetter + " " + this._y;
	}, window.SVGPathSegLinetoVerticalAbs.prototype.clone = function() {
		return new window.SVGPathSegLinetoVerticalAbs(void 0, this._y);
	}, Object.defineProperty(window.SVGPathSegLinetoVerticalAbs.prototype, "y", {
		get: function() {
			return this._y;
		},
		set: function(e) {
			this._y = e, this._segmentChanged();
		},
		enumerable: !0
	}), window.SVGPathSegLinetoVerticalRel = function(e, t) {
		window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL, "v", e), this._y = t;
	}, window.SVGPathSegLinetoVerticalRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegLinetoVerticalRel.prototype.toString = function() {
		return "[object SVGPathSegLinetoVerticalRel]";
	}, window.SVGPathSegLinetoVerticalRel.prototype._asPathString = function() {
		return this.pathSegTypeAsLetter + " " + this._y;
	}, window.SVGPathSegLinetoVerticalRel.prototype.clone = function() {
		return new window.SVGPathSegLinetoVerticalRel(void 0, this._y);
	}, Object.defineProperty(window.SVGPathSegLinetoVerticalRel.prototype, "y", {
		get: function() {
			return this._y;
		},
		set: function(e) {
			this._y = e, this._segmentChanged();
		},
		enumerable: !0
	}), window.SVGPathSegCurvetoCubicSmoothAbs = function(e, t, n, r, i) {
		window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS, "S", e), this._x = t, this._y = n, this._x2 = r, this._y2 = i;
	}, window.SVGPathSegCurvetoCubicSmoothAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegCurvetoCubicSmoothAbs.prototype.toString = function() {
		return "[object SVGPathSegCurvetoCubicSmoothAbs]";
	}, window.SVGPathSegCurvetoCubicSmoothAbs.prototype._asPathString = function() {
		return this.pathSegTypeAsLetter + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
	}, window.SVGPathSegCurvetoCubicSmoothAbs.prototype.clone = function() {
		return new window.SVGPathSegCurvetoCubicSmoothAbs(void 0, this._x, this._y, this._x2, this._y2);
	}, Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "x", {
		get: function() {
			return this._x;
		},
		set: function(e) {
			this._x = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "y", {
		get: function() {
			return this._y;
		},
		set: function(e) {
			this._y = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "x2", {
		get: function() {
			return this._x2;
		},
		set: function(e) {
			this._x2 = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothAbs.prototype, "y2", {
		get: function() {
			return this._y2;
		},
		set: function(e) {
			this._y2 = e, this._segmentChanged();
		},
		enumerable: !0
	}), window.SVGPathSegCurvetoCubicSmoothRel = function(e, t, n, r, i) {
		window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL, "s", e), this._x = t, this._y = n, this._x2 = r, this._y2 = i;
	}, window.SVGPathSegCurvetoCubicSmoothRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegCurvetoCubicSmoothRel.prototype.toString = function() {
		return "[object SVGPathSegCurvetoCubicSmoothRel]";
	}, window.SVGPathSegCurvetoCubicSmoothRel.prototype._asPathString = function() {
		return this.pathSegTypeAsLetter + " " + this._x2 + " " + this._y2 + " " + this._x + " " + this._y;
	}, window.SVGPathSegCurvetoCubicSmoothRel.prototype.clone = function() {
		return new window.SVGPathSegCurvetoCubicSmoothRel(void 0, this._x, this._y, this._x2, this._y2);
	}, Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "x", {
		get: function() {
			return this._x;
		},
		set: function(e) {
			this._x = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "y", {
		get: function() {
			return this._y;
		},
		set: function(e) {
			this._y = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "x2", {
		get: function() {
			return this._x2;
		},
		set: function(e) {
			this._x2 = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegCurvetoCubicSmoothRel.prototype, "y2", {
		get: function() {
			return this._y2;
		},
		set: function(e) {
			this._y2 = e, this._segmentChanged();
		},
		enumerable: !0
	}), window.SVGPathSegCurvetoQuadraticSmoothAbs = function(e, t, n) {
		window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS, "T", e), this._x = t, this._y = n;
	}, window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype.toString = function() {
		return "[object SVGPathSegCurvetoQuadraticSmoothAbs]";
	}, window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype._asPathString = function() {
		return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
	}, window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype.clone = function() {
		return new window.SVGPathSegCurvetoQuadraticSmoothAbs(void 0, this._x, this._y);
	}, Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype, "x", {
		get: function() {
			return this._x;
		},
		set: function(e) {
			this._x = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothAbs.prototype, "y", {
		get: function() {
			return this._y;
		},
		set: function(e) {
			this._y = e, this._segmentChanged();
		},
		enumerable: !0
	}), window.SVGPathSegCurvetoQuadraticSmoothRel = function(e, t, n) {
		window.SVGPathSeg.call(this, window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL, "t", e), this._x = t, this._y = n;
	}, window.SVGPathSegCurvetoQuadraticSmoothRel.prototype = Object.create(window.SVGPathSeg.prototype), window.SVGPathSegCurvetoQuadraticSmoothRel.prototype.toString = function() {
		return "[object SVGPathSegCurvetoQuadraticSmoothRel]";
	}, window.SVGPathSegCurvetoQuadraticSmoothRel.prototype._asPathString = function() {
		return this.pathSegTypeAsLetter + " " + this._x + " " + this._y;
	}, window.SVGPathSegCurvetoQuadraticSmoothRel.prototype.clone = function() {
		return new window.SVGPathSegCurvetoQuadraticSmoothRel(void 0, this._x, this._y);
	}, Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothRel.prototype, "x", {
		get: function() {
			return this._x;
		},
		set: function(e) {
			this._x = e, this._segmentChanged();
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegCurvetoQuadraticSmoothRel.prototype, "y", {
		get: function() {
			return this._y;
		},
		set: function(e) {
			this._y = e, this._segmentChanged();
		},
		enumerable: !0
	}), window.SVGPathElement.prototype.createSVGPathSegClosePath = function() {
		return new window.SVGPathSegClosePath(void 0);
	}, window.SVGPathElement.prototype.createSVGPathSegMovetoAbs = function(e, t) {
		return new window.SVGPathSegMovetoAbs(void 0, e, t);
	}, window.SVGPathElement.prototype.createSVGPathSegMovetoRel = function(e, t) {
		return new window.SVGPathSegMovetoRel(void 0, e, t);
	}, window.SVGPathElement.prototype.createSVGPathSegLinetoAbs = function(e, t) {
		return new window.SVGPathSegLinetoAbs(void 0, e, t);
	}, window.SVGPathElement.prototype.createSVGPathSegLinetoRel = function(e, t) {
		return new window.SVGPathSegLinetoRel(void 0, e, t);
	}, window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicAbs = function(e, t, n, r, i, a) {
		return new window.SVGPathSegCurvetoCubicAbs(void 0, e, t, n, r, i, a);
	}, window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicRel = function(e, t, n, r, i, a) {
		return new window.SVGPathSegCurvetoCubicRel(void 0, e, t, n, r, i, a);
	}, window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticAbs = function(e, t, n, r) {
		return new window.SVGPathSegCurvetoQuadraticAbs(void 0, e, t, n, r);
	}, window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticRel = function(e, t, n, r) {
		return new window.SVGPathSegCurvetoQuadraticRel(void 0, e, t, n, r);
	}, window.SVGPathElement.prototype.createSVGPathSegArcAbs = function(e, t, n, r, i, a, o) {
		return new window.SVGPathSegArcAbs(void 0, e, t, n, r, i, a, o);
	}, window.SVGPathElement.prototype.createSVGPathSegArcRel = function(e, t, n, r, i, a, o) {
		return new window.SVGPathSegArcRel(void 0, e, t, n, r, i, a, o);
	}, window.SVGPathElement.prototype.createSVGPathSegLinetoHorizontalAbs = function(e) {
		return new window.SVGPathSegLinetoHorizontalAbs(void 0, e);
	}, window.SVGPathElement.prototype.createSVGPathSegLinetoHorizontalRel = function(e) {
		return new window.SVGPathSegLinetoHorizontalRel(void 0, e);
	}, window.SVGPathElement.prototype.createSVGPathSegLinetoVerticalAbs = function(e) {
		return new window.SVGPathSegLinetoVerticalAbs(void 0, e);
	}, window.SVGPathElement.prototype.createSVGPathSegLinetoVerticalRel = function(e) {
		return new window.SVGPathSegLinetoVerticalRel(void 0, e);
	}, window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicSmoothAbs = function(e, t, n, r) {
		return new window.SVGPathSegCurvetoCubicSmoothAbs(void 0, e, t, n, r);
	}, window.SVGPathElement.prototype.createSVGPathSegCurvetoCubicSmoothRel = function(e, t, n, r) {
		return new window.SVGPathSegCurvetoCubicSmoothRel(void 0, e, t, n, r);
	}, window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticSmoothAbs = function(e, t) {
		return new window.SVGPathSegCurvetoQuadraticSmoothAbs(void 0, e, t);
	}, window.SVGPathElement.prototype.createSVGPathSegCurvetoQuadraticSmoothRel = function(e, t) {
		return new window.SVGPathSegCurvetoQuadraticSmoothRel(void 0, e, t);
	}, "getPathSegAtLength" in window.SVGPathElement.prototype || (window.SVGPathElement.prototype.getPathSegAtLength = function(e) {
		if (e === void 0 || !isFinite(e)) throw "Invalid arguments.";
		var t = document.createElementNS("http://www.w3.org/2000/svg", "path");
		t.setAttribute("d", this.getAttribute("d"));
		var n = t.pathSegList.numberOfItems - 1;
		if (n <= 0) return 0;
		do {
			if (t.pathSegList.removeItem(n), e > t.getTotalLength()) break;
			n--;
		} while (n > 0);
		return n;
	})), (!("SVGPathSegList" in window) || !("appendItem" in window.SVGPathSegList.prototype)) && (window.SVGPathSegList = function(e) {
		this._pathElement = e, this._list = this._parsePath(this._pathElement.getAttribute("d")), this._mutationObserverConfig = {
			attributes: !0,
			attributeFilter: ["d"]
		}, this._pathElementMutationObserver = new MutationObserver(this._updateListFromPathMutations.bind(this)), this._pathElementMutationObserver.observe(this._pathElement, this._mutationObserverConfig);
	}, window.SVGPathSegList.prototype.classname = "SVGPathSegList", Object.defineProperty(window.SVGPathSegList.prototype, "numberOfItems", {
		get: function() {
			return this._checkPathSynchronizedToList(), this._list.length;
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathSegList.prototype, "length", {
		get: function() {
			return this._checkPathSynchronizedToList(), this._list.length;
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathElement.prototype, "pathSegList", {
		get: function() {
			return this._pathSegList ||= new window.SVGPathSegList(this), this._pathSegList;
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathElement.prototype, "normalizedPathSegList", {
		get: function() {
			return this.pathSegList;
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathElement.prototype, "animatedPathSegList", {
		get: function() {
			return this.pathSegList;
		},
		enumerable: !0
	}), Object.defineProperty(window.SVGPathElement.prototype, "animatedNormalizedPathSegList", {
		get: function() {
			return this.pathSegList;
		},
		enumerable: !0
	}), window.SVGPathSegList.prototype._checkPathSynchronizedToList = function() {
		this._updateListFromPathMutations(this._pathElementMutationObserver.takeRecords());
	}, window.SVGPathSegList.prototype._updateListFromPathMutations = function(e) {
		if (this._pathElement) {
			var t = !1;
			e.forEach(function(e) {
				e.attributeName == "d" && (t = !0);
			}), t && (this._list = this._parsePath(this._pathElement.getAttribute("d")));
		}
	}, window.SVGPathSegList.prototype._writeListToPath = function() {
		this._pathElementMutationObserver.disconnect(), this._pathElement.setAttribute("d", window.SVGPathSegList._pathSegArrayAsString(this._list)), this._pathElementMutationObserver.observe(this._pathElement, this._mutationObserverConfig);
	}, window.SVGPathSegList.prototype.segmentChanged = function(e) {
		this._writeListToPath();
	}, window.SVGPathSegList.prototype.clear = function() {
		this._checkPathSynchronizedToList(), this._list.forEach(function(e) {
			e._owningPathSegList = null;
		}), this._list = [], this._writeListToPath();
	}, window.SVGPathSegList.prototype.initialize = function(e) {
		return this._checkPathSynchronizedToList(), this._list = [e], e._owningPathSegList = this, this._writeListToPath(), e;
	}, window.SVGPathSegList.prototype._checkValidIndex = function(e) {
		if (isNaN(e) || e < 0 || e >= this.numberOfItems) throw "INDEX_SIZE_ERR";
	}, window.SVGPathSegList.prototype.getItem = function(e) {
		return this._checkPathSynchronizedToList(), this._checkValidIndex(e), this._list[e];
	}, window.SVGPathSegList.prototype.insertItemBefore = function(e, t) {
		return this._checkPathSynchronizedToList(), t > this.numberOfItems && (t = this.numberOfItems), e._owningPathSegList && (e = e.clone()), this._list.splice(t, 0, e), e._owningPathSegList = this, this._writeListToPath(), e;
	}, window.SVGPathSegList.prototype.replaceItem = function(e, t) {
		return this._checkPathSynchronizedToList(), e._owningPathSegList && (e = e.clone()), this._checkValidIndex(t), this._list[t] = e, e._owningPathSegList = this, this._writeListToPath(), e;
	}, window.SVGPathSegList.prototype.removeItem = function(e) {
		this._checkPathSynchronizedToList(), this._checkValidIndex(e);
		var t = this._list[e];
		return this._list.splice(e, 1), this._writeListToPath(), t;
	}, window.SVGPathSegList.prototype.appendItem = function(e) {
		return this._checkPathSynchronizedToList(), e._owningPathSegList && (e = e.clone()), this._list.push(e), e._owningPathSegList = this, this._writeListToPath(), e;
	}, window.SVGPathSegList._pathSegArrayAsString = function(e) {
		var t = "", n = !0;
		return e.forEach(function(e) {
			n ? (n = !1, t += e._asPathString()) : t += " " + e._asPathString();
		}), t;
	}, window.SVGPathSegList.prototype._parsePath = function(e) {
		if (!e || e.length == 0) return [];
		var t = this, n = function() {
			this.pathSegList = [];
		};
		n.prototype.appendSegment = function(e) {
			this.pathSegList.push(e);
		};
		var r = function(e) {
			this._string = e, this._currentIndex = 0, this._endIndex = this._string.length, this._previousCommand = window.SVGPathSeg.PATHSEG_UNKNOWN, this._skipOptionalSpaces();
		};
		r.prototype._isCurrentSpace = function() {
			var e = this._string[this._currentIndex];
			return e <= " " && (e == " " || e == "\n" || e == "	" || e == "\r" || e == "\f");
		}, r.prototype._skipOptionalSpaces = function() {
			for (; this._currentIndex < this._endIndex && this._isCurrentSpace();) this._currentIndex++;
			return this._currentIndex < this._endIndex;
		}, r.prototype._skipOptionalSpacesOrDelimiter = function() {
			return this._currentIndex < this._endIndex && !this._isCurrentSpace() && this._string.charAt(this._currentIndex) != "," ? !1 : (this._skipOptionalSpaces() && this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "," && (this._currentIndex++, this._skipOptionalSpaces()), this._currentIndex < this._endIndex);
		}, r.prototype.hasMoreData = function() {
			return this._currentIndex < this._endIndex;
		}, r.prototype.peekSegmentType = function() {
			var e = this._string[this._currentIndex];
			return this._pathSegTypeFromChar(e);
		}, r.prototype._pathSegTypeFromChar = function(e) {
			switch (e) {
				case "Z":
				case "z": return window.SVGPathSeg.PATHSEG_CLOSEPATH;
				case "M": return window.SVGPathSeg.PATHSEG_MOVETO_ABS;
				case "m": return window.SVGPathSeg.PATHSEG_MOVETO_REL;
				case "L": return window.SVGPathSeg.PATHSEG_LINETO_ABS;
				case "l": return window.SVGPathSeg.PATHSEG_LINETO_REL;
				case "C": return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS;
				case "c": return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL;
				case "Q": return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS;
				case "q": return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL;
				case "A": return window.SVGPathSeg.PATHSEG_ARC_ABS;
				case "a": return window.SVGPathSeg.PATHSEG_ARC_REL;
				case "H": return window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS;
				case "h": return window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL;
				case "V": return window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS;
				case "v": return window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL;
				case "S": return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS;
				case "s": return window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL;
				case "T": return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS;
				case "t": return window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL;
				default: return window.SVGPathSeg.PATHSEG_UNKNOWN;
			}
		}, r.prototype._nextCommandHelper = function(e, t) {
			return (e == "+" || e == "-" || e == "." || e >= "0" && e <= "9") && t != window.SVGPathSeg.PATHSEG_CLOSEPATH ? t == window.SVGPathSeg.PATHSEG_MOVETO_ABS ? window.SVGPathSeg.PATHSEG_LINETO_ABS : t == window.SVGPathSeg.PATHSEG_MOVETO_REL ? window.SVGPathSeg.PATHSEG_LINETO_REL : t : window.SVGPathSeg.PATHSEG_UNKNOWN;
		}, r.prototype.initialCommandIsMoveTo = function() {
			if (!this.hasMoreData()) return !0;
			var e = this.peekSegmentType();
			return e == window.SVGPathSeg.PATHSEG_MOVETO_ABS || e == window.SVGPathSeg.PATHSEG_MOVETO_REL;
		}, r.prototype._parseNumber = function() {
			var e = 0, t = 0, n = 1, r = 0, i = 1, a = 1, o = this._currentIndex;
			if (this._skipOptionalSpaces(), this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "+" ? this._currentIndex++ : this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == "-" && (this._currentIndex++, i = -1), !(this._currentIndex == this._endIndex || (this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") && this._string.charAt(this._currentIndex) != ".")) {
				for (var s = this._currentIndex; this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9";) this._currentIndex++;
				if (this._currentIndex != s) for (var c = this._currentIndex - 1, l = 1; c >= s;) t += l * (this._string.charAt(c--) - "0"), l *= 10;
				if (this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) == ".") {
					if (this._currentIndex++, this._currentIndex >= this._endIndex || this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") return;
					for (; this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9";) n *= 10, r += (this._string.charAt(this._currentIndex) - "0") / n, this._currentIndex += 1;
				}
				if (this._currentIndex != o && this._currentIndex + 1 < this._endIndex && (this._string.charAt(this._currentIndex) == "e" || this._string.charAt(this._currentIndex) == "E") && this._string.charAt(this._currentIndex + 1) != "x" && this._string.charAt(this._currentIndex + 1) != "m") {
					if (this._currentIndex++, this._string.charAt(this._currentIndex) == "+" ? this._currentIndex++ : this._string.charAt(this._currentIndex) == "-" && (this._currentIndex++, a = -1), this._currentIndex >= this._endIndex || this._string.charAt(this._currentIndex) < "0" || this._string.charAt(this._currentIndex) > "9") return;
					for (; this._currentIndex < this._endIndex && this._string.charAt(this._currentIndex) >= "0" && this._string.charAt(this._currentIndex) <= "9";) e *= 10, e += this._string.charAt(this._currentIndex) - "0", this._currentIndex++;
				}
				var u = t + r;
				if (u *= i, e && (u *= 10 ** (a * e)), o != this._currentIndex) return this._skipOptionalSpacesOrDelimiter(), u;
			}
		}, r.prototype._parseArcFlag = function() {
			if (!(this._currentIndex >= this._endIndex)) {
				var e = !1, t = this._string.charAt(this._currentIndex++);
				if (t == "0") e = !1;
				else if (t == "1") e = !0;
				else return;
				return this._skipOptionalSpacesOrDelimiter(), e;
			}
		}, r.prototype.parseSegment = function() {
			var e = this._string[this._currentIndex], n = this._pathSegTypeFromChar(e);
			if (n == window.SVGPathSeg.PATHSEG_UNKNOWN) {
				if (this._previousCommand == window.SVGPathSeg.PATHSEG_UNKNOWN || (n = this._nextCommandHelper(e, this._previousCommand), n == window.SVGPathSeg.PATHSEG_UNKNOWN)) return null;
			} else this._currentIndex++;
			switch (this._previousCommand = n, n) {
				case window.SVGPathSeg.PATHSEG_MOVETO_REL: return new window.SVGPathSegMovetoRel(t, this._parseNumber(), this._parseNumber());
				case window.SVGPathSeg.PATHSEG_MOVETO_ABS: return new window.SVGPathSegMovetoAbs(t, this._parseNumber(), this._parseNumber());
				case window.SVGPathSeg.PATHSEG_LINETO_REL: return new window.SVGPathSegLinetoRel(t, this._parseNumber(), this._parseNumber());
				case window.SVGPathSeg.PATHSEG_LINETO_ABS: return new window.SVGPathSegLinetoAbs(t, this._parseNumber(), this._parseNumber());
				case window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_REL: return new window.SVGPathSegLinetoHorizontalRel(t, this._parseNumber());
				case window.SVGPathSeg.PATHSEG_LINETO_HORIZONTAL_ABS: return new window.SVGPathSegLinetoHorizontalAbs(t, this._parseNumber());
				case window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_REL: return new window.SVGPathSegLinetoVerticalRel(t, this._parseNumber());
				case window.SVGPathSeg.PATHSEG_LINETO_VERTICAL_ABS: return new window.SVGPathSegLinetoVerticalAbs(t, this._parseNumber());
				case window.SVGPathSeg.PATHSEG_CLOSEPATH: return this._skipOptionalSpaces(), new window.SVGPathSegClosePath(t);
				case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_REL:
					var r = {
						x1: this._parseNumber(),
						y1: this._parseNumber(),
						x2: this._parseNumber(),
						y2: this._parseNumber(),
						x: this._parseNumber(),
						y: this._parseNumber()
					};
					return new window.SVGPathSegCurvetoCubicRel(t, r.x, r.y, r.x1, r.y1, r.x2, r.y2);
				case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_ABS:
					var r = {
						x1: this._parseNumber(),
						y1: this._parseNumber(),
						x2: this._parseNumber(),
						y2: this._parseNumber(),
						x: this._parseNumber(),
						y: this._parseNumber()
					};
					return new window.SVGPathSegCurvetoCubicAbs(t, r.x, r.y, r.x1, r.y1, r.x2, r.y2);
				case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_REL:
					var r = {
						x2: this._parseNumber(),
						y2: this._parseNumber(),
						x: this._parseNumber(),
						y: this._parseNumber()
					};
					return new window.SVGPathSegCurvetoCubicSmoothRel(t, r.x, r.y, r.x2, r.y2);
				case window.SVGPathSeg.PATHSEG_CURVETO_CUBIC_SMOOTH_ABS:
					var r = {
						x2: this._parseNumber(),
						y2: this._parseNumber(),
						x: this._parseNumber(),
						y: this._parseNumber()
					};
					return new window.SVGPathSegCurvetoCubicSmoothAbs(t, r.x, r.y, r.x2, r.y2);
				case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_REL:
					var r = {
						x1: this._parseNumber(),
						y1: this._parseNumber(),
						x: this._parseNumber(),
						y: this._parseNumber()
					};
					return new window.SVGPathSegCurvetoQuadraticRel(t, r.x, r.y, r.x1, r.y1);
				case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_ABS:
					var r = {
						x1: this._parseNumber(),
						y1: this._parseNumber(),
						x: this._parseNumber(),
						y: this._parseNumber()
					};
					return new window.SVGPathSegCurvetoQuadraticAbs(t, r.x, r.y, r.x1, r.y1);
				case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_REL: return new window.SVGPathSegCurvetoQuadraticSmoothRel(t, this._parseNumber(), this._parseNumber());
				case window.SVGPathSeg.PATHSEG_CURVETO_QUADRATIC_SMOOTH_ABS: return new window.SVGPathSegCurvetoQuadraticSmoothAbs(t, this._parseNumber(), this._parseNumber());
				case window.SVGPathSeg.PATHSEG_ARC_REL:
					var r = {
						x1: this._parseNumber(),
						y1: this._parseNumber(),
						arcAngle: this._parseNumber(),
						arcLarge: this._parseArcFlag(),
						arcSweep: this._parseArcFlag(),
						x: this._parseNumber(),
						y: this._parseNumber()
					};
					return new window.SVGPathSegArcRel(t, r.x, r.y, r.x1, r.y1, r.arcAngle, r.arcLarge, r.arcSweep);
				case window.SVGPathSeg.PATHSEG_ARC_ABS:
					var r = {
						x1: this._parseNumber(),
						y1: this._parseNumber(),
						arcAngle: this._parseNumber(),
						arcLarge: this._parseArcFlag(),
						arcSweep: this._parseArcFlag(),
						x: this._parseNumber(),
						y: this._parseNumber()
					};
					return new window.SVGPathSegArcAbs(t, r.x, r.y, r.x1, r.y1, r.arcAngle, r.arcLarge, r.arcSweep);
				default: throw "Unknown path seg type.";
			}
		};
		var i = new n(), a = new r(e);
		if (!a.initialCommandIsMoveTo()) return [];
		for (; a.hasMoreData();) {
			var o = a.parseSegment();
			if (!o) return [];
			i.appendSegment(o);
		}
		return i.pathSegList;
	}));
})();
//#endregion
//#region packages/svgcanvas/core/paint.js
var d = class e {
	static #e(e) {
		let t = Number(e);
		return Number.isFinite(t) ? Math.min(100, Math.max(0, t)) : 100;
	}
	static #t(e) {
		if (e == null) return null;
		let t = String(e).trim();
		return t ? t === "none" ? "none" : t.startsWith("#") ? t.slice(1) : t : null;
	}
	static #n(e) {
		if (!e) return null;
		let t = String(e).trim();
		if (!t) return null;
		if (t.startsWith("#")) return t.slice(1);
		let n = t.match(/url\(\s*['"]?#([^'")\s]+)['"]?\s*\)/);
		if (n?.[1]) return n[1];
		let r = t.lastIndexOf("#");
		return r >= 0 && r < t.length - 1 ? t.slice(r + 1) : null;
	}
	static #r(t) {
		if (!t?.cloneNode) return null;
		let n = t.ownerDocument || document, r = /* @__PURE__ */ new Set(), i = t.cloneNode(!0), a = e.#n(i.getAttribute("href") || i.getAttribute("xlink:href"));
		for (; a && !r.has(a);) {
			r.add(a);
			let t = n.getElementById(a);
			if (!t?.getAttribute) break;
			let o = String(i.tagName || "").toLowerCase(), s = String(t.tagName || "").toLowerCase();
			if (!["lineargradient", "radialgradient"].includes(s) || s !== o) break;
			for (let e of t.attributes || []) {
				let t = e.name;
				if (t === "id" || t === "href" || t === "xlink:href") continue;
				let n = i.getAttribute(t);
				(n === null || n === "") && i.setAttribute(t, e.value);
			}
			if (i.querySelectorAll("stop").length === 0) for (let e of t.querySelectorAll?.("stop") || []) i.append(e.cloneNode(!0));
			a = e.#n(t.getAttribute("href") || t.getAttribute("xlink:href"));
		}
		return i.removeAttribute("href"), i.removeAttribute("xlink:href"), i;
	}
	constructor(t) {
		let n = t || {};
		if (this.alpha = e.#e(n.alpha), n.copy) switch (this.type = n.copy.type, this.alpha = e.#e(n.copy.alpha), this.solidColor = null, this.linearGradient = null, this.radialGradient = null, this.type) {
			case "none": break;
			case "solidColor":
				this.solidColor = e.#t(n.copy.solidColor);
				break;
			case "linearGradient":
				this.linearGradient = n.copy.linearGradient?.cloneNode ? n.copy.linearGradient.cloneNode(!0) : null;
				break;
			case "radialGradient":
				this.radialGradient = n.copy.radialGradient?.cloneNode ? n.copy.radialGradient.cloneNode(!0) : null;
				break;
		}
		else n.linearGradient ? (this.type = "linearGradient", this.solidColor = null, this.radialGradient = null, this.linearGradient = e.#r(n.linearGradient)) : n.radialGradient ? (this.type = "radialGradient", this.solidColor = null, this.linearGradient = null, this.radialGradient = e.#r(n.radialGradient)) : n.solidColor ? (this.type = "solidColor", this.solidColor = e.#t(n.solidColor)) : (this.type = "none", this.solidColor = null, this.linearGradient = null, this.radialGradient = null);
	}
}, f = {
	NONE: 0,
	ERROR: 1,
	WARN: 2,
	INFO: 3,
	DEBUG: 4
}, p = {
	currentLevel: f.WARN,
	enabled: !0,
	prefix: "[SVGCanvas]"
}, m = (e, t = "") => {
	let n = t ? ` [${t}]` : "";
	return `${p.prefix}${n} ${e}`;
}, h = (e, t, n = "") => {
	!p.enabled || p.currentLevel < f.ERROR || (console.error(m(e, n)), t && console.error(t));
}, g = (e, t, n = "") => {
	!p.enabled || p.currentLevel < f.WARN || (console.warn(m(e, n)), t !== void 0 && console.warn(t));
}, _ = "http://www.w3.org/2000/svg", v = [
	"x",
	"x1",
	"cx",
	"rx",
	"width"
], y = [
	"y",
	"y1",
	"cy",
	"ry",
	"height"
], b = [
	"r",
	"radius",
	...v,
	...y
], x, S = {}, C = (e) => {
	x = e;
	let t = document.createElementNS(_, "svg");
	document.body.append(t);
	let n = document.createElementNS(_, "rect");
	n.setAttribute("width", "1em"), n.setAttribute("height", "1ex"), n.setAttribute("x", "1in"), t.append(n);
	let r = n.getBBox();
	t.remove();
	let i = r.x;
	S = {
		em: r.width,
		ex: r.height,
		in: i,
		cm: i / 2.54,
		mm: i / 25.4,
		pt: i / 72,
		pc: i / 6,
		px: 1,
		"%": 0
	};
}, w = () => S, T = (e) => {
	let t = x.getRoundDigits();
	return isNaN(e) ? Array.isArray(e) ? `${T(e[0])},${T(e[1])}` : Number.parseFloat(e).toFixed(t) - 0 : Number(Number(e).toFixed(t));
}, E = (e, t) => (t ||= x.getBaseUnit(), T(e / S[t])), D = (e, t, n) => {
	e.setAttribute(t, n);
}, O = (e, t) => {
	if (!isNaN(t)) return t - 0;
	if (t.substr(-1) === "%") {
		let n = t.substr(0, t.length - 1) / 100, r = x.getWidth(), i = x.getHeight();
		return v.includes(e) ? n * r : y.includes(e) ? n * i : n * Math.sqrt(r * r + i * i) / Math.sqrt(2);
	}
	let n = t.slice(-2);
	return t.slice(0, -2) * S[n];
}, k = (e, t, n) => {
	if (b.includes(e)) return isNaN(t) ? (t = t.toLowerCase(), Object.keys(S).some((e) => RegExp(`^-?[\\d\\.]+${e}$`).test(t))) : !0;
	if (e === "id") {
		let e = !1;
		try {
			let r = x.getElement(t);
			e = !r || r === n;
		} catch (e) {
			h("Error getting element by ID", e, "units");
		}
		return e;
	}
	return !0;
}, A = {
	HTML: "http://www.w3.org/1999/xhtml",
	MATH: "http://www.w3.org/1998/Math/MathML",
	SE: "http://svg-edit.googlecode.com",
	SVG: "http://www.w3.org/2000/svg",
	XLINK: "http://www.w3.org/1999/xlink",
	OI: "http://www.optimistik.fr/namespace/svg/OIdata",
	XML: "http://www.w3.org/XML/1998/namespace",
	XMLNS: "http://www.w3.org/2000/xmlns/"
}, j = () => {
	let e = {};
	for (let [t, n] of Object.entries(A)) e[n] = t.toLowerCase();
	return e;
}, M = 1e-10, N = document.createElementNS(A.SVG, "svg"), P = (e) => {
	let t = (e) => {
		let t = N.createSVGMatrix();
		return Object.assign(t, {
			a: e.a,
			b: e.b,
			c: e.c,
			d: e.d,
			e: e.e,
			f: e.f
		}), t;
	};
	try {
		return N.createSVGTransformFromMatrix(e);
	} catch {
		let n = N.createSVGTransform();
		try {
			return n.setMatrix(e), n;
		} catch {
			try {
				return N.createSVGTransformFromMatrix(t(e));
			} catch {
				return n.setMatrix(t(e)), n;
			}
		}
	}
}, F = (e, t, n) => ({
	x: n.a * e + n.c * t + n.e,
	y: n.b * e + n.d * t + n.f
}), I = (e) => {
	if (e.transform?.baseVal) return e.transform.baseVal;
	if (e.gradientTransform?.baseVal) return e.gradientTransform.baseVal;
	if (e.patternTransform?.baseVal) return e.patternTransform.baseVal;
	g("No transform list found. Check browser compatibility.", e, "math");
}, ee = (e) => Math.abs(e.a - 1) < M && Math.abs(e.b) < M && Math.abs(e.c) < M && Math.abs(e.d - 1) < M && Math.abs(e.e) < M && Math.abs(e.f) < M, L = (...e) => {
	if (e.length === 0) return N.createSVGMatrix();
	let t = (e) => {
		for (let t of [
			"a",
			"b",
			"c",
			"d",
			"e",
			"f"
		]) Math.abs(e[t]) < M && (e[t] = 0);
		return e;
	};
	if (typeof DOMMatrix == "function" && typeof DOMMatrix.fromMatrix == "function") {
		let n = e.reduce((e, t) => e.multiply(DOMMatrix.fromMatrix(t)), new DOMMatrix()), r = N.createSVGMatrix();
		return Object.assign(r, {
			a: n.a,
			b: n.b,
			c: n.c,
			d: n.d,
			e: n.e,
			f: n.f
		}), t(r);
	}
	let n = N.createSVGMatrix();
	for (let t of e) {
		let e = N.createSVGMatrix();
		Object.assign(e, {
			a: n.a * t.a + n.c * t.b,
			b: n.b * t.a + n.d * t.b,
			c: n.a * t.c + n.c * t.d,
			d: n.b * t.c + n.d * t.d,
			e: n.a * t.e + n.c * t.f + n.e,
			f: n.b * t.e + n.d * t.f + n.f
		}), n = e;
	}
	return t(n);
}, R = (e) => {
	if (!e) return !1;
	for (let t = 0; t < e.numberOfItems; t++) {
		let n = e.getItem(t);
		if (n.type === SVGTransform.SVG_TRANSFORM_MATRIX && !ee(n.matrix)) return !0;
	}
	return !1;
}, te = (e, t, n, r, i) => {
	let a = F(e, t, i), o = F(e + n, t, i), s = F(e, t + r, i), c = F(e + n, t + r, i), l = Math.min(a.x, o.x, s.x, c.x), u = Math.max(a.x, o.x, s.x, c.x), d = Math.min(a.y, o.y, s.y, c.y), f = Math.max(a.y, o.y, s.y, c.y);
	return {
		tl: a,
		tr: o,
		bl: s,
		br: c,
		aabox: {
			x: l,
			y: d,
			width: u - l,
			height: f - d
		}
	};
}, z = (e, t = 0, n = null) => {
	if (!e) return P(N.createSVGMatrix());
	let r = Number.parseInt(t, 10), i = Number.parseInt(n ?? e.numberOfItems - 1, 10), [a, o] = [Math.min(r, i), Math.max(r, i)], s = [];
	for (let t = a; t <= o; t++) {
		let n = t >= 0 && t < e.numberOfItems ? e.getItem(t).matrix : N.createSVGMatrix();
		s.push(n);
	}
	let c = L(...s), l = N.createSVGMatrix();
	return Object.assign(l, {
		a: c.a,
		b: c.b,
		c: c.c,
		d: c.d,
		e: c.e,
		f: c.f
	}), P(l);
}, ne = (e) => z(I(e)).matrix, re = (e, t, n, r) => {
	let i = Math.PI / 4, a = n - e, o = r - t, s = Math.atan2(o, a), c = Math.hypot(a, o), l = Math.round(s / i) * i;
	return {
		x: e + c * Math.cos(l),
		y: t + c * Math.sin(l),
		a: l
	};
}, ie = (e, t) => t.x < e.x + e.width && t.x + t.width > e.x && t.y < e.y + e.height && t.y + t.height > e.y, ae = (e) => {
	let t = 0, n = 0;
	if (e?.offsetParent) {
		let r = e;
		do
			t += r.offsetLeft, n += r.offsetTop, r = r.offsetParent;
		while (r);
	}
	return {
		left: t,
		top: n
	};
}, B = (e) => e && typeof e == "object" && !Array.isArray(e), oe = (e, t) => {
	let n = { ...e };
	if (B(e) && B(t)) for (let r of Object.keys(t)) B(t[r]) ? n[r] = r in e ? oe(e[r], t[r]) : t[r] : n[r] = t[r];
	return n;
}, se = (e, t) => {
	if (e?.closest) try {
		return e.closest(t);
	} catch {}
	let n = {
		".": (e, t) => e.classList?.contains(t.slice(1)),
		"#": (e, t) => e.id === t.slice(1),
		"[": (e, t) => {
			let [n, r] = t.slice(1, -1).split("=").map((e) => e.replace(/["']/g, ""));
			return r ? e.getAttribute(n) === r : e.hasAttribute(n);
		},
		tag: (e, t) => e.tagName?.toLowerCase() === t
	}, r = n[t.charAt(0)] || n.tag;
	for (let n = e; n && n !== document && n.nodeType === 1; n = n.parentNode) if (r(n, t)) return n;
	return null;
}, ce = (e, t) => {
	let n = [], r = {
		".": (e, t) => e.classList?.contains(t.slice(1)),
		"#": (e, t) => e.id === t.slice(1),
		"[": (e, t) => e.hasAttribute(t.slice(1, -1)),
		tag: (e, t) => e.tagName?.toLowerCase() === t
	}, i = t?.charAt(0), a = t ? r[i] || r.tag : null;
	for (let r = e; r && r !== document; r = r.parentNode) (!t || a(r, t)) && n.push(r);
	return n.length > 0 ? n : null;
}, le = (e, t, n) => {
	let r = [], i = {
		".": (e, t) => e.classList?.contains(t.slice(1)),
		"#": (e, t) => e.id === t.slice(1),
		"[": (e, t) => e.hasAttribute(t.slice(1, -1)),
		tag: (e, t) => e.tagName?.toLowerCase() === t
	}, a = (e) => {
		if (!e) return null;
		let t = e.charAt(0);
		return i[t] || i.tag;
	}, o = a(t), s = a(n);
	for (let i = e; i && i !== document && !(t && o?.(i, t)); i = i.parentNode) (!n || s?.(i, n)) && r.push(i);
	return r.length > 0 ? r : null;
}, V = "a,circle,ellipse,foreignObject,g,image,line,path,polygon,polyline,rect,svg,text,tspan,use,clipPath".split(","), ue = null, de = null, fe = (e) => {
	ue = e, de = e.getSvgRoot();
}, pe = (e) => {
	let t = {
		"&": "&amp;",
		"<": "&lt;",
		">": "&gt;",
		"\"": "&quot;",
		"'": "&#x27;"
	};
	return e.replace(/[&<>"']/g, (e) => t[e]);
}, me = (e) => {
	let t = ve(e);
	return window.btoa(t);
}, he = (e) => _e(window.atob(e)), ge = (e) => {
	if (e.length === 0) return 0;
	let t = 0;
	for (let n = 0; n < e.length; n++) {
		let r = e.charCodeAt(n);
		t = (t << 5) - t + r | 0;
	}
	return t;
}, _e = (e) => decodeURIComponent(escape(e)), ve = (e) => unescape(encodeURIComponent(e)), ye = typeof Blob > "u" ? "" : ((e) => !e || typeof URL > "u" || !URL.createObjectURL ? "" : URL.createObjectURL(e))(new Blob(["<html><head><title>SVG-edit</title></head><body>&nbsp;</body></html>"], { type: "text/html" })), be = (e) => {
	let t = e;
	t.includes("<svg:svg") && (t = t.replace(/<(\/?)svg:/g, "<$1").replace("xmlns:svg", "xmlns"));
	let n;
	try {
		n = new DOMParser(), n.async = !1;
	} catch {
		throw Error("XML Parser could not be instantiated");
	}
	try {
		return n.parseFromString(t, "text/xml");
	} catch (e) {
		throw Error(`Error parsing XML string: ${e.message}`);
	}
}, xe = ({ x: e, y: t, width: n, height: r }) => ({
	x: e,
	y: t,
	width: n,
	height: r
}), Se = (e, t) => {
	if (e?.nodeType === 1) {
		t(e);
		let n = e.childNodes.length;
		for (; n--;) Se(e.childNodes.item(n), t);
	}
}, Ce = (e, t) => {
	if (e?.nodeType === 1) {
		let n = e.childNodes.length;
		for (; n--;) Se(e.childNodes.item(n), t);
		t(e);
	}
}, we = (e) => {
	if (!e?.startsWith("url(")) return null;
	for (let { start: t, end: n, offset: r } of [
		{
			start: "url(\"",
			end: "\"",
			offset: 5
		},
		{
			start: "url('",
			end: "'",
			offset: 5
		},
		{
			start: "url(",
			end: ")",
			offset: 4
		}
	]) if (e.startsWith(t)) {
		let t = e.indexOf(n, r + 1);
		return t > 0 ? e.substring(r, t) : null;
	}
	return null;
}, Te = (e) => e.getAttribute("href") ?? e.getAttributeNS(A.XLINK, "href"), Ee = (e, t) => {
	e.setAttribute("href", t);
}, De = () => {
	let e = ue.getSvgContent(), t = e.getElementsByTagNameNS(A.SVG, "defs");
	if (t.length > 0) return t[0];
	let n = e.ownerDocument.createElementNS(A.SVG, "defs"), r = e.firstChild?.nextSibling;
	return r ? e.insertBefore(n, r) : e.append(n), n;
}, H = (e) => {
	let t = e ?? ue.getSelectedElements()[0];
	if (e.nodeType !== 1) return null;
	let n = t.nodeName, r = null;
	switch (n) {
		case "text":
			t.textContent === "" ? (t.textContent = "a", r = t.getBBox(), t.textContent = "") : t.getBBox && (r = t.getBBox());
			break;
		case "path":
		case "g":
		case "a":
			t.getBBox && (r = t.getBBox());
			break;
		default: if (n === "use") r = t.getBBox();
		else if (V.includes(n)) if (t) try {
			r = t.getBBox();
		} catch {
			let e = t.getExtentOfChar(0), n = t.getComputedTextLength();
			r = {
				x: e.x,
				y: e.y,
				width: n,
				height: e.height
			};
		}
		else {
			let e = se(t.parentNode, "foreignObject");
			e.length && e[0].getBBox && (r = e[0].getBBox());
		}
	}
	if (r) {
		if (r.width === 0 && r.height === 0) {
			let e = n.toLowerCase(), i = (e, n = 0) => Number.parseFloat(t.getAttribute(e) ?? n), a = (() => {
				switch (e) {
					case "path": {
						let e = ((t.getAttribute("d") || "").match(/-?\d*\.?\d+/g) || []).map(Number).filter((e) => !Number.isNaN(e));
						if (e.length >= 2) {
							let t = e.filter((e, t) => t % 2 == 0), n = e.filter((e, t) => t % 2 == 1);
							return {
								x: Math.min(...t),
								y: Math.min(...n),
								width: Math.max(...t) - Math.min(...t),
								height: Math.max(...n) - Math.min(...n)
							};
						}
						break;
					}
					case "rect": return {
						x: i("x"),
						y: i("y"),
						width: i("width"),
						height: i("height")
					};
					case "line": {
						let e = i("x1"), t = i("x2"), n = i("y1"), r = i("y2");
						return {
							x: Math.min(e, t),
							y: Math.min(n, r),
							width: Math.abs(t - e),
							height: Math.abs(r - n)
						};
					}
					case "g": {
						let e = Array.from(t.children || []).map((e) => H(e)).filter(Boolean);
						if (e.length) {
							let t = Math.min(...e.map((e) => e.x)), n = Math.min(...e.map((e) => e.y)), r = Math.max(...e.map((e) => e.x + e.width)), i = Math.max(...e.map((e) => e.y + e.height));
							return {
								x: t,
								y: n,
								width: r - t,
								height: i - n
							};
						}
						break;
					}
					default: break;
				}
			})();
			a && (r = a);
		}
		r = xe(r);
	}
	return r;
}, Oe = (e) => e.map(([e, t]) => {
	let n = [];
	for (let e = 0; e < t.length; e += 2) n.push(`${t[e]},${t[e + 1]}`);
	return e + n.join(" ");
}).join(" "), ke = (e) => {
	let t = 1.81, n, r, i;
	switch (e.tagName) {
		case "ellipse":
		case "circle": {
			r = Number(e.getAttribute("rx")), i = Number(e.getAttribute("ry"));
			let a = Number(e.getAttribute("cx")), o = Number(e.getAttribute("cy"));
			e.tagName === "circle" && e.hasAttribute("r") && (i = Number(e.getAttribute("r")), r = i), n = Oe([
				["M", [a - r, o]],
				["C", [
					a - r,
					o - i / t,
					a - r / t,
					o - i,
					a,
					o - i
				]],
				["C", [
					a + r / t,
					o - i,
					a + r,
					o - i / t,
					a + r,
					o
				]],
				["C", [
					a + r,
					o + i / t,
					a + r / t,
					o + i,
					a,
					o + i
				]],
				["C", [
					a - r / t,
					o + i,
					a - r,
					o + i / t,
					a - r,
					o
				]],
				["Z", []]
			]);
			break;
		}
		case "path":
			n = e.getAttribute("d");
			break;
		case "line":
			n = `M${e.getAttribute("x1")},${e.getAttribute("y1")}L${e.getAttribute("x2")},${e.getAttribute("y2")}`;
			break;
		case "polyline":
			n = `M${e.getAttribute("points")}`;
			break;
		case "polygon":
			n = `M${e.getAttribute("points")} Z`;
			break;
		case "rect": {
			r = Number(e.getAttribute("rx")), i = Number(e.getAttribute("ry"));
			let a = e.getBBox(), { x: o, y: s } = a, c = a.width, l = a.height;
			t = 4 - t, n = Oe(!r && !i ? [
				["M", [o, s]],
				["L", [o + c, s]],
				["L", [o + c, s + l]],
				["L", [o, s + l]],
				["L", [o, s]],
				["Z", []]
			] : [
				["M", [o, s + i]],
				["C", [
					o,
					s + i / t,
					o + r / t,
					s,
					o + r,
					s
				]],
				["L", [o + c - r, s]],
				["C", [
					o + c - r / t,
					s,
					o + c,
					s + i / t,
					o + c,
					s + i
				]],
				["L", [o + c, s + l - i]],
				["C", [
					o + c,
					s + l - i / t,
					o + c - r / t,
					s + l,
					o + c - r,
					s + l
				]],
				["L", [o + r, s + l]],
				["C", [
					o + r / t,
					s + l,
					o,
					s + l - i / t,
					o,
					s + l - i
				]],
				["L", [o, s + i]],
				["Z", []]
			]);
			break;
		}
		default: break;
	}
	return n;
}, Ae = (e) => [
	"marker-start",
	"marker-end",
	"marker-mid",
	"filter",
	"clip-path"
].reduce((t, n) => {
	let r = e.getAttribute(n);
	return r && (t[n] = r), t;
}, {}), je = (e, t, n) => {
	let r = t({
		element: "path",
		attr: Ae(e)
	}), i = e.getAttribute("transform");
	i && r.setAttribute("transform", i);
	let { parentNode: a } = e;
	e.nextSibling ? e.before(r) : a.append(r);
	let o = ke(e);
	o ? r.setAttribute("d", o) : r.remove(), n.resetOrientation(r);
	let s = !1;
	try {
		s = r.getBBox();
	} catch {}
	if (s && s.width === 0 && s.height === 0) {
		let e = ((r.getAttribute("d") || "").match(/-?\d*\.?\d+/g) || []).map(Number).filter((e) => !Number.isNaN(e));
		if (e.length >= 2) {
			let t = e.filter((e, t) => t % 2 == 0), n = e.filter((e, t) => t % 2 == 1);
			s = {
				x: Math.min(...t),
				y: Math.min(...n),
				width: Math.max(...t) - Math.min(...t),
				height: Math.max(...n) - Math.min(...n)
			};
		}
	}
	return r.remove(), s;
}, Me = (e, t, n) => {
	let r = new n.history.BatchCommand("Convert element to Path");
	t = oe(t, Ae(e));
	let i = n.addSVGElementsFromJson({
		element: "path",
		attr: t
	}), a = e.getAttribute("transform");
	a && i.setAttribute("transform", a);
	let { id: o } = e, { parentNode: s } = e;
	e.nextSibling ? e.before(i) : s.append(i);
	let c = ke(e);
	if (c) {
		i.setAttribute("d", c), a && R(I(i)) && n.pathActions.resetOrientation(i);
		let { nextSibling: t } = e;
		return r.addSubCommand(new n.history.RemoveElementCommand(e, t, e.parentNode)), n.clearSelection(), e.remove(), r.addSubCommand(new n.history.InsertElementCommand(i)), i.setAttribute("id", o), i.removeAttribute("visibility"), n.addToSelection([i], !0), n.addCommandToHistory(r), i;
	}
	return i.remove(), null;
}, Ne = (e, t) => {
	let n = e % 90;
	return t || !(n > -.001 && n < .001 || n < -89.99 || n > 89.99);
}, Pe = (e, t, n) => {
	let r = H(e);
	if (!r) return null;
	let i = e.getAttribute?.("transform") ?? "", a = i.includes("matrix(");
	if (i.includes("rotate(") && !a) {
		let [n = 0, r = 0, a = 0] = i.match(/-?\d*\.?\d+/g)?.map(Number) || [], o = n * Math.PI / 180, s = Math.cos(o), c = Math.sin(o), l = e.tagName?.toLowerCase(), u = [];
		if (l === "path") {
			let t = ((e.getAttribute("d") || "").match(/-?\d*\.?\d+/g) || []).map(Number).filter((e) => !Number.isNaN(e));
			for (let e = 0; e < t.length; e += 2) u.push({
				x: t[e],
				y: t[e + 1] ?? 0
			});
		} else if (l === "rect") {
			let t = Number(e.getAttribute("x") ?? 0), n = Number(e.getAttribute("y") ?? 0), r = Number(e.getAttribute("width") ?? 0), i = Number(e.getAttribute("height") ?? 0);
			u = [
				{
					x: t,
					y: n
				},
				{
					x: t + r,
					y: n
				},
				{
					x: t,
					y: n + i
				},
				{
					x: t + r,
					y: n + i
				}
			];
		}
		if (u.length) {
			let e = u.map((e) => {
				let t = e.x - r, n = e.y - a;
				return {
					x: r + (t * s - n * c),
					y: a + (t * c + n * s)
				};
			}), o = e.map((e) => e.x), d = e.map((e) => e.y), f = {
				x: Math.min(...o),
				y: Math.min(...d),
				width: Math.max(...o) - Math.min(...o),
				height: Math.max(...d) - Math.min(...d)
			}, p = i.match(/matrix\(([^)]+)\)/);
			if (p) {
				let e = p[1].split(/[,\s]+/).filter(Boolean).map(Number), t = e[4] ?? 0, n = e[5] ?? 0;
				f = {
					...f,
					x: f.x + t,
					y: f.y + n
				};
			}
			let m = Math.abs(n % 90) < .001;
			return l !== "path" && m && typeof t == "function" && t({
				element: "path",
				attr: {}
			}), f;
		}
	}
	let o = I(e), s = ze(o), c = R(o);
	if (s || c) {
		let i = !1;
		if (Ne(s, c)) {
			if ([
				"ellipse",
				"path",
				"line",
				"polyline",
				"polygon"
			].includes(e.tagName)) {
				let a = je(e, t, n);
				a && !(a.width === 0 && a.height === 0) && (i = a, r = a);
			} else if (e.tagName === "rect") {
				let a = Number(e.getAttribute("rx")), o = Number(e.getAttribute("ry"));
				if (a || o) {
					let a = je(e, t, n);
					a && !(a.width === 0 && a.height === 0) && (i = a, r = a);
				}
			}
		}
		if (!i) {
			let { matrix: e } = z(o);
			r = te(r.x, r.y, r.width, r.height, e).aabox;
		}
	}
	return r;
}, Fe = (e) => {
	let t = e.getAttribute("stroke-width");
	return !isNaN(t) && e.getAttribute("stroke") !== "none" ? t / 2 : 0;
}, Ie = (e, t, n) => {
	if (!e || !e.length) return !1;
	let r;
	if (e.forEach((e) => {
		r || e.parentNode && (r = Pe(e, t, n));
	}), !r) return null;
	let i = r.x + r.width, a = r.y + r.height, o = r.x, s = r.y;
	if (e.length === 1) {
		let t = Fe(e[0]);
		o -= t, s -= t, i += t, a += t;
	} else e.forEach((e) => {
		let r = Pe(e, t, n);
		if (r) {
			let t = Fe(e);
			o = Math.min(o, r.x - t), s = Math.min(s, r.y - t), e.nodeType === 1 && (i = Math.max(i, r.x + r.width + t), a = Math.max(a, r.y + r.height + t));
		}
	});
	return r.x = T(o), r.y = T(s), r.width = T(i - o), r.height = T(a - s), r;
}, Le = (e) => {
	if (!e) {
		let t = ue.getSvgContent();
		for (let n = 0; n < t.children.length; n++) if (t.children[n].getBBox) {
			let r = t.children[n].getBBox();
			if (r.width !== 0 && r.height !== 0 && r.width !== 0 && r.height !== 0) {
				e = t.children[n];
				break;
			}
		}
	}
	let t = [];
	if (e) {
		let n = e.children;
		Array.from(n, (e) => {
			e.getBBox && t.push(e);
		});
	}
	return t.reverse();
}, Re = (e) => (e ||= Le(), Ie(e, ue.addSVGElementsFromJson, ue.pathActions)), ze = (e, t) => {
	if (!e) return 0;
	for (let n = 0; n < e.numberOfItems; ++n) {
		let r = e.getItem(n);
		if (r.type === 4) return t ? r.angle * Math.PI / 180 : r.angle;
	}
	return 0;
}, Be = (e, t) => ze(I(e || ue.getSelectedElements()[0]), t), Ve = (e) => {
	if (!e) return null;
	let t = we(e);
	return t ? Ue(t[0] === "#" ? t.slice(1) : t) : null;
}, He = (e) => {
	if (e?.firstChild?.tagName === "feGaussianBlur") return e.firstChild;
	{
		let t = e.children;
		for (let [e, n] of Object.entries(t)) if (n.tagName === "feGaussianBlur") return n;
	}
	return null;
}, Ue = (e) => de.querySelector(`#${e}`), We = (e, t, n, r) => {
	for (let [n, i] of Object.entries(t)) {
		let t = n.startsWith("xml:") ? A.XML : n.startsWith("xlink:") ? A.XLINK : null;
		if (i === void 0) {
			t ? e.removeAttributeNS(t, n) : e.removeAttribute(n);
			continue;
		}
		t ? e.setAttributeNS(t, n, i) : r ? D(e, n, i) : e.setAttribute(n, i);
	}
}, Ge = (e) => {
	let t = {
		"fill-opacity": 1,
		"stop-opacity": 1,
		opacity: 1,
		stroke: "none",
		"stroke-dasharray": "none",
		"stroke-linejoin": "miter",
		"stroke-linecap": "butt",
		"stroke-opacity": 1,
		"stroke-width": 1,
		rx: 0,
		ry: 0
	};
	e.nodeName === "ellipse" && (delete t.rx, delete t.ry), Object.entries(t).forEach(([t, n]) => {
		e.getAttribute(t) === String(n) && e.removeAttribute(t);
	});
}, Ke = (e) => {
	let t = ue.getBaseUnit(), n = ue.getSnappingStep();
	return t !== "px" && (n *= w()[t]), e = Math.round(e / n) * n, e;
}, qe = (e) => {
	$e(e, (e) => {
		e.preventDefault();
	});
}, Je = (e) => new DOMParser().parseFromString(e, "text/html").body.firstChild, Ye = (e, t, n = 0) => {
	let r = Je(t);
	n >= e.children.length ? e.appendChild(r) : e.insertBefore(r, e.children[n]);
}, Xe = (e) => document.getElementById(e), Ze = (e) => document.querySelector(e), Qe = (e) => [...document.querySelectorAll(e)], $e = (e, t) => {
	e.addEventListener("click", t), e.addEventListener("touchend", t);
}, et = /* @__PURE__ */ c({
	BBOX_AFFECTING_ATTRS: () => tt,
	BatchCommand: () => lt,
	ChangeElementCommand: () => ct,
	Command: () => it,
	HistoryEventTypes: () => rt,
	InsertElementCommand: () => ot,
	MoveElementCommand: () => at,
	RemoveElementCommand: () => st,
	UndoManager: () => ut
}), tt = /* @__PURE__ */ new Set([
	"x",
	"y",
	"x1",
	"y1",
	"x2",
	"y2",
	"cx",
	"cy",
	"r",
	"rx",
	"ry",
	"width",
	"height",
	"d",
	"points"
]);
function nt(e, t) {
	if (!t.some((e) => tt.has(e))) return;
	let n = Be(e);
	if (!n) return;
	let r = I(e), i = r.numberOfItems;
	for (; i--;) if (r.getItem(i).type === 4) {
		let t = H(e);
		if (!t) return;
		r.removeItem(i);
		let a;
		a = i < r.numberOfItems ? z(r, i, r.numberOfItems - 1).matrix : e.ownerSVGElement.createSVGMatrix();
		let o = F(t.x + t.width / 2, t.y + t.height / 2, a), s = e.ownerSVGElement.createSVGTransform();
		s.setRotate(n, o.x, o.y), r.insertItemBefore(s, i);
		break;
	}
}
var rt = {
	BEFORE_APPLY: "before_apply",
	AFTER_APPLY: "after_apply",
	BEFORE_UNAPPLY: "before_unapply",
	AFTER_UNAPPLY: "after_unapply"
}, it = class {
	getText() {
		return this.text;
	}
	apply(e, t) {
		e && e.handleHistoryEvent(rt.BEFORE_APPLY, this), t(e), e && e.handleHistoryEvent(rt.AFTER_APPLY, this);
	}
	unapply(e, t) {
		e && e.handleHistoryEvent(rt.BEFORE_UNAPPLY, this), t(), e && e.handleHistoryEvent(rt.AFTER_UNAPPLY, this);
	}
	elements() {
		return [this.elem];
	}
	type() {
		return this.constructor.name;
	}
}, at = class extends it {
	constructor(e, t, n, r) {
		super(), this.elem = e, this.text = r ? `Move ${e.tagName} to ${r}` : `Move ${e.tagName}`, this.oldNextSibling = t, this.oldParent = n, this.newNextSibling = e.nextSibling, this.newParent = e.parentNode;
	}
	apply(e) {
		super.apply(e, () => {
			let e = this.newNextSibling && this.newNextSibling.parentNode === this.newParent ? this.newNextSibling : null;
			this.elem = this.newParent.insertBefore(this.elem, e);
		});
	}
	unapply(e) {
		super.unapply(e, () => {
			let e = this.oldNextSibling && this.oldNextSibling.parentNode === this.oldParent ? this.oldNextSibling : null;
			this.elem = this.oldParent.insertBefore(this.elem, e);
		});
	}
}, ot = class extends it {
	constructor(e, t) {
		super(), this.elem = e, this.text = t || `Create ${e.tagName}`, this.parent = e.parentNode, this.nextSibling = this.elem.nextSibling;
	}
	apply(e) {
		super.apply(e, () => {
			let e = this.nextSibling && this.nextSibling.parentNode === this.parent ? this.nextSibling : null;
			this.elem = this.parent.insertBefore(this.elem, e);
		});
	}
	unapply(e) {
		super.unapply(e, () => {
			this.parent = this.elem.parentNode, this.elem.remove();
		});
	}
}, st = class extends it {
	constructor(e, t, n, r) {
		super(), this.elem = e, this.text = r || `Delete ${e.tagName}`, this.nextSibling = t, this.parent = n;
	}
	apply(e) {
		super.apply(e, () => {
			this.parent = this.elem.parentNode, this.elem.remove();
		});
	}
	unapply(e) {
		super.unapply(e, () => {
			let e = this.nextSibling && this.nextSibling.parentNode === this.parent ? this.nextSibling : null;
			this.parent.insertBefore(this.elem, e);
		});
	}
}, ct = class extends it {
	constructor(e, t, n) {
		super(), this.elem = e, this.text = n ? `Change ${e.tagName} ${n}` : `Change ${e.tagName}`, this.newValues = {}, this.oldValues = t;
		for (let n in t) n === "#text" ? this.newValues[n] = e ? e.textContent : "" : n === "#href" ? this.newValues[n] = Te(e) : this.newValues[n] = e.getAttribute(n);
	}
	apply(e) {
		super.apply(e, () => {
			let e = !1;
			Object.entries(this.newValues).forEach(([t, n]) => {
				let r = n == null || n === "";
				t === "#text" ? this.elem.textContent = n == null ? "" : String(n) : t === "#href" ? r ? (this.elem.removeAttribute("href"), this.elem.removeAttributeNS(A.XLINK, "href")) : Ee(this.elem, String(n)) : r ? (this.elem.setAttribute(t, ""), this.elem.removeAttribute(t)) : this.elem.setAttribute(t, n), t === "transform" && (e = !0);
			}), e || nt(this.elem, Object.keys(this.newValues));
		});
	}
	unapply(e) {
		super.unapply(e, () => {
			let e = !1;
			Object.entries(this.oldValues).forEach(([t, n]) => {
				let r = n == null || n === "";
				t === "#text" ? this.elem.textContent = n == null ? "" : String(n) : t === "#href" ? r ? (this.elem.removeAttribute("href"), this.elem.removeAttributeNS(A.XLINK, "href")) : Ee(this.elem, String(n)) : r ? this.elem.removeAttribute(t) : this.elem.setAttribute(t, n), t === "transform" && (e = !0);
			}), e || nt(this.elem, Object.keys(this.oldValues));
		});
	}
}, lt = class extends it {
	constructor(e) {
		super(), this.text = e || "Batch Command", this.stack = [];
	}
	apply(e) {
		super.apply(e, () => {
			this.stack.forEach((t) => {
				console.assert(t, "stack item should not be null"), t && t.apply(e);
			});
		});
	}
	unapply(e) {
		super.unapply(e, () => {
			[...this.stack].reverse().forEach((t) => {
				console.assert(t, "stack item should not be null"), t && t.unapply(e);
			});
		});
	}
	elements() {
		let e = [], t = this.stack.length;
		for (; t--;) {
			if (!this.stack[t]) continue;
			let n = this.stack[t].elements(), r = n.length;
			for (; r--;) e.includes(n[r]) || e.push(n[r]);
		}
		return e;
	}
	addSubCommand(e) {
		console.assert(e !== null, "cmd should not be null"), this.stack.push(e);
	}
	isEmpty() {
		return !this.stack.length;
	}
}, ut = class {
	constructor(e) {
		this.handler_ = e || null, this.undoStackPointer = 0, this.undoStack = [], this.undoChangeStackPointer = -1, this.undoableChangeStack = [];
	}
	resetUndoStack() {
		this.undoStack = [], this.undoStackPointer = 0;
	}
	getUndoStackSize() {
		return this.undoStackPointer;
	}
	getRedoStackSize() {
		return this.undoStack.length - this.undoStackPointer;
	}
	getNextUndoCommandText() {
		return this.undoStackPointer > 0 ? this.undoStack[this.undoStackPointer - 1].getText() : "";
	}
	getNextRedoCommandText() {
		return this.undoStackPointer < this.undoStack.length ? this.undoStack[this.undoStackPointer].getText() : "";
	}
	undo() {
		this.undoStackPointer > 0 && this.undoStack[--this.undoStackPointer].unapply(this.handler_);
	}
	redo() {
		this.undoStackPointer < this.undoStack.length && this.undoStack.length > 0 && this.undoStack[this.undoStackPointer++].apply(this.handler_);
	}
	addCommandToHistory(e) {
		this.undoStackPointer < this.undoStack.length && this.undoStack.length > 0 && (this.undoStack = this.undoStack.splice(0, this.undoStackPointer)), this.undoStack.push(e), this.undoStackPointer = this.undoStack.length;
	}
	beginUndoableChange(e, t) {
		let n = ++this.undoChangeStackPointer, r = t.length, i = Array(r), a = Array(r);
		for (; r--;) {
			let n = t[r];
			n && (a[r] = n, i[r] = n.getAttribute(e));
		}
		this.undoableChangeStack[n] = {
			attrName: e,
			oldValues: i,
			elements: a
		};
	}
	finishUndoableChange() {
		let e = this.undoChangeStackPointer--, t = this.undoableChangeStack[e], { attrName: n } = t, r = new lt(`Change ${n}`), i = t.elements.length;
		for (; i--;) {
			let e = t.elements[i];
			if (!e) continue;
			let a = {};
			a[n] = t.oldValues[i], a[n] !== e.getAttribute(n) && r.addSubCommand(new ct(e, a, n));
		}
		return this.undoableChangeStack[e] = null, r;
	}
}, dt = {
	1: "Z",
	2: "M",
	3: "m",
	4: "L",
	5: "l",
	6: "C",
	7: "c",
	8: "Q",
	9: "q",
	10: "A",
	11: "a",
	12: "H",
	13: "h",
	14: "V",
	15: "v",
	16: "S",
	17: "s",
	18: "T",
	19: "t"
}, ft = Object.fromEntries(Object.entries(dt).map(([e, t]) => [t, Number(e)])), pt = class {
	constructor(e) {
		this.elem = e;
	}
	_getData() {
		return this.elem.getPathData();
	}
	_setData(e) {
		this.elem.setPathData(e);
	}
	get numberOfItems() {
		return this._getData().length;
	}
	_entryToSeg(e) {
		let { type: t, values: n = [] } = e, r = { pathSegType: ft[t] || ft[t?.toUpperCase?.()] };
		switch (String(t).toUpperCase()) {
			case "H":
				[r.x] = n;
				break;
			case "V":
				[r.y] = n;
				break;
			case "M":
			case "L":
			case "T":
				[r.x, r.y] = n;
				break;
			case "S":
				[r.x2, r.y2, r.x, r.y] = n;
				break;
			case "C":
				[r.x1, r.y1, r.x2, r.y2, r.x, r.y] = n;
				break;
			case "Q":
				[r.x1, r.y1, r.x, r.y] = n;
				break;
			case "A":
				[r.r1, r.r2, r.angle, r.largeArcFlag, r.sweepFlag, r.x, r.y] = n;
				break;
			default: break;
		}
		return r;
	}
	_segToEntry(e) {
		let t = dt[e.pathSegType] || e.type;
		if (!t) return {
			type: "Z",
			values: []
		};
		let n = String(t).toUpperCase(), r = [];
		switch (n) {
			case "H":
				r = [e.x];
				break;
			case "V":
				r = [e.y];
				break;
			case "M":
			case "L":
			case "T":
				r = [e.x, e.y];
				break;
			case "S":
				r = [
					e.x2,
					e.y2,
					e.x,
					e.y
				];
				break;
			case "C":
				r = [
					e.x1,
					e.y1,
					e.x2,
					e.y2,
					e.x,
					e.y
				];
				break;
			case "Q":
				r = [
					e.x1,
					e.y1,
					e.x,
					e.y
				];
				break;
			case "A":
				r = [
					e.r1,
					e.r2,
					e.angle,
					Number(e.largeArcFlag),
					Number(e.sweepFlag),
					e.x,
					e.y
				];
				break;
			default: r = [];
		}
		return {
			type: t,
			values: r
		};
	}
	getItem(e) {
		let t = this._getData()[e];
		return t ? this._entryToSeg(t) : null;
	}
	replaceItem(e, t) {
		let n = this._getData();
		return n[t] = this._segToEntry(e), this._setData(n), e;
	}
	insertItemBefore(e, t) {
		let n = this._getData();
		return n.splice(t, 0, this._segToEntry(e)), this._setData(n), e;
	}
	appendItem(e) {
		let t = this._getData();
		return t.push(this._segToEntry(e)), this._setData(t), e;
	}
	removeItem(e) {
		let t = this._getData();
		t.splice(e, 1), this._setData(t);
	}
	clear() {
		this._setData([]);
	}
};
typeof SVGPathElement < "u" && typeof SVGPathElement.prototype.getPathData == "function" && typeof SVGPathElement.prototype.setPathData == "function" && !("pathSegList" in SVGPathElement.prototype) && Object.defineProperty(SVGPathElement.prototype, "pathSegList", { get() {
	return this._pathSegListShim ||= new pt(this), this._pathSegListShim;
} });
var mt = null, ht = (e) => {
	mt = e;
}, gt = (e, t) => mt.getSegData()[e].map((e) => t[e]), _t = (e, t) => {
	let { path: n } = e, r = {
		x: t ? t.x : e.item.x,
		y: t ? t.y : e.item.y
	};
	n.matrix && (r = F(r.x, r.y, n.matrix));
	let i = mt.getZoom();
	return r.x *= i, r.y *= i, r;
}, vt = (e, t) => {
	let n = {
		x: e.x,
		y: e.y
	};
	t.matrix && (e = F(n.x, n.y, t.imatrix), n.x = e.x, n.y = e.y);
	let r = mt.getZoom();
	return n.x /= r, n.y /= r, n;
}, yt = () => {
	let e = Ue("pathpointgrip_container");
	if (!e) {
		let t = Ue("selectorParentGroup");
		e = document.createElementNS(A.SVG, "g"), t.append(e), e.id = "pathpointgrip_container";
	}
	return e;
}, bt = (e, t, n) => {
	let r = yt(), i = Ue(`pathpointgrip_${e}`);
	if (!i) {
		i = document.createElementNS(A.SVG, "circle");
		let t = {
			id: `pathpointgrip_${e}`,
			display: "none",
			r: 4,
			fill: "#0FF",
			stroke: "#00F",
			"stroke-width": 2,
			cursor: "move",
			style: "pointer-events:all"
		}, n = mt.getUIStrings();
		"pathNodeTooltip" in n && (t["xlink:title"] = n.pathNodeTooltip), We(i, t), r.append(i), document.getElementById("pathpointgrip_" + e)?.addEventListener("dblclick", () => {
			let e = mt.getPathObj();
			e && e.setSegType();
		});
	}
	return t && n && We(i, {
		cx: t,
		cy: n,
		display: "inline"
	}), i;
}, xt = (e) => {
	let t = Ue("ctrlpointgrip_" + e);
	if (t) return t;
	t = document.createElementNS(A.SVG, "circle");
	let n = {
		id: "ctrlpointgrip_" + e,
		display: "none",
		r: 4,
		fill: "#0FF",
		stroke: "#55F",
		"stroke-width": 1,
		cursor: "move",
		style: "pointer-events:all"
	}, r = mt.getUIStrings();
	return "pathCtrlPtTooltip" in r && (n["xlink:title"] = r.pathCtrlPtTooltip), We(t, n), yt().append(t), t;
}, St = (e) => {
	let t = Ue("ctrlLine_" + e);
	return t || (t = document.createElementNS(A.SVG, "line"), We(t, {
		id: "ctrlLine_" + e,
		stroke: "#555",
		"stroke-width": 1,
		style: "pointer-events:none"
	}), yt().append(t), t);
}, Ct = (e, t) => {
	let { index: n } = e, r = bt(n);
	if (t) {
		let t = _t(e);
		We(r, {
			cx: t.x,
			cy: t.y,
			display: "inline"
		});
	}
	return r;
}, wt = (e) => {
	let { item: t, index: n } = e;
	if (!("x1" in t) || !("x2" in t)) return null;
	let r = {};
	yt();
	let i = [mt.getPathObj().segs[n - 1].item, t];
	for (let a = 1; a < 3; a++) {
		let o = n + "c" + a, s = r[`c${a}_line`] = St(o), c = _t(e, {
			x: t["x" + a],
			y: t["y" + a]
		}), l = _t(e, {
			x: i[a - 1].x,
			y: i[a - 1].y
		});
		We(s, {
			x1: c.x,
			y1: c.y,
			x2: l.x,
			y2: l.y,
			display: "inline"
		}), r[`c${a}_line`] = s;
		let u = r[`c${a}`] = xt(o);
		We(u, {
			cx: c.x,
			cy: c.y,
			display: "inline"
		}), r["c" + a] = u;
	}
	return r;
}, Tt = (e, t, n, r) => {
	let i = mt.getPathObj(), a = r || i.elem, o = "createSVGPathSeg" + mt.getPathFuncs()[e], s = mt.getSegData?.(), c = s?.[e] || s?.[e - 1];
	if (c && n.length < c.length) {
		let e = a.pathSegList?.getItem?.(t);
		e && (n = c.map((t, r) => n[r] === void 0 ? e[t] : n[r]));
	}
	let l;
	if (typeof a[o] == "function") l = a[o](...n);
	else {
		let t = c || [];
		l = { pathSegType: e }, t.forEach((e, t) => {
			l[e] = n[t];
		});
	}
	a.pathSegList.replaceItem(l, t);
}, Et = (e, t) => {
	let { index: n } = e, r = Ue(`segline_${n}`);
	if (!r) {
		let e = yt();
		r = document.createElementNS(A.SVG, "path"), We(r, {
			id: `segline_${n}`,
			display: "none",
			fill: "none",
			stroke: "#0FF",
			"stroke-width": 2,
			style: "pointer-events:none",
			d: "M0,0 0,0"
		}), e.append(r);
	}
	if (t) {
		let { prev: t } = e;
		if (!t) return r.setAttribute("display", "none"), r;
		let n = _t(t);
		Tt(2, 0, [n.x, n.y], r);
		let i = gt(e.type, e.item);
		for (let t = 0; t < i.length; t += 2) {
			let n = _t(e, {
				x: i[t],
				y: i[t + 1]
			});
			i[t] = n.x, i[t + 1] = n.y;
		}
		Tt(e.type, 1, i, r);
	}
	return r;
}, Dt = class {
	constructor(e, t) {
		this.selected = !1, this.index = e, this.item = t, this.type = t.pathSegType, this.ctrlpts = null, this.ptgrip = null, this.segsel = null;
	}
	showCtrlPts(e) {
		for (let t in this.ctrlpts) ({}).hasOwnProperty.call(this.ctrlpts, t) && this.ctrlpts[t].setAttribute("display", e ? "inline" : "none");
	}
	selectCtrls(e) {
		document.getElementById(`ctrlpointgrip_${this.index}c1`)?.setAttribute("fill", e ? "#0FF" : "#EEE"), document.getElementById(`ctrlpointgrip_${this.index}c2`)?.setAttribute("fill", e ? "#0FF" : "#EEE");
	}
	show(e) {
		this.ptgrip && (this.ptgrip.setAttribute("display", e ? "inline" : "none"), this.segsel.setAttribute("display", e ? "inline" : "none"), this.showCtrlPts(e));
	}
	select(e) {
		this.ptgrip && (this.ptgrip.setAttribute("stroke", e ? "#0FF" : "#00F"), this.segsel.setAttribute("display", e ? "inline" : "none"), this.ctrlpts && this.selectCtrls(e), this.selected = e);
	}
	addGrip() {
		this.ptgrip = Ct(this, !0), this.ctrlpts = wt(this), this.segsel = Et(this, !0);
	}
	update(e) {
		if (this.ptgrip) {
			let t = _t(this);
			if (We(this.ptgrip, {
				cx: t.x,
				cy: t.y
			}), Et(this, !0), this.ctrlpts) {
				if (e) {
					let e = mt.getPathObj();
					this.item = e.elem.pathSegList.getItem(this.index), this.type = this.item.pathSegType;
				}
				wt(this);
			}
		}
	}
	move(e, t) {
		let { item: n } = this;
		n.x += e, n.y += t, "x2" in n && (n.x2 += e), "y2" in n && (n.y2 += t), Tt(this.type, this.index, gt(this.type, n));
		let r = this.next?.item;
		if (r && "x1" in r && "y1" in r && (r.x1 += e, r.y1 += t, Tt(this.next.type, this.next.index, gt(this.next.type, r))), this.mate) {
			let { item: n } = this.mate, r = [n.x += e, n.y += t];
			Tt(this.mate.type, this.mate.index, r);
		}
		this.update(!0), this.next && this.next.update(!0);
	}
	setLinked(e) {
		let t, n, r;
		if (e === 2) {
			if (n = 1, t = this.next, !t) return;
			r = this.item;
		} else {
			if (n = 2, t = this.prev, !t) return;
			r = t.item;
		}
		let { item: i } = t;
		i["x" + n] = r.x + (r.x - this.item["x" + e]), i["y" + n] = r.y + (r.y - this.item["y" + e]);
		let a = [
			i.x,
			i.y,
			i.x1,
			i.y1,
			i.x2,
			i.y2
		];
		Tt(t.type, t.index, a), t.update(!0);
	}
	moveCtrl(e, t, n) {
		let { item: r } = this;
		r["x" + e] += t, r["y" + e] += n;
		let i = [
			r.x,
			r.y,
			r.x1,
			r.y1,
			r.x2,
			r.y2
		];
		Tt(this.type, this.index, i), this.update(!0);
	}
	setType(e, t) {
		Tt(e, this.index, t), this.type = e;
		let n = mt.getPathObj();
		this.item = n.elem.pathSegList.getItem(this.index), this.showCtrlPts(e === 6), this.ctrlpts = wt(this), this.update(!0);
	}
}, Ot = class e {
	constructor(e) {
		if (!e || e.tagName !== "path") throw Error("svgedit.path.Path constructed without a <path> element");
		this.elem = e, this.segs = [], this.selected_pts = [], mt.setPathObj(this), this.init();
	}
	setPathContext() {
		mt.setPathObj(this);
	}
	init() {
		let e = yt().querySelectorAll("*");
		Array.prototype.forEach.call(e, function(e) {
			e.setAttribute("display", "none");
		});
		let t = this.elem.pathSegList, n = t.numberOfItems;
		this.segs = [], this.selected_pts = [], this.first_seg = null;
		for (let e = 0; e < n; e++) {
			let n = t.getItem(e), r = new Dt(e, n);
			r.path = this, this.segs.push(r);
		}
		let { segs: r } = this, i = null;
		for (let e = 0; e < n; e++) {
			let t = r[e], a = e + 1 >= n ? null : r[e + 1], o = e - 1 < 0 ? null : r[e - 1];
			if (t.type === 2) {
				if (o && o.type !== 1) {
					let e = r[i];
					e.next = r[i + 1], e.next.prev = e, e.addGrip();
				}
				i = e;
			} else if (a?.type === 1) t.next = r[i + 1], t.next.prev = t, t.mate = r[i], t.addGrip(), this.first_seg ||= t;
			else if (a) t.type !== 1 && (t.addGrip(), a && a.type !== 2 && (t.next = a, t.next.prev = t));
			else if (t.type !== 1) {
				let e = r[i];
				e.next = r[i + 1], e.next.prev = e, e.addGrip(), t.addGrip(), this.first_seg ||= r[i];
			}
		}
		return this;
	}
	eachSeg(e) {
		let t = this.segs.length;
		for (let n = 0; n < t && e.call(this.segs[n], n) !== !1; n++);
	}
	addSeg(e) {
		let t = this.segs[e];
		if (!t.prev) return;
		let { prev: n } = t, r, i, a;
		switch (t.item.pathSegType) {
			case 4:
				i = (t.item.x + n.item.x) / 2, a = (t.item.y + n.item.y) / 2, r = this.elem.createSVGPathSegLinetoAbs(i, a);
				break;
			case 6: {
				let o = (n.item.x + t.item.x1) / 2, s = (t.item.x1 + t.item.x2) / 2, c = (t.item.x2 + t.item.x) / 2, l = (o + s) / 2, u = (s + c) / 2;
				i = (l + u) / 2;
				let d = (n.item.y + t.item.y1) / 2, f = (t.item.y1 + t.item.y2) / 2, p = (t.item.y2 + t.item.y) / 2, m = (d + f) / 2, h = (f + p) / 2;
				a = (m + h) / 2, r = this.elem.createSVGPathSegCurvetoCubicAbs(i, a, o, d, l, m);
				let g = [
					t.item.x,
					t.item.y,
					u,
					h,
					c,
					p
				];
				Tt(t.type, e, g);
				break;
			}
		}
		this.elem.pathSegList.insertItemBefore(r, e);
	}
	deleteSeg(e) {
		let t = this.segs[e], n = this.elem.pathSegList;
		t.show(!1);
		let { next: r } = t;
		if (t.mate) {
			let e = [r.item.x, r.item.y];
			Tt(2, r.index, e), Tt(4, t.index, e), n.removeItem(t.mate.index);
		} else if (t.prev) n.removeItem(e);
		else {
			let i = [r.item.x, r.item.y];
			Tt(2, t.next.index, i), n.removeItem(e);
		}
	}
	removePtFromSelection(e) {
		let t = this.selected_pts.indexOf(e);
		t !== -1 && (this.segs[e].select(!1), this.selected_pts.splice(t, 1));
	}
	clearSelection() {
		this.eachSeg(function() {
			this.select(!1);
		}), this.selected_pts = [];
	}
	storeD() {
		this.last_d = this.elem.getAttribute("d");
	}
	show(e) {
		return this.eachSeg(function() {
			this.show(e);
		}), e && this.selectPt(this.first_seg.index), this;
	}
	movePts(e, t) {
		let n = this.selected_pts.length;
		for (; n--;) this.segs[this.selected_pts[n]].move(e, t);
	}
	moveCtrl(e, t) {
		let n = this.segs[this.selected_pts[0]];
		n.moveCtrl(this.dragctrl, e, t), mt.getLinkControlPts() && n.setLinked(this.dragctrl);
	}
	setSegType(e) {
		this.storeD();
		let t = this.selected_pts.length, n;
		for (; t--;) {
			let r = this.selected_pts[t], i = this.segs[r], { prev: a } = i;
			if (!a) continue;
			e ||= (n = "Toggle Path Segment Type", i.type === 6 ? 4 : 6), e = Number(e);
			let o = i.item.x, s = i.item.y, c = a.item.x, l = a.item.y, u;
			switch (e) {
				case 6:
					if (i.olditem) {
						let e = i.olditem;
						u = [
							o,
							s,
							e.x1,
							e.y1,
							e.x2,
							e.y2
						];
					} else {
						let e = o - c, t = s - l;
						u = [
							o,
							s,
							c + e / 3,
							l + t / 3,
							o - e / 3,
							s - t / 3
						];
					}
					break;
				case 4:
					u = [o, s], i.olditem = i.item;
					break;
			}
			i.setType(e, u);
		}
		mt.getPathObj().endChanges(n);
	}
	selectPt(e, t) {
		this.clearSelection(), e || this.eachSeg(function(t) {
			this.prev && (e = t);
		}), this.addPtsToSelection(e), t && (this.dragctrl = t, mt.getLinkControlPts() && this.segs[e].setLinked(t));
	}
	update() {
		let { elem: e } = this;
		return Be(e) ? (this.matrix = ne(e), this.imatrix = this.matrix.inverse()) : (this.matrix = null, this.imatrix = null), this.eachSeg(function(t) {
			this.item = e.pathSegList.getItem(t), this.update();
		}), this;
	}
	endChanges(e) {
		let t = new ct(this.elem, { d: this.last_d }, e);
		mt.endChanges({
			cmd: t,
			elem: this.elem
		});
	}
	addPtsToSelection(t) {
		Array.isArray(t) || (t = [t]), t.forEach((e) => {
			this.segs[e].ptgrip && !this.selected_pts.includes(e) && e >= 0 && this.selected_pts.push(e);
		}), this.selected_pts.sort();
		let n = this.selected_pts.length, r = [];
		for (r.length = n; n--;) {
			let e = this.selected_pts[n], t = this.segs[e];
			t.select(!0), r[n] = t.ptgrip;
		}
		let i = e.subpathIsClosed(this.selected_pts[0]);
		mt.addPtsToSelection({
			grips: r,
			closedSubpath: i
		});
	}
	static subpathIsClosed(e) {
		let t = !1;
		return mt.getPathObj().eachSeg(function(n) {
			return n <= e ? !0 : this.type === 2 ? !1 : this.type === 1 ? (t = !0, !1) : !0;
		}), t;
	}
}, U = null, W = null, kt = (e) => {
	U = e;
}, At = (e, t) => {
	let { pathSegList: n } = e, r = n.numberOfItems, i = 0, a = 0, o = "", s = null;
	for (let e = 0; e < r; ++e) {
		let r = n.getItem(e), c = r.x || 0, l = r.y || 0, u = r.x1 || 0, d = r.y1 || 0, f = r.x2 || 0, p = r.y2 || 0, m = r.pathSegTypeAsLetter;
		switch (m) {
			case "z":
			case "Z":
				o += "z", s && (i = s[0], a = s[1]);
				break;
			case "H": c -= i;
			case "h":
				t ? (l = 0, i += c, m = "l") : (l = a, c += i, i = c, m = "L"), o += jt(m, [[c, l]]);
				break;
			case "V": l -= a;
			case "v":
				t ? (c = 0, a += l, m = "l") : (c = i, l += a, a = l, m = "L"), o += jt(m, [[c, l]]);
				break;
			case "M":
			case "L":
			case "T": c -= i, l -= a;
			case "l":
			case "m":
			case "t":
				t ? (i += c, a += l, m = m.toLowerCase()) : (c += i, l += a, i = c, a = l, m = m.toUpperCase()), (m === "m" || m === "M") && (s = [i, a]), o += jt(m, [[c, l]]);
				break;
			case "C": c -= i, u -= i, f -= i, l -= a, d -= a, p -= a;
			case "c":
				t ? (i += c, a += l, m = "c") : (c += i, u += i, f += i, l += a, d += a, p += a, i = c, a = l, m = "C"), o += jt(m, [
					[u, d],
					[f, p],
					[c, l]
				]);
				break;
			case "Q": c -= i, u -= i, l -= a, d -= a;
			case "q":
				t ? (i += c, a += l, m = "q") : (c += i, u += i, l += a, d += a, i = c, a = l, m = "Q"), o += jt(m, [[u, d], [c, l]]);
				break;
			case "A": c -= i, l -= a;
			case "a":
				t ? (i += c, a += l, m = "a") : (c += i, l += a, i = c, a = l, m = "A"), o += jt(m, [[r.r1, r.r2]], [
					r.angle,
					+!!r.largeArcFlag,
					+!!r.sweepFlag
				], [c, l]);
				break;
			case "S": c -= i, f -= i, l -= a, p -= a;
			case "s":
				t ? (i += c, a += l, m = "s") : (c += i, f += i, l += a, p += a, i = c, a = l, m = "S"), o += jt(m, [[f, p], [c, l]]);
				break;
		}
	}
	return o;
}, jt = (e, t, n, r) => [
	e + t.map((e) => T(e)).join(" "),
	n ? n.join(" ") : null,
	r ? T(r) : null
].filter(Boolean).join(" "), Mt = new class {
	#e = !1;
	#t = null;
	#n = null;
	#r = null;
	#i = !1;
	#a = (e) => {
		let { points: t } = e, n = t.numberOfItems;
		if (n >= 4) {
			let r = t.getItem(0), i = null, a = [];
			a.push(`M${r.x},${r.y} C`);
			let o;
			for (o = 1; o <= n - 4; o += 3) {
				let e = t.getItem(o), n = t.getItem(o + 1), s = t.getItem(o + 2);
				if (i) {
					let t = U.smoothControlPoints(i, e, r);
					if (t?.length === 2) {
						let n = a[a.length - 1].split(",");
						n[2] = t[0].x, n[3] = t[0].y, a[a.length - 1] = n.join(","), e = t[1];
					}
				}
				a.push([
					e.x,
					e.y,
					n.x,
					n.y,
					s.x,
					s.y
				].join(",")), r = s, i = n;
			}
			for (a.push("L"); o < n;) {
				let e = t.getItem(o);
				a.push([e.x, e.y].join(",")), o++;
			}
			a = a.join(" "), e = U.addSVGElementsFromJson({
				element: "path",
				curStyles: !0,
				attr: {
					id: U.getId(),
					d: a,
					fill: "none"
				}
			});
		}
		return e;
	};
	mouseDown(e, t, n, r) {
		let i;
		if (U.getCurrentMode() === "path") {
			let t = n, a = r, o = U.getZoom(), s = t / o, c = a / o, l = Ue("path_stretch_line");
			this.#t = [s, c], U.getGridSnapping() && (s = Ke(s), c = Ke(c), t = Ke(t), a = Ke(a)), l || (l = document.createElementNS(A.SVG, "path"), We(l, {
				id: "path_stretch_line",
				stroke: "#22C",
				"stroke-width": "0.5",
				fill: "none"
			}), Ue("selectorParentGroup").append(l)), l.setAttribute("display", "inline");
			let u = null, d, f = U.getDrawnPath();
			if (f) {
				let t = f.pathSegList, n = t.numberOfItems, r = 6 / o, a = !1;
				for (; n;) {
					n--;
					let e = t.getItem(n), i = e.x, o = e.y;
					if (s >= i - r && s <= i + r && c >= o - r && c <= o + r) {
						a = !0;
						break;
					}
				}
				i = U.getId(), U.removePath_(i);
				let p = Ue(i), m, h, g = t.numberOfItems;
				if (a) {
					if (n <= 1 && g >= 2) {
						let e = t.getItem(0).x, n = t.getItem(0).y;
						h = l.pathSegList.getItem(1), m = h.pathSegType === 4 ? f.createSVGPathSegLinetoAbs(e, n) : f.createSVGPathSegCurvetoCubicAbs(e, n, h.x1 / o, h.y1 / o, e, n);
						let r = f.createSVGPathSegClosePath();
						t.appendItem(m), t.appendItem(r);
					} else if (g < 3) return u = !1, u;
					if (l.remove(), U.setDrawnPath(null), U.setStarted(!1), this.#e) {
						W.matrix && U.remapElement(p, {}, W.matrix.inverse());
						let e = p.getAttribute("d"), t = W.elem.getAttribute("d");
						return W.elem.setAttribute("d", t + e), p.parentNode.removeChild(p), W.matrix && U.recalcRotatedPath(), Mt.toEditMode(W.elem), W.selectPt(), !1;
					}
				} else {
					if (!(U.getContainer() !== U.getMouseTarget(e) && U.getContainer().contains(U.getMouseTarget(e)))) return !1;
					let t = f.pathSegList.numberOfItems, n = f.pathSegList.getItem(t - 1), r = n.x, i = n.y;
					if (e.shiftKey) {
						let e = re(r, i, s, c);
						({x: s, y: c} = e);
					}
					h = l.pathSegList.getItem(1), m = h.pathSegType === 4 ? f.createSVGPathSegLinetoAbs(U.round(s), U.round(c)) : f.createSVGPathSegCurvetoCubicAbs(U.round(s), U.round(c), h.x1 / o, h.y1 / o, h.x2 / o, h.y2 / o), f.pathSegList.appendItem(m), s *= o, c *= o, l.setAttribute("d", [
						"M",
						s,
						c,
						s,
						c
					].join(" ")), d = t, this.#e && (d += W.segs.length), U.addPointGrip(d, s, c);
				}
			} else {
				let e = `M${s},${c} `;
				U.setDrawnPath(U.addSVGElementsFromJson({
					element: "path",
					curStyles: !0,
					attr: {
						d: e,
						id: U.getNextId(),
						opacity: U.getOpacity() / 2
					}
				})), l.setAttribute("d", `M${t} ${a} ${t} ${a}`), d = this.#e ? W.segs.length : 0, U.addPointGrip(d, t, a);
			}
			return;
		}
		if (!W) return;
		W.storeD(), {id: i} = e.target;
		let a;
		if (i.startsWith("pathpointgrip_")) {
			a = W.cur_pt = Number.parseInt(i.slice(14)), W.dragging = [n, r];
			let t = W.segs[a];
			e.shiftKey ? t.selected ? W.removePtFromSelection(a) : W.addPtsToSelection(a) : ((W.selected_pts.length <= 1 || !t.selected) && W.clearSelection(), W.addPtsToSelection(a));
		} else if (i.startsWith("ctrlpointgrip_")) {
			W.dragging = [n, r];
			let e = i.split("_")[1].split("c");
			a = Number(e[0]);
			let t = Number(e[1]);
			W.selectPt(a, t);
		}
		if (!W.dragging) {
			let e = U.getRubberBox();
			e ||= U.setRubberBox(U.selectorManager.getRubberBandBox());
			let t = U.getZoom();
			We(e, {
				x: n * t,
				y: r * t,
				width: 0,
				height: 0,
				display: "inline"
			}, 100);
		}
	}
	mouseMove(e, t) {
		let n = U.getZoom();
		this.#i = !0;
		let r = U.getDrawnPath();
		if (U.getCurrentMode() === "path") {
			if (!r) return;
			let i = r.pathSegList, a = i.numberOfItems - 1;
			if (this.#t) {
				let o = U.addCtrlGrip("1c1"), s = U.addCtrlGrip("0c2");
				o.setAttribute("cx", e), o.setAttribute("cy", t), o.setAttribute("display", "inline");
				let c = this.#t[0], l = this.#t[1], u = e / n, d = t / n, f = c + (c - u), p = l + (l - d);
				if (s.setAttribute("cx", f * n), s.setAttribute("cy", p * n), s.setAttribute("display", "inline"), We(U.getCtrlLine(1), {
					x1: e,
					y1: t,
					x2: f * n,
					y2: p * n,
					display: "inline"
				}), a === 0) this.#n = [e, t];
				else {
					let e = i.getItem(a - 1), t = e.x, o = e.y;
					e.pathSegType === 6 ? (t += t - e.x2, o += o - e.y2) : this.#n && (t = this.#n[0] / n, o = this.#n[1] / n), U.replacePathSeg(6, a, [
						c,
						l,
						t,
						o,
						f,
						p
					], r);
				}
			} else {
				let r = Ue("path_stretch_line");
				if (r) {
					let o = i.getItem(a);
					if (o.pathSegType === 6) {
						let i = o.x + (o.x - o.x2), a = o.y + (o.y - o.y2);
						U.replacePathSeg(6, 1, [
							e,
							t,
							i * n,
							a * n,
							e,
							t
						], r);
					} else this.#n ? U.replacePathSeg(6, 1, [
						e,
						t,
						this.#n[0],
						this.#n[1],
						e,
						t
					], r) : U.replacePathSeg(4, 1, [e, t], r);
				}
			}
			return;
		}
		if (W.dragging) {
			let n = U.getPointFromGrip({
				x: W.dragging[0],
				y: W.dragging[1]
			}, W), r = U.getPointFromGrip({
				x: e,
				y: t
			}, W), i = r.x - n.x, a = r.y - n.y;
			W.dragging = [e, t], W.dragctrl ? W.moveCtrl(i, a) : W.movePts(i, a);
		} else W.selected_pts = [], W.eachSeg(function(e) {
			let t = this;
			if (!t.next && !t.prev) return;
			let n = H(U.getRubberBox()), r = U.getGripPt(t), i = ie(n, {
				x: r.x,
				y: r.y,
				width: 0,
				height: 0
			});
			this.select(i), i && W.selected_pts.push(t.index);
		});
	}
	mouseUp(e, t, n, r) {
		let i = U.getDrawnPath();
		if (U.getCurrentMode() === "path") return this.#t = null, i || (t = Ue(U.getId()), U.setStarted(!1), this.#n = null), {
			keep: !0,
			element: t
		};
		let a = U.getRubberBox();
		if (W.dragging) {
			let t = W.cur_pt;
			W.dragging = !1, W.dragctrl = !1, W.update(), this.#i && W.endChanges("Move path point(s)"), !e.shiftKey && !this.#i && W.selectPt(t);
		} else a?.getAttribute("display") === "none" ? Mt.toSelectMode(e.target) : (a.setAttribute("display", "none"), a.getAttribute("width") <= 2 && a.getAttribute("height") <= 2 && Mt.toSelectMode(e.target));
		this.#i = !1;
	}
	toEditMode(e) {
		W = U.getPath_(e), U.setCurrentMode("pathedit"), U.clearSelection(), W.setPathContext(), W.show(!0).update(), W.oldbbox = H(W.elem), this.#e = !1;
	}
	toSelectMode(e) {
		let t = e === W.elem;
		U.setCurrentMode("select"), W.setPathContext(), W.show(!1), this.#r = !1, U.clearSelection(), W.matrix && U.recalcRotatedPath(), t && (U.call("selected", [e]), U.addToSelection([e], !0));
	}
	addSubPath(e) {
		e ? (U.setCurrentMode("path"), this.#e = !0) : (Mt.clear(!0), Mt.toEditMode(W.elem));
	}
	select(e) {
		this.#r === e ? (Mt.toEditMode(e), U.setCurrentMode("pathedit")) : this.#r = e;
	}
	reorient() {
		let e = U.getSelectedElements()[0];
		if (!e || e.nodeName !== "path" || Be(e) === 0) return;
		let t = new lt("Reorient path"), n = {
			d: e.getAttribute("d"),
			transform: e.getAttribute("transform")
		};
		t.addSubCommand(new ct(e, n)), U.clearSelection(), this.resetOrientation(e), U.addCommandToHistory(t), U.getPath_(e).show(!1).matrix = null, this.clear(), U.addToSelection([e], !0), U.call("changed", U.getSelectedElements());
	}
	clear() {
		let e = U.getDrawnPath();
		if (this.#r = null, e) {
			let e = Ue(U.getId()), t = Ue("path_stretch_line");
			t.parentNode.removeChild(t), e.parentNode.removeChild(e);
			let n = Ue("pathpointgrip_container").querySelectorAll("*");
			for (let e of n) e.setAttribute("display", "none");
			this.#n = null, U.setDrawnPath(null), U.setStarted(!1);
		} else U.getCurrentMode() === "pathedit" && this.toSelectMode();
		W && W.init().show(!1);
	}
	resetOrientation(e) {
		if (e?.nodeName !== "path") return !1;
		let t = I(e), n = z(t).matrix;
		t.clear(), e.removeAttribute("transform");
		let r = e.pathSegList, i = r.numberOfItems;
		for (let t = 0; t < i; ++t) {
			let i = r.getItem(t), a = i.pathSegType;
			if (a === 1) continue;
			let o = [];
			for (let e of [
				"",
				1,
				2
			]) {
				let t = i["x" + e], r = i["y" + e];
				if (t !== void 0 && r !== void 0) {
					let e = F(t, r, n);
					o.push(e.x, e.y);
				}
			}
			U.replacePathSeg(a, t, o, e);
		}
		U.reorientGrads(e, n);
	}
	zoomChange() {
		U.getCurrentMode() === "pathedit" && W.update();
	}
	getNodePoint() {
		let e = W.selected_pts.length ? W.selected_pts[0] : 1, t = W.segs[e];
		return {
			x: t.item.x,
			y: t.item.y,
			type: t.type
		};
	}
	linkControlPoints(e) {
		U.setLinkControlPoints(e);
	}
	clonePathNode() {
		W.storeD();
		let e = W.selected_pts, t = e.length, n = [];
		for (; t--;) {
			let r = e[t];
			W.addSeg(r), n.push(r + t), n.push(r + t + 1);
		}
		W.init().addPtsToSelection(n), W.endChanges("Clone path node(s)");
	}
	opencloseSubPath() {
		let e = W.selected_pts;
		if (e.length !== 1) return;
		let { elem: t } = W, n = t.pathSegList, r = e[0], i = null, a = null;
		if (W.eachSeg(function(e) {
			return this.type === 2 && e <= r && (a = this.item), e <= r ? !0 : this.type === 2 ? (i = e, !1) : this.type === 1 ? (i = !1, !1) : !0;
		}), i ||= W.segs.length - 1, i !== !1) {
			let e = t.createSVGPathSegLinetoAbs(a.x, a.y), r = t.createSVGPathSegClosePath();
			i === W.segs.length - 1 ? (n.appendItem(e), n.appendItem(r)) : (n.insertItemBefore(r, i), n.insertItemBefore(e, i)), W.init().selectPt(i + 1);
			return;
		}
		if (W.segs[r].mate) {
			n.removeItem(r), n.removeItem(r), W.init().selectPt(r - 1);
			return;
		}
		let o, s;
		for (let e = 0; e < n.numberOfItems; e++) {
			let t = n.getItem(e);
			if (t.pathSegType === 2) o = e;
			else if (e === r) n.removeItem(o);
			else if (t.pathSegType === 1 && r < e) {
				s = e - 1, n.removeItem(e);
				break;
			}
		}
		let c = r - o - 1;
		for (; c--;) n.insertItemBefore(n.getItem(o), s);
		let l = n.getItem(o);
		U.replacePathSeg(2, o, [l.x, l.y]), W.init().selectPt(0);
	}
	deletePathNode() {
		if (!Mt.canDeleteNodes) return;
		W.storeD();
		let e = W.selected_pts, t = e.length;
		for (; t--;) {
			let n = e[t];
			W.deleteSeg(n);
		}
		let n = () => {
			let e = W.elem.pathSegList, t = e.numberOfItems, r = (t, n) => {
				for (; n--;) e.removeItem(t);
			};
			if (t <= 1) return !0;
			for (; t--;) {
				let i = e.getItem(t);
				if (i.pathSegType === 1) {
					let i = e.getItem(t - 1), a = e.getItem(t - 2);
					if (i.pathSegType === 2) {
						r(t - 1, 2), n();
						break;
					} else if (a.pathSegType === 2) {
						r(t - 2, 3), n();
						break;
					}
				} else if (i.pathSegType === 2 && t > 0) {
					let i = e.getItem(t - 1).pathSegType;
					if (i === 2) {
						r(t - 1, 1), n();
						break;
					} else if (i === 1 && e.numberOfItems - 1 === t) {
						r(t, 1), n();
						break;
					}
				}
			}
			return !1;
		};
		if (n(), W.elem.pathSegList.numberOfItems <= 1) {
			Mt.toSelectMode(W.elem), U.canvas.deleteSelectedElements();
			return;
		}
		W.init(), W.clearSelection(), window.opera && W.elem.setAttribute("d", W.elem.getAttribute("d")), W.endChanges("Delete path node(s)");
	}
	smoothPolylineIntoPath(e) {
		return this.#a(e);
	}
	setSegType(e) {
		W?.setSegType(e);
	}
	moveNode(e, t) {
		let n = W.selected_pts;
		if (!n.length) return;
		W.storeD();
		let r = W.segs[n[0]], i = {
			x: 0,
			y: 0
		};
		i[e] = t - r.item[e], r.move(i.x, i.y), W.endChanges("Move path point");
	}
	fixEnd(e) {
		let t = e.pathSegList, n = t.numberOfItems, r;
		for (let i = 0; i < n; ++i) {
			let n = t.getItem(i);
			if (n.pathSegType === 2 && (r = n), n.pathSegType === 1) {
				let n = t.getItem(i - 1);
				if (n.x !== r.x || n.y !== r.y) {
					let n = e.createSVGPathSegLinetoAbs(r.x, r.y);
					t.insertItemBefore(n, i), Mt.fixEnd(e);
					break;
				}
			}
		}
	}
	convertPath(e, t) {
		return At(e, t);
	}
}(), Nt = /* @__PURE__ */ c({
	addCtrlGrip: () => Yt,
	addPointGrip: () => qt,
	clearData: () => fn,
	convertPath: () => hn,
	getControlPoints: () => Qt,
	getCtrlLine: () => Xt,
	getGripContainer: () => Jt,
	getGripPt: () => Gt,
	getPath_: () => nn,
	getPointFromGrip: () => Kt,
	getPointGrip: () => Zt,
	getSegSelector: () => en,
	init: () => Ut,
	path: () => Ht,
	pathActions: () => _n,
	ptObjToArr: () => Wt,
	recalcRotatedPath: () => dn,
	removePath_: () => rn,
	reorientGrads: () => pn,
	replacePathSeg: () => $t,
	setLinkControlPoints: () => Vt,
	setUiStrings: () => Lt,
	smoothControlPoints: () => tn
}), Pt = {
	2: ["x", "y"],
	4: ["x", "y"],
	6: [
		"x",
		"y",
		"x1",
		"y1",
		"x2",
		"y2"
	],
	8: [
		"x",
		"y",
		"x1",
		"y1"
	],
	10: [
		"x",
		"y",
		"r1",
		"r2",
		"angle",
		"largeArcFlag",
		"sweepFlag"
	],
	12: ["x"],
	14: ["y"],
	16: [
		"x",
		"y",
		"x2",
		"y2"
	],
	18: ["x", "y"]
}, Ft, It = {}, Lt = (e) => {
	Object.assign(It, e.ui);
}, Rt = [], zt = !0, Bt = {}, Vt = (e) => {
	zt = e;
}, Ht = null, Ut = (e) => {
	Ft = e, Ft.replacePathSeg = Tt, Ft.addPointGrip = bt, Ft.removePath_ = rn, Ft.getPath_ = nn, Ft.addCtrlGrip = xt, Ft.getCtrlLine = St, Ft.getGripPt = Gt, Ft.getPointFromGrip = vt, Ft.setLinkControlPoints = Vt, Ft.reorientGrads = pn, Ft.recalcRotatedPath = dn, Ft.getSegData = () => Pt, Ft.getUIStrings = () => It, Ft.getPathObj = () => Ht, Ft.setPathObj = (e) => {
		Ht = e;
	}, Ft.getPathFuncs = () => Rt, Ft.getLinkControlPts = () => zt, Rt = [0, "ClosePath"], [
		"Moveto",
		"Lineto",
		"CurvetoCubic",
		"CurvetoQuadratic",
		"Arc",
		"LinetoHorizontal",
		"LinetoVertical",
		"CurvetoCubicSmooth",
		"CurvetoQuadraticSmooth"
	].forEach((e) => {
		Rt.push(e + "Abs"), Rt.push(e + "Rel");
	}), kt(Ft), ht(Ft);
}, Wt = gt, Gt = _t, Kt = vt, qt = bt, Jt = yt, Yt = xt, Xt = St, Zt = Ct, Qt = wt, $t = Tt, en = Et, tn = (e, t, n) => {
	let r = e.x - n.x, i = e.y - n.y, a = t.x - n.x, o = t.y - n.y;
	if ((r !== 0 || i !== 0) && (a !== 0 || o !== 0)) {
		let e = Math.sqrt(r * r + i * i), t = Math.sqrt(a * a + o * o), s = Ft.getSvgRoot().createSVGPoint(), c = Ft.getSvgRoot().createSVGPoint(), l = Math.atan2(i, r), u = Math.atan2(o, a);
		l < 0 && (l += 2 * Math.PI), u < 0 && (u += 2 * Math.PI);
		let d = Math.abs(l - u), f = Math.abs(Math.PI - d) / 2, p, m;
		return l - u > 0 ? (p = d < Math.PI ? l + f : l - f, m = d < Math.PI ? u - f : u + f) : (p = d < Math.PI ? l - f : l + f, m = d < Math.PI ? u + f : u - f), s.x = e * Math.cos(p) + n.x, s.y = e * Math.sin(p) + n.y, c.x = t * Math.cos(m) + n.x, c.y = t * Math.sin(m) + n.y, [s, c];
	}
}, nn = (e) => {
	let t = Bt[e.id];
	return t ||= Bt[e.id] = new Ot(e), t;
}, rn = (e) => {
	e in Bt && delete Bt[e];
}, an, on, sn, cn, ln, un = (e, t) => {
	let n = e - sn, r = t - cn, i = Math.sqrt(n * n + r * r), a = Math.atan2(r, n) + ln;
	return n = i * Math.cos(a) + sn, r = i * Math.sin(a) + cn, n -= an, r -= on, i = Math.sqrt(n * n + r * r), a = Math.atan2(r, n) - ln, {
		x: i * Math.cos(a) + an,
		y: i * Math.sin(a) + on
	};
}, dn = () => {
	let e = Ht?.elem;
	if (!e || (ln = Be(e, !0), !ln)) return;
	let t = Ht.oldbbox;
	if (!t) return;
	sn = t.x + t.width / 2, cn = t.y + t.height / 2;
	let n = H(e);
	if (!n) return;
	an = n.x + n.width / 2, on = n.y + n.height / 2;
	let r = an - sn, i = on - cn, a = Math.sqrt(r * r + i * i), o = Math.atan2(i, r) + ln;
	an = a * Math.cos(o) + sn, on = a * Math.sin(o) + cn;
	let s = e.pathSegList;
	if (!s) return;
	let c = s.numberOfItems;
	for (; c;) {
		--c;
		let e = s.getItem(c), t = e.pathSegType;
		if (t === 1) continue;
		let n = Pt[t];
		if (!n) continue;
		let r = {};
		if (e.x !== null && e.x !== void 0 && e.y !== null && e.y !== void 0) {
			let t = un(e.x, e.y);
			r.x = t.x, r.y = t.y;
		}
		if (e.x1 !== null && e.x1 !== void 0 && e.y1 !== null && e.y1 !== void 0) {
			let t = un(e.x1, e.y1);
			r.x1 = t.x, r.y1 = t.y;
		}
		if (e.x2 !== null && e.x2 !== void 0 && e.y2 !== null && e.y2 !== void 0) {
			let t = un(e.x2, e.y2);
			r.x2 = t.x, r.y2 = t.y;
		}
		let i = n.map((t) => Object.prototype.hasOwnProperty.call(r, t) ? r[t] : e[t] ?? 0);
		$t(t, c, i);
	}
	H(e);
	let l = Ft.getSvgRoot().createSVGTransform(), u = I(e);
	u && (l.setRotate(ln * 180 / Math.PI, an, on), u.numberOfItems ? typeof u.replaceItem == "function" ? u.replaceItem(l, 0) : (u.removeItem(0), u.insertItemBefore(l, 0)) : u.appendItem(l));
}, fn = () => {
	Bt = {};
}, pn = (e, t) => {
	let n = H(e);
	for (let r = 0; r < 2; r++) {
		let i = r === 0 ? "fill" : "stroke", a = e.getAttribute(i);
		if (a && a.startsWith("url(")) {
			let r = Ve(a);
			if (r.tagName === "linearGradient") {
				let a = r.getAttribute("x1") || 0, o = r.getAttribute("y1") || 0, s = r.getAttribute("x2") || 1, c = r.getAttribute("y2") || 0;
				a = n.width * a + n.x, o = n.height * o + n.y, s = n.width * s + n.x, c = n.height * c + n.y;
				let l = F(a, o, t), u = F(s, c, t), d = {
					x1: (l.x - n.x) / n.width,
					y1: (l.y - n.y) / n.height,
					x2: (u.x - n.x) / n.width,
					y2: (u.y - n.y) / n.height
				}, f = r.cloneNode(!0);
				for (let [e, t] of Object.entries(d)) f.setAttribute(e, t);
				f.id = Ft.getNextId(), De().append(f), e.setAttribute(i, `url(#${f.id})`);
			}
		}
	}
}, mn = [
	0,
	"z",
	"M",
	"m",
	"L",
	"l",
	"C",
	"c",
	"Q",
	"q",
	"A",
	"a",
	"H",
	"h",
	"V",
	"v",
	"S",
	"s",
	"T",
	"t"
], hn = (e, t) => {
	let { pathSegList: n } = e, r = n.numberOfItems, i = 0, a = 0, o = "", s = null;
	for (let e = 0; e < r; ++e) {
		let r = n.getItem(e), c = r.x || 0, l = r.y || 0, u = r.x1 || 0, d = r.y1 || 0, f = r.x2 || 0, p = r.y2 || 0, m = r.pathSegType, h = mn[m][t ? "toLowerCase" : "toUpperCase"]();
		switch (m) {
			case 1:
				o += "z", s && (i = s[0], a = s[1]);
				break;
			case 12: c -= i;
			case 13:
				t ? (l = 0, i += c, h = "l") : (l = a, c += i, i = c, h = "L"), o += gn(h, [[c, l]]);
				break;
			case 14: l -= a;
			case 15:
				t ? (c = 0, a += l, h = "l") : (c = i, l += a, a = l, h = "L"), o += gn(h, [[c, l]]);
				break;
			case 2:
			case 4:
			case 18:
			case 10: c -= i, l -= a;
			case 5:
			case 3:
			case 19:
				t ? (i += c, a += l) : (c += i, l += a, i = c, a = l), (m === 2 || m === 3) && (s = [i, a]), o += gn(h, [[c, l]]);
				break;
			case 6: c -= i, u -= i, f -= i, l -= a, d -= a, p -= a;
			case 7:
				t ? (i += c, a += l) : (c += i, u += i, f += i, l += a, d += a, p += a, i = c, a = l), o += gn(h, [
					[u, d],
					[f, p],
					[c, l]
				]);
				break;
			case 8: c -= i, u -= i, l -= a, d -= a;
			case 9:
				t ? (i += c, a += l) : (c += i, u += i, l += a, d += a, i = c, a = l), o += gn(h, [[u, d], [c, l]]);
				break;
			case 11:
				t ? (i += c, a += l) : (c += i, l += a, i = c, a = l), o += gn(h, [[r.r1, r.r2]], [
					r.angle,
					+!!r.largeArcFlag,
					+!!r.sweepFlag
				], [c, l]);
				break;
			case 16: c -= i, f -= i, l -= a, p -= a;
			case 17:
				t ? (i += c, a += l) : (c += i, f += i, l += a, p += a, i = c, a = l), o += gn(h, [[f, p], [c, l]]);
				break;
		}
	}
	return o;
}, gn = (e, t, n, r) => {
	t.forEach((e, n) => {
		t[n] = T(e);
	});
	let i = e + t.join(" ");
	return n && (i += ` ${n.join(" ")}`), r && (i += ` ${T(r)}`), i;
}, _n = Mt, vn = class e {
	constructor(e, t, n) {
		if (this.name_ = e, this.group_ = n ? null : t, n) {
			let r = n.ownerDocument;
			this.group_ = r.createElementNS(A.SVG, "g");
			let i = r.createElementNS(A.SVG, "title");
			i.textContent = e, this.group_.append(i), t ? t.insertAdjacentElement("afterend", this.group_) : n.append(this.group_);
		}
		yn(this.group_), Se(this.group_, function(e) {
			e.style.pointerEvents = "inherit";
		}), this.group_.style.pointerEvents = n ? "all" : "none";
	}
	getName() {
		return this.name_;
	}
	getGroup() {
		return this.group_;
	}
	activate() {
		this.group_.style.pointerEvents = "all";
	}
	deactivate() {
		this.group_.style.pointerEvents = "none";
	}
	setVisible(e) {
		let t = e === void 0 || e ? "inline" : "none";
		this.group_.getAttribute("display") !== t && this.group_.setAttribute("display", t);
	}
	isVisible() {
		return this.group_.getAttribute("display") !== "none";
	}
	getOpacity() {
		let e = this.group_.getAttribute("opacity");
		return e ? Number.parseFloat(e) : 1;
	}
	setOpacity(e) {
		typeof e == "number" && e >= 0 && e <= 1 && this.group_.setAttribute("opacity", e);
	}
	appendChildren(e) {
		for (let t of e) this.group_.append(t);
	}
	getTitleElement() {
		let e = this.group_.childNodes.length;
		for (let t = 0; t < e; ++t) {
			let e = this.group_.childNodes.item(t);
			if (e?.tagName === "title") return e;
		}
		return null;
	}
	setName(e, t) {
		let n = this.name_;
		e = pe(e);
		let r = this.getTitleElement();
		if (r) {
			for (; r.firstChild;) r.removeChild(r.firstChild);
			return r.textContent = e, this.name_ = e, t && t.changeElement(r, { "#text": n }), this.name_;
		}
		return null;
	}
	removeGroup() {
		let e = this.group_;
		return this.group_.remove(), this.group_ = void 0, e;
	}
	static isLayer(t) {
		return t && t.tagName === "g" && e.CLASS_REGEX.test(t.getAttribute("class"));
	}
};
vn.CLASS_NAME = "layer", vn.CLASS_REGEX = RegExp(`(\\s|^)${vn.CLASS_NAME}(\\s|$)`);
var yn = (e) => {
	let t = e.getAttribute("class");
	!t || !t.length ? e.setAttribute("class", vn.CLASS_NAME) : vn.CLASS_REGEX.test(t) || e.setAttribute("class", `${t} ${vn.CLASS_NAME}`);
}, bn = class {
	constructor(e) {
		this.undoManager_ = e, this.currentBatchCommand_ = null, this.batchCommandStack_ = [];
	}
	startBatchCommand(e) {
		return this.undoManager_ ? (this.currentBatchCommand_ = new lt(e), this.batchCommandStack_.push(this.currentBatchCommand_), this) : this;
	}
	endBatchCommand() {
		if (!this.undoManager_) return this;
		if (this.currentBatchCommand_) {
			let e = this.currentBatchCommand_;
			this.batchCommandStack_.pop();
			let { length: t } = this.batchCommandStack_;
			this.currentBatchCommand_ = t ? this.batchCommandStack_[t - 1] : null, e.isEmpty() || this.addCommand_(e);
		}
		return this;
	}
	moveElement(e, t, n, r) {
		return this.undoManager_ && this.addCommand_(new at(e, t, n, r)), this;
	}
	insertElement(e, t) {
		return this.undoManager_ && this.addCommand_(new ot(e, t)), this;
	}
	removeElement(e, t, n, r) {
		return this.undoManager_ && this.addCommand_(new st(e, t, n, r)), this;
	}
	changeElement(e, t, n) {
		return this.undoManager_ && this.addCommand_(new ct(e, t, n)), this;
	}
	addCommand_(e) {
		if (!this.undoManager_) return this;
		this.currentBatchCommand_ ? this.currentBatchCommand_.addSubCommand(e) : this.undoManager_.addCommandToHistory(e);
	}
};
bn.NO_HISTORY = new bn(null);
var xn = new class {
	#e = /* @__PURE__ */ new WeakMap();
	#t = (e) => e !== null && (typeof e == "object" || typeof e == "function");
	put(e, t, n) {
		if (!this.#t(e)) return;
		let r = this.#e.get(e);
		r || (r = /* @__PURE__ */ new Map(), this.#e.set(e, r)), r.set(t, n);
	}
	get(e, t) {
		if (this.#t(e)) return this.#e.get(e)?.get(t);
	}
	has(e, t) {
		return this.#t(e) ? this.#e.get(e)?.has(t) === !0 : !1;
	}
	remove(e, t) {
		if (!this.#t(e)) return !1;
		let n = this.#e.get(e);
		if (!n) return !1;
		let r = n.delete(t);
		return n.size === 0 && this.#e.delete(e), r;
	}
}(), Sn = (e, t) => {
	let n = e?.ownerDocument || document, r = n.createElementNS(e.namespaceURI, e.nodeName);
	if (Array.from(e.attributes).forEach((e) => {
		e.namespaceURI ? r.setAttributeNS(e.namespaceURI, e.name, e.value) : r.setAttribute(e.name, e.value);
	}), r.removeAttribute("id"), r.id = t(), e.childNodes.forEach((e) => {
		switch (e.nodeType) {
			case 1:
				r.append(Sn(e, t));
				break;
			case 3:
			case 4:
				r.append(n.createTextNode(e.nodeValue ?? ""));
				break;
			default: break;
		}
	}), xn.has(e, "gsvg")) {
		let e = r.firstElementChild || r.firstChild;
		e && xn.put(r, "gsvg", e);
	}
	return xn.has(e, "symbol") && xn.put(r, "symbol", xn.get(e, "symbol")), xn.has(e, "ref") && xn.put(r, "ref", xn.get(e, "ref")), r.tagName === "image" && qe(r), r;
}, Cn = "a,circle,ellipse,foreignObject,g,image,line,path,polygon,polyline,rect,svg,text,tspan,use".split(","), wn = {
	LET_DOCUMENT_DECIDE: 0,
	ALWAYS_RANDOMIZE: 1,
	NEVER_RANDOMIZE: 2
}, Tn = wn.LET_DOCUMENT_DECIDE, En = [], Dn = (e) => e || new bn(Nn.undoMgr), On = (e) => {
	let t = e.querySelector("title");
	return t ? t.textContent : "";
}, kn = (e) => e.classList.contains("layer"), An = (e) => {
	let t = 1;
	for (; e.includes(`Layer ${t}`);) t++;
	return `Layer ${t}`;
}, jn = class {
	constructor(e, t) {
		if (!e || !e.tagName || !e.namespaceURI || e.tagName !== "svg" || e.namespaceURI !== A.SVG) throw Error("Error: svgedit.draw.Drawing instance initialized without a <svg> element");
		this.svgElem_ = e, this.obj_num = 0, this.idPrefix = t || "svg_", this.releasedNums = [], this.all_layers = [], this.layer_map = {}, this.current_layer = null, this.nonce_ = "";
		let n = this.svgElem_.getAttributeNS(A.SE, "nonce");
		n && Tn !== wn.NEVER_RANDOMIZE ? this.nonce_ = n : Tn === wn.ALWAYS_RANDOMIZE && this.setNonce(Math.floor(Math.random() * 100001));
	}
	getElem_(e) {
		return this.svgElem_.querySelector ? this.svgElem_.querySelector(`#${e}`) : this.svgElem_.querySelector(`[id=${e}]`);
	}
	getSvgElem() {
		return this.svgElem_;
	}
	getNonce() {
		return this.nonce_;
	}
	setNonce(e) {
		this.svgElem_.setAttributeNS(A.XMLNS, "xmlns:se", A.SE), this.svgElem_.setAttributeNS(A.SE, "se:nonce", e), this.nonce_ = e;
	}
	clearNonce() {
		this.nonce_ = "";
	}
	getId() {
		return this.nonce_ ? `${this.idPrefix}${this.nonce_}_${this.obj_num}` : this.idPrefix + this.obj_num;
	}
	getNextId() {
		let e = this.obj_num, t = !1;
		this.releasedNums.length > 0 ? (this.obj_num = this.releasedNums.pop(), t = !0) : this.obj_num++;
		let n = this.getId();
		for (; this.getElem_(n);) t &&= (this.obj_num = e, !1), this.obj_num++, n = this.getId();
		return t && (this.obj_num = e), n;
	}
	releaseId(e) {
		let t = `${this.idPrefix}${this.nonce_ ? `${this.nonce_}_` : ""}`;
		if (typeof e != "string" || !e.startsWith(t)) return !1;
		let n = e.slice(t.length);
		if (!/^[0-9]+$/.test(n)) return !1;
		let r = Number.parseInt(n);
		return typeof r != "number" || r <= 0 || this.releasedNums.includes(r) ? !1 : (this.releasedNums.push(r), !0);
	}
	getNumLayers() {
		return this.all_layers.length;
	}
	hasLayer(e) {
		return this.layer_map[e] !== void 0;
	}
	getLayerName(e) {
		return e >= 0 && e < this.getNumLayers() ? this.all_layers[e].getName() : "";
	}
	getCurrentLayer() {
		return this.current_layer ? this.current_layer.getGroup() : null;
	}
	getLayerByName(e) {
		let t = this.layer_map[e];
		return t ? t.getGroup() : null;
	}
	getCurrentLayerName() {
		return this.current_layer ? this.current_layer.getName() : "";
	}
	setCurrentLayerName(e, t) {
		let n = null;
		if (this.current_layer) {
			let r = this.current_layer.getName();
			n = this.current_layer.setName(e, t), n && (delete this.layer_map[r], this.layer_map[n] = this.current_layer);
		}
		return n;
	}
	setCurrentLayerPosition(e) {
		let t = this.getNumLayers();
		if (!this.current_layer || e < 0 || e >= t) return null;
		let n = this.indexCurrentLayer();
		if (n === -1 || n === e) return null;
		let r = this.current_layer.getGroup(), i = r.nextSibling, a = null;
		return e > n ? e < t - 1 && (a = this.all_layers[e + 1].getGroup()) : a = this.all_layers[e].getGroup(), this.svgElem_.insertBefore(r, a), this.identifyLayers(), this.setCurrentLayer(this.getLayerName(e)), {
			currentGroup: r,
			oldNextSibling: i
		};
	}
	mergeLayer(e) {
		let t = this.current_layer.getGroup(), n = t.previousElementSibling;
		if (!n) return;
		e.startBatchCommand("Merge Layer");
		let r = t.nextSibling;
		for (e.removeElement(t, r, this.svgElem_); t.firstChild;) {
			let r = t.firstChild;
			if (r.localName === "title") {
				e.removeElement(r, r.nextSibling, t), r.remove();
				continue;
			}
			let i = r.nextSibling;
			n.append(r), e.moveElement(r, i, t);
		}
		this.current_layer.removeGroup();
		let i = this.indexCurrentLayer();
		if (i > 0) {
			let e = this.current_layer.getName();
			this.current_layer = this.all_layers[i - 1], this.all_layers.splice(i, 1), delete this.layer_map[e];
		}
		e.endBatchCommand();
	}
	mergeAllLayers(e) {
		for (this.current_layer = this.all_layers[this.all_layers.length - 1], e.startBatchCommand("Merge all Layers"); this.all_layers.length > 1;) this.mergeLayer(e);
		e.endBatchCommand();
	}
	setCurrentLayer(e) {
		let t = this.layer_map[e];
		return t ? (this.current_layer && this.current_layer.deactivate(), this.current_layer = t, this.current_layer.activate(), !0) : !1;
	}
	indexCurrentLayer() {
		return this.all_layers.indexOf(this.current_layer);
	}
	deleteCurrentLayer() {
		if (this.current_layer && this.getNumLayers() > 1) {
			let e = this.current_layer.removeGroup();
			return this.identifyLayers(), e;
		}
		return null;
	}
	identifyLayers() {
		this.all_layers = [], this.layer_map = {};
		let e = this.svgElem_.childNodes.length, t = [], n = [], r = null, i = !1;
		for (let a = 0; a < e; ++a) {
			let e = this.svgElem_.childNodes.item(a);
			if (e?.nodeType === 1) if (e.tagName === "g") if (i = !0, kn(e)) {
				let t = On(e);
				n.push(t), r = new vn(t, e), this.all_layers.push(r), this.layer_map[t] = r;
			} else t.push(e);
			else Cn.includes(e.nodeName) && t.push(e);
		}
		if (t.length > 0 || !i) {
			let e = An(n);
			r = new vn(e, null, this.svgElem_), r.appendChildren(t), this.all_layers.push(r), this.layer_map[e] = r;
		} else r.activate();
		this.current_layer = r;
	}
	createLayer(e, t) {
		this.current_layer && this.current_layer.deactivate(), (e == null || e === "" || this.layer_map[e]) && (e = An(Object.keys(this.layer_map)));
		let n = new vn(e, null, this.svgElem_);
		return t && (t.startBatchCommand("Create Layer"), t.insertElement(n.getGroup()), t.endBatchCommand()), this.all_layers.push(n), this.layer_map[e] = n, this.current_layer = n, n.getGroup();
	}
	cloneLayer(e, t) {
		if (!this.current_layer) return null;
		this.current_layer.deactivate(), (e == null || e === "" || this.layer_map[e]) && (e = An(Object.keys(this.layer_map)));
		let n = this.current_layer.getGroup(), r = new vn(e, n, this.svgElem_), i = r.getGroup();
		[...n.childNodes].forEach((e) => {
			if (e.nodeType !== 1) {
				i.append(e.cloneNode(!0));
				return;
			}
			e.localName !== "title" && i.append(this.copyElem(e));
		}), t && (t.startBatchCommand("Duplicate Layer"), t.insertElement(i), t.endBatchCommand());
		let a = this.indexCurrentLayer();
		return a >= 0 ? this.all_layers.splice(a + 1, 0, r) : this.all_layers.push(r), this.layer_map[e] = r, this.current_layer = r, i;
	}
	getLayerVisibility(e) {
		let t = this.layer_map[e];
		return t ? t.isVisible() : !1;
	}
	setLayerVisibility(e, t) {
		if (typeof t != "boolean") return null;
		let n = this.layer_map[e];
		return n ? (n.setVisible(t), n.getGroup()) : null;
	}
	getLayerOpacity(e) {
		let t = this.layer_map[e];
		return t ? t.getOpacity() : null;
	}
	setLayerOpacity(e, t) {
		if (typeof t != "number" || t < 0 || t > 1) return;
		let n = this.layer_map[e];
		n && n.setOpacity(t);
	}
	copyElem(e) {
		return Sn(e, () => this.getNextId());
	}
}, Mn = (e, t) => {
	Tn = e === !1 ? wn.NEVER_RANDOMIZE : wn.ALWAYS_RANDOMIZE, Tn === wn.ALWAYS_RANDOMIZE && !t.getNonce() ? t.setNonce(Math.floor(Math.random() * 100001)) : Tn === wn.NEVER_RANDOMIZE && t.getNonce() && t.clearNonce();
}, Nn, Pn = (e) => {
	Nn = e;
}, Fn = () => {
	qn(), Nn.getCurrentDrawing().identifyLayers();
}, In = () => Nn.getCurrentDrawing().indexCurrentLayer(), Ln = (e, t) => {
	let n = Nn.getCurrentDrawing().createLayer(e, Dn(t));
	Nn.clearSelection(), Nn.call("changed", [n]);
}, Rn = (e, t) => {
	let n = Nn.getCurrentDrawing().cloneLayer(e, Dn(t));
	if (!n) {
		g("cloneLayer: no layer returned", null, "draw");
		return;
	}
	Nn.clearSelection(), qn(), Nn.call("changed", [n]);
}, zn = () => {
	let { BatchCommand: e, RemoveElementCommand: t } = Nn.history, n = Nn.getCurrentDrawing().getCurrentLayer();
	if (!n) return g("deleteCurrentLayer: no current layer", null, "draw"), !1;
	let { nextSibling: r } = n, i = n.parentNode, a = Nn.getCurrentDrawing().deleteCurrentLayer();
	if (a && i) {
		let n = new e("Delete Layer");
		return n.addSubCommand(new t(a, r, i)), Nn.addCommandToHistory(n), Nn.clearSelection(), Nn.call("changed", [i]), !0;
	}
	return !1;
}, Bn = (e) => {
	let t = Nn.getCurrentDrawing().setCurrentLayer(pe(e));
	return t && Nn.clearSelection(), t;
}, Vn = (e) => {
	let t = Nn.getCurrentDrawing(), n = t.getCurrentLayer();
	return n && t.setCurrentLayerName(e, Dn()) ? (Nn.call("changed", [n]), !0) : !1;
}, Hn = (e) => {
	let { MoveElementCommand: t } = Nn.history, n = Nn.getCurrentDrawing().setCurrentLayerPosition(e);
	return n ? (Nn.addCommandToHistory(new t(n.currentGroup, n.oldNextSibling, Nn.getSvgContent())), !0) : !1;
}, Un = (e, t) => {
	let { ChangeElementCommand: n } = Nn.history, r = Nn.getCurrentDrawing(), i = r.getLayerByName(e);
	if (!i) return g("setLayerVisibility: layer not found", e, "draw"), !1;
	let a = i.getAttribute("display"), o = r.setLayerVisibility(e, t);
	return o ? (Nn.addCommandToHistory(new n(o, { display: a }, "Layer Visibility")), o === r.getCurrentLayer() && (Nn.clearSelection(), Nn.pathActions.clear()), !0) : !1;
}, Wn = (e) => {
	let { BatchCommand: t, MoveElementCommand: n } = Nn.history, r = Nn.getCurrentDrawing().getLayerByName(e);
	if (!r) return !1;
	let i = new t("Move Elements to Layer"), a = Nn.getSelectedElements(), o = a.length;
	for (; o--;) {
		let e = a[o], t = e?.parentNode;
		if (!e || !t || t === r) continue;
		let s = e.nextSibling;
		r.append(e), i.addSubCommand(new n(e, s, t));
	}
	return i.isEmpty() ? (g("moveSelectedToLayer: no elements moved", null, "draw"), !1) : (Nn.addCommandToHistory(i), !0);
}, Gn = (e) => {
	Nn.getCurrentDrawing().mergeLayer(Dn(e)), Nn.clearSelection(), qn(), Nn.changeSvgContent();
}, Kn = (e) => {
	Nn.getCurrentDrawing().mergeAllLayers(Dn(e)), Nn.clearSelection(), qn(), Nn.changeSvgContent();
}, qn = () => {
	let e = En.length, t = Nn.getDataStorage();
	if (e) {
		for (let n = 0; n < e; n++) {
			let e = En[n], r = t.get(e, "orig_opac");
			r == null ? e.removeAttribute("opacity") : e.setAttribute("opacity", r), e.setAttribute("style", "pointer-events: inherit"), t.remove(e, "orig_opac");
		}
		En = [], Nn.clearSelection(!0), Nn.call("contextset", null);
	}
	Nn.setCurrentGroup(null);
}, Jn = (e) => {
	let t = Nn.getDataStorage();
	if (qn(), typeof e == "string") {
		let t = e;
		try {
			e = Ue(t);
		} catch {
			e = null;
		}
		if (!e && typeof document < "u") {
			let n = document.getElementById(t), r = Nn.getSvgContent?.();
			e = n && (!r || r.contains(n)) ? n : null;
		}
	}
	if (!e) return;
	Nn.setCurrentGroup(e);
	let n = le(e, "#svgcontent");
	if (!n) return;
	let r = [];
	n.forEach(function(e) {
		e?.parentNode && Array.prototype.filter.call(e.parentNode.children, function(t) {
			return t !== e;
		}).forEach(function(e) {
			r.push(e);
		});
	}), r.forEach(function(e) {
		let n = e.getAttribute("opacity");
		t.put(e, "orig_opac", n);
		let r = Number.parseFloat(n), i = Number.isFinite(r) ? r : 1;
		e.setAttribute("opacity", i * .33), e.setAttribute("style", "pointer-events: none"), En.push(e);
	}), Nn.clearSelection(), Nn.call("contextset", Nn.getCurrentGroup());
}, { InsertElementCommand: Yn, BatchCommand: Xn } = et, Zn = null, Qn = (e) => {
	Zn = e;
}, $n = (e, t, n) => {
	let r = sessionStorage.getItem(Zn.getClipboardID()), i;
	try {
		i = JSON.parse(r);
	} catch {
		return;
	}
	if (!Array.isArray(i) || !i.length) return;
	let a = [], o = new Xn("Paste elements"), s = {}, c = (e) => {
		e.attr?.id && (s[e.attr.id] = Zn.getNextId(), e.attr.id = s[e.attr.id]), e.children && e.children.forEach((e) => c(e));
	};
	i.forEach((e) => c(e));
	let l = (e) => {
		let t = e?.attr;
		if (t) for (let [e, n] of Object.entries(t)) {
			if (typeof n != "string" || !n) continue;
			if ((e === "href" || e === "xlink:href") && n.startsWith("#")) {
				let r = n.slice(1);
				r in s && (t[e] = `#${s[r]}`);
			}
			let r = we(n);
			if (r) {
				let i = r.slice(1);
				i in s && (t[e] = n.replace(r, `#${s[i]}`));
			}
		}
		e.children && e.children.forEach((e) => l(e));
	};
	i.forEach((e) => l(e)), Zn.runExtensions("IDsUpdated", {
		elems: i,
		changes: s
	}, !0).forEach(function(e) {
		!e || !("remove" in e) || e.remove.forEach(function(e) {
			i = i.filter(function(t) {
				return t?.attr?.id !== e;
			});
		});
	});
	let u = i.length;
	if (u) {
		for (; u--;) {
			let e = i[u];
			if (!e) continue;
			let t = Zn.addSVGElementsFromJson(e);
			a.push(t), o.addSubCommand(new Yn(t)), Zn.restoreRefElements(t);
		}
		if (a.length) {
			if (Zn.selectOnly(a), e !== "in_place") {
				let r, i;
				e ? e === "point" && (r = t, i = n) : (r = Zn.getLastClickPoint("x"), i = Zn.getLastClickPoint("y"));
				let s = Re(a);
				if (s && Number.isFinite(r) && Number.isFinite(i)) {
					let e = r - (s.x + s.width / 2), t = i - (s.y + s.height / 2), n = [], c = [];
					a.forEach(function(r) {
						n.push(e), c.push(t);
					});
					let l = Zn.moveSelectedElements(n, c, !1);
					l && o.addSubCommand(l);
				}
			}
			Zn.addCommandToHistory(o), Zn.call("changed", a);
		}
	}
}, er = (e) => {
	e.preventDefault();
	let { changedTouches: t } = e, n = t[0], r = "";
	switch (e.type) {
		case "touchstart":
			r = "mousedown";
			break;
		case "touchmove":
			r = "mousemove";
			break;
		case "touchend":
			r = "mouseup";
			break;
		default: return;
	}
	let { screenX: i, screenY: a, clientX: o, clientY: s } = n, c = new MouseEvent(r, {
		bubbles: !0,
		cancelable: !0,
		view: window,
		detail: 1,
		screenX: i,
		screenY: a,
		clientX: o,
		clientY: s,
		ctrlKey: !1,
		altKey: !1,
		shiftKey: !1,
		metaKey: !1,
		button: 0,
		relatedTarget: null
	});
	t.length < 2 && n.target.dispatchEvent(c);
}, tr = (e) => {
	e.svgroot.addEventListener("touchstart", er), e.svgroot.addEventListener("touchmove", er), e.svgroot.addEventListener("touchend", er), e.svgroot.addEventListener("touchcancel", er);
}, nr = (e, t) => e.importNode(be(`<svg id="svgroot" xmlns="${A.SVG}" xlinkns="${A.XLINK}" width="${t[0]}" 
        height="${t[1]}" x="${t[0]}" y="${t[1]}" overflow="visible">
        <defs>
          <filter id="canvashadow" filterUnits="objectBoundingBox">
            <feGaussianBlur in="SourceAlpha" stdDeviation="4" result="blur"/>
            <feOffset in="blur" dx="5" dy="5" result="offsetBlur"/>
            <feMerge>
              <feMergeNode in="offsetBlur"/>
              <feMergeNode in="SourceGraphic"/>
            </feMerge>
          </filter>
        </defs>
      </svg>`).documentElement, !0), rr = "http://www.w3.org/2000/svg", ir = new class {
	#e = navigator.userAgent;
	#t = /* @__PURE__ */ new Map();
	get isWebkit() {
		return this.#t.has("isWebkit") || this.#t.set("isWebkit", this.#e.includes("AppleWebKit")), this.#t.get("isWebkit");
	}
	get isGecko() {
		return this.#t.has("isGecko") || this.#t.set("isGecko", this.#e.includes("Gecko/")), this.#t.get("isGecko");
	}
	get isChrome() {
		return this.#t.has("isChrome") || this.#t.set("isChrome", this.#e.includes("Chrome/")), this.#t.get("isChrome");
	}
	get isMac() {
		return this.#t.has("isMac") || this.#t.set("isMac", this.#e.includes("Macintosh")), this.#t.get("isMac");
	}
	get supportsGoodTextCharPos() {
		return this.#t.has("supportsGoodTextCharPos") || this.#t.set("supportsGoodTextCharPos", this.#n()), this.#t.get("supportsGoodTextCharPos");
	}
	#n() {
		let e = document.createElementNS(rr, "svg"), t = document.createElementNS(rr, "svg");
		document.documentElement.append(e), t.setAttribute("x", 5), e.append(t);
		let n = document.createElementNS(rr, "text");
		n.textContent = "a", t.append(n);
		try {
			return n.getStartPositionOfChar(0).x === 0;
		} catch {
			return !1;
		} finally {
			e.remove();
		}
	}
}(), ar = () => ir.isWebkit, or = () => ir.isGecko, sr = () => ir.isChrome, cr = () => ir.supportsGoodTextCharPos, { UndoManager: lr, HistoryEventTypes: ur } = et, dr = null, fr = (e) => {
	dr = e, e.undoMgr = pr();
}, pr = () => new lr({ handleHistoryEvent(e, t) {
	let n = ur;
	if (e === n.BEFORE_UNAPPLY || e === n.BEFORE_APPLY) dr.clearSelection();
	else if (e === n.AFTER_APPLY || e === n.AFTER_UNAPPLY) {
		let r = t.type(), i = e === n.AFTER_APPLY;
		if (r === "ChangeElementCommand" && t.elem === dr.getSvgContent()) {
			let e = i ? t.newValues : t.oldValues;
			if (e.width !== null && e.width !== void 0 && e.width !== "") {
				let t = Number(e.width);
				Number.isFinite(t) && t > 0 && (dr.contentW = t);
			}
			if (e.height !== null && e.height !== void 0 && e.height !== "") {
				let t = Number(e.height);
				Number.isFinite(t) && t > 0 && (dr.contentH = t);
			}
		}
		let a = t.elements();
		if (dr.pathActions.clear(), dr.call("changed", a), r === "MoveElementCommand") (i ? t.newParent : t.oldParent) === dr.getSvgContent() && Fn();
		else if (r === "InsertElementCommand" || r === "RemoveElementCommand") t.parent === dr.getSvgContent() && Fn(), r === "InsertElementCommand" ? i && dr.restoreRefElements(t.elem) : i || dr.restoreRefElements(t.elem), t.elem?.tagName === "use" && dr.setUseData(t.elem);
		else if (r === "ChangeElementCommand") {
			t.elem.tagName === "title" && t.elem.parentNode.parentNode === dr.getSvgContent() && Fn();
			let r = i ? t.newValues : t.oldValues;
			if (r.stdDeviation && dr.setBlurOffsets(t.elem.parentNode, r.stdDeviation), t.elem.tagName === "text") {
				let [r, i] = [t.newValues.x - t.oldValues.x, t.newValues.y - t.oldValues.y], a = t.elem.children;
				for (let t = 0; t < a.length; t++) {
					let o = Number(a[t].getAttribute("x")), s = Number(a[t].getAttribute("y")), c = e === n.AFTER_UNAPPLY;
					o = c ? o - r : o + r, s = c ? s - i : s + i, a[t].setAttribute("x", o), a[t].setAttribute("y", s);
				}
			}
		}
	}
} }), mr = (e) => {
	if (!or()) return e;
	let t = e.cloneNode(!0);
	return e.before(t), e.remove(), dr.selectorManager.releaseSelector(e), dr.setSelectedElements(0, t), dr.selectorManager.requestSelector(t).showGrips(!0), t;
}, hr = (e, t, n) => {
	if (e === "id") {
		let e = n[0], r = e.id;
		r !== t && (dr.clearSelection(), e.id = t, dr.addToSelection([e], !0), dr.call("elementRenamed", {
			elem: e,
			oldId: r,
			newId: t
		}));
		return;
	}
	let r = dr.getSelectedElements(), i = dr.getZoom();
	dr.getCurrentMode() === "pathedit" && dr.pathActions.moveNode(e, t), n ??= r;
	let a = n.length, o = [
		"g",
		"polyline",
		"path"
	];
	for (; a--;) {
		let s = n[a];
		if (!s) continue;
		if ((e === "x" || e === "y") && o.includes(s.tagName)) {
			let n = Re([s]), r = e === "x" ? parseFloat(t) - n.x : 0, a = e === "y" ? parseFloat(t) - n.y : 0;
			dr.moveSelectedElements(r * i, a * i, !0);
			continue;
		}
		let c = e === "#text" ? s.textContent : s.getAttribute(e);
		if (c ||= "", c !== String(t)) {
			if (e === "#text") s.textContent = t, /rotate/.test(s.getAttribute("transform")) && (s = mr(s));
			else if (e === "#href") Ee(s, t);
			else if (t) {
				let n = Number(t);
				s.setAttribute(e, Number.isNaN(n) ? t : n);
			} else typeof t == "number" ? s.setAttribute(e, t) : s.removeAttribute(e);
			dr.getCurrentMode() === "textedit" && e !== "#text" && s.textContent.length && dr.textActions.toSelectMode(s), or() && s.nodeName === "text" && /rotate/.test(s.getAttribute("transform")) && (String(t).startsWith("url") || [
				"font-size",
				"font-family",
				"x",
				"y"
			].includes(e) && s.textContent) && (s = mr(s)), r.includes(s) && setTimeout(function() {
				s.parentNode && dr.selectorManager.requestSelector(s).resize();
			}, 0);
			let n = Be(s);
			if (n !== 0 && e !== "transform" && tt.has(e)) {
				let e = I(s), t = e.numberOfItems;
				for (; t--;) if (e.getItem(t).type === 4) {
					let r = H(s);
					if (!r) break;
					e.removeItem(t);
					let i;
					i = t < e.numberOfItems ? z(e, t, e.numberOfItems - 1).matrix : dr.getSvgRoot().createSVGMatrix();
					let a = F(r.x + r.width / 2, r.y + r.height / 2, i), o = dr.getSvgRoot().createSVGTransform();
					o.setRotate(n, a.x, a.y), e.insertItemBefore(o, t);
					break;
				}
			}
		}
	}
}, gr = (e, t, n) => {
	let r = dr.getSelectedElements();
	n ||= r, dr.undoMgr.beginUndoableChange(e, n), hr(e, t, n);
	let i = dr.undoMgr.finishUndoableChange();
	i.isEmpty() || dr.undoMgr.addCommandToHistory(i);
}, { BatchCommand: _r } = et, vr = null, yr = (e) => {
	vr = e, vr.getMouseTarget = Sr, vr.clearSelection = br, vr.addToSelection = xr, vr.getIntersectionList = Tr, vr.runExtensions = Cr, vr.groupSvgElem = Er, vr.prepareSvg = Dr, vr.recalculateAllSelectedDimensions = kr, vr.setRotationAngle = Or;
}, br = (e) => {
	vr.getSelectedElements().forEach((e) => {
		e && vr.selectorManager.releaseSelector(e);
	}), vr?.setEmptySelectedElements(), e || vr.call("selected", vr.getSelectedElements());
}, xr = (e, t) => {
	let n = vr.getSelectedElements();
	if (!e.length) return;
	let r = 0;
	for (; r < n.length && n[r] !== null;) ++r;
	let i = e.length;
	for (; i--;) {
		let t = e[i];
		if (!(!t || !t.getBBox) && (t.tagName === "a" && t.childNodes.length === 1 && (t = t.firstChild), !n.includes(t))) {
			n[r] = t, r++;
			let e = vr.selectorManager.requestSelector(t);
			n.length > 1 && e.showGrips(!1);
		}
	}
	if (n.length) for (vr.call("selected", n), n.length === 1 && vr.selectorManager.requestSelector(n[0]).showGrips(t), n.sort((e, t) => e && t && e.compareDocumentPosition ? 3 - (t.compareDocumentPosition(e) & 6) : +!e); !n[0];) n.shift(0);
}, Sr = (e) => {
	if (!e) return null;
	let t = e.target;
	if (t.correspondingUseElement && (t = t.correspondingUseElement), [A.MATH, A.HTML].includes(t.namespaceURI) && t.id !== "svgcanvas") {
		for (; t.nodeName !== "foreignObject";) if (t = t.parentNode, !t) return vr.getSvgRoot();
	}
	let n = vr.getCurrentDrawing().getCurrentLayer();
	if ([
		vr.getSvgRoot(),
		vr.getDOMContainer(),
		vr.getSvgContent(),
		n
	].includes(t)) return vr.getSvgRoot();
	if (se(t.parentNode, "#selectorParentGroup")) return vr.selectorManager.selectorParentGroup;
	for (; !t?.parentNode?.isSameNode(vr.getCurrentGroup() || n);) t = t.parentNode;
	return t;
}, Cr = (e, t, n) => {
	let r = n ? [] : !1;
	for (let [i, a] of Object.entries(vr.getExtensions())) if (typeof t == "function" && (t = t(i)), a.eventBased) {
		let n = new CustomEvent("svgedit", { detail: {
			action: e,
			vars: t
		} });
		document.dispatchEvent(n);
	} else a[e] && (n ? r.push(a[e](t)) : r = a[e](t));
	return r;
}, wr = (e) => {
	e ||= vr.getSvgContent().children;
	let t = [], n = e.children;
	return Array.from(n).forEach((e) => {
		e.getBBox && t.push({
			elem: e,
			bbox: Re([e])
		});
	}), t.reverse();
}, Tr = (e) => {
	let t = vr.getZoom();
	if (!vr.getRubberBox()) return null;
	let n = vr.getCurrentGroup() || vr.getCurrentDrawing().getCurrentLayer(), r;
	if (e) r = vr.getSvgContent().createSVGRect(), r.x = e.x, r.y = e.y, r.width = e.width, r.height = e.height;
	else {
		r = H(vr.getRubberBox());
		let e = vr.getSvgContent().createSVGRect();
		[
			"x",
			"y",
			"width",
			"height",
			"top",
			"right",
			"bottom",
			"left"
		].forEach((n) => {
			e[n] = r[n] / t;
		}), r = e;
	}
	let i = [];
	vr.getCurBBoxes().length === 0 && vr.setCurBBoxes(wr(n));
	let a = vr.getCurBBoxes().length;
	for (; a--;) {
		let e = vr.getCurBBoxes();
		r.width && e[a].bbox && ie(r, e[a].bbox) && i.push(e[a].elem);
	}
	return i;
}, Er = (e) => {
	let t = vr.getDataStorage(), n = document.createElementNS(A.SVG, "g");
	e.replaceWith(n), n.appendChild(e), t.put(n, "gsvg", e), n.id = vr.getNextId();
}, Dr = (e) => {
	vr.sanitizeSvg(e.documentElement), [...e.getElementsByTagNameNS(A.SVG, "path")].forEach((e) => {
		let t = vr.pathActions.convertPath(e);
		e.setAttribute("d", t), vr.pathActions.fixEnd(e);
	});
}, Or = (e, t) => {
	let n = vr.getSelectedElements();
	e = Number.parseFloat(e);
	let r = n[0], i = r.getAttribute("transform"), a = H(r), o = a.x + a.width / 2, s = a.y + a.height / 2, c = I(r);
	if (c.numberOfItems > 0 && c.getItem(0).type === 4 && c.removeItem(0), e !== 0) {
		let t = F(o, s, z(c).matrix), n = Number.isFinite(t.x) ? t.x : o, r = Number.isFinite(t.y) ? t.y : s, i = vr.getSvgRoot().createSVGTransform();
		i.setRotate(e, n, r), c.numberOfItems ? c.insertItemBefore(i, 0) : c.appendItem(i);
	} else c.numberOfItems === 0 && r.removeAttribute("transform");
	if (!t) {
		let e = r.getAttribute("transform");
		if (e && e.startsWith("rotate(")) {
			let t = e.match(/^rotate\(([\d.\-e]+)\s+([\d.\-e]+)\s+([\d.\-e]+)\)(.*)/);
			if (t) {
				let n = Number.parseFloat(t[1]), r = (e) => Math.round(Number(e) + 2 ** -52);
				e = `rotate(${n} ${r(t[2])} ${r(t[3])})${t[4] || ""}`;
			}
		}
		i ? r.setAttribute("transform", i) : r.removeAttribute("transform"), vr.changeSelectedAttribute("transform", e, n), vr.call("changed", n);
	}
	vr.selectorManager.requestSelector(n[0]).resize(), vr.getSelector().updateGripCursors(e);
}, kr = () => {
	let e = new _r(vr.getCurrentResizeMode() === "none" ? "position" : "size"), t = vr.getSelectedElements();
	t.forEach((t) => {
		let n = vr.recalculateDimensions(t);
		n && e.addSubCommand(n);
	}), e.isEmpty() || (vr.addCommandToHistory(e), vr.call("changed", t));
}, Ar = null, jr = (e) => {
	Ar = e;
}, Mr = new class {
	#e = null;
	#t = null;
	#n = null;
	#r = null;
	#i = null;
	#a = [];
	#o = null;
	#s = null;
	#c = null;
	#l = null;
	#u = !1;
	#d = (e) => {
		let t = Ar.getSvgContent(), n = [], r = e;
		for (; r && r !== t && r.nodeType === 1;) {
			let e = I(r);
			if (e && e.numberOfItems > 0) {
				let t = z(e).matrix;
				n.unshift(t);
			}
			r = r.parentNode;
		}
		return n.length === 0 ? null : n.length === 1 ? n[0] : L(...n);
	};
	#f = (e = void 0) => {
		let t = this.#t.value === "";
		if (this.#t.focus(), e === void 0) if (t) e = 0;
		else {
			if (this.#t.selectionEnd !== this.#t.selectionStart) return;
			e = this.#t.selectionEnd;
		}
		let n = this.#a[e];
		t || this.#t.setSelectionRange(e, e), this.#n = Ue("text_cursor"), this.#n || (this.#n = document.createElementNS(A.SVG, "line"), We(this.#n, {
			id: "text_cursor",
			stroke: "#333",
			"stroke-width": 1
		}), Ue("selectorParentGroup").append(this.#n)), this.#i ||= setInterval(() => {
			let e = this.#n.getAttribute("display") === "none";
			this.#n.setAttribute("display", e ? "inline" : "none");
		}, 600);
		let r = this.#v(n.x, this.#o.y), i = this.#v(n.x, this.#o.y + this.#o.height);
		We(this.#n, {
			x1: r.x,
			y1: r.y,
			x2: i.x,
			y2: i.y,
			visibility: "visible",
			display: "inline"
		}), this.#r && this.#r.setAttribute("d", "");
	};
	#p = (e, t, n) => {
		if (e === t) {
			this.#f(t);
			return;
		}
		n || this.#t.setSelectionRange(e, t), this.#r = Ue("text_selectblock"), this.#r || (this.#r = document.createElementNS(A.SVG, "path"), We(this.#r, {
			id: "text_selectblock",
			fill: "green",
			opacity: .5,
			style: "pointer-events:none"
		}), Ue("selectorParentGroup").append(this.#r));
		let r = this.#a[e], i = this.#a[t];
		this.#n.setAttribute("visibility", "hidden");
		let a = this.#v(r.x, this.#o.y), o = this.#v(r.x + (i.x - r.x), this.#o.y), s = this.#v(r.x, this.#o.y + this.#o.height), c = this.#v(r.x + (i.x - r.x), this.#o.y + this.#o.height), l = "M" + a.x + "," + a.y + " L" + o.x + "," + o.y + " " + c.x + "," + c.y + " " + s.x + "," + s.y + "z";
		We(this.#r, {
			d: l,
			display: "inline"
		});
	};
	#m = (e, t) => {
		let n = Ar.getSvgRoot().createSVGPoint();
		if (n.x = e, n.y = t, this.#a.length === 1) return 0;
		let r = this.#e.getCharNumAtPosition(n);
		r < 0 ? (r = this.#a.length - 2, e <= this.#a[0].x && (r = 0)) : r >= this.#a.length - 2 && (r = this.#a.length - 2);
		let i = this.#a[r];
		return e > i.x + i.width / 2 && r++, r;
	};
	#h = (e, t) => {
		this.#f(this.#m(e, t));
	};
	#g = (e, t, n) => {
		let r = this.#t.selectionStart, i = this.#m(e, t), a = Math.min(r, i), o = Math.max(r, i);
		this.#p(a, o, !n);
	};
	#_ = (e, t) => {
		let n = {
			x: e,
			y: t
		}, r = Ar.getZoom();
		if (n.x /= r, n.y /= r, this.#s) {
			let e = F(n.x, n.y, this.#s.inverse());
			n.x = e.x, n.y = e.y;
		}
		return n;
	};
	#v = (e, t) => {
		let n = {
			x: e,
			y: t
		};
		if (this.#s) {
			let e = F(n.x, n.y, this.#s);
			n.x = e.x, n.y = e.y;
		}
		let r = Ar.getZoom();
		return n.x *= r, n.y *= r, n;
	};
	#y = (e) => {
		this.#p(0, this.#e.textContent.length), e.target.removeEventListener("click", this.#y);
	};
	#b = (e) => {
		if (!this.#u || !this.#e) return;
		let t = Ar.getZoom(), n = F(e.pageX, e.pageY, Ar.getrootSctm()), r = n.x * t, i = n.y * t, a = this.#_(r, i), o = this.#m(a.x, a.y), s = this.#e.textContent, c = s.slice(0, o).replace(/[a-z\d]+$/i, "").length, l = s.slice(o).match(/^[a-z\d]+/i), u = (l ? l[0].length : 0) + o;
		this.#p(c, u), Ar.$click(e.target, this.#y), setTimeout(() => {
			e.target.removeEventListener("click", this.#y);
		}, 300);
	};
	select(e, t, n) {
		this.#e = e, Ar.textActions.toEditMode(t, n);
	}
	start(e) {
		this.#e = e, Ar.textActions.toEditMode();
	}
	mouseDown(e, t, n, r) {
		let i = this.#_(n, r);
		this.#t.focus(), this.#h(i.x, i.y), this.#c = n, this.#l = r;
	}
	mouseMove(e, t) {
		let n = this.#_(e, t);
		this.#g(n.x, n.y);
	}
	mouseUp(e, t, n) {
		let r = this.#_(t, n);
		this.#g(r.x, r.y, !0), e.target !== this.#e && t < this.#c + 2 && t > this.#c - 2 && n < this.#l + 2 && n > this.#l - 2 && Ar.textActions.toSelectMode(!0);
	}
	setCursor(e) {
		this.#f(e);
	}
	toEditMode(e, t) {
		if (this.#u = !1, Ar.setCurrentMode("textedit"), Ar.selectorManager.requestSelector(this.#e).showGrips(!1), Ar.selectorManager.requestSelector(this.#e), Ar.textActions.init(), this.#e.style.cursor = "text", arguments.length === 0) this.#f();
		else {
			let n = this.#_(e, t);
			this.#h(n.x, n.y);
		}
		setTimeout(() => {
			this.#u = !0;
		}, 300);
	}
	toSelectMode(e) {
		Ar.setCurrentMode("select"), clearInterval(this.#i), this.#i = null, this.#r && this.#r.setAttribute("display", "none"), this.#n && this.#n.setAttribute("visibility", "hidden"), this.#e.style.cursor = "move", e && (Ar.clearSelection(), this.#e.style.cursor = "move", Ar.call("selected", [this.#e]), Ar.addToSelection([this.#e], !0)), this.#e?.textContent.length || Ar.deleteSelectedElements(), this.#t.blur(), this.#e = !1;
	}
	setInputElem(e) {
		this.#t = e;
	}
	clear() {
		Ar.getCurrentMode() === "textedit" && Ar.textActions.toSelectMode();
	}
	init(e) {
		if (!this.#e) return;
		let t, n;
		if (!this.#e.parentNode) {
			let e = Ar.getSelectedElements();
			this.#e = e[0], Ar.selectorManager.requestSelector(this.#e).showGrips(!1);
		}
		let r = this.#e.textContent.length;
		for (this.#o = H(this.#e), this.#s = this.#d(this.#e), this.#a = [], this.#a.length = r, this.#t.focus(), this.#e.removeEventListener("dblclick", this.#b), this.#e.addEventListener("dblclick", this.#b), r || (n = {
			x: this.#o.x + this.#o.width / 2,
			width: 0
		}), t = 0; t < r; t++) {
			let e = this.#e.getStartPositionOfChar(t);
			if (n = this.#e.getEndPositionOfChar(t), !cr()) {
				let t = Ar.getZoom(), r = Ar.contentW * t;
				e.x -= r, n.x -= r, e.x /= t, n.x /= t;
			}
			this.#a[t] = {
				x: e.x,
				y: this.#o.y,
				width: n.x - e.x,
				height: this.#o.height
			};
		}
		this.#a.push({
			x: n.x,
			width: 0
		}), this.#p(this.#t.selectionStart, this.#t.selectionEnd, !0);
	}
}(), { InsertElementCommand: Nr, BatchCommand: Pr, ChangeElementCommand: Fr } = et, G = null, Ir = !1, Lr = (e) => {
	G = e, G.mouseDownEvent = Gr, G.mouseMoveEvent = Vr, G.dblClickEvent = Wr, G.mouseUpEvent = Ur, G.mouseOutEvent = Hr, G.DOMMouseScrollEvent = Kr;
}, Rr = (e) => {
	let t = {
		x: 0,
		y: 0
	}, n = {
		x: G.getControllPoint2("x"),
		y: G.getControllPoint2("y")
	}, r = {
		x: G.getControllPoint1("x"),
		y: G.getControllPoint1("y")
	}, i = {
		x: G.getStart("x"),
		y: G.getStart("y")
	}, a = {
		x: G.getEnd("x"),
		y: G.getEnd("y")
	}, o = 1 / 6, s = e * e, c = s * e, l = [
		[
			-1,
			3,
			-3,
			1
		],
		[
			3,
			-6,
			3,
			0
		],
		[
			-3,
			0,
			3,
			0
		],
		[
			1,
			4,
			1,
			0
		]
	];
	return t.x = o * ((n.x * l[0][0] + r.x * l[0][1] + i.x * l[0][2] + a.x * l[0][3]) * c + (n.x * l[1][0] + r.x * l[1][1] + i.x * l[1][2] + a.x * l[1][3]) * s + (n.x * l[2][0] + r.x * l[2][1] + i.x * l[2][2] + a.x * l[2][3]) * e + (n.x * l[3][0] + r.x * l[3][1] + i.x * l[3][2] + a.x * l[3][3])), t.y = o * ((n.y * l[0][0] + r.y * l[0][1] + i.y * l[0][2] + a.y * l[0][3]) * c + (n.y * l[1][0] + r.y * l[1][1] + i.y * l[1][2] + a.y * l[1][3]) * s + (n.y * l[2][0] + r.y * l[2][1] + i.y * l[2][2] + a.y * l[2][3]) * e + (n.y * l[3][0] + r.y * l[3][1] + i.y * l[3][2] + a.y * l[3][3])), {
		x: t.x,
		y: t.y
	};
}, zr = (e, t, n, r) => {
	let i = e.createSVGTransform();
	i.setTranslate(n, r);
	let a = I(t);
	a && (a.numberOfItems ? a.getItem(0).type === SVGTransform.SVG_TRANSFORM_TRANSLATE ? a.replaceItem(i, 0) : a.insertItemBefore(i, 0) : a.appendItem(i));
}, Br = (e, t, n, r) => {
	let i = z(n).matrix;
	for (; n.numberOfItems > 0;) n.removeItem(0);
	let a = e.createSVGTransform();
	return a.setMatrix(i), n.appendItem(a), new Fr(t, { transform: r });
}, Vr = (e) => {
	if (!G.getStarted() || e.button === 1 || G.spaceKey) return;
	G.textActions.init(), e.preventDefault();
	let t = G.getSelectedElements(), n = G.getZoom(), r = G.getSvgRoot(), i = t[0], a, o, s, c, l, u, d, f, p, m = F(e.clientX, e.clientY, G.getrootSctm()), h = m.x * n, g = m.y * n, _ = Ue(G.getId()), v = h / n, y = v, b = g / n, x = b;
	G.getCurConfig().gridSnapping && (y = Ke(y), x = Ke(x));
	let S;
	switch (G.getCurrentMode()) {
		case "select":
			if (!G.hasDragStartTransform && t.length > 0) {
				G.dragStartTransforms = /* @__PURE__ */ new Map();
				for (let e of t) {
					if (!e) continue;
					G.dragStartTransforms.set(e, e.getAttribute("transform") || "");
					let t = I(e);
					if (!t) continue;
					let n = r.createSVGTransform();
					n.setTranslate(0, 0), t.numberOfItems ? t.insertItemBefore(n, 0) : t.appendItem(n);
				}
				G.hasDragStartTransform = !0;
			}
			i && (l = y - G.getStartX(), u = x - G.getStartY(), G.getCurConfig().gridSnapping && (l = Ke(l), u = Ke(u)), Ir = Ir || Math.abs(l) > 4 || Math.abs(u) > 4, Ir && (t.forEach((e) => {
				e && (zr(r, e, l, u), G.selectorManager.requestSelector(e).resize());
			}), G.call("transition", t)));
			break;
		case "multiselect": {
			v *= n, b *= n, We(G.getRubberBox(), {
				x: Math.min(G.getRStartX(), v),
				y: Math.min(G.getRStartY(), b),
				width: Math.abs(v - G.getRStartX()),
				height: Math.abs(b - G.getRStartY())
			}, 100);
			let e = t.slice(), r = [], i = G.getIntersectionList();
			for (d = i.length, a = 0; a < d; ++a) {
				let n = i[a];
				t.includes(n) || r.push(n);
				let o = e.indexOf(n);
				o !== -1 && e.splice(o, 1);
			}
			e.length > 0 && G.removeFromSelection(e), r.length > 0 && G.addToSelection(r);
			break;
		}
		case "resize": {
			if (S = I(i), !S) break;
			let n = R(S);
			p = n ? G.getInitBbox() : H(i);
			let a = p.x, o = p.y, { width: s, height: c } = p;
			if (l = y - G.getStartX(), u = x - G.getStartY(), G.getCurConfig().gridSnapping && (l = Ke(l), u = Ke(u), c = Ke(c), s = Ke(s)), f = Be(i), f) {
				let e = Math.sqrt(l * l + u * u), t = Math.atan2(u, l) - f * Math.PI / 180;
				l = e * Math.cos(t), u = e * Math.sin(t);
			}
			!G.getCurrentResizeMode().includes("n") && !G.getCurrentResizeMode().includes("s") && (u = 0), !G.getCurrentResizeMode().includes("e") && !G.getCurrentResizeMode().includes("w") && (l = 0);
			let d = 0, m = 0, h = c ? (c + u) / c : 1, g = s ? (s + l) / s : 1;
			G.getCurrentResizeMode().includes("n") && (h = c ? (c - u) / c : 1, m = c), G.getCurrentResizeMode().includes("w") && (g = s ? (s - l) / s : 1, d = s);
			let _ = r.createSVGTransform(), v = r.createSVGTransform(), b = r.createSVGTransform();
			if (G.getCurConfig().gridSnapping && (a = Ke(a), d = Ke(d), o = Ke(o), m = Ke(m)), _.setTranslate(-(a + d), -(o + m)), (i.tagName !== "image" && e.shiftKey || i.tagName === "image" && !e.shiftKey) && (g === 1 ? g = h : h = g), v.setScale(g, h), b.setTranslate(a + d, o + m), n) {
				let e = +!!f;
				S.replaceItem(_, 2 + e), S.replaceItem(v, 1 + e), S.replaceItem(b, Number(e));
			} else {
				let e = S.numberOfItems;
				S.replaceItem(b, e - 3), S.replaceItem(v, e - 2), S.replaceItem(_, e - 1);
			}
			G.selectorManager.requestSelector(i).resize(), G.call("transition", t);
			break;
		}
		case "zoom":
			v *= n, b *= n, We(G.getRubberBox(), {
				x: Math.min(G.getRStartX() * n, v),
				y: Math.min(G.getRStartY() * n, b),
				width: Math.abs(v - G.getRStartX() * n),
				height: Math.abs(b - G.getRStartY() * n)
			}, 100);
			break;
		case "text":
			We(_, {
				x: y,
				y: x
			}, 1e3);
			break;
		case "line": {
			G.getCurConfig().gridSnapping && (y = Ke(y), x = Ke(x));
			let t = y, n = x;
			e.shiftKey && (o = re(G.getStartX(), G.getStartY(), t, n), t = o.x, n = o.y), _.setAttribute("x2", t), _.setAttribute("y2", n);
			break;
		}
		case "foreignObject":
		case "square":
		case "rect":
		case "image": {
			let t = G.getCurrentMode() === "square" || G.getCurrentMode() === "image" && !e.shiftKey || G.getCurrentMode() !== "image" && e.shiftKey, n = Math.abs(y - G.getStartX()), r = Math.abs(x - G.getStartY()), i, a;
			t ? (n = r = Math.max(n, r), i = G.getStartX() < y ? G.getStartX() : G.getStartX() - n, a = G.getStartY() < x ? G.getStartY() : G.getStartY() - r) : (i = Math.min(G.getStartX(), y), a = Math.min(G.getStartY(), x)), G.getCurConfig().gridSnapping && (n = Ke(n), r = Ke(r), i = Ke(i), a = Ke(a)), We(_, {
				width: n,
				height: r,
				x: i,
				y: a
			}, 1e3);
			break;
		}
		case "circle": {
			s = Number(_.getAttribute("cx")), c = Number(_.getAttribute("cy"));
			let e = Math.sqrt((y - s) * (y - s) + (x - c) * (x - c));
			G.getCurConfig().gridSnapping && (e = Ke(e)), _.setAttribute("r", e);
			break;
		}
		case "ellipse": {
			s = Number(_.getAttribute("cx")), c = Number(_.getAttribute("cy")), G.getCurConfig().gridSnapping && (y = Ke(y), s = Ke(s), x = Ke(x), c = Ke(c)), _.setAttribute("rx", Math.abs(y - s));
			let t = Math.abs(e.shiftKey ? y - s : x - c);
			_.setAttribute("ry", t);
			break;
		}
		case "fhellipse":
		case "fhrect": G.setFreehand("minx", Math.min(v, G.getFreehand("minx"))), G.setFreehand("maxx", Math.max(v, G.getFreehand("maxx"))), G.setFreehand("miny", Math.min(b, G.getFreehand("miny"))), G.setFreehand("maxy", Math.max(b, G.getFreehand("maxy")));
		case "fhpath":
			if (G.setEnd("x", v), G.setEnd("y", b), G.getControllPoint2("x") && G.getControllPoint2("y")) {
				for (a = 0; a < G.getStepCount() - 1; a++) if (G.setParameter(a / G.getStepCount()), G.setNextParameter((a + 1) / G.getStepCount()), G.setbSpline(Rr(G.getNextParameter())), G.setNextPos({
					x: G.getbSpline("x"),
					y: G.getbSpline("y")
				}), G.setbSpline(Rr(G.getParameter())), G.setSumDistance(G.getSumDistance() + Math.sqrt((G.getNextPos("x") - G.getbSpline("x")) * (G.getNextPos("x") - G.getbSpline("x")) + (G.getNextPos("y") - G.getbSpline("y")) * (G.getNextPos("y") - G.getbSpline("y")))), G.getSumDistance() > G.getThreSholdDist()) {
					G.setSumDistance(G.getSumDistance() - G.getThreSholdDist());
					let e = G.getSvgContent().createSVGPoint();
					e.x = G.getbSpline("x"), e.y = G.getbSpline("y"), _.points.appendItem(e);
				}
			}
			G.setControllPoint2("x", G.getControllPoint1("x")), G.setControllPoint2("y", G.getControllPoint1("y")), G.setControllPoint1("x", G.getStart("x")), G.setControllPoint1("y", G.getStart("y")), G.setStart({
				x: G.getEnd("x"),
				y: G.getEnd("y")
			});
			break;
		case "path":
		case "pathedit":
			if (y *= n, x *= n, G.getCurConfig().gridSnapping && (y = Ke(y), x = Ke(x), G.setStartX(Ke(G.getStartX())), G.setStartY(Ke(G.getStartY()))), e.shiftKey) {
				let { path: e } = Nt, t, n;
				e ? (t = e.dragging ? e.dragging[0] : G.getStartX(), n = e.dragging ? e.dragging[1] : G.getStartY()) : (t = G.getStartX(), n = G.getStartY()), o = re(t, n, y, x), {x: y, y: x} = o;
			}
			G.getRubberBox()?.getAttribute("display") !== "none" && (v *= n, b *= n, We(G.getRubberBox(), {
				x: Math.min(G.getRStartX() * n, v),
				y: Math.min(G.getRStartY() * n, b),
				width: Math.abs(v - G.getRStartX() * n),
				height: Math.abs(b - G.getRStartY() * n)
			}, 100)), G.pathActions.mouseMove(y, x);
			break;
		case "textedit":
			y *= n, x *= n, G.textActions.mouseMove(h, g);
			break;
		case "rotate": {
			p = H(i), s = p.x + p.width / 2, c = p.y + p.height / 2;
			let n = ne(i), r = F(s, c, n);
			s = r.x, c = r.y, f = (Math.atan2(c - x, s - y) * (180 / Math.PI) - 90) % 360, G.getCurConfig().gridSnapping && (f = Ke(f)), e.shiftKey && (f = Math.round(f / 45) * 45), G.setRotationAngle(f < -180 ? 360 + f : f, !0), G.call("transition", t);
			break;
		}
		default: break;
	}
	G.runExtensions("mouseMove", {
		event: e,
		mouse_x: h,
		mouse_y: g,
		selected: i
	});
}, Hr = (e) => {
	let { $id: t } = G;
	if (G.getCurrentMode() !== "select" && G.getStarted()) {
		let n = new MouseEvent("mouseup", {
			bubbles: !0,
			cancelable: !0,
			clientX: e?.clientX ?? 0,
			clientY: e?.clientY ?? 0,
			button: e?.button ?? 0,
			buttons: e?.buttons ?? 0,
			altKey: e?.altKey ?? !1,
			ctrlKey: e?.ctrlKey ?? !1,
			metaKey: e?.metaKey ?? !1,
			shiftKey: e?.shiftKey ?? !1
		});
		t("svgcanvas").dispatchEvent(n);
	}
}, Ur = (e) => {
	if (e.preventDefault(), Ir = !1, e.button === 2 || !G.getStarted()) return;
	G.textActions.init();
	let t = G.getSelectedElements(), n = G.getZoom(), r = G.getJustSelected();
	G.setJustSelected(null);
	let i = F(e.clientX, e.clientY, G.getrootSctm()), a = i.x * n, o = i.y * n, s = a / n, c = o / n, l = Ue(G.getId()), u = !1, d = s, f = c;
	G.setStarted(!1);
	let p;
	switch (G.getCurrentMode()) {
		case "resize":
		case "multiselect": G.getRubberBox() && (G.getRubberBox().setAttribute("display", "none"), G.setCurBBoxes([])), G.setCurrentMode("select");
		case "select":
			if (t[0]) {
				if (!t[1]) {
					let e = t[0];
					switch (e.tagName) {
						case "g":
						case "use":
						case "image":
						case "foreignObject": break;
						case "text": G.setCurText("font_size", e.getAttribute("font-size")), G.setCurText("font_family", e.getAttribute("font-family"));
						default: G.setCurProperties("fill", e.getAttribute("fill")), G.setCurProperties("fill_opacity", e.getAttribute("fill-opacity")), G.setCurProperties("stroke", e.getAttribute("stroke")), G.setCurProperties("stroke_opacity", e.getAttribute("stroke-opacity")), G.setCurProperties("stroke_width", e.getAttribute("stroke-width")), G.setCurProperties("stroke_dasharray", e.getAttribute("stroke-dasharray")), G.setCurProperties("stroke_linejoin", e.getAttribute("stroke-linejoin")), G.setCurProperties("stroke_linecap", e.getAttribute("stroke-linecap"));
					}
					G.selectorManager.requestSelector(e).showGrips(!0);
				}
				if (d !== G.getRStartX() || f !== G.getRStartY()) {
					let e = new Pr("position");
					t.forEach((t) => {
						if (!t) return;
						let n = I(t);
						if (!n || n.numberOfItems === 0) return;
						let r = G.dragStartTransforms?.has(t) ? G.dragStartTransforms.get(t) : G.getStartTransform() || "", i = n.getItem(0).type === SVGTransform.SVG_TRANSFORM_TRANSLATE;
						if ((t.tagName === "g" || t.tagName === "a") && i) {
							e.addSubCommand(Br(G.getSvgRoot(), t, n, r));
							return;
						}
						let a = G.recalculateDimensions(t);
						a ? e.addSubCommand(a) : n.numberOfItems > 1 && i ? e.addSubCommand(Br(G.getSvgRoot(), t, n, r)) : (t.getAttribute("transform") || "") !== r && e.addSubCommand(new Fr(t, { transform: r }));
					}), e.isEmpty() || G.addCommandToHistory(e), G.dragStartTransforms = null, G.hasDragStartTransform = !1;
					let n = t.length;
					for (let e = 0; e < n && t[e]; ++e) G.selectorManager.requestSelector(t[e]).resize();
				} else p = e.target, t[0].nodeName === "path" && !t[1] ? G.pathActions.select(t[0]) : e.shiftKey && r !== p && G.removeFromSelection([p]);
				let n = t[0];
				n && (n.removeAttribute("style"), n.localName === "foreignObject" ? Se(n, (e) => {
					e.style.removeProperty("pointer-events");
				}) : Se(n, (e) => {
					e.removeAttribute("style");
				}));
			}
			return;
		case "zoom": {
			G.getRubberBox()?.setAttribute("display", "none");
			let t = e.shiftKey ? .5 : 2;
			G.call("zoomed", {
				x: Math.min(G.getRStartX(), d),
				y: Math.min(G.getRStartY(), f),
				width: Math.abs(d - G.getRStartX()),
				height: Math.abs(f - G.getRStartY()),
				factor: t
			});
			return;
		}
		case "fhpath": {
			G.setSumDistance(0), G.setControllPoint2("x", 0), G.setControllPoint2("y", 0), G.setControllPoint1("x", 0), G.setControllPoint1("y", 0), G.setStart({
				x: 0,
				y: 0
			}), G.setEnd("x", 0), G.setEnd("y", 0);
			let e = l.getAttribute("points"), t = e.indexOf(",");
			u = t >= 0 ? e.includes(",", t + 1) : e.includes(" ", e.indexOf(" ") + 1), u && (l = G.pathActions.smoothPolylineIntoPath(l));
			break;
		}
		case "line":
			{
				let e = l.getAttribute("x1"), t = l.getAttribute("y1"), n = l.getAttribute("x2"), r = l.getAttribute("y2");
				u = e !== n || t !== r;
			}
			break;
		case "foreignObject":
		case "square":
		case "rect":
		case "image":
			{
				let e = l.getAttribute("width"), t = l.getAttribute("height"), n = Number(e), r = Number(t);
				u = n >= 1 || r >= 1 || G.getCurrentMode() === "image";
			}
			break;
		case "circle":
			u = l.getAttribute("r") !== "0";
			break;
		case "ellipse":
			{
				let e = Number(l.getAttribute("rx")), t = Number(l.getAttribute("ry"));
				u = e || t;
			}
			break;
		case "fhellipse":
			G.getFreehand("maxx") - G.getFreehand("minx") > 0 && G.getFreehand("maxy") - G.getFreehand("miny") > 0 && (l = G.addSVGElementsFromJson({
				element: "ellipse",
				curStyles: !0,
				attr: {
					cx: (G.getFreehand("minx") + G.getFreehand("maxx")) / 2,
					cy: (G.getFreehand("miny") + G.getFreehand("maxy")) / 2,
					rx: (G.getFreehand("maxx") - G.getFreehand("minx")) / 2,
					ry: (G.getFreehand("maxy") - G.getFreehand("miny")) / 2,
					id: G.getId()
				}
			}), G.call("changed", [l]), u = !0);
			break;
		case "fhrect":
			G.getFreehand("maxx") - G.getFreehand("minx") > 0 && G.getFreehand("maxy") - G.getFreehand("miny") > 0 && (l = G.addSVGElementsFromJson({
				element: "rect",
				curStyles: !0,
				attr: {
					x: G.getFreehand("minx"),
					y: G.getFreehand("miny"),
					width: G.getFreehand("maxx") - G.getFreehand("minx"),
					height: G.getFreehand("maxy") - G.getFreehand("miny"),
					id: G.getId()
				}
			}), G.call("changed", [l]), u = !0);
			break;
		case "text":
			u = !0, G.selectOnly([l]), G.textActions.start(l);
			break;
		case "path": {
			l = null, G.setStarted(!0);
			let t = G.pathActions.mouseUp(e, l, a, o);
			({element: l} = t), {keep: u} = t;
			break;
		}
		case "pathedit":
			u = !0, l = null, G.pathActions.mouseUp(e);
			break;
		case "textedit":
			u = !1, l = null, G.textActions.mouseUp(e, a, o);
			break;
		case "rotate": {
			G.hasDragStartTransform = !1, G.dragStartTransforms = null, u = !0, l = null, G.setCurrentMode("select");
			let e = G.undoMgr.finishUndoableChange();
			e.isEmpty() || G.addCommandToHistory(e), G.recalculateAllSelectedDimensions(), G.call("changed", t);
			break;
		}
		default:
			G.hasDragStartTransform = !1, G.dragStartTransforms = null;
			break;
	}
	if (G.hasDragStartTransform = !1, G.dragStartTransforms = null, G.runExtensions("mouseUp", {
		event: e,
		mouse_x: a,
		mouse_y: o
	}, !0).forEach((e) => {
		e && (u = e.keep || u, {element: l} = e, G.setStarted(e.started || G.getStarted()));
	}), !u && l) {
		for (G.getCurrentDrawing().releaseId(G.getId()), l.remove(), l = null, p = e.target; p?.parentNode?.parentNode?.tagName === "g";) p = p.parentNode;
		(G.getCurrentMode() !== "path" || !G.getDrawnPath()) && p && p.parentNode?.id !== "selectorParentGroup" && p.id !== "svgcanvas" && p.id !== "svgroot" && (G.setMode("select"), G.selectOnly([p], !0));
	} else if (l) {
		G.addedNew = !0;
		let t = .2, n, r = G.getStyle(), i = G.getOpacAni();
		if (i.beginElement && Number.parseFloat(l.getAttribute("opacity")) !== r.opacity) {
			n = i.cloneNode(!0), n.setAttribute("to", r.opacity), n.setAttribute("dur", t), l.appendChild(n);
			try {
				n.beginElement();
			} catch {}
		} else t = 0;
		setTimeout(() => {
			n && n.remove(), l.setAttribute("opacity", r.opacity), l.setAttribute("style", "pointer-events:inherit"), Ge(l), G.getCurrentMode() === "path" ? G.pathActions.toEditMode(l) : G.getCurConfig().selectNew && ([
				"circle",
				"ellipse",
				"square",
				"rect",
				"fhpath",
				"line",
				"fhellipse",
				"fhrect",
				"star",
				"polygon",
				"shapelib"
			].indexOf(G.getCurrentMode()) !== -1 && !e.altKey && G.setMode("select"), G.selectOnly([l], !0)), G.addCommandToHistory(new Nr(l)), G.call("changed", [l]);
		}, t * 1e3);
	}
	G.setStartTransform(null);
}, Wr = (e) => {
	let t = G.getSelectedElements(), n = e.target.parentNode, r = G.getMouseTarget(e), { tagName: i } = r;
	if (i === "text" && G.getCurrentMode() !== "textedit") {
		let t = F(e.clientX, e.clientY, G.getrootSctm());
		G.textActions.select(r, t.x, t.y);
	}
	n !== G.getCurrentGroup() && ((i === "g" || i === "a") && Be(r) && (G.pushGroupProperties(r), r = t[0], G.clearSelection(!0)), G.getCurrentGroup() && qn(), !(n.tagName !== "g" && n.tagName !== "a" || n === G.getCurrentDrawing().getCurrentLayer() || r === G.selectorManager.selectorParentGroup) && Jn(r));
}, Gr = (e) => {
	let t = G.getDataStorage(), n = G.getSelectedElements(), r = G.getZoom(), i = G.getStyle(), a = G.getSvgRoot(), { $id: o } = G;
	if (G.spaceKey || e.button === 1) return;
	let s = e.button === 2;
	e.altKey && G.cloneSelectedElements(0, 0);
	let c = (o("svgcontent")?.querySelector("g"))?.getScreenCTM?.();
	if (!c) return;
	G.setRootSctm(c.inverse());
	let l = F(e.clientX, e.clientY, G.getrootSctm()), u = l.x * r, d = l.y * r;
	if (e.preventDefault(), s) {
		if (G.getCurrentMode() === "path") return;
		G.setCurrentMode("select"), G.setLastClickPoint(l);
	}
	let f = u / r, p = d / r, m = G.getMouseTarget(e);
	m.tagName === "a" && m.childNodes.length === 1 && (m = m.firstChild);
	let h = f;
	G.setStartX(f), G.setRStartX(f);
	let g = p;
	if (G.setStartY(p), G.setRStartY(p), G.getCurConfig().gridSnapping && (f = Ke(f), p = Ke(p), G.setStartX(Ke(G.getStartX())), G.setStartY(Ke(G.getStartY()))), m === G.selectorManager.selectorParentGroup && n[0]) {
		let r = e.target, i = t.get(r, "type");
		i === "rotate" ? G.setCurrentMode("rotate") : i === "resize" && (G.setCurrentMode("resize"), G.setCurrentResizeMode(t.get(r, "dir"))), m = n[0];
	}
	G.setStartTransform(m.getAttribute("transform"));
	let _ = I(m);
	if (_?.numberOfItems > 1 && m.tagName !== "g" && m.tagName !== "a") {
		let e = z(_).matrix;
		for (; _.numberOfItems > 0;) _.removeItem(0);
		let t = G.getSvgRoot().createSVGTransform();
		t.setMatrix(e), _.appendItem(t);
	}
	switch (G.getCurrentMode()) {
		case "select":
			G.setStarted(!0), G.setCurrentResizeMode("none"), s && G.setStarted(!1), m === a ? s || (G.clearSelection(), G.setCurrentMode("multiselect"), G.getRubberBox() || G.setRubberBox(G.selectorManager.getRubberBandBox()), G.setRStartX(G.getRStartX() * r), G.setRStartY(G.getRStartY() * r), We(G.getRubberBox(), {
				x: G.getRStartX(),
				y: G.getRStartY(),
				width: 0,
				height: 0,
				display: "inline"
			}, 100)) : n.includes(m) || (e.shiftKey || G.clearSelection(!0), G.addToSelection([m]), G.setJustSelected(m), G.pathActions.clear());
			break;
		case "zoom":
			G.setStarted(!0), G.getRubberBox() || G.setRubberBox(G.selectorManager.getRubberBandBox()), We(G.getRubberBox(), {
				x: h * r,
				y: g * r,
				width: 0,
				height: 0,
				display: "inline"
			}, 100);
			break;
		case "resize": {
			if (!_) break;
			G.setStarted(!0), G.setStartX(f), G.setStartY(p), G.setInitBbox(H(o("selectedBox0")));
			let e = {};
			for (let [t, n] of Object.entries(G.getInitBbox())) e[t] = n / r;
			G.setInitBbox(e);
			let t = +!!Be(m);
			R(_) ? (_.insertItemBefore(a.createSVGTransform(), t), _.insertItemBefore(a.createSVGTransform(), t), _.insertItemBefore(a.createSVGTransform(), t)) : (_.appendItem(a.createSVGTransform()), _.appendItem(a.createSVGTransform()), _.appendItem(a.createSVGTransform()));
			break;
		}
		case "fhellipse":
		case "fhrect":
		case "fhpath":
			G.setStart({
				x: h,
				y: g
			}), G.setControllPoint1("x", 0), G.setControllPoint1("y", 0), G.setControllPoint2("x", 0), G.setControllPoint2("y", 0), G.setStarted(!0), G.setDAttr(h + "," + g + " "), G.addSVGElementsFromJson({
				element: "polyline",
				curStyles: !0,
				attr: {
					points: G.getDAttr(),
					id: G.getNextId(),
					fill: "none",
					opacity: i.opacity / 2,
					"stroke-linecap": "round",
					style: "pointer-events:none"
				}
			}), G.setFreehand("minx", h), G.setFreehand("maxx", h), G.setFreehand("miny", g), G.setFreehand("maxy", g);
			break;
		case "image": {
			G.setStarted(!0);
			let e = G.addSVGElementsFromJson({
				element: "image",
				attr: {
					x: f,
					y: p,
					width: 0,
					height: 0,
					id: G.getNextId(),
					opacity: i.opacity / 2,
					style: "pointer-events:inherit"
				}
			});
			Ee(e, G.getLastGoodImgUrl()), qe(e);
			break;
		}
		case "square":
		case "rect":
			G.setStarted(!0), G.setStartX(f), G.setStartY(p), G.addSVGElementsFromJson({
				element: "rect",
				curStyles: !0,
				attr: {
					x: f,
					y: p,
					width: 0,
					height: 0,
					id: G.getNextId(),
					opacity: i.opacity / 2
				}
			});
			break;
		case "line": {
			G.setStarted(!0);
			let e = Number(i.stroke_width) === 0 ? 1 : i.stroke_width;
			G.addSVGElementsFromJson({
				element: "line",
				curStyles: !0,
				attr: {
					x1: f,
					y1: p,
					x2: f,
					y2: p,
					id: G.getNextId(),
					stroke: i.stroke,
					"stroke-width": e,
					"stroke-dasharray": i.stroke_dasharray,
					"stroke-linejoin": i.stroke_linejoin,
					"stroke-linecap": i.stroke_linecap,
					"stroke-opacity": i.stroke_opacity,
					fill: "none",
					opacity: i.opacity / 2,
					style: "pointer-events:none"
				}
			});
			break;
		}
		case "circle":
			G.setStarted(!0), G.addSVGElementsFromJson({
				element: "circle",
				curStyles: !0,
				attr: {
					cx: f,
					cy: p,
					r: 0,
					id: G.getNextId(),
					opacity: i.opacity / 2
				}
			});
			break;
		case "ellipse":
			G.setStarted(!0), G.addSVGElementsFromJson({
				element: "ellipse",
				curStyles: !0,
				attr: {
					cx: f,
					cy: p,
					rx: 0,
					ry: 0,
					id: G.getNextId(),
					opacity: i.opacity / 2
				}
			});
			break;
		case "text":
			G.setStarted(!0), G.addSVGElementsFromJson({
				element: "text",
				curStyles: !0,
				attr: {
					x: f,
					y: p,
					id: G.getNextId(),
					fill: G.getCurText("fill"),
					"stroke-width": G.getCurText("stroke_width"),
					"font-size": G.getCurText("font_size"),
					"font-family": G.getCurText("font_family"),
					"text-anchor": "middle",
					"xml:space": "preserve",
					opacity: i.opacity
				}
			});
			break;
		case "path":
		case "pathedit":
			G.setStartX(G.getStartX() * r), G.setStartY(G.getStartY() * r), G.pathActions.mouseDown(e, m, G.getStartX(), G.getStartY()), G.setStarted(!0);
			break;
		case "textedit":
			G.setStartX(G.getStartX() * r), G.setStartY(G.getStartY() * r), G.textActions.mouseDown(e, m, G.getStartX(), G.getStartY()), G.setStarted(!0);
			break;
		case "rotate":
			G.setStarted(!0), G.undoMgr.beginUndoableChange("transform", n);
			break;
		default: break;
	}
	G.runExtensions("mouseDown", {
		event: e,
		start_x: G.getStartX(),
		start_y: G.getStartY(),
		selectedElements: n
	}, !0).forEach((e) => {
		e?.started && G.setStarted(!0);
	});
}, Kr = (e) => {
	let t = G.getZoom(), { $id: n } = G;
	if (!e.shiftKey) return;
	e.preventDefault();
	let r = (n("svgcontent")?.querySelector("g"))?.getScreenCTM?.();
	if (!r) return;
	G.setRootSctm(r.inverse());
	let i = document.getElementById("workarea"), a = G.getCurConfig().showRulers ? 16 : 0, o = F(e.clientX, e.clientY, G.getrootSctm()), s = parseFloat(getComputedStyle(i, null).width.replace("px", "")), c = parseFloat(getComputedStyle(i, null).height.replace("px", "")), l = s - 15 - a, u = c - 15 - a, d = l * G.getrootSctm().a, f = u * G.getrootSctm().d, p = ae(i), m = p.left + a, h = p.top + a, g = e.wheelDelta ? e.wheelDelta : e.detail ? -e.detail : 0;
	if (!g) return;
	let _ = Math.max(3 / 4, Math.min(4 / 3, g)), v, y;
	_ > 1 ? (v = Math.ceil(l / d * _ * 100) / 100, y = Math.ceil(u / f * _ * 100) / 100) : (v = Math.floor(l / d * _ * 100) / 100, y = Math.floor(u / f * _ * 100) / 100);
	let b = Math.min(v, y);
	if (b = Math.min(10, Math.max(.01, b)), b === t) return;
	_ = b / t;
	let x = F(m, h, G.getrootSctm()), S = {
		x: o.x - (o.x - x.x) / _,
		y: o.y - (o.y - x.y) / _
	}, C = {
		x: S.x * b,
		y: S.y * b
	}, w = {
		x: C.x - a + s / 2,
		y: C.y - a + c / 2
	};
	G.setZoom(b), document.getElementById("zoom").value = (b * 100).toFixed(1), G.call("updateCanvas", {
		center: !1,
		newCtr: w
	}), G.call("zoomDone");
}, qr = null, Jr = null, Yr = (e) => {
	qr = e, Jr = e.getDOMDocument?.() || (typeof document < "u" ? document : null);
}, Xr = (e) => {
	if (!e) return null;
	if (e.nodeType === 3 || e.nodeType === 4) return e.nodeValue;
	if (e.nodeType !== 1) return null;
	let t = {
		element: e.tagName,
		attr: {},
		children: []
	}, n = e.attributes;
	if (n) for (let e = 0; e < n.length; e++) {
		let r = n[e];
		r && (t.attr[r.name] = r.value);
	}
	let r = e.childNodes;
	if (r) for (let e = 0; e < r.length; e++) {
		let n = r[e], i = Xr(n);
		i != null && t.children.push(i);
	}
	return t;
}, Zr = (e) => {
	if (!Jr) return null;
	if (e == null) return Jr.createTextNode("");
	if (typeof e == "string") return Jr.createTextNode(e);
	let t = e.attr || {}, n = t.id, r = null;
	if (typeof n == "string" && n) {
		try {
			r = Ue(n);
		} catch {}
		if (!r) {
			let e = Jr.getElementById?.(n), t = qr?.getSvgRoot?.();
			e && (!t || t.contains(e)) && (r = e);
		}
	}
	let i = qr?.getDrawing?.()?.getCurrentLayer?.();
	if (r && e.element !== r.tagName && (r.remove(), r = null), !r) {
		let t = e.namespace || A.SVG;
		r = Jr.createElementNS(t, e.element), i && (qr.getCurrentGroup() || i).append(r);
	}
	let a = qr.getCurShape?.() || {};
	if (e.curStyles) {
		let e = Number(a.opacity), t = Number.isFinite(e) ? e / 2 : .5;
		We(r, {
			fill: a.fill,
			stroke: a.stroke,
			"stroke-width": a.stroke_width,
			"stroke-dasharray": a.stroke_dasharray,
			"stroke-linejoin": a.stroke_linejoin,
			"stroke-linecap": a.stroke_linecap,
			"stroke-opacity": a.stroke_opacity,
			"fill-opacity": a.fill_opacity,
			opacity: t,
			style: "pointer-events:inherit"
		}, 100);
	}
	if (We(r, t, 100), Ge(r), e.children) {
		for (; r.firstChild;) r.firstChild.remove();
		e.children.forEach((e) => {
			let t = Zr(e);
			t && r.append(t);
		});
	}
	return r;
}, K = null, Qr = (e) => {
	K = e, K.getBold = gi, K.setBold = _i, K.getItalic = xi, K.setItalic = Si, K.hasTextDecoration = vi, K.addTextDecoration = yi, K.removeTextDecoration = bi, K.setTextAnchor = Ci, K.setLetterSpacing = wi, K.setWordSpacing = Ti, K.setTextLength = Ei, K.setLengthAdjust = Di, K.getFontFamily = Oi, K.setFontFamily = ki, K.setFontColor = Ai, K.getFontColor = ji, K.getFontSize = Mi, K.setFontSize = Ni, K.getText = Pi, K.setTextContent = Fi, K.setImageURL = Ii, K.setLinkURL = Li, K.setRectRadius = Ri, K.makeHyperlink = zi, K.removeHyperlink = Bi, K.setSegType = Vi, K.setStrokeWidth = di, K.getResolution = $r, K.getTitle = ei, K.setGroupTitle = ti, K.setStrokeAttr = fi, K.setBackground = Hi, K.setDocumentTitle = ni, K.getEditorNS = ii, K.setResolution = ri, K.setBBoxZoom = ai, K.setCurrentZoom = oi, K.setColor = si, K.setGradient = ci, K.setPaint = ui;
}, $r = () => {
	let e = K.getZoom();
	return {
		w: K.getSvgContent().getAttribute("width") / e,
		h: K.getSvgContent().getAttribute("height") / e,
		zoom: e
	};
}, ei = (e) => {
	let t = K.getSelectedElements(), n = K.getDataStorage();
	if (e ||= t[0], !e) return;
	n.has(e, "gsvg") ? e = n.get(e, "gsvg") : n.has(e, "symbol") && (e = n.get(e, "symbol"));
	let r = e.childNodes;
	for (let e of r) if (e.nodeName === "title") return e.textContent;
	return "";
}, ti = (e) => {
	let { InsertElementCommand: t, RemoveElementCommand: n, ChangeElementCommand: r, BatchCommand: i } = K.history, a = K.getSelectedElements(), o = K.getDataStorage(), s = a[0];
	if (!s || (o.has(s, "gsvg") ? s = o.get(s, "gsvg") : o.has(s, "symbol") && (s = o.get(s, "symbol")), !s)) return;
	let c = new i("Set Label"), l = null;
	for (let e of s.childNodes) if (e.nodeName === "title") {
		l = e;
		break;
	}
	if (e.length === 0) {
		if (!l) return;
		let { nextSibling: e } = l;
		l.remove(), c.addSubCommand(new n(l, e, s));
	} else if (l) {
		let t = l.textContent;
		if (t === e) return;
		l.textContent = e, c.addSubCommand(new r(l, { "#text": t }));
	} else l = K.getDOMDocument().createElementNS(A.SVG, "title"), l.textContent = e, s.insertBefore(l, s.firstChild), c.addSubCommand(new t(l));
	c.isEmpty() || K.addCommandToHistory(c);
}, ni = (e) => {
	let { InsertElementCommand: t, RemoveElementCommand: n, ChangeElementCommand: r, BatchCommand: i } = K.history, a = K.getSvgContent(), o = new i("Change Image Title"), s = null;
	for (let e of a.childNodes) if (e.nodeName === "title") {
		s = e;
		break;
	}
	if (!s) {
		if (!e.length) return;
		s = K.getDOMDocument().createElementNS(A.SVG, "title"), s.textContent = e, a.insertBefore(s, a.firstChild), o.addSubCommand(new t(s));
	} else if (e.length) {
		let t = s.textContent;
		if (t === e) return;
		s.textContent = e, o.addSubCommand(new r(s, { "#text": t }));
	} else {
		let { nextSibling: e } = s;
		s.remove(), o.addSubCommand(new n(s, e, a));
	}
	o.isEmpty() || K.addCommandToHistory(o);
}, ri = (e, t) => {
	let { ChangeElementCommand: n, BatchCommand: r } = K.history, { w: i, h: a } = K.getResolution(), o;
	if (e === "fit") {
		let n = Re();
		if (n) {
			o = new r("Fit Canvas to Content");
			let i = Le();
			K.addToSelection(i);
			let a = [], s = [];
			i.forEach((e, t) => {
				a.push(n.x * -1), s.push(n.y * -1);
			});
			let c = K.moveSelectedElements(a, s, !1);
			c && o.addSubCommand(c), K.clearSelection(), e = Math.round(n.width), t = Math.round(n.height);
		} else return !1;
	}
	let s = O("width", e), c = O("height", t);
	if (s !== i || c !== a) {
		o ||= new r("Change Image Dimensions");
		let e = K.getSvgContent(), t = e.getAttribute("viewBox");
		e.setAttribute("width", s), e.setAttribute("height", c), K.contentW = s, K.contentH = c, e.setAttribute("viewBox", [
			0,
			0,
			s,
			c
		].join(" ")), o.addSubCommand(new n(e, {
			width: i,
			height: a,
			viewBox: t
		})), K.addCommandToHistory(o), K.call("changed", [e]);
	}
	return !0;
}, ii = (e) => (e && K.getSvgContent().setAttribute("xmlns:se", A.SE), A.SE), ai = (e, t, n) => {
	let r = K.getZoom(), i = K.getSelectedElements(), a = .85, o, s = (e) => {
		if (!e || !Number.isFinite(t) || !Number.isFinite(n) || t <= 0 || n <= 0 || !Number.isFinite(e.width) || !Number.isFinite(e.height) || e.width <= 0 || e.height <= 0) return;
		let r = Math.round(t / e.width * 100 * a) / 100, i = Math.round(n / e.height * 100 * a) / 100, o = Math.min(r, i);
		if (!(!Number.isFinite(o) || o <= 0)) return K.setZoom(o), {
			zoom: o,
			bbox: e
		};
	};
	if (e && typeof e == "object") {
		if (o = e, o.width === 0 || o.height === 0) {
			let e = r;
			return Number.isFinite(o.zoom) && o.zoom > 0 ? e = o.zoom : Number.isFinite(o.factor) && o.factor > 0 && (e = r * o.factor), Number.isFinite(e) && e > 0 && K.setZoom(e), {
				zoom: e,
				bbox: o
			};
		}
		return s(o);
	}
	switch (e) {
		case "selection":
			if (!i[0]) return;
			o = Re(i.filter(Boolean));
			break;
		case "canvas": {
			let e = K.getResolution();
			a = .95, o = {
				width: e.w,
				height: e.h,
				x: 0,
				y: 0
			};
			break;
		}
		case "content":
			o = Re();
			break;
		case "layer":
			o = Re(Le(K.getCurrentDrawing().getCurrentLayer()));
			break;
		default: return;
	}
	return s(o);
}, oi = (e) => {
	if (!Number.isFinite(e) || e <= 0) return;
	let t = K.getSelectedElements(), n = K.getResolution(), r = n.w / e, i = n.h / e;
	!Number.isFinite(r) || !Number.isFinite(i) || r <= 0 || i <= 0 || (K.getSvgContent().setAttribute("viewBox", `0 0 ${r} ${i}`), K.setZoom(e), t.forEach((e) => {
		if (!e) return;
		let t = K.selectorManager.requestSelector(e);
		t && t.resize();
	}), K.pathActions.zoomChange(), K.runExtensions("zoomChanged", e));
}, si = (e, t, n) => {
	let r = K.getSelectedElements();
	K.setCurShape(e, t), K.setCurProperties(`${e}_paint`, { type: "solidColor" });
	let i = [], a = (e) => {
		e.nodeName !== "g" && i.push(e);
	}, o = r.length;
	for (; o--;) {
		let t = r[o];
		t && (t.tagName === "g" ? Se(t, a) : e === "fill" ? t.tagName !== "polyline" && t.tagName !== "line" && i.push(t) : i.push(t));
	}
	i.length > 0 && (n ? K.changeSelectedAttributeNoUndo(e, t, i) : (K.changeSelectedAttribute(e, t, i), K.call("changed", i)));
}, ci = (e) => {
	if (!K.getCurProperties(`${e}_paint`) || K.getCurProperties(`${e}_paint`).type === "solidColor") return;
	let t = K[e + "Grad"];
	if (!t) return;
	let n = li(t), r = De();
	n ? t = n : (t = K.getDOMDocument().importNode(t, !0), r.append(t), t.id = K.getNextId()), K.setColor(e, `url(#${t.id})`);
}, li = (e) => {
	if (!e || !["linearGradient", "radialGradient"].includes(e.tagName)) return null;
	let t = De().querySelectorAll("linearGradient, radialGradient"), n = t.length, r = [
		"r",
		"cx",
		"cy",
		"fx",
		"fy"
	];
	for (; n--;) {
		let i = t[n];
		if (i.tagName !== e.tagName) continue;
		if (e.tagName === "linearGradient") {
			if (e.getAttribute("x1") !== i.getAttribute("x1") || e.getAttribute("y1") !== i.getAttribute("y1") || e.getAttribute("x2") !== i.getAttribute("x2") || e.getAttribute("y2") !== i.getAttribute("y2")) continue;
		} else {
			let t = {
				r: Number(e.getAttribute("r")),
				cx: Number(e.getAttribute("cx")),
				cy: Number(e.getAttribute("cy")),
				fx: Number(e.getAttribute("fx")),
				fy: Number(e.getAttribute("fy"))
			}, n = {
				r: Number(i.getAttribute("r")),
				cx: Number(i.getAttribute("cx")),
				cy: Number(i.getAttribute("cy")),
				fx: Number(i.getAttribute("fx")),
				fy: Number(i.getAttribute("fy"))
			}, a = !1;
			if (r.forEach((e) => {
				t[e] !== n[e] && (a = !0);
			}), a) continue;
		}
		let a = e.getElementsByTagNameNS(A.SVG, "stop"), o = i.getElementsByTagNameNS(A.SVG, "stop");
		if (a.length !== o.length) continue;
		let s = a.length;
		for (; s--;) {
			let e = a[s], t = o[s];
			if (e.getAttribute("offset") !== t.getAttribute("offset") || e.getAttribute("stop-opacity") !== t.getAttribute("stop-opacity") || e.getAttribute("stop-color") !== t.getAttribute("stop-color")) break;
		}
		if (s === -1) return i;
	}
	return null;
}, ui = (e, t) => {
	let n = new d(t);
	switch (K.setPaintOpacity(e, n.alpha / 100, !0), K.setCurProperties(`${e}_paint`, n), n.type) {
		case "solidColor":
			K.setColor(e, n.solidColor === "none" ? "none" : `#${n.solidColor}`);
			break;
		case "linearGradient":
		case "radialGradient":
			K.setCanvas(e + "Grad", n[n.type]), K.setGradient(e);
			break;
	}
}, di = (e) => {
	let t = K.getSelectedElements();
	if (e === 0 && ["line", "path"].includes(K.getMode())) {
		K.setStrokeWidth(1);
		return;
	}
	K.setCurProperties("stroke_width", e);
	let n = [], r = (e) => {
		e.nodeName !== "g" && n.push(e);
	}, i = t.length;
	for (; i--;) {
		let e = t[i];
		e && (e.tagName === "g" ? Se(e, r) : n.push(e));
	}
	n.length > 0 && (K.changeSelectedAttribute("stroke-width", e, n), K.call("changed", t));
}, fi = (e, t) => {
	let n = K.getSelectedElements();
	K.setCurShape(e.replace("-", "_"), t);
	let r = [], i = n.length;
	for (; i--;) {
		let e = n[i];
		e && (e.tagName === "g" ? Se(e, (e) => {
			e.nodeName !== "g" && r.push(e);
		}) : r.push(e));
	}
	r.length > 0 && (K.changeSelectedAttribute(e, t, r), K.call("changed", n));
}, pi = () => K.getSelectedElements().filter((e) => e?.tagName === "text"), mi = (e, t, n) => {
	let r = String(n);
	return e.filter((e) => ((t === "#text" ? e.textContent : e.getAttribute(t)) || "") !== r);
}, hi = (e) => {
	e.length > 0 && K.call("changed", e);
}, gi = () => pi().every((e) => e.getAttribute("font-weight") === "bold"), _i = (e) => {
	let t = pi(), n = e ? "bold" : "normal", r = mi(t, "font-weight", n);
	r.length > 0 && K.changeSelectedAttribute("font-weight", n, r), t.some((e) => e.textContent) || K.textActions.setCursor(), hi(r);
}, vi = (e) => pi().every((t) => (t.getAttribute("text-decoration") || "").includes(e)), yi = (e) => {
	let { ChangeElementCommand: t, BatchCommand: n } = K.history, r = pi(), i = new n();
	r.forEach((n) => {
		let r = n.getAttribute("text-decoration") || "";
		r.includes(e) || (i.addSubCommand(new t(n, { "text-decoration": r })), K.changeSelectedAttributeNoUndo("text-decoration", `${r} ${e}`.trim(), [n]));
	}), i.isEmpty() || K.undoMgr.addCommandToHistory(i), r.some((e) => e.textContent) || K.textActions.setCursor();
}, bi = (e) => {
	let { ChangeElementCommand: t, BatchCommand: n } = K.history, r = pi(), i = new n();
	r.forEach((n) => {
		let r = n.getAttribute("text-decoration") || "";
		i.addSubCommand(new t(n, { "text-decoration": r })), K.changeSelectedAttributeNoUndo("text-decoration", r.replace(e, "").trim(), [n]);
	}), i.isEmpty() || K.undoMgr.addCommandToHistory(i), r.some((e) => e.textContent) || K.textActions.setCursor();
}, xi = () => pi().every((e) => e.getAttribute("font-style") === "italic"), Si = (e) => {
	let t = pi(), n = e ? "italic" : "normal", r = mi(t, "font-style", n);
	r.length > 0 && K.changeSelectedAttribute("font-style", n, r), t.some((e) => e.textContent) || K.textActions.setCursor(), hi(r);
}, Ci = (e) => {
	let t = mi(pi(), "text-anchor", e);
	t.length > 0 && K.changeSelectedAttribute("text-anchor", e, t), hi(t);
}, wi = (e) => {
	let t = pi(), n = mi(t, "letter-spacing", e);
	n.length > 0 && K.changeSelectedAttribute("letter-spacing", e, n), t.some((e) => e.textContent) || K.textActions.setCursor(), hi(n);
}, Ti = (e) => {
	let t = pi(), n = mi(t, "word-spacing", e);
	n.length > 0 && K.changeSelectedAttribute("word-spacing", e, n), t.some((e) => e.textContent) || K.textActions.setCursor(), hi(n);
}, Ei = (e) => {
	let t = pi(), n = mi(t, "textLength", e);
	n.length > 0 && K.changeSelectedAttribute("textLength", e, n), t.some((e) => e.textContent) || K.textActions.setCursor(), hi(n);
}, Di = (e) => {
	let t = pi(), n = mi(t, "lengthAdjust", e);
	n.length > 0 && K.changeSelectedAttribute("lengthAdjust", e, n), t.some((e) => e.textContent) || K.textActions.setCursor(), hi(n);
}, Oi = () => K.getCurText("font_family"), ki = (e) => {
	let t = pi(), n = mi(t, "font-family", e);
	K.setCurText("font_family", e), n.length > 0 && K.changeSelectedAttribute("font-family", e, n), t.some((e) => e.textContent) || K.textActions.setCursor(), hi(n);
}, Ai = (e) => {
	let t = mi(pi(), "fill", e);
	K.setCurText("fill", e), t.length > 0 && K.changeSelectedAttribute("fill", e, t), hi(t);
}, ji = () => K.getCurText("fill"), Mi = () => K.getCurText("font_size"), Ni = (e) => {
	let t = pi(), n = mi(t, "font-size", e);
	K.setCurText("font_size", e), n.length > 0 && K.changeSelectedAttribute("font-size", e, n), t.some((e) => e.textContent) || K.textActions.setCursor(), hi(n);
}, Pi = () => {
	let e = K.getSelectedElements()[0];
	return e ? e.textContent : "";
}, Fi = (e) => {
	K.changeSelectedAttribute("#text", e), K.textActions.init(e), K.textActions.setCursor();
}, Ii = (e) => {
	let { ChangeElementCommand: t, BatchCommand: n } = K.history, r = K.getSelectedElements()[0];
	if (!r) return;
	let i = {
		width: r.getAttribute("width"),
		height: r.getAttribute("height")
	}, a = !i.width || !i.height, o = Te(r), s = o !== e;
	if (!s && !a) return;
	let c = new n("Change Image URL");
	s && (Ee(r, e), c.addSubCommand(new t(r, { "#href": o })));
	let l = !1, u = () => {
		l || (l = !0, !c.isEmpty() && (K.addCommandToHistory(c), K.call("changed", [r])));
	}, d = new Image();
	d.onload = () => {
		let e = {
			width: r.getAttribute("width"),
			height: r.getAttribute("height")
		};
		r.setAttribute("width", d.width), r.setAttribute("height", d.height);
		let n = K.selectorManager.requestSelector(r);
		n && n.resize(), c.addSubCommand(new t(r, e)), u();
	}, d.onerror = () => {
		u();
	}, d.src = e;
}, Li = (e) => {
	let { ChangeElementCommand: t, BatchCommand: n } = K.history, r = K.getSelectedElements()[0];
	if (!r) return;
	if (r.tagName !== "a") {
		let e = ce(r.parentNode, "a");
		if (e?.length) r = e[0];
		else return;
	}
	let i = Te(r);
	if (i === e) return;
	let a = new n("Change Link URL");
	Ee(r, e), a.addSubCommand(new t(r, { "#href": i })), K.addCommandToHistory(a);
}, Ri = (e) => {
	let { ChangeElementCommand: t } = K.history, n = K.getSelectedElements()[0];
	if (n?.tagName !== "rect") return;
	let r = Number(e);
	if (!Number.isFinite(r) || r < 0) return;
	let i = n.getAttribute("rx"), a = n.getAttribute("ry"), o = Number(i), s = Number(a);
	r === 0 && i === null && a === null || i !== null && Number.isFinite(o) && a !== null && Number.isFinite(s) && o === r && s === r || (n.setAttribute("rx", r), n.setAttribute("ry", r), K.addCommandToHistory(new t(n, {
		rx: i,
		ry: a
	}, "Radius")), K.call("changed", [n]));
}, zi = (e) => {
	K.groupSelectedElements("a", e);
}, Bi = () => {
	K.ungroupSelectedElement();
}, Vi = (e) => {
	K.pathActions.setSegType(e);
}, Hi = (e, t) => {
	let n = Ue("canvasBackground");
	if (!n) return;
	let r = n.querySelector("rect");
	if (!r) return;
	let i = Ue("background_image"), a = Ue("background_pattern");
	if (r.setAttribute("fill", e === "chessboard" ? "#fff" : e), e === "chessboard") {
		if (!a) {
			a = K.getDOMDocument().createElementNS(A.SVG, "foreignObject"), K.assignAttributes(a, {
				id: "background_pattern",
				width: "100%",
				height: "100%",
				preserveAspectRatio: "xMinYMin",
				style: "pointer-events:none"
			});
			let e = document.createElement("div");
			K.assignAttributes(e, { style: "pointer-events:none;width:100%;height:100%;background-image:url(data:image/gif;base64,R0lGODlhEAAQAIAAAP///9bW1iH5BAAAAAAALAAAAAAQABAAAAIfjG+gq4jM3IFLJgpswNly/XkcBpIiVaInlLJr9FZWAQA7);" }), a.append(e), n.append(a);
		}
	} else a && a.remove();
	t ? (i || (i = K.getDOMDocument().createElementNS(A.SVG, "image"), K.assignAttributes(i, {
		id: "background_image",
		width: "100%",
		height: "100%",
		preserveAspectRatio: "xMinYMin",
		style: "pointer-events:none"
	})), Ee(i, t), n.append(i)) : i && i.remove();
}, Ui = null, Wi = (e) => {
	if (e == null) return null;
	let t = String(e).trim();
	if (!t) return null;
	if (t.endsWith("%")) {
		let e = Number.parseFloat(t.slice(0, -1));
		return Number.isNaN(e) ? t : `${100 - e}%`;
	}
	let n = Number.parseFloat(t);
	return Number.isNaN(n) ? t : String(1 - n);
}, Gi = (e, t) => {
	let n = e.getAttribute(t);
	if (n == null) return;
	let r = Wi(n);
	r != null && e.setAttribute(t, r);
}, Ki = (e) => {
	Ui = e;
}, qi = [
	0,
	"z",
	"M",
	"m",
	"L",
	"l",
	"C",
	"c",
	"Q",
	"q",
	"A",
	"a",
	"H",
	"h",
	"V",
	"v",
	"S",
	"s",
	"T",
	"t"
], Ji = (e, t, n) => {
	let r = (e, t) => F(e, t, n), i = (e) => n.a * e, a = (e) => n.d * e, o = Ui.getGridSnapping?.() && e?.parentNode?.parentNode?.localName === "svg", s = () => {
		if (o) for (let [e, n] of Object.entries(t)) t[e] = Ke(n);
		We(e, t, 1e3, !0);
	}, c = H(e);
	["fill", "stroke"].forEach((t) => {
		let r = e.getAttribute(t);
		if (r?.startsWith("url(") && (n.a < 0 || n.d < 0)) {
			let i = Ve(r);
			if (!i) return;
			let a = (i.tagName || "").toLowerCase();
			if (!["lineargradient", "radialgradient"].includes(a) || i.getAttribute("gradientUnits") === "userSpaceOnUse") return;
			let o = i.cloneNode(!0);
			n.a < 0 && (a === "lineargradient" ? (Gi(o, "x1"), Gi(o, "x2")) : (Gi(o, "cx"), Gi(o, "fx"))), n.d < 0 && (a === "lineargradient" ? (Gi(o, "y1"), Gi(o, "y2")) : (Gi(o, "cy"), Gi(o, "fy")));
			let s = (Ui.getCurrentDrawing?.() || Ui.getDrawing?.())?.getNextId?.() ?? (i.id ? `${i.id}-mirrored` : `mirrored-grad-${Date.now()}`);
			if (!s) {
				g("Unable to mirror gradient: no drawing context available", null, "coords");
				return;
			}
			o.id = s, De().append(o), e.setAttribute(t, `url(#${o.id})`);
		}
	});
	let l = e.tagName;
	if (l !== "use") switch (l) {
		case "foreignObject":
		case "rect":
		case "image":
			if (l === "image" && (n.a < 0 || n.d < 0)) {
				let t = I(e), r = Ui.getSvgRoot().createSVGTransform();
				r.setMatrix(L(z(t).matrix, n)), t.clear(), t.appendItem(r);
			} else {
				let e = r(t.x, t.y);
				t.width = i(t.width), t.height = a(t.height), t.x = e.x + Math.min(0, t.width), t.y = e.y + Math.min(0, t.height), t.width = Math.abs(t.width), t.height = Math.abs(t.height);
			}
			s();
			break;
		case "ellipse": {
			let e = r(t.cx, t.cy);
			t.cx = e.x, t.cy = e.y, t.rx = Math.abs(i(t.rx)), t.ry = Math.abs(a(t.ry)), s();
			break;
		}
		case "circle": {
			let e = r(t.cx, t.cy);
			t.cx = e.x, t.cy = e.y;
			let i = te(c.x, c.y, c.width, c.height, n), a = i.tr.x - i.tl.x, o = i.bl.y - i.tl.y;
			t.r = Math.min(Math.abs(a / 2), Math.abs(o / 2)), s();
			break;
		}
		case "line": {
			let e = r(t.x1, t.y1), n = r(t.x2, t.y2);
			t.x1 = e.x, t.y1 = e.y, t.x2 = n.x, t.y2 = n.y, s();
			break;
		}
		case "text": {
			let i = r(t.x, t.y);
			t.x = i.x, t.y = i.y;
			let a = e.getAttribute("font-size");
			a ||= window.getComputedStyle(e).fontSize;
			let o = parseFloat(a);
			isNaN(o) || (t["font-size"] = o * Math.abs(n.a)), s();
			let c = e.childNodes;
			for (let e = 0; e < c.length; e++) {
				let i = c[e];
				if (i.nodeType === 1 && i.tagName === "tspan") {
					let e = {}, a = i.hasAttribute("x"), o = i.hasAttribute("y");
					if (a && (e.x = r(O("x", i.getAttribute("x")), t.y).x), o) {
						let n = O("y", i.getAttribute("y"));
						e.y = r(t.x, n).y;
					}
					let s = i.getAttribute("font-size");
					s ||= window.getComputedStyle(i).fontSize;
					let c = parseFloat(s);
					isNaN(c) || (e["font-size"] = c * Math.abs(n.a)), (a || o || e["font-size"]) && We(i, e, 1e3, !0);
				}
			}
			break;
		}
		case "tspan": {
			let i = r(t.x, t.y);
			t.x = i.x, t.y = i.y;
			let a = e.getAttribute("font-size");
			a ||= window.getComputedStyle(e).fontSize;
			let o = parseFloat(a);
			isNaN(o) || (t["font-size"] = o * Math.abs(n.a)), s();
			break;
		}
		case "g": {
			let n = Ui.getDataStorage().get(e, "gsvg");
			n && We(n, t, 1e3, !0);
			break;
		}
		case "polyline":
		case "polygon": {
			t.points.forEach((e) => {
				let { x: t, y: n } = r(e.x, e.y);
				e.x = t, e.y = n;
			});
			let n = t.points.map((e) => `${e.x},${e.y}`).join(" ");
			e.setAttribute("points", n);
			break;
		}
		case "path": {
			let o = typeof e.getPathData == "function" && typeof e.setPathData == "function", s = o ? null : e.pathSegList, c = o ? e.getPathData().length : s.numberOfItems, l = n.a * n.d - n.b * n.c < 0;
			if (t.d = [], o) {
				let n = e.getPathData();
				for (let e = 0; e < c; ++e) {
					let r = n[e], i = r.type, a = qi.indexOf(i);
					if (a === -1) continue;
					let o = r.values || [], s = { type: a };
					switch (i.toUpperCase()) {
						case "M":
						case "L":
						case "T":
							[s.x, s.y] = o;
							break;
						case "H":
							[s.x] = o;
							break;
						case "V":
							[s.y] = o;
							break;
						case "C":
							[s.x1, s.y1, s.x2, s.y2, s.x, s.y] = o;
							break;
						case "S":
							[s.x2, s.y2, s.x, s.y] = o;
							break;
						case "Q":
							[s.x1, s.y1, s.x, s.y] = o;
							break;
						case "A":
							[s.r1, s.r2, s.angle, s.largeArcFlag, s.sweepFlag, s.x, s.y] = o;
							break;
						default: break;
					}
					t.d[e] = s;
				}
			} else for (let e = 0; e < c; ++e) {
				let n = s.getItem(e);
				t.d[e] = {
					type: n.pathSegType,
					x: n.x,
					y: n.y,
					x1: n.x1,
					y1: n.y1,
					x2: n.x2,
					y2: n.y2,
					r1: n.r1,
					r2: n.r2,
					angle: n.angle,
					largeArcFlag: n.largeArcFlag,
					sweepFlag: n.sweepFlag
				};
			}
			let u = t.d[0], d;
			c > 0 && (d = r(u.x, u.y), t.d[0].x = d.x, t.d[0].y = d.y);
			for (let e = 1; e < c; ++e) {
				let n = t.d[e], { type: o } = n;
				if (o % 2 == 0) {
					let e = r(n.x === void 0 ? d.x : n.x, n.y === void 0 ? d.y : n.y);
					if (n.x = e.x, n.y = e.y, n.x1 !== void 0 && n.y1 !== void 0) {
						let e = r(n.x1, n.y1);
						n.x1 = e.x, n.y1 = e.y;
					}
					if (n.x2 !== void 0 && n.y2 !== void 0) {
						let e = r(n.x2, n.y2);
						n.x2 = e.x, n.y2 = e.y;
					}
					o === 10 && (n.r1 = Math.abs(i(n.r1)), n.r2 = Math.abs(a(n.r2)), l && (n.sweepFlag = +!Number(n.sweepFlag), typeof n.angle == "number" && (n.angle = -n.angle)));
				} else n.x !== void 0 && (n.x = i(n.x)), n.y !== void 0 && (n.y = a(n.y)), n.x1 !== void 0 && (n.x1 = i(n.x1)), n.y1 !== void 0 && (n.y1 = a(n.y1)), n.x2 !== void 0 && (n.x2 = i(n.x2)), n.y2 !== void 0 && (n.y2 = a(n.y2)), o === 11 && (n.r1 = Math.abs(i(n.r1)), n.r2 = Math.abs(a(n.r2)), l && (n.sweepFlag = +!Number(n.sweepFlag), typeof n.angle == "number" && (n.angle = -n.angle)));
			}
			let f = "", p = [];
			t.d.forEach((e) => {
				let { type: t } = e, n = qi[t];
				switch (f += n, t) {
					case 13:
					case 12:
						f += `${e.x} `, p.push({
							type: n,
							values: [e.x]
						});
						break;
					case 15:
					case 14:
						f += `${e.y} `, p.push({
							type: n,
							values: [e.y]
						});
						break;
					case 3:
					case 5:
					case 19:
					case 2:
					case 4:
					case 18:
						f += `${e.x},${e.y} `, p.push({
							type: n,
							values: [e.x, e.y]
						});
						break;
					case 7:
					case 6:
						f += `${e.x1},${e.y1} ${e.x2},${e.y2} ${e.x},${e.y} `, p.push({
							type: n,
							values: [
								e.x1,
								e.y1,
								e.x2,
								e.y2,
								e.x,
								e.y
							]
						});
						break;
					case 9:
					case 8:
						f += `${e.x1},${e.y1} ${e.x},${e.y} `, p.push({
							type: n,
							values: [
								e.x1,
								e.y1,
								e.x,
								e.y
							]
						});
						break;
					case 11:
					case 10:
						f += e.r1 + "," + e.r2 + " " + e.angle + " " + Number(e.largeArcFlag) + " " + Number(e.sweepFlag) + " " + e.x + "," + e.y + " ", p.push({
							type: n,
							values: [
								e.r1,
								e.r2,
								e.angle,
								Number(e.largeArcFlag),
								Number(e.sweepFlag),
								e.x,
								e.y
							]
						});
						break;
					case 17:
					case 16:
						f += `${e.x2},${e.y2} ${e.x},${e.y} `, p.push({
							type: n,
							values: [
								e.x2,
								e.y2,
								e.x,
								e.y
							]
						});
						break;
					default: break;
				}
			});
			let m = f.trim();
			if (e.setAttribute("d", m), o) try {
				e.setPathData(p);
			} catch {}
			break;
		}
		default: break;
	}
}, Yi, Xi = (e) => {
	Yi = e;
}, Zi = (e, t, n, r) => {
	let i = Ve(e);
	if (!i) return;
	if (r && i.id) {
		let e = Yi.getSvgContent?.();
		if (e) {
			let a = `[clip-path="url(#${i.id})"]`;
			if (e.querySelectorAll(a).length > 1) {
				let e = i.cloneNode(!0);
				return e.id = Yi.getNextId(), De().append(e), r.setAttribute("clip-path", `url(#${e.id})`), Zi(`url(#${e.id})`, t, n);
			}
		}
	}
	let a = i.firstElementChild;
	if (!a) return e;
	let o = I(a);
	if (!o) {
		let r = (a.tagName || "").toLowerCase();
		if (r === "rect") {
			let e = O("x", a.getAttribute("x") || 0) + t, r = O("y", a.getAttribute("y") || 0) + n;
			a.setAttribute("x", e), a.setAttribute("y", r);
		} else if (r === "circle" || r === "ellipse") {
			let e = O("cx", a.getAttribute("cx") || 0) + t, r = O("cy", a.getAttribute("cy") || 0) + n;
			a.setAttribute("cx", e), a.setAttribute("cy", r);
		} else if (r === "line") a.setAttribute("x1", O("x1", a.getAttribute("x1") || 0) + t), a.setAttribute("y1", O("y1", a.getAttribute("y1") || 0) + n), a.setAttribute("x2", O("x2", a.getAttribute("x2") || 0) + t), a.setAttribute("y2", O("y2", a.getAttribute("y2") || 0) + n);
		else if (r === "polyline" || r === "polygon") {
			let e = (a.getAttribute("points") || "").trim();
			if (e) {
				let r = e.split(/\s+/).map((e) => {
					let [r, i] = e.split(",");
					return `${Number(r) + t},${Number(i) + n}`;
				});
				a.setAttribute("points", r.join(" "));
			}
		} else a.setAttribute("transform", `translate(${t},${n})`);
		return e;
	}
	if (o.numberOfItems) {
		let r = Yi.getSvgRoot().createSVGMatrix();
		r.e = t, r.f = n;
		let i = L(z(o).matrix, r), a = Yi.getSvgRoot().createSVGTransform();
		return a.setMatrix(i), o.clear(), o.appendItem(a), e;
	}
	let s = (a.tagName || "").toLowerCase();
	if ((s === "polyline" || s === "polygon") && !a.points?.numberOfItems) {
		let e = (a.getAttribute("points") || "").trim();
		if (e) {
			let r = e.split(/\s+/).map((e) => {
				let [r, i] = e.split(",");
				return `${Number(r) + t},${Number(i) + n}`;
			});
			a.setAttribute("points", r.join(" "));
		}
		return;
	}
	let c = Yi.getSvgRoot().createSVGTransform();
	return c.setTranslate(t, n), o.appendItem(c), Qi(a), e;
}, Qi = (e) => {
	if (!e || e.tagName === "g" || e.tagName === "a" || e.getAttribute?.("clip-path") && e.querySelector?.("[clip-path]")) return null;
	let t = Yi.getSvgRoot(), n = Yi.getDataStorage(), r = I(e);
	if (r?.numberOfItems > 0) {
		let t = r.numberOfItems, n = t;
		for (; t--;) {
			let i = r.getItem(t);
			if (i.type === SVGTransform.SVG_TRANSFORM_MATRIX) {
				if (ee(i.matrix)) {
					if (n === 1) return e.removeAttribute("transform"), null;
					r.removeItem(t);
				}
			} else (i.type === SVGTransform.SVG_TRANSFORM_ROTATE && i.angle === 0 || i.type === SVGTransform.SVG_TRANSFORM_TRANSLATE && i.matrix.e === 0 && i.matrix.f === 0) && r.removeItem(t);
		}
		if (r.numberOfItems === 1 && Be(e)) return null;
	}
	if (!r || r.numberOfItems === 0) return e.removeAttribute("transform"), null;
	if (e.tagName === "use") return null;
	let i = new lt("Transform");
	switch (e.tagName) {
		case "line":
		case "polyline":
		case "polygon":
		case "path": break;
		default: if (r.numberOfItems === 1 && r.getItem(0).type === SVGTransform.SVG_TRANSFORM_MATRIX || r.numberOfItems === 2 && r.getItem(0).type === SVGTransform.SVG_TRANSFORM_MATRIX && r.getItem(1).type === SVGTransform.SVG_TRANSFORM_ROTATE) return null;
	}
	let a = n.has(e, "gsvg") ? n.get(e, "gsvg") : void 0, o = {}, s = null, c = [];
	switch (e.tagName) {
		case "line":
			c = [
				"x1",
				"y1",
				"x2",
				"y2"
			];
			break;
		case "circle":
			c = [
				"cx",
				"cy",
				"r"
			];
			break;
		case "ellipse":
			c = [
				"cx",
				"cy",
				"rx",
				"ry"
			];
			break;
		case "foreignObject":
		case "rect":
		case "image":
			c = [
				"width",
				"height",
				"x",
				"y"
			];
			break;
		case "text":
		case "tspan":
			c = ["x", "y"];
			break;
		case "polygon":
		case "polyline": {
			s = {}, s.points = e.getAttribute("points");
			let t = e.points, n = t.numberOfItems;
			o.points = Array(n);
			for (let e = 0; e < n; ++e) {
				let n = t.getItem(e);
				o.points[e] = {
					x: n.x,
					y: n.y
				};
			}
			break;
		}
		case "path":
			s = {}, s.d = e.getAttribute("d"), o.d = e.getAttribute("d");
			break;
	}
	if (c.length ? c.forEach((t) => {
		o[t] = O(t, e.getAttribute(t));
	}) : a && (o = {
		x: Number(a.getAttribute("x")) || 0,
		y: Number(a.getAttribute("y")) || 0
	}), !s) {
		s = oe({}, o);
		for (let [e, t] of Object.entries(s)) s[e] = O(e, t);
	}
	s.transform = Yi.getStartTransform() || "";
	let l, u;
	if (e.tagName === "g" && !a || e.tagName === "a") {
		let n = H(e);
		l = {
			x: n.x + n.width / 2,
			y: n.y + n.height / 2
		}, u = F(n.x + n.width / 2, n.y + n.height / 2, z(r).matrix);
		let a = Be(e);
		if (a) {
			let e = a * Math.PI / 180, t = Math.abs(e) > 1e-10 ? Math.sin(e) / (1 - Math.cos(e)) : 2 / e;
			for (let e = 0; e < r.numberOfItems; ++e) {
				let n = r.getItem(e);
				if (n.type === SVGTransform.SVG_TRANSFORM_ROTATE) {
					let i = n.matrix;
					l.y = (t * i.e + i.f) / 2, l.x = (i.e - t * i.f) / 2, r.removeItem(e);
					break;
				}
			}
		}
		let o = r.numberOfItems, s = 0, c = 0, d = 0, f;
		o && (f = r.getItem(0).matrix);
		let p;
		if (o >= 3 && r.getItem(o - 2).type === SVGTransform.SVG_TRANSFORM_SCALE && r.getItem(o - 3).type === SVGTransform.SVG_TRANSFORM_TRANSLATE && r.getItem(o - 1).type === SVGTransform.SVG_TRANSFORM_TRANSLATE) {
			d = 3;
			let n = r.getItem(o - 3).matrix, a = r.getItem(o - 2).matrix, s = r.getItem(o - 1).matrix, c = e.childNodes, l = c.length;
			for (; l--;) {
				let e = c.item(l);
				if (e.nodeType !== 1) continue;
				let r = I(e);
				if (!r) continue;
				let o = z(r).matrix, u = Be(e);
				if (p = Yi.getStartTransform(), Yi.setStartTransform(e.getAttribute("transform")), u || R(r)) {
					let e = t.createSVGTransform();
					e.setMatrix(L(n, a, s, o)), r.clear(), r.appendItem(e);
				} else {
					let e = L(o.inverse(), s, o), i = t.createSVGMatrix();
					i.e = -e.e, i.f = -e.f;
					let c = L(i.inverse(), o.inverse(), n, a, s, o, e.inverse()), l = t.createSVGTransform(), u = t.createSVGTransform(), d = t.createSVGTransform();
					l.setTranslate(e.e, e.f), u.setScale(c.a, c.d), d.setTranslate(i.e, i.f), r.appendItem(d), r.appendItem(u), r.appendItem(l);
				}
				let d = Qi(e);
				d && i.addSubCommand(d), Yi.setStartTransform(p);
			}
			r.removeItem(o - 1), r.removeItem(o - 2), r.removeItem(o - 3);
		} else if (o >= 3 && r.getItem(o - 1).type === SVGTransform.SVG_TRANSFORM_MATRIX) {
			d = 3;
			let e = z(r).matrix, n = t.createSVGTransform();
			n.setMatrix(e), r.clear(), r.appendItem(n);
		} else if ((o === 1 || o > 1 && r.getItem(1).type !== SVGTransform.SVG_TRANSFORM_SCALE) && r.getItem(0).type === SVGTransform.SVG_TRANSFORM_TRANSLATE) {
			d = 2;
			let n = z(r).matrix;
			r.removeItem(0);
			let a = L(z(r).matrix.inverse(), n);
			if (s = a.e, c = a.f, s !== 0 || c !== 0) {
				let n = e.getAttribute?.("clip-path");
				n && Zi(n, s, c, e);
				let r = e.childNodes, a = r.length, o = [];
				for (; a--;) {
					let n = r.item(a);
					if (n.nodeType !== 1) continue;
					let l = n.getAttribute("clip-path");
					if (l && !o.includes(l)) {
						let e = Zi(l, s, c, n);
						o.push(e || l);
					}
					let u = I(n);
					if (!u) continue;
					p = Yi.getStartTransform(), Yi.setStartTransform(n.getAttribute("transform"));
					let d = t.createSVGTransform();
					d.setTranslate(s, c), u.numberOfItems ? u.insertItemBefore(d, 0) : u.appendItem(d);
					let f = Qi(n);
					f && i.addSubCommand(f);
					let m = e.getElementsByTagNameNS(A.SVG, "use"), h = `#${n.id}`, g = m.length;
					for (; g--;) {
						let e = m.item(g);
						if (h === Te(e)) {
							let n = t.createSVGTransform();
							n.setTranslate(-s, -c), I(e)?.insertItemBefore(n, 0);
							let r = Qi(e);
							r && i.addSubCommand(r);
						}
					}
					Yi.setStartTransform(p);
				}
			}
		} else if (o === 1 && r.getItem(0).type === SVGTransform.SVG_TRANSFORM_MATRIX && !a) {
			d = 1;
			let n = r.getItem(0).matrix, a = e.childNodes, o = a.length;
			for (; o--;) {
				let e = a.item(o);
				if (e.nodeType !== 1) continue;
				let r = I(e);
				if (!r) continue;
				p = Yi.getStartTransform(), Yi.setStartTransform(e.getAttribute("transform"));
				let s = L(n, z(r).matrix), c = t.createSVGTransform();
				c.setMatrix(s), r.clear(), r.appendItem(c);
				let l = Qi(e);
				l && i.addSubCommand(l), Yi.setStartTransform(p);
				let u = e.getAttribute("stroke-width");
				if (e.getAttribute("stroke") !== "none" && !Number.isNaN(Number(u))) {
					let t = (Math.abs(s.a) + Math.abs(s.d)) / 2;
					e.setAttribute("stroke-width", Number(u) * t);
				}
			}
			r.clear();
		} else {
			if (a) {
				let e = t.createSVGTransform();
				e.setRotate(a, u.x, u.y), r.numberOfItems ? r.insertItemBefore(e, 0) : r.appendItem(e);
			}
			return r.numberOfItems === 0 && e.removeAttribute("transform"), null;
		}
		if (d === 2) {
			if (a) {
				u = {
					x: l.x + f.e,
					y: l.y + f.f
				};
				let e = t.createSVGTransform();
				e.setRotate(a, u.x, u.y), r.numberOfItems ? r.insertItemBefore(e, 0) : r.appendItem(e);
			}
		} else if (d === 3) {
			let n = z(r).matrix, o = t.createSVGTransform();
			o.setRotate(a, l.x, l.y);
			let d = o.matrix, f = t.createSVGTransform();
			f.setRotate(a, u.x, u.y);
			let m = f.matrix.inverse(), h = L(n.inverse(), m, d, n);
			if (s = h.e, c = h.f, s !== 0 || c !== 0) {
				let n = e.childNodes, r = n.length;
				for (; r--;) {
					let e = n.item(r);
					if (e.nodeType !== 1) continue;
					let a = I(e);
					if (!a) continue;
					p = Yi.getStartTransform(), Yi.setStartTransform(e.getAttribute("transform"));
					let o = t.createSVGTransform();
					o.setTranslate(s, c), a.numberOfItems ? a.insertItemBefore(o, 0) : a.appendItem(o);
					let l = Qi(e);
					l && i.addSubCommand(l), Yi.setStartTransform(p);
				}
			}
			a && (r.numberOfItems ? r.insertItemBefore(f, 0) : r.appendItem(f));
		}
	} else {
		let n = H(e);
		if (!n && e.tagName !== "path") return null;
		let i, a = 0, s = 0;
		[
			"use",
			"image",
			"text",
			"tspan"
		].includes(e.tagName) && (a = O("x", e.getAttribute("x") || "0"), s = O("y", e.getAttribute("y") || "0"));
		let c = Be(e);
		if (c) {
			if (e.localName === "image") {
				let t = O("x", e.getAttribute("x") || "0"), n = O("y", e.getAttribute("y") || "0"), i = O("width", e.getAttribute("width") || "0"), a = O("height", e.getAttribute("height") || "0"), o = t + i / 2, s = n + a / 2;
				l = {
					x: o,
					y: s
				};
				let c = z(r).matrix;
				u = F(o, s, c);
			} else if (e.localName === "text") {
				let e = n.x + n.width / 2, t = n.y + n.height / 2;
				l = {
					x: e,
					y: t
				}, u = F(e, t, z(r).matrix);
			} else l = {
				x: n.x + n.width / 2 + a,
				y: n.y + n.height / 2 + s
			}, u = F(n.x + n.width / 2 + a, n.y + n.height / 2 + s, z(r).matrix);
			for (let e = 0; e < r.numberOfItems; ++e) if (r.getItem(e).type === SVGTransform.SVG_TRANSFORM_ROTATE) {
				r.removeItem(e);
				break;
			}
		}
		let d = r.numberOfItems;
		if (d >= 3 && r.getItem(d - 3).type === SVGTransform.SVG_TRANSFORM_TRANSLATE && r.getItem(d - 2).type === SVGTransform.SVG_TRANSFORM_SCALE && r.getItem(d - 1).type === SVGTransform.SVG_TRANSFORM_TRANSLATE) {
			if (i = z(r, d - 3, d - 1).matrix, r.removeItem(d - 1), r.removeItem(d - 2), r.removeItem(d - 3), e.tagName === "use") {
				let n = z(I(e)).matrix, a = L(n, i);
				r.clear();
				let o = t.createSVGTransform();
				o.setMatrix(a), r.appendItem(o);
			} else Ji(e, o, i);
			if (c) {
				let n = z(r).matrix, i = t.createSVGTransform();
				i.setRotate(c, l.x, l.y);
				let a = i.matrix, s = t.createSVGTransform();
				s.setRotate(c, u.x, u.y);
				let d = s.matrix.inverse(), f = L(n.inverse(), d, a, n);
				Ji(e, o, f), r.numberOfItems ? r.insertItemBefore(s, 0) : r.appendItem(s);
			}
		} else if ((d === 1 || d > 1 && r.getItem(1).type !== SVGTransform.SVG_TRANSFORM_SCALE) && r.getItem(0).type === SVGTransform.SVG_TRANSFORM_TRANSLATE) {
			let n = r.getItem(0).matrix, a = z(r, 1).matrix;
			if (i = L(a.inverse(), n, a), r.removeItem(0), e.tagName === "use") {
				let n = z(I(e)).matrix, a = L(n, i);
				r.clear();
				let o = t.createSVGTransform();
				o.setMatrix(a), r.appendItem(o);
			} else Ji(e, o, i);
			if (c) {
				R(r) || (u = {
					x: l.x + i.e,
					y: l.y + i.f
				});
				let e = t.createSVGTransform();
				e.setRotate(c, u.x, u.y), r.numberOfItems ? r.insertItemBefore(e, 0) : r.appendItem(e);
			}
		} else if (d === 1 && r.getItem(0).type === SVGTransform.SVG_TRANSFORM_MATRIX && !c) if (i = z(r).matrix, r.clear(), e.tagName === "use") {
			let n = z(I(e)).matrix, a = L(n, i);
			r.clear();
			let o = t.createSVGTransform();
			o.setMatrix(a), r.appendItem(o);
		} else Ji(e, o, i);
		else {
			if (c) {
				let e = t.createSVGTransform();
				e.setRotate(c, u.x, u.y), r.numberOfItems ? r.insertItemBefore(e, 0) : r.appendItem(e);
			}
			return r.numberOfItems === 0 && e.removeAttribute("transform"), null;
		}
	}
	return r.numberOfItems === 0 && e.removeAttribute("transform"), i.addSubCommand(new ct(e, s)), i;
}, { MoveElementCommand: $i, BatchCommand: ea, InsertElementCommand: ta, RemoveElementCommand: na, ChangeElementCommand: ra } = et, q = null, ia = (e) => {
	q = e, q.copySelectedElements = ga, q.groupSelectedElements = _a, q.pushGroupProperties = va, q.ungroupSelectedElement = ba, q.moveToTopSelectedElement = aa, q.moveToBottomSelectedElement = oa, q.moveUpDownSelected = sa, q.moveSelectedElements = ca, q.cloneSelectedElements = la, q.alignSelectedElements = ua, q.updateCanvas = xa, q.cycleElement = Sa, q.deleteSelectedElements = ma, q.flipSelectedElements = ha;
}, aa = () => {
	let [e] = q.getSelectedElements();
	if (e) {
		let t = e, n = t.parentNode, r = t.nextSibling;
		t.parentNode.append(t), r !== t.nextSibling && (q.addCommandToHistory(new $i(t, r, n, "top")), q.call("changed", [t]));
	}
}, oa = () => {
	let [e] = q.getSelectedElements();
	if (e) {
		let t = e, n = t.parentNode, r = t.nextSibling, i = t.parentNode.firstElementChild;
		if (i?.tagName === "title" && (i = i.nextElementSibling), i?.tagName === "defs" && (i = i.nextElementSibling), !i) return;
		t = t.parentNode.insertBefore(t, i), r !== t.nextSibling && (q.addCommandToHistory(new $i(t, r, n, "bottom")), q.call("changed", [t]));
	}
}, sa = (e) => {
	let t = q.getSelectedElements()[0];
	if (!t) return;
	q.setCurBBoxes([]);
	let n, r, i = q.getIntersectionList(Re([t]));
	if (e === "Down" && i.reverse(), Array.prototype.forEach.call(i, (e) => r ? (n === void 0 && (n = e), !1) : (e === t && (r = !0), !0)), !n) return;
	let a = t, o = a.parentNode, s = a.nextSibling;
	e === "Down" ? n.insertAdjacentElement("beforebegin", a) : n.insertAdjacentElement("afterend", a), s !== a.nextSibling && (q.addCommandToHistory(new $i(a, s, o, `Move ${e}`)), q.call("changed", [a]));
}, ca = (e, t, n = !0) => {
	let r = q.getSelectedElements(), i = q.getZoom();
	Array.isArray(e) || (e /= i, t /= i);
	let a = new ea("position");
	if (r.forEach((n, r) => {
		if (n) {
			let i = n.getAttribute("transform") || "", o = q.getSvgRoot().createSVGTransform(), s = I(n);
			Array.isArray(e) ? o.setTranslate(e[r], t[r]) : o.setTranslate(e, t), s.numberOfItems ? s.insertItemBefore(o, 0) : s.appendItem(o);
			let c = Qi(n);
			c ? a.addSubCommand(c) : (n.getAttribute("transform") || "") !== i && a.addSubCommand(new ra(n, { transform: i })), q.gettingSelectorManager().requestSelector(n).resize();
		}
	}), !a.isEmpty()) return n && q.addCommandToHistory(a), q.call("changed", r), a;
}, la = (e, t) => {
	let n = q.getSelectedElements(), r = q.getCurrentGroup(), i, a, o = new ea("Clone Elements"), s = n.length, c = (e) => {
		if (!e) return -1;
		let t = 0, n = e;
		do
			t++, n = n.previousElementSibling;
		while (n);
		return t;
	};
	for (n.sort((e, t) => c(t) - c(e)), i = 0; i < s && (a = n[i], a); ++i);
	let l = n.slice(0, i);
	q.clearSelection(!0);
	let u = q.getDrawing();
	for (i = l.length; i--;) a = l[i] = u.copyElem(l[i]), (r || u.getCurrentLayer()).append(a), o.addSubCommand(new ta(a));
	o.isEmpty() || (q.addToSelection(l.reverse()), ca(e, t, !1), q.addCommandToHistory(o));
}, ua = (e, t) => {
	let n = q.getSelectedElements(), r = [], i = n.length;
	if (!i) return;
	let a = Number.MAX_VALUE, o = Number.MIN_VALUE, s = Number.MAX_VALUE, c = Number.MIN_VALUE, l = (e) => [
		"l",
		"c",
		"r",
		"left",
		"center",
		"right"
	].includes(e), u = (e) => [
		"t",
		"m",
		"b",
		"top",
		"middle",
		"bottom"
	].includes(e);
	for (let e = 0; e < i && n[e]; ++e) {
		let t = n[e];
		r[e] = Re([t]);
	}
	switch (["smallest", "largest"].includes(t) && [
		"dh",
		"distrib_horiz",
		"dv",
		"distrib_verti"
	].includes(e) && (t = "selected"), t) {
		case "smallest":
			if (l(e) || u(e)) {
				let e = r.slice().sort((e, t) => e.width - t.width)[0];
				a = e.x, s = e.y, o = e.x + e.width, c = e.y + e.height;
			}
			break;
		case "largest":
			if (l(e) || u(e)) {
				let e = r.slice().sort((e, t) => e.width - t.width)[r.length - 1];
				a = e.x, s = e.y, o = e.x + e.width, c = e.y + e.height;
			}
			break;
		case "page":
			a = 0, s = 0, o = q.getContentW(), c = q.getContentH();
			break;
		default:
			a = Math.min(...r.map((e) => e.x)), s = Math.min(...r.map((e) => e.y)), o = Math.max(...r.map((e) => e.x + e.width)), c = Math.max(...r.map((e) => e.y + e.height));
			break;
	}
	let d = [], f = [];
	["dh", "distrib_horiz"].includes(e) ? [d, f] = da(t, n, r, a, o, s, c) : ["dv", "distrib_verti"].includes(e) ? [d, f] = fa(t, n, r, a, o, s, c) : [d, f] = pa(e, n, r, a, o, s, c), ca(d, f);
}, da = (e, t, n, r, i, a, o) => {
	let s = [], c = [];
	for (let e = 0; e < t.length; e++) c[e] = 0;
	let l = n.slice().sort((e, t) => {
		let n = e.x + e.width, r = t.x + t.width;
		return n === r ? 0 : n > r ? 1 : -1;
	});
	e === "page" && (l.unshift({
		x: 0,
		y: 0,
		width: 0,
		height: o
	}), l.push({
		x: i,
		y: 0,
		width: 0,
		height: o
	}));
	let u = (i - r - l.map((e) => e.width).reduce((e, t) => e + t, 0)) / (l.length - 1), d = [];
	for (let e = 0; e < l.length; ++e) {
		if (d[e] = 0, e === 0) continue;
		let t = l[e].x;
		l[e].x = l[e - 1].x + l[e - 1].width + u, d[e] = l[e].x - t;
	}
	return l.forEach((e, t) => {
		let r = n.findIndex((t) => t === e);
		r !== -1 && (s[r] = d[t]);
	}), [s, c];
}, fa = (e, t, n, r, i, a, o) => {
	let s = [], c = [];
	for (let e = 0; e < t.length; e++) s[e] = 0;
	let l = n.slice().sort((e, t) => {
		let n = e.y + e.height, r = t.y + t.height;
		return n === r ? 0 : n > r ? 1 : -1;
	});
	e === "page" && (l.unshift({
		x: 0,
		y: 0,
		width: i,
		height: 0
	}), l.push({
		x: 0,
		y: o,
		width: i,
		height: 0
	}));
	let u = (o - a - l.map((e) => e.height).reduce((e, t) => e + t, 0)) / (l.length - 1), d = [];
	for (let e = 0; e < l.length; ++e) {
		if (d[e] = 0, e === 0) continue;
		let t = l[e].y;
		l[e].y = l[e - 1].y + l[e - 1].height + u, d[e] = l[e].y - t;
	}
	return l.forEach((e, t) => {
		let r = n.findIndex((t) => t === e);
		r !== -1 && (c[r] = d[t]);
	}), [s, c];
}, pa = (e, t, n, r, i, a, o) => {
	let s = t.length, c = Array(s), l = Array(s);
	for (let u = 0; u < s && t[u]; ++u) {
		let t = n[u];
		switch (c[u] = 0, l[u] = 0, e) {
			case "l":
			case "left":
				c[u] = r - t.x;
				break;
			case "c":
			case "center":
				c[u] = (r + i) / 2 - (t.x + t.width / 2);
				break;
			case "r":
			case "right":
				c[u] = i - (t.x + t.width);
				break;
			case "t":
			case "top":
				l[u] = a - t.y;
				break;
			case "m":
			case "middle":
				l[u] = (a + o) / 2 - (t.y + t.height / 2);
				break;
			case "b":
			case "bottom":
				l[u] = o - (t.y + t.height);
				break;
		}
	}
	return [c, l];
}, ma = () => {
	let e = q.getSelectedElements(), t = new ea("Delete Elements"), n = [];
	e.forEach((e) => {
		if (e) {
			let r = e.parentNode, i = e;
			q.gettingSelectorManager().releaseSelector(i), rn(i.id), r.tagName === "a" && r.childNodes.length === 1 && (i = r, r = r.parentNode);
			let { nextSibling: a } = i;
			i.remove();
			let o = i;
			n.push(e), t.addSubCommand(new na(o, a, r));
		}
	}), q.setEmptySelectedElements(), t.isEmpty() || q.addCommandToHistory(t), q.call("changed", n), q.clearSelection();
}, ha = (e, t) => {
	let n = q.getSelectedElements(), r = new ea("Flip Elements"), i = q.getSvgRoot();
	n.forEach((n) => {
		if (!n) return;
		let a = Re([n]);
		if (!a) return;
		let o = a.x + a.width / 2, s = a.y + a.height / 2, c = n.getAttribute("transform") || "", l = i.createSVGMatrix().translate(o, s).scaleNonUniform(e, t).translate(-o, -s), u = I(n), d = L(z(u).matrix, l), f = i.createSVGTransform();
		f.setMatrix(d), u.clear(), u.appendItem(f);
		let p = q.getStartTransform ? q.getStartTransform() : null;
		q.setStartTransform && q.setStartTransform(c);
		let m = Qi(n);
		q.setStartTransform && q.setStartTransform(p), m ? r.addSubCommand(m) : (n.getAttribute("transform") || "") !== c && r.addSubCommand(new ra(n, { transform: c })), q.gettingSelectorManager().requestSelector(n).resize();
	}), r.isEmpty() || (q.addCommandToHistory(r), q.call("changed", n.filter(Boolean)));
}, ga = () => {
	let e = q.getSelectedElements().filter(Boolean), t = JSON.stringify(e.map((e) => q.getJsonFromSvgElements(e)));
	sessionStorage.setItem(q.getClipboardID(), t), q.flashStorage(), document.getElementById("se-cmenu_canvas")?.setAttribute("enablemenuitems", "#paste,#paste_in_place");
}, _a = (e, t) => {
	let n = q.getSelectedElements();
	e ||= "g";
	let r = "", i;
	switch (e) {
		case "a":
			r = "Make hyperlink", i = t || "";
			break;
		default:
			e = "g", r = "Group Elements";
			break;
	}
	let a = new ea(r), o = q.addSVGElementsFromJson({
		element: e,
		attr: { id: q.getNextId() }
	});
	e === "a" && Ee(o, i), a.addSubCommand(new ta(o));
	let s = n.length;
	for (; s--;) {
		let e = n[s];
		if (!e) continue;
		e.parentNode.tagName === "a" && e.parentNode.childNodes.length === 1 && (e = e.parentNode);
		let t = e.nextSibling, r = e.parentNode;
		o.append(e), a.addSubCommand(new $i(e, t, r));
	}
	a.isEmpty() || q.addCommandToHistory(a), q.selectOnly([o], !0);
}, va = (e, t) => {
	let n = e.childNodes, r = n.length, i = e.getAttribute("transform"), a = I(e), o = z(a).matrix, s = new ea("Push group properties"), c = Be(e), l = {
		filter: e.getAttribute("filter"),
		opacity: e.getAttribute("opacity")
	}, u, d, f, p = q.getDrawing();
	for (let i = 0; i < r; i++) {
		let r = n[i];
		if (r.nodeType !== 1) continue;
		if (l.opacity !== null && l.opacity !== 1) {
			let e = Math.round((r.getAttribute("opacity") || 1) * l.opacity * 100) / 100;
			q.changeSelectedAttribute("opacity", e, [r]);
		}
		if (l.filter) {
			let t = q.getBlur(r), n = t;
			if (d ||= q.getBlur(e), t ? t = Number(d) + Number(t) : t === 0 && (t = d), n) u = Ve(r.getAttribute("filter"));
			else if (!u) u = Ve(l.filter);
			else {
				u = p.copyElem(u), De().append(u);
				let e = He(u)?.tagName === "feGaussianBlur" ? "blur" : "filter";
				u.id = `${r.id}_${e}`, q.changeSelectedAttribute("filter", `url(#${u.id})`, [r]);
			}
			let i = He(u);
			t && (q.changeSelectedAttribute("stdDeviation", t, [i]), q.setBlurOffsets(u, t));
		}
		let m = I(r);
		if (r.tagName.includes("Gradient") && (m = null), m && r.tagName !== "defs" && a.numberOfItems) if (c && a.numberOfItems === 1) {
			let e = a.getItem(0).matrix, t = q.getSvgRoot().createSVGMatrix(), n = Be(r);
			n && (t = m.getItem(0).matrix);
			let i = H(r), o = z(m).matrix, s = F(i.x + i.width / 2, i.y + i.height / 2, o), l = c + n, u = q.getSvgRoot().createSVGTransform();
			u.setRotate(l, s.x, s.y);
			let d = L(e, t, u.matrix.inverse());
			if (n && m.removeItem(0), l && (m.numberOfItems ? m.insertItemBefore(u, 0) : m.appendItem(u)), d.e || d.f) {
				let e = q.getSvgRoot().createSVGTransform();
				e.setTranslate(d.e, d.f), m.numberOfItems ? m.insertItemBefore(e, 0) : m.appendItem(e);
			}
		} else {
			let e = r.getAttribute("transform");
			f = {}, f.transform = e || "";
			let n = q.getSvgRoot().createSVGTransform();
			n.setMatrix(o), m.numberOfItems ? m.insertItemBefore(n, 0) : m.appendItem(n), t && s.addSubCommand(new ra(r, f));
		}
	}
	if (i && (f = {}, f.transform = i, e.setAttribute("transform", ""), e.removeAttribute("transform"), s.addSubCommand(new ra(e, f))), t && !s.isEmpty()) return s;
}, ya = (e) => {
	let t = q.getSelectedElements();
	e ||= t[0];
	let n = e, r = new ea(), i, a = q.getDataStorage();
	if (a.has(n, "gsvg")) {
		let t = e.firstChild, n = {
			x: Number(t.getAttribute("x")),
			y: Number(t.getAttribute("y"))
		}, r = e.firstChild.firstChild;
		r && (r.outerHTML = r.innerHTML), a.remove(e, "gsvg");
		let i = I(e), o = q.getSvgRoot().createSVGTransform();
		return o.setTranslate(n.x, n.y), i.appendItem(o), Qi(e), q.call("selected", [e]), e;
	} else if (a.has(n, "symbol")) {
		if (e = a.get(n, "symbol"), !e) {
			g("Unable to convert <use>: missing symbol reference", null, "selected-elem");
			return;
		}
		i = n.getAttribute("transform") || "";
		let t = {
			x: Number(n.getAttribute("x")),
			y: Number(n.getAttribute("y"))
		}, o = e.getAttribute("viewBox");
		if (o) {
			let e = o.split(/[ ,]+/);
			t.x -= Number(e[0]), t.y -= Number(e[1]);
		}
		i += " translate(" + (t.x || 0) + "," + (t.y || 0) + ")";
		let s = n.parentNode, c = n.nextSibling;
		r.addSubCommand(new na(n, c, s)), n.remove();
		let l = q.getSvgContent().querySelectorAll("use").length, u = q.getDOMDocument().createElementNS(A.SVG, "g"), d = e.childNodes, f;
		for (f = 0; f < d.length; f++) u.append(d[f].cloneNode(!0));
		if (or()) {
			let e = De().querySelectorAll("linearGradient,radialGradient,pattern");
			for (let t = 0, n = e.length; n > t; t++) u.appendChild(e[t].cloneNode(!0));
		}
		i && u.setAttribute("transform", i);
		let p = e.parentNode;
		if (q.uniquifyElems(u), or()) {
			let e = De(), t = u.querySelectorAll("linearGradient,radialGradient,pattern");
			for (let n = 0, r = t.length; r > n; n++) e.appendChild(t[n]);
		}
		if (u.id = q.getNextId(), s && s.insertBefore(u, c), p) {
			if (!l) {
				let { nextSibling: t } = e;
				e.remove(), r.addSubCommand(new na(e, t, p));
			}
			r.addSubCommand(new ta(u));
		}
		q.setUseData(u), or() ? q.convertGradients(De()) : q.convertGradients(u), Ce(u, (e) => {
			try {
				Qi(e);
			} catch (e) {
				h("Error recalculating dimensions", e, "selected-elem");
			}
		});
		let m = u.querySelectorAll(q.getVisElems());
		Array.prototype.forEach.call(m, (e) => {
			e.id ||= q.getNextId();
		}), q.selectOnly([u]);
		let _ = va(u, !0);
		return _ && r.addSubCommand(_), q.addCommandToHistory(r), u;
	} else return g("Unexpected element to ungroup:", e, "selected-elem"), null;
}, ba = () => {
	let e = q.getSelectedElements(), t = q.getDataStorage(), n = e[0];
	if (!n) return;
	if (t.has(n, "gsvg") || t.has(n, "symbol")) {
		if (n = ya(n), !n) return;
	} else if (n.tagName === "use") {
		let e = Te(n);
		if (!e || !e.startsWith("#")) {
			g("Unexpected <use> without local reference:", n, "selected-elem");
			return;
		}
		let r = Ue(e.slice(1));
		if (!r) {
			g("Unexpected <use> without resolved reference:", n, "selected-elem");
			return;
		}
		if (t.put(n, "symbol", r), t.put(n, "ref", r), n = ya(n), !n) return;
	}
	let r = ce(n.parentNode, "a");
	if (r?.length && (n = r[0]), n.tagName === "g" || n.tagName === "a") {
		let e = new ea("Ungroup Elements"), t = va(n, !0);
		t && e.addSubCommand(t);
		let r = n.parentNode, i = n.nextSibling, a = Array(n.childNodes.length), o = 0;
		for (; n.firstChild;) {
			let t = n.firstChild, s = t.nextSibling, c = t.parentNode;
			if (t.tagName === "title") {
				let { nextSibling: n } = t;
				e.addSubCommand(new na(t, n, c)), t.remove();
				continue;
			}
			a[o++] = r.insertBefore(t, i), e.addSubCommand(new $i(t, s, c));
		}
		q.clearSelection();
		let s = n.nextSibling;
		n.remove(), e.addSubCommand(new na(n, s, r)), e.isEmpty() || q.addCommandToHistory(e), q.addToSelection(a);
	}
}, xa = (e, t) => {
	q.getSvgRoot().setAttribute("width", e), q.getSvgRoot().setAttribute("height", t);
	let n = q.getZoom(), r = document.getElementById("canvasBackground"), i = Number(q.getSvgContent().getAttribute("x")), a = Number(q.getSvgContent().getAttribute("y")), o = (e - q.contentW * n) / 2, s = (t - q.contentH * n) / 2;
	We(q.getSvgContent(), {
		width: q.contentW * n,
		height: q.contentH * n,
		x: o,
		y: s,
		viewBox: `0 0 ${q.contentW} ${q.contentH}`
	}), We(r, {
		width: q.getSvgContent().getAttribute("width"),
		height: q.getSvgContent().getAttribute("height"),
		x: o,
		y: s
	});
	let c = Ue("background_image");
	return c && We(c, {
		width: "100%",
		height: "100%"
	}), q.selectorManager.selectorParentGroup.setAttribute("transform", `translate(${o},${s})`), q.runExtensions("canvasUpdated", {
		new_x: o,
		new_y: s,
		old_x: i,
		old_y: a,
		d_x: o - i,
		d_y: s - a
	}), {
		x: o,
		y: s,
		old_x: i,
		old_y: a,
		d_x: o - i,
		d_y: s - a
	};
}, Sa = (e) => {
	let t = q.getSelectedElements(), n = q.getCurrentGroup(), r, i = t[0], a = !1, o = Le(n || q.getCurrentDrawing().getCurrentLayer());
	if (o.length) {
		if (!i) r = e ? o.length - 1 : 0, a = o[r];
		else {
			let t = o.length;
			for (; t--;) if (o[t] === i) {
				r = e ? t - 1 : t + 1, r >= o.length ? r = 0 : r < 0 && (r = o.length - 1), a = o[r];
				break;
			}
		}
		q.selectOnly([a], !0), q.call("selected", t);
	}
}, Ca = null, wa = (e) => {
	Ca = e;
}, Ta = (e) => !e || e.nodeType !== 1 ? null : e.querySelector("feGaussianBlur") || e.firstElementChild, Ea = (e) => {
	let t = Ca.getSelectedElements()[0];
	if (!t) return;
	let n = Ca.getFilter();
	if (n ||= Ca.getElement(`${t.id}_blur`), e === 0) Ca.changeSelectedAttributeNoUndo("filter", ""), Ca.setFilterHidden(!0);
	else {
		if (!n) {
			let r = Ca.addSVGElementsFromJson({
				element: "feGaussianBlur",
				attr: {
					in: "SourceGraphic",
					stdDeviation: e
				}
			});
			n = Ca.addSVGElementsFromJson({
				element: "filter",
				attr: { id: `${t.id}_blur` }
			}), n.append(r), Ca.findDefs().append(n);
		}
		(Ca.getFilterHidden() || !t.getAttribute("filter")) && (Ca.changeSelectedAttributeNoUndo("filter", `url(#${n.id})`), Ca.setFilterHidden(!1));
		let r = Ta(n);
		if (!r) return;
		Ca.changeSelectedAttributeNoUndo("stdDeviation", e, [r]), Ca.setBlurOffsets(n, e);
	}
}, Da = () => {
	let e = Ca.getCurCommand();
	if (!e) {
		Ca.setCurCommand(null), Ca.setFilter(null), Ca.setFilterHidden(!1);
		return;
	}
	let t = Ca.undoMgr.finishUndoableChange();
	t.isEmpty() || e.addSubCommand(t), e.isEmpty() || Ca.addCommandToHistory(e), Ca.setCurCommand(null), Ca.setFilter(null), Ca.setFilterHidden(!1);
}, Oa = (e, t) => {
	!e || e.nodeType !== 1 || (t = Number(t) || 0, t > 3 ? Ca.assignAttributes(e, {
		x: "-50%",
		y: "-50%",
		width: "200%",
		height: "200%"
	}, 100) : (e.removeAttribute("x"), e.removeAttribute("y"), e.removeAttribute("width"), e.removeAttribute("height")));
}, J = (e, t) => {
	let { InsertElementCommand: n, ChangeElementCommand: r, BatchCommand: i } = Ca.history, a = Ca.getSelectedElements();
	if (Ca.getCurCommand()) {
		Da();
		return;
	}
	let o = a[0];
	if (!o) return;
	let s = o.id, c = Ca.getElement(`${s}_blur`);
	Ca.setFilter(c), e = Number(e) || 0;
	let l = new i("Change blur");
	if (e === 0) {
		let e = o.getAttribute("filter");
		if (!e) return;
		let t = { filter: e };
		o.removeAttribute("filter"), l.addSubCommand(new r(o, t)), Ca.addCommandToHistory(l), Ca.setFilter(null), Ca.setFilterHidden(!0);
		return;
	}
	if (!c) {
		let t = Ca.addSVGElementsFromJson({
			element: "feGaussianBlur",
			attr: {
				in: "SourceGraphic",
				stdDeviation: e
			}
		});
		c = Ca.addSVGElementsFromJson({
			element: "filter",
			attr: { id: `${s}_blur` }
		}), c.append(t);
		let r = Ca.findDefs();
		r && r.ownerDocument === c.ownerDocument && r.append(c), Ca.setFilter(c), l.addSubCommand(new n(c));
	}
	let u = { filter: o.getAttribute("filter") };
	Ca.changeSelectedAttributeNoUndo("filter", `url(#${c.id})`), l.addSubCommand(new r(o, u)), Ca.setBlurOffsets(c, e), Ca.setCurCommand(l);
	let d = Ta(c);
	Ca.undoMgr.beginUndoableChange("stdDeviation", [d]), t && (Ca.setBlurNoUndo(e), Da());
}, ka = j(), Aa = [
	"font-family",
	"font-size",
	"font-stretch",
	"font-style",
	"font-weight"
], ja = [
	"class",
	"id",
	"display",
	"transform",
	"style"
], Ma = {
	a: [
		"clip-path",
		"clip-rule",
		"fill",
		"fill-opacity",
		"fill-rule",
		"filter",
		"href",
		"mask",
		"opacity",
		"stroke",
		"stroke-dasharray",
		"stroke-dashoffset",
		"stroke-linecap",
		"stroke-linejoin",
		"stroke-miterlimit",
		"stroke-opacity",
		"stroke-width",
		"systemLanguage",
		"xlink:href",
		"xlink:title"
	],
	circle: [
		"clip-path",
		"clip-rule",
		"cx",
		"cy",
		"enable-background",
		"fill",
		"fill-opacity",
		"fill-rule",
		"filter",
		"mask",
		"opacity",
		"r",
		"requiredFeatures",
		"stroke",
		"stroke-dasharray",
		"stroke-dashoffset",
		"stroke-linecap",
		"stroke-linejoin",
		"stroke-miterlimit",
		"stroke-opacity",
		"stroke-width",
		"systemLanguage"
	],
	clipPath: ["clipPathUnits"],
	defs: [],
	desc: [],
	ellipse: [
		"clip-path",
		"clip-rule",
		"cx",
		"cy",
		"fill",
		"fill-opacity",
		"fill-rule",
		"filter",
		"mask",
		"opacity",
		"requiredFeatures",
		"rx",
		"ry",
		"stroke",
		"stroke-dasharray",
		"stroke-dashoffset",
		"stroke-linecap",
		"stroke-linejoin",
		"stroke-miterlimit",
		"stroke-opacity",
		"stroke-width",
		"systemLanguage"
	],
	feBlend: ["in", "in2"],
	feColorMatrix: [
		"in",
		"type",
		"value",
		"result",
		"values"
	],
	feComposite: [
		"in",
		"operator",
		"result",
		"in2"
	],
	feFlood: [
		"flood-color",
		"in",
		"result",
		"flood-opacity"
	],
	feGaussianBlur: [
		"color-interpolation-filters",
		"in",
		"requiredFeatures",
		"stdDeviation",
		"result"
	],
	feMerge: [],
	feMergeNode: ["in"],
	feMorphology: [
		"in",
		"operator",
		"radius"
	],
	feOffset: [
		"dx",
		"in",
		"dy",
		"result"
	],
	filter: [
		"color-interpolation-filters",
		"filterRes",
		"filterUnits",
		"height",
		"href",
		"primitiveUnits",
		"requiredFeatures",
		"width",
		"x",
		"xlink:href",
		"y"
	],
	foreignObject: [
		"font-size",
		"height",
		"opacity",
		"requiredFeatures",
		"width",
		"x",
		"y"
	],
	g: [
		...Aa,
		"clip-path",
		"clip-rule",
		"fill",
		"fill-opacity",
		"fill-rule",
		"filter",
		"mask",
		"opacity",
		"requiredFeatures",
		"stroke",
		"stroke-dasharray",
		"stroke-dashoffset",
		"stroke-linecap",
		"stroke-linejoin",
		"stroke-miterlimit",
		"stroke-opacity",
		"stroke-width",
		"systemLanguage",
		"text-anchor"
	],
	image: [
		"clip-path",
		"clip-rule",
		"filter",
		"height",
		"mask",
		"opacity",
		"preserveAspectRatio",
		"requiredFeatures",
		"systemLanguage",
		"viewBox",
		"width",
		"x",
		"href",
		"xlink:href",
		"xlink:title",
		"y"
	],
	line: [
		"clip-path",
		"clip-rule",
		"fill",
		"fill-opacity",
		"fill-rule",
		"filter",
		"marker-end",
		"marker-mid",
		"marker-start",
		"mask",
		"opacity",
		"requiredFeatures",
		"stroke",
		"stroke-dasharray",
		"stroke-dashoffset",
		"stroke-linecap",
		"stroke-linejoin",
		"stroke-miterlimit",
		"stroke-opacity",
		"stroke-width",
		"systemLanguage",
		"x1",
		"x2",
		"y1",
		"y2"
	],
	linearGradient: [
		"gradientTransform",
		"gradientUnits",
		"requiredFeatures",
		"spreadMethod",
		"systemLanguage",
		"x1",
		"x2",
		"href",
		"xlink:href",
		"y1",
		"y2"
	],
	marker: [
		"markerHeight",
		"markerUnits",
		"markerWidth",
		"orient",
		"preserveAspectRatio",
		"refX",
		"refY",
		"se_type",
		"systemLanguage",
		"viewBox"
	],
	mask: [
		"height",
		"maskContentUnits",
		"maskUnits",
		"width",
		"x",
		"y"
	],
	metadata: [],
	path: [
		"clip-path",
		"clip-rule",
		"d",
		"enable-background",
		"fill",
		"fill-opacity",
		"fill-rule",
		"filter",
		"marker-end",
		"marker-mid",
		"marker-start",
		"mask",
		"opacity",
		"requiredFeatures",
		"stroke",
		"stroke-dasharray",
		"stroke-dashoffset",
		"stroke-linecap",
		"stroke-linejoin",
		"stroke-miterlimit",
		"stroke-opacity",
		"stroke-width",
		"systemLanguage"
	],
	pattern: [
		"height",
		"patternContentUnits",
		"patternTransform",
		"patternUnits",
		"requiredFeatures",
		"systemLanguage",
		"viewBox",
		"width",
		"x",
		"href",
		"xlink:href",
		"y"
	],
	polygon: /* @__PURE__ */ "clip-path.clip-rule.fill.fill-opacity.fill-rule.filter.marker-end.marker-mid.marker-start.mask.opacity.points.requiredFeatures.stroke.stroke-dasharray.stroke-dashoffset.stroke-linecap.stroke-linejoin.stroke-miterlimit.stroke-opacity.stroke-width.systemLanguage.sides.shape.edge.point.starRadiusMultiplier.r.radialshift.r2.orient.cx.cy".split("."),
	polyline: [
		"clip-path",
		"clip-rule",
		"fill",
		"fill-opacity",
		"fill-rule",
		"filter",
		"marker-end",
		"marker-mid",
		"marker-start",
		"mask",
		"opacity",
		"points",
		"requiredFeatures",
		"stroke",
		"stroke-dasharray",
		"stroke-dashoffset",
		"stroke-linecap",
		"stroke-linejoin",
		"stroke-miterlimit",
		"stroke-opacity",
		"stroke-width",
		"systemLanguage",
		"se:connector"
	],
	radialGradient: [
		"cx",
		"cy",
		"fx",
		"fy",
		"gradientTransform",
		"gradientUnits",
		"r",
		"requiredFeatures",
		"spreadMethod",
		"systemLanguage",
		"href",
		"xlink:href"
	],
	rect: [
		"clip-path",
		"clip-rule",
		"fill",
		"fill-opacity",
		"fill-rule",
		"filter",
		"height",
		"mask",
		"opacity",
		"requiredFeatures",
		"rx",
		"ry",
		"stroke",
		"stroke-dasharray",
		"stroke-dashoffset",
		"stroke-linecap",
		"stroke-linejoin",
		"stroke-miterlimit",
		"stroke-opacity",
		"stroke-width",
		"systemLanguage",
		"width",
		"x",
		"y"
	],
	stop: [
		"offset",
		"requiredFeatures",
		"stop-opacity",
		"systemLanguage",
		"stop-color",
		"gradientUnits",
		"gradientTransform"
	],
	style: ["type"],
	svg: [
		"clip-path",
		"clip-rule",
		"enable-background",
		"filter",
		"height",
		"mask",
		"preserveAspectRatio",
		"requiredFeatures",
		"systemLanguage",
		"version",
		"viewBox",
		"width",
		"x",
		"xmlns",
		"xmlns:se",
		"xmlns:xlink",
		"xmlns:oi",
		"oi:animations",
		"y",
		"stroke-linejoin",
		"fill-rule",
		"aria-label",
		"stroke-width",
		"fill-rule",
		"xml:space"
	],
	switch: ["requiredFeatures", "systemLanguage"],
	symbol: [
		...Aa,
		"fill",
		"fill-opacity",
		"fill-rule",
		"filter",
		"opacity",
		"overflow",
		"preserveAspectRatio",
		"requiredFeatures",
		"stroke",
		"stroke-dasharray",
		"stroke-dashoffset",
		"stroke-linecap",
		"stroke-linejoin",
		"stroke-miterlimit",
		"stroke-opacity",
		"stroke-width",
		"systemLanguage",
		"viewBox",
		"width",
		"height"
	],
	text: [
		...Aa,
		"clip-path",
		"clip-rule",
		"dominant-baseline",
		"fill",
		"fill-opacity",
		"fill-rule",
		"filter",
		"mask",
		"opacity",
		"requiredFeatures",
		"stroke",
		"stroke-dasharray",
		"stroke-dashoffset",
		"stroke-linecap",
		"stroke-linejoin",
		"stroke-miterlimit",
		"stroke-opacity",
		"stroke-width",
		"systemLanguage",
		"text-anchor",
		"letter-spacing",
		"word-spacing",
		"text-decoration",
		"textLength",
		"lengthAdjust",
		"x",
		"xml:space",
		"y"
	],
	textPath: [
		"dominant-baseline",
		"href",
		"method",
		"requiredFeatures",
		"spacing",
		"startOffset",
		"systemLanguage",
		"xlink:href"
	],
	title: [],
	tspan: [
		...Aa,
		"clip-path",
		"clip-rule",
		"dx",
		"dy",
		"dominant-baseline",
		"fill",
		"fill-opacity",
		"fill-rule",
		"filter",
		"mask",
		"opacity",
		"requiredFeatures",
		"rotate",
		"stroke",
		"stroke-dasharray",
		"stroke-dashoffset",
		"stroke-linecap",
		"stroke-linejoin",
		"stroke-miterlimit",
		"stroke-opacity",
		"stroke-width",
		"systemLanguage",
		"text-anchor",
		"textLength",
		"x",
		"xml:space",
		"y"
	],
	use: [
		"clip-path",
		"clip-rule",
		"fill",
		"fill-opacity",
		"fill-rule",
		"filter",
		"height",
		"href",
		"mask",
		"stroke",
		"stroke-dasharray",
		"stroke-dashoffset",
		"stroke-linecap",
		"stroke-linejoin",
		"stroke-miterlimit",
		"stroke-opacity",
		"stroke-width",
		"width",
		"x",
		"xlink:href",
		"y",
		"overflow"
	],
	feComponentTransfer: ["in", "result"],
	feFuncR: [
		"type",
		"tableValues",
		"slope",
		"intercept",
		"amplitude",
		"exponent",
		"offset"
	],
	feFuncG: [
		"type",
		"tableValues",
		"slope",
		"intercept",
		"amplitude",
		"exponent",
		"offset"
	],
	feFuncB: [
		"type",
		"tableValues",
		"slope",
		"intercept",
		"amplitude",
		"exponent",
		"offset"
	],
	feFuncA: [
		"type",
		"tableValues",
		"slope",
		"intercept",
		"amplitude",
		"exponent",
		"offset"
	],
	feConvolveMatrix: [
		"in",
		"order",
		"kernelMatrix",
		"divisor",
		"bias",
		"targetX",
		"targetY",
		"edgeMode",
		"kernelUnitLength",
		"preserveAlpha"
	],
	feDiffuseLighting: [
		"in",
		"surfaceScale",
		"diffuseConstant",
		"kernelUnitLength",
		"lighting-color"
	],
	feSpecularLighting: [
		"in",
		"surfaceScale",
		"specularConstant",
		"specularExponent",
		"kernelUnitLength",
		"lighting-color"
	],
	feDisplacementMap: [
		"in",
		"in2",
		"scale",
		"xChannelSelector",
		"yChannelSelector"
	],
	feTurbulence: [
		"baseFrequency",
		"numOctaves",
		"result",
		"seed",
		"stitchTiles",
		"type"
	],
	feTile: ["in"],
	annotation: ["encoding"],
	"annotation-xml": ["encoding"],
	maction: [
		"actiontype",
		"other",
		"selection"
	],
	math: ["xmlns"],
	menclose: ["notation"],
	merror: [],
	mfrac: ["linethickness"],
	mi: ["mathvariant"],
	mmultiscripts: [],
	mn: [],
	mo: [
		"fence",
		"lspace",
		"maxsize",
		"minsize",
		"rspace",
		"stretchy"
	],
	mover: [],
	mpadded: [
		"lspace",
		"width",
		"height",
		"depth",
		"voffset"
	],
	mphantom: [],
	mprescripts: [],
	mroot: [],
	mrow: [
		"href",
		"xlink:href",
		"xlink:type",
		"xmlns:xlink"
	],
	mspace: [
		"depth",
		"height",
		"width"
	],
	msqrt: [],
	mstyle: [
		"displaystyle",
		"mathbackground",
		"mathcolor",
		"mathvariant",
		"scriptlevel"
	],
	msub: [],
	msubsup: [],
	msup: [],
	mtable: [
		"align",
		"columnalign",
		"columnlines",
		"columnspacing",
		"displaystyle",
		"equalcolumns",
		"equalrows",
		"frame",
		"rowalign",
		"rowlines",
		"rowspacing",
		"width"
	],
	mtd: [
		"columnalign",
		"columnspan",
		"rowalign",
		"rowspan"
	],
	mtext: [],
	mtr: ["columnalign", "rowalign"],
	munder: [],
	munderover: [],
	none: [],
	semantics: [],
	div: [],
	p: [],
	li: [],
	pre: [],
	ol: [],
	ul: [],
	span: [],
	hr: [],
	br: [],
	h1: [],
	h2: [],
	h3: [],
	h4: [],
	h5: [],
	h6: []
};
for (let [e, t] of Object.entries(Ma)) Ma[e] = [...t, ...ja];
var Na = {};
for (let [e, t] of Object.entries(Ma)) {
	let n = {};
	for (let e of t) if (e.includes(":")) {
		let [t, r] = e.split(":");
		n[r] = A[t.toUpperCase()];
	} else n[e] = e === "xmlns" ? A.XMLNS : null;
	Na[e] = n;
}
var Pa = (e) => {
	if (e.nodeType === 3 && (e.nodeValue = e.nodeValue.trim(), e.nodeValue.length || e.remove()), e.nodeType !== 1) return;
	let t = e.ownerDocument, n = e.parentNode;
	if (!t || !n) return;
	let r = Ma[e.nodeName], i = Na[e.nodeName];
	if (r !== void 0) {
		let t = [], n = e.attributes.length;
		for (; n--;) {
			let a = e.attributes.item(n), o = a.nodeName, s = a.localName, c = a.namespaceURI;
			if (c !== i[s] && c !== A.XMLNS && !(c === A.XMLNS && ka[a.value]) && !(s === "href" && r.includes("href"))) if (o.startsWith("se:") || o.startsWith("oi:") || o.startsWith("data-")) {
				let e = o.startsWith("se:") ? A.SE : o.startsWith("oi:") ? A.OI : null;
				t.push([
					o,
					a.value,
					e
				]);
			} else g(`attribute ${o} in element ${e.nodeName} not in whitelist is removed: ${e.outerHTML}`, null, "sanitize"), e.removeAttributeNS(c, s);
			if (o === "style") {
				let t = a.value.split(";"), n = t.length;
				for (; n--;) {
					let [i, a] = t[n].split(":"), o = (i || "").trim(), s = (a || "").trim();
					r.includes(o) && e.setAttribute(o, s);
				}
				e.removeAttribute("style");
			}
		}
		let a = e.getAttributeNS(A.XLINK, "href");
		a && (e.setAttribute("href", a), e.removeAttributeNS(A.XLINK, "href")), Object.values(t).forEach(([t, n, r]) => {
			e.setAttributeNS(r, t, n);
		});
		let o = Te(e);
		if (o && [
			"filter",
			"linearGradient",
			"pattern",
			"radialGradient",
			"textPath",
			"use"
		].includes(e.nodeName) && o[0] !== "#" && (Ee(e, ""), g(`attribute href in element ${e.nodeName} pointing to a non-local reference (${o}) is removed: ${e.outerHTML}`, null, "sanitize"), e.removeAttributeNS(A.XLINK, "href"), e.removeAttribute("href")), e.nodeName === "use" && !Te(e)) {
			g(`element ${e.nodeName} without a xlink:href or href is removed: ${e.outerHTML}`, null, "sanitize"), e.remove();
			return;
		}
		if (e.nodeName === "use") {
			let t = Ve(Te(e));
			if (t) {
				let n = t.getAttribute("viewBox"), r = n ? n.split(/[\s,]+/).map(Number) : null, i = Number(t.getAttribute("width")), a = Number(t.getAttribute("height"));
				if (!e.hasAttribute("width")) {
					let t = r?.[2] || i;
					t && e.setAttribute("width", t);
				}
				if (!e.hasAttribute("height")) {
					let t = r?.[3] || a;
					t && e.setAttribute("height", t);
				}
			}
		}
		for ([
			"clip-path",
			"fill",
			"filter",
			"marker-end",
			"marker-mid",
			"marker-start",
			"mask",
			"stroke"
		].forEach((t) => {
			let n = e.getAttribute(t);
			n && (n = we(n), n && n[0] !== "#" && (e.setAttribute(t, ""), g(`attribute ${t} in element ${e.nodeName} pointing to a non-local reference (${n}) is removed: ${e.outerHTML}`, null, "sanitize"), e.removeAttribute(t)));
		}), n = e.childNodes.length; n--;) Pa(e.childNodes.item(n));
	} else {
		g(`element ${e.nodeName} not supported is removed: ${e.outerHTML}`, null, "sanitize");
		let t = [];
		for (; e.hasChildNodes();) t.push(n.insertBefore(e.firstChild, e));
		e.remove();
		let r = t.length;
		for (; r--;) Pa(t[r]);
	}
};
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/typeof.js
function Fa(e) {
	"@babel/helpers - typeof";
	return Fa = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, Fa(e);
}
var Ia = o((() => {}));
//#endregion
//#region node_modules/fflate/esm/browser.js
Ia();
var La = Uint8Array, Ra = Uint16Array, za = Int32Array, Ba = new La([
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	1,
	1,
	1,
	1,
	2,
	2,
	2,
	2,
	3,
	3,
	3,
	3,
	4,
	4,
	4,
	4,
	5,
	5,
	5,
	5,
	0,
	0,
	0,
	0
]), Va = new La([
	0,
	0,
	0,
	0,
	1,
	1,
	2,
	2,
	3,
	3,
	4,
	4,
	5,
	5,
	6,
	6,
	7,
	7,
	8,
	8,
	9,
	9,
	10,
	10,
	11,
	11,
	12,
	12,
	13,
	13,
	0,
	0
]), Ha = new La([
	16,
	17,
	18,
	0,
	8,
	7,
	9,
	6,
	10,
	5,
	11,
	4,
	12,
	3,
	13,
	2,
	14,
	1,
	15
]), Ua = function(e, t) {
	for (var n = new Ra(31), r = 0; r < 31; ++r) n[r] = t += 1 << e[r - 1];
	for (var i = new za(n[30]), r = 1; r < 30; ++r) for (var a = n[r]; a < n[r + 1]; ++a) i[a] = a - n[r] << 5 | r;
	return {
		b: n,
		r: i
	};
}, Wa = Ua(Ba, 2), Ga = Wa.b, Ka = Wa.r;
Ga[28] = 258, Ka[258] = 28;
var qa = Ua(Va, 0);
qa.b;
for (var Ja = qa.r, Ya = new Ra(32768), Xa = 0; Xa < 32768; ++Xa) {
	var Za = (Xa & 43690) >> 1 | (Xa & 21845) << 1;
	Za = (Za & 52428) >> 2 | (Za & 13107) << 2, Za = (Za & 61680) >> 4 | (Za & 3855) << 4, Ya[Xa] = ((Za & 65280) >> 8 | (Za & 255) << 8) >> 1;
}
for (var Qa = (function(e, t, n) {
	for (var r = e.length, i = 0, a = new Ra(t); i < r; ++i) e[i] && ++a[e[i] - 1];
	var o = new Ra(t);
	for (i = 1; i < t; ++i) o[i] = o[i - 1] + a[i - 1] << 1;
	var s;
	if (n) {
		s = new Ra(1 << t);
		var c = 15 - t;
		for (i = 0; i < r; ++i) if (e[i]) for (var l = i << 4 | e[i], u = t - e[i], d = o[e[i] - 1]++ << u, f = d | (1 << u) - 1; d <= f; ++d) s[Ya[d] >> c] = l;
	} else for (s = new Ra(r), i = 0; i < r; ++i) e[i] && (s[i] = Ya[o[e[i] - 1]++] >> 15 - e[i]);
	return s;
}), $a = new La(288), Xa = 0; Xa < 144; ++Xa) $a[Xa] = 8;
for (var Xa = 144; Xa < 256; ++Xa) $a[Xa] = 9;
for (var Xa = 256; Xa < 280; ++Xa) $a[Xa] = 7;
for (var Xa = 280; Xa < 288; ++Xa) $a[Xa] = 8;
for (var eo = new La(32), Xa = 0; Xa < 32; ++Xa) eo[Xa] = 5;
var to = /*#__PURE__*/ Qa($a, 9, 0), no = /*#__PURE__*/ Qa(eo, 5, 0), ro = function(e) {
	return (e + 7) / 8 | 0;
}, io = function(e, t, n) {
	return (t == null || t < 0) && (t = 0), (n == null || n > e.length) && (n = e.length), new La(e.subarray(t, n));
}, ao = function(e, t, n) {
	n <<= t & 7;
	var r = t / 8 | 0;
	e[r] |= n, e[r + 1] |= n >> 8;
}, oo = function(e, t, n) {
	n <<= t & 7;
	var r = t / 8 | 0;
	e[r] |= n, e[r + 1] |= n >> 8, e[r + 2] |= n >> 16;
}, so = function(e, t) {
	for (var n = [], r = 0; r < e.length; ++r) e[r] && n.push({
		s: r,
		f: e[r]
	});
	var i = n.length, a = n.slice();
	if (!i) return {
		t: ho,
		l: 0
	};
	if (i == 1) {
		var o = new La(n[0].s + 1);
		return o[n[0].s] = 1, {
			t: o,
			l: 1
		};
	}
	n.sort(function(e, t) {
		return e.f - t.f;
	}), n.push({
		s: -1,
		f: 25001
	});
	var s = n[0], c = n[1], l = 0, u = 1, d = 2;
	for (n[0] = {
		s: -1,
		f: s.f + c.f,
		l: s,
		r: c
	}; u != i - 1;) s = n[n[l].f < n[d].f ? l++ : d++], c = n[l != u && n[l].f < n[d].f ? l++ : d++], n[u++] = {
		s: -1,
		f: s.f + c.f,
		l: s,
		r: c
	};
	for (var f = a[0].s, r = 1; r < i; ++r) a[r].s > f && (f = a[r].s);
	var p = new Ra(f + 1), m = co(n[u - 1], p, 0);
	if (m > t) {
		var r = 0, h = 0, g = m - t, _ = 1 << g;
		for (a.sort(function(e, t) {
			return p[t.s] - p[e.s] || e.f - t.f;
		}); r < i; ++r) {
			var v = a[r].s;
			if (p[v] > t) h += _ - (1 << m - p[v]), p[v] = t;
			else break;
		}
		for (h >>= g; h > 0;) {
			var y = a[r].s;
			p[y] < t ? h -= 1 << t - p[y]++ - 1 : ++r;
		}
		for (; r >= 0 && h; --r) {
			var b = a[r].s;
			p[b] == t && (--p[b], ++h);
		}
		m = t;
	}
	return {
		t: new La(p),
		l: m
	};
}, co = function(e, t, n) {
	return e.s == -1 ? Math.max(co(e.l, t, n + 1), co(e.r, t, n + 1)) : t[e.s] = n;
}, lo = function(e) {
	for (var t = e.length; t && !e[--t];);
	for (var n = new Ra(++t), r = 0, i = e[0], a = 1, o = function(e) {
		n[r++] = e;
	}, s = 1; s <= t; ++s) if (e[s] == i && s != t) ++a;
	else {
		if (!i && a > 2) {
			for (; a > 138; a -= 138) o(32754);
			a > 2 && (o(a > 10 ? a - 11 << 5 | 28690 : a - 3 << 5 | 12305), a = 0);
		} else if (a > 3) {
			for (o(i), --a; a > 6; a -= 6) o(8304);
			a > 2 && (o(a - 3 << 5 | 8208), a = 0);
		}
		for (; a--;) o(i);
		a = 1, i = e[s];
	}
	return {
		c: n.subarray(0, r),
		n: t
	};
}, uo = function(e, t) {
	for (var n = 0, r = 0; r < t.length; ++r) n += e[r] * t[r];
	return n;
}, fo = function(e, t, n) {
	var r = n.length, i = ro(t + 2);
	e[i] = r & 255, e[i + 1] = r >> 8, e[i + 2] = e[i] ^ 255, e[i + 3] = e[i + 1] ^ 255;
	for (var a = 0; a < r; ++a) e[i + a + 4] = n[a];
	return (i + 4 + r) * 8;
}, po = function(e, t, n, r, i, a, o, s, c, l, u) {
	ao(t, u++, n), ++i[256];
	for (var d = so(i, 15), f = d.t, p = d.l, m = so(a, 15), h = m.t, g = m.l, _ = lo(f), v = _.c, y = _.n, b = lo(h), x = b.c, S = b.n, C = new Ra(19), w = 0; w < v.length; ++w) ++C[v[w] & 31];
	for (var w = 0; w < x.length; ++w) ++C[x[w] & 31];
	for (var T = so(C, 7), E = T.t, D = T.l, O = 19; O > 4 && !E[Ha[O - 1]]; --O);
	var k = l + 5 << 3, A = uo(i, $a) + uo(a, eo) + o, j = uo(i, f) + uo(a, h) + o + 14 + 3 * O + uo(C, E) + 2 * C[16] + 3 * C[17] + 7 * C[18];
	if (c >= 0 && k <= A && k <= j) return fo(t, u, e.subarray(c, c + l));
	var M, N, P, F;
	if (ao(t, u, 1 + (j < A)), u += 2, j < A) {
		M = Qa(f, p, 0), N = f, P = Qa(h, g, 0), F = h;
		var I = Qa(E, D, 0);
		ao(t, u, y - 257), ao(t, u + 5, S - 1), ao(t, u + 10, O - 4), u += 14;
		for (var w = 0; w < O; ++w) ao(t, u + 3 * w, E[Ha[w]]);
		u += 3 * O;
		for (var ee = [v, x], L = 0; L < 2; ++L) for (var R = ee[L], w = 0; w < R.length; ++w) {
			var te = R[w] & 31;
			ao(t, u, I[te]), u += E[te], te > 15 && (ao(t, u, R[w] >> 5 & 127), u += R[w] >> 12);
		}
	} else M = to, N = $a, P = no, F = eo;
	for (var w = 0; w < s; ++w) {
		var z = r[w];
		if (z > 255) {
			var te = z >> 18 & 31;
			oo(t, u, M[te + 257]), u += N[te + 257], te > 7 && (ao(t, u, z >> 23 & 31), u += Ba[te]);
			var ne = z & 31;
			oo(t, u, P[ne]), u += F[ne], ne > 3 && (oo(t, u, z >> 5 & 8191), u += Va[ne]);
		} else oo(t, u, M[z]), u += N[z];
	}
	return oo(t, u, M[256]), u + N[256];
}, mo = /*#__PURE__*/ new za([
	65540,
	131080,
	131088,
	131104,
	262176,
	1048704,
	1048832,
	2114560,
	2117632
]), ho = /*#__PURE__*/ new La(0), go = function(e, t, n, r, i, a) {
	var o = a.z || e.length, s = new La(r + o + 5 * (1 + Math.ceil(o / 7e3)) + i), c = s.subarray(r, s.length - i), l = a.l, u = (a.r || 0) & 7;
	if (t) {
		u && (c[0] = a.r >> 3);
		for (var d = mo[t - 1], f = d >> 13, p = d & 8191, m = (1 << n) - 1, h = a.p || new Ra(32768), g = a.h || new Ra(m + 1), _ = Math.ceil(n / 3), v = 2 * _, y = function(t) {
			return (e[t] ^ e[t + 1] << _ ^ e[t + 2] << v) & m;
		}, b = new za(25e3), x = new Ra(288), S = new Ra(32), C = 0, w = 0, T = a.i || 0, E = 0, D = a.w || 0, O = 0; T + 2 < o; ++T) {
			var k = y(T), A = T & 32767, j = g[k];
			if (h[A] = j, g[k] = A, D <= T) {
				var M = o - T;
				if ((C > 7e3 || E > 24576) && (M > 423 || !l)) {
					u = po(e, c, 0, b, x, S, w, E, O, T - O, u), E = C = w = 0, O = T;
					for (var N = 0; N < 286; ++N) x[N] = 0;
					for (var N = 0; N < 30; ++N) S[N] = 0;
				}
				var P = 2, F = 0, I = p, ee = A - j & 32767;
				if (M > 2 && k == y(T - ee)) for (var L = Math.min(f, M) - 1, R = Math.min(32767, T), te = Math.min(258, M); ee <= R && --I && A != j;) {
					if (e[T + P] == e[T + P - ee]) {
						for (var z = 0; z < te && e[T + z] == e[T + z - ee]; ++z);
						if (z > P) {
							if (P = z, F = ee, z > L) break;
							for (var ne = Math.min(ee, z - 2), re = 0, N = 0; N < ne; ++N) {
								var ie = T - ee + N & 32767, ae = ie - h[ie] & 32767;
								ae > re && (re = ae, j = ie);
							}
						}
					}
					A = j, j = h[A], ee += A - j & 32767;
				}
				if (F) {
					b[E++] = 268435456 | Ka[P] << 18 | Ja[F];
					var B = Ka[P] & 31, oe = Ja[F] & 31;
					w += Ba[B] + Va[oe], ++x[257 + B], ++S[oe], D = T + P, ++C;
				} else b[E++] = e[T], ++x[e[T]];
			}
		}
		for (T = Math.max(T, D); T < o; ++T) b[E++] = e[T], ++x[e[T]];
		u = po(e, c, l, b, x, S, w, E, O, T - O, u), l || (a.r = u & 7 | c[u / 8 | 0] << 3, u -= 7, a.h = g, a.p = h, a.i = T, a.w = D);
	} else {
		for (var T = a.w || 0; T < o + l; T += 65535) {
			var se = T + 65535;
			se >= o && (c[u / 8 | 0] = l, se = o), u = fo(c, u + 1, e.subarray(T, se));
		}
		a.i = o;
	}
	return io(s, 0, r + ro(u) + i);
}, _o = function() {
	var e = 1, t = 0;
	return {
		p: function(n) {
			for (var r = e, i = t, a = n.length | 0, o = 0; o != a;) {
				for (var s = Math.min(o + 2655, a); o < s; ++o) i += r += n[o];
				r = (r & 65535) + 15 * (r >> 16), i = (i & 65535) + 15 * (i >> 16);
			}
			e = r, t = i;
		},
		d: function() {
			return e %= 65521, t %= 65521, (e & 255) << 24 | (e & 65280) << 8 | (t & 255) << 8 | t >> 8;
		}
	};
}, vo = function(e, t, n, r, i) {
	if (!i && (i = { l: 1 }, t.dictionary)) {
		var a = t.dictionary.subarray(-32768), o = new La(a.length + e.length);
		o.set(a), o.set(e, a.length), e = o, i.w = a.length;
	}
	return go(e, t.level == null ? 6 : t.level, t.mem == null ? i.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(e.length))) * 1.5) : 20 : 12 + t.mem, n, r, i);
}, yo = function(e, t, n) {
	for (; n; ++t) e[t] = n, n >>>= 8;
}, bo = function(e, t) {
	var n = t.level, r = n == 0 ? 0 : n < 6 ? 1 : n == 9 ? 3 : 2;
	if (e[0] = 120, e[1] = r << 6 | (t.dictionary && 32), e[1] |= 31 - (e[0] << 8 | e[1]) % 31, t.dictionary) {
		var i = _o();
		i.p(t.dictionary), yo(e, 2, i.d());
	}
};
function xo(e, t) {
	t ||= {};
	var n = _o();
	n.p(e);
	var r = vo(e, t, t.dictionary ? 6 : 2, 4);
	return bo(r, t), yo(r, r.length - 4, n.d()), r;
}
var So = typeof TextDecoder < "u" && /*#__PURE__*/ new TextDecoder();
try {
	So.decode(ho, { stream: !0 });
} catch {}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function Co(e) {
	if (Array.isArray(e)) return e;
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function wo(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r, i, a, o, s = [], c = !0, l = !1;
		try {
			if (a = (n = n.call(e)).next, t === 0) {
				if (Object(n) !== n) return;
				c = !1;
			} else for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
		} catch (e) {
			l = !0, i = e;
		} finally {
			try {
				if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
			} finally {
				if (l) throw i;
			}
		}
		return s;
	}
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function To(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
function Eo(e, t) {
	if (e) {
		if (typeof e == "string") return To(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? To(e, t) : void 0;
	}
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function Do() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/slicedToArray.js
function Oo(e, t) {
	return Co(e) || wo(e, t) || Eo(e, t) || Do();
}
//#endregion
//#region node_modules/iobuffer/lib-esm/text.js
function ko(e, t = "utf8") {
	return new TextDecoder(t).decode(e);
}
var Ao = new TextEncoder();
function jo(e) {
	return Ao.encode(e);
}
//#endregion
//#region node_modules/iobuffer/lib-esm/IOBuffer.js
var Mo = 1024 * 8, No = (() => {
	let e = /* @__PURE__ */ new Uint8Array(4), t = new Uint32Array(e.buffer);
	return !((t[0] = 1) & e[0]);
})(), Po = {
	int8: globalThis.Int8Array,
	uint8: globalThis.Uint8Array,
	int16: globalThis.Int16Array,
	uint16: globalThis.Uint16Array,
	int32: globalThis.Int32Array,
	uint32: globalThis.Uint32Array,
	uint64: globalThis.BigUint64Array,
	int64: globalThis.BigInt64Array,
	float32: globalThis.Float32Array,
	float64: globalThis.Float64Array
}, Fo = class e {
	buffer;
	byteLength;
	byteOffset;
	length;
	offset;
	lastWrittenByte;
	littleEndian;
	_data;
	_mark;
	_marks;
	constructor(t = Mo, n = {}) {
		let r = !1;
		typeof t == "number" ? t = new ArrayBuffer(t) : (r = !0, this.lastWrittenByte = t.byteLength);
		let i = n.offset ? n.offset >>> 0 : 0, a = t.byteLength - i, o = i;
		(ArrayBuffer.isView(t) || t instanceof e) && (t.byteLength !== t.buffer.byteLength && (o = t.byteOffset + i), t = t.buffer), r ? this.lastWrittenByte = a : this.lastWrittenByte = 0, this.buffer = t, this.length = a, this.byteLength = a, this.byteOffset = o, this.offset = 0, this.littleEndian = !0, this._data = new DataView(this.buffer, o, a), this._mark = 0, this._marks = [];
	}
	available(e = 1) {
		return this.offset + e <= this.length;
	}
	isLittleEndian() {
		return this.littleEndian;
	}
	setLittleEndian() {
		return this.littleEndian = !0, this;
	}
	isBigEndian() {
		return !this.littleEndian;
	}
	setBigEndian() {
		return this.littleEndian = !1, this;
	}
	skip(e = 1) {
		return this.offset += e, this;
	}
	back(e = 1) {
		return this.offset -= e, this;
	}
	seek(e) {
		return this.offset = e, this;
	}
	mark() {
		return this._mark = this.offset, this;
	}
	reset() {
		return this.offset = this._mark, this;
	}
	pushMark() {
		return this._marks.push(this.offset), this;
	}
	popMark() {
		let e = this._marks.pop();
		if (e === void 0) throw Error("Mark stack empty");
		return this.seek(e), this;
	}
	rewind() {
		return this.offset = 0, this;
	}
	ensureAvailable(e = 1) {
		if (!this.available(e)) {
			let t = (this.offset + e) * 2, n = new Uint8Array(t);
			n.set(new Uint8Array(this.buffer)), this.buffer = n.buffer, this.length = t, this.byteLength = t, this._data = new DataView(this.buffer);
		}
		return this;
	}
	readBoolean() {
		return this.readUint8() !== 0;
	}
	readInt8() {
		return this._data.getInt8(this.offset++);
	}
	readUint8() {
		return this._data.getUint8(this.offset++);
	}
	readByte() {
		return this.readUint8();
	}
	readBytes(e = 1) {
		return this.readArray(e, "uint8");
	}
	readArray(e, t) {
		let n = Po[t].BYTES_PER_ELEMENT * e, r = this.byteOffset + this.offset, i = this.buffer.slice(r, r + n);
		if (this.littleEndian === No && t !== "uint8" && t !== "int8") {
			let e = new Uint8Array(this.buffer.slice(r, r + n));
			e.reverse();
			let i = new Po[t](e.buffer);
			return this.offset += n, i.reverse(), i;
		}
		let a = new Po[t](i);
		return this.offset += n, a;
	}
	readInt16() {
		let e = this._data.getInt16(this.offset, this.littleEndian);
		return this.offset += 2, e;
	}
	readUint16() {
		let e = this._data.getUint16(this.offset, this.littleEndian);
		return this.offset += 2, e;
	}
	readInt32() {
		let e = this._data.getInt32(this.offset, this.littleEndian);
		return this.offset += 4, e;
	}
	readUint32() {
		let e = this._data.getUint32(this.offset, this.littleEndian);
		return this.offset += 4, e;
	}
	readFloat32() {
		let e = this._data.getFloat32(this.offset, this.littleEndian);
		return this.offset += 4, e;
	}
	readFloat64() {
		let e = this._data.getFloat64(this.offset, this.littleEndian);
		return this.offset += 8, e;
	}
	readBigInt64() {
		let e = this._data.getBigInt64(this.offset, this.littleEndian);
		return this.offset += 8, e;
	}
	readBigUint64() {
		let e = this._data.getBigUint64(this.offset, this.littleEndian);
		return this.offset += 8, e;
	}
	readChar() {
		return String.fromCharCode(this.readInt8());
	}
	readChars(e = 1) {
		let t = "";
		for (let n = 0; n < e; n++) t += this.readChar();
		return t;
	}
	readUtf8(e = 1) {
		return ko(this.readBytes(e));
	}
	decodeText(e = 1, t = "utf8") {
		return ko(this.readBytes(e), t);
	}
	writeBoolean(e) {
		return this.writeUint8(e ? 255 : 0), this;
	}
	writeInt8(e) {
		return this.ensureAvailable(1), this._data.setInt8(this.offset++, e), this._updateLastWrittenByte(), this;
	}
	writeUint8(e) {
		return this.ensureAvailable(1), this._data.setUint8(this.offset++, e), this._updateLastWrittenByte(), this;
	}
	writeByte(e) {
		return this.writeUint8(e);
	}
	writeBytes(e) {
		this.ensureAvailable(e.length);
		for (let t = 0; t < e.length; t++) this._data.setUint8(this.offset++, e[t]);
		return this._updateLastWrittenByte(), this;
	}
	writeInt16(e) {
		return this.ensureAvailable(2), this._data.setInt16(this.offset, e, this.littleEndian), this.offset += 2, this._updateLastWrittenByte(), this;
	}
	writeUint16(e) {
		return this.ensureAvailable(2), this._data.setUint16(this.offset, e, this.littleEndian), this.offset += 2, this._updateLastWrittenByte(), this;
	}
	writeInt32(e) {
		return this.ensureAvailable(4), this._data.setInt32(this.offset, e, this.littleEndian), this.offset += 4, this._updateLastWrittenByte(), this;
	}
	writeUint32(e) {
		return this.ensureAvailable(4), this._data.setUint32(this.offset, e, this.littleEndian), this.offset += 4, this._updateLastWrittenByte(), this;
	}
	writeFloat32(e) {
		return this.ensureAvailable(4), this._data.setFloat32(this.offset, e, this.littleEndian), this.offset += 4, this._updateLastWrittenByte(), this;
	}
	writeFloat64(e) {
		return this.ensureAvailable(8), this._data.setFloat64(this.offset, e, this.littleEndian), this.offset += 8, this._updateLastWrittenByte(), this;
	}
	writeBigInt64(e) {
		return this.ensureAvailable(8), this._data.setBigInt64(this.offset, e, this.littleEndian), this.offset += 8, this._updateLastWrittenByte(), this;
	}
	writeBigUint64(e) {
		return this.ensureAvailable(8), this._data.setBigUint64(this.offset, e, this.littleEndian), this.offset += 8, this._updateLastWrittenByte(), this;
	}
	writeChar(e) {
		return this.writeUint8(e.charCodeAt(0));
	}
	writeChars(e) {
		for (let t = 0; t < e.length; t++) this.writeUint8(e.charCodeAt(t));
		return this;
	}
	writeUtf8(e) {
		return this.writeBytes(jo(e));
	}
	toArray() {
		return new Uint8Array(this.buffer, this.byteOffset, this.lastWrittenByte);
	}
	getWrittenByteLength() {
		return this.lastWrittenByte - this.byteOffset;
	}
	_updateLastWrittenByte() {
		this.offset > this.lastWrittenByte && (this.lastWrittenByte = this.offset);
	}
}, Io = 4, Lo = 0, Ro = 1, zo = 2;
function Bo(e) {
	let t = e.length;
	for (; --t >= 0;) e[t] = 0;
}
var Vo = 0, Ho = 1, Uo = 2, Wo = 29, Go = 256, Ko = 286, qo = 30, Jo = 19, Yo = 573, Xo = 15, Zo = 16, Qo = 7, $o = 256, es = 16, ts = 17, ns = 18, rs = new Uint8Array([
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	1,
	1,
	1,
	1,
	2,
	2,
	2,
	2,
	3,
	3,
	3,
	3,
	4,
	4,
	4,
	4,
	5,
	5,
	5,
	5,
	0
]), is = new Uint8Array([
	0,
	0,
	0,
	0,
	1,
	1,
	2,
	2,
	3,
	3,
	4,
	4,
	5,
	5,
	6,
	6,
	7,
	7,
	8,
	8,
	9,
	9,
	10,
	10,
	11,
	11,
	12,
	12,
	13,
	13
]), as = new Uint8Array([
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	2,
	3,
	7
]), os = new Uint8Array([
	16,
	17,
	18,
	0,
	8,
	7,
	9,
	6,
	10,
	5,
	11,
	4,
	12,
	3,
	13,
	2,
	14,
	1,
	15
]), ss = 512, cs = Array(288 * 2);
Bo(cs);
var ls = Array(qo * 2);
Bo(ls);
var us = Array(ss);
Bo(us);
var ds = Array(256);
Bo(ds);
var fs = Array(Wo);
Bo(fs);
var ps = Array(qo);
Bo(ps);
function ms(e, t, n, r, i) {
	this.static_tree = e, this.extra_bits = t, this.extra_base = n, this.elems = r, this.max_length = i, this.has_stree = e && e.length;
}
var hs, gs, _s;
function vs(e, t) {
	this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
}
var ys = (e) => e < 256 ? us[e] : us[256 + (e >>> 7)], bs = (e, t) => {
	e.pending_buf[e.pending++] = t & 255, e.pending_buf[e.pending++] = t >>> 8 & 255;
}, xs = (e, t, n) => {
	e.bi_valid > Zo - n ? (e.bi_buf |= t << e.bi_valid & 65535, bs(e, e.bi_buf), e.bi_buf = t >> Zo - e.bi_valid, e.bi_valid += n - Zo) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += n);
}, Ss = (e, t, n) => {
	xs(e, n[t * 2], n[t * 2 + 1]);
}, Cs = (e, t) => {
	let n = 0;
	do
		n |= e & 1, e >>>= 1, n <<= 1;
	while (--t > 0);
	return n >>> 1;
}, ws = (e) => {
	e.bi_valid === 16 ? (bs(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : e.bi_valid >= 8 && (e.pending_buf[e.pending++] = e.bi_buf & 255, e.bi_buf >>= 8, e.bi_valid -= 8);
}, Ts = (e, t) => {
	let n = t.dyn_tree, r = t.max_code, i = t.stat_desc.static_tree, a = t.stat_desc.has_stree, o = t.stat_desc.extra_bits, s = t.stat_desc.extra_base, c = t.stat_desc.max_length, l, u, d, f, p, m, h = 0;
	for (f = 0; f <= Xo; f++) e.bl_count[f] = 0;
	for (n[e.heap[e.heap_max] * 2 + 1] = 0, l = e.heap_max + 1; l < Yo; l++) u = e.heap[l], f = n[n[u * 2 + 1] * 2 + 1] + 1, f > c && (f = c, h++), n[u * 2 + 1] = f, !(u > r) && (e.bl_count[f]++, p = 0, u >= s && (p = o[u - s]), m = n[u * 2], e.opt_len += m * (f + p), a && (e.static_len += m * (i[u * 2 + 1] + p)));
	if (h !== 0) {
		do {
			for (f = c - 1; e.bl_count[f] === 0;) f--;
			e.bl_count[f]--, e.bl_count[f + 1] += 2, e.bl_count[c]--, h -= 2;
		} while (h > 0);
		for (f = c; f !== 0; f--) for (u = e.bl_count[f]; u !== 0;) d = e.heap[--l], !(d > r) && (n[d * 2 + 1] !== f && (e.opt_len += (f - n[d * 2 + 1]) * n[d * 2], n[d * 2 + 1] = f), u--);
	}
}, Es = (e, t, n) => {
	let r = Array(16), i = 0, a, o;
	for (a = 1; a <= Xo; a++) i = i + n[a - 1] << 1, r[a] = i;
	for (o = 0; o <= t; o++) {
		let t = e[o * 2 + 1];
		t !== 0 && (e[o * 2] = Cs(r[t]++, t));
	}
}, Ds = () => {
	let e, t, n, r, i, a = Array(16);
	for (n = 0, r = 0; r < Wo - 1; r++) for (fs[r] = n, e = 0; e < 1 << rs[r]; e++) ds[n++] = r;
	for (ds[n - 1] = r, i = 0, r = 0; r < 16; r++) for (ps[r] = i, e = 0; e < 1 << is[r]; e++) us[i++] = r;
	for (i >>= 7; r < qo; r++) for (ps[r] = i << 7, e = 0; e < 1 << is[r] - 7; e++) us[256 + i++] = r;
	for (t = 0; t <= Xo; t++) a[t] = 0;
	for (e = 0; e <= 143;) cs[e * 2 + 1] = 8, e++, a[8]++;
	for (; e <= 255;) cs[e * 2 + 1] = 9, e++, a[9]++;
	for (; e <= 279;) cs[e * 2 + 1] = 7, e++, a[7]++;
	for (; e <= 287;) cs[e * 2 + 1] = 8, e++, a[8]++;
	for (Es(cs, 287, a), e = 0; e < qo; e++) ls[e * 2 + 1] = 5, ls[e * 2] = Cs(e, 5);
	hs = new ms(cs, rs, 257, Ko, Xo), gs = new ms(ls, is, 0, qo, Xo), _s = new ms([], as, 0, Jo, Qo);
}, Os = (e) => {
	let t;
	for (t = 0; t < Ko; t++) e.dyn_ltree[t * 2] = 0;
	for (t = 0; t < qo; t++) e.dyn_dtree[t * 2] = 0;
	for (t = 0; t < Jo; t++) e.bl_tree[t * 2] = 0;
	e.dyn_ltree[$o * 2] = 1, e.opt_len = e.static_len = 0, e.sym_next = e.matches = 0;
}, ks = (e) => {
	e.bi_valid > 8 ? bs(e, e.bi_buf) : e.bi_valid > 0 && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
}, As = (e, t, n, r) => {
	let i = t * 2, a = n * 2;
	return e[i] < e[a] || e[i] === e[a] && r[t] <= r[n];
}, js = (e, t, n) => {
	let r = e.heap[n], i = n << 1;
	for (; i <= e.heap_len && (i < e.heap_len && As(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !As(t, r, e.heap[i], e.depth));) e.heap[n] = e.heap[i], n = i, i <<= 1;
	e.heap[n] = r;
}, Ms = (e, t, n) => {
	let r, i, a = 0, o, s;
	if (e.sym_next !== 0) do
		r = e.pending_buf[e.sym_buf + a++] & 255, r += (e.pending_buf[e.sym_buf + a++] & 255) << 8, i = e.pending_buf[e.sym_buf + a++], r === 0 ? Ss(e, i, t) : (o = ds[i], Ss(e, o + Go + 1, t), s = rs[o], s !== 0 && (i -= fs[o], xs(e, i, s)), r--, o = ys(r), Ss(e, o, n), s = is[o], s !== 0 && (r -= ps[o], xs(e, r, s)));
	while (a < e.sym_next);
	Ss(e, $o, t);
}, Ns = (e, t) => {
	let n = t.dyn_tree, r = t.stat_desc.static_tree, i = t.stat_desc.has_stree, a = t.stat_desc.elems, o, s, c = -1, l;
	for (e.heap_len = 0, e.heap_max = Yo, o = 0; o < a; o++) n[o * 2] === 0 ? n[o * 2 + 1] = 0 : (e.heap[++e.heap_len] = c = o, e.depth[o] = 0);
	for (; e.heap_len < 2;) l = e.heap[++e.heap_len] = c < 2 ? ++c : 0, n[l * 2] = 1, e.depth[l] = 0, e.opt_len--, i && (e.static_len -= r[l * 2 + 1]);
	for (t.max_code = c, o = e.heap_len >> 1; o >= 1; o--) js(e, n, o);
	l = a;
	do
		o = e.heap[1], e.heap[1] = e.heap[e.heap_len--], js(e, n, 1), s = e.heap[1], e.heap[--e.heap_max] = o, e.heap[--e.heap_max] = s, n[l * 2] = n[o * 2] + n[s * 2], e.depth[l] = (e.depth[o] >= e.depth[s] ? e.depth[o] : e.depth[s]) + 1, n[o * 2 + 1] = n[s * 2 + 1] = l, e.heap[1] = l++, js(e, n, 1);
	while (e.heap_len >= 2);
	e.heap[--e.heap_max] = e.heap[1], Ts(e, t), Es(n, c, e.bl_count);
}, Ps = (e, t, n) => {
	let r, i = -1, a, o = t[1], s = 0, c = 7, l = 4;
	for (o === 0 && (c = 138, l = 3), t[(n + 1) * 2 + 1] = 65535, r = 0; r <= n; r++) a = o, o = t[(r + 1) * 2 + 1], !(++s < c && a === o) && (s < l ? e.bl_tree[a * 2] += s : a === 0 ? s <= 10 ? e.bl_tree[ts * 2]++ : e.bl_tree[ns * 2]++ : (a !== i && e.bl_tree[a * 2]++, e.bl_tree[es * 2]++), s = 0, i = a, o === 0 ? (c = 138, l = 3) : a === o ? (c = 6, l = 3) : (c = 7, l = 4));
}, Fs = (e, t, n) => {
	let r, i = -1, a, o = t[1], s = 0, c = 7, l = 4;
	for (o === 0 && (c = 138, l = 3), r = 0; r <= n; r++) if (a = o, o = t[(r + 1) * 2 + 1], !(++s < c && a === o)) {
		if (s < l) do
			Ss(e, a, e.bl_tree);
		while (--s !== 0);
		else a === 0 ? s <= 10 ? (Ss(e, ts, e.bl_tree), xs(e, s - 3, 3)) : (Ss(e, ns, e.bl_tree), xs(e, s - 11, 7)) : (a !== i && (Ss(e, a, e.bl_tree), s--), Ss(e, es, e.bl_tree), xs(e, s - 3, 2));
		s = 0, i = a, o === 0 ? (c = 138, l = 3) : a === o ? (c = 6, l = 3) : (c = 7, l = 4);
	}
}, Is = (e) => {
	let t;
	for (Ps(e, e.dyn_ltree, e.l_desc.max_code), Ps(e, e.dyn_dtree, e.d_desc.max_code), Ns(e, e.bl_desc), t = Jo - 1; t >= 3 && e.bl_tree[os[t] * 2 + 1] === 0; t--);
	return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
}, Ls = (e, t, n, r) => {
	let i;
	for (xs(e, t - 257, 5), xs(e, n - 1, 5), xs(e, r - 4, 4), i = 0; i < r; i++) xs(e, e.bl_tree[os[i] * 2 + 1], 3);
	Fs(e, e.dyn_ltree, t - 1), Fs(e, e.dyn_dtree, n - 1);
}, Rs = (e) => {
	let t = 4093624447, n;
	for (n = 0; n <= 31; n++, t >>>= 1) if (t & 1 && e.dyn_ltree[n * 2] !== 0) return Lo;
	if (e.dyn_ltree[18] !== 0 || e.dyn_ltree[20] !== 0 || e.dyn_ltree[26] !== 0) return Ro;
	for (n = 32; n < Go; n++) if (e.dyn_ltree[n * 2] !== 0) return Ro;
	return Lo;
}, zs = !1, Bs = (e) => {
	zs ||= (Ds(), !0), e.l_desc = new vs(e.dyn_ltree, hs), e.d_desc = new vs(e.dyn_dtree, gs), e.bl_desc = new vs(e.bl_tree, _s), e.bi_buf = 0, e.bi_valid = 0, Os(e);
}, Vs = (e, t, n, r) => {
	xs(e, (Vo << 1) + +!!r, 3), ks(e), bs(e, n), bs(e, ~n), n && e.pending_buf.set(e.window.subarray(t, t + n), e.pending), e.pending += n;
}, Hs = {
	_tr_init: Bs,
	_tr_stored_block: Vs,
	_tr_flush_block: (e, t, n, r) => {
		let i, a, o = 0;
		e.level > 0 ? (e.strm.data_type === zo && (e.strm.data_type = Rs(e)), Ns(e, e.l_desc), Ns(e, e.d_desc), o = Is(e), i = e.opt_len + 3 + 7 >>> 3, a = e.static_len + 3 + 7 >>> 3, a <= i && (i = a)) : i = a = n + 5, n + 4 <= i && t !== -1 ? Vs(e, t, n, r) : e.strategy === Io || a === i ? (xs(e, (Ho << 1) + +!!r, 3), Ms(e, cs, ls)) : (xs(e, (Uo << 1) + +!!r, 3), Ls(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, o + 1), Ms(e, e.dyn_ltree, e.dyn_dtree)), Os(e), r && ks(e);
	},
	_tr_tally: (e, t, n) => (e.pending_buf[e.sym_buf + e.sym_next++] = t, e.pending_buf[e.sym_buf + e.sym_next++] = t >> 8, e.pending_buf[e.sym_buf + e.sym_next++] = n, t === 0 ? e.dyn_ltree[n * 2]++ : (e.matches++, t--, e.dyn_ltree[(ds[n] + Go + 1) * 2]++, e.dyn_dtree[ys(t) * 2]++), e.sym_next === e.sym_end),
	_tr_align: (e) => {
		xs(e, Ho << 1, 3), Ss(e, $o, cs), ws(e);
	}
}, Us = (e, t, n, r) => {
	let i = e & 65535 | 0, a = e >>> 16 & 65535 | 0, o = 0;
	for (; n !== 0;) {
		o = n > 2e3 ? 2e3 : n, n -= o;
		do
			i = i + t[r++] | 0, a = a + i | 0;
		while (--o);
		i %= 65521, a %= 65521;
	}
	return i | a << 16 | 0;
}, Ws = new Uint32Array((() => {
	let e, t = [];
	for (var n = 0; n < 256; n++) {
		e = n;
		for (var r = 0; r < 8; r++) e = e & 1 ? 3988292384 ^ e >>> 1 : e >>> 1;
		t[n] = e;
	}
	return t;
})()), Gs = (e, t, n, r) => {
	let i = Ws, a = r + n;
	e ^= -1;
	for (let n = r; n < a; n++) e = e >>> 8 ^ i[(e ^ t[n]) & 255];
	return e ^ -1;
}, Ks = {
	2: "need dictionary",
	1: "stream end",
	0: "",
	"-1": "file error",
	"-2": "stream error",
	"-3": "data error",
	"-4": "insufficient memory",
	"-5": "buffer error",
	"-6": "incompatible version"
}, qs = {
	Z_NO_FLUSH: 0,
	Z_PARTIAL_FLUSH: 1,
	Z_SYNC_FLUSH: 2,
	Z_FULL_FLUSH: 3,
	Z_FINISH: 4,
	Z_BLOCK: 5,
	Z_TREES: 6,
	Z_OK: 0,
	Z_STREAM_END: 1,
	Z_NEED_DICT: 2,
	Z_ERRNO: -1,
	Z_STREAM_ERROR: -2,
	Z_DATA_ERROR: -3,
	Z_MEM_ERROR: -4,
	Z_BUF_ERROR: -5,
	Z_NO_COMPRESSION: 0,
	Z_BEST_SPEED: 1,
	Z_BEST_COMPRESSION: 9,
	Z_DEFAULT_COMPRESSION: -1,
	Z_FILTERED: 1,
	Z_HUFFMAN_ONLY: 2,
	Z_RLE: 3,
	Z_FIXED: 4,
	Z_DEFAULT_STRATEGY: 0,
	Z_BINARY: 0,
	Z_TEXT: 1,
	Z_UNKNOWN: 2,
	Z_DEFLATED: 8
}, { _tr_init: Js, _tr_stored_block: Ys, _tr_flush_block: Xs, _tr_tally: Zs, _tr_align: Qs } = Hs, { Z_NO_FLUSH: $s, Z_PARTIAL_FLUSH: ec, Z_FULL_FLUSH: tc, Z_FINISH: nc, Z_BLOCK: rc, Z_OK: ic, Z_STREAM_END: ac, Z_STREAM_ERROR: oc, Z_DATA_ERROR: sc, Z_BUF_ERROR: cc, Z_DEFAULT_COMPRESSION: lc, Z_FILTERED: uc, Z_HUFFMAN_ONLY: dc, Z_RLE: fc, Z_FIXED: pc, Z_DEFAULT_STRATEGY: mc, Z_UNKNOWN: hc, Z_DEFLATED: gc } = qs, _c = 9, vc = 15, yc = 8, bc = 573, xc = 3, Sc = 258, Cc = 262, wc = 32, Tc = 42, Ec = 57, Dc = 69, Oc = 73, kc = 91, Ac = 103, jc = 113, Y = 666, Mc = 1, Nc = 2, Pc = 3, Fc = 4, Ic = 3, Lc = (e, t) => (e.msg = Ks[t], t), Rc = (e) => e * 2 - (e > 4 ? 9 : 0), zc = (e) => {
	let t = e.length;
	for (; --t >= 0;) e[t] = 0;
}, Bc = (e) => {
	let t, n, r, i = e.w_size;
	t = e.hash_size, r = t;
	do
		n = e.head[--r], e.head[r] = n >= i ? n - i : 0;
	while (--t);
	t = i, r = t;
	do
		n = e.prev[--r], e.prev[r] = n >= i ? n - i : 0;
	while (--t);
}, Vc = (e, t, n) => (t << e.hash_shift ^ n) & e.hash_mask, Hc = (e) => {
	let t = e.state, n = t.pending;
	n > e.avail_out && (n = e.avail_out), n !== 0 && (e.output.set(t.pending_buf.subarray(t.pending_out, t.pending_out + n), e.next_out), e.next_out += n, t.pending_out += n, e.total_out += n, e.avail_out -= n, t.pending -= n, t.pending === 0 && (t.pending_out = 0));
}, Uc = (e, t) => {
	Xs(e, e.block_start >= 0 ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, Hc(e.strm);
}, Wc = (e, t) => {
	e.pending_buf[e.pending++] = t;
}, Gc = (e, t) => {
	e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = t & 255;
}, Kc = (e, t, n, r) => {
	let i = e.avail_in;
	return i > r && (i = r), i === 0 ? 0 : (e.avail_in -= i, t.set(e.input.subarray(e.next_in, e.next_in + i), n), e.state.wrap === 1 ? e.adler = Us(e.adler, t, i, n) : e.state.wrap === 2 && (e.adler = Gs(e.adler, t, i, n)), e.next_in += i, e.total_in += i, i);
}, qc = (e, t) => {
	let n = e.max_chain_length, r = e.strstart, i, a, o = e.prev_length, s = e.nice_match, c = e.strstart > e.w_size - Cc ? e.strstart - (e.w_size - Cc) : 0, l = e.window, u = e.w_mask, d = e.prev, f = e.strstart + Sc, p = l[r + o - 1], m = l[r + o];
	e.prev_length >= e.good_match && (n >>= 2), s > e.lookahead && (s = e.lookahead);
	do {
		if (i = t, l[i + o] !== m || l[i + o - 1] !== p || l[i] !== l[r] || l[++i] !== l[r + 1]) continue;
		r += 2, i++;
		do		;
while (l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && r < f);
		if (a = Sc - (f - r), r = f - Sc, a > o) {
			if (e.match_start = t, o = a, a >= s) break;
			p = l[r + o - 1], m = l[r + o];
		}
	} while ((t = d[t & u]) > c && --n !== 0);
	return o <= e.lookahead ? o : e.lookahead;
}, Jc = (e) => {
	let t = e.w_size, n, r, i;
	do {
		if (r = e.window_size - e.lookahead - e.strstart, e.strstart >= t + (t - Cc) && (e.window.set(e.window.subarray(t, t + t - r), 0), e.match_start -= t, e.strstart -= t, e.block_start -= t, e.insert > e.strstart && (e.insert = e.strstart), Bc(e), r += t), e.strm.avail_in === 0) break;
		if (n = Kc(e.strm, e.window, e.strstart + e.lookahead, r), e.lookahead += n, e.lookahead + e.insert >= xc) for (i = e.strstart - e.insert, e.ins_h = e.window[i], e.ins_h = Vc(e, e.ins_h, e.window[i + 1]); e.insert && (e.ins_h = Vc(e, e.ins_h, e.window[i + xc - 1]), e.prev[i & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = i, i++, e.insert--, !(e.lookahead + e.insert < xc)););
	} while (e.lookahead < Cc && e.strm.avail_in !== 0);
}, Yc = (e, t) => {
	let n = e.pending_buf_size - 5 > e.w_size ? e.w_size : e.pending_buf_size - 5, r, i, a, o = 0, s = e.strm.avail_in;
	do {
		if (r = 65535, a = e.bi_valid + 42 >> 3, e.strm.avail_out < a || (a = e.strm.avail_out - a, i = e.strstart - e.block_start, r > i + e.strm.avail_in && (r = i + e.strm.avail_in), r > a && (r = a), r < n && (r === 0 && t !== nc || t === $s || r !== i + e.strm.avail_in))) break;
		o = +(t === nc && r === i + e.strm.avail_in), Ys(e, 0, 0, o), e.pending_buf[e.pending - 4] = r, e.pending_buf[e.pending - 3] = r >> 8, e.pending_buf[e.pending - 2] = ~r, e.pending_buf[e.pending - 1] = ~r >> 8, Hc(e.strm), i && (i > r && (i = r), e.strm.output.set(e.window.subarray(e.block_start, e.block_start + i), e.strm.next_out), e.strm.next_out += i, e.strm.avail_out -= i, e.strm.total_out += i, e.block_start += i, r -= i), r && (Kc(e.strm, e.strm.output, e.strm.next_out, r), e.strm.next_out += r, e.strm.avail_out -= r, e.strm.total_out += r);
	} while (o === 0);
	return s -= e.strm.avail_in, s && (s >= e.w_size ? (e.matches = 2, e.window.set(e.strm.input.subarray(e.strm.next_in - e.w_size, e.strm.next_in), 0), e.strstart = e.w_size, e.insert = e.strstart) : (e.window_size - e.strstart <= s && (e.strstart -= e.w_size, e.window.set(e.window.subarray(e.w_size, e.w_size + e.strstart), 0), e.matches < 2 && e.matches++, e.insert > e.strstart && (e.insert = e.strstart)), e.window.set(e.strm.input.subarray(e.strm.next_in - s, e.strm.next_in), e.strstart), e.strstart += s, e.insert += s > e.w_size - e.insert ? e.w_size - e.insert : s), e.block_start = e.strstart), e.high_water < e.strstart && (e.high_water = e.strstart), o ? Fc : t !== $s && t !== nc && e.strm.avail_in === 0 && e.strstart === e.block_start ? Nc : (a = e.window_size - e.strstart, e.strm.avail_in > a && e.block_start >= e.w_size && (e.block_start -= e.w_size, e.strstart -= e.w_size, e.window.set(e.window.subarray(e.w_size, e.w_size + e.strstart), 0), e.matches < 2 && e.matches++, a += e.w_size, e.insert > e.strstart && (e.insert = e.strstart)), a > e.strm.avail_in && (a = e.strm.avail_in), a && (Kc(e.strm, e.window, e.strstart, a), e.strstart += a, e.insert += a > e.w_size - e.insert ? e.w_size - e.insert : a), e.high_water < e.strstart && (e.high_water = e.strstart), a = e.bi_valid + 42 >> 3, a = e.pending_buf_size - a > 65535 ? 65535 : e.pending_buf_size - a, n = a > e.w_size ? e.w_size : a, i = e.strstart - e.block_start, (i >= n || (i || t === nc) && t !== $s && e.strm.avail_in === 0 && i <= a) && (r = i > a ? a : i, o = +(t === nc && e.strm.avail_in === 0 && r === i), Ys(e, e.block_start, r, o), e.block_start += r, Hc(e.strm)), o ? Pc : Mc);
}, Xc = (e, t) => {
	let n, r;
	for (;;) {
		if (e.lookahead < Cc) {
			if (Jc(e), e.lookahead < Cc && t === $s) return Mc;
			if (e.lookahead === 0) break;
		}
		if (n = 0, e.lookahead >= xc && (e.ins_h = Vc(e, e.ins_h, e.window[e.strstart + xc - 1]), n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), n !== 0 && e.strstart - n <= e.w_size - Cc && (e.match_length = qc(e, n)), e.match_length >= xc) if (r = Zs(e, e.strstart - e.match_start, e.match_length - xc), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= xc) {
			e.match_length--;
			do
				e.strstart++, e.ins_h = Vc(e, e.ins_h, e.window[e.strstart + xc - 1]), n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart;
			while (--e.match_length !== 0);
			e.strstart++;
		} else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = Vc(e, e.ins_h, e.window[e.strstart + 1]);
		else r = Zs(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
		if (r && (Uc(e, !1), e.strm.avail_out === 0)) return Mc;
	}
	return e.insert = e.strstart < xc - 1 ? e.strstart : xc - 1, t === nc ? (Uc(e, !0), e.strm.avail_out === 0 ? Pc : Fc) : e.sym_next && (Uc(e, !1), e.strm.avail_out === 0) ? Mc : Nc;
}, Zc = (e, t) => {
	let n, r, i;
	for (;;) {
		if (e.lookahead < Cc) {
			if (Jc(e), e.lookahead < Cc && t === $s) return Mc;
			if (e.lookahead === 0) break;
		}
		if (n = 0, e.lookahead >= xc && (e.ins_h = Vc(e, e.ins_h, e.window[e.strstart + xc - 1]), n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = xc - 1, n !== 0 && e.prev_length < e.max_lazy_match && e.strstart - n <= e.w_size - Cc && (e.match_length = qc(e, n), e.match_length <= 5 && (e.strategy === uc || e.match_length === xc && e.strstart - e.match_start > 4096) && (e.match_length = xc - 1)), e.prev_length >= xc && e.match_length <= e.prev_length) {
			i = e.strstart + e.lookahead - xc, r = Zs(e, e.strstart - 1 - e.prev_match, e.prev_length - xc), e.lookahead -= e.prev_length - 1, e.prev_length -= 2;
			do
				++e.strstart <= i && (e.ins_h = Vc(e, e.ins_h, e.window[e.strstart + xc - 1]), n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart);
			while (--e.prev_length !== 0);
			if (e.match_available = 0, e.match_length = xc - 1, e.strstart++, r && (Uc(e, !1), e.strm.avail_out === 0)) return Mc;
		} else if (e.match_available) {
			if (r = Zs(e, 0, e.window[e.strstart - 1]), r && Uc(e, !1), e.strstart++, e.lookahead--, e.strm.avail_out === 0) return Mc;
		} else e.match_available = 1, e.strstart++, e.lookahead--;
	}
	return e.match_available &&= (r = Zs(e, 0, e.window[e.strstart - 1]), 0), e.insert = e.strstart < xc - 1 ? e.strstart : xc - 1, t === nc ? (Uc(e, !0), e.strm.avail_out === 0 ? Pc : Fc) : e.sym_next && (Uc(e, !1), e.strm.avail_out === 0) ? Mc : Nc;
}, Qc = (e, t) => {
	let n, r, i, a, o = e.window;
	for (;;) {
		if (e.lookahead <= Sc) {
			if (Jc(e), e.lookahead <= Sc && t === $s) return Mc;
			if (e.lookahead === 0) break;
		}
		if (e.match_length = 0, e.lookahead >= xc && e.strstart > 0 && (i = e.strstart - 1, r = o[i], r === o[++i] && r === o[++i] && r === o[++i])) {
			a = e.strstart + Sc;
			do			;
while (r === o[++i] && r === o[++i] && r === o[++i] && r === o[++i] && r === o[++i] && r === o[++i] && r === o[++i] && r === o[++i] && i < a);
			e.match_length = Sc - (a - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
		}
		if (e.match_length >= xc ? (n = Zs(e, 1, e.match_length - xc), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (n = Zs(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), n && (Uc(e, !1), e.strm.avail_out === 0)) return Mc;
	}
	return e.insert = 0, t === nc ? (Uc(e, !0), e.strm.avail_out === 0 ? Pc : Fc) : e.sym_next && (Uc(e, !1), e.strm.avail_out === 0) ? Mc : Nc;
}, $c = (e, t) => {
	let n;
	for (;;) {
		if (e.lookahead === 0 && (Jc(e), e.lookahead === 0)) {
			if (t === $s) return Mc;
			break;
		}
		if (e.match_length = 0, n = Zs(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, n && (Uc(e, !1), e.strm.avail_out === 0)) return Mc;
	}
	return e.insert = 0, t === nc ? (Uc(e, !0), e.strm.avail_out === 0 ? Pc : Fc) : e.sym_next && (Uc(e, !1), e.strm.avail_out === 0) ? Mc : Nc;
};
function el(e, t, n, r, i) {
	this.good_length = e, this.max_lazy = t, this.nice_length = n, this.max_chain = r, this.func = i;
}
var tl = [
	new el(0, 0, 0, 0, Yc),
	new el(4, 4, 8, 4, Xc),
	new el(4, 5, 16, 8, Xc),
	new el(4, 6, 32, 32, Xc),
	new el(4, 4, 16, 16, Zc),
	new el(8, 16, 32, 32, Zc),
	new el(8, 16, 128, 128, Zc),
	new el(8, 32, 128, 256, Zc),
	new el(32, 128, 258, 1024, Zc),
	new el(32, 258, 258, 4096, Zc)
], nl = (e) => {
	e.window_size = 2 * e.w_size, zc(e.head), e.max_lazy_match = tl[e.level].max_lazy, e.good_match = tl[e.level].good_length, e.nice_match = tl[e.level].nice_length, e.max_chain_length = tl[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = xc - 1, e.match_available = 0, e.ins_h = 0;
};
function rl() {
	this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = gc, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new Uint16Array(bc * 2), this.dyn_dtree = /* @__PURE__ */ new Uint16Array(122), this.bl_tree = /* @__PURE__ */ new Uint16Array(78), zc(this.dyn_ltree), zc(this.dyn_dtree), zc(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = /* @__PURE__ */ new Uint16Array(16), this.heap = /* @__PURE__ */ new Uint16Array(573), zc(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = /* @__PURE__ */ new Uint16Array(573), zc(this.depth), this.sym_buf = 0, this.lit_bufsize = 0, this.sym_next = 0, this.sym_end = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
}
var il = (e) => {
	if (!e) return 1;
	let t = e.state;
	return +(!t || t.strm !== e || t.status !== Tc && t.status !== Ec && t.status !== Dc && t.status !== Oc && t.status !== kc && t.status !== Ac && t.status !== jc && t.status !== Y);
}, al = (e) => {
	if (il(e)) return Lc(e, oc);
	e.total_in = e.total_out = 0, e.data_type = hc;
	let t = e.state;
	return t.pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap === 2 ? Ec : t.wrap ? Tc : jc, e.adler = t.wrap === 2 ? 0 : 1, t.last_flush = -2, Js(t), ic;
}, ol = (e) => {
	let t = al(e);
	return t === ic && nl(e.state), t;
}, sl = (e, t) => il(e) || e.state.wrap !== 2 ? oc : (e.state.gzhead = t, ic), cl = (e, t, n, r, i, a) => {
	if (!e) return oc;
	let o = 1;
	if (t === lc && (t = 6), r < 0 ? (o = 0, r = -r) : r > 15 && (o = 2, r -= 16), i < 1 || i > _c || n !== gc || r < 8 || r > 15 || t < 0 || t > 9 || a < 0 || a > pc || r === 8 && o !== 1) return Lc(e, oc);
	r === 8 && (r = 9);
	let s = new rl();
	return e.state = s, s.strm = e, s.status = Tc, s.wrap = o, s.gzhead = null, s.w_bits = r, s.w_size = 1 << s.w_bits, s.w_mask = s.w_size - 1, s.hash_bits = i + 7, s.hash_size = 1 << s.hash_bits, s.hash_mask = s.hash_size - 1, s.hash_shift = ~~((s.hash_bits + xc - 1) / xc), s.window = new Uint8Array(s.w_size * 2), s.head = new Uint16Array(s.hash_size), s.prev = new Uint16Array(s.w_size), s.lit_bufsize = 1 << i + 6, s.pending_buf_size = s.lit_bufsize * 4, s.pending_buf = new Uint8Array(s.pending_buf_size), s.sym_buf = s.lit_bufsize, s.sym_end = (s.lit_bufsize - 1) * 3, s.level = t, s.strategy = a, s.method = n, ol(e);
}, ll = {
	deflateInit: (e, t) => cl(e, t, gc, vc, yc, mc),
	deflateInit2: cl,
	deflateReset: ol,
	deflateResetKeep: al,
	deflateSetHeader: sl,
	deflate: (e, t) => {
		if (il(e) || t > rc || t < 0) return e ? Lc(e, oc) : oc;
		let n = e.state;
		if (!e.output || e.avail_in !== 0 && !e.input || n.status === Y && t !== nc) return Lc(e, e.avail_out === 0 ? cc : oc);
		let r = n.last_flush;
		if (n.last_flush = t, n.pending !== 0) {
			if (Hc(e), e.avail_out === 0) return n.last_flush = -1, ic;
		} else if (e.avail_in === 0 && Rc(t) <= Rc(r) && t !== nc) return Lc(e, cc);
		if (n.status === Y && e.avail_in !== 0) return Lc(e, cc);
		if (n.status === Tc && n.wrap === 0 && (n.status = jc), n.status === Tc) {
			let t = gc + (n.w_bits - 8 << 4) << 8, r = -1;
			if (r = n.strategy >= dc || n.level < 2 ? 0 : n.level < 6 ? 1 : n.level === 6 ? 2 : 3, t |= r << 6, n.strstart !== 0 && (t |= wc), t += 31 - t % 31, Gc(n, t), n.strstart !== 0 && (Gc(n, e.adler >>> 16), Gc(n, e.adler & 65535)), e.adler = 1, n.status = jc, Hc(e), n.pending !== 0) return n.last_flush = -1, ic;
		}
		if (n.status === Ec) {
			if (e.adler = 0, Wc(n, 31), Wc(n, 139), Wc(n, 8), n.gzhead) Wc(n, +!!n.gzhead.text + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), Wc(n, n.gzhead.time & 255), Wc(n, n.gzhead.time >> 8 & 255), Wc(n, n.gzhead.time >> 16 & 255), Wc(n, n.gzhead.time >> 24 & 255), Wc(n, n.level === 9 ? 2 : n.strategy >= dc || n.level < 2 ? 4 : 0), Wc(n, n.gzhead.os & 255), n.gzhead.extra && n.gzhead.extra.length && (Wc(n, n.gzhead.extra.length & 255), Wc(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = Gs(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = Dc;
			else if (Wc(n, 0), Wc(n, 0), Wc(n, 0), Wc(n, 0), Wc(n, 0), Wc(n, n.level === 9 ? 2 : n.strategy >= dc || n.level < 2 ? 4 : 0), Wc(n, Ic), n.status = jc, Hc(e), n.pending !== 0) return n.last_flush = -1, ic;
		}
		if (n.status === Dc) {
			if (n.gzhead.extra) {
				let t = n.pending, r = (n.gzhead.extra.length & 65535) - n.gzindex;
				for (; n.pending + r > n.pending_buf_size;) {
					let i = n.pending_buf_size - n.pending;
					if (n.pending_buf.set(n.gzhead.extra.subarray(n.gzindex, n.gzindex + i), n.pending), n.pending = n.pending_buf_size, n.gzhead.hcrc && n.pending > t && (e.adler = Gs(e.adler, n.pending_buf, n.pending - t, t)), n.gzindex += i, Hc(e), n.pending !== 0) return n.last_flush = -1, ic;
					t = 0, r -= i;
				}
				let i = new Uint8Array(n.gzhead.extra);
				n.pending_buf.set(i.subarray(n.gzindex, n.gzindex + r), n.pending), n.pending += r, n.gzhead.hcrc && n.pending > t && (e.adler = Gs(e.adler, n.pending_buf, n.pending - t, t)), n.gzindex = 0;
			}
			n.status = Oc;
		}
		if (n.status === Oc) {
			if (n.gzhead.name) {
				let t = n.pending, r;
				do {
					if (n.pending === n.pending_buf_size) {
						if (n.gzhead.hcrc && n.pending > t && (e.adler = Gs(e.adler, n.pending_buf, n.pending - t, t)), Hc(e), n.pending !== 0) return n.last_flush = -1, ic;
						t = 0;
					}
					r = n.gzindex < n.gzhead.name.length ? n.gzhead.name.charCodeAt(n.gzindex++) & 255 : 0, Wc(n, r);
				} while (r !== 0);
				n.gzhead.hcrc && n.pending > t && (e.adler = Gs(e.adler, n.pending_buf, n.pending - t, t)), n.gzindex = 0;
			}
			n.status = kc;
		}
		if (n.status === kc) {
			if (n.gzhead.comment) {
				let t = n.pending, r;
				do {
					if (n.pending === n.pending_buf_size) {
						if (n.gzhead.hcrc && n.pending > t && (e.adler = Gs(e.adler, n.pending_buf, n.pending - t, t)), Hc(e), n.pending !== 0) return n.last_flush = -1, ic;
						t = 0;
					}
					r = n.gzindex < n.gzhead.comment.length ? n.gzhead.comment.charCodeAt(n.gzindex++) & 255 : 0, Wc(n, r);
				} while (r !== 0);
				n.gzhead.hcrc && n.pending > t && (e.adler = Gs(e.adler, n.pending_buf, n.pending - t, t));
			}
			n.status = Ac;
		}
		if (n.status === Ac) {
			if (n.gzhead.hcrc) {
				if (n.pending + 2 > n.pending_buf_size && (Hc(e), n.pending !== 0)) return n.last_flush = -1, ic;
				Wc(n, e.adler & 255), Wc(n, e.adler >> 8 & 255), e.adler = 0;
			}
			if (n.status = jc, Hc(e), n.pending !== 0) return n.last_flush = -1, ic;
		}
		if (e.avail_in !== 0 || n.lookahead !== 0 || t !== $s && n.status !== Y) {
			let r = n.level === 0 ? Yc(n, t) : n.strategy === dc ? $c(n, t) : n.strategy === fc ? Qc(n, t) : tl[n.level].func(n, t);
			if ((r === Pc || r === Fc) && (n.status = Y), r === Mc || r === Pc) return e.avail_out === 0 && (n.last_flush = -1), ic;
			if (r === Nc && (t === ec ? Qs(n) : t !== rc && (Ys(n, 0, 0, !1), t === tc && (zc(n.head), n.lookahead === 0 && (n.strstart = 0, n.block_start = 0, n.insert = 0))), Hc(e), e.avail_out === 0)) return n.last_flush = -1, ic;
		}
		return t === nc ? n.wrap <= 0 ? ac : (n.wrap === 2 ? (Wc(n, e.adler & 255), Wc(n, e.adler >> 8 & 255), Wc(n, e.adler >> 16 & 255), Wc(n, e.adler >> 24 & 255), Wc(n, e.total_in & 255), Wc(n, e.total_in >> 8 & 255), Wc(n, e.total_in >> 16 & 255), Wc(n, e.total_in >> 24 & 255)) : (Gc(n, e.adler >>> 16), Gc(n, e.adler & 65535)), Hc(e), n.wrap > 0 && (n.wrap = -n.wrap), n.pending === 0 ? ac : ic) : ic;
	},
	deflateEnd: (e) => {
		if (il(e)) return oc;
		let t = e.state.status;
		return e.state = null, t === jc ? Lc(e, sc) : ic;
	},
	deflateSetDictionary: (e, t) => {
		let n = t.length;
		if (il(e)) return oc;
		let r = e.state, i = r.wrap;
		if (i === 2 || i === 1 && r.status !== Tc || r.lookahead) return oc;
		if (i === 1 && (e.adler = Us(e.adler, t, n, 0)), r.wrap = 0, n >= r.w_size) {
			i === 0 && (zc(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0);
			let e = new Uint8Array(r.w_size);
			e.set(t.subarray(n - r.w_size, n), 0), t = e, n = r.w_size;
		}
		let a = e.avail_in, o = e.next_in, s = e.input;
		for (e.avail_in = n, e.next_in = 0, e.input = t, Jc(r); r.lookahead >= xc;) {
			let e = r.strstart, t = r.lookahead - (xc - 1);
			do
				r.ins_h = Vc(r, r.ins_h, r.window[e + xc - 1]), r.prev[e & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = e, e++;
			while (--t);
			r.strstart = e, r.lookahead = xc - 1, Jc(r);
		}
		return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = xc - 1, r.match_available = 0, e.next_in = o, e.input = s, e.avail_in = a, r.wrap = i, ic;
	},
	deflateInfo: "pako deflate (from Nodeca project)"
}, ul = (e, t) => Object.prototype.hasOwnProperty.call(e, t), dl = {
	assign: function(e) {
		let t = Array.prototype.slice.call(arguments, 1);
		for (; t.length;) {
			let n = t.shift();
			if (n) {
				if (typeof n != "object") throw TypeError(n + "must be non-object");
				for (let t in n) ul(n, t) && (e[t] = n[t]);
			}
		}
		return e;
	},
	flattenChunks: (e) => {
		let t = 0;
		for (let n = 0, r = e.length; n < r; n++) t += e[n].length;
		let n = new Uint8Array(t);
		for (let t = 0, r = 0, i = e.length; t < i; t++) {
			let i = e[t];
			n.set(i, r), r += i.length;
		}
		return n;
	}
}, fl = !0;
try {
	String.fromCharCode.apply(null, /* @__PURE__ */ new Uint8Array(1));
} catch {
	fl = !1;
}
var pl = /* @__PURE__ */ new Uint8Array(256);
for (let e = 0; e < 256; e++) pl[e] = e >= 252 ? 6 : e >= 248 ? 5 : e >= 240 ? 4 : e >= 224 ? 3 : e >= 192 ? 2 : 1;
pl[254] = pl[254] = 1;
var ml = (e) => {
	if (typeof TextEncoder == "function" && TextEncoder.prototype.encode) return new TextEncoder().encode(e);
	let t, n, r, i, a, o = e.length, s = 0;
	for (i = 0; i < o; i++) n = e.charCodeAt(i), (n & 64512) == 55296 && i + 1 < o && (r = e.charCodeAt(i + 1), (r & 64512) == 56320 && (n = 65536 + (n - 55296 << 10) + (r - 56320), i++)), s += n < 128 ? 1 : n < 2048 ? 2 : n < 65536 ? 3 : 4;
	for (t = new Uint8Array(s), a = 0, i = 0; a < s; i++) n = e.charCodeAt(i), (n & 64512) == 55296 && i + 1 < o && (r = e.charCodeAt(i + 1), (r & 64512) == 56320 && (n = 65536 + (n - 55296 << 10) + (r - 56320), i++)), n < 128 ? t[a++] = n : n < 2048 ? (t[a++] = 192 | n >>> 6, t[a++] = 128 | n & 63) : n < 65536 ? (t[a++] = 224 | n >>> 12, t[a++] = 128 | n >>> 6 & 63, t[a++] = 128 | n & 63) : (t[a++] = 240 | n >>> 18, t[a++] = 128 | n >>> 12 & 63, t[a++] = 128 | n >>> 6 & 63, t[a++] = 128 | n & 63);
	return t;
}, hl = (e, t) => {
	if (t < 65534 && e.subarray && fl) return String.fromCharCode.apply(null, e.length === t ? e : e.subarray(0, t));
	let n = "";
	for (let r = 0; r < t; r++) n += String.fromCharCode(e[r]);
	return n;
}, gl = {
	string2buf: ml,
	buf2string: (e, t) => {
		let n = t || e.length;
		if (typeof TextDecoder == "function" && TextDecoder.prototype.decode) return new TextDecoder().decode(e.subarray(0, t));
		let r, i, a = Array(n * 2);
		for (i = 0, r = 0; r < n;) {
			let t = e[r++];
			if (t < 128) {
				a[i++] = t;
				continue;
			}
			let o = pl[t];
			if (o > 4) {
				a[i++] = 65533, r += o - 1;
				continue;
			}
			for (t &= o === 2 ? 31 : o === 3 ? 15 : 7; o > 1 && r < n;) t = t << 6 | e[r++] & 63, o--;
			if (o > 1) {
				a[i++] = 65533;
				continue;
			}
			t < 65536 ? a[i++] = t : (t -= 65536, a[i++] = 55296 | t >> 10 & 1023, a[i++] = 56320 | t & 1023);
		}
		return hl(a, i);
	},
	utf8border: (e, t) => {
		t ||= e.length, t > e.length && (t = e.length);
		let n = t - 1;
		for (; n >= 0 && (e[n] & 192) == 128;) n--;
		return n < 0 || n === 0 ? t : n + pl[e[n]] > t ? n : t;
	}
};
function _l() {
	this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var vl = _l, yl = Object.prototype.toString, { Z_NO_FLUSH: bl, Z_SYNC_FLUSH: xl, Z_FULL_FLUSH: Sl, Z_FINISH: Cl, Z_OK: wl, Z_STREAM_END: Tl, Z_DEFAULT_COMPRESSION: El, Z_DEFAULT_STRATEGY: Dl, Z_DEFLATED: Ol } = qs;
function kl(e) {
	this.options = dl.assign({
		level: El,
		method: Ol,
		chunkSize: 16384,
		windowBits: 15,
		memLevel: 8,
		strategy: Dl
	}, e || {});
	let t = this.options;
	t.raw && t.windowBits > 0 ? t.windowBits = -t.windowBits : t.gzip && t.windowBits > 0 && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new vl(), this.strm.avail_out = 0;
	let n = ll.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
	if (n !== wl) throw Error(Ks[n]);
	if (t.header && ll.deflateSetHeader(this.strm, t.header), t.dictionary) {
		let e;
		if (e = typeof t.dictionary == "string" ? gl.string2buf(t.dictionary) : yl.call(t.dictionary) === "[object ArrayBuffer]" ? new Uint8Array(t.dictionary) : t.dictionary, n = ll.deflateSetDictionary(this.strm, e), n !== wl) throw Error(Ks[n]);
		this._dict_set = !0;
	}
}
kl.prototype.push = function(e, t) {
	let n = this.strm, r = this.options.chunkSize, i, a;
	if (this.ended) return !1;
	for (a = t === ~~t ? t : t === !0 ? Cl : bl, typeof e == "string" ? n.input = gl.string2buf(e) : yl.call(e) === "[object ArrayBuffer]" ? n.input = new Uint8Array(e) : n.input = e, n.next_in = 0, n.avail_in = n.input.length;;) {
		if (n.avail_out === 0 && (n.output = new Uint8Array(r), n.next_out = 0, n.avail_out = r), (a === xl || a === Sl) && n.avail_out <= 6) {
			this.onData(n.output.subarray(0, n.next_out)), n.avail_out = 0;
			continue;
		}
		if (i = ll.deflate(n, a), i === Tl) return n.next_out > 0 && this.onData(n.output.subarray(0, n.next_out)), i = ll.deflateEnd(this.strm), this.onEnd(i), this.ended = !0, i === wl;
		if (n.avail_out === 0) {
			this.onData(n.output);
			continue;
		}
		if (a > 0 && n.next_out > 0) {
			this.onData(n.output.subarray(0, n.next_out)), n.avail_out = 0;
			continue;
		}
		if (n.avail_in === 0) break;
	}
	return !0;
}, kl.prototype.onData = function(e) {
	this.chunks.push(e);
}, kl.prototype.onEnd = function(e) {
	e === wl && (this.result = dl.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
};
function Al(e, t) {
	let n = new kl(t);
	if (n.push(e, !0), n.err) throw n.msg || Ks[n.err];
	return n.result;
}
function jl(e, t) {
	return t ||= {}, t.raw = !0, Al(e, t);
}
function Ml(e, t) {
	return t ||= {}, t.gzip = !0, Al(e, t);
}
var Nl = {
	Deflate: kl,
	deflate: Al,
	deflateRaw: jl,
	gzip: Ml,
	constants: qs
}, Pl = 16209, Fl = 16191, Il = function(e, t) {
	let n, r, i, a, o, s, c, l, u, d, f, p, m, h, g, _, v, y, b, x, S, C, w, T, E = e.state;
	n = e.next_in, w = e.input, r = n + (e.avail_in - 5), i = e.next_out, T = e.output, a = i - (t - e.avail_out), o = i + (e.avail_out - 257), s = E.dmax, c = E.wsize, l = E.whave, u = E.wnext, d = E.window, f = E.hold, p = E.bits, m = E.lencode, h = E.distcode, g = (1 << E.lenbits) - 1, _ = (1 << E.distbits) - 1;
	top: do {
		p < 15 && (f += w[n++] << p, p += 8, f += w[n++] << p, p += 8), v = m[f & g];
		dolen: for (;;) {
			if (y = v >>> 24, f >>>= y, p -= y, y = v >>> 16 & 255, y === 0) T[i++] = v & 65535;
			else if (y & 16) {
				b = v & 65535, y &= 15, y && (p < y && (f += w[n++] << p, p += 8), b += f & (1 << y) - 1, f >>>= y, p -= y), p < 15 && (f += w[n++] << p, p += 8, f += w[n++] << p, p += 8), v = h[f & _];
				dodist: for (;;) {
					if (y = v >>> 24, f >>>= y, p -= y, y = v >>> 16 & 255, y & 16) {
						if (x = v & 65535, y &= 15, p < y && (f += w[n++] << p, p += 8, p < y && (f += w[n++] << p, p += 8)), x += f & (1 << y) - 1, x > s) {
							e.msg = "invalid distance too far back", E.mode = Pl;
							break top;
						}
						if (f >>>= y, p -= y, y = i - a, x > y) {
							if (y = x - y, y > l && E.sane) {
								e.msg = "invalid distance too far back", E.mode = Pl;
								break top;
							}
							if (S = 0, C = d, u === 0) {
								if (S += c - y, y < b) {
									b -= y;
									do
										T[i++] = d[S++];
									while (--y);
									S = i - x, C = T;
								}
							} else if (u < y) {
								if (S += c + u - y, y -= u, y < b) {
									b -= y;
									do
										T[i++] = d[S++];
									while (--y);
									if (S = 0, u < b) {
										y = u, b -= y;
										do
											T[i++] = d[S++];
										while (--y);
										S = i - x, C = T;
									}
								}
							} else if (S += u - y, y < b) {
								b -= y;
								do
									T[i++] = d[S++];
								while (--y);
								S = i - x, C = T;
							}
							for (; b > 2;) T[i++] = C[S++], T[i++] = C[S++], T[i++] = C[S++], b -= 3;
							b && (T[i++] = C[S++], b > 1 && (T[i++] = C[S++]));
						} else {
							S = i - x;
							do
								T[i++] = T[S++], T[i++] = T[S++], T[i++] = T[S++], b -= 3;
							while (b > 2);
							b && (T[i++] = T[S++], b > 1 && (T[i++] = T[S++]));
						}
					} else if (y & 64) {
						e.msg = "invalid distance code", E.mode = Pl;
						break top;
					} else {
						v = h[(v & 65535) + (f & (1 << y) - 1)];
						continue dodist;
					}
					break;
				}
			} else if (!(y & 64)) {
				v = m[(v & 65535) + (f & (1 << y) - 1)];
				continue dolen;
			} else if (y & 32) {
				E.mode = Fl;
				break top;
			} else {
				e.msg = "invalid literal/length code", E.mode = Pl;
				break top;
			}
			break;
		}
	} while (n < r && i < o);
	b = p >> 3, n -= b, p -= b << 3, f &= (1 << p) - 1, e.next_in = n, e.next_out = i, e.avail_in = n < r ? 5 + (r - n) : 5 - (n - r), e.avail_out = i < o ? 257 + (o - i) : 257 - (i - o), E.hold = f, E.bits = p;
}, Ll = 15, Rl = 852, zl = 592, Bl = 0, Vl = 1, Hl = 2, Ul = new Uint16Array([
	3,
	4,
	5,
	6,
	7,
	8,
	9,
	10,
	11,
	13,
	15,
	17,
	19,
	23,
	27,
	31,
	35,
	43,
	51,
	59,
	67,
	83,
	99,
	115,
	131,
	163,
	195,
	227,
	258,
	0,
	0
]), Wl = new Uint8Array([
	16,
	16,
	16,
	16,
	16,
	16,
	16,
	16,
	17,
	17,
	17,
	17,
	18,
	18,
	18,
	18,
	19,
	19,
	19,
	19,
	20,
	20,
	20,
	20,
	21,
	21,
	21,
	21,
	16,
	72,
	78
]), Gl = new Uint16Array([
	1,
	2,
	3,
	4,
	5,
	7,
	9,
	13,
	17,
	25,
	33,
	49,
	65,
	97,
	129,
	193,
	257,
	385,
	513,
	769,
	1025,
	1537,
	2049,
	3073,
	4097,
	6145,
	8193,
	12289,
	16385,
	24577,
	0,
	0
]), Kl = new Uint8Array([
	16,
	16,
	16,
	16,
	17,
	17,
	18,
	18,
	19,
	19,
	20,
	20,
	21,
	21,
	22,
	22,
	23,
	23,
	24,
	24,
	25,
	25,
	26,
	26,
	27,
	27,
	28,
	28,
	29,
	29,
	64,
	64
]), ql = (e, t, n, r, i, a, o, s) => {
	let c = s.bits, l = 0, u = 0, d = 0, f = 0, p = 0, m = 0, h = 0, g = 0, _ = 0, v = 0, y, b, x, S, C, w = null, T, E = /* @__PURE__ */ new Uint16Array(16), D = /* @__PURE__ */ new Uint16Array(16), O = null, k, A, j;
	for (l = 0; l <= Ll; l++) E[l] = 0;
	for (u = 0; u < r; u++) E[t[n + u]]++;
	for (p = c, f = Ll; f >= 1 && E[f] === 0; f--);
	if (p > f && (p = f), f === 0) return i[a++] = 20971520, i[a++] = 20971520, s.bits = 1, 0;
	for (d = 1; d < f && E[d] === 0; d++);
	for (p < d && (p = d), g = 1, l = 1; l <= Ll; l++) if (g <<= 1, g -= E[l], g < 0) return -1;
	if (g > 0 && (e === Bl || f !== 1)) return -1;
	for (D[1] = 0, l = 1; l < Ll; l++) D[l + 1] = D[l] + E[l];
	for (u = 0; u < r; u++) t[n + u] !== 0 && (o[D[t[n + u]]++] = u);
	if (e === Bl ? (w = O = o, T = 20) : e === Vl ? (w = Ul, O = Wl, T = 257) : (w = Gl, O = Kl, T = 0), v = 0, u = 0, l = d, C = a, m = p, h = 0, x = -1, _ = 1 << p, S = _ - 1, e === Vl && _ > Rl || e === Hl && _ > zl) return 1;
	for (;;) {
		k = l - h, o[u] + 1 < T ? (A = 0, j = o[u]) : o[u] >= T ? (A = O[o[u] - T], j = w[o[u] - T]) : (A = 96, j = 0), y = 1 << l - h, b = 1 << m, d = b;
		do
			b -= y, i[C + (v >> h) + b] = k << 24 | A << 16 | j | 0;
		while (b !== 0);
		for (y = 1 << l - 1; v & y;) y >>= 1;
		if (y === 0 ? v = 0 : (v &= y - 1, v += y), u++, --E[l] === 0) {
			if (l === f) break;
			l = t[n + o[u]];
		}
		if (l > p && (v & S) !== x) {
			for (h === 0 && (h = p), C += d, m = l - h, g = 1 << m; m + h < f && (g -= E[m + h], !(g <= 0));) m++, g <<= 1;
			if (_ += 1 << m, e === Vl && _ > Rl || e === Hl && _ > zl) return 1;
			x = v & S, i[x] = p << 24 | m << 16 | C - a | 0;
		}
	}
	return v !== 0 && (i[C + v] = l - h << 24 | 4194304), s.bits = p, 0;
}, Jl = 0, Yl = 1, Xl = 2, { Z_FINISH: Zl, Z_BLOCK: Ql, Z_TREES: $l, Z_OK: eu, Z_STREAM_END: tu, Z_NEED_DICT: nu, Z_STREAM_ERROR: ru, Z_DATA_ERROR: iu, Z_MEM_ERROR: au, Z_BUF_ERROR: ou, Z_DEFLATED: su } = qs, cu = 16180, lu = 16181, uu = 16182, du = 16183, fu = 16184, pu = 16185, mu = 16186, hu = 16187, gu = 16188, _u = 16189, vu = 16190, yu = 16191, bu = 16192, xu = 16193, Su = 16194, Cu = 16195, wu = 16196, Tu = 16197, Eu = 16198, Du = 16199, Ou = 16200, ku = 16201, Au = 16202, ju = 16203, Mu = 16204, Nu = 16205, Pu = 16206, Fu = 16207, Iu = 16208, Lu = 16209, Ru = 16210, zu = 16211, Bu = 852, Vu = 592, Hu = 15, Uu = (e) => (e >>> 24 & 255) + (e >>> 8 & 65280) + ((e & 65280) << 8) + ((e & 255) << 24);
function Wu() {
	this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = /* @__PURE__ */ new Uint16Array(320), this.work = /* @__PURE__ */ new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
var Gu = (e) => {
	if (!e) return 1;
	let t = e.state;
	return +(!t || t.strm !== e || t.mode < cu || t.mode > zu);
}, Ku = (e) => {
	if (Gu(e)) return ru;
	let t = e.state;
	return e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = t.wrap & 1), t.mode = cu, t.last = 0, t.havedict = 0, t.flags = -1, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new Int32Array(Bu), t.distcode = t.distdyn = new Int32Array(Vu), t.sane = 1, t.back = -1, eu;
}, qu = (e) => {
	if (Gu(e)) return ru;
	let t = e.state;
	return t.wsize = 0, t.whave = 0, t.wnext = 0, Ku(e);
}, Ju = (e, t) => {
	let n;
	if (Gu(e)) return ru;
	let r = e.state;
	return t < 0 ? (n = 0, t = -t) : (n = (t >> 4) + 5, t < 48 && (t &= 15)), t && (t < 8 || t > 15) ? ru : (r.window !== null && r.wbits !== t && (r.window = null), r.wrap = n, r.wbits = t, qu(e));
}, Yu = (e, t) => {
	if (!e) return ru;
	let n = new Wu();
	e.state = n, n.strm = e, n.window = null, n.mode = cu;
	let r = Ju(e, t);
	return r !== eu && (e.state = null), r;
}, Xu = (e) => Yu(e, Hu), Zu = !0, Qu, $u, ed = (e) => {
	if (Zu) {
		Qu = /* @__PURE__ */ new Int32Array(512), $u = /* @__PURE__ */ new Int32Array(32);
		let t = 0;
		for (; t < 144;) e.lens[t++] = 8;
		for (; t < 256;) e.lens[t++] = 9;
		for (; t < 280;) e.lens[t++] = 7;
		for (; t < 288;) e.lens[t++] = 8;
		for (ql(Yl, e.lens, 0, 288, Qu, 0, e.work, { bits: 9 }), t = 0; t < 32;) e.lens[t++] = 5;
		ql(Xl, e.lens, 0, 32, $u, 0, e.work, { bits: 5 }), Zu = !1;
	}
	e.lencode = Qu, e.lenbits = 9, e.distcode = $u, e.distbits = 5;
}, td = (e, t, n, r) => {
	let i, a = e.state;
	return a.window === null && (a.wsize = 1 << a.wbits, a.wnext = 0, a.whave = 0, a.window = new Uint8Array(a.wsize)), r >= a.wsize ? (a.window.set(t.subarray(n - a.wsize, n), 0), a.wnext = 0, a.whave = a.wsize) : (i = a.wsize - a.wnext, i > r && (i = r), a.window.set(t.subarray(n - r, n - r + i), a.wnext), r -= i, r ? (a.window.set(t.subarray(n - r, n), 0), a.wnext = r, a.whave = a.wsize) : (a.wnext += i, a.wnext === a.wsize && (a.wnext = 0), a.whave < a.wsize && (a.whave += i))), 0;
}, nd = {
	inflateReset: qu,
	inflateReset2: Ju,
	inflateResetKeep: Ku,
	inflateInit: Xu,
	inflateInit2: Yu,
	inflate: (e, t) => {
		let n, r, i, a, o, s, c, l, u, d, f, p, m, h, g = 0, _, v, y, b, x, S, C, w, T = /* @__PURE__ */ new Uint8Array(4), E, D, O = new Uint8Array([
			16,
			17,
			18,
			0,
			8,
			7,
			9,
			6,
			10,
			5,
			11,
			4,
			12,
			3,
			13,
			2,
			14,
			1,
			15
		]);
		if (Gu(e) || !e.output || !e.input && e.avail_in !== 0) return ru;
		n = e.state, n.mode === yu && (n.mode = bu), o = e.next_out, i = e.output, c = e.avail_out, a = e.next_in, r = e.input, s = e.avail_in, l = n.hold, u = n.bits, d = s, f = c, w = eu;
		inf_leave: for (;;) switch (n.mode) {
			case cu:
				if (n.wrap === 0) {
					n.mode = bu;
					break;
				}
				for (; u < 16;) {
					if (s === 0) break inf_leave;
					s--, l += r[a++] << u, u += 8;
				}
				if (n.wrap & 2 && l === 35615) {
					n.wbits === 0 && (n.wbits = 15), n.check = 0, T[0] = l & 255, T[1] = l >>> 8 & 255, n.check = Gs(n.check, T, 2, 0), l = 0, u = 0, n.mode = lu;
					break;
				}
				if (n.head && (n.head.done = !1), !(n.wrap & 1) || (((l & 255) << 8) + (l >> 8)) % 31) {
					e.msg = "incorrect header check", n.mode = Lu;
					break;
				}
				if ((l & 15) !== su) {
					e.msg = "unknown compression method", n.mode = Lu;
					break;
				}
				if (l >>>= 4, u -= 4, C = (l & 15) + 8, n.wbits === 0 && (n.wbits = C), C > 15 || C > n.wbits) {
					e.msg = "invalid window size", n.mode = Lu;
					break;
				}
				n.dmax = 1 << n.wbits, n.flags = 0, e.adler = n.check = 1, n.mode = l & 512 ? _u : yu, l = 0, u = 0;
				break;
			case lu:
				for (; u < 16;) {
					if (s === 0) break inf_leave;
					s--, l += r[a++] << u, u += 8;
				}
				if (n.flags = l, (n.flags & 255) !== su) {
					e.msg = "unknown compression method", n.mode = Lu;
					break;
				}
				if (n.flags & 57344) {
					e.msg = "unknown header flags set", n.mode = Lu;
					break;
				}
				n.head && (n.head.text = l >> 8 & 1), n.flags & 512 && n.wrap & 4 && (T[0] = l & 255, T[1] = l >>> 8 & 255, n.check = Gs(n.check, T, 2, 0)), l = 0, u = 0, n.mode = uu;
			case uu:
				for (; u < 32;) {
					if (s === 0) break inf_leave;
					s--, l += r[a++] << u, u += 8;
				}
				n.head && (n.head.time = l), n.flags & 512 && n.wrap & 4 && (T[0] = l & 255, T[1] = l >>> 8 & 255, T[2] = l >>> 16 & 255, T[3] = l >>> 24 & 255, n.check = Gs(n.check, T, 4, 0)), l = 0, u = 0, n.mode = du;
			case du:
				for (; u < 16;) {
					if (s === 0) break inf_leave;
					s--, l += r[a++] << u, u += 8;
				}
				n.head && (n.head.xflags = l & 255, n.head.os = l >> 8), n.flags & 512 && n.wrap & 4 && (T[0] = l & 255, T[1] = l >>> 8 & 255, n.check = Gs(n.check, T, 2, 0)), l = 0, u = 0, n.mode = fu;
			case fu:
				if (n.flags & 1024) {
					for (; u < 16;) {
						if (s === 0) break inf_leave;
						s--, l += r[a++] << u, u += 8;
					}
					n.length = l, n.head && (n.head.extra_len = l), n.flags & 512 && n.wrap & 4 && (T[0] = l & 255, T[1] = l >>> 8 & 255, n.check = Gs(n.check, T, 2, 0)), l = 0, u = 0;
				} else n.head && (n.head.extra = null);
				n.mode = pu;
			case pu:
				if (n.flags & 1024 && (p = n.length, p > s && (p = s), p && (n.head && (C = n.head.extra_len - n.length, n.head.extra || (n.head.extra = new Uint8Array(n.head.extra_len)), n.head.extra.set(r.subarray(a, a + p), C)), n.flags & 512 && n.wrap & 4 && (n.check = Gs(n.check, r, p, a)), s -= p, a += p, n.length -= p), n.length)) break inf_leave;
				n.length = 0, n.mode = mu;
			case mu:
				if (n.flags & 2048) {
					if (s === 0) break inf_leave;
					p = 0;
					do
						C = r[a + p++], n.head && C && n.length < 65536 && (n.head.name += String.fromCharCode(C));
					while (C && p < s);
					if (n.flags & 512 && n.wrap & 4 && (n.check = Gs(n.check, r, p, a)), s -= p, a += p, C) break inf_leave;
				} else n.head && (n.head.name = null);
				n.length = 0, n.mode = hu;
			case hu:
				if (n.flags & 4096) {
					if (s === 0) break inf_leave;
					p = 0;
					do
						C = r[a + p++], n.head && C && n.length < 65536 && (n.head.comment += String.fromCharCode(C));
					while (C && p < s);
					if (n.flags & 512 && n.wrap & 4 && (n.check = Gs(n.check, r, p, a)), s -= p, a += p, C) break inf_leave;
				} else n.head && (n.head.comment = null);
				n.mode = gu;
			case gu:
				if (n.flags & 512) {
					for (; u < 16;) {
						if (s === 0) break inf_leave;
						s--, l += r[a++] << u, u += 8;
					}
					if (n.wrap & 4 && l !== (n.check & 65535)) {
						e.msg = "header crc mismatch", n.mode = Lu;
						break;
					}
					l = 0, u = 0;
				}
				n.head && (n.head.hcrc = n.flags >> 9 & 1, n.head.done = !0), e.adler = n.check = 0, n.mode = yu;
				break;
			case _u:
				for (; u < 32;) {
					if (s === 0) break inf_leave;
					s--, l += r[a++] << u, u += 8;
				}
				e.adler = n.check = Uu(l), l = 0, u = 0, n.mode = vu;
			case vu:
				if (n.havedict === 0) return e.next_out = o, e.avail_out = c, e.next_in = a, e.avail_in = s, n.hold = l, n.bits = u, nu;
				e.adler = n.check = 1, n.mode = yu;
			case yu: if (t === Ql || t === $l) break inf_leave;
			case bu:
				if (n.last) {
					l >>>= u & 7, u -= u & 7, n.mode = Pu;
					break;
				}
				for (; u < 3;) {
					if (s === 0) break inf_leave;
					s--, l += r[a++] << u, u += 8;
				}
				switch (n.last = l & 1, l >>>= 1, --u, l & 3) {
					case 0:
						n.mode = xu;
						break;
					case 1:
						if (ed(n), n.mode = Du, t === $l) {
							l >>>= 2, u -= 2;
							break inf_leave;
						}
						break;
					case 2:
						n.mode = wu;
						break;
					case 3: e.msg = "invalid block type", n.mode = Lu;
				}
				l >>>= 2, u -= 2;
				break;
			case xu:
				for (l >>>= u & 7, u -= u & 7; u < 32;) {
					if (s === 0) break inf_leave;
					s--, l += r[a++] << u, u += 8;
				}
				if ((l & 65535) != (l >>> 16 ^ 65535)) {
					e.msg = "invalid stored block lengths", n.mode = Lu;
					break;
				}
				if (n.length = l & 65535, l = 0, u = 0, n.mode = Su, t === $l) break inf_leave;
			case Su: n.mode = Cu;
			case Cu:
				if (p = n.length, p) {
					if (p > s && (p = s), p > c && (p = c), p === 0) break inf_leave;
					i.set(r.subarray(a, a + p), o), s -= p, a += p, c -= p, o += p, n.length -= p;
					break;
				}
				n.mode = yu;
				break;
			case wu:
				for (; u < 14;) {
					if (s === 0) break inf_leave;
					s--, l += r[a++] << u, u += 8;
				}
				if (n.nlen = (l & 31) + 257, l >>>= 5, u -= 5, n.ndist = (l & 31) + 1, l >>>= 5, u -= 5, n.ncode = (l & 15) + 4, l >>>= 4, u -= 4, n.nlen > 286 || n.ndist > 30) {
					e.msg = "too many length or distance symbols", n.mode = Lu;
					break;
				}
				n.have = 0, n.mode = Tu;
			case Tu:
				for (; n.have < n.ncode;) {
					for (; u < 3;) {
						if (s === 0) break inf_leave;
						s--, l += r[a++] << u, u += 8;
					}
					n.lens[O[n.have++]] = l & 7, l >>>= 3, u -= 3;
				}
				for (; n.have < 19;) n.lens[O[n.have++]] = 0;
				if (n.lencode = n.lendyn, n.lenbits = 7, E = { bits: n.lenbits }, w = ql(Jl, n.lens, 0, 19, n.lencode, 0, n.work, E), n.lenbits = E.bits, w) {
					e.msg = "invalid code lengths set", n.mode = Lu;
					break;
				}
				n.have = 0, n.mode = Eu;
			case Eu:
				for (; n.have < n.nlen + n.ndist;) {
					for (; g = n.lencode[l & (1 << n.lenbits) - 1], _ = g >>> 24, v = g >>> 16 & 255, y = g & 65535, !(_ <= u);) {
						if (s === 0) break inf_leave;
						s--, l += r[a++] << u, u += 8;
					}
					if (y < 16) l >>>= _, u -= _, n.lens[n.have++] = y;
					else {
						if (y === 16) {
							for (D = _ + 2; u < D;) {
								if (s === 0) break inf_leave;
								s--, l += r[a++] << u, u += 8;
							}
							if (l >>>= _, u -= _, n.have === 0) {
								e.msg = "invalid bit length repeat", n.mode = Lu;
								break;
							}
							C = n.lens[n.have - 1], p = 3 + (l & 3), l >>>= 2, u -= 2;
						} else if (y === 17) {
							for (D = _ + 3; u < D;) {
								if (s === 0) break inf_leave;
								s--, l += r[a++] << u, u += 8;
							}
							l >>>= _, u -= _, C = 0, p = 3 + (l & 7), l >>>= 3, u -= 3;
						} else {
							for (D = _ + 7; u < D;) {
								if (s === 0) break inf_leave;
								s--, l += r[a++] << u, u += 8;
							}
							l >>>= _, u -= _, C = 0, p = 11 + (l & 127), l >>>= 7, u -= 7;
						}
						if (n.have + p > n.nlen + n.ndist) {
							e.msg = "invalid bit length repeat", n.mode = Lu;
							break;
						}
						for (; p--;) n.lens[n.have++] = C;
					}
				}
				if (n.mode === Lu) break;
				if (n.lens[256] === 0) {
					e.msg = "invalid code -- missing end-of-block", n.mode = Lu;
					break;
				}
				if (n.lenbits = 9, E = { bits: n.lenbits }, w = ql(Yl, n.lens, 0, n.nlen, n.lencode, 0, n.work, E), n.lenbits = E.bits, w) {
					e.msg = "invalid literal/lengths set", n.mode = Lu;
					break;
				}
				if (n.distbits = 6, n.distcode = n.distdyn, E = { bits: n.distbits }, w = ql(Xl, n.lens, n.nlen, n.ndist, n.distcode, 0, n.work, E), n.distbits = E.bits, w) {
					e.msg = "invalid distances set", n.mode = Lu;
					break;
				}
				if (n.mode = Du, t === $l) break inf_leave;
			case Du: n.mode = Ou;
			case Ou:
				if (s >= 6 && c >= 258) {
					e.next_out = o, e.avail_out = c, e.next_in = a, e.avail_in = s, n.hold = l, n.bits = u, Il(e, f), o = e.next_out, i = e.output, c = e.avail_out, a = e.next_in, r = e.input, s = e.avail_in, l = n.hold, u = n.bits, n.mode === yu && (n.back = -1);
					break;
				}
				for (n.back = 0; g = n.lencode[l & (1 << n.lenbits) - 1], _ = g >>> 24, v = g >>> 16 & 255, y = g & 65535, !(_ <= u);) {
					if (s === 0) break inf_leave;
					s--, l += r[a++] << u, u += 8;
				}
				if (v && !(v & 240)) {
					for (b = _, x = v, S = y; g = n.lencode[S + ((l & (1 << b + x) - 1) >> b)], _ = g >>> 24, v = g >>> 16 & 255, y = g & 65535, !(b + _ <= u);) {
						if (s === 0) break inf_leave;
						s--, l += r[a++] << u, u += 8;
					}
					l >>>= b, u -= b, n.back += b;
				}
				if (l >>>= _, u -= _, n.back += _, n.length = y, v === 0) {
					n.mode = Nu;
					break;
				}
				if (v & 32) {
					n.back = -1, n.mode = yu;
					break;
				}
				if (v & 64) {
					e.msg = "invalid literal/length code", n.mode = Lu;
					break;
				}
				n.extra = v & 15, n.mode = ku;
			case ku:
				if (n.extra) {
					for (D = n.extra; u < D;) {
						if (s === 0) break inf_leave;
						s--, l += r[a++] << u, u += 8;
					}
					n.length += l & (1 << n.extra) - 1, l >>>= n.extra, u -= n.extra, n.back += n.extra;
				}
				n.was = n.length, n.mode = Au;
			case Au:
				for (; g = n.distcode[l & (1 << n.distbits) - 1], _ = g >>> 24, v = g >>> 16 & 255, y = g & 65535, !(_ <= u);) {
					if (s === 0) break inf_leave;
					s--, l += r[a++] << u, u += 8;
				}
				if (!(v & 240)) {
					for (b = _, x = v, S = y; g = n.distcode[S + ((l & (1 << b + x) - 1) >> b)], _ = g >>> 24, v = g >>> 16 & 255, y = g & 65535, !(b + _ <= u);) {
						if (s === 0) break inf_leave;
						s--, l += r[a++] << u, u += 8;
					}
					l >>>= b, u -= b, n.back += b;
				}
				if (l >>>= _, u -= _, n.back += _, v & 64) {
					e.msg = "invalid distance code", n.mode = Lu;
					break;
				}
				n.offset = y, n.extra = v & 15, n.mode = ju;
			case ju:
				if (n.extra) {
					for (D = n.extra; u < D;) {
						if (s === 0) break inf_leave;
						s--, l += r[a++] << u, u += 8;
					}
					n.offset += l & (1 << n.extra) - 1, l >>>= n.extra, u -= n.extra, n.back += n.extra;
				}
				if (n.offset > n.dmax) {
					e.msg = "invalid distance too far back", n.mode = Lu;
					break;
				}
				n.mode = Mu;
			case Mu:
				if (c === 0) break inf_leave;
				if (p = f - c, n.offset > p) {
					if (p = n.offset - p, p > n.whave && n.sane) {
						e.msg = "invalid distance too far back", n.mode = Lu;
						break;
					}
					p > n.wnext ? (p -= n.wnext, m = n.wsize - p) : m = n.wnext - p, p > n.length && (p = n.length), h = n.window;
				} else h = i, m = o - n.offset, p = n.length;
				p > c && (p = c), c -= p, n.length -= p;
				do
					i[o++] = h[m++];
				while (--p);
				n.length === 0 && (n.mode = Ou);
				break;
			case Nu:
				if (c === 0) break inf_leave;
				i[o++] = n.length, c--, n.mode = Ou;
				break;
			case Pu:
				if (n.wrap) {
					for (; u < 32;) {
						if (s === 0) break inf_leave;
						s--, l |= r[a++] << u, u += 8;
					}
					if (f -= c, e.total_out += f, n.total += f, n.wrap & 4 && f && (e.adler = n.check = n.flags ? Gs(n.check, i, f, o - f) : Us(n.check, i, f, o - f)), f = c, n.wrap & 4 && (n.flags ? l : Uu(l)) !== n.check) {
						e.msg = "incorrect data check", n.mode = Lu;
						break;
					}
					l = 0, u = 0;
				}
				n.mode = Fu;
			case Fu:
				if (n.wrap && n.flags) {
					for (; u < 32;) {
						if (s === 0) break inf_leave;
						s--, l += r[a++] << u, u += 8;
					}
					if (n.wrap & 4 && l !== (n.total & 4294967295)) {
						e.msg = "incorrect length check", n.mode = Lu;
						break;
					}
					l = 0, u = 0;
				}
				n.mode = Iu;
			case Iu:
				w = tu;
				break inf_leave;
			case Lu:
				w = iu;
				break inf_leave;
			case Ru: return au;
			case zu:
			default: return ru;
		}
		return e.next_out = o, e.avail_out = c, e.next_in = a, e.avail_in = s, n.hold = l, n.bits = u, (n.wsize || f !== e.avail_out && n.mode < Lu && (n.mode < Pu || t !== Zl)) && td(e, e.output, e.next_out, f - e.avail_out), d -= e.avail_in, f -= e.avail_out, e.total_in += d, e.total_out += f, n.total += f, n.wrap & 4 && f && (e.adler = n.check = n.flags ? Gs(n.check, i, f, e.next_out - f) : Us(n.check, i, f, e.next_out - f)), e.data_type = n.bits + (n.last ? 64 : 0) + (n.mode === yu ? 128 : 0) + (n.mode === Du || n.mode === Su ? 256 : 0), (d === 0 && f === 0 || t === Zl) && w === eu && (w = ou), w;
	},
	inflateEnd: (e) => {
		if (Gu(e)) return ru;
		let t = e.state;
		return t.window &&= null, e.state = null, eu;
	},
	inflateGetHeader: (e, t) => {
		if (Gu(e)) return ru;
		let n = e.state;
		return n.wrap & 2 ? (n.head = t, t.done = !1, eu) : ru;
	},
	inflateSetDictionary: (e, t) => {
		let n = t.length, r, i, a;
		return Gu(e) || (r = e.state, r.wrap !== 0 && r.mode !== vu) ? ru : r.mode === vu && (i = 1, i = Us(i, t, n, 0), i !== r.check) ? iu : (a = td(e, t, n, n), a ? (r.mode = Ru, au) : (r.havedict = 1, eu));
	},
	inflateInfo: "pako inflate (from Nodeca project)"
};
function rd() {
	this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
}
var id = rd, ad = Object.prototype.toString, { Z_NO_FLUSH: od, Z_FINISH: sd, Z_OK: cd, Z_STREAM_END: ld, Z_NEED_DICT: ud, Z_STREAM_ERROR: dd, Z_DATA_ERROR: fd, Z_MEM_ERROR: pd } = qs;
function md(e) {
	this.options = dl.assign({
		chunkSize: 1024 * 64,
		windowBits: 15,
		to: ""
	}, e || {});
	let t = this.options;
	t.raw && t.windowBits >= 0 && t.windowBits < 16 && (t.windowBits = -t.windowBits, t.windowBits === 0 && (t.windowBits = -15)), t.windowBits >= 0 && t.windowBits < 16 && !(e && e.windowBits) && (t.windowBits += 32), t.windowBits > 15 && t.windowBits < 48 && (t.windowBits & 15 || (t.windowBits |= 15)), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new vl(), this.strm.avail_out = 0;
	let n = nd.inflateInit2(this.strm, t.windowBits);
	if (n !== cd || (this.header = new id(), nd.inflateGetHeader(this.strm, this.header), t.dictionary && (typeof t.dictionary == "string" ? t.dictionary = gl.string2buf(t.dictionary) : ad.call(t.dictionary) === "[object ArrayBuffer]" && (t.dictionary = new Uint8Array(t.dictionary)), t.raw && (n = nd.inflateSetDictionary(this.strm, t.dictionary), n !== cd)))) throw Error(Ks[n]);
}
md.prototype.push = function(e, t) {
	let n = this.strm, r = this.options.chunkSize, i = this.options.dictionary, a, o, s;
	if (this.ended) return !1;
	for (o = t === ~~t ? t : t === !0 ? sd : od, ad.call(e) === "[object ArrayBuffer]" ? n.input = new Uint8Array(e) : n.input = e, n.next_in = 0, n.avail_in = n.input.length;;) {
		for (n.avail_out === 0 && (n.output = new Uint8Array(r), n.next_out = 0, n.avail_out = r), a = nd.inflate(n, o), a === ud && i && (a = nd.inflateSetDictionary(n, i), a === cd ? a = nd.inflate(n, o) : a === fd && (a = ud)); n.avail_in > 0 && a === ld && n.state.wrap > 0 && e[n.next_in] !== 0;) nd.inflateReset(n), a = nd.inflate(n, o);
		switch (a) {
			case dd:
			case fd:
			case ud:
			case pd: return this.onEnd(a), this.ended = !0, !1;
		}
		if (s = n.avail_out, n.next_out && (n.avail_out === 0 || a === ld)) if (this.options.to === "string") {
			let e = gl.utf8border(n.output, n.next_out), t = n.next_out - e, i = gl.buf2string(n.output, e);
			n.next_out = t, n.avail_out = r - t, t && n.output.set(n.output.subarray(e, e + t), 0), this.onData(i);
		} else this.onData(n.output.length === n.next_out ? n.output : n.output.subarray(0, n.next_out));
		if (!(a === cd && s === 0)) {
			if (a === ld) return a = nd.inflateEnd(this.strm), this.onEnd(a), this.ended = !0, !0;
			if (n.avail_in === 0) break;
		}
	}
	return !0;
}, md.prototype.onData = function(e) {
	this.chunks.push(e);
}, md.prototype.onEnd = function(e) {
	e === cd && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = dl.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
};
function hd(e, t) {
	let n = new md(t);
	if (n.push(e), n.err) throw n.msg || Ks[n.err];
	return n.result;
}
function gd(e, t) {
	return t ||= {}, t.raw = !0, hd(e, t);
}
var _d = {
	Inflate: md,
	inflate: hd,
	inflateRaw: gd,
	ungzip: hd,
	constants: qs
}, { Deflate: vd, deflate: yd, deflateRaw: bd, gzip: xd } = Nl, { Inflate: Sd, inflate: Cd, inflateRaw: wd, ungzip: Td } = _d, Ed = Sd, Dd = Cd, Od = [];
for (let e = 0; e < 256; e++) {
	let t = e;
	for (let e = 0; e < 8; e++) t & 1 ? t = 3988292384 ^ t >>> 1 : t >>>= 1;
	Od[e] = t;
}
var kd = 4294967295;
function Ad(e, t, n) {
	let r = e;
	for (let e = 0; e < n; e++) r = Od[(r ^ t[e]) & 255] ^ r >>> 8;
	return r;
}
function jd(e, t) {
	return (Ad(kd, e, t) ^ kd) >>> 0;
}
function Md(e, t, n) {
	let r = e.readUint32(), i = jd(new Uint8Array(e.buffer, e.byteOffset + e.offset - t - 4, t), t);
	if (i !== r) throw Error(`CRC mismatch for chunk ${n}. Expected ${r}, found ${i}`);
}
//#endregion
//#region node_modules/fast-png/lib-esm/helpers/unfilter.js
function Nd(e, t, n) {
	for (let r = 0; r < n; r++) t[r] = e[r];
}
function Pd(e, t, n, r) {
	let i = 0;
	for (; i < r; i++) t[i] = e[i];
	for (; i < n; i++) t[i] = e[i] + t[i - r] & 255;
}
function Fd(e, t, n, r) {
	let i = 0;
	if (n.length === 0) for (; i < r; i++) t[i] = e[i];
	else for (; i < r; i++) t[i] = e[i] + n[i] & 255;
}
function Id(e, t, n, r, i) {
	let a = 0;
	if (n.length === 0) {
		for (; a < i; a++) t[a] = e[a];
		for (; a < r; a++) t[a] = e[a] + (t[a - i] >> 1) & 255;
	} else {
		for (; a < i; a++) t[a] = e[a] + (n[a] >> 1) & 255;
		for (; a < r; a++) t[a] = e[a] + (t[a - i] + n[a] >> 1) & 255;
	}
}
function Ld(e, t, n, r, i) {
	let a = 0;
	if (n.length === 0) {
		for (; a < i; a++) t[a] = e[a];
		for (; a < r; a++) t[a] = e[a] + t[a - i] & 255;
	} else {
		for (; a < i; a++) t[a] = e[a] + n[a] & 255;
		for (; a < r; a++) t[a] = e[a] + Rd(t[a - i], n[a], n[a - i]) & 255;
	}
}
function Rd(e, t, n) {
	let r = e + t - n, i = Math.abs(r - e), a = Math.abs(r - t), o = Math.abs(r - n);
	return i <= a && i <= o ? e : a <= o ? t : n;
}
//#endregion
//#region node_modules/fast-png/lib-esm/helpers/applyUnfilter.js
function zd(e, t, n, r, i, a) {
	switch (e) {
		case 0:
			Nd(t, n, i);
			break;
		case 1:
			Pd(t, n, i, a);
			break;
		case 2:
			Fd(t, n, r, i);
			break;
		case 3:
			Id(t, n, r, i, a);
			break;
		case 4:
			Ld(t, n, r, i, a);
			break;
		default: throw Error(`Unsupported filter: ${e}`);
	}
}
//#endregion
//#region node_modules/fast-png/lib-esm/helpers/decodeInterlaceAdam7.js
var Bd = new Uint16Array([255]), Vd = new Uint8Array(Bd.buffer)[0] === 255;
function Hd(e) {
	let { data: t, width: n, height: r, channels: i, depth: a } = e, o = [
		{
			x: 0,
			y: 0,
			xStep: 8,
			yStep: 8
		},
		{
			x: 4,
			y: 0,
			xStep: 8,
			yStep: 8
		},
		{
			x: 0,
			y: 4,
			xStep: 4,
			yStep: 8
		},
		{
			x: 2,
			y: 0,
			xStep: 4,
			yStep: 4
		},
		{
			x: 0,
			y: 2,
			xStep: 2,
			yStep: 4
		},
		{
			x: 1,
			y: 0,
			xStep: 2,
			yStep: 2
		},
		{
			x: 0,
			y: 1,
			xStep: 1,
			yStep: 2
		}
	], s = Math.ceil(a / 8) * i, c = new Uint8Array(r * n * s), l = 0;
	for (let e = 0; e < 7; e++) {
		let i = o[e], a = Math.ceil((n - i.x) / i.xStep), u = Math.ceil((r - i.y) / i.yStep);
		if (a <= 0 || u <= 0) continue;
		let d = a * s, f = new Uint8Array(d);
		for (let e = 0; e < u; e++) {
			let o = t[l++], u = t.subarray(l, l + d);
			l += d;
			let p = new Uint8Array(d);
			zd(o, u, p, f, d, s), f.set(p);
			for (let t = 0; t < a; t++) {
				let a = i.x + t * i.xStep, o = i.y + e * i.yStep;
				if (!(a >= n || o >= r)) for (let e = 0; e < s; e++) c[(o * n + a) * s + e] = p[t * s + e];
			}
		}
	}
	if (a === 16) {
		let e = new Uint16Array(c.buffer);
		if (Vd) for (let t = 0; t < e.length; t++) e[t] = Ud(e[t]);
		return e;
	} else return c;
}
function Ud(e) {
	return (e & 255) << 8 | e >> 8 & 255;
}
//#endregion
//#region node_modules/fast-png/lib-esm/helpers/decodeInterlaceNull.js
var Wd = new Uint16Array([255]), Gd = new Uint8Array(Wd.buffer)[0] === 255, Kd = /* @__PURE__ */ new Uint8Array();
function qd(e) {
	let { data: t, width: n, height: r, channels: i, depth: a } = e, o = Math.ceil(a / 8) * i, s = Math.ceil(a / 8 * i * n), c = new Uint8Array(r * s), l = Kd, u = 0, d, f;
	for (let e = 0; e < r; e++) {
		switch (d = t.subarray(u + 1, u + 1 + s), f = c.subarray(e * s, (e + 1) * s), t[u]) {
			case 0:
				Nd(d, f, s);
				break;
			case 1:
				Pd(d, f, s, o);
				break;
			case 2:
				Fd(d, f, l, s);
				break;
			case 3:
				Id(d, f, l, s, o);
				break;
			case 4:
				Ld(d, f, l, s, o);
				break;
			default: throw Error(`Unsupported filter: ${t[u]}`);
		}
		l = f, u += s + 1;
	}
	if (a === 16) {
		let e = new Uint16Array(c.buffer);
		if (Gd) for (let t = 0; t < e.length; t++) e[t] = Jd(e[t]);
		return e;
	} else return c;
}
function Jd(e) {
	return (e & 255) << 8 | e >> 8 & 255;
}
//#endregion
//#region node_modules/fast-png/lib-esm/helpers/signature.js
var Yd = Uint8Array.of(137, 80, 78, 71, 13, 10, 26, 10);
function Xd(e) {
	if (!Zd(e.readBytes(Yd.length))) throw Error("wrong PNG signature");
}
function Zd(e) {
	if (e.length < Yd.length) return !1;
	for (let t = 0; t < Yd.length; t++) if (e[t] !== Yd[t]) return !1;
	return !0;
}
//#endregion
//#region node_modules/fast-png/lib-esm/helpers/text.js
var Qd = "tEXt", $d = 0, ef = new TextDecoder("latin1");
function tf(e) {
	if (rf(e), e.length === 0 || e.length > 79) throw Error("keyword length must be between 1 and 79");
}
var nf = /^[\u0000-\u00FF]*$/;
function rf(e) {
	if (!nf.test(e)) throw Error("invalid latin1 text");
}
function af(e, t, n) {
	let r = of(t);
	e[r] = sf(t, n - r.length - 1);
}
function of(e) {
	for (e.mark(); e.readByte() !== $d;);
	let t = e.offset;
	e.reset();
	let n = ef.decode(e.readBytes(t - e.offset - 1));
	return e.skip(1), tf(n), n;
}
function sf(e, t) {
	return ef.decode(e.readBytes(t));
}
//#endregion
//#region node_modules/fast-png/lib-esm/internalTypes.js
var cf = {
	UNKNOWN: -1,
	GREYSCALE: 0,
	TRUECOLOUR: 2,
	INDEXED_COLOUR: 3,
	GREYSCALE_ALPHA: 4,
	TRUECOLOUR_ALPHA: 6
}, lf = {
	UNKNOWN: -1,
	DEFLATE: 0
}, uf = {
	UNKNOWN: -1,
	ADAPTIVE: 0
}, df = {
	UNKNOWN: -1,
	NO_INTERLACE: 0,
	ADAM7: 1
}, ff = {
	NONE: 0,
	BACKGROUND: 1,
	PREVIOUS: 2
}, pf = {
	SOURCE: 0,
	OVER: 1
}, mf = class extends Fo {
	_checkCrc;
	_inflator;
	_png;
	_apng;
	_end;
	_hasPalette;
	_palette;
	_hasTransparency;
	_transparency;
	_compressionMethod;
	_filterMethod;
	_interlaceMethod;
	_colorType;
	_isAnimated;
	_numberOfFrames;
	_numberOfPlays;
	_frames;
	_writingDataChunks;
	constructor(e, t = {}) {
		super(e);
		let { checkCrc: n = !1 } = t;
		this._checkCrc = n, this._inflator = new Ed(), this._png = {
			width: -1,
			height: -1,
			channels: -1,
			data: /* @__PURE__ */ new Uint8Array(),
			depth: 1,
			text: {}
		}, this._apng = {
			width: -1,
			height: -1,
			channels: -1,
			depth: 1,
			numberOfFrames: 1,
			numberOfPlays: 0,
			text: {},
			frames: []
		}, this._end = !1, this._hasPalette = !1, this._palette = [], this._hasTransparency = !1, this._transparency = /* @__PURE__ */ new Uint16Array(), this._compressionMethod = lf.UNKNOWN, this._filterMethod = uf.UNKNOWN, this._interlaceMethod = df.UNKNOWN, this._colorType = cf.UNKNOWN, this._isAnimated = !1, this._numberOfFrames = 1, this._numberOfPlays = 0, this._frames = [], this._writingDataChunks = !1, this.setBigEndian();
	}
	decode() {
		for (Xd(this); !this._end;) {
			let e = this.readUint32(), t = this.readChars(4);
			this.decodeChunk(e, t);
		}
		return this.decodeImage(), this._png;
	}
	decodeApng() {
		for (Xd(this); !this._end;) {
			let e = this.readUint32(), t = this.readChars(4);
			this.decodeApngChunk(e, t);
		}
		return this.decodeApngImage(), this._apng;
	}
	decodeChunk(e, t) {
		let n = this.offset;
		switch (t) {
			case "IHDR":
				this.decodeIHDR();
				break;
			case "PLTE":
				this.decodePLTE(e);
				break;
			case "IDAT":
				this.decodeIDAT(e);
				break;
			case "IEND":
				this._end = !0;
				break;
			case "tRNS":
				this.decodetRNS(e);
				break;
			case "iCCP":
				this.decodeiCCP(e);
				break;
			case Qd:
				af(this._png.text, this, e);
				break;
			case "pHYs":
				this.decodepHYs();
				break;
			default:
				this.skip(e);
				break;
		}
		if (this.offset - n !== e) throw Error(`Length mismatch while decoding chunk ${t}`);
		this._checkCrc ? Md(this, e + 4, t) : this.skip(4);
	}
	decodeApngChunk(e, t) {
		let n = this.offset;
		switch (t !== "fdAT" && t !== "IDAT" && this._writingDataChunks && this.pushDataToFrame(), t) {
			case "acTL":
				this.decodeACTL();
				break;
			case "fcTL":
				this.decodeFCTL();
				break;
			case "fdAT":
				this.decodeFDAT(e);
				break;
			default:
				this.decodeChunk(e, t), this.offset = n + e;
				break;
		}
		if (this.offset - n !== e) throw Error(`Length mismatch while decoding chunk ${t}`);
		this._checkCrc ? Md(this, e + 4, t) : this.skip(4);
	}
	decodeIHDR() {
		let e = this._png;
		e.width = this.readUint32(), e.height = this.readUint32(), e.depth = hf(this.readUint8());
		let t = this.readUint8();
		this._colorType = t;
		let n;
		switch (t) {
			case cf.GREYSCALE:
				n = 1;
				break;
			case cf.TRUECOLOUR:
				n = 3;
				break;
			case cf.INDEXED_COLOUR:
				n = 1;
				break;
			case cf.GREYSCALE_ALPHA:
				n = 2;
				break;
			case cf.TRUECOLOUR_ALPHA:
				n = 4;
				break;
			case cf.UNKNOWN:
			default: throw Error(`Unknown color type: ${t}`);
		}
		if (this._png.channels = n, this._compressionMethod = this.readUint8(), this._compressionMethod !== lf.DEFLATE) throw Error(`Unsupported compression method: ${this._compressionMethod}`);
		this._filterMethod = this.readUint8(), this._interlaceMethod = this.readUint8();
	}
	decodeACTL() {
		this._numberOfFrames = this.readUint32(), this._numberOfPlays = this.readUint32(), this._isAnimated = !0;
	}
	decodeFCTL() {
		let e = {
			sequenceNumber: this.readUint32(),
			width: this.readUint32(),
			height: this.readUint32(),
			xOffset: this.readUint32(),
			yOffset: this.readUint32(),
			delayNumber: this.readUint16(),
			delayDenominator: this.readUint16(),
			disposeOp: this.readUint8(),
			blendOp: this.readUint8(),
			data: /* @__PURE__ */ new Uint8Array()
		};
		this._frames.push(e);
	}
	decodePLTE(e) {
		if (e % 3 != 0) throw RangeError(`PLTE field length must be a multiple of 3. Got ${e}`);
		let t = e / 3;
		this._hasPalette = !0;
		let n = [];
		this._palette = n;
		for (let e = 0; e < t; e++) n.push([
			this.readUint8(),
			this.readUint8(),
			this.readUint8()
		]);
	}
	decodeIDAT(e) {
		this._writingDataChunks = !0;
		let t = e, n = this.offset + this.byteOffset;
		if (this._inflator.push(new Uint8Array(this.buffer, n, t)), this._inflator.err) throw Error(`Error while decompressing the data: ${this._inflator.err}`);
		this.skip(e);
	}
	decodeFDAT(e) {
		this._writingDataChunks = !0;
		let t = e, n = this.offset + this.byteOffset;
		if (n += 4, t -= 4, this._inflator.push(new Uint8Array(this.buffer, n, t)), this._inflator.err) throw Error(`Error while decompressing the data: ${this._inflator.err}`);
		this.skip(e);
	}
	decodetRNS(e) {
		switch (this._colorType) {
			case cf.GREYSCALE:
			case cf.TRUECOLOUR:
				if (e % 2 != 0) throw RangeError(`tRNS chunk length must be a multiple of 2. Got ${e}`);
				if (e / 2 > this._png.width * this._png.height) throw Error(`tRNS chunk contains more alpha values than there are pixels (${e / 2} vs ${this._png.width * this._png.height})`);
				this._hasTransparency = !0, this._transparency = new Uint16Array(e / 2);
				for (let t = 0; t < e / 2; t++) this._transparency[t] = this.readUint16();
				break;
			case cf.INDEXED_COLOUR: {
				if (e > this._palette.length) throw Error(`tRNS chunk contains more alpha values than there are palette colors (${e} vs ${this._palette.length})`);
				let t = 0;
				for (; t < e; t++) {
					let e = this.readByte();
					this._palette[t].push(e);
				}
				for (; t < this._palette.length; t++) this._palette[t].push(255);
				break;
			}
			case cf.UNKNOWN:
			case cf.GREYSCALE_ALPHA:
			case cf.TRUECOLOUR_ALPHA:
			default: throw Error(`tRNS chunk is not supported for color type ${this._colorType}`);
		}
	}
	decodeiCCP(e) {
		let t = of(this), n = this.readUint8();
		if (n !== lf.DEFLATE) throw Error(`Unsupported iCCP compression method: ${n}`);
		let r = this.readBytes(e - t.length - 2);
		this._png.iccEmbeddedProfile = {
			name: t,
			profile: Dd(r)
		};
	}
	decodepHYs() {
		let e = this.readUint32(), t = this.readUint32(), n = this.readByte();
		this._png.resolution = {
			x: e,
			y: t,
			unit: n
		};
	}
	decodeApngImage() {
		this._apng.width = this._png.width, this._apng.height = this._png.height, this._apng.channels = this._png.channels, this._apng.depth = this._png.depth, this._apng.numberOfFrames = this._numberOfFrames, this._apng.numberOfPlays = this._numberOfPlays, this._apng.text = this._png.text, this._apng.resolution = this._png.resolution;
		for (let e = 0; e < this._numberOfFrames; e++) {
			let t = {
				sequenceNumber: this._frames[e].sequenceNumber,
				delayNumber: this._frames[e].delayNumber,
				delayDenominator: this._frames[e].delayDenominator,
				data: this._apng.depth === 8 ? new Uint8Array(this._apng.width * this._apng.height * this._apng.channels) : new Uint16Array(this._apng.width * this._apng.height * this._apng.channels)
			}, n = this._frames.at(e);
			if (n) {
				if (n.data = qd({
					data: n.data,
					width: n.width,
					height: n.height,
					channels: this._apng.channels,
					depth: this._apng.depth
				}), this._hasPalette && (this._apng.palette = this._palette), this._hasTransparency && (this._apng.transparency = this._transparency), e === 0 || n.xOffset === 0 && n.yOffset === 0 && n.width === this._png.width && n.height === this._png.height) t.data = n.data;
				else {
					let r = this._apng.frames.at(e - 1);
					this.disposeFrame(n, r, t), this.addFrameDataToCanvas(t, n);
				}
				this._apng.frames.push(t);
			}
		}
		return this._apng;
	}
	disposeFrame(e, t, n) {
		switch (e.disposeOp) {
			case ff.NONE: break;
			case ff.BACKGROUND:
				for (let t = 0; t < this._png.height; t++) for (let r = 0; r < this._png.width; r++) {
					let i = (t * e.width + r) * this._png.channels;
					for (let e = 0; e < this._png.channels; e++) n.data[i + e] = 0;
				}
				break;
			case ff.PREVIOUS:
				n.data.set(t.data);
				break;
			default: throw Error("Unknown disposeOp");
		}
	}
	addFrameDataToCanvas(e, t) {
		let n = 1 << this._png.depth, r = (e, n) => ({
			index: ((e + t.yOffset) * this._png.width + t.xOffset + n) * this._png.channels,
			frameIndex: (e * t.width + n) * this._png.channels
		});
		switch (t.blendOp) {
			case pf.SOURCE:
				for (let n = 0; n < t.height; n++) for (let i = 0; i < t.width; i++) {
					let { index: a, frameIndex: o } = r(n, i);
					for (let n = 0; n < this._png.channels; n++) e.data[a + n] = t.data[o + n];
				}
				break;
			case pf.OVER:
				for (let i = 0; i < t.height; i++) for (let a = 0; a < t.width; a++) {
					let { index: o, frameIndex: s } = r(i, a);
					for (let r = 0; r < this._png.channels; r++) {
						let i = t.data[s + this._png.channels - 1] / n, a = r % (this._png.channels - 1) == 0 ? 1 : t.data[s + r], c = Math.floor(i * a + (1 - i) * e.data[o + r]);
						e.data[o + r] += c;
					}
				}
				break;
			default: throw Error("Unknown blendOp");
		}
	}
	decodeImage() {
		if (this._inflator.err) throw Error(`Error while decompressing the data: ${this._inflator.err}`);
		let e = this._isAnimated ? (this._frames?.at(0)).data : this._inflator.result;
		if (this._filterMethod !== uf.ADAPTIVE) throw Error(`Filter method ${this._filterMethod} not supported`);
		if (this._interlaceMethod === df.NO_INTERLACE) this._png.data = qd({
			data: e,
			width: this._png.width,
			height: this._png.height,
			channels: this._png.channels,
			depth: this._png.depth
		});
		else if (this._interlaceMethod === df.ADAM7) this._png.data = Hd({
			data: e,
			width: this._png.width,
			height: this._png.height,
			channels: this._png.channels,
			depth: this._png.depth
		});
		else throw Error(`Interlace method ${this._interlaceMethod} not supported`);
		this._hasPalette && (this._png.palette = this._palette), this._hasTransparency && (this._png.transparency = this._transparency);
	}
	pushDataToFrame() {
		let e = this._inflator.result, t = this._frames.at(-1);
		t ? t.data = e : this._frames.push({
			sequenceNumber: 0,
			width: this._png.width,
			height: this._png.height,
			xOffset: 0,
			yOffset: 0,
			delayNumber: 0,
			delayDenominator: 0,
			disposeOp: ff.NONE,
			blendOp: pf.SOURCE,
			data: e
		}), this._inflator = new Ed(), this._writingDataChunks = !1;
	}
};
function hf(e) {
	if (e !== 1 && e !== 2 && e !== 4 && e !== 8 && e !== 16) throw Error(`invalid bit depth: ${e}`);
	return e;
}
//#endregion
//#region node_modules/fast-png/lib-esm/types.js
var gf;
(function(e) {
	e[e.UNKNOWN = 0] = "UNKNOWN", e[e.METRE = 1] = "METRE";
})(gf ||= {});
//#endregion
//#region node_modules/fast-png/lib-esm/index.js
function _f(e, t) {
	return new mf(e, t).decode();
}
//#endregion
//#region node_modules/html2canvas/dist/html2canvas.js
var vf = /* @__PURE__ */ s(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self, n.html2canvas = r());
	})(e, (function() {
		var e = function(t, n) {
			return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
				e.__proto__ = t;
			} || function(e, t) {
				for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
			}, e(t, n);
		};
		function t(t, n) {
			if (typeof n != "function" && n !== null) throw TypeError("Class extends value " + String(n) + " is not a constructor or null");
			e(t, n);
			function r() {
				this.constructor = t;
			}
			t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
		}
		var n = function() {
			return n = Object.assign || function(e) {
				for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n], t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
				return e;
			}, n.apply(this, arguments);
		};
		function r(e, t, n, r) {
			function i(e) {
				return e instanceof n ? e : new n(function(t) {
					t(e);
				});
			}
			return new (n ||= Promise)(function(n, a) {
				function o(e) {
					try {
						c(r.next(e));
					} catch (e) {
						a(e);
					}
				}
				function s(e) {
					try {
						c(r.throw(e));
					} catch (e) {
						a(e);
					}
				}
				function c(e) {
					e.done ? n(e.value) : i(e.value).then(o, s);
				}
				c((r = r.apply(e, t || [])).next());
			});
		}
		function i(e, t) {
			var n = {
				label: 0,
				sent: function() {
					if (a[0] & 1) throw a[1];
					return a[1];
				},
				trys: [],
				ops: []
			}, r, i, a, o;
			return o = {
				next: s(0),
				throw: s(1),
				return: s(2)
			}, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
				return this;
			}), o;
			function s(e) {
				return function(t) {
					return c([e, t]);
				};
			}
			function c(o) {
				if (r) throw TypeError("Generator is already executing.");
				for (; n;) try {
					if (r = 1, i && (a = o[0] & 2 ? i.return : o[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, o[1])).done) return a;
					switch (i = 0, a && (o = [o[0] & 2, a.value]), o[0]) {
						case 0:
						case 1:
							a = o;
							break;
						case 4: return n.label++, {
							value: o[1],
							done: !1
						};
						case 5:
							n.label++, i = o[1], o = [0];
							continue;
						case 7:
							o = n.ops.pop(), n.trys.pop();
							continue;
						default:
							if ((a = n.trys, !(a = a.length > 0 && a[a.length - 1])) && (o[0] === 6 || o[0] === 2)) {
								n = 0;
								continue;
							}
							if (o[0] === 3 && (!a || o[1] > a[0] && o[1] < a[3])) {
								n.label = o[1];
								break;
							}
							if (o[0] === 6 && n.label < a[1]) {
								n.label = a[1], a = o;
								break;
							}
							if (a && n.label < a[2]) {
								n.label = a[2], n.ops.push(o);
								break;
							}
							a[2] && n.ops.pop(), n.trys.pop();
							continue;
					}
					o = t.call(e, n);
				} catch (e) {
					o = [6, e], i = 0;
				} finally {
					r = a = 0;
				}
				if (o[0] & 5) throw o[1];
				return {
					value: o[0] ? o[1] : void 0,
					done: !0
				};
			}
		}
		function a(e, t, n) {
			if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++) (a || !(r in t)) && (a ||= Array.prototype.slice.call(t, 0, r), a[r] = t[r]);
			return e.concat(a || t);
		}
		for (var o = function() {
			function e(e, t, n, r) {
				this.left = e, this.top = t, this.width = n, this.height = r;
			}
			return e.prototype.add = function(t, n, r, i) {
				return new e(this.left + t, this.top + n, this.width + r, this.height + i);
			}, e.fromClientRect = function(t, n) {
				return new e(n.left + t.windowBounds.left, n.top + t.windowBounds.top, n.width, n.height);
			}, e.fromDOMRectList = function(t, n) {
				var r = Array.from(n).find(function(e) {
					return e.width !== 0;
				});
				return r ? new e(r.left + t.windowBounds.left, r.top + t.windowBounds.top, r.width, r.height) : e.EMPTY;
			}, e.EMPTY = new e(0, 0, 0, 0), e;
		}(), s = function(e, t) {
			return o.fromClientRect(e, t.getBoundingClientRect());
		}, c = function(e) {
			var t = e.body, n = e.documentElement;
			if (!t || !n) throw Error("Unable to get document size");
			return new o(0, 0, Math.max(Math.max(t.scrollWidth, n.scrollWidth), Math.max(t.offsetWidth, n.offsetWidth), Math.max(t.clientWidth, n.clientWidth)), Math.max(Math.max(t.scrollHeight, n.scrollHeight), Math.max(t.offsetHeight, n.offsetHeight), Math.max(t.clientHeight, n.clientHeight)));
		}, l = function(e) {
			for (var t = [], n = 0, r = e.length; n < r;) {
				var i = e.charCodeAt(n++);
				if (i >= 55296 && i <= 56319 && n < r) {
					var a = e.charCodeAt(n++);
					(a & 64512) == 56320 ? t.push(((i & 1023) << 10) + (a & 1023) + 65536) : (t.push(i), n--);
				} else t.push(i);
			}
			return t;
		}, u = function() {
			var e = [...arguments];
			if (String.fromCodePoint) return String.fromCodePoint.apply(String, e);
			var t = e.length;
			if (!t) return "";
			for (var n = [], r = -1, i = ""; ++r < t;) {
				var a = e[r];
				a <= 65535 ? n.push(a) : (a -= 65536, n.push((a >> 10) + 55296, a % 1024 + 56320)), (r + 1 === t || n.length > 16384) && (i += String.fromCharCode.apply(String, n), n.length = 0);
			}
			return i;
		}, d = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", f = typeof Uint8Array > "u" ? [] : /* @__PURE__ */ new Uint8Array(256), p = 0; p < d.length; p++) f[d.charCodeAt(p)] = p;
		for (var m = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", h = typeof Uint8Array > "u" ? [] : /* @__PURE__ */ new Uint8Array(256), g = 0; g < m.length; g++) h[m.charCodeAt(g)] = g;
		for (var _ = function(e) {
			var t = e.length * .75, n = e.length, r, i = 0, a, o, s, c;
			e[e.length - 1] === "=" && (t--, e[e.length - 2] === "=" && t--);
			var l = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && Uint8Array.prototype.slice !== void 0 ? new ArrayBuffer(t) : Array(t), u = Array.isArray(l) ? l : new Uint8Array(l);
			for (r = 0; r < n; r += 4) a = h[e.charCodeAt(r)], o = h[e.charCodeAt(r + 1)], s = h[e.charCodeAt(r + 2)], c = h[e.charCodeAt(r + 3)], u[i++] = a << 2 | o >> 4, u[i++] = (o & 15) << 4 | s >> 2, u[i++] = (s & 3) << 6 | c & 63;
			return l;
		}, v = function(e) {
			for (var t = e.length, n = [], r = 0; r < t; r += 2) n.push(e[r + 1] << 8 | e[r]);
			return n;
		}, y = function(e) {
			for (var t = e.length, n = [], r = 0; r < t; r += 4) n.push(e[r + 3] << 24 | e[r + 2] << 16 | e[r + 1] << 8 | e[r]);
			return n;
		}, b = 5, x = 11, S = 2, C = x - b, w = 65536 >> b, T = (1 << b) - 1, E = w + (1024 >> b) + 32, D = 65536 >> x, O = (1 << C) - 1, k = function(e, t, n) {
			return e.slice ? e.slice(t, n) : new Uint16Array(Array.prototype.slice.call(e, t, n));
		}, A = function(e, t, n) {
			return e.slice ? e.slice(t, n) : new Uint32Array(Array.prototype.slice.call(e, t, n));
		}, j = function(e, t) {
			var n = _(e), r = Array.isArray(n) ? y(n) : new Uint32Array(n), i = Array.isArray(n) ? v(n) : new Uint16Array(n), a = 24, o = k(i, a / 2, r[4] / 2), s = r[5] === 2 ? k(i, (a + r[4]) / 2) : A(r, Math.ceil((a + r[4]) / 4));
			return new M(r[0], r[1], r[2], r[3], o, s);
		}, M = function() {
			function e(e, t, n, r, i, a) {
				this.initialValue = e, this.errorValue = t, this.highStart = n, this.highValueIndex = r, this.index = i, this.data = a;
			}
			return e.prototype.get = function(e) {
				var t;
				if (e >= 0) {
					if (e < 55296 || e > 56319 && e <= 65535) return t = this.index[e >> b], t = (t << S) + (e & T), this.data[t];
					if (e <= 65535) return t = this.index[w + (e - 55296 >> b)], t = (t << S) + (e & T), this.data[t];
					if (e < this.highStart) return t = E - D + (e >> x), t = this.index[t], t += e >> b & O, t = this.index[t], t = (t << S) + (e & T), this.data[t];
					if (e <= 1114111) return this.data[this.highValueIndex];
				}
				return this.errorValue;
			}, e;
		}(), N = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", P = typeof Uint8Array > "u" ? [] : /* @__PURE__ */ new Uint8Array(256), F = 0; F < N.length; F++) P[N.charCodeAt(F)] = F;
		var I = "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", ee = 50, L = 1, R = 2, te = 3, z = 4, ne = 5, re = 7, ie = 8, ae = 9, B = 10, oe = 11, se = 12, ce = 13, le = 14, V = 15, ue = 16, de = 17, fe = 18, pe = 19, me = 20, he = 21, ge = 22, _e = 23, ve = 24, ye = 25, be = 26, xe = 27, Se = 28, Ce = 29, we = 30, Te = 31, Ee = 32, De = 33, H = 34, Oe = 35, ke = 36, Ae = 37, je = 38, Me = 39, Ne = 40, Pe = 41, Fe = 42, Ie = 43, Le = [9001, 65288], Re = "!", ze = "×", Be = "÷", Ve = j(I), He = [we, ke], Ue = [
			L,
			R,
			te,
			ne
		], We = [B, ie], Ge = [xe, be], Ke = Ue.concat(We), qe = [
			je,
			Me,
			Ne,
			H,
			Oe
		], Je = [V, ce], Ye = function(e, t) {
			t === void 0 && (t = "strict");
			var n = [], r = [], i = [];
			return e.forEach(function(e, a) {
				var o = Ve.get(e);
				if (o > ee ? (i.push(!0), o -= ee) : i.push(!1), [
					"normal",
					"auto",
					"loose"
				].indexOf(t) !== -1 && [
					8208,
					8211,
					12316,
					12448
				].indexOf(e) !== -1) return r.push(a), n.push(ue);
				if (o === z || o === oe) {
					if (a === 0) return r.push(a), n.push(we);
					var s = n[a - 1];
					return Ke.indexOf(s) === -1 ? (r.push(r[a - 1]), n.push(s)) : (r.push(a), n.push(we));
				}
				if (r.push(a), o === Te) return n.push(t === "strict" ? he : Ae);
				if (o === Fe || o === Ce) return n.push(we);
				if (o === Ie) return e >= 131072 && e <= 196605 || e >= 196608 && e <= 262141 ? n.push(Ae) : n.push(we);
				n.push(o);
			}), [
				r,
				n,
				i
			];
		}, Xe = function(e, t, n, r) {
			var i = r[n];
			if (Array.isArray(e) ? e.indexOf(i) !== -1 : e === i) for (var a = n; a <= r.length;) {
				a++;
				var o = r[a];
				if (o === t) return !0;
				if (o !== B) break;
			}
			if (i === B) for (var a = n; a > 0;) {
				a--;
				var s = r[a];
				if (Array.isArray(e) ? e.indexOf(s) !== -1 : e === s) for (var c = n; c <= r.length;) {
					c++;
					var o = r[c];
					if (o === t) return !0;
					if (o !== B) break;
				}
				if (s !== B) break;
			}
			return !1;
		}, Ze = function(e, t) {
			for (var n = e; n >= 0;) {
				var r = t[n];
				if (r === B) n--;
				else return r;
			}
			return 0;
		}, Qe = function(e, t, n, r, i) {
			if (n[r] === 0) return ze;
			var a = r - 1;
			if (Array.isArray(i) && i[a] === !0) return ze;
			var o = a - 1, s = a + 1, c = t[a], l = o >= 0 ? t[o] : 0, u = t[s];
			if (c === R && u === te) return ze;
			if (Ue.indexOf(c) !== -1) return Re;
			if (Ue.indexOf(u) !== -1 || We.indexOf(u) !== -1) return ze;
			if (Ze(a, t) === ie) return Be;
			if (Ve.get(e[a]) === oe || (c === Ee || c === De) && Ve.get(e[s]) === oe || c === re || u === re || c === ae || [
				B,
				ce,
				V
			].indexOf(c) === -1 && u === ae || [
				de,
				fe,
				pe,
				ve,
				Se
			].indexOf(u) !== -1 || Ze(a, t) === ge || Xe(_e, ge, a, t) || Xe([de, fe], he, a, t) || Xe(se, se, a, t)) return ze;
			if (c === B) return Be;
			if (c === _e || u === _e) return ze;
			if (u === ue || c === ue) return Be;
			if ([
				ce,
				V,
				he
			].indexOf(u) !== -1 || c === le || l === ke && Je.indexOf(c) !== -1 || c === Se && u === ke || u === me || He.indexOf(u) !== -1 && c === ye || He.indexOf(c) !== -1 && u === ye || c === xe && [
				Ae,
				Ee,
				De
			].indexOf(u) !== -1 || [
				Ae,
				Ee,
				De
			].indexOf(c) !== -1 && u === be || He.indexOf(c) !== -1 && Ge.indexOf(u) !== -1 || Ge.indexOf(c) !== -1 && He.indexOf(u) !== -1 || [xe, be].indexOf(c) !== -1 && (u === ye || [ge, V].indexOf(u) !== -1 && t[s + 1] === ye) || [ge, V].indexOf(c) !== -1 && u === ye || c === ye && [
				ye,
				Se,
				ve
			].indexOf(u) !== -1) return ze;
			if ([
				ye,
				Se,
				ve,
				de,
				fe
			].indexOf(u) !== -1) for (var d = a; d >= 0;) {
				var f = t[d];
				if (f === ye) return ze;
				if ([Se, ve].indexOf(f) !== -1) d--;
				else break;
			}
			if ([xe, be].indexOf(u) !== -1) for (var d = [de, fe].indexOf(c) === -1 ? a : o; d >= 0;) {
				var f = t[d];
				if (f === ye) return ze;
				if ([Se, ve].indexOf(f) !== -1) d--;
				else break;
			}
			if (je === c && [
				je,
				Me,
				H,
				Oe
			].indexOf(u) !== -1 || [Me, H].indexOf(c) !== -1 && [Me, Ne].indexOf(u) !== -1 || [Ne, Oe].indexOf(c) !== -1 && u === Ne || qe.indexOf(c) !== -1 && [me, be].indexOf(u) !== -1 || qe.indexOf(u) !== -1 && c === xe || He.indexOf(c) !== -1 && He.indexOf(u) !== -1 || c === ve && He.indexOf(u) !== -1 || He.concat(ye).indexOf(c) !== -1 && u === ge && Le.indexOf(e[s]) === -1 || He.concat(ye).indexOf(u) !== -1 && c === fe) return ze;
			if (c === Pe && u === Pe) {
				for (var p = n[a], m = 1; p > 0 && (p--, t[p] === Pe);) m++;
				if (m % 2 != 0) return ze;
			}
			return c === Ee && u === De ? ze : Be;
		}, $e = function(e, t) {
			t ||= {
				lineBreak: "normal",
				wordBreak: "normal"
			};
			var n = Ye(e, t.lineBreak), r = n[0], i = n[1], a = n[2];
			(t.wordBreak === "break-all" || t.wordBreak === "break-word") && (i = i.map(function(e) {
				return [
					ye,
					we,
					Fe
				].indexOf(e) === -1 ? e : Ae;
			}));
			var o = t.wordBreak === "keep-all" ? a.map(function(t, n) {
				return t && e[n] >= 19968 && e[n] <= 40959;
			}) : void 0;
			return [
				r,
				i,
				o
			];
		}, et = function() {
			function e(e, t, n, r) {
				this.codePoints = e, this.required = t === Re, this.start = n, this.end = r;
			}
			return e.prototype.slice = function() {
				return u.apply(void 0, this.codePoints.slice(this.start, this.end));
			}, e;
		}(), tt = function(e, t) {
			var n = l(e), r = $e(n, t), i = r[0], a = r[1], o = r[2], s = n.length, c = 0, u = 0;
			return { next: function() {
				if (u >= s) return {
					done: !0,
					value: null
				};
				for (var e = ze; u < s && (e = Qe(n, a, i, ++u, o)) === ze;);
				if (e !== ze || u === s) {
					var t = new et(n, e, c, u);
					return c = u, {
						value: t,
						done: !1
					};
				}
				return {
					done: !0,
					value: null
				};
			} };
		}, nt = 1, rt = 2, it = 4, at = 8, ot = 10, st = 47, ct = 92, lt = 9, ut = 32, dt = 34, ft = 61, pt = 35, mt = 36, ht = 37, gt = 39, _t = 40, vt = 41, yt = 95, bt = 45, xt = 33, St = 60, Ct = 62, wt = 64, Tt = 91, Et = 93, Dt = 61, Ot = 123, U = 63, W = 125, kt = 124, At = 126, jt = 128, Mt = 65533, Nt = 42, Pt = 43, Ft = 44, It = 58, Lt = 59, Rt = 46, zt = 0, Bt = 8, Vt = 11, Ht = 14, Ut = 31, Wt = 127, Gt = -1, Kt = 48, qt = 97, Jt = 101, Yt = 102, Xt = 117, Zt = 122, Qt = 65, $t = 69, en = 70, tn = 85, nn = 90, rn = function(e) {
			return e >= Kt && e <= 57;
		}, an = function(e) {
			return e >= 55296 && e <= 57343;
		}, on = function(e) {
			return rn(e) || e >= Qt && e <= en || e >= qt && e <= Yt;
		}, sn = function(e) {
			return e >= qt && e <= Zt;
		}, cn = function(e) {
			return e >= Qt && e <= nn;
		}, ln = function(e) {
			return sn(e) || cn(e);
		}, un = function(e) {
			return e >= jt;
		}, dn = function(e) {
			return e === ot || e === lt || e === ut;
		}, fn = function(e) {
			return ln(e) || un(e) || e === yt;
		}, pn = function(e) {
			return fn(e) || rn(e) || e === bt;
		}, mn = function(e) {
			return e >= zt && e <= Bt || e === Vt || e >= Ht && e <= Ut || e === Wt;
		}, hn = function(e, t) {
			return e === ct && t !== ot;
		}, gn = function(e, t, n) {
			return e === bt ? fn(t) || hn(t, n) : fn(e) ? !0 : !!(e === ct && hn(e, t));
		}, _n = function(e, t, n) {
			return e === Pt || e === bt ? rn(t) ? !0 : t === Rt && rn(n) : rn(e === Rt ? t : e);
		}, vn = function(e) {
			var t = 0, n = 1;
			(e[t] === Pt || e[t] === bt) && (e[t] === bt && (n = -1), t++);
			for (var r = []; rn(e[t]);) r.push(e[t++]);
			var i = r.length ? parseInt(u.apply(void 0, r), 10) : 0;
			e[t] === Rt && t++;
			for (var a = []; rn(e[t]);) a.push(e[t++]);
			var o = a.length, s = o ? parseInt(u.apply(void 0, a), 10) : 0;
			(e[t] === $t || e[t] === Jt) && t++;
			var c = 1;
			(e[t] === Pt || e[t] === bt) && (e[t] === bt && (c = -1), t++);
			for (var l = []; rn(e[t]);) l.push(e[t++]);
			var d = l.length ? parseInt(u.apply(void 0, l), 10) : 0;
			return n * (i + s * 10 ** -o) * 10 ** (c * d);
		}, yn = { type: 2 }, bn = { type: 3 }, xn = { type: 4 }, Sn = { type: 13 }, Cn = { type: 8 }, wn = { type: 21 }, Tn = { type: 9 }, En = { type: 10 }, Dn = { type: 11 }, On = { type: 12 }, kn = { type: 14 }, An = { type: 23 }, jn = { type: 1 }, Mn = { type: 25 }, Nn = { type: 24 }, Pn = { type: 26 }, Fn = { type: 27 }, In = { type: 28 }, Ln = { type: 29 }, Rn = { type: 31 }, zn = { type: 32 }, Bn = function() {
			function e() {
				this._value = [];
			}
			return e.prototype.write = function(e) {
				this._value = this._value.concat(l(e));
			}, e.prototype.read = function() {
				for (var e = [], t = this.consumeToken(); t !== zn;) e.push(t), t = this.consumeToken();
				return e;
			}, e.prototype.consumeToken = function() {
				var e = this.consumeCodePoint();
				switch (e) {
					case dt: return this.consumeStringToken(dt);
					case pt:
						var t = this.peekCodePoint(0), n = this.peekCodePoint(1), r = this.peekCodePoint(2);
						if (pn(t) || hn(n, r)) {
							var i = gn(t, n, r) ? rt : nt, a = this.consumeName();
							return {
								type: 5,
								value: a,
								flags: i
							};
						}
						break;
					case mt:
						if (this.peekCodePoint(0) === ft) return this.consumeCodePoint(), Sn;
						break;
					case gt: return this.consumeStringToken(gt);
					case _t: return yn;
					case vt: return bn;
					case Nt:
						if (this.peekCodePoint(0) === ft) return this.consumeCodePoint(), kn;
						break;
					case Pt:
						if (_n(e, this.peekCodePoint(0), this.peekCodePoint(1))) return this.reconsumeCodePoint(e), this.consumeNumericToken();
						break;
					case Ft: return xn;
					case bt:
						var o = e, s = this.peekCodePoint(0), c = this.peekCodePoint(1);
						if (_n(o, s, c)) return this.reconsumeCodePoint(e), this.consumeNumericToken();
						if (gn(o, s, c)) return this.reconsumeCodePoint(e), this.consumeIdentLikeToken();
						if (s === bt && c === Ct) return this.consumeCodePoint(), this.consumeCodePoint(), Nn;
						break;
					case Rt:
						if (_n(e, this.peekCodePoint(0), this.peekCodePoint(1))) return this.reconsumeCodePoint(e), this.consumeNumericToken();
						break;
					case st:
						if (this.peekCodePoint(0) === Nt) for (this.consumeCodePoint();;) {
							var l = this.consumeCodePoint();
							if (l === Nt && (l = this.consumeCodePoint(), l === st) || l === Gt) return this.consumeToken();
						}
						break;
					case It: return Pn;
					case Lt: return Fn;
					case St:
						if (this.peekCodePoint(0) === xt && this.peekCodePoint(1) === bt && this.peekCodePoint(2) === bt) return this.consumeCodePoint(), this.consumeCodePoint(), Mn;
						break;
					case wt:
						if (gn(this.peekCodePoint(0), this.peekCodePoint(1), this.peekCodePoint(2))) {
							var a = this.consumeName();
							return {
								type: 7,
								value: a
							};
						}
						break;
					case Tt: return In;
					case ct:
						if (hn(e, this.peekCodePoint(0))) return this.reconsumeCodePoint(e), this.consumeIdentLikeToken();
						break;
					case Et: return Ln;
					case Dt:
						if (this.peekCodePoint(0) === ft) return this.consumeCodePoint(), Cn;
						break;
					case Ot: return Dn;
					case W: return On;
					case Xt:
					case tn:
						var d = this.peekCodePoint(0), f = this.peekCodePoint(1);
						return d === Pt && (on(f) || f === U) && (this.consumeCodePoint(), this.consumeUnicodeRangeToken()), this.reconsumeCodePoint(e), this.consumeIdentLikeToken();
					case kt:
						if (this.peekCodePoint(0) === ft) return this.consumeCodePoint(), Tn;
						if (this.peekCodePoint(0) === kt) return this.consumeCodePoint(), wn;
						break;
					case At:
						if (this.peekCodePoint(0) === ft) return this.consumeCodePoint(), En;
						break;
					case Gt: return zn;
				}
				return dn(e) ? (this.consumeWhiteSpace(), Rn) : rn(e) ? (this.reconsumeCodePoint(e), this.consumeNumericToken()) : fn(e) ? (this.reconsumeCodePoint(e), this.consumeIdentLikeToken()) : {
					type: 6,
					value: u(e)
				};
			}, e.prototype.consumeCodePoint = function() {
				var e = this._value.shift();
				return e === void 0 ? -1 : e;
			}, e.prototype.reconsumeCodePoint = function(e) {
				this._value.unshift(e);
			}, e.prototype.peekCodePoint = function(e) {
				return e >= this._value.length ? -1 : this._value[e];
			}, e.prototype.consumeUnicodeRangeToken = function() {
				for (var e = [], t = this.consumeCodePoint(); on(t) && e.length < 6;) e.push(t), t = this.consumeCodePoint();
				for (var n = !1; t === U && e.length < 6;) e.push(t), t = this.consumeCodePoint(), n = !0;
				if (n) {
					var r = parseInt(u.apply(void 0, e.map(function(e) {
						return e === U ? Kt : e;
					})), 16), i = parseInt(u.apply(void 0, e.map(function(e) {
						return e === U ? en : e;
					})), 16);
					return {
						type: 30,
						start: r,
						end: i
					};
				}
				var a = parseInt(u.apply(void 0, e), 16);
				if (this.peekCodePoint(0) === bt && on(this.peekCodePoint(1))) {
					this.consumeCodePoint(), t = this.consumeCodePoint();
					for (var o = []; on(t) && o.length < 6;) o.push(t), t = this.consumeCodePoint();
					var i = parseInt(u.apply(void 0, o), 16);
					return {
						type: 30,
						start: a,
						end: i
					};
				} else return {
					type: 30,
					start: a,
					end: a
				};
			}, e.prototype.consumeIdentLikeToken = function() {
				var e = this.consumeName();
				return e.toLowerCase() === "url" && this.peekCodePoint(0) === _t ? (this.consumeCodePoint(), this.consumeUrlToken()) : this.peekCodePoint(0) === _t ? (this.consumeCodePoint(), {
					type: 19,
					value: e
				}) : {
					type: 20,
					value: e
				};
			}, e.prototype.consumeUrlToken = function() {
				var e = [];
				if (this.consumeWhiteSpace(), this.peekCodePoint(0) === Gt) return {
					type: 22,
					value: ""
				};
				var t = this.peekCodePoint(0);
				if (t === gt || t === dt) {
					var n = this.consumeStringToken(this.consumeCodePoint());
					return n.type === 0 && (this.consumeWhiteSpace(), this.peekCodePoint(0) === Gt || this.peekCodePoint(0) === vt) ? (this.consumeCodePoint(), {
						type: 22,
						value: n.value
					}) : (this.consumeBadUrlRemnants(), An);
				}
				for (;;) {
					var r = this.consumeCodePoint();
					if (r === Gt || r === vt) return {
						type: 22,
						value: u.apply(void 0, e)
					};
					if (dn(r)) return this.consumeWhiteSpace(), this.peekCodePoint(0) === Gt || this.peekCodePoint(0) === vt ? (this.consumeCodePoint(), {
						type: 22,
						value: u.apply(void 0, e)
					}) : (this.consumeBadUrlRemnants(), An);
					if (r === dt || r === gt || r === _t || mn(r)) return this.consumeBadUrlRemnants(), An;
					if (r === ct) if (hn(r, this.peekCodePoint(0))) e.push(this.consumeEscapedCodePoint());
					else return this.consumeBadUrlRemnants(), An;
					else e.push(r);
				}
			}, e.prototype.consumeWhiteSpace = function() {
				for (; dn(this.peekCodePoint(0));) this.consumeCodePoint();
			}, e.prototype.consumeBadUrlRemnants = function() {
				for (;;) {
					var e = this.consumeCodePoint();
					if (e === vt || e === Gt) return;
					hn(e, this.peekCodePoint(0)) && this.consumeEscapedCodePoint();
				}
			}, e.prototype.consumeStringSlice = function(e) {
				for (var t = 5e4, n = ""; e > 0;) {
					var r = Math.min(t, e);
					n += u.apply(void 0, this._value.splice(0, r)), e -= r;
				}
				return this._value.shift(), n;
			}, e.prototype.consumeStringToken = function(e) {
				var t = "", n = 0;
				do {
					var r = this._value[n];
					if (r === Gt || r === void 0 || r === e) return t += this.consumeStringSlice(n), {
						type: 0,
						value: t
					};
					if (r === ot) return this._value.splice(0, n), jn;
					if (r === ct) {
						var i = this._value[n + 1];
						i !== Gt && i !== void 0 && (i === ot ? (t += this.consumeStringSlice(n), n = -1, this._value.shift()) : hn(r, i) && (t += this.consumeStringSlice(n), t += u(this.consumeEscapedCodePoint()), n = -1));
					}
					n++;
				} while (!0);
			}, e.prototype.consumeNumber = function() {
				var e = [], t = it, n = this.peekCodePoint(0);
				for ((n === Pt || n === bt) && e.push(this.consumeCodePoint()); rn(this.peekCodePoint(0));) e.push(this.consumeCodePoint());
				n = this.peekCodePoint(0);
				var r = this.peekCodePoint(1);
				if (n === Rt && rn(r)) for (e.push(this.consumeCodePoint(), this.consumeCodePoint()), t = at; rn(this.peekCodePoint(0));) e.push(this.consumeCodePoint());
				n = this.peekCodePoint(0), r = this.peekCodePoint(1);
				var i = this.peekCodePoint(2);
				if ((n === $t || n === Jt) && ((r === Pt || r === bt) && rn(i) || rn(r))) for (e.push(this.consumeCodePoint(), this.consumeCodePoint()), t = at; rn(this.peekCodePoint(0));) e.push(this.consumeCodePoint());
				return [vn(e), t];
			}, e.prototype.consumeNumericToken = function() {
				var e = this.consumeNumber(), t = e[0], n = e[1], r = this.peekCodePoint(0);
				return gn(r, this.peekCodePoint(1), this.peekCodePoint(2)) ? {
					type: 15,
					number: t,
					flags: n,
					unit: this.consumeName()
				} : r === ht ? (this.consumeCodePoint(), {
					type: 16,
					number: t,
					flags: n
				}) : {
					type: 17,
					number: t,
					flags: n
				};
			}, e.prototype.consumeEscapedCodePoint = function() {
				var e = this.consumeCodePoint();
				if (on(e)) {
					for (var t = u(e); on(this.peekCodePoint(0)) && t.length < 6;) t += u(this.consumeCodePoint());
					dn(this.peekCodePoint(0)) && this.consumeCodePoint();
					var n = parseInt(t, 16);
					return n === 0 || an(n) || n > 1114111 ? Mt : n;
				}
				return e === Gt ? Mt : e;
			}, e.prototype.consumeName = function() {
				for (var e = "";;) {
					var t = this.consumeCodePoint();
					if (pn(t)) e += u(t);
					else if (hn(t, this.peekCodePoint(0))) e += u(this.consumeEscapedCodePoint());
					else return this.reconsumeCodePoint(t), e;
				}
			}, e;
		}(), Vn = function() {
			function e(e) {
				this._tokens = e;
			}
			return e.create = function(t) {
				var n = new Bn();
				return n.write(t), new e(n.read());
			}, e.parseValue = function(t) {
				return e.create(t).parseComponentValue();
			}, e.parseValues = function(t) {
				return e.create(t).parseComponentValues();
			}, e.prototype.parseComponentValue = function() {
				for (var e = this.consumeToken(); e.type === 31;) e = this.consumeToken();
				if (e.type === 32) throw SyntaxError("Error parsing CSS component value, unexpected EOF");
				this.reconsumeToken(e);
				var t = this.consumeComponentValue();
				do
					e = this.consumeToken();
				while (e.type === 31);
				if (e.type === 32) return t;
				throw SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
			}, e.prototype.parseComponentValues = function() {
				for (var e = [];;) {
					var t = this.consumeComponentValue();
					if (t.type === 32) return e;
					e.push(t), e.push();
				}
			}, e.prototype.consumeComponentValue = function() {
				var e = this.consumeToken();
				switch (e.type) {
					case 11:
					case 28:
					case 2: return this.consumeSimpleBlock(e.type);
					case 19: return this.consumeFunction(e);
				}
				return e;
			}, e.prototype.consumeSimpleBlock = function(e) {
				for (var t = {
					type: e,
					values: []
				}, n = this.consumeToken();;) {
					if (n.type === 32 || Xn(n, e)) return t;
					this.reconsumeToken(n), t.values.push(this.consumeComponentValue()), n = this.consumeToken();
				}
			}, e.prototype.consumeFunction = function(e) {
				for (var t = {
					name: e.value,
					values: [],
					type: 18
				};;) {
					var n = this.consumeToken();
					if (n.type === 32 || n.type === 3) return t;
					this.reconsumeToken(n), t.values.push(this.consumeComponentValue());
				}
			}, e.prototype.consumeToken = function() {
				var e = this._tokens.shift();
				return e === void 0 ? zn : e;
			}, e.prototype.reconsumeToken = function(e) {
				this._tokens.unshift(e);
			}, e;
		}(), Hn = function(e) {
			return e.type === 15;
		}, Un = function(e) {
			return e.type === 17;
		}, Wn = function(e) {
			return e.type === 20;
		}, Gn = function(e) {
			return e.type === 0;
		}, Kn = function(e, t) {
			return Wn(e) && e.value === t;
		}, qn = function(e) {
			return e.type !== 31;
		}, Jn = function(e) {
			return e.type !== 31 && e.type !== 4;
		}, Yn = function(e) {
			var t = [], n = [];
			return e.forEach(function(e) {
				if (e.type === 4) {
					if (n.length === 0) throw Error("Error parsing function args, zero tokens for arg");
					t.push(n), n = [];
					return;
				}
				e.type !== 31 && n.push(e);
			}), n.length && t.push(n), t;
		}, Xn = function(e, t) {
			return t === 11 && e.type === 12 || t === 28 && e.type === 29 || t === 2 && e.type === 3;
		}, Zn = function(e) {
			return e.type === 17 || e.type === 15;
		}, Qn = function(e) {
			return e.type === 16 || Zn(e);
		}, $n = function(e) {
			return e.length > 1 ? [e[0], e[1]] : [e[0]];
		}, er = {
			type: 17,
			number: 0,
			flags: it
		}, tr = {
			type: 16,
			number: 50,
			flags: it
		}, nr = {
			type: 16,
			number: 100,
			flags: it
		}, rr = function(e, t, n) {
			var r = e[0], i = e[1];
			return [ir(r, t), ir(i === void 0 ? r : i, n)];
		}, ir = function(e, t) {
			if (e.type === 16) return e.number / 100 * t;
			if (Hn(e)) switch (e.unit) {
				case "rem":
				case "em": return 16 * e.number;
				default: return e.number;
			}
			return e.number;
		}, ar = "deg", or = "grad", sr = "rad", cr = "turn", lr = {
			name: "angle",
			parse: function(e, t) {
				if (t.type === 15) switch (t.unit) {
					case ar: return Math.PI * t.number / 180;
					case or: return Math.PI / 200 * t.number;
					case sr: return t.number;
					case cr: return Math.PI * 2 * t.number;
				}
				throw Error("Unsupported angle type");
			}
		}, ur = function(e) {
			return e.type === 15 && (e.unit === ar || e.unit === or || e.unit === sr || e.unit === cr);
		}, dr = function(e) {
			switch (e.filter(Wn).map(function(e) {
				return e.value;
			}).join(" ")) {
				case "to bottom right":
				case "to right bottom":
				case "left top":
				case "top left": return [er, er];
				case "to top":
				case "bottom": return fr(0);
				case "to bottom left":
				case "to left bottom":
				case "right top":
				case "top right": return [er, nr];
				case "to right":
				case "left": return fr(90);
				case "to top left":
				case "to left top":
				case "right bottom":
				case "bottom right": return [nr, nr];
				case "to bottom":
				case "top": return fr(180);
				case "to top right":
				case "to right top":
				case "left bottom":
				case "bottom left": return [nr, er];
				case "to left":
				case "right": return fr(270);
			}
			return 0;
		}, fr = function(e) {
			return Math.PI * e / 180;
		}, pr = {
			name: "color",
			parse: function(e, t) {
				if (t.type === 18) {
					var n = xr[t.name];
					if (n === void 0) throw Error("Attempting to parse an unsupported color function \"" + t.name + "\"");
					return n(e, t.values);
				}
				if (t.type === 5) {
					if (t.value.length === 3) {
						var r = t.value.substring(0, 1), i = t.value.substring(1, 2), a = t.value.substring(2, 3);
						return gr(parseInt(r + r, 16), parseInt(i + i, 16), parseInt(a + a, 16), 1);
					}
					if (t.value.length === 4) {
						var r = t.value.substring(0, 1), i = t.value.substring(1, 2), a = t.value.substring(2, 3), o = t.value.substring(3, 4);
						return gr(parseInt(r + r, 16), parseInt(i + i, 16), parseInt(a + a, 16), parseInt(o + o, 16) / 255);
					}
					if (t.value.length === 6) {
						var r = t.value.substring(0, 2), i = t.value.substring(2, 4), a = t.value.substring(4, 6);
						return gr(parseInt(r, 16), parseInt(i, 16), parseInt(a, 16), 1);
					}
					if (t.value.length === 8) {
						var r = t.value.substring(0, 2), i = t.value.substring(2, 4), a = t.value.substring(4, 6), o = t.value.substring(6, 8);
						return gr(parseInt(r, 16), parseInt(i, 16), parseInt(a, 16), parseInt(o, 16) / 255);
					}
				}
				if (t.type === 20) {
					var s = Cr[t.value.toUpperCase()];
					if (s !== void 0) return s;
				}
				return Cr.TRANSPARENT;
			}
		}, mr = function(e) {
			return (255 & e) == 0;
		}, hr = function(e) {
			var t = 255 & e, n = 255 & e >> 8, r = 255 & e >> 16, i = 255 & e >> 24;
			return t < 255 ? "rgba(" + i + "," + r + "," + n + "," + t / 255 + ")" : "rgb(" + i + "," + r + "," + n + ")";
		}, gr = function(e, t, n, r) {
			return (e << 24 | t << 16 | n << 8 | Math.round(r * 255) << 0) >>> 0;
		}, _r = function(e, t) {
			if (e.type === 17) return e.number;
			if (e.type === 16) {
				var n = t === 3 ? 1 : 255;
				return t === 3 ? e.number / 100 * n : Math.round(e.number / 100 * n);
			}
			return 0;
		}, vr = function(e, t) {
			var n = t.filter(Jn);
			if (n.length === 3) {
				var r = n.map(_r), i = r[0], a = r[1], o = r[2];
				return gr(i, a, o, 1);
			}
			if (n.length === 4) {
				var s = n.map(_r), i = s[0], a = s[1], o = s[2], c = s[3];
				return gr(i, a, o, c);
			}
			return 0;
		};
		function yr(e, t, n) {
			return n < 0 && (n += 1), n >= 1 && --n, n < 1 / 6 ? (t - e) * n * 6 + e : n < 1 / 2 ? t : n < 2 / 3 ? (t - e) * 6 * (2 / 3 - n) + e : e;
		}
		var br = function(e, t) {
			var n = t.filter(Jn), r = n[0], i = n[1], a = n[2], o = n[3], s = (r.type === 17 ? fr(r.number) : lr.parse(e, r)) / (Math.PI * 2), c = Qn(i) ? i.number / 100 : 0, l = Qn(a) ? a.number / 100 : 0, u = o !== void 0 && Qn(o) ? ir(o, 1) : 1;
			if (c === 0) return gr(l * 255, l * 255, l * 255, 1);
			var d = l <= .5 ? l * (c + 1) : l + c - l * c, f = l * 2 - d, p = yr(f, d, s + 1 / 3), m = yr(f, d, s), h = yr(f, d, s - 1 / 3);
			return gr(p * 255, m * 255, h * 255, u);
		}, xr = {
			hsl: br,
			hsla: br,
			rgb: vr,
			rgba: vr
		}, Sr = function(e, t) {
			return pr.parse(e, Vn.create(t).parseComponentValue());
		}, Cr = {
			ALICEBLUE: 4042850303,
			ANTIQUEWHITE: 4209760255,
			AQUA: 16777215,
			AQUAMARINE: 2147472639,
			AZURE: 4043309055,
			BEIGE: 4126530815,
			BISQUE: 4293182719,
			BLACK: 255,
			BLANCHEDALMOND: 4293643775,
			BLUE: 65535,
			BLUEVIOLET: 2318131967,
			BROWN: 2771004159,
			BURLYWOOD: 3736635391,
			CADETBLUE: 1604231423,
			CHARTREUSE: 2147418367,
			CHOCOLATE: 3530104575,
			CORAL: 4286533887,
			CORNFLOWERBLUE: 1687547391,
			CORNSILK: 4294499583,
			CRIMSON: 3692313855,
			CYAN: 16777215,
			DARKBLUE: 35839,
			DARKCYAN: 9145343,
			DARKGOLDENROD: 3095837695,
			DARKGRAY: 2846468607,
			DARKGREEN: 6553855,
			DARKGREY: 2846468607,
			DARKKHAKI: 3182914559,
			DARKMAGENTA: 2332068863,
			DARKOLIVEGREEN: 1433087999,
			DARKORANGE: 4287365375,
			DARKORCHID: 2570243327,
			DARKRED: 2332033279,
			DARKSALMON: 3918953215,
			DARKSEAGREEN: 2411499519,
			DARKSLATEBLUE: 1211993087,
			DARKSLATEGRAY: 793726975,
			DARKSLATEGREY: 793726975,
			DARKTURQUOISE: 13554175,
			DARKVIOLET: 2483082239,
			DEEPPINK: 4279538687,
			DEEPSKYBLUE: 12582911,
			DIMGRAY: 1768516095,
			DIMGREY: 1768516095,
			DODGERBLUE: 512819199,
			FIREBRICK: 2988581631,
			FLORALWHITE: 4294635775,
			FORESTGREEN: 579543807,
			FUCHSIA: 4278255615,
			GAINSBORO: 3705462015,
			GHOSTWHITE: 4177068031,
			GOLD: 4292280575,
			GOLDENROD: 3668254975,
			GRAY: 2155905279,
			GREEN: 8388863,
			GREENYELLOW: 2919182335,
			GREY: 2155905279,
			HONEYDEW: 4043305215,
			HOTPINK: 4285117695,
			INDIANRED: 3445382399,
			INDIGO: 1258324735,
			IVORY: 4294963455,
			KHAKI: 4041641215,
			LAVENDER: 3873897215,
			LAVENDERBLUSH: 4293981695,
			LAWNGREEN: 2096890111,
			LEMONCHIFFON: 4294626815,
			LIGHTBLUE: 2916673279,
			LIGHTCORAL: 4034953471,
			LIGHTCYAN: 3774873599,
			LIGHTGOLDENRODYELLOW: 4210742015,
			LIGHTGRAY: 3553874943,
			LIGHTGREEN: 2431553791,
			LIGHTGREY: 3553874943,
			LIGHTPINK: 4290167295,
			LIGHTSALMON: 4288707327,
			LIGHTSEAGREEN: 548580095,
			LIGHTSKYBLUE: 2278488831,
			LIGHTSLATEGRAY: 2005441023,
			LIGHTSLATEGREY: 2005441023,
			LIGHTSTEELBLUE: 2965692159,
			LIGHTYELLOW: 4294959359,
			LIME: 16711935,
			LIMEGREEN: 852308735,
			LINEN: 4210091775,
			MAGENTA: 4278255615,
			MAROON: 2147483903,
			MEDIUMAQUAMARINE: 1724754687,
			MEDIUMBLUE: 52735,
			MEDIUMORCHID: 3126187007,
			MEDIUMPURPLE: 2473647103,
			MEDIUMSEAGREEN: 1018393087,
			MEDIUMSLATEBLUE: 2070474495,
			MEDIUMSPRINGGREEN: 16423679,
			MEDIUMTURQUOISE: 1221709055,
			MEDIUMVIOLETRED: 3340076543,
			MIDNIGHTBLUE: 421097727,
			MINTCREAM: 4127193855,
			MISTYROSE: 4293190143,
			MOCCASIN: 4293178879,
			NAVAJOWHITE: 4292783615,
			NAVY: 33023,
			OLDLACE: 4260751103,
			OLIVE: 2155872511,
			OLIVEDRAB: 1804477439,
			ORANGE: 4289003775,
			ORANGERED: 4282712319,
			ORCHID: 3664828159,
			PALEGOLDENROD: 4008225535,
			PALEGREEN: 2566625535,
			PALETURQUOISE: 2951671551,
			PALEVIOLETRED: 3681588223,
			PAPAYAWHIP: 4293907967,
			PEACHPUFF: 4292524543,
			PERU: 3448061951,
			PINK: 4290825215,
			PLUM: 3718307327,
			POWDERBLUE: 2967529215,
			PURPLE: 2147516671,
			REBECCAPURPLE: 1714657791,
			RED: 4278190335,
			ROSYBROWN: 3163525119,
			ROYALBLUE: 1097458175,
			SADDLEBROWN: 2336560127,
			SALMON: 4202722047,
			SANDYBROWN: 4104413439,
			SEAGREEN: 780883967,
			SEASHELL: 4294307583,
			SIENNA: 2689740287,
			SILVER: 3233857791,
			SKYBLUE: 2278484991,
			SLATEBLUE: 1784335871,
			SLATEGRAY: 1887473919,
			SLATEGREY: 1887473919,
			SNOW: 4294638335,
			SPRINGGREEN: 16744447,
			STEELBLUE: 1182971135,
			TAN: 3535047935,
			TEAL: 8421631,
			THISTLE: 3636451583,
			TOMATO: 4284696575,
			TRANSPARENT: 0,
			TURQUOISE: 1088475391,
			VIOLET: 4001558271,
			WHEAT: 4125012991,
			WHITE: 4294967295,
			WHITESMOKE: 4126537215,
			YELLOW: 4294902015,
			YELLOWGREEN: 2597139199
		}, wr = {
			name: "background-clip",
			initialValue: "border-box",
			prefix: !1,
			type: 1,
			parse: function(e, t) {
				return t.map(function(e) {
					if (Wn(e)) switch (e.value) {
						case "padding-box": return 1;
						case "content-box": return 2;
					}
					return 0;
				});
			}
		}, Tr = {
			name: "background-color",
			initialValue: "transparent",
			prefix: !1,
			type: 3,
			format: "color"
		}, Er = function(e, t) {
			var n = pr.parse(e, t[0]), r = t[1];
			return r && Qn(r) ? {
				color: n,
				stop: r
			} : {
				color: n,
				stop: null
			};
		}, Dr = function(e, t) {
			var n = e[0], r = e[e.length - 1];
			n.stop === null && (n.stop = er), r.stop === null && (r.stop = nr);
			for (var i = [], a = 0, o = 0; o < e.length; o++) {
				var s = e[o].stop;
				if (s !== null) {
					var c = ir(s, t);
					c > a ? i.push(c) : i.push(a), a = c;
				} else i.push(null);
			}
			for (var l = null, o = 0; o < i.length; o++) {
				var u = i[o];
				if (u === null) l === null && (l = o);
				else if (l !== null) {
					for (var d = o - l, f = (u - i[l - 1]) / (d + 1), p = 1; p <= d; p++) i[l + p - 1] = f * p;
					l = null;
				}
			}
			return e.map(function(e, n) {
				return {
					color: e.color,
					stop: Math.max(Math.min(1, i[n] / t), 0)
				};
			});
		}, Or = function(e, t, n) {
			var r = t / 2, i = n / 2, a = ir(e[0], t) - r, o = i - ir(e[1], n);
			return (Math.atan2(o, a) + Math.PI * 2) % (Math.PI * 2);
		}, kr = function(e, t, n) {
			var r = typeof e == "number" ? e : Or(e, t, n), i = Math.abs(t * Math.sin(r)) + Math.abs(n * Math.cos(r)), a = t / 2, o = n / 2, s = i / 2, c = Math.sin(r - Math.PI / 2) * s, l = Math.cos(r - Math.PI / 2) * s;
			return [
				i,
				a - l,
				a + l,
				o - c,
				o + c
			];
		}, Ar = function(e, t) {
			return Math.sqrt(e * e + t * t);
		}, jr = function(e, t, n, r, i) {
			return [
				[0, 0],
				[0, t],
				[e, 0],
				[e, t]
			].reduce(function(e, t) {
				var a = t[0], o = t[1], s = Ar(n - a, r - o);
				return (i ? s < e.optimumDistance : s > e.optimumDistance) ? {
					optimumCorner: t,
					optimumDistance: s
				} : e;
			}, {
				optimumDistance: i ? Infinity : -Infinity,
				optimumCorner: null
			}).optimumCorner;
		}, Mr = function(e, t, n, r, i) {
			var a = 0, o = 0;
			switch (e.size) {
				case 0:
					e.shape === 0 ? a = o = Math.min(Math.abs(t), Math.abs(t - r), Math.abs(n), Math.abs(n - i)) : e.shape === 1 && (a = Math.min(Math.abs(t), Math.abs(t - r)), o = Math.min(Math.abs(n), Math.abs(n - i)));
					break;
				case 2:
					if (e.shape === 0) a = o = Math.min(Ar(t, n), Ar(t, n - i), Ar(t - r, n), Ar(t - r, n - i));
					else if (e.shape === 1) {
						var s = Math.min(Math.abs(n), Math.abs(n - i)) / Math.min(Math.abs(t), Math.abs(t - r)), c = jr(r, i, t, n, !0), l = c[0], u = c[1];
						a = Ar(l - t, (u - n) / s), o = s * a;
					}
					break;
				case 1:
					e.shape === 0 ? a = o = Math.max(Math.abs(t), Math.abs(t - r), Math.abs(n), Math.abs(n - i)) : e.shape === 1 && (a = Math.max(Math.abs(t), Math.abs(t - r)), o = Math.max(Math.abs(n), Math.abs(n - i)));
					break;
				case 3:
					if (e.shape === 0) a = o = Math.max(Ar(t, n), Ar(t, n - i), Ar(t - r, n), Ar(t - r, n - i));
					else if (e.shape === 1) {
						var s = Math.max(Math.abs(n), Math.abs(n - i)) / Math.max(Math.abs(t), Math.abs(t - r)), d = jr(r, i, t, n, !1), l = d[0], u = d[1];
						a = Ar(l - t, (u - n) / s), o = s * a;
					}
					break;
			}
			return Array.isArray(e.size) && (a = ir(e.size[0], r), o = e.size.length === 2 ? ir(e.size[1], i) : a), [a, o];
		}, Nr = function(e, t) {
			var n = fr(180), r = [];
			return Yn(t).forEach(function(t, i) {
				if (i === 0) {
					var a = t[0];
					if (a.type === 20 && a.value === "to") {
						n = dr(t);
						return;
					} else if (ur(a)) {
						n = lr.parse(e, a);
						return;
					}
				}
				var o = Er(e, t);
				r.push(o);
			}), {
				angle: n,
				stops: r,
				type: 1
			};
		}, Pr = function(e, t) {
			var n = fr(180), r = [];
			return Yn(t).forEach(function(t, i) {
				if (i === 0) {
					var a = t[0];
					if (a.type === 20 && [
						"top",
						"left",
						"right",
						"bottom"
					].indexOf(a.value) !== -1) {
						n = dr(t);
						return;
					} else if (ur(a)) {
						n = (lr.parse(e, a) + fr(270)) % fr(360);
						return;
					}
				}
				var o = Er(e, t);
				r.push(o);
			}), {
				angle: n,
				stops: r,
				type: 1
			};
		}, Fr = function(e, t) {
			var n = fr(180), r = [], i = 1;
			return Yn(t).forEach(function(t, n) {
				var a = t[0];
				if (n === 0) {
					if (Wn(a) && a.value === "linear") {
						i = 1;
						return;
					} else if (Wn(a) && a.value === "radial") {
						i = 2;
						return;
					}
				}
				if (a.type === 18) {
					if (a.name === "from") {
						var o = pr.parse(e, a.values[0]);
						r.push({
							stop: er,
							color: o
						});
					} else if (a.name === "to") {
						var o = pr.parse(e, a.values[0]);
						r.push({
							stop: nr,
							color: o
						});
					} else if (a.name === "color-stop") {
						var s = a.values.filter(Jn);
						if (s.length === 2) {
							var o = pr.parse(e, s[1]), c = s[0];
							Un(c) && r.push({
								stop: {
									type: 16,
									number: c.number * 100,
									flags: c.flags
								},
								color: o
							});
						}
					}
				}
			}), i === 1 ? {
				angle: (n + fr(180)) % fr(360),
				stops: r,
				type: i
			} : {
				size: 3,
				shape: 0,
				stops: r,
				position: [],
				type: i
			};
		}, G = "closest-side", Ir = "farthest-side", Lr = "closest-corner", Rr = "farthest-corner", zr = "circle", Br = "ellipse", Vr = "cover", Hr = "contain", Ur = function(e, t) {
			var n = 0, r = 3, i = [], a = [];
			return Yn(t).forEach(function(t, o) {
				var s = !0;
				if (o === 0) {
					var c = !1;
					s = t.reduce(function(e, t) {
						if (c) if (Wn(t)) switch (t.value) {
							case "center": return a.push(tr), e;
							case "top":
							case "left": return a.push(er), e;
							case "right":
							case "bottom": return a.push(nr), e;
						}
						else (Qn(t) || Zn(t)) && a.push(t);
						else if (Wn(t)) switch (t.value) {
							case zr: return n = 0, !1;
							case Br: return n = 1, !1;
							case "at": return c = !0, !1;
							case G: return r = 0, !1;
							case Vr:
							case Ir: return r = 1, !1;
							case Hr:
							case Lr: return r = 2, !1;
							case Rr: return r = 3, !1;
						}
						else if (Zn(t) || Qn(t)) return Array.isArray(r) || (r = []), r.push(t), !1;
						return e;
					}, s);
				}
				if (s) {
					var l = Er(e, t);
					i.push(l);
				}
			}), {
				size: r,
				shape: n,
				stops: i,
				position: a,
				type: 2
			};
		}, Wr = function(e, t) {
			var n = 0, r = 3, i = [], a = [];
			return Yn(t).forEach(function(t, o) {
				var s = !0;
				if (o === 0 ? s = t.reduce(function(e, t) {
					if (Wn(t)) switch (t.value) {
						case "center": return a.push(tr), !1;
						case "top":
						case "left": return a.push(er), !1;
						case "right":
						case "bottom": return a.push(nr), !1;
					}
					else if (Qn(t) || Zn(t)) return a.push(t), !1;
					return e;
				}, s) : o === 1 && (s = t.reduce(function(e, t) {
					if (Wn(t)) switch (t.value) {
						case zr: return n = 0, !1;
						case Br: return n = 1, !1;
						case Hr:
						case G: return r = 0, !1;
						case Ir: return r = 1, !1;
						case Lr: return r = 2, !1;
						case Vr:
						case Rr: return r = 3, !1;
					}
					else if (Zn(t) || Qn(t)) return Array.isArray(r) || (r = []), r.push(t), !1;
					return e;
				}, s)), s) {
					var c = Er(e, t);
					i.push(c);
				}
			}), {
				size: r,
				shape: n,
				stops: i,
				position: a,
				type: 2
			};
		}, Gr = function(e) {
			return e.type === 1;
		}, Kr = function(e) {
			return e.type === 2;
		}, qr = {
			name: "image",
			parse: function(e, t) {
				if (t.type === 22) {
					var n = {
						url: t.value,
						type: 0
					};
					return e.cache.addImage(t.value), n;
				}
				if (t.type === 18) {
					var r = Yr[t.name];
					if (r === void 0) throw Error("Attempting to parse an unsupported image function \"" + t.name + "\"");
					return r(e, t.values);
				}
				throw Error("Unsupported image type " + t.type);
			}
		};
		function Jr(e) {
			return !(e.type === 20 && e.value === "none") && (e.type !== 18 || !!Yr[e.name]);
		}
		var Yr = {
			"linear-gradient": Nr,
			"-moz-linear-gradient": Pr,
			"-ms-linear-gradient": Pr,
			"-o-linear-gradient": Pr,
			"-webkit-linear-gradient": Pr,
			"radial-gradient": Ur,
			"-moz-radial-gradient": Wr,
			"-ms-radial-gradient": Wr,
			"-o-radial-gradient": Wr,
			"-webkit-radial-gradient": Wr,
			"-webkit-gradient": Fr
		}, Xr = {
			name: "background-image",
			initialValue: "none",
			type: 1,
			prefix: !1,
			parse: function(e, t) {
				if (t.length === 0) return [];
				var n = t[0];
				return n.type === 20 && n.value === "none" ? [] : t.filter(function(e) {
					return Jn(e) && Jr(e);
				}).map(function(t) {
					return qr.parse(e, t);
				});
			}
		}, Zr = {
			name: "background-origin",
			initialValue: "border-box",
			prefix: !1,
			type: 1,
			parse: function(e, t) {
				return t.map(function(e) {
					if (Wn(e)) switch (e.value) {
						case "padding-box": return 1;
						case "content-box": return 2;
					}
					return 0;
				});
			}
		}, K = {
			name: "background-position",
			initialValue: "0% 0%",
			type: 1,
			prefix: !1,
			parse: function(e, t) {
				return Yn(t).map(function(e) {
					return e.filter(Qn);
				}).map($n);
			}
		}, Qr = {
			name: "background-repeat",
			initialValue: "repeat",
			prefix: !1,
			type: 1,
			parse: function(e, t) {
				return Yn(t).map(function(e) {
					return e.filter(Wn).map(function(e) {
						return e.value;
					}).join(" ");
				}).map($r);
			}
		}, $r = function(e) {
			switch (e) {
				case "no-repeat": return 1;
				case "repeat-x":
				case "repeat no-repeat": return 2;
				case "repeat-y":
				case "no-repeat repeat": return 3;
				default: return 0;
			}
		}, ei;
		(function(e) {
			e.AUTO = "auto", e.CONTAIN = "contain", e.COVER = "cover";
		})(ei ||= {});
		var ti = {
			name: "background-size",
			initialValue: "0",
			prefix: !1,
			type: 1,
			parse: function(e, t) {
				return Yn(t).map(function(e) {
					return e.filter(ni);
				});
			}
		}, ni = function(e) {
			return Wn(e) || Qn(e);
		}, ri = function(e) {
			return {
				name: "border-" + e + "-color",
				initialValue: "transparent",
				prefix: !1,
				type: 3,
				format: "color"
			};
		}, ii = ri("top"), ai = ri("right"), oi = ri("bottom"), si = ri("left"), ci = function(e) {
			return {
				name: "border-radius-" + e,
				initialValue: "0 0",
				prefix: !1,
				type: 1,
				parse: function(e, t) {
					return $n(t.filter(Qn));
				}
			};
		}, li = ci("top-left"), ui = ci("top-right"), di = ci("bottom-right"), fi = ci("bottom-left"), pi = function(e) {
			return {
				name: "border-" + e + "-style",
				initialValue: "solid",
				prefix: !1,
				type: 2,
				parse: function(e, t) {
					switch (t) {
						case "none": return 0;
						case "dashed": return 2;
						case "dotted": return 3;
						case "double": return 4;
					}
					return 1;
				}
			};
		}, mi = pi("top"), hi = pi("right"), gi = pi("bottom"), _i = pi("left"), vi = function(e) {
			return {
				name: "border-" + e + "-width",
				initialValue: "0",
				type: 0,
				prefix: !1,
				parse: function(e, t) {
					return Hn(t) ? t.number : 0;
				}
			};
		}, yi = vi("top"), bi = vi("right"), xi = vi("bottom"), Si = vi("left"), Ci = {
			name: "color",
			initialValue: "transparent",
			prefix: !1,
			type: 3,
			format: "color"
		}, wi = {
			name: "direction",
			initialValue: "ltr",
			prefix: !1,
			type: 2,
			parse: function(e, t) {
				switch (t) {
					case "rtl": return 1;
					default: return 0;
				}
			}
		}, Ti = {
			name: "display",
			initialValue: "inline-block",
			prefix: !1,
			type: 1,
			parse: function(e, t) {
				return t.filter(Wn).reduce(function(e, t) {
					return e | Ei(t.value);
				}, 0);
			}
		}, Ei = function(e) {
			switch (e) {
				case "block":
				case "-webkit-box": return 2;
				case "inline": return 4;
				case "run-in": return 8;
				case "flow": return 16;
				case "flow-root": return 32;
				case "table": return 64;
				case "flex":
				case "-webkit-flex": return 128;
				case "grid":
				case "-ms-grid": return 256;
				case "ruby": return 512;
				case "subgrid": return 1024;
				case "list-item": return 2048;
				case "table-row-group": return 4096;
				case "table-header-group": return 8192;
				case "table-footer-group": return 16384;
				case "table-row": return 32768;
				case "table-cell": return 65536;
				case "table-column-group": return 131072;
				case "table-column": return 262144;
				case "table-caption": return 524288;
				case "ruby-base": return 1048576;
				case "ruby-text": return 2097152;
				case "ruby-base-container": return 4194304;
				case "ruby-text-container": return 8388608;
				case "contents": return 16777216;
				case "inline-block": return 33554432;
				case "inline-list-item": return 67108864;
				case "inline-table": return 134217728;
				case "inline-flex": return 268435456;
				case "inline-grid": return 536870912;
			}
			return 0;
		}, Di = {
			name: "float",
			initialValue: "none",
			prefix: !1,
			type: 2,
			parse: function(e, t) {
				switch (t) {
					case "left": return 1;
					case "right": return 2;
					case "inline-start": return 3;
					case "inline-end": return 4;
				}
				return 0;
			}
		}, Oi = {
			name: "letter-spacing",
			initialValue: "0",
			prefix: !1,
			type: 0,
			parse: function(e, t) {
				return t.type === 20 && t.value === "normal" ? 0 : t.type === 17 || t.type === 15 ? t.number : 0;
			}
		}, ki;
		(function(e) {
			e.NORMAL = "normal", e.STRICT = "strict";
		})(ki ||= {});
		var Ai = {
			name: "line-break",
			initialValue: "normal",
			prefix: !1,
			type: 2,
			parse: function(e, t) {
				switch (t) {
					case "strict": return ki.STRICT;
					default: return ki.NORMAL;
				}
			}
		}, ji = {
			name: "line-height",
			initialValue: "normal",
			prefix: !1,
			type: 4
		}, Mi = function(e, t) {
			return Wn(e) && e.value === "normal" ? 1.2 * t : e.type === 17 ? t * e.number : Qn(e) ? ir(e, t) : t;
		}, Ni = {
			name: "list-style-image",
			initialValue: "none",
			type: 0,
			prefix: !1,
			parse: function(e, t) {
				return t.type === 20 && t.value === "none" ? null : qr.parse(e, t);
			}
		}, Pi = {
			name: "list-style-position",
			initialValue: "outside",
			prefix: !1,
			type: 2,
			parse: function(e, t) {
				switch (t) {
					case "inside": return 0;
					default: return 1;
				}
			}
		}, Fi = {
			name: "list-style-type",
			initialValue: "none",
			prefix: !1,
			type: 2,
			parse: function(e, t) {
				switch (t) {
					case "disc": return 0;
					case "circle": return 1;
					case "square": return 2;
					case "decimal": return 3;
					case "cjk-decimal": return 4;
					case "decimal-leading-zero": return 5;
					case "lower-roman": return 6;
					case "upper-roman": return 7;
					case "lower-greek": return 8;
					case "lower-alpha": return 9;
					case "upper-alpha": return 10;
					case "arabic-indic": return 11;
					case "armenian": return 12;
					case "bengali": return 13;
					case "cambodian": return 14;
					case "cjk-earthly-branch": return 15;
					case "cjk-heavenly-stem": return 16;
					case "cjk-ideographic": return 17;
					case "devanagari": return 18;
					case "ethiopic-numeric": return 19;
					case "georgian": return 20;
					case "gujarati": return 21;
					case "gurmukhi": return 22;
					case "hebrew": return 22;
					case "hiragana": return 23;
					case "hiragana-iroha": return 24;
					case "japanese-formal": return 25;
					case "japanese-informal": return 26;
					case "kannada": return 27;
					case "katakana": return 28;
					case "katakana-iroha": return 29;
					case "khmer": return 30;
					case "korean-hangul-formal": return 31;
					case "korean-hanja-formal": return 32;
					case "korean-hanja-informal": return 33;
					case "lao": return 34;
					case "lower-armenian": return 35;
					case "malayalam": return 36;
					case "mongolian": return 37;
					case "myanmar": return 38;
					case "oriya": return 39;
					case "persian": return 40;
					case "simp-chinese-formal": return 41;
					case "simp-chinese-informal": return 42;
					case "tamil": return 43;
					case "telugu": return 44;
					case "thai": return 45;
					case "tibetan": return 46;
					case "trad-chinese-formal": return 47;
					case "trad-chinese-informal": return 48;
					case "upper-armenian": return 49;
					case "disclosure-open": return 50;
					case "disclosure-closed": return 51;
					default: return -1;
				}
			}
		}, Ii = function(e) {
			return {
				name: "margin-" + e,
				initialValue: "0",
				prefix: !1,
				type: 4
			};
		}, Li = Ii("top"), Ri = Ii("right"), zi = Ii("bottom"), Bi = Ii("left"), Vi = {
			name: "overflow",
			initialValue: "visible",
			prefix: !1,
			type: 1,
			parse: function(e, t) {
				return t.filter(Wn).map(function(e) {
					switch (e.value) {
						case "hidden": return 1;
						case "scroll": return 2;
						case "clip": return 3;
						case "auto": return 4;
						default: return 0;
					}
				});
			}
		}, Hi = {
			name: "overflow-wrap",
			initialValue: "normal",
			prefix: !1,
			type: 2,
			parse: function(e, t) {
				switch (t) {
					case "break-word": return "break-word";
					default: return "normal";
				}
			}
		}, Ui = function(e) {
			return {
				name: "padding-" + e,
				initialValue: "0",
				prefix: !1,
				type: 3,
				format: "length-percentage"
			};
		}, Wi = Ui("top"), Gi = Ui("right"), Ki = Ui("bottom"), qi = Ui("left"), Ji = {
			name: "text-align",
			initialValue: "left",
			prefix: !1,
			type: 2,
			parse: function(e, t) {
				switch (t) {
					case "right": return 2;
					case "center":
					case "justify": return 1;
					default: return 0;
				}
			}
		}, Yi = {
			name: "position",
			initialValue: "static",
			prefix: !1,
			type: 2,
			parse: function(e, t) {
				switch (t) {
					case "relative": return 1;
					case "absolute": return 2;
					case "fixed": return 3;
					case "sticky": return 4;
				}
				return 0;
			}
		}, Xi = {
			name: "text-shadow",
			initialValue: "none",
			type: 1,
			prefix: !1,
			parse: function(e, t) {
				return t.length === 1 && Kn(t[0], "none") ? [] : Yn(t).map(function(t) {
					for (var n = {
						color: Cr.TRANSPARENT,
						offsetX: er,
						offsetY: er,
						blur: er
					}, r = 0, i = 0; i < t.length; i++) {
						var a = t[i];
						Zn(a) ? (r === 0 ? n.offsetX = a : r === 1 ? n.offsetY = a : n.blur = a, r++) : n.color = pr.parse(e, a);
					}
					return n;
				});
			}
		}, Zi = {
			name: "text-transform",
			initialValue: "none",
			prefix: !1,
			type: 2,
			parse: function(e, t) {
				switch (t) {
					case "uppercase": return 2;
					case "lowercase": return 1;
					case "capitalize": return 3;
				}
				return 0;
			}
		}, Qi = {
			name: "transform",
			initialValue: "none",
			prefix: !0,
			type: 0,
			parse: function(e, t) {
				if (t.type === 20 && t.value === "none") return null;
				if (t.type === 18) {
					var n = $i[t.name];
					if (n === void 0) throw Error("Attempting to parse an unsupported transform function \"" + t.name + "\"");
					return n(t.values);
				}
				return null;
			}
		}, $i = {
			matrix: function(e) {
				var t = e.filter(function(e) {
					return e.type === 17;
				}).map(function(e) {
					return e.number;
				});
				return t.length === 6 ? t : null;
			},
			matrix3d: function(e) {
				var t = e.filter(function(e) {
					return e.type === 17;
				}).map(function(e) {
					return e.number;
				}), n = t[0], r = t[1];
				t[2], t[3];
				var i = t[4], a = t[5];
				t[6], t[7], t[8], t[9], t[10], t[11];
				var o = t[12], s = t[13];
				return t[14], t[15], t.length === 16 ? [
					n,
					r,
					i,
					a,
					o,
					s
				] : null;
			}
		}, ea = {
			type: 16,
			number: 50,
			flags: it
		}, ta = [ea, ea], na = {
			name: "transform-origin",
			initialValue: "50% 50%",
			prefix: !0,
			type: 1,
			parse: function(e, t) {
				var n = t.filter(Qn);
				return n.length === 2 ? [n[0], n[1]] : ta;
			}
		}, ra = {
			name: "visible",
			initialValue: "none",
			prefix: !1,
			type: 2,
			parse: function(e, t) {
				switch (t) {
					case "hidden": return 1;
					case "collapse": return 2;
					default: return 0;
				}
			}
		}, q;
		(function(e) {
			e.NORMAL = "normal", e.BREAK_ALL = "break-all", e.KEEP_ALL = "keep-all";
		})(q ||= {});
		for (var ia = {
			name: "word-break",
			initialValue: "normal",
			prefix: !1,
			type: 2,
			parse: function(e, t) {
				switch (t) {
					case "break-all": return q.BREAK_ALL;
					case "keep-all": return q.KEEP_ALL;
					default: return q.NORMAL;
				}
			}
		}, aa = {
			name: "z-index",
			initialValue: "auto",
			prefix: !1,
			type: 0,
			parse: function(e, t) {
				if (t.type === 20) return {
					auto: !0,
					order: 0
				};
				if (Un(t)) return {
					auto: !1,
					order: t.number
				};
				throw Error("Invalid z-index number parsed");
			}
		}, oa = {
			name: "time",
			parse: function(e, t) {
				if (t.type === 15) switch (t.unit.toLowerCase()) {
					case "s": return 1e3 * t.number;
					case "ms": return t.number;
				}
				throw Error("Unsupported time type");
			}
		}, sa = {
			name: "opacity",
			initialValue: "1",
			type: 0,
			prefix: !1,
			parse: function(e, t) {
				return Un(t) ? t.number : 1;
			}
		}, ca = {
			name: "text-decoration-color",
			initialValue: "transparent",
			prefix: !1,
			type: 3,
			format: "color"
		}, la = {
			name: "text-decoration-line",
			initialValue: "none",
			prefix: !1,
			type: 1,
			parse: function(e, t) {
				return t.filter(Wn).map(function(e) {
					switch (e.value) {
						case "underline": return 1;
						case "overline": return 2;
						case "line-through": return 3;
						case "none": return 4;
					}
					return 0;
				}).filter(function(e) {
					return e !== 0;
				});
			}
		}, ua = {
			name: "font-family",
			initialValue: "",
			prefix: !1,
			type: 1,
			parse: function(e, t) {
				var n = [], r = [];
				return t.forEach(function(e) {
					switch (e.type) {
						case 20:
						case 0:
							n.push(e.value);
							break;
						case 17:
							n.push(e.number.toString());
							break;
						case 4:
							r.push(n.join(" ")), n.length = 0;
							break;
					}
				}), n.length && r.push(n.join(" ")), r.map(function(e) {
					return e.indexOf(" ") === -1 ? e : "'" + e + "'";
				});
			}
		}, da = {
			name: "font-size",
			initialValue: "0",
			prefix: !1,
			type: 3,
			format: "length"
		}, fa = {
			name: "font-weight",
			initialValue: "normal",
			type: 0,
			prefix: !1,
			parse: function(e, t) {
				if (Un(t)) return t.number;
				if (Wn(t)) switch (t.value) {
					case "bold": return 700;
					default: return 400;
				}
				return 400;
			}
		}, pa = {
			name: "font-variant",
			initialValue: "none",
			type: 1,
			prefix: !1,
			parse: function(e, t) {
				return t.filter(Wn).map(function(e) {
					return e.value;
				});
			}
		}, ma = {
			name: "font-style",
			initialValue: "normal",
			prefix: !1,
			type: 2,
			parse: function(e, t) {
				switch (t) {
					case "oblique": return "oblique";
					case "italic": return "italic";
					default: return "normal";
				}
			}
		}, ha = function(e, t) {
			return (e & t) !== 0;
		}, ga = {
			name: "content",
			initialValue: "none",
			type: 1,
			prefix: !1,
			parse: function(e, t) {
				if (t.length === 0) return [];
				var n = t[0];
				return n.type === 20 && n.value === "none" ? [] : t;
			}
		}, _a = {
			name: "counter-increment",
			initialValue: "none",
			prefix: !0,
			type: 1,
			parse: function(e, t) {
				if (t.length === 0) return null;
				var n = t[0];
				if (n.type === 20 && n.value === "none") return null;
				for (var r = [], i = t.filter(qn), a = 0; a < i.length; a++) {
					var o = i[a], s = i[a + 1];
					if (o.type === 20) {
						var c = s && Un(s) ? s.number : 1;
						r.push({
							counter: o.value,
							increment: c
						});
					}
				}
				return r;
			}
		}, va = {
			name: "counter-reset",
			initialValue: "none",
			prefix: !0,
			type: 1,
			parse: function(e, t) {
				if (t.length === 0) return [];
				for (var n = [], r = t.filter(qn), i = 0; i < r.length; i++) {
					var a = r[i], o = r[i + 1];
					if (Wn(a) && a.value !== "none") {
						var s = o && Un(o) ? o.number : 0;
						n.push({
							counter: a.value,
							reset: s
						});
					}
				}
				return n;
			}
		}, ya = {
			name: "duration",
			initialValue: "0s",
			prefix: !1,
			type: 1,
			parse: function(e, t) {
				return t.filter(Hn).map(function(t) {
					return oa.parse(e, t);
				});
			}
		}, ba = {
			name: "quotes",
			initialValue: "none",
			prefix: !0,
			type: 1,
			parse: function(e, t) {
				if (t.length === 0) return null;
				var n = t[0];
				if (n.type === 20 && n.value === "none") return null;
				var r = [], i = t.filter(Gn);
				if (i.length % 2 != 0) return null;
				for (var a = 0; a < i.length; a += 2) {
					var o = i[a].value, s = i[a + 1].value;
					r.push({
						open: o,
						close: s
					});
				}
				return r;
			}
		}, xa = function(e, t, n) {
			if (!e) return "";
			var r = e[Math.min(t, e.length - 1)];
			return r ? n ? r.open : r.close : "";
		}, Sa = {
			name: "box-shadow",
			initialValue: "none",
			type: 1,
			prefix: !1,
			parse: function(e, t) {
				return t.length === 1 && Kn(t[0], "none") ? [] : Yn(t).map(function(t) {
					for (var n = {
						color: 255,
						offsetX: er,
						offsetY: er,
						blur: er,
						spread: er,
						inset: !1
					}, r = 0, i = 0; i < t.length; i++) {
						var a = t[i];
						Kn(a, "inset") ? n.inset = !0 : Zn(a) ? (r === 0 ? n.offsetX = a : r === 1 ? n.offsetY = a : r === 2 ? n.blur = a : n.spread = a, r++) : n.color = pr.parse(e, a);
					}
					return n;
				});
			}
		}, Ca = {
			name: "paint-order",
			initialValue: "normal",
			prefix: !1,
			type: 1,
			parse: function(e, t) {
				var n = [
					0,
					1,
					2
				], r = [];
				return t.filter(Wn).forEach(function(e) {
					switch (e.value) {
						case "stroke":
							r.push(1);
							break;
						case "fill":
							r.push(0);
							break;
						case "markers":
							r.push(2);
							break;
					}
				}), n.forEach(function(e) {
					r.indexOf(e) === -1 && r.push(e);
				}), r;
			}
		}, wa = {
			name: "-webkit-text-stroke-color",
			initialValue: "currentcolor",
			prefix: !1,
			type: 3,
			format: "color"
		}, Ta = {
			name: "-webkit-text-stroke-width",
			initialValue: "0",
			type: 0,
			prefix: !1,
			parse: function(e, t) {
				return Hn(t) ? t.number : 0;
			}
		}, Ea = function() {
			function e(e, t) {
				this.animationDuration = J(e, ya, t.animationDuration), this.backgroundClip = J(e, wr, t.backgroundClip), this.backgroundColor = J(e, Tr, t.backgroundColor), this.backgroundImage = J(e, Xr, t.backgroundImage), this.backgroundOrigin = J(e, Zr, t.backgroundOrigin), this.backgroundPosition = J(e, K, t.backgroundPosition), this.backgroundRepeat = J(e, Qr, t.backgroundRepeat), this.backgroundSize = J(e, ti, t.backgroundSize), this.borderTopColor = J(e, ii, t.borderTopColor), this.borderRightColor = J(e, ai, t.borderRightColor), this.borderBottomColor = J(e, oi, t.borderBottomColor), this.borderLeftColor = J(e, si, t.borderLeftColor), this.borderTopLeftRadius = J(e, li, t.borderTopLeftRadius), this.borderTopRightRadius = J(e, ui, t.borderTopRightRadius), this.borderBottomRightRadius = J(e, di, t.borderBottomRightRadius), this.borderBottomLeftRadius = J(e, fi, t.borderBottomLeftRadius), this.borderTopStyle = J(e, mi, t.borderTopStyle), this.borderRightStyle = J(e, hi, t.borderRightStyle), this.borderBottomStyle = J(e, gi, t.borderBottomStyle), this.borderLeftStyle = J(e, _i, t.borderLeftStyle), this.borderTopWidth = J(e, yi, t.borderTopWidth), this.borderRightWidth = J(e, bi, t.borderRightWidth), this.borderBottomWidth = J(e, xi, t.borderBottomWidth), this.borderLeftWidth = J(e, Si, t.borderLeftWidth), this.boxShadow = J(e, Sa, t.boxShadow), this.color = J(e, Ci, t.color), this.direction = J(e, wi, t.direction), this.display = J(e, Ti, t.display), this.float = J(e, Di, t.cssFloat), this.fontFamily = J(e, ua, t.fontFamily), this.fontSize = J(e, da, t.fontSize), this.fontStyle = J(e, ma, t.fontStyle), this.fontVariant = J(e, pa, t.fontVariant), this.fontWeight = J(e, fa, t.fontWeight), this.letterSpacing = J(e, Oi, t.letterSpacing), this.lineBreak = J(e, Ai, t.lineBreak), this.lineHeight = J(e, ji, t.lineHeight), this.listStyleImage = J(e, Ni, t.listStyleImage), this.listStylePosition = J(e, Pi, t.listStylePosition), this.listStyleType = J(e, Fi, t.listStyleType), this.marginTop = J(e, Li, t.marginTop), this.marginRight = J(e, Ri, t.marginRight), this.marginBottom = J(e, zi, t.marginBottom), this.marginLeft = J(e, Bi, t.marginLeft), this.opacity = J(e, sa, t.opacity);
				var n = J(e, Vi, t.overflow);
				this.overflowX = n[0], this.overflowY = n[+(n.length > 1)], this.overflowWrap = J(e, Hi, t.overflowWrap), this.paddingTop = J(e, Wi, t.paddingTop), this.paddingRight = J(e, Gi, t.paddingRight), this.paddingBottom = J(e, Ki, t.paddingBottom), this.paddingLeft = J(e, qi, t.paddingLeft), this.paintOrder = J(e, Ca, t.paintOrder), this.position = J(e, Yi, t.position), this.textAlign = J(e, Ji, t.textAlign), this.textDecorationColor = J(e, ca, t.textDecorationColor ?? t.color), this.textDecorationLine = J(e, la, t.textDecorationLine ?? t.textDecoration), this.textShadow = J(e, Xi, t.textShadow), this.textTransform = J(e, Zi, t.textTransform), this.transform = J(e, Qi, t.transform), this.transformOrigin = J(e, na, t.transformOrigin), this.visibility = J(e, ra, t.visibility), this.webkitTextStrokeColor = J(e, wa, t.webkitTextStrokeColor), this.webkitTextStrokeWidth = J(e, Ta, t.webkitTextStrokeWidth), this.wordBreak = J(e, ia, t.wordBreak), this.zIndex = J(e, aa, t.zIndex);
			}
			return e.prototype.isVisible = function() {
				return this.display > 0 && this.opacity > 0 && this.visibility === 0;
			}, e.prototype.isTransparent = function() {
				return mr(this.backgroundColor);
			}, e.prototype.isTransformed = function() {
				return this.transform !== null;
			}, e.prototype.isPositioned = function() {
				return this.position !== 0;
			}, e.prototype.isPositionedWithZIndex = function() {
				return this.isPositioned() && !this.zIndex.auto;
			}, e.prototype.isFloating = function() {
				return this.float !== 0;
			}, e.prototype.isInlineLevel = function() {
				return ha(this.display, 4) || ha(this.display, 33554432) || ha(this.display, 268435456) || ha(this.display, 536870912) || ha(this.display, 67108864) || ha(this.display, 134217728);
			}, e;
		}(), Da = function() {
			function e(e, t) {
				this.content = J(e, ga, t.content), this.quotes = J(e, ba, t.quotes);
			}
			return e;
		}(), Oa = function() {
			function e(e, t) {
				this.counterIncrement = J(e, _a, t.counterIncrement), this.counterReset = J(e, va, t.counterReset);
			}
			return e;
		}(), J = function(e, t, n) {
			var r = new Bn(), i = n == null ? t.initialValue : n.toString();
			r.write(i);
			var a = new Vn(r.read());
			switch (t.type) {
				case 2:
					var o = a.parseComponentValue();
					return t.parse(e, Wn(o) ? o.value : t.initialValue);
				case 0: return t.parse(e, a.parseComponentValue());
				case 1: return t.parse(e, a.parseComponentValues());
				case 4: return a.parseComponentValue();
				case 3:
					switch (t.format) {
						case "angle": return lr.parse(e, a.parseComponentValue());
						case "color": return pr.parse(e, a.parseComponentValue());
						case "image": return qr.parse(e, a.parseComponentValue());
						case "length":
							var s = a.parseComponentValue();
							return Zn(s) ? s : er;
						case "length-percentage":
							var c = a.parseComponentValue();
							return Qn(c) ? c : er;
						case "time": return oa.parse(e, a.parseComponentValue());
					}
					break;
			}
		}, ka = "data-html2canvas-debug", Aa = function(e) {
			switch (e.getAttribute(ka)) {
				case "all": return 1;
				case "clone": return 2;
				case "parse": return 3;
				case "render": return 4;
				default: return 0;
			}
		}, ja = function(e, t) {
			var n = Aa(e);
			return n === 1 || t === n;
		}, Ma = function() {
			function e(e, t) {
				if (this.context = e, this.textNodes = [], this.elements = [], this.flags = 0, ja(t, 3)) debugger;
				this.styles = new Ea(e, window.getComputedStyle(t, null)), bs(t) && (this.styles.animationDuration.some(function(e) {
					return e > 0;
				}) && (t.style.animationDuration = "0s"), this.styles.transform !== null && (t.style.transform = "none")), this.bounds = s(this.context, t), ja(t, 4) && (this.flags |= 16);
			}
			return e;
		}(), Na = "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", Pa = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Fa = typeof Uint8Array > "u" ? [] : /* @__PURE__ */ new Uint8Array(256), Ia = 0; Ia < Pa.length; Ia++) Fa[Pa.charCodeAt(Ia)] = Ia;
		for (var La = function(e) {
			var t = e.length * .75, n = e.length, r, i = 0, a, o, s, c;
			e[e.length - 1] === "=" && (t--, e[e.length - 2] === "=" && t--);
			var l = typeof ArrayBuffer < "u" && typeof Uint8Array < "u" && Uint8Array.prototype.slice !== void 0 ? new ArrayBuffer(t) : Array(t), u = Array.isArray(l) ? l : new Uint8Array(l);
			for (r = 0; r < n; r += 4) a = Fa[e.charCodeAt(r)], o = Fa[e.charCodeAt(r + 1)], s = Fa[e.charCodeAt(r + 2)], c = Fa[e.charCodeAt(r + 3)], u[i++] = a << 2 | o >> 4, u[i++] = (o & 15) << 4 | s >> 2, u[i++] = (s & 3) << 6 | c & 63;
			return l;
		}, Ra = function(e) {
			for (var t = e.length, n = [], r = 0; r < t; r += 2) n.push(e[r + 1] << 8 | e[r]);
			return n;
		}, za = function(e) {
			for (var t = e.length, n = [], r = 0; r < t; r += 4) n.push(e[r + 3] << 24 | e[r + 2] << 16 | e[r + 1] << 8 | e[r]);
			return n;
		}, Ba = 5, Va = 11, Ha = 2, Ua = Va - Ba, Wa = 65536 >> Ba, Ga = (1 << Ba) - 1, Ka = Wa + (1024 >> Ba) + 32, qa = 65536 >> Va, Ja = (1 << Ua) - 1, Ya = function(e, t, n) {
			return e.slice ? e.slice(t, n) : new Uint16Array(Array.prototype.slice.call(e, t, n));
		}, Xa = function(e, t, n) {
			return e.slice ? e.slice(t, n) : new Uint32Array(Array.prototype.slice.call(e, t, n));
		}, Za = function(e, t) {
			var n = La(e), r = Array.isArray(n) ? za(n) : new Uint32Array(n), i = Array.isArray(n) ? Ra(n) : new Uint16Array(n), a = 24, o = Ya(i, a / 2, r[4] / 2), s = r[5] === 2 ? Ya(i, (a + r[4]) / 2) : Xa(r, Math.ceil((a + r[4]) / 4));
			return new Qa(r[0], r[1], r[2], r[3], o, s);
		}, Qa = function() {
			function e(e, t, n, r, i, a) {
				this.initialValue = e, this.errorValue = t, this.highStart = n, this.highValueIndex = r, this.index = i, this.data = a;
			}
			return e.prototype.get = function(e) {
				var t;
				if (e >= 0) {
					if (e < 55296 || e > 56319 && e <= 65535) return t = this.index[e >> Ba], t = (t << Ha) + (e & Ga), this.data[t];
					if (e <= 65535) return t = this.index[Wa + (e - 55296 >> Ba)], t = (t << Ha) + (e & Ga), this.data[t];
					if (e < this.highStart) return t = Ka - qa + (e >> Va), t = this.index[t], t += e >> Ba & Ja, t = this.index[t], t = (t << Ha) + (e & Ga), this.data[t];
					if (e <= 1114111) return this.data[this.highValueIndex];
				}
				return this.errorValue;
			}, e;
		}(), $a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", eo = typeof Uint8Array > "u" ? [] : /* @__PURE__ */ new Uint8Array(256), to = 0; to < $a.length; to++) eo[$a.charCodeAt(to)] = to;
		var no = 1, ro = 2, io = 3, ao = 4, oo = 5, so = 7, co = 8, lo = 9, uo = 10, fo = 11, po = 12, mo = 13, ho = 14, go = 15, _o = function(e) {
			for (var t = [], n = 0, r = e.length; n < r;) {
				var i = e.charCodeAt(n++);
				if (i >= 55296 && i <= 56319 && n < r) {
					var a = e.charCodeAt(n++);
					(a & 64512) == 56320 ? t.push(((i & 1023) << 10) + (a & 1023) + 65536) : (t.push(i), n--);
				} else t.push(i);
			}
			return t;
		}, vo = function() {
			var e = [...arguments];
			if (String.fromCodePoint) return String.fromCodePoint.apply(String, e);
			var t = e.length;
			if (!t) return "";
			for (var n = [], r = -1, i = ""; ++r < t;) {
				var a = e[r];
				a <= 65535 ? n.push(a) : (a -= 65536, n.push((a >> 10) + 55296, a % 1024 + 56320)), (r + 1 === t || n.length > 16384) && (i += String.fromCharCode.apply(String, n), n.length = 0);
			}
			return i;
		}, yo = Za(Na), bo = "×", xo = "÷", So = function(e) {
			return yo.get(e);
		}, Co = function(e, t, n) {
			var r = n - 2, i = t[r], a = t[n - 1], o = t[n];
			if (a === ro && o === io) return bo;
			if (a === ro || a === io || a === ao || o === ro || o === io || o === ao) return xo;
			if (a === co && [
				co,
				lo,
				fo,
				po
			].indexOf(o) !== -1 || (a === fo || a === lo) && (o === lo || o === uo) || (a === po || a === uo) && o === uo || o === mo || o === oo || o === so || a === no) return bo;
			if (a === mo && o === ho) {
				for (; i === oo;) i = t[--r];
				if (i === ho) return bo;
			}
			if (a === go && o === go) {
				for (var s = 0; i === go;) s++, i = t[--r];
				if (s % 2 == 0) return bo;
			}
			return xo;
		}, wo = function(e) {
			var t = _o(e), n = t.length, r = 0, i = 0, a = t.map(So);
			return { next: function() {
				if (r >= n) return {
					done: !0,
					value: null
				};
				for (var e = bo; r < n && (e = Co(t, a, ++r)) === bo;);
				if (e !== bo || r === n) {
					var o = vo.apply(null, t.slice(i, r));
					return i = r, {
						value: o,
						done: !1
					};
				}
				return {
					done: !0,
					value: null
				};
			} };
		}, To = function(e) {
			for (var t = wo(e), n = [], r; !(r = t.next()).done;) r.value && n.push(r.value.slice());
			return n;
		}, Eo = function(e) {
			var t = 123;
			if (e.createRange) {
				var n = e.createRange();
				if (n.getBoundingClientRect) {
					var r = e.createElement("boundtest");
					r.style.height = t + "px", r.style.display = "block", e.body.appendChild(r), n.selectNode(r);
					var i = n.getBoundingClientRect(), a = Math.round(i.height);
					if (e.body.removeChild(r), a === t) return !0;
				}
			}
			return !1;
		}, Do = function(e) {
			var t = e.createElement("boundtest");
			t.style.width = "50px", t.style.display = "block", t.style.fontSize = "12px", t.style.letterSpacing = "0px", t.style.wordSpacing = "0px", e.body.appendChild(t);
			var n = e.createRange();
			t.innerHTML = typeof "".repeat == "function" ? "&#128104;".repeat(10) : "";
			var r = t.firstChild, i = l(r.data).map(function(e) {
				return u(e);
			}), a = 0, o = {}, s = i.every(function(e, t) {
				n.setStart(r, a), n.setEnd(r, a + e.length);
				var i = n.getBoundingClientRect();
				a += e.length;
				var s = i.x > o.x || i.y > o.y;
				return o = i, t === 0 || s;
			});
			return e.body.removeChild(t), s;
		}, Oo = function() {
			return new Image().crossOrigin !== void 0;
		}, ko = function() {
			return typeof new XMLHttpRequest().responseType == "string";
		}, Ao = function(e) {
			var t = new Image(), n = e.createElement("canvas"), r = n.getContext("2d");
			if (!r) return !1;
			t.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
			try {
				r.drawImage(t, 0, 0), n.toDataURL();
			} catch {
				return !1;
			}
			return !0;
		}, jo = function(e) {
			return e[0] === 0 && e[1] === 255 && e[2] === 0 && e[3] === 255;
		}, Mo = function(e) {
			var t = e.createElement("canvas"), n = 100;
			t.width = n, t.height = n;
			var r = t.getContext("2d");
			if (!r) return Promise.reject(!1);
			r.fillStyle = "rgb(0, 255, 0)", r.fillRect(0, 0, n, n);
			var i = new Image(), a = t.toDataURL();
			i.src = a;
			var o = No(n, n, 0, 0, i);
			return r.fillStyle = "red", r.fillRect(0, 0, n, n), Po(o).then(function(t) {
				r.drawImage(t, 0, 0);
				var i = r.getImageData(0, 0, n, n).data;
				r.fillStyle = "red", r.fillRect(0, 0, n, n);
				var o = e.createElement("div");
				return o.style.backgroundImage = "url(" + a + ")", o.style.height = n + "px", jo(i) ? Po(No(n, n, 0, 0, o)) : Promise.reject(!1);
			}).then(function(e) {
				return r.drawImage(e, 0, 0), jo(r.getImageData(0, 0, n, n).data);
			}).catch(function() {
				return !1;
			});
		}, No = function(e, t, n, r, i) {
			var a = "http://www.w3.org/2000/svg", o = document.createElementNS(a, "svg"), s = document.createElementNS(a, "foreignObject");
			return o.setAttributeNS(null, "width", e.toString()), o.setAttributeNS(null, "height", t.toString()), s.setAttributeNS(null, "width", "100%"), s.setAttributeNS(null, "height", "100%"), s.setAttributeNS(null, "x", n.toString()), s.setAttributeNS(null, "y", r.toString()), s.setAttributeNS(null, "externalResourcesRequired", "true"), o.appendChild(s), s.appendChild(i), o;
		}, Po = function(e) {
			return new Promise(function(t, n) {
				var r = new Image();
				r.onload = function() {
					return t(r);
				}, r.onerror = n, r.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(e));
			});
		}, Fo = {
			get SUPPORT_RANGE_BOUNDS() {
				var e = Eo(document);
				return Object.defineProperty(Fo, "SUPPORT_RANGE_BOUNDS", { value: e }), e;
			},
			get SUPPORT_WORD_BREAKING() {
				var e = Fo.SUPPORT_RANGE_BOUNDS && Do(document);
				return Object.defineProperty(Fo, "SUPPORT_WORD_BREAKING", { value: e }), e;
			},
			get SUPPORT_SVG_DRAWING() {
				var e = Ao(document);
				return Object.defineProperty(Fo, "SUPPORT_SVG_DRAWING", { value: e }), e;
			},
			get SUPPORT_FOREIGNOBJECT_DRAWING() {
				var e = typeof Array.from == "function" && typeof window.fetch == "function" ? Mo(document) : Promise.resolve(!1);
				return Object.defineProperty(Fo, "SUPPORT_FOREIGNOBJECT_DRAWING", { value: e }), e;
			},
			get SUPPORT_CORS_IMAGES() {
				var e = Oo();
				return Object.defineProperty(Fo, "SUPPORT_CORS_IMAGES", { value: e }), e;
			},
			get SUPPORT_RESPONSE_TYPE() {
				var e = ko();
				return Object.defineProperty(Fo, "SUPPORT_RESPONSE_TYPE", { value: e }), e;
			},
			get SUPPORT_CORS_XHR() {
				var e = "withCredentials" in new XMLHttpRequest();
				return Object.defineProperty(Fo, "SUPPORT_CORS_XHR", { value: e }), e;
			},
			get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
				var e = !!(typeof Intl < "u" && Intl.Segmenter);
				return Object.defineProperty(Fo, "SUPPORT_NATIVE_TEXT_SEGMENTATION", { value: e }), e;
			}
		}, Io = function() {
			function e(e, t) {
				this.text = e, this.bounds = t;
			}
			return e;
		}(), Lo = function(e, t, n, r) {
			var i = Ho(t, n), a = [], s = 0;
			return i.forEach(function(t) {
				if (n.textDecorationLine.length || t.trim().length > 0) if (Fo.SUPPORT_RANGE_BOUNDS) {
					var i = zo(r, s, t.length).getClientRects();
					if (i.length > 1) {
						var c = Bo(t), l = 0;
						c.forEach(function(t) {
							a.push(new Io(t, o.fromDOMRectList(e, zo(r, l + s, t.length).getClientRects()))), l += t.length;
						});
					} else a.push(new Io(t, o.fromDOMRectList(e, i)));
				} else {
					var u = r.splitText(t.length);
					a.push(new Io(t, Ro(e, r))), r = u;
				}
				else Fo.SUPPORT_RANGE_BOUNDS || (r = r.splitText(t.length));
				s += t.length;
			}), a;
		}, Ro = function(e, t) {
			var n = t.ownerDocument;
			if (n) {
				var r = n.createElement("html2canvaswrapper");
				r.appendChild(t.cloneNode(!0));
				var i = t.parentNode;
				if (i) {
					i.replaceChild(r, t);
					var a = s(e, r);
					return r.firstChild && i.replaceChild(r.firstChild, r), a;
				}
			}
			return o.EMPTY;
		}, zo = function(e, t, n) {
			var r = e.ownerDocument;
			if (!r) throw Error("Node has no owner document");
			var i = r.createRange();
			return i.setStart(e, t), i.setEnd(e, t + n), i;
		}, Bo = function(e) {
			if (Fo.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
				var t = new Intl.Segmenter(void 0, { granularity: "grapheme" });
				return Array.from(t.segment(e)).map(function(e) {
					return e.segment;
				});
			}
			return To(e);
		}, Vo = function(e, t) {
			if (Fo.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
				var n = new Intl.Segmenter(void 0, { granularity: "word" });
				return Array.from(n.segment(e)).map(function(e) {
					return e.segment;
				});
			}
			return Wo(e, t);
		}, Ho = function(e, t) {
			return t.letterSpacing === 0 ? Vo(e, t) : Bo(e);
		}, Uo = [
			32,
			160,
			4961,
			65792,
			65793,
			4153,
			4241
		], Wo = function(e, t) {
			for (var n = tt(e, {
				lineBreak: t.lineBreak,
				wordBreak: t.overflowWrap === "break-word" ? "break-word" : t.wordBreak
			}), r = [], i, a = function() {
				if (i.value) {
					var e = l(i.value.slice()), t = "";
					e.forEach(function(e) {
						Uo.indexOf(e) === -1 ? t += u(e) : (t.length && r.push(t), r.push(u(e)), t = "");
					}), t.length && r.push(t);
				}
			}; !(i = n.next()).done;) a();
			return r;
		}, Go = function() {
			function e(e, t, n) {
				this.text = Ko(t.data, n.textTransform), this.textBounds = Lo(e, this.text, n, t);
			}
			return e;
		}(), Ko = function(e, t) {
			switch (t) {
				case 1: return e.toLowerCase();
				case 3: return e.replace(qo, Jo);
				case 2: return e.toUpperCase();
				default: return e;
			}
		}, qo = /(^|\s|:|-|\(|\))([a-z])/g, Jo = function(e, t, n) {
			return e.length > 0 ? t + n.toUpperCase() : e;
		}, Yo = function(e) {
			t(n, e);
			function n(t, n) {
				var r = e.call(this, t, n) || this;
				return r.src = n.currentSrc || n.src, r.intrinsicWidth = n.naturalWidth, r.intrinsicHeight = n.naturalHeight, r.context.cache.addImage(r.src), r;
			}
			return n;
		}(Ma), Xo = function(e) {
			t(n, e);
			function n(t, n) {
				var r = e.call(this, t, n) || this;
				return r.canvas = n, r.intrinsicWidth = n.width, r.intrinsicHeight = n.height, r;
			}
			return n;
		}(Ma), Zo = function(e) {
			t(n, e);
			function n(t, n) {
				var r = e.call(this, t, n) || this, i = new XMLSerializer(), a = s(t, n);
				return n.setAttribute("width", a.width + "px"), n.setAttribute("height", a.height + "px"), r.svg = "data:image/svg+xml," + encodeURIComponent(i.serializeToString(n)), r.intrinsicWidth = n.width.baseVal.value, r.intrinsicHeight = n.height.baseVal.value, r.context.cache.addImage(r.svg), r;
			}
			return n;
		}(Ma), Qo = function(e) {
			t(n, e);
			function n(t, n) {
				var r = e.call(this, t, n) || this;
				return r.value = n.value, r;
			}
			return n;
		}(Ma), $o = function(e) {
			t(n, e);
			function n(t, n) {
				var r = e.call(this, t, n) || this;
				return r.start = n.start, r.reversed = typeof n.reversed == "boolean" && n.reversed === !0, r;
			}
			return n;
		}(Ma), es = [{
			type: 15,
			flags: 0,
			unit: "px",
			number: 3
		}], ts = [{
			type: 16,
			flags: 0,
			number: 50
		}], ns = function(e) {
			return e.width > e.height ? new o(e.left + (e.width - e.height) / 2, e.top, e.height, e.height) : e.width < e.height ? new o(e.left, e.top + (e.height - e.width) / 2, e.width, e.width) : e;
		}, rs = function(e) {
			var t = e.type === os ? Array(e.value.length + 1).join("•") : e.value;
			return t.length === 0 ? e.placeholder || "" : t;
		}, is = "checkbox", as = "radio", os = "password", ss = 707406591, cs = function(e) {
			t(n, e);
			function n(t, n) {
				var r = e.call(this, t, n) || this;
				switch (r.type = n.type.toLowerCase(), r.checked = n.checked, r.value = rs(n), (r.type === is || r.type === as) && (r.styles.backgroundColor = 3739148031, r.styles.borderTopColor = r.styles.borderRightColor = r.styles.borderBottomColor = r.styles.borderLeftColor = 2779096575, r.styles.borderTopWidth = r.styles.borderRightWidth = r.styles.borderBottomWidth = r.styles.borderLeftWidth = 1, r.styles.borderTopStyle = r.styles.borderRightStyle = r.styles.borderBottomStyle = r.styles.borderLeftStyle = 1, r.styles.backgroundClip = [0], r.styles.backgroundOrigin = [0], r.bounds = ns(r.bounds)), r.type) {
					case is:
						r.styles.borderTopRightRadius = r.styles.borderTopLeftRadius = r.styles.borderBottomRightRadius = r.styles.borderBottomLeftRadius = es;
						break;
					case as:
						r.styles.borderTopRightRadius = r.styles.borderTopLeftRadius = r.styles.borderBottomRightRadius = r.styles.borderBottomLeftRadius = ts;
						break;
				}
				return r;
			}
			return n;
		}(Ma), ls = function(e) {
			t(n, e);
			function n(t, n) {
				var r = e.call(this, t, n) || this, i = n.options[n.selectedIndex || 0];
				return r.value = i && i.text || "", r;
			}
			return n;
		}(Ma), us = function(e) {
			t(n, e);
			function n(t, n) {
				var r = e.call(this, t, n) || this;
				return r.value = n.value, r;
			}
			return n;
		}(Ma), ds = function(e) {
			t(n, e);
			function n(t, n) {
				var r = e.call(this, t, n) || this;
				r.src = n.src, r.width = parseInt(n.width, 10) || 0, r.height = parseInt(n.height, 10) || 0, r.backgroundColor = r.styles.backgroundColor;
				try {
					if (n.contentWindow && n.contentWindow.document && n.contentWindow.document.documentElement) {
						r.tree = hs(t, n.contentWindow.document.documentElement);
						var i = n.contentWindow.document.documentElement ? Sr(t, getComputedStyle(n.contentWindow.document.documentElement).backgroundColor) : Cr.TRANSPARENT, a = n.contentWindow.document.body ? Sr(t, getComputedStyle(n.contentWindow.document.body).backgroundColor) : Cr.TRANSPARENT;
						r.backgroundColor = mr(i) ? mr(a) ? r.styles.backgroundColor : a : i;
					}
				} catch {}
				return r;
			}
			return n;
		}(Ma), fs = [
			"OL",
			"UL",
			"MENU"
		], ps = function(e, t, n, r) {
			for (var i = t.firstChild, a = void 0; i; i = a) if (a = i.nextSibling, vs(i) && i.data.trim().length > 0) n.textNodes.push(new Go(e, i, n.styles));
			else if (ys(i)) if (Is(i) && i.assignedNodes) i.assignedNodes().forEach(function(t) {
				return ps(e, t, n, r);
			});
			else {
				var o = ms(e, i);
				o.styles.isVisible() && (gs(i, o, r) ? o.flags |= 4 : _s(o.styles) && (o.flags |= 2), fs.indexOf(i.tagName) !== -1 && (o.flags |= 8), n.elements.push(o), i.slot, i.shadowRoot ? ps(e, i.shadowRoot, o, r) : !Ps(i) && !Es(i) && !Fs(i) && ps(e, i, o, r));
			}
		}, ms = function(e, t) {
			return As(t) ? new Yo(e, t) : Os(t) ? new Xo(e, t) : Es(t) ? new Zo(e, t) : Ss(t) ? new Qo(e, t) : Cs(t) ? new $o(e, t) : ws(t) ? new cs(e, t) : Fs(t) ? new ls(e, t) : Ps(t) ? new us(e, t) : js(t) ? new ds(e, t) : new Ma(e, t);
		}, hs = function(e, t) {
			var n = ms(e, t);
			return n.flags |= 4, ps(e, t, n, n), n;
		}, gs = function(e, t, n) {
			return t.styles.isPositionedWithZIndex() || t.styles.opacity < 1 || t.styles.isTransformed() || Ds(e) && n.styles.isTransparent();
		}, _s = function(e) {
			return e.isPositioned() || e.isFloating();
		}, vs = function(e) {
			return e.nodeType === Node.TEXT_NODE;
		}, ys = function(e) {
			return e.nodeType === Node.ELEMENT_NODE;
		}, bs = function(e) {
			return ys(e) && e.style !== void 0 && !xs(e);
		}, xs = function(e) {
			return typeof e.className == "object";
		}, Ss = function(e) {
			return e.tagName === "LI";
		}, Cs = function(e) {
			return e.tagName === "OL";
		}, ws = function(e) {
			return e.tagName === "INPUT";
		}, Ts = function(e) {
			return e.tagName === "HTML";
		}, Es = function(e) {
			return e.tagName === "svg";
		}, Ds = function(e) {
			return e.tagName === "BODY";
		}, Os = function(e) {
			return e.tagName === "CANVAS";
		}, ks = function(e) {
			return e.tagName === "VIDEO";
		}, As = function(e) {
			return e.tagName === "IMG";
		}, js = function(e) {
			return e.tagName === "IFRAME";
		}, Ms = function(e) {
			return e.tagName === "STYLE";
		}, Ns = function(e) {
			return e.tagName === "SCRIPT";
		}, Ps = function(e) {
			return e.tagName === "TEXTAREA";
		}, Fs = function(e) {
			return e.tagName === "SELECT";
		}, Is = function(e) {
			return e.tagName === "SLOT";
		}, Ls = function(e) {
			return e.tagName.indexOf("-") > 0;
		}, Rs = function() {
			function e() {
				this.counters = {};
			}
			return e.prototype.getCounterValue = function(e) {
				var t = this.counters[e];
				return t && t.length ? t[t.length - 1] : 1;
			}, e.prototype.getCounterValues = function(e) {
				return this.counters[e] || [];
			}, e.prototype.pop = function(e) {
				var t = this;
				e.forEach(function(e) {
					return t.counters[e].pop();
				});
			}, e.prototype.parse = function(e) {
				var t = this, n = e.counterIncrement, r = e.counterReset, i = !0;
				n !== null && n.forEach(function(e) {
					var n = t.counters[e.counter];
					n && e.increment !== 0 && (i = !1, n.length || n.push(1), n[Math.max(0, n.length - 1)] += e.increment);
				});
				var a = [];
				return i && r.forEach(function(e) {
					var n = t.counters[e.counter];
					a.push(e.counter), n ||= t.counters[e.counter] = [], n.push(e.reset);
				}), a;
			}, e;
		}(), zs = {
			integers: [
				1e3,
				900,
				500,
				400,
				100,
				90,
				50,
				40,
				10,
				9,
				5,
				4,
				1
			],
			values: [
				"M",
				"CM",
				"D",
				"CD",
				"C",
				"XC",
				"L",
				"XL",
				"X",
				"IX",
				"V",
				"IV",
				"I"
			]
		}, Bs = {
			integers: [
				9e3,
				8e3,
				7e3,
				6e3,
				5e3,
				4e3,
				3e3,
				2e3,
				1e3,
				900,
				800,
				700,
				600,
				500,
				400,
				300,
				200,
				100,
				90,
				80,
				70,
				60,
				50,
				40,
				30,
				20,
				10,
				9,
				8,
				7,
				6,
				5,
				4,
				3,
				2,
				1
			],
			values: /* @__PURE__ */ "Ք.Փ.Ւ.Ց.Ր.Տ.Վ.Ս.Ռ.Ջ.Պ.Չ.Ո.Շ.Ն.Յ.Մ.Ճ.Ղ.Ձ.Հ.Կ.Ծ.Խ.Լ.Ի.Ժ.Թ.Ը.Է.Զ.Ե.Դ.Գ.Բ.Ա".split(".")
		}, Vs = {
			integers: [
				1e4,
				9e3,
				8e3,
				7e3,
				6e3,
				5e3,
				4e3,
				3e3,
				2e3,
				1e3,
				400,
				300,
				200,
				100,
				90,
				80,
				70,
				60,
				50,
				40,
				30,
				20,
				19,
				18,
				17,
				16,
				15,
				10,
				9,
				8,
				7,
				6,
				5,
				4,
				3,
				2,
				1
			],
			values: /* @__PURE__ */ "י׳.ט׳.ח׳.ז׳.ו׳.ה׳.ד׳.ג׳.ב׳.א׳.ת.ש.ר.ק.צ.פ.ע.ס.נ.מ.ל.כ.יט.יח.יז.טז.טו.י.ט.ח.ז.ו.ה.ד.ג.ב.א".split(".")
		}, Hs = {
			integers: [
				1e4,
				9e3,
				8e3,
				7e3,
				6e3,
				5e3,
				4e3,
				3e3,
				2e3,
				1e3,
				900,
				800,
				700,
				600,
				500,
				400,
				300,
				200,
				100,
				90,
				80,
				70,
				60,
				50,
				40,
				30,
				20,
				10,
				9,
				8,
				7,
				6,
				5,
				4,
				3,
				2,
				1
			],
			values: /* @__PURE__ */ "ჵ.ჰ.ჯ.ჴ.ხ.ჭ.წ.ძ.ც.ჩ.შ.ყ.ღ.ქ.ფ.ჳ.ტ.ს.რ.ჟ.პ.ო.ჲ.ნ.მ.ლ.კ.ი.თ.ჱ.ზ.ვ.ე.დ.გ.ბ.ა".split(".")
		}, Us = function(e, t, n, r, i, a) {
			return e < t || e > n ? nc(e, i, a.length > 0) : r.integers.reduce(function(t, n, i) {
				for (; e >= n;) e -= n, t += r.values[i];
				return t;
			}, "") + a;
		}, Ws = function(e, t, n, r) {
			var i = "";
			do
				n || e--, i = r(e) + i, e /= t;
			while (e * t >= t);
			return i;
		}, Gs = function(e, t, n, r, i) {
			var a = n - t + 1;
			return (e < 0 ? "-" : "") + (Ws(Math.abs(e), a, r, function(e) {
				return u(Math.floor(e % a) + t);
			}) + i);
		}, Ks = function(e, t, n) {
			n === void 0 && (n = ". ");
			var r = t.length;
			return Ws(Math.abs(e), r, !1, function(e) {
				return t[Math.floor(e % r)];
			}) + n;
		}, qs = 1, Js = 2, Ys = 4, Xs = 8, Zs = function(e, t, n, r, i, a) {
			if (e < -9999 || e > 9999) return nc(e, 4, i.length > 0);
			var o = Math.abs(e), s = i;
			if (o === 0) return t[0] + s;
			for (var c = 0; o > 0 && c <= 4; c++) {
				var l = o % 10;
				l === 0 && ha(a, qs) && s !== "" ? s = t[l] + s : l > 1 || l === 1 && c === 0 || l === 1 && c === 1 && ha(a, Js) || l === 1 && c === 1 && ha(a, Ys) && e > 100 || l === 1 && c > 1 && ha(a, Xs) ? s = t[l] + (c > 0 ? n[c - 1] : "") + s : l === 1 && c > 0 && (s = n[c - 1] + s), o = Math.floor(o / 10);
			}
			return (e < 0 ? r : "") + s;
		}, Qs = "十百千萬", $s = "拾佰仟萬", ec = "マイナス", tc = "마이너스", nc = function(e, t, n) {
			var r = n ? ". " : "", i = n ? "、" : "", a = n ? ", " : "", o = n ? " " : "";
			switch (t) {
				case 0: return "•" + o;
				case 1: return "◦" + o;
				case 2: return "◾" + o;
				case 5:
					var s = Gs(e, 48, 57, !0, r);
					return s.length < 4 ? "0" + s : s;
				case 4: return Ks(e, "〇一二三四五六七八九", i);
				case 6: return Us(e, 1, 3999, zs, 3, r).toLowerCase();
				case 7: return Us(e, 1, 3999, zs, 3, r);
				case 8: return Gs(e, 945, 969, !1, r);
				case 9: return Gs(e, 97, 122, !1, r);
				case 10: return Gs(e, 65, 90, !1, r);
				case 11: return Gs(e, 1632, 1641, !0, r);
				case 12:
				case 49: return Us(e, 1, 9999, Bs, 3, r);
				case 35: return Us(e, 1, 9999, Bs, 3, r).toLowerCase();
				case 13: return Gs(e, 2534, 2543, !0, r);
				case 14:
				case 30: return Gs(e, 6112, 6121, !0, r);
				case 15: return Ks(e, "子丑寅卯辰巳午未申酉戌亥", i);
				case 16: return Ks(e, "甲乙丙丁戊己庚辛壬癸", i);
				case 17:
				case 48: return Zs(e, "零一二三四五六七八九", Qs, "負", i, Js | Ys | Xs);
				case 47: return Zs(e, "零壹貳參肆伍陸柒捌玖", $s, "負", i, qs | Js | Ys | Xs);
				case 42: return Zs(e, "零一二三四五六七八九", Qs, "负", i, Js | Ys | Xs);
				case 41: return Zs(e, "零壹贰叁肆伍陆柒捌玖", $s, "负", i, qs | Js | Ys | Xs);
				case 26: return Zs(e, "〇一二三四五六七八九", "十百千万", ec, i, 0);
				case 25: return Zs(e, "零壱弐参四伍六七八九", "拾百千万", ec, i, qs | Js | Ys);
				case 31: return Zs(e, "영일이삼사오육칠팔구", "십백천만", tc, a, qs | Js | Ys);
				case 33: return Zs(e, "零一二三四五六七八九", "十百千萬", tc, a, 0);
				case 32: return Zs(e, "零壹貳參四五六七八九", "拾百千", tc, a, qs | Js | Ys);
				case 18: return Gs(e, 2406, 2415, !0, r);
				case 20: return Us(e, 1, 19999, Hs, 3, r);
				case 21: return Gs(e, 2790, 2799, !0, r);
				case 22: return Gs(e, 2662, 2671, !0, r);
				case 22: return Us(e, 1, 10999, Vs, 3, r);
				case 23: return Ks(e, "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん");
				case 24: return Ks(e, "いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす");
				case 27: return Gs(e, 3302, 3311, !0, r);
				case 28: return Ks(e, "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン", i);
				case 29: return Ks(e, "イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス", i);
				case 34: return Gs(e, 3792, 3801, !0, r);
				case 37: return Gs(e, 6160, 6169, !0, r);
				case 38: return Gs(e, 4160, 4169, !0, r);
				case 39: return Gs(e, 2918, 2927, !0, r);
				case 40: return Gs(e, 1776, 1785, !0, r);
				case 43: return Gs(e, 3046, 3055, !0, r);
				case 44: return Gs(e, 3174, 3183, !0, r);
				case 45: return Gs(e, 3664, 3673, !0, r);
				case 46: return Gs(e, 3872, 3881, !0, r);
				default: return Gs(e, 48, 57, !0, r);
			}
		}, rc = "data-html2canvas-ignore", ic = function() {
			function e(e, t, n) {
				if (this.context = e, this.options = n, this.scrolledElements = [], this.referenceElement = t, this.counters = new Rs(), this.quoteDepth = 0, !t.ownerDocument) throw Error("Cloned element does not have an owner document");
				this.documentElement = this.cloneNode(t.ownerDocument.documentElement, !1);
			}
			return e.prototype.toIFrame = function(e, t) {
				var n = this, a = oc(e, t);
				if (!a.contentWindow) return Promise.reject("Unable to find iframe window");
				var o = e.defaultView.pageXOffset, s = e.defaultView.pageYOffset, c = a.contentWindow, l = c.document, u = lc(a).then(function() {
					return r(n, void 0, void 0, function() {
						var e, n;
						return i(this, function(r) {
							switch (r.label) {
								case 0: return this.scrolledElements.forEach(mc), c && (c.scrollTo(t.left, t.top), /(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (c.scrollY !== t.top || c.scrollX !== t.left) && (this.context.logger.warn("Unable to restore scroll position for cloned document"), this.context.windowBounds = this.context.windowBounds.add(c.scrollX - t.left, c.scrollY - t.top, 0, 0))), e = this.options.onclone, n = this.clonedReferenceElement, n === void 0 ? [2, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")] : l.fonts && l.fonts.ready ? [4, l.fonts.ready] : [3, 2];
								case 1: r.sent(), r.label = 2;
								case 2: return /(AppleWebKit)/g.test(navigator.userAgent) ? [4, cc(l)] : [3, 4];
								case 3: r.sent(), r.label = 4;
								case 4: return typeof e == "function" ? [2, Promise.resolve().then(function() {
									return e(l, n);
								}).then(function() {
									return a;
								})] : [2, a];
							}
						});
					});
				});
				return l.open(), l.write(fc(document.doctype) + "<html></html>"), pc(this.referenceElement.ownerDocument, o, s), l.replaceChild(l.adoptNode(this.documentElement), l.documentElement), l.close(), u;
			}, e.prototype.createElementClone = function(e) {
				if (ja(e, 2)) debugger;
				if (Os(e)) return this.createCanvasClone(e);
				if (ks(e)) return this.createVideoClone(e);
				if (Ms(e)) return this.createStyleClone(e);
				var t = e.cloneNode(!1);
				return As(t) && (As(e) && e.currentSrc && e.currentSrc !== e.src && (t.src = e.currentSrc, t.srcset = ""), t.loading === "lazy" && (t.loading = "eager")), Ls(t) ? this.createCustomElementClone(t) : t;
			}, e.prototype.createCustomElementClone = function(e) {
				var t = document.createElement("html2canvascustomelement");
				return dc(e.style, t), t;
			}, e.prototype.createStyleClone = function(e) {
				try {
					var t = e.sheet;
					if (t && t.cssRules) {
						var n = [].slice.call(t.cssRules, 0).reduce(function(e, t) {
							return t && typeof t.cssText == "string" ? e + t.cssText : e;
						}, ""), r = e.cloneNode(!1);
						return r.textContent = n, r;
					}
				} catch (e) {
					if (this.context.logger.error("Unable to access cssRules property", e), e.name !== "SecurityError") throw e;
				}
				return e.cloneNode(!1);
			}, e.prototype.createCanvasClone = function(e) {
				if (this.options.inlineImages && e.ownerDocument) {
					var t = e.ownerDocument.createElement("img");
					try {
						return t.src = e.toDataURL(), t;
					} catch {
						this.context.logger.info("Unable to inline canvas contents, canvas is tainted", e);
					}
				}
				var n = e.cloneNode(!1);
				try {
					n.width = e.width, n.height = e.height;
					var r = e.getContext("2d"), i = n.getContext("2d");
					if (i) if (!this.options.allowTaint && r) i.putImageData(r.getImageData(0, 0, e.width, e.height), 0, 0);
					else {
						var a = e.getContext("webgl2") ?? e.getContext("webgl");
						a && a.getContextAttributes()?.preserveDrawingBuffer === !1 && this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", e), i.drawImage(e, 0, 0);
					}
					return n;
				} catch {
					this.context.logger.info("Unable to clone canvas as it is tainted", e);
				}
				return n;
			}, e.prototype.createVideoClone = function(e) {
				var t = e.ownerDocument.createElement("canvas");
				t.width = e.offsetWidth, t.height = e.offsetHeight;
				var n = t.getContext("2d");
				try {
					return n && (n.drawImage(e, 0, 0, t.width, t.height), this.options.allowTaint || n.getImageData(0, 0, t.width, t.height)), t;
				} catch {
					this.context.logger.info("Unable to clone video as it is tainted", e);
				}
				var r = e.ownerDocument.createElement("canvas");
				return r.width = e.offsetWidth, r.height = e.offsetHeight, r;
			}, e.prototype.appendChildNode = function(e, t, n) {
				(!ys(t) || !Ns(t) && !t.hasAttribute(rc) && (typeof this.options.ignoreElements != "function" || !this.options.ignoreElements(t))) && (!this.options.copyStyles || !ys(t) || !Ms(t)) && e.appendChild(this.cloneNode(t, n));
			}, e.prototype.cloneChildNodes = function(e, t, n) {
				for (var r = this, i = e.shadowRoot ? e.shadowRoot.firstChild : e.firstChild; i; i = i.nextSibling) if (ys(i) && Is(i) && typeof i.assignedNodes == "function") {
					var a = i.assignedNodes();
					a.length && a.forEach(function(e) {
						return r.appendChildNode(t, e, n);
					});
				} else this.appendChildNode(t, i, n);
			}, e.prototype.cloneNode = function(e, t) {
				if (vs(e)) return document.createTextNode(e.data);
				if (!e.ownerDocument) return e.cloneNode(!1);
				var n = e.ownerDocument.defaultView;
				if (n && ys(e) && (bs(e) || xs(e))) {
					var r = this.createElementClone(e);
					r.style.transitionProperty = "none";
					var i = n.getComputedStyle(e), a = n.getComputedStyle(e, ":before"), o = n.getComputedStyle(e, ":after");
					this.referenceElement === e && bs(r) && (this.clonedReferenceElement = r), Ds(r) && bc(r);
					var s = this.counters.parse(new Oa(this.context, i)), c = this.resolvePseudoContent(e, r, a, ac.BEFORE);
					Ls(e) && (t = !0), ks(e) || this.cloneChildNodes(e, r, t), c && r.insertBefore(c, r.firstChild);
					var l = this.resolvePseudoContent(e, r, o, ac.AFTER);
					return l && r.appendChild(l), this.counters.pop(s), (i && (this.options.copyStyles || xs(e)) && !js(e) || t) && dc(i, r), (e.scrollTop !== 0 || e.scrollLeft !== 0) && this.scrolledElements.push([
						r,
						e.scrollLeft,
						e.scrollTop
					]), (Ps(e) || Fs(e)) && (Ps(r) || Fs(r)) && (r.value = e.value), r;
				}
				return e.cloneNode(!1);
			}, e.prototype.resolvePseudoContent = function(e, t, n, r) {
				var i = this;
				if (n) {
					var a = n.content, o = t.ownerDocument;
					if (!(!o || !a || a === "none" || a === "-moz-alt-content" || n.display === "none")) {
						this.counters.parse(new Oa(this.context, n));
						var s = new Da(this.context, n), c = o.createElement("html2canvaspseudoelement");
						dc(n, c), s.content.forEach(function(t) {
							if (t.type === 0) c.appendChild(o.createTextNode(t.value));
							else if (t.type === 22) {
								var n = o.createElement("img");
								n.src = t.value, n.style.opacity = "1", c.appendChild(n);
							} else if (t.type === 18) {
								if (t.name === "attr") {
									var r = t.values.filter(Wn);
									r.length && c.appendChild(o.createTextNode(e.getAttribute(r[0].value) || ""));
								} else if (t.name === "counter") {
									var a = t.values.filter(Jn), l = a[0], u = a[1];
									if (l && Wn(l)) {
										var d = i.counters.getCounterValue(l.value), f = u && Wn(u) ? Fi.parse(i.context, u.value) : 3;
										c.appendChild(o.createTextNode(nc(d, f, !1)));
									}
								} else if (t.name === "counters") {
									var p = t.values.filter(Jn), l = p[0], m = p[1], u = p[2];
									if (l && Wn(l)) {
										var h = i.counters.getCounterValues(l.value), g = u && Wn(u) ? Fi.parse(i.context, u.value) : 3, _ = m && m.type === 0 ? m.value : "", v = h.map(function(e) {
											return nc(e, g, !1);
										}).join(_);
										c.appendChild(o.createTextNode(v));
									}
								}
							} else if (t.type === 20) switch (t.value) {
								case "open-quote":
									c.appendChild(o.createTextNode(xa(s.quotes, i.quoteDepth++, !0)));
									break;
								case "close-quote":
									c.appendChild(o.createTextNode(xa(s.quotes, --i.quoteDepth, !1)));
									break;
								default: c.appendChild(o.createTextNode(t.value));
							}
						}), c.className = _c + " " + vc;
						var l = r === ac.BEFORE ? " " + _c : " " + vc;
						return xs(t) ? t.className.baseValue += l : t.className += l, c;
					}
				}
			}, e.destroy = function(e) {
				return e.parentNode ? (e.parentNode.removeChild(e), !0) : !1;
			}, e;
		}(), ac;
		(function(e) {
			e[e.BEFORE = 0] = "BEFORE", e[e.AFTER = 1] = "AFTER";
		})(ac ||= {});
		var oc = function(e, t) {
			var n = e.createElement("iframe");
			return n.className = "html2canvas-container", n.style.visibility = "hidden", n.style.position = "fixed", n.style.left = "-10000px", n.style.top = "0px", n.style.border = "0", n.width = t.width.toString(), n.height = t.height.toString(), n.scrolling = "no", n.setAttribute(rc, "true"), e.body.appendChild(n), n;
		}, sc = function(e) {
			return new Promise(function(t) {
				if (e.complete) {
					t();
					return;
				}
				if (!e.src) {
					t();
					return;
				}
				e.onload = t, e.onerror = t;
			});
		}, cc = function(e) {
			return Promise.all([].slice.call(e.images, 0).map(sc));
		}, lc = function(e) {
			return new Promise(function(t, n) {
				var r = e.contentWindow;
				if (!r) return n("No window assigned for iframe");
				var i = r.document;
				r.onload = e.onload = function() {
					r.onload = e.onload = null;
					var n = setInterval(function() {
						i.body.childNodes.length > 0 && i.readyState === "complete" && (clearInterval(n), t(e));
					}, 50);
				};
			});
		}, uc = [
			"all",
			"d",
			"content"
		], dc = function(e, t) {
			for (var n = e.length - 1; n >= 0; n--) {
				var r = e.item(n);
				uc.indexOf(r) === -1 && t.style.setProperty(r, e.getPropertyValue(r));
			}
			return t;
		}, fc = function(e) {
			var t = "";
			return e && (t += "<!DOCTYPE ", e.name && (t += e.name), e.internalSubset && (t += e.internalSubset), e.publicId && (t += "\"" + e.publicId + "\""), e.systemId && (t += "\"" + e.systemId + "\""), t += ">"), t;
		}, pc = function(e, t, n) {
			e && e.defaultView && (t !== e.defaultView.pageXOffset || n !== e.defaultView.pageYOffset) && e.defaultView.scrollTo(t, n);
		}, mc = function(e) {
			var t = e[0], n = e[1], r = e[2];
			t.scrollLeft = n, t.scrollTop = r;
		}, hc = ":before", gc = ":after", _c = "___html2canvas___pseudoelement_before", vc = "___html2canvas___pseudoelement_after", yc = "{\n    content: \"\" !important;\n    display: none !important;\n}", bc = function(e) {
			xc(e, "." + _c + hc + yc + "\n         ." + vc + gc + yc);
		}, xc = function(e, t) {
			var n = e.ownerDocument;
			if (n) {
				var r = n.createElement("style");
				r.textContent = t, e.appendChild(r);
			}
		}, Sc = function() {
			function e() {}
			return e.getOrigin = function(t) {
				var n = e._link;
				return n ? (n.href = t, n.href = n.href, n.protocol + n.hostname + n.port) : "about:blank";
			}, e.isSameOrigin = function(t) {
				return e.getOrigin(t) === e._origin;
			}, e.setContext = function(t) {
				e._link = t.document.createElement("a"), e._origin = e.getOrigin(t.location.href);
			}, e._origin = "about:blank", e;
		}(), Cc = function() {
			function e(e, t) {
				this.context = e, this._options = t, this._cache = {};
			}
			return e.prototype.addImage = function(e) {
				var t = Promise.resolve();
				return this.has(e) || (Ac(e) || Dc(e)) && (this._cache[e] = this.loadImage(e)).catch(function() {}), t;
			}, e.prototype.match = function(e) {
				return this._cache[e];
			}, e.prototype.loadImage = function(e) {
				return r(this, void 0, void 0, function() {
					var t, n, r, a, o = this;
					return i(this, function(i) {
						switch (i.label) {
							case 0: return t = Sc.isSameOrigin(e), n = !Oc(e) && this._options.useCORS === !0 && Fo.SUPPORT_CORS_IMAGES && !t, r = !Oc(e) && !t && !Ac(e) && typeof this._options.proxy == "string" && Fo.SUPPORT_CORS_XHR && !n, !t && this._options.allowTaint === !1 && !Oc(e) && !Ac(e) && !r && !n ? [2] : (a = e, r ? [4, this.proxy(a)] : [3, 2]);
							case 1: a = i.sent(), i.label = 2;
							case 2: return this.context.logger.debug("Added image " + e.substring(0, 256)), [4, new Promise(function(e, t) {
								var r = new Image();
								r.onload = function() {
									return e(r);
								}, r.onerror = t, (kc(a) || n) && (r.crossOrigin = "anonymous"), r.src = a, r.complete === !0 && setTimeout(function() {
									return e(r);
								}, 500), o._options.imageTimeout > 0 && setTimeout(function() {
									return t("Timed out (" + o._options.imageTimeout + "ms) loading image");
								}, o._options.imageTimeout);
							})];
							case 3: return [2, i.sent()];
						}
					});
				});
			}, e.prototype.has = function(e) {
				return this._cache[e] !== void 0;
			}, e.prototype.keys = function() {
				return Promise.resolve(Object.keys(this._cache));
			}, e.prototype.proxy = function(e) {
				var t = this, n = this._options.proxy;
				if (!n) throw Error("No proxy defined");
				var r = e.substring(0, 256);
				return new Promise(function(i, a) {
					var o = Fo.SUPPORT_RESPONSE_TYPE ? "blob" : "text", s = new XMLHttpRequest();
					s.onload = function() {
						if (s.status === 200) if (o === "text") i(s.response);
						else {
							var e = new FileReader();
							e.addEventListener("load", function() {
								return i(e.result);
							}, !1), e.addEventListener("error", function(e) {
								return a(e);
							}, !1), e.readAsDataURL(s.response);
						}
						else a("Failed to proxy resource " + r + " with status code " + s.status);
					}, s.onerror = a;
					var c = n.indexOf("?") > -1 ? "&" : "?";
					if (s.open("GET", "" + n + c + "url=" + encodeURIComponent(e) + "&responseType=" + o), o !== "text" && s instanceof XMLHttpRequest && (s.responseType = o), t._options.imageTimeout) {
						var l = t._options.imageTimeout;
						s.timeout = l, s.ontimeout = function() {
							return a("Timed out (" + l + "ms) proxying " + r);
						};
					}
					s.send();
				});
			}, e;
		}(), wc = /^data:image\/svg\+xml/i, Tc = /^data:image\/.*;base64,/i, Ec = /^data:image\/.*/i, Dc = function(e) {
			return Fo.SUPPORT_SVG_DRAWING || !jc(e);
		}, Oc = function(e) {
			return Ec.test(e);
		}, kc = function(e) {
			return Tc.test(e);
		}, Ac = function(e) {
			return e.substr(0, 4) === "blob";
		}, jc = function(e) {
			return e.substr(-3).toLowerCase() === "svg" || wc.test(e);
		}, Y = function() {
			function e(e, t) {
				this.type = 0, this.x = e, this.y = t;
			}
			return e.prototype.add = function(t, n) {
				return new e(this.x + t, this.y + n);
			}, e;
		}(), Mc = function(e, t, n) {
			return new Y(e.x + (t.x - e.x) * n, e.y + (t.y - e.y) * n);
		}, Nc = function() {
			function e(e, t, n, r) {
				this.type = 1, this.start = e, this.startControl = t, this.endControl = n, this.end = r;
			}
			return e.prototype.subdivide = function(t, n) {
				var r = Mc(this.start, this.startControl, t), i = Mc(this.startControl, this.endControl, t), a = Mc(this.endControl, this.end, t), o = Mc(r, i, t), s = Mc(i, a, t), c = Mc(o, s, t);
				return n ? new e(this.start, r, o, c) : new e(c, s, a, this.end);
			}, e.prototype.add = function(t, n) {
				return new e(this.start.add(t, n), this.startControl.add(t, n), this.endControl.add(t, n), this.end.add(t, n));
			}, e.prototype.reverse = function() {
				return new e(this.end, this.endControl, this.startControl, this.start);
			}, e;
		}(), Pc = function(e) {
			return e.type === 1;
		}, Fc = function() {
			function e(e) {
				var t = e.styles, n = e.bounds, r = rr(t.borderTopLeftRadius, n.width, n.height), i = r[0], a = r[1], o = rr(t.borderTopRightRadius, n.width, n.height), s = o[0], c = o[1], l = rr(t.borderBottomRightRadius, n.width, n.height), u = l[0], d = l[1], f = rr(t.borderBottomLeftRadius, n.width, n.height), p = f[0], m = f[1], h = [];
				h.push((i + s) / n.width), h.push((p + u) / n.width), h.push((a + m) / n.height), h.push((c + d) / n.height);
				var g = Math.max.apply(Math, h);
				g > 1 && (i /= g, a /= g, s /= g, c /= g, u /= g, d /= g, p /= g, m /= g);
				var _ = n.width - s, v = n.height - d, y = n.width - u, b = n.height - m, x = t.borderTopWidth, S = t.borderRightWidth, C = t.borderBottomWidth, w = t.borderLeftWidth, T = ir(t.paddingTop, e.bounds.width), E = ir(t.paddingRight, e.bounds.width), D = ir(t.paddingBottom, e.bounds.width), O = ir(t.paddingLeft, e.bounds.width);
				this.topLeftBorderDoubleOuterBox = i > 0 || a > 0 ? Lc(n.left + w / 3, n.top + x / 3, i - w / 3, a - x / 3, Ic.TOP_LEFT) : new Y(n.left + w / 3, n.top + x / 3), this.topRightBorderDoubleOuterBox = i > 0 || a > 0 ? Lc(n.left + _, n.top + x / 3, s - S / 3, c - x / 3, Ic.TOP_RIGHT) : new Y(n.left + n.width - S / 3, n.top + x / 3), this.bottomRightBorderDoubleOuterBox = u > 0 || d > 0 ? Lc(n.left + y, n.top + v, u - S / 3, d - C / 3, Ic.BOTTOM_RIGHT) : new Y(n.left + n.width - S / 3, n.top + n.height - C / 3), this.bottomLeftBorderDoubleOuterBox = p > 0 || m > 0 ? Lc(n.left + w / 3, n.top + b, p - w / 3, m - C / 3, Ic.BOTTOM_LEFT) : new Y(n.left + w / 3, n.top + n.height - C / 3), this.topLeftBorderDoubleInnerBox = i > 0 || a > 0 ? Lc(n.left + w * 2 / 3, n.top + x * 2 / 3, i - w * 2 / 3, a - x * 2 / 3, Ic.TOP_LEFT) : new Y(n.left + w * 2 / 3, n.top + x * 2 / 3), this.topRightBorderDoubleInnerBox = i > 0 || a > 0 ? Lc(n.left + _, n.top + x * 2 / 3, s - S * 2 / 3, c - x * 2 / 3, Ic.TOP_RIGHT) : new Y(n.left + n.width - S * 2 / 3, n.top + x * 2 / 3), this.bottomRightBorderDoubleInnerBox = u > 0 || d > 0 ? Lc(n.left + y, n.top + v, u - S * 2 / 3, d - C * 2 / 3, Ic.BOTTOM_RIGHT) : new Y(n.left + n.width - S * 2 / 3, n.top + n.height - C * 2 / 3), this.bottomLeftBorderDoubleInnerBox = p > 0 || m > 0 ? Lc(n.left + w * 2 / 3, n.top + b, p - w * 2 / 3, m - C * 2 / 3, Ic.BOTTOM_LEFT) : new Y(n.left + w * 2 / 3, n.top + n.height - C * 2 / 3), this.topLeftBorderStroke = i > 0 || a > 0 ? Lc(n.left + w / 2, n.top + x / 2, i - w / 2, a - x / 2, Ic.TOP_LEFT) : new Y(n.left + w / 2, n.top + x / 2), this.topRightBorderStroke = i > 0 || a > 0 ? Lc(n.left + _, n.top + x / 2, s - S / 2, c - x / 2, Ic.TOP_RIGHT) : new Y(n.left + n.width - S / 2, n.top + x / 2), this.bottomRightBorderStroke = u > 0 || d > 0 ? Lc(n.left + y, n.top + v, u - S / 2, d - C / 2, Ic.BOTTOM_RIGHT) : new Y(n.left + n.width - S / 2, n.top + n.height - C / 2), this.bottomLeftBorderStroke = p > 0 || m > 0 ? Lc(n.left + w / 2, n.top + b, p - w / 2, m - C / 2, Ic.BOTTOM_LEFT) : new Y(n.left + w / 2, n.top + n.height - C / 2), this.topLeftBorderBox = i > 0 || a > 0 ? Lc(n.left, n.top, i, a, Ic.TOP_LEFT) : new Y(n.left, n.top), this.topRightBorderBox = s > 0 || c > 0 ? Lc(n.left + _, n.top, s, c, Ic.TOP_RIGHT) : new Y(n.left + n.width, n.top), this.bottomRightBorderBox = u > 0 || d > 0 ? Lc(n.left + y, n.top + v, u, d, Ic.BOTTOM_RIGHT) : new Y(n.left + n.width, n.top + n.height), this.bottomLeftBorderBox = p > 0 || m > 0 ? Lc(n.left, n.top + b, p, m, Ic.BOTTOM_LEFT) : new Y(n.left, n.top + n.height), this.topLeftPaddingBox = i > 0 || a > 0 ? Lc(n.left + w, n.top + x, Math.max(0, i - w), Math.max(0, a - x), Ic.TOP_LEFT) : new Y(n.left + w, n.top + x), this.topRightPaddingBox = s > 0 || c > 0 ? Lc(n.left + Math.min(_, n.width - S), n.top + x, _ > n.width + S ? 0 : Math.max(0, s - S), Math.max(0, c - x), Ic.TOP_RIGHT) : new Y(n.left + n.width - S, n.top + x), this.bottomRightPaddingBox = u > 0 || d > 0 ? Lc(n.left + Math.min(y, n.width - w), n.top + Math.min(v, n.height - C), Math.max(0, u - S), Math.max(0, d - C), Ic.BOTTOM_RIGHT) : new Y(n.left + n.width - S, n.top + n.height - C), this.bottomLeftPaddingBox = p > 0 || m > 0 ? Lc(n.left + w, n.top + Math.min(b, n.height - C), Math.max(0, p - w), Math.max(0, m - C), Ic.BOTTOM_LEFT) : new Y(n.left + w, n.top + n.height - C), this.topLeftContentBox = i > 0 || a > 0 ? Lc(n.left + w + O, n.top + x + T, Math.max(0, i - (w + O)), Math.max(0, a - (x + T)), Ic.TOP_LEFT) : new Y(n.left + w + O, n.top + x + T), this.topRightContentBox = s > 0 || c > 0 ? Lc(n.left + Math.min(_, n.width + w + O), n.top + x + T, _ > n.width + w + O ? 0 : s - w + O, c - (x + T), Ic.TOP_RIGHT) : new Y(n.left + n.width - (S + E), n.top + x + T), this.bottomRightContentBox = u > 0 || d > 0 ? Lc(n.left + Math.min(y, n.width - (w + O)), n.top + Math.min(v, n.height + x + T), Math.max(0, u - (S + E)), d - (C + D), Ic.BOTTOM_RIGHT) : new Y(n.left + n.width - (S + E), n.top + n.height - (C + D)), this.bottomLeftContentBox = p > 0 || m > 0 ? Lc(n.left + w + O, n.top + b, Math.max(0, p - (w + O)), m - (C + D), Ic.BOTTOM_LEFT) : new Y(n.left + w + O, n.top + n.height - (C + D));
			}
			return e;
		}(), Ic;
		(function(e) {
			e[e.TOP_LEFT = 0] = "TOP_LEFT", e[e.TOP_RIGHT = 1] = "TOP_RIGHT", e[e.BOTTOM_RIGHT = 2] = "BOTTOM_RIGHT", e[e.BOTTOM_LEFT = 3] = "BOTTOM_LEFT";
		})(Ic ||= {});
		var Lc = function(e, t, n, r, i) {
			var a = 4 * ((Math.sqrt(2) - 1) / 3), o = n * a, s = r * a, c = e + n, l = t + r;
			switch (i) {
				case Ic.TOP_LEFT: return new Nc(new Y(e, l), new Y(e, l - s), new Y(c - o, t), new Y(c, t));
				case Ic.TOP_RIGHT: return new Nc(new Y(e, t), new Y(e + o, t), new Y(c, l - s), new Y(c, l));
				case Ic.BOTTOM_RIGHT: return new Nc(new Y(c, t), new Y(c, t + s), new Y(e + o, l), new Y(e, l));
				case Ic.BOTTOM_LEFT:
				default: return new Nc(new Y(c, l), new Y(c - o, l), new Y(e, t + s), new Y(e, t));
			}
		}, Rc = function(e) {
			return [
				e.topLeftBorderBox,
				e.topRightBorderBox,
				e.bottomRightBorderBox,
				e.bottomLeftBorderBox
			];
		}, zc = function(e) {
			return [
				e.topLeftContentBox,
				e.topRightContentBox,
				e.bottomRightContentBox,
				e.bottomLeftContentBox
			];
		}, Bc = function(e) {
			return [
				e.topLeftPaddingBox,
				e.topRightPaddingBox,
				e.bottomRightPaddingBox,
				e.bottomLeftPaddingBox
			];
		}, Vc = function() {
			function e(e, t, n) {
				this.offsetX = e, this.offsetY = t, this.matrix = n, this.type = 0, this.target = 6;
			}
			return e;
		}(), Hc = function() {
			function e(e, t) {
				this.path = e, this.target = t, this.type = 1;
			}
			return e;
		}(), Uc = function() {
			function e(e) {
				this.opacity = e, this.type = 2, this.target = 6;
			}
			return e;
		}(), Wc = function(e) {
			return e.type === 0;
		}, Gc = function(e) {
			return e.type === 1;
		}, Kc = function(e) {
			return e.type === 2;
		}, qc = function(e, t) {
			return e.length === t.length && e.some(function(e, n) {
				return e === t[n];
			});
		}, Jc = function(e, t, n, r, i) {
			return e.map(function(e, a) {
				switch (a) {
					case 0: return e.add(t, n);
					case 1: return e.add(t + r, n);
					case 2: return e.add(t + r, n + i);
					case 3: return e.add(t, n + i);
				}
				return e;
			});
		}, Yc = function() {
			function e(e) {
				this.element = e, this.inlineLevel = [], this.nonInlineLevel = [], this.negativeZIndex = [], this.zeroOrAutoZIndexOrTransformedOrOpacity = [], this.positiveZIndex = [], this.nonPositionedFloats = [], this.nonPositionedInlineLevel = [];
			}
			return e;
		}(), Xc = function() {
			function e(e, t) {
				if (this.container = e, this.parent = t, this.effects = [], this.curves = new Fc(this.container), this.container.styles.opacity < 1 && this.effects.push(new Uc(this.container.styles.opacity)), this.container.styles.transform !== null) {
					var n = this.container.bounds.left + this.container.styles.transformOrigin[0].number, r = this.container.bounds.top + this.container.styles.transformOrigin[1].number, i = this.container.styles.transform;
					this.effects.push(new Vc(n, r, i));
				}
				if (this.container.styles.overflowX !== 0) {
					var a = Rc(this.curves), o = Bc(this.curves);
					qc(a, o) ? this.effects.push(new Hc(a, 6)) : (this.effects.push(new Hc(a, 2)), this.effects.push(new Hc(o, 4)));
				}
			}
			return e.prototype.getEffects = function(e) {
				for (var t = [2, 3].indexOf(this.container.styles.position) === -1, n = this.parent, r = this.effects.slice(0); n;) {
					var i = n.effects.filter(function(e) {
						return !Gc(e);
					});
					if (t || n.container.styles.position !== 0 || !n.parent) {
						if (r.unshift.apply(r, i), t = [2, 3].indexOf(n.container.styles.position) === -1, n.container.styles.overflowX !== 0) {
							var a = Rc(n.curves), o = Bc(n.curves);
							qc(a, o) || r.unshift(new Hc(o, 6));
						}
					} else r.unshift.apply(r, i);
					n = n.parent;
				}
				return r.filter(function(t) {
					return ha(t.target, e);
				});
			}, e;
		}(), Zc = function(e, t, n, r) {
			e.container.elements.forEach(function(i) {
				var a = ha(i.flags, 4), o = ha(i.flags, 2), s = new Xc(i, e);
				ha(i.styles.display, 2048) && r.push(s);
				var c = ha(i.flags, 8) ? [] : r;
				if (a || o) {
					var l = a || i.styles.isPositioned() ? n : t, u = new Yc(s);
					if (i.styles.isPositioned() || i.styles.opacity < 1 || i.styles.isTransformed()) {
						var d = i.styles.zIndex.order;
						if (d < 0) {
							var f = 0;
							l.negativeZIndex.some(function(e, t) {
								return d > e.element.container.styles.zIndex.order ? (f = t, !1) : f > 0;
							}), l.negativeZIndex.splice(f, 0, u);
						} else if (d > 0) {
							var p = 0;
							l.positiveZIndex.some(function(e, t) {
								return d >= e.element.container.styles.zIndex.order ? (p = t + 1, !1) : p > 0;
							}), l.positiveZIndex.splice(p, 0, u);
						} else l.zeroOrAutoZIndexOrTransformedOrOpacity.push(u);
					} else i.styles.isFloating() ? l.nonPositionedFloats.push(u) : l.nonPositionedInlineLevel.push(u);
					Zc(s, u, a ? u : n, c);
				} else i.styles.isInlineLevel() ? t.inlineLevel.push(s) : t.nonInlineLevel.push(s), Zc(s, t, n, c);
				ha(i.flags, 8) && Qc(i, c);
			});
		}, Qc = function(e, t) {
			for (var n = e instanceof $o ? e.start : 1, r = e instanceof $o && e.reversed, i = 0; i < t.length; i++) {
				var a = t[i];
				a.container instanceof Qo && typeof a.container.value == "number" && a.container.value !== 0 && (n = a.container.value), a.listValue = nc(n, a.container.styles.listStyleType, !0), n += r ? -1 : 1;
			}
		}, $c = function(e) {
			var t = new Xc(e, null), n = new Yc(t), r = [];
			return Zc(t, n, n, r), Qc(t.container, r), n;
		}, el = function(e, t) {
			switch (t) {
				case 0: return al(e.topLeftBorderBox, e.topLeftPaddingBox, e.topRightBorderBox, e.topRightPaddingBox);
				case 1: return al(e.topRightBorderBox, e.topRightPaddingBox, e.bottomRightBorderBox, e.bottomRightPaddingBox);
				case 2: return al(e.bottomRightBorderBox, e.bottomRightPaddingBox, e.bottomLeftBorderBox, e.bottomLeftPaddingBox);
				default: return al(e.bottomLeftBorderBox, e.bottomLeftPaddingBox, e.topLeftBorderBox, e.topLeftPaddingBox);
			}
		}, tl = function(e, t) {
			switch (t) {
				case 0: return al(e.topLeftBorderBox, e.topLeftBorderDoubleOuterBox, e.topRightBorderBox, e.topRightBorderDoubleOuterBox);
				case 1: return al(e.topRightBorderBox, e.topRightBorderDoubleOuterBox, e.bottomRightBorderBox, e.bottomRightBorderDoubleOuterBox);
				case 2: return al(e.bottomRightBorderBox, e.bottomRightBorderDoubleOuterBox, e.bottomLeftBorderBox, e.bottomLeftBorderDoubleOuterBox);
				default: return al(e.bottomLeftBorderBox, e.bottomLeftBorderDoubleOuterBox, e.topLeftBorderBox, e.topLeftBorderDoubleOuterBox);
			}
		}, nl = function(e, t) {
			switch (t) {
				case 0: return al(e.topLeftBorderDoubleInnerBox, e.topLeftPaddingBox, e.topRightBorderDoubleInnerBox, e.topRightPaddingBox);
				case 1: return al(e.topRightBorderDoubleInnerBox, e.topRightPaddingBox, e.bottomRightBorderDoubleInnerBox, e.bottomRightPaddingBox);
				case 2: return al(e.bottomRightBorderDoubleInnerBox, e.bottomRightPaddingBox, e.bottomLeftBorderDoubleInnerBox, e.bottomLeftPaddingBox);
				default: return al(e.bottomLeftBorderDoubleInnerBox, e.bottomLeftPaddingBox, e.topLeftBorderDoubleInnerBox, e.topLeftPaddingBox);
			}
		}, rl = function(e, t) {
			switch (t) {
				case 0: return il(e.topLeftBorderStroke, e.topRightBorderStroke);
				case 1: return il(e.topRightBorderStroke, e.bottomRightBorderStroke);
				case 2: return il(e.bottomRightBorderStroke, e.bottomLeftBorderStroke);
				default: return il(e.bottomLeftBorderStroke, e.topLeftBorderStroke);
			}
		}, il = function(e, t) {
			var n = [];
			return Pc(e) ? n.push(e.subdivide(.5, !1)) : n.push(e), Pc(t) ? n.push(t.subdivide(.5, !0)) : n.push(t), n;
		}, al = function(e, t, n, r) {
			var i = [];
			return Pc(e) ? i.push(e.subdivide(.5, !1)) : i.push(e), Pc(n) ? i.push(n.subdivide(.5, !0)) : i.push(n), Pc(r) ? i.push(r.subdivide(.5, !0).reverse()) : i.push(r), Pc(t) ? i.push(t.subdivide(.5, !1).reverse()) : i.push(t), i;
		}, ol = function(e) {
			var t = e.bounds, n = e.styles;
			return t.add(n.borderLeftWidth, n.borderTopWidth, -(n.borderRightWidth + n.borderLeftWidth), -(n.borderTopWidth + n.borderBottomWidth));
		}, sl = function(e) {
			var t = e.styles, n = e.bounds, r = ir(t.paddingLeft, n.width), i = ir(t.paddingRight, n.width), a = ir(t.paddingTop, n.width), o = ir(t.paddingBottom, n.width);
			return n.add(r + t.borderLeftWidth, a + t.borderTopWidth, -(t.borderRightWidth + t.borderLeftWidth + r + i), -(t.borderTopWidth + t.borderBottomWidth + a + o));
		}, cl = function(e, t) {
			return e === 0 ? t.bounds : e === 2 ? sl(t) : ol(t);
		}, ll = function(e, t) {
			return e === 0 ? t.bounds : e === 2 ? sl(t) : ol(t);
		}, ul = function(e, t, n) {
			var r = cl(ml(e.styles.backgroundOrigin, t), e), i = ll(ml(e.styles.backgroundClip, t), e), a = pl(ml(e.styles.backgroundSize, t), n, r), o = a[0], s = a[1], c = rr(ml(e.styles.backgroundPosition, t), r.width - o, r.height - s);
			return [
				hl(ml(e.styles.backgroundRepeat, t), c, a, r, i),
				Math.round(r.left + c[0]),
				Math.round(r.top + c[1]),
				o,
				s
			];
		}, dl = function(e) {
			return Wn(e) && e.value === ei.AUTO;
		}, fl = function(e) {
			return typeof e == "number";
		}, pl = function(e, t, n) {
			var r = t[0], i = t[1], a = t[2], o = e[0], s = e[1];
			if (!o) return [0, 0];
			if (Qn(o) && s && Qn(s)) return [ir(o, n.width), ir(s, n.height)];
			var c = fl(a);
			if (Wn(o) && (o.value === ei.CONTAIN || o.value === ei.COVER)) return fl(a) ? n.width / n.height < a == (o.value === ei.COVER) ? [n.height * a, n.height] : [n.width, n.width / a] : [n.width, n.height];
			var l = fl(r), u = fl(i), d = l || u;
			if (dl(o) && (!s || dl(s))) return l && u ? [r, i] : !c && !d ? [n.width, n.height] : d && c ? [l ? r : i * a, u ? i : r / a] : [l ? r : n.width, u ? i : n.height];
			if (c) {
				var f = 0, p = 0;
				return Qn(o) ? f = ir(o, n.width) : Qn(s) && (p = ir(s, n.height)), dl(o) ? f = p * a : (!s || dl(s)) && (p = f / a), [f, p];
			}
			var m = null, h = null;
			if (Qn(o) ? m = ir(o, n.width) : s && Qn(s) && (h = ir(s, n.height)), m !== null && (!s || dl(s)) && (h = l && u ? m / r * i : n.height), h !== null && dl(o) && (m = l && u ? h / i * r : n.width), m !== null && h !== null) return [m, h];
			throw Error("Unable to calculate background-size for element");
		}, ml = function(e, t) {
			var n = e[t];
			return n === void 0 ? e[0] : n;
		}, hl = function(e, t, n, r, i) {
			var a = t[0], o = t[1], s = n[0], c = n[1];
			switch (e) {
				case 2: return [
					new Y(Math.round(r.left), Math.round(r.top + o)),
					new Y(Math.round(r.left + r.width), Math.round(r.top + o)),
					new Y(Math.round(r.left + r.width), Math.round(c + r.top + o)),
					new Y(Math.round(r.left), Math.round(c + r.top + o))
				];
				case 3: return [
					new Y(Math.round(r.left + a), Math.round(r.top)),
					new Y(Math.round(r.left + a + s), Math.round(r.top)),
					new Y(Math.round(r.left + a + s), Math.round(r.height + r.top)),
					new Y(Math.round(r.left + a), Math.round(r.height + r.top))
				];
				case 1: return [
					new Y(Math.round(r.left + a), Math.round(r.top + o)),
					new Y(Math.round(r.left + a + s), Math.round(r.top + o)),
					new Y(Math.round(r.left + a + s), Math.round(r.top + o + c)),
					new Y(Math.round(r.left + a), Math.round(r.top + o + c))
				];
				default: return [
					new Y(Math.round(i.left), Math.round(i.top)),
					new Y(Math.round(i.left + i.width), Math.round(i.top)),
					new Y(Math.round(i.left + i.width), Math.round(i.height + i.top)),
					new Y(Math.round(i.left), Math.round(i.height + i.top))
				];
			}
		}, gl = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", _l = "Hidden Text", vl = function() {
			function e(e) {
				this._data = {}, this._document = e;
			}
			return e.prototype.parseMetrics = function(e, t) {
				var n = this._document.createElement("div"), r = this._document.createElement("img"), i = this._document.createElement("span"), a = this._document.body;
				n.style.visibility = "hidden", n.style.fontFamily = e, n.style.fontSize = t, n.style.margin = "0", n.style.padding = "0", n.style.whiteSpace = "nowrap", a.appendChild(n), r.src = gl, r.width = 1, r.height = 1, r.style.margin = "0", r.style.padding = "0", r.style.verticalAlign = "baseline", i.style.fontFamily = e, i.style.fontSize = t, i.style.margin = "0", i.style.padding = "0", i.appendChild(this._document.createTextNode(_l)), n.appendChild(i), n.appendChild(r);
				var o = r.offsetTop - i.offsetTop + 2;
				n.removeChild(i), n.appendChild(this._document.createTextNode(_l)), n.style.lineHeight = "normal", r.style.verticalAlign = "super";
				var s = r.offsetTop - n.offsetTop + 2;
				return a.removeChild(n), {
					baseline: o,
					middle: s
				};
			}, e.prototype.getMetrics = function(e, t) {
				var n = e + " " + t;
				return this._data[n] === void 0 && (this._data[n] = this.parseMetrics(e, t)), this._data[n];
			}, e;
		}(), yl = function() {
			function e(e, t) {
				this.context = e, this.options = t;
			}
			return e;
		}(), bl = 1e4, xl = function(e) {
			t(n, e);
			function n(t, n) {
				var r = e.call(this, t, n) || this;
				return r._activeEffects = [], r.canvas = n.canvas ? n.canvas : document.createElement("canvas"), r.ctx = r.canvas.getContext("2d"), n.canvas || (r.canvas.width = Math.floor(n.width * n.scale), r.canvas.height = Math.floor(n.height * n.scale), r.canvas.style.width = n.width + "px", r.canvas.style.height = n.height + "px"), r.fontMetrics = new vl(document), r.ctx.scale(r.options.scale, r.options.scale), r.ctx.translate(-n.x, -n.y), r.ctx.textBaseline = "bottom", r._activeEffects = [], r.context.logger.debug("Canvas renderer initialized (" + n.width + "x" + n.height + ") with scale " + n.scale), r;
			}
			return n.prototype.applyEffects = function(e) {
				for (var t = this; this._activeEffects.length;) this.popEffect();
				e.forEach(function(e) {
					return t.applyEffect(e);
				});
			}, n.prototype.applyEffect = function(e) {
				this.ctx.save(), Kc(e) && (this.ctx.globalAlpha = e.opacity), Wc(e) && (this.ctx.translate(e.offsetX, e.offsetY), this.ctx.transform(e.matrix[0], e.matrix[1], e.matrix[2], e.matrix[3], e.matrix[4], e.matrix[5]), this.ctx.translate(-e.offsetX, -e.offsetY)), Gc(e) && (this.path(e.path), this.ctx.clip()), this._activeEffects.push(e);
			}, n.prototype.popEffect = function() {
				this._activeEffects.pop(), this.ctx.restore();
			}, n.prototype.renderStack = function(e) {
				return r(this, void 0, void 0, function() {
					var t;
					return i(this, function(n) {
						switch (n.label) {
							case 0: return t = e.element.container.styles, t.isVisible() ? [4, this.renderStackContent(e)] : [3, 2];
							case 1: n.sent(), n.label = 2;
							case 2: return [2];
						}
					});
				});
			}, n.prototype.renderNode = function(e) {
				return r(this, void 0, void 0, function() {
					return i(this, function(t) {
						switch (t.label) {
							case 0:
								if (ha(e.container.flags, 16)) debugger;
								return e.container.styles.isVisible() ? [4, this.renderNodeBackgroundAndBorders(e)] : [3, 3];
							case 1: return t.sent(), [4, this.renderNodeContent(e)];
							case 2: t.sent(), t.label = 3;
							case 3: return [2];
						}
					});
				});
			}, n.prototype.renderTextWithLetterSpacing = function(e, t, n) {
				var r = this;
				t === 0 ? this.ctx.fillText(e.text, e.bounds.left, e.bounds.top + n) : Bo(e.text).reduce(function(t, i) {
					return r.ctx.fillText(i, t, e.bounds.top + n), t + r.ctx.measureText(i).width;
				}, e.bounds.left);
			}, n.prototype.createFontStyle = function(e) {
				var t = e.fontVariant.filter(function(e) {
					return e === "normal" || e === "small-caps";
				}).join(""), n = El(e.fontFamily).join(", "), r = Hn(e.fontSize) ? "" + e.fontSize.number + e.fontSize.unit : e.fontSize.number + "px";
				return [
					[
						e.fontStyle,
						t,
						e.fontWeight,
						r,
						n
					].join(" "),
					n,
					r
				];
			}, n.prototype.renderTextNode = function(e, t) {
				return r(this, void 0, void 0, function() {
					var n, r, a, o, s, c, l, u, d = this;
					return i(this, function(i) {
						return n = this.createFontStyle(t), r = n[0], a = n[1], o = n[2], this.ctx.font = r, this.ctx.direction = t.direction === 1 ? "rtl" : "ltr", this.ctx.textAlign = "left", this.ctx.textBaseline = "alphabetic", s = this.fontMetrics.getMetrics(a, o), c = s.baseline, l = s.middle, u = t.paintOrder, e.textBounds.forEach(function(e) {
							u.forEach(function(n) {
								switch (n) {
									case 0:
										d.ctx.fillStyle = hr(t.color), d.renderTextWithLetterSpacing(e, t.letterSpacing, c);
										var r = t.textShadow;
										r.length && e.text.trim().length && (r.slice(0).reverse().forEach(function(n) {
											d.ctx.shadowColor = hr(n.color), d.ctx.shadowOffsetX = n.offsetX.number * d.options.scale, d.ctx.shadowOffsetY = n.offsetY.number * d.options.scale, d.ctx.shadowBlur = n.blur.number, d.renderTextWithLetterSpacing(e, t.letterSpacing, c);
										}), d.ctx.shadowColor = "", d.ctx.shadowOffsetX = 0, d.ctx.shadowOffsetY = 0, d.ctx.shadowBlur = 0), t.textDecorationLine.length && (d.ctx.fillStyle = hr(t.textDecorationColor || t.color), t.textDecorationLine.forEach(function(t) {
											switch (t) {
												case 1:
													d.ctx.fillRect(e.bounds.left, Math.round(e.bounds.top + c), e.bounds.width, 1);
													break;
												case 2:
													d.ctx.fillRect(e.bounds.left, Math.round(e.bounds.top), e.bounds.width, 1);
													break;
												case 3:
													d.ctx.fillRect(e.bounds.left, Math.ceil(e.bounds.top + l), e.bounds.width, 1);
													break;
											}
										}));
										break;
									case 1:
										t.webkitTextStrokeWidth && e.text.trim().length && (d.ctx.strokeStyle = hr(t.webkitTextStrokeColor), d.ctx.lineWidth = t.webkitTextStrokeWidth, d.ctx.lineJoin = window.chrome ? "miter" : "round", d.ctx.strokeText(e.text, e.bounds.left, e.bounds.top + c)), d.ctx.strokeStyle = "", d.ctx.lineWidth = 0, d.ctx.lineJoin = "miter";
										break;
								}
							});
						}), [2];
					});
				});
			}, n.prototype.renderReplacedElement = function(e, t, n) {
				if (n && e.intrinsicWidth > 0 && e.intrinsicHeight > 0) {
					var r = sl(e), i = Bc(t);
					this.path(i), this.ctx.save(), this.ctx.clip(), this.ctx.drawImage(n, 0, 0, e.intrinsicWidth, e.intrinsicHeight, r.left, r.top, r.width, r.height), this.ctx.restore();
				}
			}, n.prototype.renderNodeContent = function(e) {
				return r(this, void 0, void 0, function() {
					var t, r, a, s, c, l, u, u, d, f, p, m, h, g, _, v, y, b, x, u, S, h, v;
					return i(this, function(i) {
						switch (i.label) {
							case 0: this.applyEffects(e.getEffects(4)), t = e.container, r = e.curves, a = t.styles, s = 0, c = t.textNodes, i.label = 1;
							case 1: return s < c.length ? (l = c[s], [4, this.renderTextNode(l, a)]) : [3, 4];
							case 2: i.sent(), i.label = 3;
							case 3: return s++, [3, 1];
							case 4:
								if (!(t instanceof Yo)) return [3, 8];
								i.label = 5;
							case 5: return i.trys.push([
								5,
								7,
								,
								8
							]), [4, this.context.cache.match(t.src)];
							case 6: return u = i.sent(), this.renderReplacedElement(t, r, u), [3, 8];
							case 7: return i.sent(), this.context.logger.error("Error loading image " + t.src), [3, 8];
							case 8:
								if (t instanceof Xo && this.renderReplacedElement(t, r, t.canvas), !(t instanceof Zo)) return [3, 12];
								i.label = 9;
							case 9: return i.trys.push([
								9,
								11,
								,
								12
							]), [4, this.context.cache.match(t.svg)];
							case 10: return u = i.sent(), this.renderReplacedElement(t, r, u), [3, 12];
							case 11: return i.sent(), this.context.logger.error("Error loading svg " + t.svg.substring(0, 255)), [3, 12];
							case 12: return t instanceof ds && t.tree ? (d = new n(this.context, {
								scale: this.options.scale,
								backgroundColor: t.backgroundColor,
								x: 0,
								y: 0,
								width: t.width,
								height: t.height
							}), [4, d.render(t.tree)]) : [3, 14];
							case 13: f = i.sent(), t.width && t.height && this.ctx.drawImage(f, 0, 0, t.width, t.height, t.bounds.left, t.bounds.top, t.bounds.width, t.bounds.height), i.label = 14;
							case 14:
								if (t instanceof cs && (p = Math.min(t.bounds.width, t.bounds.height), t.type === is ? t.checked && (this.ctx.save(), this.path([
									new Y(t.bounds.left + p * .39363, t.bounds.top + p * .79),
									new Y(t.bounds.left + p * .16, t.bounds.top + p * .5549),
									new Y(t.bounds.left + p * .27347, t.bounds.top + p * .44071),
									new Y(t.bounds.left + p * .39694, t.bounds.top + p * .5649),
									new Y(t.bounds.left + p * .72983, t.bounds.top + p * .23),
									new Y(t.bounds.left + p * .84, t.bounds.top + p * .34085),
									new Y(t.bounds.left + p * .39363, t.bounds.top + p * .79)
								]), this.ctx.fillStyle = hr(ss), this.ctx.fill(), this.ctx.restore()) : t.type === as && t.checked && (this.ctx.save(), this.ctx.beginPath(), this.ctx.arc(t.bounds.left + p / 2, t.bounds.top + p / 2, p / 4, 0, Math.PI * 2, !0), this.ctx.fillStyle = hr(ss), this.ctx.fill(), this.ctx.restore())), Sl(t) && t.value.length) {
									switch (m = this.createFontStyle(a), h = m[0], g = m[1], _ = this.fontMetrics.getMetrics(h, g).baseline, this.ctx.font = h, this.ctx.fillStyle = hr(a.color), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = wl(t.styles.textAlign), v = sl(t), y = 0, t.styles.textAlign) {
										case 1:
											y += v.width / 2;
											break;
										case 2:
											y += v.width;
											break;
									}
									b = v.add(y, 0, 0, -v.height / 2 + 1), this.ctx.save(), this.path([
										new Y(v.left, v.top),
										new Y(v.left + v.width, v.top),
										new Y(v.left + v.width, v.top + v.height),
										new Y(v.left, v.top + v.height)
									]), this.ctx.clip(), this.renderTextWithLetterSpacing(new Io(t.value, b), a.letterSpacing, _), this.ctx.restore(), this.ctx.textBaseline = "alphabetic", this.ctx.textAlign = "left";
								}
								if (!ha(t.styles.display, 2048)) return [3, 20];
								if (t.styles.listStyleImage === null) return [3, 19];
								if (x = t.styles.listStyleImage, x.type !== 0) return [3, 18];
								u = void 0, S = x.url, i.label = 15;
							case 15: return i.trys.push([
								15,
								17,
								,
								18
							]), [4, this.context.cache.match(S)];
							case 16: return u = i.sent(), this.ctx.drawImage(u, t.bounds.left - (u.width + 10), t.bounds.top), [3, 18];
							case 17: return i.sent(), this.context.logger.error("Error loading list-style-image " + S), [3, 18];
							case 18: return [3, 20];
							case 19: e.listValue && t.styles.listStyleType !== -1 && (h = this.createFontStyle(a)[0], this.ctx.font = h, this.ctx.fillStyle = hr(a.color), this.ctx.textBaseline = "middle", this.ctx.textAlign = "right", v = new o(t.bounds.left, t.bounds.top + ir(t.styles.paddingTop, t.bounds.width), t.bounds.width, Mi(a.lineHeight, a.fontSize.number) / 2 + 1), this.renderTextWithLetterSpacing(new Io(e.listValue, v), a.letterSpacing, Mi(a.lineHeight, a.fontSize.number) / 2 + 2), this.ctx.textBaseline = "bottom", this.ctx.textAlign = "left"), i.label = 20;
							case 20: return [2];
						}
					});
				});
			}, n.prototype.renderStackContent = function(e) {
				return r(this, void 0, void 0, function() {
					var t, n, r, a, o, r, s, c, r, l, u, r, d, f, r, p, m, r, h, g, r;
					return i(this, function(i) {
						switch (i.label) {
							case 0:
								if (ha(e.element.container.flags, 16)) debugger;
								return [4, this.renderNodeBackgroundAndBorders(e.element)];
							case 1: i.sent(), t = 0, n = e.negativeZIndex, i.label = 2;
							case 2: return t < n.length ? (r = n[t], [4, this.renderStack(r)]) : [3, 5];
							case 3: i.sent(), i.label = 4;
							case 4: return t++, [3, 2];
							case 5: return [4, this.renderNodeContent(e.element)];
							case 6: i.sent(), a = 0, o = e.nonInlineLevel, i.label = 7;
							case 7: return a < o.length ? (r = o[a], [4, this.renderNode(r)]) : [3, 10];
							case 8: i.sent(), i.label = 9;
							case 9: return a++, [3, 7];
							case 10: s = 0, c = e.nonPositionedFloats, i.label = 11;
							case 11: return s < c.length ? (r = c[s], [4, this.renderStack(r)]) : [3, 14];
							case 12: i.sent(), i.label = 13;
							case 13: return s++, [3, 11];
							case 14: l = 0, u = e.nonPositionedInlineLevel, i.label = 15;
							case 15: return l < u.length ? (r = u[l], [4, this.renderStack(r)]) : [3, 18];
							case 16: i.sent(), i.label = 17;
							case 17: return l++, [3, 15];
							case 18: d = 0, f = e.inlineLevel, i.label = 19;
							case 19: return d < f.length ? (r = f[d], [4, this.renderNode(r)]) : [3, 22];
							case 20: i.sent(), i.label = 21;
							case 21: return d++, [3, 19];
							case 22: p = 0, m = e.zeroOrAutoZIndexOrTransformedOrOpacity, i.label = 23;
							case 23: return p < m.length ? (r = m[p], [4, this.renderStack(r)]) : [3, 26];
							case 24: i.sent(), i.label = 25;
							case 25: return p++, [3, 23];
							case 26: h = 0, g = e.positiveZIndex, i.label = 27;
							case 27: return h < g.length ? (r = g[h], [4, this.renderStack(r)]) : [3, 30];
							case 28: i.sent(), i.label = 29;
							case 29: return h++, [3, 27];
							case 30: return [2];
						}
					});
				});
			}, n.prototype.mask = function(e) {
				this.ctx.beginPath(), this.ctx.moveTo(0, 0), this.ctx.lineTo(this.canvas.width, 0), this.ctx.lineTo(this.canvas.width, this.canvas.height), this.ctx.lineTo(0, this.canvas.height), this.ctx.lineTo(0, 0), this.formatPath(e.slice(0).reverse()), this.ctx.closePath();
			}, n.prototype.path = function(e) {
				this.ctx.beginPath(), this.formatPath(e), this.ctx.closePath();
			}, n.prototype.formatPath = function(e) {
				var t = this;
				e.forEach(function(e, n) {
					var r = Pc(e) ? e.start : e;
					n === 0 ? t.ctx.moveTo(r.x, r.y) : t.ctx.lineTo(r.x, r.y), Pc(e) && t.ctx.bezierCurveTo(e.startControl.x, e.startControl.y, e.endControl.x, e.endControl.y, e.end.x, e.end.y);
				});
			}, n.prototype.renderRepeat = function(e, t, n, r) {
				this.path(e), this.ctx.fillStyle = t, this.ctx.translate(n, r), this.ctx.fill(), this.ctx.translate(-n, -r);
			}, n.prototype.resizeImage = function(e, t, n) {
				if (e.width === t && e.height === n) return e;
				var r = (this.canvas.ownerDocument ?? document).createElement("canvas");
				return r.width = Math.max(1, t), r.height = Math.max(1, n), r.getContext("2d").drawImage(e, 0, 0, e.width, e.height, 0, 0, t, n), r;
			}, n.prototype.renderBackgroundImage = function(e) {
				return r(this, void 0, void 0, function() {
					var t, n, r, a, o, s;
					return i(this, function(c) {
						switch (c.label) {
							case 0: t = e.styles.backgroundImage.length - 1, n = function(n) {
								var a, o, s, c, l, u, d, f, p, m, c, l, u, d, f, h, g, _, v, y, b, x, S, C, p, w, c, T, E, d, f, D, l, u, O, k, A, j, M, N, P, F;
								return i(this, function(i) {
									switch (i.label) {
										case 0:
											if (n.type !== 0) return [3, 5];
											a = void 0, o = n.url, i.label = 1;
										case 1: return i.trys.push([
											1,
											3,
											,
											4
										]), [4, r.context.cache.match(o)];
										case 2: return a = i.sent(), [3, 4];
										case 3: return i.sent(), r.context.logger.error("Error loading background-image " + o), [3, 4];
										case 4: return a && (s = ul(e, t, [
											a.width,
											a.height,
											a.width / a.height
										]), c = s[0], l = s[1], u = s[2], d = s[3], f = s[4], p = r.ctx.createPattern(r.resizeImage(a, d, f), "repeat"), r.renderRepeat(c, p, l, u)), [3, 6];
										case 5: Gr(n) ? (m = ul(e, t, [
											null,
											null,
											null
										]), c = m[0], l = m[1], u = m[2], d = m[3], f = m[4], h = kr(n.angle, d, f), g = h[0], _ = h[1], v = h[2], y = h[3], b = h[4], x = document.createElement("canvas"), x.width = d, x.height = f, S = x.getContext("2d"), C = S.createLinearGradient(_, y, v, b), Dr(n.stops, g).forEach(function(e) {
											return C.addColorStop(e.stop, hr(e.color));
										}), S.fillStyle = C, S.fillRect(0, 0, d, f), d > 0 && f > 0 && (p = r.ctx.createPattern(x, "repeat"), r.renderRepeat(c, p, l, u))) : Kr(n) && (w = ul(e, t, [
											null,
											null,
											null
										]), c = w[0], T = w[1], E = w[2], d = w[3], f = w[4], D = n.position.length === 0 ? [tr] : n.position, l = ir(D[0], d), u = ir(D[D.length - 1], f), O = Mr(n, l, u, d, f), k = O[0], A = O[1], k > 0 && A > 0 && (j = r.ctx.createRadialGradient(T + l, E + u, 0, T + l, E + u, k), Dr(n.stops, k * 2).forEach(function(e) {
											return j.addColorStop(e.stop, hr(e.color));
										}), r.path(c), r.ctx.fillStyle = j, k === A ? r.ctx.fill() : (M = e.bounds.left + .5 * e.bounds.width, N = e.bounds.top + .5 * e.bounds.height, P = A / k, F = 1 / P, r.ctx.save(), r.ctx.translate(M, N), r.ctx.transform(1, 0, 0, P, 0, 0), r.ctx.translate(-M, -N), r.ctx.fillRect(T, F * (E - N) + N, d, f * F), r.ctx.restore()))), i.label = 6;
										case 6: return t--, [2];
									}
								});
							}, r = this, a = 0, o = e.styles.backgroundImage.slice(0).reverse(), c.label = 1;
							case 1: return a < o.length ? (s = o[a], [5, n(s)]) : [3, 4];
							case 2: c.sent(), c.label = 3;
							case 3: return a++, [3, 1];
							case 4: return [2];
						}
					});
				});
			}, n.prototype.renderSolidBorder = function(e, t, n) {
				return r(this, void 0, void 0, function() {
					return i(this, function(r) {
						return this.path(el(n, t)), this.ctx.fillStyle = hr(e), this.ctx.fill(), [2];
					});
				});
			}, n.prototype.renderDoubleBorder = function(e, t, n, a) {
				return r(this, void 0, void 0, function() {
					var r, o;
					return i(this, function(i) {
						switch (i.label) {
							case 0: return t < 3 ? [4, this.renderSolidBorder(e, n, a)] : [3, 2];
							case 1: return i.sent(), [2];
							case 2: return r = tl(a, n), this.path(r), this.ctx.fillStyle = hr(e), this.ctx.fill(), o = nl(a, n), this.path(o), this.ctx.fill(), [2];
						}
					});
				});
			}, n.prototype.renderNodeBackgroundAndBorders = function(e) {
				return r(this, void 0, void 0, function() {
					var t, n, r, a, o, s, c, l, u = this;
					return i(this, function(i) {
						switch (i.label) {
							case 0: return this.applyEffects(e.getEffects(2)), t = e.container.styles, n = !mr(t.backgroundColor) || t.backgroundImage.length, r = [
								{
									style: t.borderTopStyle,
									color: t.borderTopColor,
									width: t.borderTopWidth
								},
								{
									style: t.borderRightStyle,
									color: t.borderRightColor,
									width: t.borderRightWidth
								},
								{
									style: t.borderBottomStyle,
									color: t.borderBottomColor,
									width: t.borderBottomWidth
								},
								{
									style: t.borderLeftStyle,
									color: t.borderLeftColor,
									width: t.borderLeftWidth
								}
							], a = Cl(ml(t.backgroundClip, 0), e.curves), n || t.boxShadow.length ? (this.ctx.save(), this.path(a), this.ctx.clip(), mr(t.backgroundColor) || (this.ctx.fillStyle = hr(t.backgroundColor), this.ctx.fill()), [4, this.renderBackgroundImage(e.container)]) : [3, 2];
							case 1: i.sent(), this.ctx.restore(), t.boxShadow.slice(0).reverse().forEach(function(t) {
								u.ctx.save();
								var n = Rc(e.curves), r = t.inset ? 0 : bl, i = Jc(n, -r + (t.inset ? 1 : -1) * t.spread.number, (t.inset ? 1 : -1) * t.spread.number, t.spread.number * (t.inset ? -2 : 2), t.spread.number * (t.inset ? -2 : 2));
								t.inset ? (u.path(n), u.ctx.clip(), u.mask(i)) : (u.mask(n), u.ctx.clip(), u.path(i)), u.ctx.shadowOffsetX = t.offsetX.number + r, u.ctx.shadowOffsetY = t.offsetY.number, u.ctx.shadowColor = hr(t.color), u.ctx.shadowBlur = t.blur.number, u.ctx.fillStyle = t.inset ? hr(t.color) : "rgba(0,0,0,1)", u.ctx.fill(), u.ctx.restore();
							}), i.label = 2;
							case 2: o = 0, s = 0, c = r, i.label = 3;
							case 3: return s < c.length ? (l = c[s], l.style !== 0 && !mr(l.color) && l.width > 0 ? l.style === 2 ? [4, this.renderDashedDottedBorder(l.color, l.width, o, e.curves, 2)] : [3, 5] : [3, 11]) : [3, 13];
							case 4: return i.sent(), [3, 11];
							case 5: return l.style === 3 ? [4, this.renderDashedDottedBorder(l.color, l.width, o, e.curves, 3)] : [3, 7];
							case 6: return i.sent(), [3, 11];
							case 7: return l.style === 4 ? [4, this.renderDoubleBorder(l.color, l.width, o, e.curves)] : [3, 9];
							case 8: return i.sent(), [3, 11];
							case 9: return [4, this.renderSolidBorder(l.color, o, e.curves)];
							case 10: i.sent(), i.label = 11;
							case 11: o++, i.label = 12;
							case 12: return s++, [3, 3];
							case 13: return [2];
						}
					});
				});
			}, n.prototype.renderDashedDottedBorder = function(e, t, n, a, o) {
				return r(this, void 0, void 0, function() {
					var r, s, c, l, u, d, f, p, m, h, g, _, v, y, b, x, b, x;
					return i(this, function(i) {
						return this.ctx.save(), r = rl(a, n), s = el(a, n), o === 2 && (this.path(s), this.ctx.clip()), Pc(s[0]) ? (c = s[0].start.x, l = s[0].start.y) : (c = s[0].x, l = s[0].y), Pc(s[1]) ? (u = s[1].end.x, d = s[1].end.y) : (u = s[1].x, d = s[1].y), f = Math.abs(n === 0 || n === 2 ? c - u : l - d), this.ctx.beginPath(), o === 3 ? this.formatPath(r) : this.formatPath(s.slice(0, 2)), p = t < 3 ? t * 3 : t * 2, m = t < 3 ? t * 2 : t, o === 3 && (p = t, m = t), h = !0, f <= p * 2 ? h = !1 : f <= p * 2 + m ? (g = f / (2 * p + m), p *= g, m *= g) : (_ = Math.floor((f + m) / (p + m)), v = (f - _ * p) / (_ - 1), y = (f - (_ + 1) * p) / _, m = y <= 0 || Math.abs(m - v) < Math.abs(m - y) ? v : y), h && (o === 3 ? this.ctx.setLineDash([0, p + m]) : this.ctx.setLineDash([p, m])), o === 3 ? (this.ctx.lineCap = "round", this.ctx.lineWidth = t) : this.ctx.lineWidth = t * 2 + 1.1, this.ctx.strokeStyle = hr(e), this.ctx.stroke(), this.ctx.setLineDash([]), o === 2 && (Pc(s[0]) && (b = s[3], x = s[0], this.ctx.beginPath(), this.formatPath([new Y(b.end.x, b.end.y), new Y(x.start.x, x.start.y)]), this.ctx.stroke()), Pc(s[1]) && (b = s[1], x = s[2], this.ctx.beginPath(), this.formatPath([new Y(b.end.x, b.end.y), new Y(x.start.x, x.start.y)]), this.ctx.stroke())), this.ctx.restore(), [2];
					});
				});
			}, n.prototype.render = function(e) {
				return r(this, void 0, void 0, function() {
					var t;
					return i(this, function(n) {
						switch (n.label) {
							case 0: return this.options.backgroundColor && (this.ctx.fillStyle = hr(this.options.backgroundColor), this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height)), t = $c(e), [4, this.renderStack(t)];
							case 1: return n.sent(), this.applyEffects([]), [2, this.canvas];
						}
					});
				});
			}, n;
		}(yl), Sl = function(e) {
			return e instanceof us || e instanceof ls || e instanceof cs && e.type !== as && e.type !== is;
		}, Cl = function(e, t) {
			switch (e) {
				case 0: return Rc(t);
				case 2: return zc(t);
				default: return Bc(t);
			}
		}, wl = function(e) {
			switch (e) {
				case 1: return "center";
				case 2: return "right";
				default: return "left";
			}
		}, Tl = ["-apple-system", "system-ui"], El = function(e) {
			return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? e.filter(function(e) {
				return Tl.indexOf(e) === -1;
			}) : e;
		}, Dl = function(e) {
			t(n, e);
			function n(t, n) {
				var r = e.call(this, t, n) || this;
				return r.canvas = n.canvas ? n.canvas : document.createElement("canvas"), r.ctx = r.canvas.getContext("2d"), r.options = n, r.canvas.width = Math.floor(n.width * n.scale), r.canvas.height = Math.floor(n.height * n.scale), r.canvas.style.width = n.width + "px", r.canvas.style.height = n.height + "px", r.ctx.scale(r.options.scale, r.options.scale), r.ctx.translate(-n.x, -n.y), r.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + n.width + "x" + n.height + " at " + n.x + "," + n.y + ") with scale " + n.scale), r;
			}
			return n.prototype.render = function(e) {
				return r(this, void 0, void 0, function() {
					var t, n;
					return i(this, function(r) {
						switch (r.label) {
							case 0: return t = No(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, e), [4, Ol(t)];
							case 1: return n = r.sent(), this.options.backgroundColor && (this.ctx.fillStyle = hr(this.options.backgroundColor), this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale)), this.ctx.drawImage(n, -this.options.x * this.options.scale, -this.options.y * this.options.scale), [2, this.canvas];
						}
					});
				});
			}, n;
		}(yl), Ol = function(e) {
			return new Promise(function(t, n) {
				var r = new Image();
				r.onload = function() {
					t(r);
				}, r.onerror = n, r.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(e));
			});
		}, kl = function() {
			function e(e) {
				var t = e.id, n = e.enabled;
				this.id = t, this.enabled = n, this.start = Date.now();
			}
			return e.prototype.debug = function() {
				var e = [...arguments];
				this.enabled && (typeof window < "u" && window.console && typeof console.debug == "function" ? console.debug.apply(console, a([this.id, this.getTime() + "ms"], e)) : this.info.apply(this, e));
			}, e.prototype.getTime = function() {
				return Date.now() - this.start;
			}, e.prototype.info = function() {
				var e = [...arguments];
				this.enabled && typeof window < "u" && window.console && typeof console.info == "function" && console.info.apply(console, a([this.id, this.getTime() + "ms"], e));
			}, e.prototype.warn = function() {
				var e = [...arguments];
				this.enabled && (typeof window < "u" && window.console && typeof console.warn == "function" ? console.warn.apply(console, a([this.id, this.getTime() + "ms"], e)) : this.info.apply(this, e));
			}, e.prototype.error = function() {
				var e = [...arguments];
				this.enabled && (typeof window < "u" && window.console && typeof console.error == "function" ? console.error.apply(console, a([this.id, this.getTime() + "ms"], e)) : this.info.apply(this, e));
			}, e.instances = {}, e;
		}(), Al = function() {
			function e(t, n) {
				this.windowBounds = n, this.instanceName = "#" + e.instanceCount++, this.logger = new kl({
					id: this.instanceName,
					enabled: t.logging
				}), this.cache = t.cache ?? new Cc(this, t);
			}
			return e.instanceCount = 1, e;
		}(), jl = function(e, t) {
			return t === void 0 && (t = {}), Ml(e, t);
		};
		typeof window < "u" && Sc.setContext(window);
		var Ml = function(e, t) {
			return r(void 0, void 0, void 0, function() {
				var r, a, l, u, d, f, p, m, h, g, _, v, y, b, x, S, C, w, T, E, D, O, D;
				return i(this, function(i) {
					switch (i.label) {
						case 0:
							if (!e || typeof e != "object") return [2, Promise.reject("Invalid element provided as first argument")];
							if (r = e.ownerDocument, !r) throw Error("Element is not attached to a Document");
							if (a = r.defaultView, !a) throw Error("Document is not attached to a Window");
							return l = {
								allowTaint: t.allowTaint ?? !1,
								imageTimeout: t.imageTimeout ?? 15e3,
								proxy: t.proxy,
								useCORS: t.useCORS ?? !1
							}, u = n({
								logging: t.logging ?? !0,
								cache: t.cache
							}, l), d = {
								windowWidth: t.windowWidth ?? a.innerWidth,
								windowHeight: t.windowHeight ?? a.innerHeight,
								scrollX: t.scrollX ?? a.pageXOffset,
								scrollY: t.scrollY ?? a.pageYOffset
							}, f = new o(d.scrollX, d.scrollY, d.windowWidth, d.windowHeight), p = new Al(u, f), m = t.foreignObjectRendering ?? !1, h = {
								allowTaint: t.allowTaint ?? !1,
								onclone: t.onclone,
								ignoreElements: t.ignoreElements,
								inlineImages: m,
								copyStyles: m
							}, p.logger.debug("Starting document clone with size " + f.width + "x" + f.height + " scrolled to " + -f.left + "," + -f.top), g = new ic(p, e, h), _ = g.clonedReferenceElement, _ ? [4, g.toIFrame(r, f)] : [2, Promise.reject("Unable to find element in cloned iframe")];
						case 1: return v = i.sent(), y = Ds(_) || Ts(_) ? c(_.ownerDocument) : s(p, _), b = y.width, x = y.height, S = y.left, C = y.top, w = Nl(p, _, t.backgroundColor), T = {
							canvas: t.canvas,
							backgroundColor: w,
							scale: t.scale ?? a.devicePixelRatio ?? 1,
							x: (t.x ?? 0) + S,
							y: (t.y ?? 0) + C,
							width: t.width ?? Math.ceil(b),
							height: t.height ?? Math.ceil(x)
						}, m ? (p.logger.debug("Document cloned, using foreign object rendering"), D = new Dl(p, T), [4, D.render(_)]) : [3, 3];
						case 2: return E = i.sent(), [3, 5];
						case 3: return p.logger.debug("Document cloned, element located at " + S + "," + C + " with size " + b + "x" + x + " using computed rendering"), p.logger.debug("Starting DOM parsing"), O = hs(p, _), w === O.styles.backgroundColor && (O.styles.backgroundColor = Cr.TRANSPARENT), p.logger.debug("Starting renderer for element at " + T.x + "," + T.y + " with size " + T.width + "x" + T.height), D = new xl(p, T), [4, D.render(O)];
						case 4: E = i.sent(), i.label = 5;
						case 5: return (t.removeContainer ?? !0) && (ic.destroy(v) || p.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore")), p.logger.debug("Finished rendering"), [2, E];
					}
				});
			});
		}, Nl = function(e, t, n) {
			var r = t.ownerDocument, i = r.documentElement ? Sr(e, getComputedStyle(r.documentElement).backgroundColor) : Cr.TRANSPARENT, a = r.body ? Sr(e, getComputedStyle(r.body).backgroundColor) : Cr.TRANSPARENT, o = typeof n == "string" ? Sr(e, n) : n === null ? Cr.TRANSPARENT : 4294967295;
			return t === r.documentElement ? mr(i) ? mr(a) ? o : a : i : o;
		};
		return jl;
	}));
})), yf = /* @__PURE__ */ c({ default: () => Hp });
function bf(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function xf(e) {
	if (Array.isArray(e)) return e;
}
function Sf(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r, i, a, o, s = [], c = !0, l = !1;
		try {
			if (a = (n = n.call(e)).next, t !== 0) for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
		} catch (e) {
			l = !0, i = e;
		} finally {
			try {
				if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
			} finally {
				if (l) throw i;
			}
		}
		return s;
	}
}
function Cf() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function wf(e, t) {
	return xf(e) || Sf(e, t) || Tf(e, t) || Cf();
}
function Tf(e, t) {
	if (e) {
		if (typeof e == "string") return bf(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? bf(e, t) : void 0;
	}
}
function Ef(e) {
	return function(t) {
		t instanceof RegExp && (t.lastIndex = 0);
		var n = [...arguments].slice(1);
		return Wf(e, t, n);
	};
}
function Df(e) {
	return function() {
		return Gf(e, [...arguments]);
	};
}
function Of(e, t) {
	let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Qf;
	if (If && If(e, null), !Zf(t)) return e;
	let r = t.length;
	for (; r--;) {
		let i = t[r];
		if (typeof i == "string") {
			let e = n(i);
			e !== i && (Lf(t) || (t[r] = e), i = e);
		}
		e[i] = !0;
	}
	return e;
}
function kf(e) {
	for (let t = 0; t < e.length; t++) cp(e, t) || (e[t] = null);
	return e;
}
function Af(e) {
	let t = Hf(null);
	for (let r of Ff(e)) {
		var n = wf(r, 2);
		let i = n[0], a = n[1];
		cp(e, i) && (Zf(a) ? t[i] = kf(a) : a && typeof a == "object" && a.constructor === Object ? t[i] = Af(a) : t[i] = a);
	}
	return t;
}
function jf(e) {
	switch (typeof e) {
		case "string": return e;
		case "number": return ip(e);
		case "boolean": return ap(e);
		case "bigint": return op ? op(e) : "0";
		case "symbol": return sp ? sp(e) : "Symbol()";
		case "undefined": return lp(e);
		case "function":
		case "object": {
			if (e === null) return lp(e);
			let t = e, n = Mf(t, "toString");
			if (typeof n == "function") {
				let e = n(t);
				return typeof e == "string" ? e : lp(e);
			}
			return lp(e);
		}
		default: return lp(e);
	}
}
function Mf(e, t) {
	for (; e !== null;) {
		let n = zf(e, t);
		if (n) {
			if (n.get) return Ef(n.get);
			if (typeof n.value == "function") return Ef(n.value);
		}
		e = Rf(e);
	}
	function n() {
		return null;
	}
	return n;
}
function Nf(e) {
	try {
		return up(e, ""), !0;
	} catch {
		return !1;
	}
}
function Pf() {
	let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Rp(), t = (e) => Pf(e);
	if (t.version = "3.4.11", t.removed = [], !e || !e.document || e.document.nodeType !== Lp.document || !e.Element) return t.isSupported = !1, t;
	let n = e.document, r = n, i = r.currentScript;
	e.DocumentFragment;
	let a = e.HTMLTemplateElement, o = e.Node, s = e.Element, c = e.NodeFilter;
	e.NamedNodeMap === void 0 && (e.NamedNodeMap || e.MozNamedAttrMap), e.HTMLFormElement;
	let l = e.DOMParser, u = e.trustedTypes, d = s.prototype, f = Mf(d, "cloneNode"), p = Mf(d, "remove"), m = Mf(d, "nextSibling"), h = Mf(d, "childNodes"), g = Mf(d, "parentNode"), _ = Mf(d, "shadowRoot"), v = Mf(d, "attributes"), y = o && o.prototype ? Mf(o.prototype, "nodeType") : null, b = o && o.prototype ? Mf(o.prototype, "nodeName") : null;
	if (typeof a == "function") {
		let e = n.createElement("template");
		e.content && e.content.ownerDocument && (n = e.content.ownerDocument);
	}
	let x, S = "", C, w = !1, T = 0, E = function() {
		if (T > 0) throw dp("A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the \"DOMPurify and Trusted Types\" section of the README.");
	}, D = function(e) {
		E(), T++;
		try {
			return x.createHTML(e);
		} finally {
			T--;
		}
	}, O = function(e) {
		E(), T++;
		try {
			return x.createScriptURL(e);
		} finally {
			T--;
		}
	}, k = function() {
		return w ||= (C = zp(u, i), !0), C;
	}, A = n, j = A.implementation, M = A.createNodeIterator, N = A.createDocumentFragment, P = A.getElementsByTagName, F = r.importNode, I = Bp();
	t.isSupported = typeof Ff == "function" && typeof g == "function" && j && j.createHTMLDocument !== void 0;
	let ee = Cp, L = wp, R = Tp, te = Ep, z = Dp, ne = kp, re = Ap, ie = Mp, ae = Op, B = null, oe = Of({}, [
		...fp,
		...pp,
		...mp,
		...gp,
		...vp
	]), se = null, ce = Of({}, [
		...yp,
		...bp,
		...xp,
		...Sp
	]), le = Object.seal(Hf(null, {
		tagNameCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		},
		attributeNameCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		},
		allowCustomizedBuiltInElements: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: !1
		}
	})), V = null, ue = null, de = Object.seal(Hf(null, {
		tagCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		},
		attributeCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		}
	})), fe = !0, pe = !0, me = !1, he = !0, ge = !1, _e = !0, ve = !1, ye = !1, be = null, xe = null, Se = !1, Ce = !1, we = !1, Te = !1, Ee = !0, De = !1, H = "user-content-", Oe = !0, ke = !1, Ae = {}, je = null, Me = Of({}, /* @__PURE__ */ "annotation-xml.audio.colgroup.desc.foreignobject.head.iframe.math.mi.mn.mo.ms.mtext.noembed.noframes.noscript.plaintext.script.selectedcontent.style.svg.template.thead.title.video.xmp".split(".")), Ne = null, Pe = Of({}, [
		"audio",
		"video",
		"img",
		"source",
		"image",
		"track"
	]), Fe = null, Ie = Of({}, [
		"alt",
		"class",
		"for",
		"id",
		"label",
		"name",
		"pattern",
		"placeholder",
		"role",
		"summary",
		"title",
		"value",
		"style",
		"xmlns"
	]), Le = "http://www.w3.org/1998/Math/MathML", Re = "http://www.w3.org/2000/svg", ze = "http://www.w3.org/1999/xhtml", Be = ze, Ve = !1, He = null, Ue = Of({}, [
		Le,
		Re,
		ze
	], $f), We = Bf([
		"mi",
		"mo",
		"mn",
		"ms",
		"mtext"
	]), Ge = Of({}, We), Ke = Bf(["annotation-xml"]), qe = Of({}, Ke), Je = Of({}, [
		"title",
		"style",
		"font",
		"a",
		"script"
	]), Ye = null, Xe = ["application/xhtml+xml", "text/html"], Ze = null, Qe = null, $e = n.createElement("form"), et = function(e) {
		return e instanceof RegExp || e instanceof Function;
	}, tt = function() {
		let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		if (Qe && Qe === e) return;
		(!e || typeof e != "object") && (e = {}), e = Af(e), Ye = Xe.indexOf(e.PARSER_MEDIA_TYPE) === -1 ? "text/html" : e.PARSER_MEDIA_TYPE, Ze = Ye === "application/xhtml+xml" ? $f : Qf, B = Vp(e, "ALLOWED_TAGS", oe, { transform: Ze }), se = Vp(e, "ALLOWED_ATTR", ce, { transform: Ze }), He = Vp(e, "ALLOWED_NAMESPACES", Ue, { transform: $f }), Fe = Vp(e, "ADD_URI_SAFE_ATTR", Ie, {
			transform: Ze,
			base: Ie
		}), Ne = Vp(e, "ADD_DATA_URI_TAGS", Pe, {
			transform: Ze,
			base: Pe
		}), je = Vp(e, "FORBID_CONTENTS", Me, { transform: Ze }), V = Vp(e, "FORBID_TAGS", Af({}), { transform: Ze }), ue = Vp(e, "FORBID_ATTR", Af({}), { transform: Ze }), Ae = cp(e, "USE_PROFILES") ? e.USE_PROFILES && typeof e.USE_PROFILES == "object" ? Af(e.USE_PROFILES) : e.USE_PROFILES : !1, fe = e.ALLOW_ARIA_ATTR !== !1, pe = e.ALLOW_DATA_ATTR !== !1, me = e.ALLOW_UNKNOWN_PROTOCOLS || !1, he = e.ALLOW_SELF_CLOSE_IN_ATTR !== !1, ge = e.SAFE_FOR_TEMPLATES || !1, _e = e.SAFE_FOR_XML !== !1, ve = e.WHOLE_DOCUMENT || !1, Ce = e.RETURN_DOM || !1, we = e.RETURN_DOM_FRAGMENT || !1, Te = e.RETURN_TRUSTED_TYPE || !1, Se = e.FORCE_BODY || !1, Ee = e.SANITIZE_DOM !== !1, De = e.SANITIZE_NAMED_PROPS || !1, Oe = e.KEEP_CONTENT !== !1, ke = e.IN_PLACE || !1, ae = Nf(e.ALLOWED_URI_REGEXP) ? e.ALLOWED_URI_REGEXP : Op, Be = typeof e.NAMESPACE == "string" ? e.NAMESPACE : ze, Ge = cp(e, "MATHML_TEXT_INTEGRATION_POINTS") && e.MATHML_TEXT_INTEGRATION_POINTS && typeof e.MATHML_TEXT_INTEGRATION_POINTS == "object" ? Af(e.MATHML_TEXT_INTEGRATION_POINTS) : Of({}, We), qe = cp(e, "HTML_INTEGRATION_POINTS") && e.HTML_INTEGRATION_POINTS && typeof e.HTML_INTEGRATION_POINTS == "object" ? Af(e.HTML_INTEGRATION_POINTS) : Of({}, Ke);
		let t = cp(e, "CUSTOM_ELEMENT_HANDLING") && e.CUSTOM_ELEMENT_HANDLING && typeof e.CUSTOM_ELEMENT_HANDLING == "object" ? Af(e.CUSTOM_ELEMENT_HANDLING) : Hf(null);
		if (le = Hf(null), cp(t, "tagNameCheck") && et(t.tagNameCheck) && (le.tagNameCheck = t.tagNameCheck), cp(t, "attributeNameCheck") && et(t.attributeNameCheck) && (le.attributeNameCheck = t.attributeNameCheck), cp(t, "allowCustomizedBuiltInElements") && typeof t.allowCustomizedBuiltInElements == "boolean" && (le.allowCustomizedBuiltInElements = t.allowCustomizedBuiltInElements), Vf(le), ge && (pe = !1), we && (Ce = !0), Ae && (B = Of({}, vp), se = Hf(null), Ae.html === !0 && (Of(B, fp), Of(se, yp)), Ae.svg === !0 && (Of(B, pp), Of(se, bp), Of(se, Sp)), Ae.svgFilters === !0 && (Of(B, mp), Of(se, bp), Of(se, Sp)), Ae.mathMl === !0 && (Of(B, gp), Of(se, xp), Of(se, Sp))), de.tagCheck = null, de.attributeCheck = null, cp(e, "ADD_TAGS") && (typeof e.ADD_TAGS == "function" ? de.tagCheck = e.ADD_TAGS : Zf(e.ADD_TAGS) && (B === oe && (B = Af(B)), Of(B, e.ADD_TAGS, Ze))), cp(e, "ADD_ATTR") && (typeof e.ADD_ATTR == "function" ? de.attributeCheck = e.ADD_ATTR : Zf(e.ADD_ATTR) && (se === ce && (se = Af(se)), Of(se, e.ADD_ATTR, Ze))), cp(e, "ADD_URI_SAFE_ATTR") && Zf(e.ADD_URI_SAFE_ATTR) && Of(Fe, e.ADD_URI_SAFE_ATTR, Ze), cp(e, "FORBID_CONTENTS") && Zf(e.FORBID_CONTENTS) && (je === Me && (je = Af(je)), Of(je, e.FORBID_CONTENTS, Ze)), cp(e, "ADD_FORBID_CONTENTS") && Zf(e.ADD_FORBID_CONTENTS) && (je === Me && (je = Af(je)), Of(je, e.ADD_FORBID_CONTENTS, Ze)), Oe && (B["#text"] = !0), ve && Of(B, [
			"html",
			"head",
			"body"
		]), B.table && (Of(B, ["tbody"]), delete V.tbody), e.TRUSTED_TYPES_POLICY) {
			if (typeof e.TRUSTED_TYPES_POLICY.createHTML != "function") throw dp("TRUSTED_TYPES_POLICY configuration option must provide a \"createHTML\" hook.");
			if (typeof e.TRUSTED_TYPES_POLICY.createScriptURL != "function") throw dp("TRUSTED_TYPES_POLICY configuration option must provide a \"createScriptURL\" hook.");
			let t = x;
			x = e.TRUSTED_TYPES_POLICY;
			try {
				S = D("");
			} catch (e) {
				throw x = t, e;
			}
		} else e.TRUSTED_TYPES_POLICY === null ? (x = void 0, S = "") : (x === void 0 && (x = k()), x && typeof S == "string" && (S = D("")));
		Bf && Bf(e), Qe = e;
	}, nt = Of({}, [
		...pp,
		...mp,
		...hp
	]), rt = Of({}, [...gp, ..._p]), it = function(e, t, n) {
		return t.namespaceURI === ze ? e === "svg" : t.namespaceURI === Le ? e === "svg" && (n === "annotation-xml" || Ge[n]) : !!nt[e];
	}, at = function(e, t, n) {
		return t.namespaceURI === ze ? e === "math" : t.namespaceURI === Re ? e === "math" && qe[n] : !!rt[e];
	}, ot = function(e, t, n) {
		return t.namespaceURI === Re && !qe[n] || t.namespaceURI === Le && !Ge[n] ? !1 : !rt[e] && (Je[e] || !nt[e]);
	}, st = function(e) {
		let t = g(e);
		(!t || !t.tagName) && (t = {
			namespaceURI: Be,
			tagName: "template"
		});
		let n = Qf(e.tagName), r = Qf(t.tagName);
		return He[e.namespaceURI] ? e.namespaceURI === Re ? it(n, t, r) : e.namespaceURI === Le ? at(n, t, r) : e.namespaceURI === ze ? ot(n, t, r) : !!(Ye === "application/xhtml+xml" && He[e.namespaceURI]) : !1;
	}, ct = function(e) {
		Yf(t.removed, { element: e });
		try {
			g(e).removeChild(e);
		} catch {
			if (p(e), !g(e)) throw dp("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
		}
	}, lt = function(e) {
		let t = h(e);
		if (t) {
			let e = [];
			Kf(t, (t) => {
				Yf(e, t);
			}), Kf(e, (e) => {
				try {
					p(e);
				} catch {}
			});
		}
		let n = v(e);
		if (n) for (let t = n.length - 1; t >= 0; --t) {
			let r = n[t], i = r && r.name;
			if (typeof i == "string") try {
				e.removeAttribute(i);
			} catch {}
		}
	}, ut = function(e, n) {
		try {
			Yf(t.removed, {
				attribute: n.getAttributeNode(e),
				from: n
			});
		} catch {
			Yf(t.removed, {
				attribute: null,
				from: n
			});
		}
		if (n.removeAttribute(e), e === "is") if (Ce || we) try {
			ct(n);
		} catch {}
		else try {
			n.setAttribute(e, "");
		} catch {}
	}, dt = function(e) {
		let t = v(e);
		if (t) for (let n = t.length - 1; n >= 0; --n) {
			let r = t[n], i = r && r.name;
			if (!(typeof i != "string" || se[Ze(i)])) try {
				e.removeAttribute(i);
			} catch {}
		}
	}, ft = function(e) {
		let t = [e];
		for (; t.length > 0;) {
			let e = t.pop();
			(y ? y(e) : e.nodeType) === Lp.element && dt(e);
			let n = h(e);
			if (n) for (let e = n.length - 1; e >= 0; --e) t.push(n[e]);
		}
	}, pt = function(e) {
		let t = null, r = null;
		if (Se) e = "<remove></remove>" + e;
		else {
			let t = ep(e, /^[\r\n\t ]+/);
			r = t && t[0];
		}
		Ye === "application/xhtml+xml" && Be === ze && (e = "<html xmlns=\"http://www.w3.org/1999/xhtml\"><head></head><body>" + e + "</body></html>");
		let i = x ? D(e) : e;
		if (Be === ze) try {
			t = new l().parseFromString(i, Ye);
		} catch {}
		if (!t || !t.documentElement) {
			t = j.createDocument(Be, "template", null);
			try {
				t.documentElement.innerHTML = Ve ? S : i;
			} catch {}
		}
		let a = t.body || t.documentElement;
		return e && r && a.insertBefore(n.createTextNode(r), a.childNodes[0] || null), Be === ze ? P.call(t, ve ? "html" : "body")[0] : ve ? t.documentElement : a;
	}, mt = function(e) {
		return M.call(e.ownerDocument || e, e, c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT | c.SHOW_PROCESSING_INSTRUCTION | c.SHOW_CDATA_SECTION, null);
	}, ht = function(e) {
		return e = tp(e, ee, " "), e = tp(e, L, " "), e = tp(e, R, " "), e;
	}, gt = function(e) {
		e.normalize();
		let t = M.call(e.ownerDocument || e, e, c.SHOW_TEXT | c.SHOW_COMMENT | c.SHOW_CDATA_SECTION | c.SHOW_PROCESSING_INSTRUCTION, null), n = t.nextNode();
		for (; n;) n.data = ht(n.data), n = t.nextNode();
		let r = e.querySelectorAll?.call(e, "template");
		r && Kf(r, (e) => {
			vt(e.content) && gt(e.content);
		});
	}, _t = function(e) {
		let t = b ? b(e) : null;
		return typeof t != "string" || Ze(t) !== "form" ? !1 : typeof e.nodeName != "string" || typeof e.textContent != "string" || typeof e.removeChild != "function" || e.attributes !== v(e) || typeof e.removeAttribute != "function" || typeof e.setAttribute != "function" || typeof e.namespaceURI != "string" || typeof e.insertBefore != "function" || typeof e.hasChildNodes != "function" || e.nodeType !== y(e) || e.childNodes !== h(e);
	}, vt = function(e) {
		if (!y || typeof e != "object" || !e) return !1;
		try {
			return y(e) === Lp.documentFragment;
		} catch {
			return !1;
		}
	}, yt = function(e) {
		if (!y || typeof e != "object" || !e) return !1;
		try {
			return typeof y(e) == "number";
		} catch {
			return !1;
		}
	};
	function bt(e, n, r) {
		e.length !== 0 && Kf(e, (e) => {
			e.call(t, n, r, Qe);
		});
	}
	let xt = function(e, t) {
		return !!(_e && e.hasChildNodes() && !yt(e.firstElementChild) && up(Np, e.textContent) && up(Np, e.innerHTML) || _e && e.namespaceURI === ze && t === "style" && yt(e.firstElementChild) || e.nodeType === Lp.processingInstruction || _e && e.nodeType === Lp.comment && up(Pp, e.data));
	}, St = function(e, t) {
		if (!V[t] && Et(t) && (le.tagNameCheck instanceof RegExp && up(le.tagNameCheck, t) || le.tagNameCheck instanceof Function && le.tagNameCheck(t))) return !1;
		if (Oe && !je[t]) {
			let t = g(e), n = h(e);
			if (n && t) {
				let r = n.length;
				for (let i = r - 1; i >= 0; --i) {
					let r = ke ? n[i] : f(n[i], !0);
					t.insertBefore(r, m(e));
				}
			}
		}
		return ct(e), !0;
	}, Ct = function(e) {
		if (bt(I.beforeSanitizeElements, e, null), _t(e)) return ct(e), !0;
		let n = Ze(b ? b(e) : e.nodeName);
		if (bt(I.uponSanitizeElement, e, {
			tagName: n,
			allowedTags: B
		}), xt(e, n)) return ct(e), !0;
		if (V[n] || !(de.tagCheck instanceof Function && de.tagCheck(n)) && !B[n]) return St(e, n);
		if ((y ? y(e) : e.nodeType) === Lp.element && !st(e) || (n === "noscript" || n === "noembed" || n === "noframes") && up(Fp, e.innerHTML)) return ct(e), !0;
		if (ge && e.nodeType === Lp.text) {
			let n = ht(e.textContent);
			e.textContent !== n && (Yf(t.removed, { element: e.cloneNode() }), e.textContent = n);
		}
		return bt(I.afterSanitizeElements, e, null), !1;
	}, wt = function(e, t, r) {
		if (ue[t] || Ee && (t === "id" || t === "name") && (r in n || r in $e)) return !1;
		let i = se[t] || de.attributeCheck instanceof Function && de.attributeCheck(t, e);
		if (!(pe && up(te, t)) && !(fe && up(z, t))) {
			if (!i) {
				if (!(Et(e) && (le.tagNameCheck instanceof RegExp && up(le.tagNameCheck, e) || le.tagNameCheck instanceof Function && le.tagNameCheck(e)) && (le.attributeNameCheck instanceof RegExp && up(le.attributeNameCheck, t) || le.attributeNameCheck instanceof Function && le.attributeNameCheck(t, e)) || t === "is" && le.allowCustomizedBuiltInElements && (le.tagNameCheck instanceof RegExp && up(le.tagNameCheck, r) || le.tagNameCheck instanceof Function && le.tagNameCheck(r)))) return !1;
			} else if (!Fe[t] && !up(ae, tp(r, re, "")) && !((t === "src" || t === "xlink:href" || t === "href") && e !== "script" && np(r, "data:") === 0 && Ne[e]) && !(me && !up(ne, tp(r, re, ""))) && r) return !1;
		}
		return !0;
	}, Tt = Of({}, [
		"annotation-xml",
		"color-profile",
		"font-face",
		"font-face-format",
		"font-face-name",
		"font-face-src",
		"font-face-uri",
		"missing-glyph"
	]), Et = function(e) {
		return !Tt[Qf(e)] && up(ie, e);
	}, Dt = function(e, t, n, r) {
		if (x && typeof u == "object" && typeof u.getAttributeType == "function" && !n) switch (u.getAttributeType(e, t)) {
			case "TrustedHTML": return D(r);
			case "TrustedScriptURL": return O(r);
		}
		return r;
	}, Ot = function(e, n, r, i) {
		try {
			r ? e.setAttributeNS(r, n, i) : e.setAttribute(n, i), _t(e) ? ct(e) : Jf(t.removed);
		} catch {
			ut(n, e);
		}
	}, U = function(e) {
		bt(I.beforeSanitizeAttributes, e, null);
		let t = e.attributes;
		if (!t || _t(e)) return;
		let n = {
			attrName: "",
			attrValue: "",
			keepAttr: !0,
			allowedAttributes: se,
			forceKeepAttr: void 0
		}, r = t.length, i = Ze(e.nodeName);
		for (; r--;) {
			let a = t[r], o = a.name, s = a.namespaceURI, c = a.value, l = Ze(o), u = c, d = o === "value" ? u : rp(u);
			if (n.attrName = l, n.attrValue = d, n.keepAttr = !0, n.forceKeepAttr = void 0, bt(I.uponSanitizeAttribute, e, n), d = n.attrValue, De && (l === "id" || l === "name") && np(d, H) !== 0 && (ut(o, e), d = H + d), _e && up(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, d)) {
				ut(o, e);
				continue;
			}
			if (l === "attributename" && ep(d, "href")) {
				ut(o, e);
				continue;
			}
			if (!n.forceKeepAttr) {
				if (!n.keepAttr) {
					ut(o, e);
					continue;
				}
				if (!he && up(Ip, d)) {
					ut(o, e);
					continue;
				}
				if (ge && (d = ht(d)), !wt(i, l, d)) {
					ut(o, e);
					continue;
				}
				d = Dt(i, l, s, d), d !== u && Ot(e, o, s, d);
			}
		}
		bt(I.afterSanitizeAttributes, e, null);
	}, W = function(e) {
		let t = null, n = mt(e);
		for (bt(I.beforeSanitizeShadowDOM, e, null); t = n.nextNode();) if (bt(I.uponSanitizeShadowNode, t, null), Ct(t), U(t), vt(t.content) && W(t.content), (y ? y(t) : t.nodeType) === Lp.element) {
			let e = _(t);
			vt(e) && (kt(e), W(e));
		}
		bt(I.afterSanitizeShadowDOM, e, null);
	}, kt = function(e) {
		let t = [{
			node: e,
			shadow: null
		}];
		for (; t.length > 0;) {
			let e = t.pop();
			if (e.shadow) {
				W(e.shadow);
				continue;
			}
			let n = e.node, r = (y ? y(n) : n.nodeType) === Lp.element, i = h(n);
			if (i) for (let e = i.length - 1; e >= 0; --e) t.push({
				node: i[e],
				shadow: null
			});
			if (r) {
				let e = b ? b(n) : null;
				if (typeof e == "string" && Ze(e) === "template") {
					let e = n.content;
					vt(e) && t.push({
						node: e,
						shadow: null
					});
				}
			}
			if (r) {
				let e = _(n);
				vt(e) && t.push({
					node: null,
					shadow: e
				}, {
					node: e,
					shadow: null
				});
			}
		}
	};
	return t.sanitize = function(e) {
		let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = null, a = null, o = null, s = null;
		if (Ve = !e, Ve && (e = "<!-->"), typeof e != "string" && !yt(e) && (e = jf(e), typeof e != "string")) throw dp("dirty is not a string, aborting");
		if (!t.isSupported) return e;
		ye ? (B = be, se = xe) : tt(n), (I.uponSanitizeElement.length > 0 || I.uponSanitizeAttribute.length > 0) && (B = Af(B)), I.uponSanitizeAttribute.length > 0 && (se = Af(se)), t.removed = [];
		let c = ke && typeof e != "string" && yt(e);
		if (c) {
			let t = b ? b(e) : e.nodeName;
			if (typeof t == "string") {
				let e = Ze(t);
				if (!B[e] || V[e]) throw dp("root node is forbidden and cannot be sanitized in-place");
			}
			if (_t(e)) throw dp("root node is clobbered and cannot be sanitized in-place");
			try {
				kt(e);
			} catch (t) {
				throw lt(e), t;
			}
		} else if (yt(e)) i = pt("<!---->"), a = i.ownerDocument.importNode(e, !0), a.nodeType === Lp.element && a.nodeName === "BODY" || a.nodeName === "HTML" ? i = a : i.appendChild(a), kt(a);
		else {
			if (!Ce && !ge && !ve && e.indexOf("<") === -1) return x && Te ? D(e) : e;
			if (i = pt(e), !i) return Ce ? null : Te ? S : "";
		}
		i && Se && ct(i.firstChild);
		let l = mt(c ? e : i);
		try {
			for (; o = l.nextNode();) Ct(o), U(o), vt(o.content) && W(o.content);
		} catch (t) {
			throw c && lt(e), t;
		}
		if (c) return Kf(t.removed, (e) => {
			e.element && ft(e.element);
		}), ge && gt(e), e;
		if (Ce) {
			if (ge && gt(i), we) for (s = N.call(i.ownerDocument); i.firstChild;) s.appendChild(i.firstChild);
			else s = i;
			return (se.shadowroot || se.shadowrootmode) && (s = F.call(r, s, !0)), s;
		}
		let u = ve ? i.outerHTML : i.innerHTML;
		return ve && B["!doctype"] && i.ownerDocument && i.ownerDocument.doctype && i.ownerDocument.doctype.name && up(jp, i.ownerDocument.doctype.name) && (u = "<!DOCTYPE " + i.ownerDocument.doctype.name + ">\n" + u), ge && (u = ht(u)), x && Te ? D(u) : u;
	}, t.setConfig = function() {
		let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		tt(e), ye = !0, be = B, xe = se;
	}, t.clearConfig = function() {
		Qe = null, ye = !1, be = null, xe = null, x = C, S = "";
	}, t.isValidAttribute = function(e, t, n) {
		Qe || tt({});
		let r = Ze(e), i = Ze(t);
		return wt(r, i, n);
	}, t.addHook = function(e, t) {
		typeof t == "function" && cp(I, e) && Yf(I[e], t);
	}, t.removeHook = function(e, t) {
		if (cp(I, e)) {
			if (t !== void 0) {
				let n = qf(I[e], t);
				return n === -1 ? void 0 : Xf(I[e], n, 1)[0];
			}
			return Jf(I[e]);
		}
	}, t.removeHooks = function(e) {
		cp(I, e) && (I[e] = []);
	}, t.removeAllHooks = function() {
		I = Bp();
	}, t;
}
var Ff, If, Lf, Rf, zf, Bf, Vf, Hf, Uf, Wf, Gf, Kf, qf, Jf, Yf, Xf, Zf, Qf, $f, ep, tp, np, rp, ip, ap, op, sp, cp, lp, up, dp, fp, pp, mp, hp, gp, _p, vp, yp, bp, xp, Sp, Cp, wp, Tp, Ep, Dp, Op, kp, Ap, jp, Mp, Np, Pp, Fp, Ip, Lp, Rp, zp, Bp, Vp, Hp, Up = o((() => {
	Ff = Object.entries, If = Object.setPrototypeOf, Lf = Object.isFrozen, Rf = Object.getPrototypeOf, zf = Object.getOwnPropertyDescriptor, Bf = Object.freeze, Vf = Object.seal, Hf = Object.create, Uf = typeof Reflect < "u" && Reflect, Wf = Uf.apply, Gf = Uf.construct, Bf ||= function(e) {
		return e;
	}, Vf ||= function(e) {
		return e;
	}, Wf ||= function(e, t) {
		var n = [...arguments].slice(2);
		return e.apply(t, n);
	}, Gf ||= function(e) {
		return new e(...[...arguments].slice(1));
	}, Kf = Ef(Array.prototype.forEach), qf = Ef(Array.prototype.lastIndexOf), Jf = Ef(Array.prototype.pop), Yf = Ef(Array.prototype.push), Xf = Ef(Array.prototype.splice), Zf = Array.isArray, Qf = Ef(String.prototype.toLowerCase), $f = Ef(String.prototype.toString), ep = Ef(String.prototype.match), tp = Ef(String.prototype.replace), np = Ef(String.prototype.indexOf), rp = Ef(String.prototype.trim), ip = Ef(Number.prototype.toString), ap = Ef(Boolean.prototype.toString), op = typeof BigInt > "u" ? null : Ef(BigInt.prototype.toString), sp = typeof Symbol > "u" ? null : Ef(Symbol.prototype.toString), cp = Ef(Object.prototype.hasOwnProperty), lp = Ef(Object.prototype.toString), up = Ef(RegExp.prototype.test), dp = Df(TypeError), fp = Bf(/* @__PURE__ */ "a.abbr.acronym.address.area.article.aside.audio.b.bdi.bdo.big.blink.blockquote.body.br.button.canvas.caption.center.cite.code.col.colgroup.content.data.datalist.dd.decorator.del.details.dfn.dialog.dir.div.dl.dt.element.em.fieldset.figcaption.figure.font.footer.form.h1.h2.h3.h4.h5.h6.head.header.hgroup.hr.html.i.img.input.ins.kbd.label.legend.li.main.map.mark.marquee.menu.menuitem.meter.nav.nobr.ol.optgroup.option.output.p.picture.pre.progress.q.rp.rt.ruby.s.samp.search.section.select.shadow.slot.small.source.spacer.span.strike.strong.style.sub.summary.sup.table.tbody.td.template.textarea.tfoot.th.thead.time.tr.track.tt.u.ul.var.video.wbr".split(".")), pp = Bf(/* @__PURE__ */ "svg.a.altglyph.altglyphdef.altglyphitem.animatecolor.animatemotion.animatetransform.circle.clippath.defs.desc.ellipse.enterkeyhint.exportparts.filter.font.g.glyph.glyphref.hkern.image.inputmode.line.lineargradient.marker.mask.metadata.mpath.part.path.pattern.polygon.polyline.radialgradient.rect.stop.style.switch.symbol.text.textpath.title.tref.tspan.view.vkern".split(".")), mp = Bf([
		"feBlend",
		"feColorMatrix",
		"feComponentTransfer",
		"feComposite",
		"feConvolveMatrix",
		"feDiffuseLighting",
		"feDisplacementMap",
		"feDistantLight",
		"feDropShadow",
		"feFlood",
		"feFuncA",
		"feFuncB",
		"feFuncG",
		"feFuncR",
		"feGaussianBlur",
		"feImage",
		"feMerge",
		"feMergeNode",
		"feMorphology",
		"feOffset",
		"fePointLight",
		"feSpecularLighting",
		"feSpotLight",
		"feTile",
		"feTurbulence"
	]), hp = Bf([
		"animate",
		"color-profile",
		"cursor",
		"discard",
		"font-face",
		"font-face-format",
		"font-face-name",
		"font-face-src",
		"font-face-uri",
		"foreignobject",
		"hatch",
		"hatchpath",
		"mesh",
		"meshgradient",
		"meshpatch",
		"meshrow",
		"missing-glyph",
		"script",
		"set",
		"solidcolor",
		"unknown",
		"use"
	]), gp = Bf(/* @__PURE__ */ "math.menclose.merror.mfenced.mfrac.mglyph.mi.mlabeledtr.mmultiscripts.mn.mo.mover.mpadded.mphantom.mroot.mrow.ms.mspace.msqrt.mstyle.msub.msup.msubsup.mtable.mtd.mtext.mtr.munder.munderover.mprescripts".split(".")), _p = Bf([
		"maction",
		"maligngroup",
		"malignmark",
		"mlongdiv",
		"mscarries",
		"mscarry",
		"msgroup",
		"mstack",
		"msline",
		"msrow",
		"semantics",
		"annotation",
		"annotation-xml",
		"mprescripts",
		"none"
	]), vp = Bf(["#text"]), yp = Bf(/* @__PURE__ */ "accept.action.align.alt.autocapitalize.autocomplete.autopictureinpicture.autoplay.background.bgcolor.border.capture.cellpadding.cellspacing.checked.cite.class.clear.color.cols.colspan.command.commandfor.controls.controlslist.coords.crossorigin.datetime.decoding.default.dir.disabled.disablepictureinpicture.disableremoteplayback.download.draggable.enctype.enterkeyhint.exportparts.face.for.headers.height.hidden.high.href.hreflang.id.inert.inputmode.integrity.ismap.kind.label.lang.list.loading.loop.low.max.maxlength.media.method.min.minlength.multiple.muted.name.nonce.noshade.novalidate.nowrap.open.optimum.part.pattern.placeholder.playsinline.popover.popovertarget.popovertargetaction.poster.preload.pubdate.radiogroup.readonly.rel.required.rev.reversed.role.rows.rowspan.spellcheck.scope.selected.shape.size.sizes.slot.span.srclang.start.src.srcset.step.style.summary.tabindex.title.translate.type.usemap.valign.value.width.wrap.xmlns".split(".")), bp = Bf(/* @__PURE__ */ "accent-height.accumulate.additive.alignment-baseline.amplitude.ascent.attributename.attributetype.azimuth.basefrequency.baseline-shift.begin.bias.by.class.clip.clippathunits.clip-path.clip-rule.color.color-interpolation.color-interpolation-filters.color-profile.color-rendering.cx.cy.d.dx.dy.diffuseconstant.direction.display.divisor.dur.edgemode.elevation.end.exponent.fill.fill-opacity.fill-rule.filter.filterunits.flood-color.flood-opacity.font-family.font-size.font-size-adjust.font-stretch.font-style.font-variant.font-weight.fx.fy.g1.g2.glyph-name.glyphref.gradientunits.gradienttransform.height.href.id.image-rendering.in.in2.intercept.k.k1.k2.k3.k4.kerning.keypoints.keysplines.keytimes.lang.lengthadjust.letter-spacing.kernelmatrix.kernelunitlength.lighting-color.local.marker-end.marker-mid.marker-start.markerheight.markerunits.markerwidth.maskcontentunits.maskunits.max.mask.mask-type.media.method.mode.min.name.numoctaves.offset.operator.opacity.order.orient.orientation.origin.overflow.paint-order.path.pathlength.patterncontentunits.patterntransform.patternunits.points.preservealpha.preserveaspectratio.primitiveunits.r.rx.ry.radius.refx.refy.repeatcount.repeatdur.restart.result.rotate.scale.seed.shape-rendering.slope.specularconstant.specularexponent.spreadmethod.startoffset.stddeviation.stitchtiles.stop-color.stop-opacity.stroke-dasharray.stroke-dashoffset.stroke-linecap.stroke-linejoin.stroke-miterlimit.stroke-opacity.stroke.stroke-width.style.surfacescale.systemlanguage.tabindex.tablevalues.targetx.targety.transform.transform-origin.text-anchor.text-decoration.text-rendering.textlength.type.u1.u2.unicode.values.viewbox.visibility.version.vert-adv-y.vert-origin-x.vert-origin-y.width.word-spacing.wrap.writing-mode.xchannelselector.ychannelselector.x.x1.x2.xmlns.y.y1.y2.z.zoomandpan".split(".")), xp = Bf(/* @__PURE__ */ "accent.accentunder.align.bevelled.close.columnalign.columnlines.columnspacing.columnspan.denomalign.depth.dir.display.displaystyle.encoding.fence.frame.height.href.id.largeop.length.linethickness.lquote.lspace.mathbackground.mathcolor.mathsize.mathvariant.maxsize.minsize.movablelimits.notation.numalign.open.rowalign.rowlines.rowspacing.rowspan.rspace.rquote.scriptlevel.scriptminsize.scriptsizemultiplier.selection.separator.separators.stretchy.subscriptshift.supscriptshift.symmetric.voffset.width.xmlns".split(".")), Sp = Bf([
		"xlink:href",
		"xml:id",
		"xlink:title",
		"xml:space",
		"xmlns:xlink"
	]), Cp = Vf(/{{[\w\W]*|^[\w\W]*}}/g), wp = Vf(/<%[\w\W]*|^[\w\W]*%>/g), Tp = Vf(/\${[\w\W]*/g), Ep = Vf(/^data-[\-\w.\u00B7-\uFFFF]+$/), Dp = Vf(/^aria-[\-\w]+$/), Op = Vf(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i), kp = Vf(/^(?:\w+script|data):/i), Ap = Vf(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g), jp = Vf(/^html$/i), Mp = Vf(/^[a-z][.\w]*(-[.\w]+)+$/i), Np = Vf(/<[/\w!]/g), Pp = Vf(/<[/\w]/g), Fp = Vf(/<\/no(script|embed|frames)/i), Ip = Vf(/\/>/i), Lp = {
		element: 1,
		attribute: 2,
		text: 3,
		cdataSection: 4,
		entityReference: 5,
		entityNode: 6,
		processingInstruction: 7,
		comment: 8,
		document: 9,
		documentType: 10,
		documentFragment: 11,
		notation: 12
	}, Rp = function() {
		return typeof window > "u" ? null : window;
	}, zp = function(e, t) {
		if (typeof e != "object" || typeof e.createPolicy != "function") return null;
		let n = null, r = "data-tt-policy-suffix";
		t && t.hasAttribute(r) && (n = t.getAttribute(r));
		let i = "dompurify" + (n ? "#" + n : "");
		try {
			return e.createPolicy(i, {
				createHTML(e) {
					return e;
				},
				createScriptURL(e) {
					return e;
				}
			});
		} catch {
			return console.warn("TrustedTypes policy " + i + " could not be created."), null;
		}
	}, Bp = function() {
		return {
			afterSanitizeAttributes: [],
			afterSanitizeElements: [],
			afterSanitizeShadowDOM: [],
			beforeSanitizeAttributes: [],
			beforeSanitizeElements: [],
			beforeSanitizeShadowDOM: [],
			uponSanitizeAttribute: [],
			uponSanitizeElement: [],
			uponSanitizeShadowNode: []
		};
	}, Vp = function(e, t, n, r) {
		return cp(e, t) && Zf(e[t]) ? Of(r.base ? Af(r.base) : {}, e[t], r.transform) : n;
	}, Hp = Pf();
})), Wp = /* @__PURE__ */ s(((e, t) => {
	var n = function(e) {
		return e && e.Math === Math && e;
	};
	t.exports = n(typeof globalThis == "object" && globalThis) || n(typeof window == "object" && window) || n(typeof self == "object" && self) || n(typeof global == "object" && global) || n(typeof e == "object" && e) || (function() {
		return this;
	})() || Function("return this")();
})), Gp = /* @__PURE__ */ s(((e, t) => {
	t.exports = function(e) {
		try {
			return !!e();
		} catch {
			return !0;
		}
	};
})), Kp = /* @__PURE__ */ s(((e, t) => {
	t.exports = !Gp()(function() {
		return Object.defineProperty({}, 1, { get: function() {
			return 7;
		} })[1] !== 7;
	});
})), qp = /* @__PURE__ */ s(((e, t) => {
	t.exports = !Gp()(function() {
		var e = (function() {}).bind();
		return typeof e != "function" || e.hasOwnProperty("prototype");
	});
})), Jp = /* @__PURE__ */ s(((e, t) => {
	var n = qp(), r = Function.prototype.call;
	t.exports = n ? r.bind(r) : function() {
		return r.apply(r, arguments);
	};
})), Yp = /* @__PURE__ */ s(((e) => {
	var t = {}.propertyIsEnumerable, n = Object.getOwnPropertyDescriptor;
	e.f = n && !t.call({ 1: 2 }, 1) ? function(e) {
		var t = n(this, e);
		return !!t && t.enumerable;
	} : t;
})), Xp = /* @__PURE__ */ s(((e, t) => {
	t.exports = function(e, t) {
		return {
			enumerable: !(e & 1),
			configurable: !(e & 2),
			writable: !(e & 4),
			value: t
		};
	};
})), Zp = /* @__PURE__ */ s(((e, t) => {
	var n = qp(), r = Function.prototype, i = r.call, a = n && r.bind.bind(i, i);
	t.exports = n ? a : function(e) {
		return function() {
			return i.apply(e, arguments);
		};
	};
})), Qp = /* @__PURE__ */ s(((e, t) => {
	var n = Zp(), r = n({}.toString), i = n("".slice);
	t.exports = function(e) {
		return i(r(e), 8, -1);
	};
})), $p = /* @__PURE__ */ s(((e, t) => {
	var n = Zp(), r = Gp(), i = Qp(), a = Object, o = n("".split);
	t.exports = r(function() {
		return !a("z").propertyIsEnumerable(0);
	}) ? function(e) {
		return i(e) === "String" ? o(e, "") : a(e);
	} : a;
})), em = /* @__PURE__ */ s(((e, t) => {
	t.exports = function(e) {
		return e == null;
	};
})), tm = /* @__PURE__ */ s(((e, t) => {
	var n = em(), r = TypeError;
	t.exports = function(e) {
		if (n(e)) throw new r("Can't call method on " + e);
		return e;
	};
})), nm = /* @__PURE__ */ s(((e, t) => {
	var n = $p(), r = tm();
	t.exports = function(e) {
		return n(r(e));
	};
})), rm = /* @__PURE__ */ s(((e, t) => {
	var n = typeof document == "object" && document.all;
	t.exports = n === void 0 && n !== void 0 ? function(e) {
		return typeof e == "function" || e === n;
	} : function(e) {
		return typeof e == "function";
	};
})), im = /* @__PURE__ */ s(((e, t) => {
	var n = rm();
	t.exports = function(e) {
		return typeof e == "object" ? e !== null : n(e);
	};
})), am = /* @__PURE__ */ s(((e, t) => {
	var n = Wp(), r = rm(), i = function(e) {
		return r(e) ? e : void 0;
	};
	t.exports = function(e, t) {
		return arguments.length < 2 ? i(n[e]) : n[e] && n[e][t];
	};
})), om = /* @__PURE__ */ s(((e, t) => {
	t.exports = Zp()({}.isPrototypeOf);
})), sm = /* @__PURE__ */ s(((e, t) => {
	var n = Wp().navigator, r = n && n.userAgent;
	t.exports = r ? String(r) : "";
})), cm = /* @__PURE__ */ s(((e, t) => {
	var n = Wp(), r = sm(), i = n.process, a = n.Deno, o = i && i.versions || a && a.version, s = o && o.v8, c, l;
	s && (c = s.split("."), l = c[0] > 0 && c[0] < 4 ? 1 : +(c[0] + c[1])), !l && r && (c = r.match(/Edge\/(\d+)/), (!c || c[1] >= 74) && (c = r.match(/Chrome\/(\d+)/), c && (l = +c[1]))), t.exports = l;
})), lm = /* @__PURE__ */ s(((e, t) => {
	var n = cm(), r = Gp(), i = Wp().String;
	t.exports = !!Object.getOwnPropertySymbols && !r(function() {
		var e = Symbol("symbol detection");
		return !i(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && n && n < 41;
	});
})), um = /* @__PURE__ */ s(((e, t) => {
	t.exports = lm() && !Symbol.sham && typeof Symbol.iterator == "symbol";
})), dm = /* @__PURE__ */ s(((e, t) => {
	var n = am(), r = rm(), i = om(), a = um(), o = Object;
	t.exports = a ? function(e) {
		return typeof e == "symbol";
	} : function(e) {
		var t = n("Symbol");
		return r(t) && i(t.prototype, o(e));
	};
})), fm = /* @__PURE__ */ s(((e, t) => {
	var n = String;
	t.exports = function(e) {
		try {
			return n(e);
		} catch {
			return "Object";
		}
	};
})), pm = /* @__PURE__ */ s(((e, t) => {
	var n = rm(), r = fm(), i = TypeError;
	t.exports = function(e) {
		if (n(e)) return e;
		throw new i(r(e) + " is not a function");
	};
})), mm = /* @__PURE__ */ s(((e, t) => {
	var n = pm(), r = em();
	t.exports = function(e, t) {
		var i = e[t];
		return r(i) ? void 0 : n(i);
	};
})), hm = /* @__PURE__ */ s(((e, t) => {
	var n = Jp(), r = rm(), i = im(), a = TypeError;
	t.exports = function(e, t) {
		var o, s;
		if (t === "string" && r(o = e.toString) && !i(s = n(o, e)) || r(o = e.valueOf) && !i(s = n(o, e)) || t !== "string" && r(o = e.toString) && !i(s = n(o, e))) return s;
		throw new a("Can't convert object to primitive value");
	};
})), gm = /* @__PURE__ */ s(((e, t) => {
	t.exports = !1;
})), _m = /* @__PURE__ */ s(((e, t) => {
	var n = Wp(), r = Object.defineProperty;
	t.exports = function(e, t) {
		try {
			r(n, e, {
				value: t,
				configurable: !0,
				writable: !0
			});
		} catch {
			n[e] = t;
		}
		return t;
	};
})), vm = /* @__PURE__ */ s(((e, t) => {
	var n = gm(), r = Wp(), i = _m(), a = "__core-js_shared__", o = t.exports = r[a] || i(a, {});
	(o.versions ||= []).push({
		version: "3.47.0",
		mode: n ? "pure" : "global",
		copyright: "© 2014-2025 Denis Pushkarev (zloirock.ru), 2025 CoreJS Company (core-js.io)",
		license: "https://github.com/zloirock/core-js/blob/v3.47.0/LICENSE",
		source: "https://github.com/zloirock/core-js"
	});
})), ym = /* @__PURE__ */ s(((e, t) => {
	var n = vm();
	t.exports = function(e, t) {
		return n[e] || (n[e] = t || {});
	};
})), bm = /* @__PURE__ */ s(((e, t) => {
	var n = tm(), r = Object;
	t.exports = function(e) {
		return r(n(e));
	};
})), xm = /* @__PURE__ */ s(((e, t) => {
	var n = Zp(), r = bm(), i = n({}.hasOwnProperty);
	t.exports = Object.hasOwn || function(e, t) {
		return i(r(e), t);
	};
})), Sm = /* @__PURE__ */ s(((e, t) => {
	var n = Zp(), r = 0, i = Math.random(), a = n(1.1.toString);
	t.exports = function(e) {
		return "Symbol(" + (e === void 0 ? "" : e) + ")_" + a(++r + i, 36);
	};
})), Cm = /* @__PURE__ */ s(((e, t) => {
	var n = Wp(), r = ym(), i = xm(), a = Sm(), o = lm(), s = um(), c = n.Symbol, l = r("wks"), u = s ? c.for || c : c && c.withoutSetter || a;
	t.exports = function(e) {
		return i(l, e) || (l[e] = o && i(c, e) ? c[e] : u("Symbol." + e)), l[e];
	};
})), wm = /* @__PURE__ */ s(((e, t) => {
	var n = Jp(), r = im(), i = dm(), a = mm(), o = hm(), s = Cm(), c = TypeError, l = s("toPrimitive");
	t.exports = function(e, t) {
		if (!r(e) || i(e)) return e;
		var s = a(e, l), u;
		if (s) {
			if (t === void 0 && (t = "default"), u = n(s, e, t), !r(u) || i(u)) return u;
			throw new c("Can't convert object to primitive value");
		}
		return t === void 0 && (t = "number"), o(e, t);
	};
})), Tm = /* @__PURE__ */ s(((e, t) => {
	var n = wm(), r = dm();
	t.exports = function(e) {
		var t = n(e, "string");
		return r(t) ? t : t + "";
	};
})), Em = /* @__PURE__ */ s(((e, t) => {
	var n = Wp(), r = im(), i = n.document, a = r(i) && r(i.createElement);
	t.exports = function(e) {
		return a ? i.createElement(e) : {};
	};
})), Dm = /* @__PURE__ */ s(((e, t) => {
	var n = Kp(), r = Gp(), i = Em();
	t.exports = !n && !r(function() {
		return Object.defineProperty(i("div"), "a", { get: function() {
			return 7;
		} }).a !== 7;
	});
})), Om = /* @__PURE__ */ s(((e) => {
	var t = Kp(), n = Jp(), r = Yp(), i = Xp(), a = nm(), o = Tm(), s = xm(), c = Dm(), l = Object.getOwnPropertyDescriptor;
	e.f = t ? l : function(e, t) {
		if (e = a(e), t = o(t), c) try {
			return l(e, t);
		} catch {}
		if (s(e, t)) return i(!n(r.f, e, t), e[t]);
	};
})), km = /* @__PURE__ */ s(((e, t) => {
	var n = Kp(), r = Gp();
	t.exports = n && r(function() {
		return Object.defineProperty(function() {}, "prototype", {
			value: 42,
			writable: !1
		}).prototype !== 42;
	});
})), Am = /* @__PURE__ */ s(((e, t) => {
	var n = im(), r = String, i = TypeError;
	t.exports = function(e) {
		if (n(e)) return e;
		throw new i(r(e) + " is not an object");
	};
})), jm = /* @__PURE__ */ s(((e) => {
	var t = Kp(), n = Dm(), r = km(), i = Am(), a = Tm(), o = TypeError, s = Object.defineProperty, c = Object.getOwnPropertyDescriptor, l = "enumerable", u = "configurable", d = "writable";
	e.f = t ? r ? function(e, t, n) {
		if (i(e), t = a(t), i(n), typeof e == "function" && t === "prototype" && "value" in n && d in n && !n[d]) {
			var r = c(e, t);
			r && r[d] && (e[t] = n.value, n = {
				configurable: u in n ? n[u] : r[u],
				enumerable: l in n ? n[l] : r[l],
				writable: !1
			});
		}
		return s(e, t, n);
	} : s : function(e, t, r) {
		if (i(e), t = a(t), i(r), n) try {
			return s(e, t, r);
		} catch {}
		if ("get" in r || "set" in r) throw new o("Accessors not supported");
		return "value" in r && (e[t] = r.value), e;
	};
})), Mm = /* @__PURE__ */ s(((e, t) => {
	var n = Kp(), r = jm(), i = Xp();
	t.exports = n ? function(e, t, n) {
		return r.f(e, t, i(1, n));
	} : function(e, t, n) {
		return e[t] = n, e;
	};
})), Nm = /* @__PURE__ */ s(((e, t) => {
	var n = Kp(), r = xm(), i = Function.prototype, a = n && Object.getOwnPropertyDescriptor, o = r(i, "name");
	t.exports = {
		EXISTS: o,
		PROPER: o && (function() {}).name === "something",
		CONFIGURABLE: o && (!n || n && a(i, "name").configurable)
	};
})), Pm = /* @__PURE__ */ s(((e, t) => {
	var n = Zp(), r = rm(), i = vm(), a = n(Function.toString);
	r(i.inspectSource) || (i.inspectSource = function(e) {
		return a(e);
	}), t.exports = i.inspectSource;
})), Fm = /* @__PURE__ */ s(((e, t) => {
	var n = Wp(), r = rm(), i = n.WeakMap;
	t.exports = r(i) && /native code/.test(String(i));
})), Im = /* @__PURE__ */ s(((e, t) => {
	var n = ym(), r = Sm(), i = n("keys");
	t.exports = function(e) {
		return i[e] || (i[e] = r(e));
	};
})), Lm = /* @__PURE__ */ s(((e, t) => {
	t.exports = {};
})), Rm = /* @__PURE__ */ s(((e, t) => {
	var n = Fm(), r = Wp(), i = im(), a = Mm(), o = xm(), s = vm(), c = Im(), l = Lm(), u = "Object already initialized", d = r.TypeError, f = r.WeakMap, p, m, h, g = function(e) {
		return h(e) ? m(e) : p(e, {});
	}, _ = function(e) {
		return function(t) {
			var n;
			if (!i(t) || (n = m(t)).type !== e) throw new d("Incompatible receiver, " + e + " required");
			return n;
		};
	};
	if (n || s.state) {
		var v = s.state ||= new f();
		v.get = v.get, v.has = v.has, v.set = v.set, p = function(e, t) {
			if (v.has(e)) throw new d(u);
			return t.facade = e, v.set(e, t), t;
		}, m = function(e) {
			return v.get(e) || {};
		}, h = function(e) {
			return v.has(e);
		};
	} else {
		var y = c("state");
		l[y] = !0, p = function(e, t) {
			if (o(e, y)) throw new d(u);
			return t.facade = e, a(e, y, t), t;
		}, m = function(e) {
			return o(e, y) ? e[y] : {};
		}, h = function(e) {
			return o(e, y);
		};
	}
	t.exports = {
		set: p,
		get: m,
		has: h,
		enforce: g,
		getterFor: _
	};
})), zm = /* @__PURE__ */ s(((e, t) => {
	var n = Zp(), r = Gp(), i = rm(), a = xm(), o = Kp(), s = Nm().CONFIGURABLE, c = Pm(), l = Rm(), u = l.enforce, d = l.get, f = String, p = Object.defineProperty, m = n("".slice), h = n("".replace), g = n([].join), _ = o && !r(function() {
		return p(function() {}, "length", { value: 8 }).length !== 8;
	}), v = String(String).split("String"), y = t.exports = function(e, t, n) {
		m(f(t), 0, 7) === "Symbol(" && (t = "[" + h(f(t), /^Symbol\(([^)]*)\).*$/, "$1") + "]"), n && n.getter && (t = "get " + t), n && n.setter && (t = "set " + t), (!a(e, "name") || s && e.name !== t) && (o ? p(e, "name", {
			value: t,
			configurable: !0
		}) : e.name = t), _ && n && a(n, "arity") && e.length !== n.arity && p(e, "length", { value: n.arity });
		try {
			n && a(n, "constructor") && n.constructor ? o && p(e, "prototype", { writable: !1 }) : e.prototype &&= void 0;
		} catch {}
		var r = u(e);
		return a(r, "source") || (r.source = g(v, typeof t == "string" ? t : "")), e;
	};
	Function.prototype.toString = y(function() {
		return i(this) && d(this).source || c(this);
	}, "toString");
})), Bm = /* @__PURE__ */ s(((e, t) => {
	var n = rm(), r = jm(), i = zm(), a = _m();
	t.exports = function(e, t, o, s) {
		s ||= {};
		var c = s.enumerable, l = s.name === void 0 ? t : s.name;
		if (n(o) && i(o, l, s), s.global) c ? e[t] = o : a(t, o);
		else {
			try {
				s.unsafe ? e[t] && (c = !0) : delete e[t];
			} catch {}
			c ? e[t] = o : r.f(e, t, {
				value: o,
				enumerable: !1,
				configurable: !s.nonConfigurable,
				writable: !s.nonWritable
			});
		}
		return e;
	};
})), Vm = /* @__PURE__ */ s(((e, t) => {
	var n = Math.ceil, r = Math.floor;
	t.exports = Math.trunc || function(e) {
		var t = +e;
		return (t > 0 ? r : n)(t);
	};
})), Hm = /* @__PURE__ */ s(((e, t) => {
	var n = Vm();
	t.exports = function(e) {
		var t = +e;
		return t !== t || t === 0 ? 0 : n(t);
	};
})), Um = /* @__PURE__ */ s(((e, t) => {
	var n = Hm(), r = Math.max, i = Math.min;
	t.exports = function(e, t) {
		var a = n(e);
		return a < 0 ? r(a + t, 0) : i(a, t);
	};
})), Wm = /* @__PURE__ */ s(((e, t) => {
	var n = Hm(), r = Math.min;
	t.exports = function(e) {
		var t = n(e);
		return t > 0 ? r(t, 9007199254740991) : 0;
	};
})), Gm = /* @__PURE__ */ s(((e, t) => {
	var n = Wm();
	t.exports = function(e) {
		return n(e.length);
	};
})), Km = /* @__PURE__ */ s(((e, t) => {
	var n = nm(), r = Um(), i = Gm(), a = function(e) {
		return function(t, a, o) {
			var s = n(t), c = i(s);
			if (c === 0) return !e && -1;
			var l = r(o, c), u;
			if (e && a !== a) {
				for (; c > l;) if (u = s[l++], u !== u) return !0;
			} else for (; c > l; l++) if ((e || l in s) && s[l] === a) return e || l || 0;
			return !e && -1;
		};
	};
	t.exports = {
		includes: a(!0),
		indexOf: a(!1)
	};
})), qm = /* @__PURE__ */ s(((e, t) => {
	var n = Zp(), r = xm(), i = nm(), a = Km().indexOf, o = Lm(), s = n([].push);
	t.exports = function(e, t) {
		var n = i(e), c = 0, l = [], u;
		for (u in n) !r(o, u) && r(n, u) && s(l, u);
		for (; t.length > c;) r(n, u = t[c++]) && (~a(l, u) || s(l, u));
		return l;
	};
})), Jm = /* @__PURE__ */ s(((e, t) => {
	t.exports = [
		"constructor",
		"hasOwnProperty",
		"isPrototypeOf",
		"propertyIsEnumerable",
		"toLocaleString",
		"toString",
		"valueOf"
	];
})), Ym = /* @__PURE__ */ s(((e) => {
	var t = qm(), n = Jm().concat("length", "prototype");
	e.f = Object.getOwnPropertyNames || function(e) {
		return t(e, n);
	};
})), Xm = /* @__PURE__ */ s(((e) => {
	e.f = Object.getOwnPropertySymbols;
})), Zm = /* @__PURE__ */ s(((e, t) => {
	var n = am(), r = Zp(), i = Ym(), a = Xm(), o = Am(), s = r([].concat);
	t.exports = n("Reflect", "ownKeys") || function(e) {
		var t = i.f(o(e)), n = a.f;
		return n ? s(t, n(e)) : t;
	};
})), Qm = /* @__PURE__ */ s(((e, t) => {
	var n = xm(), r = Zm(), i = Om(), a = jm();
	t.exports = function(e, t, o) {
		for (var s = r(t), c = a.f, l = i.f, u = 0; u < s.length; u++) {
			var d = s[u];
			!n(e, d) && !(o && n(o, d)) && c(e, d, l(t, d));
		}
	};
})), $m = /* @__PURE__ */ s(((e, t) => {
	var n = Gp(), r = rm(), i = /#|\.prototype\./, a = function(e, t) {
		var i = s[o(e)];
		return i === l ? !0 : i === c ? !1 : r(t) ? n(t) : !!t;
	}, o = a.normalize = function(e) {
		return String(e).replace(i, ".").toLowerCase();
	}, s = a.data = {}, c = a.NATIVE = "N", l = a.POLYFILL = "P";
	t.exports = a;
})), eh = /* @__PURE__ */ s(((e, t) => {
	var n = Wp(), r = Om().f, i = Mm(), a = Bm(), o = _m(), s = Qm(), c = $m();
	t.exports = function(e, t) {
		var l = e.target, u = e.global, d = e.stat, f, p = u ? n : d ? n[l] || o(l, {}) : n[l] && n[l].prototype, m, h, g, _;
		if (p) for (m in t) {
			if (g = t[m], e.dontCallGetSet ? (_ = r(p, m), h = _ && _.value) : h = p[m], f = c(u ? m : l + (d ? "." : "#") + m, e.forced), !f && h !== void 0) {
				if (typeof g == typeof h) continue;
				s(g, h);
			}
			(e.sham || h && h.sham) && i(g, "sham", !0), a(p, m, g, e);
		}
	};
})), th = /* @__PURE__ */ s(((e, t) => {
	var n = Wp(), r = sm(), i = Qp(), a = function(e) {
		return r.slice(0, e.length) === e;
	};
	t.exports = (function() {
		return a("Bun/") ? "BUN" : a("Cloudflare-Workers") ? "CLOUDFLARE" : a("Deno/") ? "DENO" : a("Node.js/") ? "NODE" : n.Bun && typeof Bun.version == "string" ? "BUN" : n.Deno && typeof Deno.version == "object" ? "DENO" : i(n.process) === "process" ? "NODE" : n.window && n.document ? "BROWSER" : "REST";
	})();
})), nh = /* @__PURE__ */ s(((e, t) => {
	t.exports = th() === "NODE";
})), rh = /* @__PURE__ */ s(((e, t) => {
	t.exports = Wp();
})), ih = /* @__PURE__ */ s(((e, t) => {
	var n = Zp(), r = pm();
	t.exports = function(e, t, i) {
		try {
			return n(r(Object.getOwnPropertyDescriptor(e, t)[i]));
		} catch {}
	};
})), ah = /* @__PURE__ */ s(((e, t) => {
	var n = im();
	t.exports = function(e) {
		return n(e) || e === null;
	};
})), oh = /* @__PURE__ */ s(((e, t) => {
	var n = ah(), r = String, i = TypeError;
	t.exports = function(e) {
		if (n(e)) return e;
		throw new i("Can't set " + r(e) + " as a prototype");
	};
})), sh = /* @__PURE__ */ s(((e, t) => {
	var n = ih(), r = im(), i = tm(), a = oh();
	t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
		var e = !1, t = {}, o;
		try {
			o = n(Object.prototype, "__proto__", "set"), o(t, []), e = t instanceof Array;
		} catch {}
		return function(t, n) {
			return i(t), a(n), r(t) && (e ? o(t, n) : t.__proto__ = n), t;
		};
	}() : void 0);
})), ch = /* @__PURE__ */ s(((e, t) => {
	var n = jm().f, r = xm(), i = Cm()("toStringTag");
	t.exports = function(e, t, a) {
		e && !a && (e = e.prototype), e && !r(e, i) && n(e, i, {
			configurable: !0,
			value: t
		});
	};
})), lh = /* @__PURE__ */ s(((e, t) => {
	var n = zm(), r = jm();
	t.exports = function(e, t, i) {
		return i.get && n(i.get, t, { getter: !0 }), i.set && n(i.set, t, { setter: !0 }), r.f(e, t, i);
	};
})), uh = /* @__PURE__ */ s(((e, t) => {
	var n = am(), r = lh(), i = Cm(), a = Kp(), o = i("species");
	t.exports = function(e) {
		var t = n(e);
		a && t && !t[o] && r(t, o, {
			configurable: !0,
			get: function() {
				return this;
			}
		});
	};
})), dh = /* @__PURE__ */ s(((e, t) => {
	var n = om(), r = TypeError;
	t.exports = function(e, t) {
		if (n(t, e)) return e;
		throw new r("Incorrect invocation");
	};
})), fh = /* @__PURE__ */ s(((e, t) => {
	var n = Cm()("toStringTag"), r = {};
	r[n] = "z", t.exports = String(r) === "[object z]";
})), ph = /* @__PURE__ */ s(((e, t) => {
	var n = fh(), r = rm(), i = Qp(), a = Cm()("toStringTag"), o = Object, s = i(function() {
		return arguments;
	}()) === "Arguments", c = function(e, t) {
		try {
			return e[t];
		} catch {}
	};
	t.exports = n ? i : function(e) {
		var t, n, l;
		return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (n = c(t = o(e), a)) == "string" ? n : s ? i(t) : (l = i(t)) === "Object" && r(t.callee) ? "Arguments" : l;
	};
})), mh = /* @__PURE__ */ s(((e, t) => {
	var n = Zp(), r = Gp(), i = rm(), a = ph(), o = am(), s = Pm(), c = function() {}, l = o("Reflect", "construct"), u = /^\s*(?:class|function)\b/, d = n(u.exec), f = !u.test(c), p = function(e) {
		if (!i(e)) return !1;
		try {
			return l(c, [], e), !0;
		} catch {
			return !1;
		}
	}, m = function(e) {
		if (!i(e)) return !1;
		switch (a(e)) {
			case "AsyncFunction":
			case "GeneratorFunction":
			case "AsyncGeneratorFunction": return !1;
		}
		try {
			return f || !!d(u, s(e));
		} catch {
			return !0;
		}
	};
	m.sham = !0, t.exports = !l || r(function() {
		var e;
		return p(p.call) || !p(Object) || !p(function() {
			e = !0;
		}) || e;
	}) ? m : p;
})), hh = /* @__PURE__ */ s(((e, t) => {
	var n = mh(), r = fm(), i = TypeError;
	t.exports = function(e) {
		if (n(e)) return e;
		throw new i(r(e) + " is not a constructor");
	};
})), gh = /* @__PURE__ */ s(((e, t) => {
	var n = Am(), r = hh(), i = em(), a = Cm()("species");
	t.exports = function(e, t) {
		var o = n(e).constructor, s;
		return o === void 0 || i(s = n(o)[a]) ? t : r(s);
	};
})), _h = /* @__PURE__ */ s(((e, t) => {
	var n = qp(), r = Function.prototype, i = r.apply, a = r.call;
	t.exports = typeof Reflect == "object" && Reflect.apply || (n ? a.bind(i) : function() {
		return a.apply(i, arguments);
	});
})), vh = /* @__PURE__ */ s(((e, t) => {
	var n = Qp(), r = Zp();
	t.exports = function(e) {
		if (n(e) === "Function") return r(e);
	};
})), yh = /* @__PURE__ */ s(((e, t) => {
	var n = vh(), r = pm(), i = qp(), a = n(n.bind);
	t.exports = function(e, t) {
		return r(e), t === void 0 ? e : i ? a(e, t) : function() {
			return e.apply(t, arguments);
		};
	};
})), bh = /* @__PURE__ */ s(((e, t) => {
	t.exports = am()("document", "documentElement");
})), xh = /* @__PURE__ */ s(((e, t) => {
	t.exports = Zp()([].slice);
})), Sh = /* @__PURE__ */ s(((e, t) => {
	var n = TypeError;
	t.exports = function(e, t) {
		if (e < t) throw new n("Not enough arguments");
		return e;
	};
})), Ch = /* @__PURE__ */ s(((e, t) => {
	var n = sm();
	t.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(n);
})), wh = /* @__PURE__ */ s(((e, t) => {
	var n = Wp(), r = _h(), i = yh(), a = rm(), o = xm(), s = Gp(), c = bh(), l = xh(), u = Em(), d = Sh(), f = Ch(), p = nh(), m = n.setImmediate, h = n.clearImmediate, g = n.process, _ = n.Dispatch, v = n.Function, y = n.MessageChannel, b = n.String, x = 0, S = {}, C = "onreadystatechange", w, T, E, D;
	s(function() {
		w = n.location;
	});
	var O = function(e) {
		if (o(S, e)) {
			var t = S[e];
			delete S[e], t();
		}
	}, k = function(e) {
		return function() {
			O(e);
		};
	}, A = function(e) {
		O(e.data);
	}, j = function(e) {
		n.postMessage(b(e), w.protocol + "//" + w.host);
	};
	(!m || !h) && (m = function(e) {
		d(arguments.length, 1);
		var t = a(e) ? e : v(e), n = l(arguments, 1);
		return S[++x] = function() {
			r(t, void 0, n);
		}, T(x), x;
	}, h = function(e) {
		delete S[e];
	}, p ? T = function(e) {
		g.nextTick(k(e));
	} : _ && _.now ? T = function(e) {
		_.now(k(e));
	} : y && !f ? (E = new y(), D = E.port2, E.port1.onmessage = A, T = i(D.postMessage, D)) : n.addEventListener && a(n.postMessage) && !n.importScripts && w && w.protocol !== "file:" && !s(j) ? (T = j, n.addEventListener("message", A, !1)) : T = C in u("script") ? function(e) {
		c.appendChild(u("script"))[C] = function() {
			c.removeChild(this), O(e);
		};
	} : function(e) {
		setTimeout(k(e), 0);
	}), t.exports = {
		set: m,
		clear: h
	};
})), Th = /* @__PURE__ */ s(((e, t) => {
	var n = Wp(), r = Kp(), i = Object.getOwnPropertyDescriptor;
	t.exports = function(e) {
		if (!r) return n[e];
		var t = i(n, e);
		return t && t.value;
	};
})), Eh = /* @__PURE__ */ s(((e, t) => {
	var n = function() {
		this.head = null, this.tail = null;
	};
	n.prototype = {
		add: function(e) {
			var t = {
				item: e,
				next: null
			}, n = this.tail;
			n ? n.next = t : this.head = t, this.tail = t;
		},
		get: function() {
			var e = this.head;
			if (e) return (this.head = e.next) === null && (this.tail = null), e.item;
		}
	}, t.exports = n;
})), Dh = /* @__PURE__ */ s(((e, t) => {
	var n = sm();
	t.exports = /ipad|iphone|ipod/i.test(n) && typeof Pebble < "u";
})), Oh = /* @__PURE__ */ s(((e, t) => {
	var n = sm();
	t.exports = /web0s(?!.*chrome)/i.test(n);
})), kh = /* @__PURE__ */ s(((e, t) => {
	var n = Wp(), r = Th(), i = yh(), a = wh().set, o = Eh(), s = Ch(), c = Dh(), l = Oh(), u = nh(), d = n.MutationObserver || n.WebKitMutationObserver, f = n.document, p = n.process, m = n.Promise, h = r("queueMicrotask"), g, _, v, y, b;
	if (!h) {
		var x = new o(), S = function() {
			var e, t;
			for (u && (e = p.domain) && e.exit(); t = x.get();) try {
				t();
			} catch (e) {
				throw x.head && g(), e;
			}
			e && e.enter();
		};
		!s && !u && !l && d && f ? (_ = !0, v = f.createTextNode(""), new d(S).observe(v, { characterData: !0 }), g = function() {
			v.data = _ = !_;
		}) : !c && m && m.resolve ? (y = m.resolve(void 0), y.constructor = m, b = i(y.then, y), g = function() {
			b(S);
		}) : u ? g = function() {
			p.nextTick(S);
		} : (a = i(a, n), g = function() {
			a(S);
		}), h = function(e) {
			x.head || g(), x.add(e);
		};
	}
	t.exports = h;
})), Ah = /* @__PURE__ */ s(((e, t) => {
	t.exports = function(e, t) {
		try {
			arguments.length === 1 ? console.error(e) : console.error(e, t);
		} catch {}
	};
})), jh = /* @__PURE__ */ s(((e, t) => {
	t.exports = function(e) {
		try {
			return {
				error: !1,
				value: e()
			};
		} catch (e) {
			return {
				error: !0,
				value: e
			};
		}
	};
})), Mh = /* @__PURE__ */ s(((e, t) => {
	t.exports = Wp().Promise;
})), Nh = /* @__PURE__ */ s(((e, t) => {
	var n = Wp(), r = Mh(), i = rm(), a = $m(), o = Pm(), s = Cm(), c = th(), l = gm(), u = cm(), d = r && r.prototype, f = s("species"), p = !1, m = i(n.PromiseRejectionEvent);
	t.exports = {
		CONSTRUCTOR: a("Promise", function() {
			var e = o(r), t = e !== String(r);
			if (!t && u === 66 || l && !(d.catch && d.finally)) return !0;
			if (!u || u < 51 || !/native code/.test(e)) {
				var n = new r(function(e) {
					e(1);
				}), i = function(e) {
					e(function() {}, function() {});
				}, a = n.constructor = {};
				if (a[f] = i, p = n.then(function() {}) instanceof i, !p) return !0;
			}
			return !t && (c === "BROWSER" || c === "DENO") && !m;
		}),
		REJECTION_EVENT: m,
		SUBCLASSING: p
	};
})), Ph = /* @__PURE__ */ s(((e, t) => {
	var n = pm(), r = TypeError, i = function(e) {
		var t, i;
		this.promise = new e(function(e, n) {
			if (t !== void 0 || i !== void 0) throw new r("Bad Promise constructor");
			t = e, i = n;
		}), this.resolve = n(t), this.reject = n(i);
	};
	t.exports.f = function(e) {
		return new i(e);
	};
})), Fh = /* @__PURE__ */ s((() => {
	var e = eh(), t = gm(), n = nh(), r = Wp(), i = rh(), a = Jp(), o = Bm(), s = sh(), c = ch(), l = uh(), u = pm(), d = rm(), f = im(), p = dh(), m = gh(), h = wh().set, g = kh(), _ = Ah(), v = jh(), y = Eh(), b = Rm(), x = Mh(), S = Nh(), C = Ph(), w = "Promise", T = S.CONSTRUCTOR, E = S.REJECTION_EVENT, D = S.SUBCLASSING, O = b.getterFor(w), k = b.set, A = x && x.prototype, j = x, M = A, N = r.TypeError, P = r.document, F = r.process, I = C.f, ee = I, L = !!(P && P.createEvent && r.dispatchEvent), R = "unhandledrejection", te = "rejectionhandled", z = 0, ne = 1, re = 2, ie = 1, ae = 2, B, oe, se, ce, le = function(e) {
		var t;
		return f(e) && d(t = e.then) ? t : !1;
	}, V = function(e, t) {
		var n = t.value, r = t.state === ne, i = r ? e.ok : e.fail, o = e.resolve, s = e.reject, c = e.domain, l, u, d;
		try {
			i ? (r || (t.rejection === ae && me(t), t.rejection = ie), i === !0 ? l = n : (c && c.enter(), l = i(n), c && (c.exit(), d = !0)), l === e.promise ? s(new N("Promise-chain cycle")) : (u = le(l)) ? a(u, l, o, s) : o(l)) : s(n);
		} catch (e) {
			c && !d && c.exit(), s(e);
		}
	}, ue = function(e, t) {
		e.notified || (e.notified = !0, g(function() {
			for (var n = e.reactions, r; r = n.get();) V(r, e);
			e.notified = !1, t && !e.rejection && fe(e);
		}));
	}, de = function(e, t, n) {
		var i, a;
		L ? (i = P.createEvent("Event"), i.promise = t, i.reason = n, i.initEvent(e, !1, !0), r.dispatchEvent(i)) : i = {
			promise: t,
			reason: n
		}, !E && (a = r["on" + e]) ? a(i) : e === R && _("Unhandled promise rejection", n);
	}, fe = function(e) {
		a(h, r, function() {
			var t = e.facade, r = e.value, i = pe(e), a;
			if (i && (a = v(function() {
				n ? F.emit("unhandledRejection", r, t) : de(R, t, r);
			}), e.rejection = n || pe(e) ? ae : ie, a.error)) throw a.value;
		});
	}, pe = function(e) {
		return e.rejection !== ie && !e.parent;
	}, me = function(e) {
		a(h, r, function() {
			var t = e.facade;
			n ? F.emit("rejectionHandled", t) : de(te, t, e.value);
		});
	}, he = function(e, t, n) {
		return function(r) {
			e(t, r, n);
		};
	}, ge = function(e, t, n) {
		e.done || (e.done = !0, n && (e = n), e.value = t, e.state = re, ue(e, !0));
	}, _e = function(e, t, n) {
		if (!e.done) {
			e.done = !0, n && (e = n);
			try {
				if (e.facade === t) throw new N("Promise can't be resolved itself");
				var r = le(t);
				r ? g(function() {
					var n = { done: !1 };
					try {
						a(r, t, he(_e, n, e), he(ge, n, e));
					} catch (t) {
						ge(n, t, e);
					}
				}) : (e.value = t, e.state = ne, ue(e, !1));
			} catch (t) {
				ge({ done: !1 }, t, e);
			}
		}
	};
	if (T && (j = function(e) {
		p(this, M), u(e), a(B, this);
		var t = O(this);
		try {
			e(he(_e, t), he(ge, t));
		} catch (e) {
			ge(t, e);
		}
	}, M = j.prototype, B = function(e) {
		k(this, {
			type: w,
			done: !1,
			notified: !1,
			parent: !1,
			reactions: new y(),
			rejection: !1,
			state: z,
			value: null
		});
	}, B.prototype = o(M, "then", function(e, t) {
		var r = O(this), i = I(m(this, j));
		return r.parent = !0, i.ok = !d(e) || e, i.fail = d(t) && t, i.domain = n ? F.domain : void 0, r.state === z ? r.reactions.add(i) : g(function() {
			V(i, r);
		}), i.promise;
	}), oe = function() {
		var e = new B(), t = O(e);
		this.promise = e, this.resolve = he(_e, t), this.reject = he(ge, t);
	}, C.f = I = function(e) {
		return e === j || e === se ? new oe(e) : ee(e);
	}, !t && d(x) && A !== Object.prototype)) {
		ce = A.then, D || o(A, "then", function(e, t) {
			var n = this;
			return new j(function(e, t) {
				a(ce, n, e, t);
			}).then(e, t);
		}, { unsafe: !0 });
		try {
			delete A.constructor;
		} catch {}
		s && s(A, M);
	}
	e({
		global: !0,
		constructor: !0,
		wrap: !0,
		forced: T
	}, { Promise: j }), se = i.Promise, c(j, w, !1, !0), l(w);
})), Ih = /* @__PURE__ */ s(((e, t) => {
	t.exports = {};
})), Lh = /* @__PURE__ */ s(((e, t) => {
	var n = Cm(), r = Ih(), i = n("iterator"), a = Array.prototype;
	t.exports = function(e) {
		return e !== void 0 && (r.Array === e || a[i] === e);
	};
})), Rh = /* @__PURE__ */ s(((e, t) => {
	var n = ph(), r = mm(), i = em(), a = Ih(), o = Cm()("iterator");
	t.exports = function(e) {
		if (!i(e)) return r(e, o) || r(e, "@@iterator") || a[n(e)];
	};
})), zh = /* @__PURE__ */ s(((e, t) => {
	var n = Jp(), r = pm(), i = Am(), a = fm(), o = Rh(), s = TypeError;
	t.exports = function(e, t) {
		var c = arguments.length < 2 ? o(e) : t;
		if (r(c)) return i(n(c, e));
		throw new s(a(e) + " is not iterable");
	};
})), Bh = /* @__PURE__ */ s(((e, t) => {
	var n = Jp(), r = Am(), i = mm();
	t.exports = function(e, t, a) {
		var o, s;
		r(e);
		try {
			if (o = i(e, "return"), !o) {
				if (t === "throw") throw a;
				return a;
			}
			o = n(o, e);
		} catch (e) {
			s = !0, o = e;
		}
		if (t === "throw") throw a;
		if (s) throw o;
		return r(o), a;
	};
})), Vh = /* @__PURE__ */ s(((e, t) => {
	var n = yh(), r = Jp(), i = Am(), a = fm(), o = Lh(), s = Gm(), c = om(), l = zh(), u = Rh(), d = Bh(), f = TypeError, p = function(e, t) {
		this.stopped = e, this.result = t;
	}, m = p.prototype;
	t.exports = function(e, t, h) {
		var g = h && h.that, _ = !!(h && h.AS_ENTRIES), v = !!(h && h.IS_RECORD), y = !!(h && h.IS_ITERATOR), b = !!(h && h.INTERRUPTED), x = n(t, g), S, C, w, T, E, D, O, k = function(e) {
			return S && d(S, "normal"), new p(!0, e);
		}, A = function(e) {
			return _ ? (i(e), b ? x(e[0], e[1], k) : x(e[0], e[1])) : b ? x(e, k) : x(e);
		};
		if (v) S = e.iterator;
		else if (y) S = e;
		else {
			if (C = u(e), !C) throw new f(a(e) + " is not iterable");
			if (o(C)) {
				for (w = 0, T = s(e); T > w; w++) if (E = A(e[w]), E && c(m, E)) return E;
				return new p(!1);
			}
			S = l(e, C);
		}
		for (D = v ? e.next : S.next; !(O = r(D, S)).done;) {
			try {
				E = A(O.value);
			} catch (e) {
				d(S, "throw", e);
			}
			if (typeof E == "object" && E && c(m, E)) return E;
		}
		return new p(!1);
	};
})), Hh = /* @__PURE__ */ s(((e, t) => {
	var n = Cm()("iterator"), r = !1;
	try {
		var i = 0, a = {
			next: function() {
				return { done: !!i++ };
			},
			return: function() {
				r = !0;
			}
		};
		a[n] = function() {
			return this;
		}, Array.from(a, function() {
			throw 2;
		});
	} catch {}
	t.exports = function(e, t) {
		try {
			if (!t && !r) return !1;
		} catch {
			return !1;
		}
		var i = !1;
		try {
			var a = {};
			a[n] = function() {
				return { next: function() {
					return { done: i = !0 };
				} };
			}, e(a);
		} catch {}
		return i;
	};
})), Uh = /* @__PURE__ */ s(((e, t) => {
	var n = Mh(), r = Hh();
	t.exports = Nh().CONSTRUCTOR || !r(function(e) {
		n.all(e).then(void 0, function() {});
	});
})), Wh = /* @__PURE__ */ s((() => {
	var e = eh(), t = Jp(), n = pm(), r = Ph(), i = jh(), a = Vh();
	e({
		target: "Promise",
		stat: !0,
		forced: Uh()
	}, { all: function(e) {
		var o = this, s = r.f(o), c = s.resolve, l = s.reject, u = i(function() {
			var r = n(o.resolve), i = [], s = 0, u = 1;
			a(e, function(e) {
				var n = s++, a = !1;
				u++, t(r, o, e).then(function(e) {
					a || (a = !0, i[n] = e, --u || c(i));
				}, l);
			}), --u || c(i);
		});
		return u.error && l(u.value), s.promise;
	} });
})), Gh = /* @__PURE__ */ s((() => {
	var e = eh(), t = gm(), n = Nh().CONSTRUCTOR, r = Mh(), i = am(), a = rm(), o = Bm(), s = r && r.prototype;
	if (e({
		target: "Promise",
		proto: !0,
		forced: n,
		real: !0
	}, { catch: function(e) {
		return this.then(void 0, e);
	} }), !t && a(r)) {
		var c = i("Promise").prototype.catch;
		s.catch !== c && o(s, "catch", c, { unsafe: !0 });
	}
})), Kh = /* @__PURE__ */ s((() => {
	var e = eh(), t = Jp(), n = pm(), r = Ph(), i = jh(), a = Vh();
	e({
		target: "Promise",
		stat: !0,
		forced: Uh()
	}, { race: function(e) {
		var o = this, s = r.f(o), c = s.reject, l = i(function() {
			var r = n(o.resolve);
			a(e, function(e) {
				t(r, o, e).then(s.resolve, c);
			});
		});
		return l.error && c(l.value), s.promise;
	} });
})), qh = /* @__PURE__ */ s((() => {
	var e = eh(), t = Ph(), n = Nh().CONSTRUCTOR;
	e({
		target: "Promise",
		stat: !0,
		forced: n
	}, { reject: function(e) {
		var n = t.f(this), r = n.reject;
		return r(e), n.promise;
	} });
})), Jh = /* @__PURE__ */ s(((e, t) => {
	var n = Am(), r = im(), i = Ph();
	t.exports = function(e, t) {
		if (n(e), r(t) && t.constructor === e) return t;
		var a = i.f(e), o = a.resolve;
		return o(t), a.promise;
	};
})), Yh = /* @__PURE__ */ s((() => {
	var e = eh(), t = am(), n = gm(), r = Mh(), i = Nh().CONSTRUCTOR, a = Jh(), o = t("Promise"), s = n && !i;
	e({
		target: "Promise",
		stat: !0,
		forced: n || i
	}, { resolve: function(e) {
		return a(s && this === o ? r : this, e);
	} });
})), Xh = /* @__PURE__ */ s((() => {
	Fh(), Wh(), Gh(), Kh(), qh(), Yh();
}));
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
function Zh(e, t, n, r, i, a, o) {
	try {
		var s = e[a](o), c = s.value;
	} catch (e) {
		n(e);
		return;
	}
	s.done ? t(c) : Promise.resolve(c).then(r, i);
}
function Qh(e) {
	return function() {
		var t = this, n = arguments;
		return new Promise(function(r, i) {
			var a = e.apply(t, n);
			function o(e) {
				Zh(a, r, i, o, s, "next", e);
			}
			function s(e) {
				Zh(a, r, i, o, s, "throw", e);
			}
			o(void 0);
		});
	};
}
var $h = o((() => {})), eg = /* @__PURE__ */ s(((e, t) => {
	var n = ph(), r = String;
	t.exports = function(e) {
		if (n(e) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
		return r(e);
	};
})), tg = /* @__PURE__ */ s(((e, t) => {
	var n = Am();
	t.exports = function() {
		var e = n(this), t = "";
		return e.hasIndices && (t += "d"), e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.dotAll && (t += "s"), e.unicode && (t += "u"), e.unicodeSets && (t += "v"), e.sticky && (t += "y"), t;
	};
})), ng = /* @__PURE__ */ s(((e, t) => {
	var n = Gp(), r = Wp().RegExp, i = n(function() {
		var e = r("a", "y");
		return e.lastIndex = 2, e.exec("abcd") !== null;
	}), a = i || n(function() {
		return !r("a", "y").sticky;
	});
	t.exports = {
		BROKEN_CARET: i || n(function() {
			var e = r("^r", "gy");
			return e.lastIndex = 2, e.exec("str") !== null;
		}),
		MISSED_STICKY: a,
		UNSUPPORTED_Y: i
	};
})), rg = /* @__PURE__ */ s(((e, t) => {
	var n = qm(), r = Jm();
	t.exports = Object.keys || function(e) {
		return n(e, r);
	};
})), ig = /* @__PURE__ */ s(((e) => {
	var t = Kp(), n = km(), r = jm(), i = Am(), a = nm(), o = rg();
	e.f = t && !n ? Object.defineProperties : function(e, t) {
		i(e);
		for (var n = a(t), s = o(t), c = s.length, l = 0, u; c > l;) r.f(e, u = s[l++], n[u]);
		return e;
	};
})), ag = /* @__PURE__ */ s(((e, t) => {
	var n = Am(), r = ig(), i = Jm(), a = Lm(), o = bh(), s = Em(), c = Im(), l = ">", u = "<", d = "prototype", f = "script", p = c("IE_PROTO"), m = function() {}, h = function(e) {
		return u + f + l + e + u + "/" + f + l;
	}, g = function(e) {
		e.write(h("")), e.close();
		var t = e.parentWindow.Object;
		return e = null, t;
	}, _ = function() {
		var e = s("iframe"), t = "java" + f + ":", n;
		return e.style.display = "none", o.appendChild(e), e.src = String(t), n = e.contentWindow.document, n.open(), n.write(h("document.F=Object")), n.close(), n.F;
	}, v, y = function() {
		try {
			v = new ActiveXObject("htmlfile");
		} catch {}
		y = typeof document < "u" ? document.domain && v ? g(v) : _() : g(v);
		for (var e = i.length; e--;) delete y[d][i[e]];
		return y();
	};
	a[p] = !0, t.exports = Object.create || function(e, t) {
		var i;
		return e === null ? i = y() : (m[d] = n(e), i = new m(), m[d] = null, i[p] = e), t === void 0 ? i : r.f(i, t);
	};
})), og = /* @__PURE__ */ s(((e, t) => {
	var n = Gp(), r = Wp().RegExp;
	t.exports = n(function() {
		var e = r(".", "s");
		return !(e.dotAll && e.test("\n") && e.flags === "s");
	});
})), sg = /* @__PURE__ */ s(((e, t) => {
	var n = Gp(), r = Wp().RegExp;
	t.exports = n(function() {
		var e = r("(?<a>b)", "g");
		return e.exec("b").groups.a !== "b" || "b".replace(e, "$<a>c") !== "bc";
	});
})), cg = /* @__PURE__ */ s(((e, t) => {
	var n = Jp(), r = Zp(), i = eg(), a = tg(), o = ng(), s = ym(), c = ag(), l = Rm().get, u = og(), d = sg(), f = s("native-string-replace", String.prototype.replace), p = RegExp.prototype.exec, m = p, h = r("".charAt), g = r("".indexOf), _ = r("".replace), v = r("".slice), y = (function() {
		var e = /a/, t = /b*/g;
		return n(p, e, "a"), n(p, t, "a"), e.lastIndex !== 0 || t.lastIndex !== 0;
	})(), b = o.BROKEN_CARET, x = /()??/.exec("")[1] !== void 0;
	(y || x || b || u || d) && (m = function(e) {
		var t = this, r = l(t), o = i(e), s = r.raw, u, d, S, C, w, T, E;
		if (s) return s.lastIndex = t.lastIndex, u = n(m, s, o), t.lastIndex = s.lastIndex, u;
		var D = r.groups, O = b && t.sticky, k = n(a, t), A = t.source, j = 0, M = o;
		if (O && (k = _(k, "y", ""), g(k, "g") === -1 && (k += "g"), M = v(o, t.lastIndex), t.lastIndex > 0 && (!t.multiline || t.multiline && h(o, t.lastIndex - 1) !== "\n") && (A = "(?: " + A + ")", M = " " + M, j++), d = RegExp("^(?:" + A + ")", k)), x && (d = RegExp("^" + A + "$(?!\\s)", k)), y && (S = t.lastIndex), C = n(p, O ? d : t, M), O ? C ? (C.input = v(C.input, j), C[0] = v(C[0], j), C.index = t.lastIndex, t.lastIndex += C[0].length) : t.lastIndex = 0 : y && C && (t.lastIndex = t.global ? C.index + C[0].length : S), x && C && C.length > 1 && n(f, C[0], d, function() {
			for (w = 1; w < arguments.length - 2; w++) arguments[w] === void 0 && (C[w] = void 0);
		}), C && D) for (C.groups = T = c(null), w = 0; w < D.length; w++) E = D[w], T[E[0]] = C[E[1]];
		return C;
	}), t.exports = m;
})), lg = /* @__PURE__ */ s((() => {
	var e = eh(), t = cg();
	e({
		target: "RegExp",
		proto: !0,
		forced: /./.exec !== t
	}, { exec: t });
})), ug = /* @__PURE__ */ s(((e, t) => {
	lg();
	var n = Jp(), r = Bm(), i = cg(), a = Gp(), o = Cm(), s = Mm(), c = o("species"), l = RegExp.prototype;
	t.exports = function(e, t, u, d) {
		var f = o(e), p = !a(function() {
			var t = {};
			return t[f] = function() {
				return 7;
			}, ""[e](t) !== 7;
		}), m = p && !a(function() {
			var t = !1, n = /a/;
			if (e === "split") {
				var r = {};
				r[c] = function() {
					return n;
				}, n = {
					constructor: r,
					flags: ""
				}, n[f] = /./[f];
			}
			return n.exec = function() {
				return t = !0, null;
			}, n[f](""), !t;
		});
		if (!p || !m || u) {
			var h = /./[f], g = t(f, ""[e], function(e, t, r, a, o) {
				var s = t.exec;
				return s === i || s === l.exec ? p && !o ? {
					done: !0,
					value: n(h, t, r, a)
				} : {
					done: !0,
					value: n(e, r, t, a)
				} : { done: !1 };
			});
			r(String.prototype, e, g[0]), r(l, f, g[1]);
		}
		d && s(l[f], "sham", !0);
	};
})), dg = /* @__PURE__ */ s(((e, t) => {
	var n = Zp(), r = Hm(), i = eg(), a = tm(), o = n("".charAt), s = n("".charCodeAt), c = n("".slice), l = function(e) {
		return function(t, n) {
			var l = i(a(t)), u = r(n), d = l.length, f, p;
			return u < 0 || u >= d ? e ? "" : void 0 : (f = s(l, u), f < 55296 || f > 56319 || u + 1 === d || (p = s(l, u + 1)) < 56320 || p > 57343 ? e ? o(l, u) : f : e ? c(l, u, u + 2) : (f - 55296 << 10) + (p - 56320) + 65536);
		};
	};
	t.exports = {
		codeAt: l(!1),
		charAt: l(!0)
	};
})), fg = /* @__PURE__ */ s(((e, t) => {
	var n = dg().charAt;
	t.exports = function(e, t, r) {
		return t + (r ? n(e, t).length : 1);
	};
})), pg = /* @__PURE__ */ s(((e, t) => {
	var n = Wp(), r = Gp(), i = n.RegExp;
	t.exports = { correct: !r(function() {
		var e = !0;
		try {
			i(".", "d");
		} catch {
			e = !1;
		}
		var t = {}, n = "", r = e ? "dgimsy" : "gimsy", a = function(e, r) {
			Object.defineProperty(t, e, { get: function() {
				return n += r, !0;
			} });
		}, o = {
			dotAll: "s",
			global: "g",
			ignoreCase: "i",
			multiline: "m",
			sticky: "y"
		};
		for (var s in e && (o.hasIndices = "d"), o) a(s, o[s]);
		return Object.getOwnPropertyDescriptor(i.prototype, "flags").get.call(t) !== r || n !== r;
	}) };
})), mg = /* @__PURE__ */ s(((e, t) => {
	var n = Jp(), r = xm(), i = om(), a = pg(), o = tg(), s = RegExp.prototype;
	t.exports = a.correct ? function(e) {
		return e.flags;
	} : function(e) {
		return !a.correct && i(s, e) && !r(e, "flags") ? n(o, e) : e.flags;
	};
})), hg = /* @__PURE__ */ s(((e, t) => {
	var n = Jp(), r = Am(), i = rm(), a = Qp(), o = cg(), s = TypeError;
	t.exports = function(e, t) {
		var c = e.exec;
		if (i(c)) {
			var l = n(c, e, t);
			return l !== null && r(l), l;
		}
		if (a(e) === "RegExp") return n(o, e, t);
		throw new s("RegExp#exec called on incompatible receiver");
	};
})), gg = /* @__PURE__ */ s((() => {
	var e = Jp(), t = Zp(), n = ug(), r = Am(), i = im(), a = Wm(), o = eg(), s = tm(), c = mm(), l = fg(), u = mg(), d = hg(), f = t("".indexOf);
	n("match", function(t, n, p) {
		return [function(n) {
			var r = s(this), a = i(n) ? c(n, t) : void 0;
			return a ? e(a, n, r) : new RegExp(n)[t](o(r));
		}, function(e) {
			var t = r(this), i = o(e), s = p(n, t, i);
			if (s.done) return s.value;
			var c = o(u(t));
			if (f(c, "g") === -1) return d(t, i);
			var m = f(c, "u") !== -1;
			t.lastIndex = 0;
			for (var h = [], g = 0, _; (_ = d(t, i)) !== null;) {
				var v = o(_[0]);
				h[g] = v, v === "" && (t.lastIndex = l(i, a(t.lastIndex), m)), g++;
			}
			return g === 0 ? null : h;
		}];
	});
})), _g = /* @__PURE__ */ s(((e, t) => {
	var n = Zp(), r = bm(), i = Math.floor, a = n("".charAt), o = n("".replace), s = n("".slice), c = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, l = /\$([$&'`]|\d{1,2})/g;
	t.exports = function(e, t, n, u, d, f) {
		var p = n + e.length, m = u.length, h = l;
		return d !== void 0 && (d = r(d), h = c), o(f, h, function(r, o) {
			var c;
			switch (a(o, 0)) {
				case "$": return "$";
				case "&": return e;
				case "`": return s(t, 0, n);
				case "'": return s(t, p);
				case "<":
					c = d[s(o, 1, -1)];
					break;
				default:
					var l = +o;
					if (l === 0) return r;
					if (l > m) {
						var f = i(l / 10);
						return f === 0 ? r : f <= m ? u[f - 1] === void 0 ? a(o, 1) : u[f - 1] + a(o, 1) : r;
					}
					c = u[l - 1];
			}
			return c === void 0 ? "" : c;
		});
	};
})), vg = /* @__PURE__ */ s((() => {
	var e = _h(), t = Jp(), n = Zp(), r = ug(), i = Gp(), a = Am(), o = rm(), s = im(), c = Hm(), l = Wm(), u = eg(), d = tm(), f = fg(), p = mm(), m = _g(), h = mg(), g = hg(), _ = Cm()("replace"), v = Math.max, y = Math.min, b = n([].concat), x = n([].push), S = n("".indexOf), C = n("".slice), w = function(e) {
		return e === void 0 ? e : String(e);
	}, T = (function() {
		return "a".replace(/./, "$0") === "$0";
	})(), E = (function() {
		return /./[_] ? /./[_]("a", "$0") === "" : !1;
	})();
	r("replace", function(n, r, i) {
		var T = E ? "$" : "$0";
		return [function(e, n) {
			var i = d(this), a = s(e) ? p(e, _) : void 0;
			return a ? t(a, e, i, n) : t(r, u(i), e, n);
		}, function(t, n) {
			var s = a(this), d = u(t);
			if (typeof n == "string" && S(n, T) === -1 && S(n, "$<") === -1) {
				var p = i(r, s, d, n);
				if (p.done) return p.value;
			}
			var _ = o(n);
			_ || (n = u(n));
			var E = u(h(s)), D = S(E, "g") !== -1, O;
			D && (O = S(E, "u") !== -1, s.lastIndex = 0);
			for (var k = [], A; A = g(s, d), !(A === null || (x(k, A), !D));) u(A[0]) === "" && (s.lastIndex = f(d, l(s.lastIndex), O));
			for (var j = "", M = 0, N = 0; N < k.length; N++) {
				A = k[N];
				for (var P = u(A[0]), F = v(y(c(A.index), d.length), 0), I = [], ee, L = 1; L < A.length; L++) x(I, w(A[L]));
				var R = A.groups;
				if (_) {
					var te = b([P], I, F, d);
					R !== void 0 && x(te, R), ee = u(e(n, void 0, te));
				} else ee = m(P, d, F, I, R, n);
				F >= M && (j += C(d, M, F) + ee, M = F + P.length);
			}
			return j + C(d, M);
		}];
	}, !!i(function() {
		var e = /./;
		return e.exec = function() {
			var e = [];
			return e.groups = { a: "7" }, e;
		}, "".replace(e, "$<a>") !== "7";
	}) || !T || E);
})), yg = /* @__PURE__ */ s(((e, t) => {
	var n = im(), r = Qp(), i = Cm()("match");
	t.exports = function(e) {
		var t;
		return n(e) && ((t = e[i]) === void 0 ? r(e) === "RegExp" : !!t);
	};
})), bg = /* @__PURE__ */ s(((e, t) => {
	var n = yg(), r = TypeError;
	t.exports = function(e) {
		if (n(e)) throw new r("The method doesn't accept regular expressions");
		return e;
	};
})), xg = /* @__PURE__ */ s(((e, t) => {
	var n = Cm()("match");
	t.exports = function(e) {
		var t = /./;
		try {
			"/./"[e](t);
		} catch {
			try {
				return t[n] = !1, "/./"[e](t);
			} catch {}
		}
		return !1;
	};
})), Sg = /* @__PURE__ */ s((() => {
	var e = eh(), t = vh(), n = Om().f, r = Wm(), i = eg(), a = bg(), o = tm(), s = xg(), c = gm(), l = t("".slice), u = Math.min, d = s("startsWith");
	e({
		target: "String",
		proto: !0,
		forced: !(!c && !d && function() {
			var e = n(String.prototype, "startsWith");
			return e && !e.writable;
		}()) && !d
	}, { startsWith: function(e) {
		var t = i(o(this));
		a(e);
		var n = r(u(arguments.length > 1 ? arguments[1] : void 0, t.length)), s = i(e);
		return l(t, n, n + s.length) === s;
	} });
})), Cg = /* @__PURE__ */ s(((e, t) => {
	var n = Cm(), r = ag(), i = jm().f, a = n("unscopables"), o = Array.prototype;
	o[a] === void 0 && i(o, a, {
		configurable: !0,
		value: r(null)
	}), t.exports = function(e) {
		o[a][e] = !0;
	};
})), wg = /* @__PURE__ */ s(((e, t) => {
	t.exports = !Gp()(function() {
		function e() {}
		return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
	});
})), Tg = /* @__PURE__ */ s(((e, t) => {
	var n = xm(), r = rm(), i = bm(), a = Im(), o = wg(), s = a("IE_PROTO"), c = Object, l = c.prototype;
	t.exports = o ? c.getPrototypeOf : function(e) {
		var t = i(e);
		if (n(t, s)) return t[s];
		var a = t.constructor;
		return r(a) && t instanceof a ? a.prototype : t instanceof c ? l : null;
	};
})), Eg = /* @__PURE__ */ s(((e, t) => {
	var n = Gp(), r = rm(), i = im(), a = ag(), o = Tg(), s = Bm(), c = Cm(), l = gm(), u = c("iterator"), d = !1, f, p, m;
	[].keys && (m = [].keys(), "next" in m ? (p = o(o(m)), p !== Object.prototype && (f = p)) : d = !0), !i(f) || n(function() {
		var e = {};
		return f[u].call(e) !== e;
	}) ? f = {} : l && (f = a(f)), r(f[u]) || s(f, u, function() {
		return this;
	}), t.exports = {
		IteratorPrototype: f,
		BUGGY_SAFARI_ITERATORS: d
	};
})), Dg = /* @__PURE__ */ s(((e, t) => {
	var n = Eg().IteratorPrototype, r = ag(), i = Xp(), a = ch(), o = Ih(), s = function() {
		return this;
	};
	t.exports = function(e, t, c, l) {
		var u = t + " Iterator";
		return e.prototype = r(n, { next: i(+!l, c) }), a(e, u, !1, !0), o[u] = s, e;
	};
})), Og = /* @__PURE__ */ s(((e, t) => {
	var n = eh(), r = Jp(), i = gm(), a = Nm(), o = rm(), s = Dg(), c = Tg(), l = sh(), u = ch(), d = Mm(), f = Bm(), p = Cm(), m = Ih(), h = Eg(), g = a.PROPER, _ = a.CONFIGURABLE, v = h.IteratorPrototype, y = h.BUGGY_SAFARI_ITERATORS, b = p("iterator"), x = "keys", S = "values", C = "entries", w = function() {
		return this;
	};
	t.exports = function(e, t, a, p, h, T, E) {
		s(a, t, p);
		var D = function(e) {
			if (e === h && M) return M;
			if (!y && e && e in A) return A[e];
			switch (e) {
				case x: return function() {
					return new a(this, e);
				};
				case S: return function() {
					return new a(this, e);
				};
				case C: return function() {
					return new a(this, e);
				};
			}
			return function() {
				return new a(this);
			};
		}, O = t + " Iterator", k = !1, A = e.prototype, j = A[b] || A["@@iterator"] || h && A[h], M = !y && j || D(h), N = t === "Array" && A.entries || j, P, F, I;
		if (N && (P = c(N.call(new e())), P !== Object.prototype && P.next && (!i && c(P) !== v && (l ? l(P, v) : o(P[b]) || f(P, b, w)), u(P, O, !0, !0), i && (m[O] = w))), g && h === S && j && j.name !== S && (!i && _ ? d(A, "name", S) : (k = !0, M = function() {
			return r(j, this);
		})), h) if (F = {
			values: D(S),
			keys: T ? M : D(x),
			entries: D(C)
		}, E) for (I in F) (y || k || !(I in A)) && f(A, I, F[I]);
		else n({
			target: t,
			proto: !0,
			forced: y || k
		}, F);
		return (!i || E) && A[b] !== M && f(A, b, M, { name: h }), m[t] = M, F;
	};
})), kg = /* @__PURE__ */ s(((e, t) => {
	t.exports = function(e, t) {
		return {
			value: e,
			done: t
		};
	};
})), Ag = /* @__PURE__ */ s(((e, t) => {
	var n = nm(), r = Cg(), i = Ih(), a = Rm(), o = jm().f, s = Og(), c = kg(), l = gm(), u = Kp(), d = "Array Iterator", f = a.set, p = a.getterFor(d);
	t.exports = s(Array, "Array", function(e, t) {
		f(this, {
			type: d,
			target: n(e),
			index: 0,
			kind: t
		});
	}, function() {
		var e = p(this), t = e.target, n = e.index++;
		if (!t || n >= t.length) return e.target = null, c(void 0, !0);
		switch (e.kind) {
			case "keys": return c(n, !1);
			case "values": return c(t[n], !1);
		}
		return c([n, t[n]], !1);
	}, "values");
	var m = i.Arguments = i.Array;
	if (r("keys"), r("values"), r("entries"), !l && u && m.name !== "values") try {
		o(m, "name", { value: "values" });
	} catch {}
})), jg = /* @__PURE__ */ s(((e, t) => {
	t.exports = {
		CSSRuleList: 0,
		CSSStyleDeclaration: 0,
		CSSValueList: 0,
		ClientRectList: 0,
		DOMRectList: 0,
		DOMStringList: 0,
		DOMTokenList: 1,
		DataTransferItemList: 0,
		FileList: 0,
		HTMLAllCollection: 0,
		HTMLCollection: 0,
		HTMLFormElement: 0,
		HTMLSelectElement: 0,
		MediaList: 0,
		MimeTypeArray: 0,
		NamedNodeMap: 0,
		NodeList: 1,
		PaintRequestList: 0,
		Plugin: 0,
		PluginArray: 0,
		SVGLengthList: 0,
		SVGNumberList: 0,
		SVGPathSegList: 0,
		SVGPointList: 0,
		SVGStringList: 0,
		SVGTransformList: 0,
		SourceBufferList: 0,
		StyleSheetList: 0,
		TextTrackCueList: 0,
		TextTrackList: 0,
		TouchList: 0
	};
})), Mg = /* @__PURE__ */ s(((e, t) => {
	var n = Em()("span").classList, r = n && n.constructor && n.constructor.prototype;
	t.exports = r === Object.prototype ? void 0 : r;
})), Ng = /* @__PURE__ */ s((() => {
	var e = Wp(), t = jg(), n = Mg(), r = Ag(), i = Mm(), a = ch(), o = Cm()("iterator"), s = r.values, c = function(e, n) {
		if (e) {
			if (e[o] !== s) try {
				i(e, o, s);
			} catch {
				e[o] = s;
			}
			if (a(e, n, !0), t[n]) {
				for (var c in r) if (e[c] !== r[c]) try {
					i(e, c, r[c]);
				} catch {
					e[c] = r[c];
				}
			}
		}
	};
	for (var l in t) c(e[l] && e[l].prototype, l);
	c(n, "DOMTokenList");
}));
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/toPrimitive.js
function Pg(e, t) {
	if (Fa(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (Fa(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
var Fg = o((() => {}));
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/toPropertyKey.js
function Ig(e) {
	var t = Pg(e, "string");
	return Fa(t) == "symbol" ? t : t + "";
}
var Lg = o((() => {
	Ia(), Fg();
}));
//#endregion
//#region node_modules/@babel/runtime/helpers/esm/defineProperty.js
function Rg(e, t, n) {
	return (t = Ig(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
var zg = o((() => {
	Lg();
})), Bg = /* @__PURE__ */ s(((e, t) => {
	var n = pm(), r = bm(), i = $p(), a = Gm(), o = TypeError, s = "Reduce of empty array with no initial value", c = function(e) {
		return function(t, c, l, u) {
			var d = r(t), f = i(d), p = a(d);
			if (n(c), p === 0 && l < 2) throw new o(s);
			var m = e ? p - 1 : 0, h = e ? -1 : 1;
			if (l < 2) for (;;) {
				if (m in f) {
					u = f[m], m += h;
					break;
				}
				if (m += h, e ? m < 0 : p <= m) throw new o(s);
			}
			for (; e ? m >= 0 : p > m; m += h) m in f && (u = c(u, f[m], m, d));
			return u;
		};
	};
	t.exports = {
		left: c(!1),
		right: c(!0)
	};
})), Vg = /* @__PURE__ */ s(((e, t) => {
	var n = Gp();
	t.exports = function(e, t) {
		var r = [][e];
		return !!r && n(function() {
			r.call(null, t || function() {
				return 1;
			}, 1);
		});
	};
})), Hg = /* @__PURE__ */ s((() => {
	var e = eh(), t = Bg().left, n = Vg(), r = cm();
	e({
		target: "Array",
		proto: !0,
		forced: !nh() && r > 79 && r < 83 || !n("reduce")
	}, { reduce: function(e) {
		var n = arguments.length;
		return t(this, e, n, n > 1 ? arguments[1] : void 0);
	} });
})), Ug = /* @__PURE__ */ s((() => {
	var e = eh(), t = vh(), n = Om().f, r = Wm(), i = eg(), a = bg(), o = tm(), s = xg(), c = gm(), l = t("".slice), u = Math.min, d = s("endsWith");
	e({
		target: "String",
		proto: !0,
		forced: !(!c && !d && function() {
			var e = n(String.prototype, "endsWith");
			return e && !e.writable;
		}()) && !d
	}, { endsWith: function(e) {
		var t = i(o(this));
		a(e);
		var n = arguments.length > 1 ? arguments[1] : void 0, s = t.length, c = n === void 0 ? s : u(r(n), s), d = i(e);
		return l(t, c - d.length, c) === d;
	} });
})), Wg = /* @__PURE__ */ s((() => {
	var e = Jp(), t = Zp(), n = ug(), r = Am(), i = im(), a = tm(), o = gh(), s = fg(), c = Wm(), l = eg(), u = mm(), d = hg(), f = ng(), p = Gp(), m = f.UNSUPPORTED_Y, h = 4294967295, g = Math.min, _ = t([].push), v = t("".slice), y = !p(function() {
		var e = /(?:)/, t = e.exec;
		e.exec = function() {
			return t.apply(this, arguments);
		};
		var n = "ab".split(e);
		return n.length !== 2 || n[0] !== "a" || n[1] !== "b";
	}), b = "abbc".split(/(b)*/)[1] === "c" || "test".split(/(?:)/, -1).length !== 4 || "ab".split(/(?:ab)*/).length !== 2 || ".".split(/(.?)(.?)/).length !== 4 || ".".split(/()()/).length > 1 || "".split(/.?/).length;
	n("split", function(t, n, f) {
		var p = "0".split(void 0, 0).length ? function(t, r) {
			return t === void 0 && r === 0 ? [] : e(n, this, t, r);
		} : n;
		return [function(n, r) {
			var o = a(this), s = i(n) ? u(n, t) : void 0;
			return s ? e(s, n, o, r) : e(p, l(o), n, r);
		}, function(e, t) {
			var i = r(this), a = l(e);
			if (!b) {
				var u = f(p, i, a, t, p !== n);
				if (u.done) return u.value;
			}
			var y = o(i, RegExp), x = i.unicode, S = (i.ignoreCase ? "i" : "") + (i.multiline ? "m" : "") + (i.unicode ? "u" : "") + (m ? "g" : "y"), C = new y(m ? "^(?:" + i.source + ")" : i, S), w = t === void 0 ? h : t >>> 0;
			if (w === 0) return [];
			if (a.length === 0) return d(C, a) === null ? [a] : [];
			for (var T = 0, E = 0, D = []; E < a.length;) {
				C.lastIndex = m ? 0 : E;
				var O = d(C, m ? v(a, E) : a), k;
				if (O === null || (k = g(c(C.lastIndex + (m ? E : 0)), a.length)) === T) E = s(a, E, x);
				else {
					if (_(D, v(a, T, E)), D.length === w) return D;
					for (var A = 1; A <= O.length - 1; A++) if (_(D, O[A]), D.length === w) return D;
					E = T = k;
				}
			}
			return _(D, v(a, T)), D;
		}];
	}, b || !y, m);
})), Gg = /* @__PURE__ */ s(((e, t) => {
	(function() {
		var e, n, r, i, a, o;
		typeof performance < "u" && performance !== null && performance.now ? t.exports = function() {
			return performance.now();
		} : typeof process < "u" && process !== null && process.hrtime ? (t.exports = function() {
			return (e() - a) / 1e6;
		}, n = process.hrtime, e = function() {
			var e = n();
			return e[0] * 1e9 + e[1];
		}, i = e(), o = process.uptime() * 1e9, a = i - o) : Date.now ? (t.exports = function() {
			return Date.now() - r;
		}, r = Date.now()) : (t.exports = function() {
			return (/* @__PURE__ */ new Date()).getTime() - r;
		}, r = (/* @__PURE__ */ new Date()).getTime());
	}).call(e);
})), Kg = /* @__PURE__ */ s(((e, t) => {
	for (var n = Gg(), r = typeof window > "u" ? global : window, i = ["moz", "webkit"], a = "AnimationFrame", o = r["request" + a], s = r["cancel" + a] || r["cancelRequest" + a], c = 0; !o && c < i.length; c++) o = r[i[c] + "Request" + a], s = r[i[c] + "Cancel" + a] || r[i[c] + "CancelRequest" + a];
	if (!o || !s) {
		var l = 0, u = 0, d = [], f = 1e3 / 60;
		o = function(e) {
			if (d.length === 0) {
				var t = n(), r = Math.max(0, f - (t - l));
				l = r + t, setTimeout(function() {
					var e = d.slice(0);
					d.length = 0;
					for (var t = 0; t < e.length; t++) if (!e[t].cancelled) try {
						e[t].callback(l);
					} catch (e) {
						setTimeout(function() {
							throw e;
						}, 0);
					}
				}, Math.round(r));
			}
			return d.push({
				handle: ++u,
				callback: e,
				cancelled: !1
			}), u;
		}, s = function(e) {
			for (var t = 0; t < d.length; t++) d[t].handle === e && (d[t].cancelled = !0);
		};
	}
	t.exports = function(e) {
		return o.call(r, e);
	}, t.exports.cancel = function() {
		s.apply(r, arguments);
	}, t.exports.polyfill = function(e) {
		e ||= r, e.requestAnimationFrame = o, e.cancelAnimationFrame = s;
	};
})), qg = /* @__PURE__ */ s(((e, t) => {
	t.exports = "	\n\v\f\r \xA0              　\u2028\u2029﻿";
})), Jg = /* @__PURE__ */ s(((e, t) => {
	var n = Zp(), r = tm(), i = eg(), a = qg(), o = n("".replace), s = RegExp("^[" + a + "]+"), c = RegExp("(^|[^" + a + "])[" + a + "]+$"), l = function(e) {
		return function(t) {
			var n = i(r(t));
			return e & 1 && (n = o(n, s, "")), e & 2 && (n = o(n, c, "$1")), n;
		};
	};
	t.exports = {
		start: l(1),
		end: l(2),
		trim: l(3)
	};
})), Yg = /* @__PURE__ */ s(((e, t) => {
	var n = Nm().PROPER, r = Gp(), i = qg(), a = "​᠎";
	t.exports = function(e) {
		return r(function() {
			return !!i[e]() || a[e]() !== a || n && i[e].name !== e;
		});
	};
})), Xg = /* @__PURE__ */ s((() => {
	var e = eh(), t = Jg().trim;
	e({
		target: "String",
		proto: !0,
		forced: Yg()("trim")
	}, { trim: function() {
		return t(this);
	} });
})), Zg = /* @__PURE__ */ s(((e, t) => {
	t.exports = function(e) {
		this.ok = !1, this.alpha = 1, e.charAt(0) == "#" && (e = e.substr(1, 6)), e = e.replace(/ /g, ""), e = e.toLowerCase();
		var t = {
			aliceblue: "f0f8ff",
			antiquewhite: "faebd7",
			aqua: "00ffff",
			aquamarine: "7fffd4",
			azure: "f0ffff",
			beige: "f5f5dc",
			bisque: "ffe4c4",
			black: "000000",
			blanchedalmond: "ffebcd",
			blue: "0000ff",
			blueviolet: "8a2be2",
			brown: "a52a2a",
			burlywood: "deb887",
			cadetblue: "5f9ea0",
			chartreuse: "7fff00",
			chocolate: "d2691e",
			coral: "ff7f50",
			cornflowerblue: "6495ed",
			cornsilk: "fff8dc",
			crimson: "dc143c",
			cyan: "00ffff",
			darkblue: "00008b",
			darkcyan: "008b8b",
			darkgoldenrod: "b8860b",
			darkgray: "a9a9a9",
			darkgreen: "006400",
			darkkhaki: "bdb76b",
			darkmagenta: "8b008b",
			darkolivegreen: "556b2f",
			darkorange: "ff8c00",
			darkorchid: "9932cc",
			darkred: "8b0000",
			darksalmon: "e9967a",
			darkseagreen: "8fbc8f",
			darkslateblue: "483d8b",
			darkslategray: "2f4f4f",
			darkturquoise: "00ced1",
			darkviolet: "9400d3",
			deeppink: "ff1493",
			deepskyblue: "00bfff",
			dimgray: "696969",
			dodgerblue: "1e90ff",
			feldspar: "d19275",
			firebrick: "b22222",
			floralwhite: "fffaf0",
			forestgreen: "228b22",
			fuchsia: "ff00ff",
			gainsboro: "dcdcdc",
			ghostwhite: "f8f8ff",
			gold: "ffd700",
			goldenrod: "daa520",
			gray: "808080",
			green: "008000",
			greenyellow: "adff2f",
			honeydew: "f0fff0",
			hotpink: "ff69b4",
			indianred: "cd5c5c",
			indigo: "4b0082",
			ivory: "fffff0",
			khaki: "f0e68c",
			lavender: "e6e6fa",
			lavenderblush: "fff0f5",
			lawngreen: "7cfc00",
			lemonchiffon: "fffacd",
			lightblue: "add8e6",
			lightcoral: "f08080",
			lightcyan: "e0ffff",
			lightgoldenrodyellow: "fafad2",
			lightgrey: "d3d3d3",
			lightgreen: "90ee90",
			lightpink: "ffb6c1",
			lightsalmon: "ffa07a",
			lightseagreen: "20b2aa",
			lightskyblue: "87cefa",
			lightslateblue: "8470ff",
			lightslategray: "778899",
			lightsteelblue: "b0c4de",
			lightyellow: "ffffe0",
			lime: "00ff00",
			limegreen: "32cd32",
			linen: "faf0e6",
			magenta: "ff00ff",
			maroon: "800000",
			mediumaquamarine: "66cdaa",
			mediumblue: "0000cd",
			mediumorchid: "ba55d3",
			mediumpurple: "9370d8",
			mediumseagreen: "3cb371",
			mediumslateblue: "7b68ee",
			mediumspringgreen: "00fa9a",
			mediumturquoise: "48d1cc",
			mediumvioletred: "c71585",
			midnightblue: "191970",
			mintcream: "f5fffa",
			mistyrose: "ffe4e1",
			moccasin: "ffe4b5",
			navajowhite: "ffdead",
			navy: "000080",
			oldlace: "fdf5e6",
			olive: "808000",
			olivedrab: "6b8e23",
			orange: "ffa500",
			orangered: "ff4500",
			orchid: "da70d6",
			palegoldenrod: "eee8aa",
			palegreen: "98fb98",
			paleturquoise: "afeeee",
			palevioletred: "d87093",
			papayawhip: "ffefd5",
			peachpuff: "ffdab9",
			peru: "cd853f",
			pink: "ffc0cb",
			plum: "dda0dd",
			powderblue: "b0e0e6",
			purple: "800080",
			rebeccapurple: "663399",
			red: "ff0000",
			rosybrown: "bc8f8f",
			royalblue: "4169e1",
			saddlebrown: "8b4513",
			salmon: "fa8072",
			sandybrown: "f4a460",
			seagreen: "2e8b57",
			seashell: "fff5ee",
			sienna: "a0522d",
			silver: "c0c0c0",
			skyblue: "87ceeb",
			slateblue: "6a5acd",
			slategray: "708090",
			snow: "fffafa",
			springgreen: "00ff7f",
			steelblue: "4682b4",
			tan: "d2b48c",
			teal: "008080",
			thistle: "d8bfd8",
			tomato: "ff6347",
			turquoise: "40e0d0",
			violet: "ee82ee",
			violetred: "d02090",
			wheat: "f5deb3",
			white: "ffffff",
			whitesmoke: "f5f5f5",
			yellow: "ffff00",
			yellowgreen: "9acd32"
		};
		e = t[e] || e;
		for (var n = [
			{
				re: /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*((?:\d?\.)?\d)\)$/,
				example: ["rgba(123, 234, 45, 0.8)", "rgba(255,234,245,1.0)"],
				process: function(e) {
					return [
						parseInt(e[1]),
						parseInt(e[2]),
						parseInt(e[3]),
						parseFloat(e[4])
					];
				}
			},
			{
				re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
				example: ["rgb(123, 234, 45)", "rgb(255,234,245)"],
				process: function(e) {
					return [
						parseInt(e[1]),
						parseInt(e[2]),
						parseInt(e[3])
					];
				}
			},
			{
				re: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
				example: ["#00ff00", "336699"],
				process: function(e) {
					return [
						parseInt(e[1], 16),
						parseInt(e[2], 16),
						parseInt(e[3], 16)
					];
				}
			},
			{
				re: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
				example: ["#fb0", "f0f"],
				process: function(e) {
					return [
						parseInt(e[1] + e[1], 16),
						parseInt(e[2] + e[2], 16),
						parseInt(e[3] + e[3], 16)
					];
				}
			}
		], r = 0; r < n.length; r++) {
			var i = n[r].re, a = n[r].process, o = i.exec(e);
			if (o) {
				var s = a(o);
				this.r = s[0], this.g = s[1], this.b = s[2], s.length > 3 && (this.alpha = s[3]), this.ok = !0;
			}
		}
		this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.alpha = this.alpha < 0 ? 0 : this.alpha > 1 || isNaN(this.alpha) ? 1 : this.alpha, this.toRGB = function() {
			return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
		}, this.toRGBA = function() {
			return "rgba(" + this.r + ", " + this.g + ", " + this.b + ", " + this.alpha + ")";
		}, this.toHex = function() {
			var e = this.r.toString(16), t = this.g.toString(16), n = this.b.toString(16);
			return e.length == 1 && (e = "0" + e), t.length == 1 && (t = "0" + t), n.length == 1 && (n = "0" + n), "#" + e + t + n;
		}, this.getHelpXML = function() {
			for (var e = [], r = 0; r < n.length; r++) for (var i = n[r].example, a = 0; a < i.length; a++) e[e.length] = i[a];
			for (var o in t) e[e.length] = o;
			var s = document.createElement("ul");
			s.setAttribute("id", "rgbcolor-examples");
			for (var r = 0; r < e.length; r++) try {
				var c = document.createElement("li"), l = new RGBColor(e[r]), u = document.createElement("div");
				u.style.cssText = "margin: 3px; border: 1px solid black; background:" + l.toHex() + "; color:" + l.toHex(), u.appendChild(document.createTextNode("test"));
				var d = document.createTextNode(" " + e[r] + " -> " + l.toRGB() + " -> " + l.toHex());
				c.appendChild(u), c.appendChild(d), s.appendChild(c);
			} catch {}
			return s;
		};
	};
})), Qg = /* @__PURE__ */ s((() => {
	var e = eh(), t = vh(), n = Km().indexOf, r = Vg(), i = t([].indexOf), a = !!i && 1 / i([1], 1, -0) < 0;
	e({
		target: "Array",
		proto: !0,
		forced: a || !r("indexOf")
	}, { indexOf: function(e) {
		var t = arguments.length > 1 ? arguments[1] : void 0;
		return a ? i(this, e, t) || 0 : n(this, e, t);
	} });
})), $g = /* @__PURE__ */ s((() => {
	var e = eh(), t = Zp(), n = bg(), r = tm(), i = eg(), a = xg(), o = t("".indexOf);
	e({
		target: "String",
		proto: !0,
		forced: !a("includes")
	}, { includes: function(e) {
		return !!~o(i(r(this)), i(n(e)), arguments.length > 1 ? arguments[1] : void 0);
	} });
})), e_ = /* @__PURE__ */ s(((e, t) => {
	var n = Qp();
	t.exports = Array.isArray || function(e) {
		return n(e) === "Array";
	};
})), t_ = /* @__PURE__ */ s((() => {
	var e = eh(), t = Zp(), n = e_(), r = t([].reverse), i = [1, 2];
	e({
		target: "Array",
		proto: !0,
		forced: String(i) === String(i.reverse())
	}, { reverse: function() {
		return n(this) && (this.length = this.length), r(this);
	} });
}));
//#endregion
//#region node_modules/svg-pathdata/lib/SVGPathData.module.js
function n_(e, t) {
	if (typeof t != "function" && t !== null) throw TypeError("Class extends value " + String(t) + " is not a constructor or null");
	function n() {
		this.constructor = e;
	}
	f_(e, t), e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
function r_(e) {
	var t = "";
	Array.isArray(e) || (e = [e]);
	for (var n = 0; n < e.length; n++) {
		var r = e[n];
		if (r.type === X.CLOSE_PATH) t += "z";
		else if (r.type === X.HORIZ_LINE_TO) t += (r.relative ? "h" : "H") + r.x;
		else if (r.type === X.VERT_LINE_TO) t += (r.relative ? "v" : "V") + r.y;
		else if (r.type === X.MOVE_TO) t += (r.relative ? "m" : "M") + r.x + " " + r.y;
		else if (r.type === X.LINE_TO) t += (r.relative ? "l" : "L") + r.x + " " + r.y;
		else if (r.type === X.CURVE_TO) t += (r.relative ? "c" : "C") + r.x1 + " " + r.y1 + " " + r.x2 + " " + r.y2 + " " + r.x + " " + r.y;
		else if (r.type === X.SMOOTH_CURVE_TO) t += (r.relative ? "s" : "S") + r.x2 + " " + r.y2 + " " + r.x + " " + r.y;
		else if (r.type === X.QUAD_TO) t += (r.relative ? "q" : "Q") + r.x1 + " " + r.y1 + " " + r.x + " " + r.y;
		else if (r.type === X.SMOOTH_QUAD_TO) t += (r.relative ? "t" : "T") + r.x + " " + r.y;
		else {
			if (r.type !== X.ARC) throw Error("Unexpected command type \"" + r.type + "\" at index " + n + ".");
			t += (r.relative ? "a" : "A") + r.rX + " " + r.rY + " " + r.xRot + " " + +r.lArcFlag + " " + +r.sweepFlag + " " + r.x + " " + r.y;
		}
	}
	return t;
}
function i_(e, t) {
	var n = e[0], r = e[1];
	return [n * Math.cos(t) - r * Math.sin(t), n * Math.sin(t) + r * Math.cos(t)];
}
function a_() {
	for (var e = [...arguments], t = 0; t < e.length; t++) if (typeof e[t] != "number") throw Error("assertNumbers arguments[" + t + "] is not a number. " + typeof e[t] + " == typeof " + e[t]);
	return !0;
}
function o_(e, t, n) {
	e.lArcFlag = e.lArcFlag === 0 ? 0 : 1, e.sweepFlag = e.sweepFlag === 0 ? 0 : 1;
	var r = e.rX, i = e.rY, a = e.x, o = e.y;
	r = Math.abs(e.rX), i = Math.abs(e.rY);
	var s = i_([(t - a) / 2, (n - o) / 2], -e.xRot / 180 * p_), c = s[0], l = s[1], u = c ** 2 / r ** 2 + l ** 2 / i ** 2;
	1 < u && (r *= Math.sqrt(u), i *= Math.sqrt(u)), e.rX = r, e.rY = i;
	var d = r ** 2 * l ** 2 + i ** 2 * c ** 2, f = (e.lArcFlag === e.sweepFlag ? -1 : 1) * Math.sqrt(Math.max(0, (r ** 2 * i ** 2 - d) / d)), p = r * l / i * f, m = -i * c / r * f, h = i_([p, m], e.xRot / 180 * p_);
	e.cX = h[0] + (t + a) / 2, e.cY = h[1] + (n + o) / 2, e.phi1 = Math.atan2((l - m) / i, (c - p) / r), e.phi2 = Math.atan2((-l - m) / i, (-c - p) / r), e.sweepFlag === 0 && e.phi2 > e.phi1 && (e.phi2 -= 2 * p_), e.sweepFlag === 1 && e.phi2 < e.phi1 && (e.phi2 += 2 * p_), e.phi1 *= 180 / p_, e.phi2 *= 180 / p_;
}
function s_(e, t, n) {
	a_(e, t, n);
	var r = e * e + t * t - n * n;
	if (0 > r) return [];
	if (r === 0) return [[e * n / (e * e + t * t), t * n / (e * e + t * t)]];
	var i = Math.sqrt(r);
	return [[(e * n + t * i) / (e * e + t * t), (t * n - e * i) / (e * e + t * t)], [(e * n - t * i) / (e * e + t * t), (t * n + e * i) / (e * e + t * t)]];
}
function c_(e, t, n) {
	return (1 - n) * e + n * t;
}
function l_(e, t, n, r) {
	return e + Math.cos(r / 180 * p_) * t + Math.sin(r / 180 * p_) * n;
}
function u_(e, t, n, r) {
	var i = 1e-6, a = t - e, o = n - t, s = 3 * a + 3 * (r - n) - 6 * o, c = 6 * (o - a), l = 3 * a;
	return Math.abs(s) < i ? [-l / c] : function(e, t, n) {
		n === void 0 && (n = 1e-6);
		var r = e * e / 4 - t;
		if (r < -n) return [];
		if (r <= n) return [-e / 2];
		var i = Math.sqrt(r);
		return [-e / 2 - i, -e / 2 + i];
	}(c / s, l / s, i);
}
function d_(e, t, n, r, i) {
	var a = 1 - i;
	return e * (a * a * a) + t * (3 * a * a * i) + n * (3 * a * i * i) + r * (i * i * i);
}
var f_, p_, m_, h_, g_, __, v_, y_, b_, X, x_, S_ = o((() => {
	f_ = function(e, t) {
		return (f_ = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
			e.__proto__ = t;
		} || function(e, t) {
			for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
		})(e, t);
	}, p_ = Math.PI, h_ = Math.PI / 180, (function(e) {
		function t() {
			return i((function(e, t, n) {
				return e.relative &&= (e.x1 !== void 0 && (e.x1 += t), e.y1 !== void 0 && (e.y1 += n), e.x2 !== void 0 && (e.x2 += t), e.y2 !== void 0 && (e.y2 += n), e.x !== void 0 && (e.x += t), e.y !== void 0 && (e.y += n), !1), e;
			}));
		}
		function n() {
			var e = NaN, t = NaN, n = NaN, r = NaN;
			return i((function(i, a, o) {
				return i.type & X.SMOOTH_CURVE_TO && (i.type = X.CURVE_TO, e = isNaN(e) ? a : e, t = isNaN(t) ? o : t, i.x1 = i.relative ? a - e : 2 * a - e, i.y1 = i.relative ? o - t : 2 * o - t), i.type & X.CURVE_TO ? (e = i.relative ? a + i.x2 : i.x2, t = i.relative ? o + i.y2 : i.y2) : (e = NaN, t = NaN), i.type & X.SMOOTH_QUAD_TO && (i.type = X.QUAD_TO, n = isNaN(n) ? a : n, r = isNaN(r) ? o : r, i.x1 = i.relative ? a - n : 2 * a - n, i.y1 = i.relative ? o - r : 2 * o - r), i.type & X.QUAD_TO ? (n = i.relative ? a + i.x1 : i.x1, r = i.relative ? o + i.y1 : i.y1) : (n = NaN, r = NaN), i;
			}));
		}
		function r() {
			var e = NaN, t = NaN;
			return i((function(n, r, i) {
				if (n.type & X.SMOOTH_QUAD_TO && (n.type = X.QUAD_TO, e = isNaN(e) ? r : e, t = isNaN(t) ? i : t, n.x1 = n.relative ? r - e : 2 * r - e, n.y1 = n.relative ? i - t : 2 * i - t), n.type & X.QUAD_TO) {
					e = n.relative ? r + n.x1 : n.x1, t = n.relative ? i + n.y1 : n.y1;
					var a = n.x1, o = n.y1;
					n.type = X.CURVE_TO, n.x1 = ((n.relative ? 0 : r) + 2 * a) / 3, n.y1 = ((n.relative ? 0 : i) + 2 * o) / 3, n.x2 = (n.x + 2 * a) / 3, n.y2 = (n.y + 2 * o) / 3;
				} else e = NaN, t = NaN;
				return n;
			}));
		}
		function i(e) {
			var t = 0, n = 0, r = NaN, i = NaN;
			return function(a) {
				if (isNaN(r) && !(a.type & X.MOVE_TO)) throw Error("path must start with moveto");
				var o = e(a, t, n, r, i);
				return a.type & X.CLOSE_PATH && (t = r, n = i), a.x !== void 0 && (t = a.relative ? t + a.x : a.x), a.y !== void 0 && (n = a.relative ? n + a.y : a.y), a.type & X.MOVE_TO && (r = t, i = n), o;
			};
		}
		function a(e, t, n, r, a, o) {
			return a_(e, t, n, r, a, o), i((function(i, s, c, l) {
				var u = i.x1, d = i.x2, f = i.relative && !isNaN(l), p = i.x === void 0 ? f ? 0 : s : i.x, m = i.y === void 0 ? f ? 0 : c : i.y;
				function h(e) {
					return e * e;
				}
				i.type & X.HORIZ_LINE_TO && t !== 0 && (i.type = X.LINE_TO, i.y = i.relative ? 0 : c), i.type & X.VERT_LINE_TO && n !== 0 && (i.type = X.LINE_TO, i.x = i.relative ? 0 : s), i.x !== void 0 && (i.x = i.x * e + m * n + (f ? 0 : a)), i.y !== void 0 && (i.y = p * t + i.y * r + (f ? 0 : o)), i.x1 !== void 0 && (i.x1 = i.x1 * e + i.y1 * n + (f ? 0 : a)), i.y1 !== void 0 && (i.y1 = u * t + i.y1 * r + (f ? 0 : o)), i.x2 !== void 0 && (i.x2 = i.x2 * e + i.y2 * n + (f ? 0 : a)), i.y2 !== void 0 && (i.y2 = d * t + i.y2 * r + (f ? 0 : o));
				var g = e * r - t * n;
				if (i.xRot !== void 0 && (e !== 1 || t !== 0 || n !== 0 || r !== 1)) if (g === 0) delete i.rX, delete i.rY, delete i.xRot, delete i.lArcFlag, delete i.sweepFlag, i.type = X.LINE_TO;
				else {
					var _ = i.xRot * Math.PI / 180, v = Math.sin(_), y = Math.cos(_), b = 1 / h(i.rX), x = 1 / h(i.rY), S = h(y) * b + h(v) * x, C = 2 * v * y * (b - x), w = h(v) * b + h(y) * x, T = S * r * r - C * t * r + w * t * t, E = C * (e * r + t * n) - 2 * (S * n * r + w * e * t), D = S * n * n - C * e * n + w * e * e, O = (Math.atan2(E, T - D) + Math.PI) % Math.PI / 2, k = Math.sin(O), A = Math.cos(O);
					i.rX = Math.abs(g) / Math.sqrt(T * h(A) + E * k * A + D * h(k)), i.rY = Math.abs(g) / Math.sqrt(T * h(k) - E * k * A + D * h(A)), i.xRot = 180 * O / Math.PI;
				}
				return i.sweepFlag !== void 0 && 0 > g && (i.sweepFlag = +!i.sweepFlag), i;
			}));
		}
		function o() {
			return function(e) {
				var t = {};
				for (var n in e) t[n] = e[n];
				return t;
			};
		}
		e.ROUND = function(e) {
			function t(t) {
				return Math.round(t * e) / e;
			}
			return e === void 0 && (e = 0x9184e72a000), a_(e), function(e) {
				return e.x1 !== void 0 && (e.x1 = t(e.x1)), e.y1 !== void 0 && (e.y1 = t(e.y1)), e.x2 !== void 0 && (e.x2 = t(e.x2)), e.y2 !== void 0 && (e.y2 = t(e.y2)), e.x !== void 0 && (e.x = t(e.x)), e.y !== void 0 && (e.y = t(e.y)), e.rX !== void 0 && (e.rX = t(e.rX)), e.rY !== void 0 && (e.rY = t(e.rY)), e;
			};
		}, e.TO_ABS = t, e.TO_REL = function() {
			return i((function(e, t, n) {
				return e.relative ||= (e.x1 !== void 0 && (e.x1 -= t), e.y1 !== void 0 && (e.y1 -= n), e.x2 !== void 0 && (e.x2 -= t), e.y2 !== void 0 && (e.y2 -= n), e.x !== void 0 && (e.x -= t), e.y !== void 0 && (e.y -= n), !0), e;
			}));
		}, e.NORMALIZE_HVZ = function(e, t, n) {
			return e === void 0 && (e = !0), t === void 0 && (t = !0), n === void 0 && (n = !0), i((function(r, i, a, o, s) {
				if (isNaN(o) && !(r.type & X.MOVE_TO)) throw Error("path must start with moveto");
				return t && r.type & X.HORIZ_LINE_TO && (r.type = X.LINE_TO, r.y = r.relative ? 0 : a), n && r.type & X.VERT_LINE_TO && (r.type = X.LINE_TO, r.x = r.relative ? 0 : i), e && r.type & X.CLOSE_PATH && (r.type = X.LINE_TO, r.x = r.relative ? o - i : o, r.y = r.relative ? s - a : s), r.type & X.ARC && (r.rX === 0 || r.rY === 0) && (r.type = X.LINE_TO, delete r.rX, delete r.rY, delete r.xRot, delete r.lArcFlag, delete r.sweepFlag), r;
			}));
		}, e.NORMALIZE_ST = n, e.QT_TO_C = r, e.INFO = i, e.SANITIZE = function(e) {
			e === void 0 && (e = 0), a_(e);
			var t = NaN, n = NaN, r = NaN, a = NaN;
			return i((function(i, o, s, c, l) {
				var u = Math.abs, d = !1, f = 0, p = 0;
				if (i.type & X.SMOOTH_CURVE_TO && (f = isNaN(t) ? 0 : o - t, p = isNaN(n) ? 0 : s - n), i.type & (X.CURVE_TO | X.SMOOTH_CURVE_TO) ? (t = i.relative ? o + i.x2 : i.x2, n = i.relative ? s + i.y2 : i.y2) : (t = NaN, n = NaN), i.type & X.SMOOTH_QUAD_TO ? (r = isNaN(r) ? o : 2 * o - r, a = isNaN(a) ? s : 2 * s - a) : i.type & X.QUAD_TO ? (r = i.relative ? o + i.x1 : i.x1, a = i.relative ? s + i.y1 : i.y2) : (r = NaN, a = NaN), i.type & X.LINE_COMMANDS || i.type & X.ARC && (i.rX === 0 || i.rY === 0 || !i.lArcFlag) || i.type & X.CURVE_TO || i.type & X.SMOOTH_CURVE_TO || i.type & X.QUAD_TO || i.type & X.SMOOTH_QUAD_TO) {
					var m = i.x === void 0 ? 0 : i.relative ? i.x : i.x - o, h = i.y === void 0 ? 0 : i.relative ? i.y : i.y - s;
					f = isNaN(r) ? i.x1 === void 0 ? f : i.relative ? i.x : i.x1 - o : r - o, p = isNaN(a) ? i.y1 === void 0 ? p : i.relative ? i.y : i.y1 - s : a - s;
					var g = i.x2 === void 0 ? 0 : i.relative ? i.x : i.x2 - o, _ = i.y2 === void 0 ? 0 : i.relative ? i.y : i.y2 - s;
					u(m) <= e && u(h) <= e && u(f) <= e && u(p) <= e && u(g) <= e && u(_) <= e && (d = !0);
				}
				return i.type & X.CLOSE_PATH && u(o - c) <= e && u(s - l) <= e && (d = !0), d ? [] : i;
			}));
		}, e.MATRIX = a, e.ROTATE = function(e, t, n) {
			t === void 0 && (t = 0), n === void 0 && (n = 0), a_(e, t, n);
			var r = Math.sin(e), i = Math.cos(e);
			return a(i, r, -r, i, t - t * i + n * r, n - t * r - n * i);
		}, e.TRANSLATE = function(e, t) {
			return t === void 0 && (t = 0), a_(e, t), a(1, 0, 0, 1, e, t);
		}, e.SCALE = function(e, t) {
			return t === void 0 && (t = e), a_(e, t), a(e, 0, 0, t, 0, 0);
		}, e.SKEW_X = function(e) {
			return a_(e), a(1, 0, Math.atan(e), 1, 0, 0);
		}, e.SKEW_Y = function(e) {
			return a_(e), a(1, Math.atan(e), 0, 1, 0, 0);
		}, e.X_AXIS_SYMMETRY = function(e) {
			return e === void 0 && (e = 0), a_(e), a(-1, 0, 0, 1, e, 0);
		}, e.Y_AXIS_SYMMETRY = function(e) {
			return e === void 0 && (e = 0), a_(e), a(1, 0, 0, -1, 0, e);
		}, e.A_TO_C = function() {
			return i((function(e, t, n) {
				return X.ARC === e.type ? function(e, t, n) {
					var r, i, a, o;
					e.cX || o_(e, t, n);
					for (var s = Math.min(e.phi1, e.phi2), c = Math.max(e.phi1, e.phi2) - s, l = Math.ceil(c / 90), u = Array(l), d = t, f = n, p = 0; p < l; p++) {
						var m = c_(e.phi1, e.phi2, p / l), h = c_(e.phi1, e.phi2, (p + 1) / l), g = h - m, _ = 4 / 3 * Math.tan(g * h_ / 4), v = [Math.cos(m * h_) - _ * Math.sin(m * h_), Math.sin(m * h_) + _ * Math.cos(m * h_)], y = v[0], b = v[1], x = [Math.cos(h * h_), Math.sin(h * h_)], S = x[0], C = x[1], w = [S + _ * Math.sin(h * h_), C - _ * Math.cos(h * h_)], T = w[0], E = w[1];
						u[p] = {
							relative: e.relative,
							type: X.CURVE_TO
						};
						var D = function(t, n) {
							var r = i_([t * e.rX, n * e.rY], e.xRot), i = r[0], a = r[1];
							return [e.cX + i, e.cY + a];
						};
						r = D(y, b), u[p].x1 = r[0], u[p].y1 = r[1], i = D(T, E), u[p].x2 = i[0], u[p].y2 = i[1], a = D(S, C), u[p].x = a[0], u[p].y = a[1], e.relative && (u[p].x1 -= d, u[p].y1 -= f, u[p].x2 -= d, u[p].y2 -= f, u[p].x -= d, u[p].y -= f), d = (o = [u[p].x, u[p].y])[0], f = o[1];
					}
					return u;
				}(e, e.relative ? 0 : t, e.relative ? 0 : n) : e;
			}));
		}, e.ANNOTATE_ARCS = function() {
			return i((function(e, t, n) {
				return e.relative && (t = 0, n = 0), X.ARC === e.type && o_(e, t, n), e;
			}));
		}, e.CLONE = o, e.CALCULATE_BOUNDS = function() {
			var e = function(e) {
				var t = {};
				for (var n in e) t[n] = e[n];
				return t;
			}, a = t(), o = r(), s = n(), c = i((function(t, n, r) {
				var i = s(o(a(e(t))));
				function l(e) {
					e > c.maxX && (c.maxX = e), e < c.minX && (c.minX = e);
				}
				function u(e) {
					e > c.maxY && (c.maxY = e), e < c.minY && (c.minY = e);
				}
				if (i.type & X.DRAWING_COMMANDS && (l(n), u(r)), i.type & X.HORIZ_LINE_TO && l(i.x), i.type & X.VERT_LINE_TO && u(i.y), i.type & X.LINE_TO && (l(i.x), u(i.y)), i.type & X.CURVE_TO) {
					l(i.x), u(i.y);
					for (var d = 0, f = u_(n, i.x1, i.x2, i.x); d < f.length; d++) 0 < (O = f[d]) && 1 > O && l(d_(n, i.x1, i.x2, i.x, O));
					for (var p = 0, m = u_(r, i.y1, i.y2, i.y); p < m.length; p++) 0 < (O = m[p]) && 1 > O && u(d_(r, i.y1, i.y2, i.y, O));
				}
				if (i.type & X.ARC) {
					l(i.x), u(i.y), o_(i, n, r);
					for (var h = i.xRot / 180 * Math.PI, g = Math.cos(h) * i.rX, _ = Math.sin(h) * i.rX, v = -Math.sin(h) * i.rY, y = Math.cos(h) * i.rY, b = i.phi1 < i.phi2 ? [i.phi1, i.phi2] : -180 > i.phi2 ? [i.phi2 + 360, i.phi1 + 360] : [i.phi2, i.phi1], x = b[0], S = b[1], C = function(e) {
						var t = e[0], n = e[1], r = 180 * Math.atan2(n, t) / Math.PI;
						return r < x ? r + 360 : r;
					}, w = 0, T = s_(v, -g, 0).map(C); w < T.length; w++) (O = T[w]) > x && O < S && l(l_(i.cX, g, v, O));
					for (var E = 0, D = s_(y, -_, 0).map(C); E < D.length; E++) {
						var O;
						(O = D[E]) > x && O < S && u(l_(i.cY, _, y, O));
					}
				}
				return t;
			}));
			return c.minX = Infinity, c.maxX = -Infinity, c.minY = Infinity, c.maxY = -Infinity, c;
		};
	})(m_ ||= {}), __ = function() {
		function e() {}
		return e.prototype.round = function(e) {
			return this.transform(m_.ROUND(e));
		}, e.prototype.toAbs = function() {
			return this.transform(m_.TO_ABS());
		}, e.prototype.toRel = function() {
			return this.transform(m_.TO_REL());
		}, e.prototype.normalizeHVZ = function(e, t, n) {
			return this.transform(m_.NORMALIZE_HVZ(e, t, n));
		}, e.prototype.normalizeST = function() {
			return this.transform(m_.NORMALIZE_ST());
		}, e.prototype.qtToC = function() {
			return this.transform(m_.QT_TO_C());
		}, e.prototype.aToC = function() {
			return this.transform(m_.A_TO_C());
		}, e.prototype.sanitize = function(e) {
			return this.transform(m_.SANITIZE(e));
		}, e.prototype.translate = function(e, t) {
			return this.transform(m_.TRANSLATE(e, t));
		}, e.prototype.scale = function(e, t) {
			return this.transform(m_.SCALE(e, t));
		}, e.prototype.rotate = function(e, t, n) {
			return this.transform(m_.ROTATE(e, t, n));
		}, e.prototype.matrix = function(e, t, n, r, i, a) {
			return this.transform(m_.MATRIX(e, t, n, r, i, a));
		}, e.prototype.skewX = function(e) {
			return this.transform(m_.SKEW_X(e));
		}, e.prototype.skewY = function(e) {
			return this.transform(m_.SKEW_Y(e));
		}, e.prototype.xSymmetry = function(e) {
			return this.transform(m_.X_AXIS_SYMMETRY(e));
		}, e.prototype.ySymmetry = function(e) {
			return this.transform(m_.Y_AXIS_SYMMETRY(e));
		}, e.prototype.annotateArcs = function() {
			return this.transform(m_.ANNOTATE_ARCS());
		}, e;
	}(), v_ = function(e) {
		return e === " " || e === "	" || e === "\r" || e === "\n";
	}, y_ = function(e) {
		return 48 <= e.charCodeAt(0) && e.charCodeAt(0) <= 57;
	}, b_ = function(e) {
		function t() {
			var t = e.call(this) || this;
			return t.curNumber = "", t.curCommandType = -1, t.curCommandRelative = !1, t.canParseCommandOrComma = !0, t.curNumberHasExp = !1, t.curNumberHasExpDigits = !1, t.curNumberHasDecimal = !1, t.curArgs = [], t;
		}
		return n_(t, e), t.prototype.finish = function(e) {
			if (e === void 0 && (e = []), this.parse(" ", e), this.curArgs.length !== 0 || !this.canParseCommandOrComma) throw SyntaxError("Unterminated command at the path end.");
			return e;
		}, t.prototype.parse = function(e, t) {
			var n = this;
			t === void 0 && (t = []);
			for (var r = function(e) {
				t.push(e), n.curArgs.length = 0, n.canParseCommandOrComma = !0;
			}, i = 0; i < e.length; i++) {
				var a = e[i], o = !(this.curCommandType !== X.ARC || this.curArgs.length !== 3 && this.curArgs.length !== 4 || this.curNumber.length !== 1 || this.curNumber !== "0" && this.curNumber !== "1"), s = y_(a) && (this.curNumber === "0" && a === "0" || o);
				if (!y_(a) || s) if (a !== "e" && a !== "E") if (a !== "-" && a !== "+" || !this.curNumberHasExp || this.curNumberHasExpDigits) if (a !== "." || this.curNumberHasExp || this.curNumberHasDecimal || o) {
					if (this.curNumber && this.curCommandType !== -1) {
						var c = Number(this.curNumber);
						if (isNaN(c)) throw SyntaxError("Invalid number ending at " + i);
						if (this.curCommandType === X.ARC) {
							if (this.curArgs.length === 0 || this.curArgs.length === 1) {
								if (0 > c) throw SyntaxError("Expected positive number, got \"" + c + "\" at index \"" + i + "\"");
							} else if ((this.curArgs.length === 3 || this.curArgs.length === 4) && this.curNumber !== "0" && this.curNumber !== "1") throw SyntaxError("Expected a flag, got \"" + this.curNumber + "\" at index \"" + i + "\"");
						}
						this.curArgs.push(c), this.curArgs.length === x_[this.curCommandType] && (X.HORIZ_LINE_TO === this.curCommandType ? r({
							type: X.HORIZ_LINE_TO,
							relative: this.curCommandRelative,
							x: c
						}) : X.VERT_LINE_TO === this.curCommandType ? r({
							type: X.VERT_LINE_TO,
							relative: this.curCommandRelative,
							y: c
						}) : this.curCommandType === X.MOVE_TO || this.curCommandType === X.LINE_TO || this.curCommandType === X.SMOOTH_QUAD_TO ? (r({
							type: this.curCommandType,
							relative: this.curCommandRelative,
							x: this.curArgs[0],
							y: this.curArgs[1]
						}), X.MOVE_TO === this.curCommandType && (this.curCommandType = X.LINE_TO)) : this.curCommandType === X.CURVE_TO ? r({
							type: X.CURVE_TO,
							relative: this.curCommandRelative,
							x1: this.curArgs[0],
							y1: this.curArgs[1],
							x2: this.curArgs[2],
							y2: this.curArgs[3],
							x: this.curArgs[4],
							y: this.curArgs[5]
						}) : this.curCommandType === X.SMOOTH_CURVE_TO ? r({
							type: X.SMOOTH_CURVE_TO,
							relative: this.curCommandRelative,
							x2: this.curArgs[0],
							y2: this.curArgs[1],
							x: this.curArgs[2],
							y: this.curArgs[3]
						}) : this.curCommandType === X.QUAD_TO ? r({
							type: X.QUAD_TO,
							relative: this.curCommandRelative,
							x1: this.curArgs[0],
							y1: this.curArgs[1],
							x: this.curArgs[2],
							y: this.curArgs[3]
						}) : this.curCommandType === X.ARC && r({
							type: X.ARC,
							relative: this.curCommandRelative,
							rX: this.curArgs[0],
							rY: this.curArgs[1],
							xRot: this.curArgs[2],
							lArcFlag: this.curArgs[3],
							sweepFlag: this.curArgs[4],
							x: this.curArgs[5],
							y: this.curArgs[6]
						})), this.curNumber = "", this.curNumberHasExpDigits = !1, this.curNumberHasExp = !1, this.curNumberHasDecimal = !1, this.canParseCommandOrComma = !0;
					}
					if (!v_(a)) if (a === "," && this.canParseCommandOrComma) this.canParseCommandOrComma = !1;
					else if (a !== "+" && a !== "-" && a !== ".") if (s) this.curNumber = a, this.curNumberHasDecimal = !1;
					else {
						if (this.curArgs.length !== 0) throw SyntaxError("Unterminated command at index " + i + ".");
						if (!this.canParseCommandOrComma) throw SyntaxError("Unexpected character \"" + a + "\" at index " + i + ". Command cannot follow comma");
						if (this.canParseCommandOrComma = !1, a !== "z" && a !== "Z") if (a === "h" || a === "H") this.curCommandType = X.HORIZ_LINE_TO, this.curCommandRelative = a === "h";
						else if (a === "v" || a === "V") this.curCommandType = X.VERT_LINE_TO, this.curCommandRelative = a === "v";
						else if (a === "m" || a === "M") this.curCommandType = X.MOVE_TO, this.curCommandRelative = a === "m";
						else if (a === "l" || a === "L") this.curCommandType = X.LINE_TO, this.curCommandRelative = a === "l";
						else if (a === "c" || a === "C") this.curCommandType = X.CURVE_TO, this.curCommandRelative = a === "c";
						else if (a === "s" || a === "S") this.curCommandType = X.SMOOTH_CURVE_TO, this.curCommandRelative = a === "s";
						else if (a === "q" || a === "Q") this.curCommandType = X.QUAD_TO, this.curCommandRelative = a === "q";
						else if (a === "t" || a === "T") this.curCommandType = X.SMOOTH_QUAD_TO, this.curCommandRelative = a === "t";
						else {
							if (a !== "a" && a !== "A") throw SyntaxError("Unexpected character \"" + a + "\" at index " + i + ".");
							this.curCommandType = X.ARC, this.curCommandRelative = a === "a";
						}
						else t.push({ type: X.CLOSE_PATH }), this.canParseCommandOrComma = !0, this.curCommandType = -1;
					}
					else this.curNumber = a, this.curNumberHasDecimal = a === ".";
				} else this.curNumber += a, this.curNumberHasDecimal = !0;
				else this.curNumber += a;
				else this.curNumber += a, this.curNumberHasExp = !0;
				else this.curNumber += a, this.curNumberHasExpDigits = this.curNumberHasExp;
			}
			return t;
		}, t.prototype.transform = function(e) {
			return Object.create(this, { parse: { value: function(t, n) {
				n === void 0 && (n = []);
				for (var r = 0, i = Object.getPrototypeOf(this).parse.call(this, t); r < i.length; r++) {
					var a = i[r], o = e(a);
					Array.isArray(o) ? n.push.apply(n, o) : n.push(o);
				}
				return n;
			} } });
		}, t;
	}(__), X = function(e) {
		function t(n) {
			var r = e.call(this) || this;
			return r.commands = typeof n == "string" ? t.parse(n) : n, r;
		}
		return n_(t, e), t.prototype.encode = function() {
			return t.encode(this.commands);
		}, t.prototype.getBounds = function() {
			var e = m_.CALCULATE_BOUNDS();
			return this.transform(e), e;
		}, t.prototype.transform = function(e) {
			for (var t = [], n = 0, r = this.commands; n < r.length; n++) {
				var i = e(r[n]);
				Array.isArray(i) ? t.push.apply(t, i) : t.push(i);
			}
			return this.commands = t, this;
		}, t.encode = function(e) {
			return r_(e);
		}, t.parse = function(e) {
			var t = new b_(), n = [];
			return t.parse(e, n), t.finish(n), n;
		}, t.CLOSE_PATH = 1, t.MOVE_TO = 2, t.HORIZ_LINE_TO = 4, t.VERT_LINE_TO = 8, t.LINE_TO = 16, t.CURVE_TO = 32, t.SMOOTH_CURVE_TO = 64, t.QUAD_TO = 128, t.SMOOTH_QUAD_TO = 256, t.ARC = 512, t.LINE_COMMANDS = t.LINE_TO | t.HORIZ_LINE_TO | t.VERT_LINE_TO, t.DRAWING_COMMANDS = t.HORIZ_LINE_TO | t.VERT_LINE_TO | t.LINE_TO | t.CURVE_TO | t.SMOOTH_CURVE_TO | t.QUAD_TO | t.SMOOTH_QUAD_TO | t.ARC, t;
	}(__), x_ = ((g_ = {})[X.MOVE_TO] = 2, g_[X.LINE_TO] = 2, g_[X.HORIZ_LINE_TO] = 1, g_[X.VERT_LINE_TO] = 1, g_[X.CLOSE_PATH] = 0, g_[X.QUAD_TO] = 4, g_[X.SMOOTH_QUAD_TO] = 2, g_[X.CURVE_TO] = 6, g_[X.SMOOTH_CURVE_TO] = 4, g_[X.ARC] = 7, g_);
})), C_ = /* @__PURE__ */ s((() => {
	var e = Nm().PROPER, t = Bm(), n = Am(), r = eg(), i = Gp(), a = mg(), o = "toString", s = RegExp.prototype, c = s[o], l = i(function() {
		return c.call({
			source: "a",
			flags: "b"
		}) !== "/a/b";
	}), u = e && c.name !== o;
	(l || u) && t(s, o, function() {
		var e = n(this), t = r(e.source), i = r(a(e));
		return "/" + t + "/" + i;
	}, { unsafe: !0 });
}));
//#endregion
//#region node_modules/stackblur-canvas/dist/stackblur-es.js
function w_(e) {
	"@babel/helpers - typeof";
	return w_ = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, w_(e);
}
function T_(e, t) {
	if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
}
function E_(e, t, n, r, i) {
	if (typeof e == "string" && (e = document.getElementById(e)), !e || w_(e) !== "object" || !("getContext" in e)) throw TypeError("Expecting canvas with `getContext` method in processCanvasRGB(A) calls!");
	var a = e.getContext("2d");
	try {
		return a.getImageData(t, n, r, i);
	} catch (e) {
		throw Error("unable to access image data: " + e);
	}
}
function D_(e, t, n, r, i, a) {
	if (!(isNaN(a) || a < 1)) {
		a |= 0;
		var o = E_(e, t, n, r, i);
		o = O_(o, t, n, r, i, a), e.getContext("2d").putImageData(o, t, n);
	}
}
function O_(e, t, n, r, i, a) {
	for (var o = e.data, s = 2 * a + 1, c = r - 1, l = i - 1, u = a + 1, d = u * (u + 1) / 2, f = new j_(), p = f, m, h = 1; h < s; h++) p = p.next = new j_(), h === u && (m = p);
	p.next = f;
	for (var g = null, _ = null, v = 0, y = 0, b = k_[a], x = A_[a], S = 0; S < i; S++) {
		p = f;
		for (var C = o[y], w = o[y + 1], T = o[y + 2], E = o[y + 3], D = 0; D < u; D++) p.r = C, p.g = w, p.b = T, p.a = E, p = p.next;
		for (var O = 0, k = 0, A = 0, j = 0, M = u * C, N = u * w, P = u * T, F = u * E, I = d * C, ee = d * w, L = d * T, R = d * E, te = 1; te < u; te++) {
			var z = y + ((c < te ? c : te) << 2), ne = o[z], re = o[z + 1], ie = o[z + 2], ae = o[z + 3], B = u - te;
			I += (p.r = ne) * B, ee += (p.g = re) * B, L += (p.b = ie) * B, R += (p.a = ae) * B, O += ne, k += re, A += ie, j += ae, p = p.next;
		}
		g = f, _ = m;
		for (var oe = 0; oe < r; oe++) {
			var se = R * b >>> x;
			if (o[y + 3] = se, se !== 0) {
				var ce = 255 / se;
				o[y] = (I * b >>> x) * ce, o[y + 1] = (ee * b >>> x) * ce, o[y + 2] = (L * b >>> x) * ce;
			} else o[y] = o[y + 1] = o[y + 2] = 0;
			I -= M, ee -= N, L -= P, R -= F, M -= g.r, N -= g.g, P -= g.b, F -= g.a;
			var le = oe + a + 1;
			le = v + (le < c ? le : c) << 2, O += g.r = o[le], k += g.g = o[le + 1], A += g.b = o[le + 2], j += g.a = o[le + 3], I += O, ee += k, L += A, R += j, g = g.next;
			var V = _, ue = V.r, de = V.g, fe = V.b, pe = V.a;
			M += ue, N += de, P += fe, F += pe, O -= ue, k -= de, A -= fe, j -= pe, _ = _.next, y += 4;
		}
		v += r;
	}
	for (var me = 0; me < r; me++) {
		y = me << 2;
		var he = o[y], ge = o[y + 1], _e = o[y + 2], ve = o[y + 3], ye = u * he, be = u * ge, xe = u * _e, Se = u * ve, Ce = d * he, we = d * ge, Te = d * _e, Ee = d * ve;
		p = f;
		for (var De = 0; De < u; De++) p.r = he, p.g = ge, p.b = _e, p.a = ve, p = p.next;
		for (var H = r, Oe = 0, ke = 0, Ae = 0, je = 0, Me = 1; Me <= a; Me++) {
			y = H + me << 2;
			var Ne = u - Me;
			Ce += (p.r = he = o[y]) * Ne, we += (p.g = ge = o[y + 1]) * Ne, Te += (p.b = _e = o[y + 2]) * Ne, Ee += (p.a = ve = o[y + 3]) * Ne, je += he, Oe += ge, ke += _e, Ae += ve, p = p.next, Me < l && (H += r);
		}
		y = me, g = f, _ = m;
		for (var Pe = 0; Pe < i; Pe++) {
			var Fe = y << 2;
			o[Fe + 3] = ve = Ee * b >>> x, ve > 0 ? (ve = 255 / ve, o[Fe] = (Ce * b >>> x) * ve, o[Fe + 1] = (we * b >>> x) * ve, o[Fe + 2] = (Te * b >>> x) * ve) : o[Fe] = o[Fe + 1] = o[Fe + 2] = 0, Ce -= ye, we -= be, Te -= xe, Ee -= Se, ye -= g.r, be -= g.g, xe -= g.b, Se -= g.a, Fe = me + ((Fe = Pe + u) < l ? Fe : l) * r << 2, Ce += je += g.r = o[Fe], we += Oe += g.g = o[Fe + 1], Te += ke += g.b = o[Fe + 2], Ee += Ae += g.a = o[Fe + 3], g = g.next, ye += he = _.r, be += ge = _.g, xe += _e = _.b, Se += ve = _.a, je -= he, Oe -= ge, ke -= _e, Ae -= ve, _ = _.next, y += r;
		}
	}
	return e;
}
var k_, A_, j_, M_ = o((() => {
	k_ = [
		512,
		512,
		456,
		512,
		328,
		456,
		335,
		512,
		405,
		328,
		271,
		456,
		388,
		335,
		292,
		512,
		454,
		405,
		364,
		328,
		298,
		271,
		496,
		456,
		420,
		388,
		360,
		335,
		312,
		292,
		273,
		512,
		482,
		454,
		428,
		405,
		383,
		364,
		345,
		328,
		312,
		298,
		284,
		271,
		259,
		496,
		475,
		456,
		437,
		420,
		404,
		388,
		374,
		360,
		347,
		335,
		323,
		312,
		302,
		292,
		282,
		273,
		265,
		512,
		497,
		482,
		468,
		454,
		441,
		428,
		417,
		405,
		394,
		383,
		373,
		364,
		354,
		345,
		337,
		328,
		320,
		312,
		305,
		298,
		291,
		284,
		278,
		271,
		265,
		259,
		507,
		496,
		485,
		475,
		465,
		456,
		446,
		437,
		428,
		420,
		412,
		404,
		396,
		388,
		381,
		374,
		367,
		360,
		354,
		347,
		341,
		335,
		329,
		323,
		318,
		312,
		307,
		302,
		297,
		292,
		287,
		282,
		278,
		273,
		269,
		265,
		261,
		512,
		505,
		497,
		489,
		482,
		475,
		468,
		461,
		454,
		447,
		441,
		435,
		428,
		422,
		417,
		411,
		405,
		399,
		394,
		389,
		383,
		378,
		373,
		368,
		364,
		359,
		354,
		350,
		345,
		341,
		337,
		332,
		328,
		324,
		320,
		316,
		312,
		309,
		305,
		301,
		298,
		294,
		291,
		287,
		284,
		281,
		278,
		274,
		271,
		268,
		265,
		262,
		259,
		257,
		507,
		501,
		496,
		491,
		485,
		480,
		475,
		470,
		465,
		460,
		456,
		451,
		446,
		442,
		437,
		433,
		428,
		424,
		420,
		416,
		412,
		408,
		404,
		400,
		396,
		392,
		388,
		385,
		381,
		377,
		374,
		370,
		367,
		363,
		360,
		357,
		354,
		350,
		347,
		344,
		341,
		338,
		335,
		332,
		329,
		326,
		323,
		320,
		318,
		315,
		312,
		310,
		307,
		304,
		302,
		299,
		297,
		294,
		292,
		289,
		287,
		285,
		282,
		280,
		278,
		275,
		273,
		271,
		269,
		267,
		265,
		263,
		261,
		259
	], A_ = [
		9,
		11,
		12,
		13,
		13,
		14,
		14,
		15,
		15,
		15,
		15,
		16,
		16,
		16,
		16,
		17,
		17,
		17,
		17,
		17,
		17,
		17,
		18,
		18,
		18,
		18,
		18,
		18,
		18,
		18,
		18,
		19,
		19,
		19,
		19,
		19,
		19,
		19,
		19,
		19,
		19,
		19,
		19,
		19,
		19,
		20,
		20,
		20,
		20,
		20,
		20,
		20,
		20,
		20,
		20,
		20,
		20,
		20,
		20,
		20,
		20,
		20,
		20,
		21,
		21,
		21,
		21,
		21,
		21,
		21,
		21,
		21,
		21,
		21,
		21,
		21,
		21,
		21,
		21,
		21,
		21,
		21,
		21,
		21,
		21,
		21,
		21,
		21,
		21,
		21,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		22,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		23,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24
	], j_ = function e() {
		T_(this, e), this.r = 0, this.g = 0, this.b = 0, this.a = 0, this.next = null;
	};
})), N_ = /* @__PURE__ */ c({
	AElement: () => ky,
	AnimateColorElement: () => Cy,
	AnimateElement: () => Sy,
	AnimateTransformElement: () => wy,
	BoundingBox: () => $v,
	CB1: () => J_,
	CB2: () => Y_,
	CB3: () => X_,
	CB4: () => Z_,
	Canvg: () => Xy,
	CircleElement: () => ly,
	ClipPathElement: () => By,
	DefsElement: () => gy,
	DescElement: () => qy,
	Document: () => Yy,
	Element: () => Xv,
	EllipseElement: () => uy,
	FeColorMatrixElement: () => Ly,
	FeCompositeElement: () => Wy,
	FeDropShadowElement: () => Hy,
	FeGaussianBlurElement: () => Gy,
	FeMorphologyElement: () => Uy,
	FilterElement: () => Vy,
	Font: () => Qv,
	FontElement: () => Ty,
	FontFaceElement: () => Ey,
	GElement: () => _y,
	GlyphElement: () => ry,
	GradientElement: () => vy,
	ImageElement: () => My,
	LineElement: () => dy,
	LinearGradientElement: () => yy,
	MarkerElement: () => hy,
	MaskElement: () => Ry,
	Matrix: () => Gv,
	MissingGlyphElement: () => Dy,
	Mouse: () => Fv,
	PSEUDO_ZERO: () => jv,
	Parser: () => Vv,
	PathElement: () => ny,
	PathParser: () => ey,
	PatternElement: () => my,
	Point: () => Pv,
	PolygonElement: () => py,
	PolylineElement: () => fy,
	Property: () => Mv,
	QB1: () => Q_,
	QB2: () => $_,
	QB3: () => ev,
	RadialGradientElement: () => by,
	RectElement: () => cy,
	RenderedElement: () => ty,
	Rotate: () => Uv,
	SVGElement: () => sy,
	SVGFontLoader: () => Py,
	Scale: () => Wv,
	Screen: () => Rv,
	Skew: () => Kv,
	SkewX: () => qv,
	SkewY: () => Jv,
	StopElement: () => xy,
	StyleElement: () => Fy,
	SymbolElement: () => Ny,
	TRefElement: () => Oy,
	TSpanElement: () => ay,
	TextElement: () => iy,
	TextPathElement: () => Ay,
	TitleElement: () => Ky,
	Transform: () => Yv,
	Translate: () => Hv,
	UnknownElement: () => Zv,
	UseElement: () => Iy,
	ViewPort: () => Nv,
	compressSpaces: () => I_,
	default: () => Xy,
	getSelectorSpecificity: () => W_,
	normalizeAttributeName: () => B_,
	normalizeColor: () => H_,
	parseExternalUrl: () => V_,
	presets: () => Sv,
	toNumbers: () => z_,
	trimLeft: () => L_,
	trimRight: () => R_,
	vectorMagnitude: () => G_,
	vectorsAngle: () => q_,
	vectorsRatio: () => K_
});
function P_() {
	var { DOMParser: e } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = {
		window: null,
		ignoreAnimation: !0,
		ignoreMouse: !0,
		DOMParser: e,
		createCanvas(e, t) {
			return new OffscreenCanvas(e, t);
		},
		createImage(e) {
			return Qh(function* () {
				var t = yield (yield fetch(e)).blob();
				return yield createImageBitmap(t);
			})();
		}
	};
	return (typeof DOMParser < "u" || e === void 0) && Reflect.deleteProperty(t, "DOMParser"), t;
}
function F_(e) {
	var { DOMParser: t, canvas: n, fetch: r } = e;
	return {
		window: null,
		ignoreAnimation: !0,
		ignoreMouse: !0,
		DOMParser: t,
		fetch: r,
		createCanvas: n.createCanvas,
		createImage: n.loadImage
	};
}
function I_(e) {
	return e.replace(/(?!\u3000)\s+/gm, " ");
}
function L_(e) {
	return e.replace(/^[\n \t]+/, "");
}
function R_(e) {
	return e.replace(/[\n \t]+$/, "");
}
function z_(e) {
	return ((e || "").match(/-?(\d+(?:\.\d*(?:[eE][+-]?\d+)?)?|\.\d+)(?=\D|$)/gm) || []).map(parseFloat);
}
function B_(e) {
	return Cv.test(e) ? e.toLowerCase() : e;
}
function V_(e) {
	var t = /url\(('([^']+)'|"([^"]+)"|([^'")]+))\)/.exec(e) || [];
	return t[2] || t[3] || t[4];
}
function H_(e) {
	if (!e.startsWith("rgb")) return e;
	var t = 3;
	return e.replace(/\d+(\.\d+)?/g, (e, n) => t-- && n ? String(Math.round(parseFloat(e))) : e);
}
function U_(e, t) {
	var n = t.exec(e);
	return n ? [e.replace(t, " "), n.length] : [e, 0];
}
function W_(e) {
	var t = [
		0,
		0,
		0
	], n = e.replace(/:not\(([^)]*)\)/g, "     $1 ").replace(/{[\s\S]*/gm, " "), r = 0;
	return [n, r] = U_(n, wv), t[1] += r, [n, r] = U_(n, Tv), t[0] += r, [n, r] = U_(n, Ev), t[1] += r, [n, r] = U_(n, Dv), t[2] += r, [n, r] = U_(n, Ov), t[1] += r, [n, r] = U_(n, kv), t[1] += r, n = n.replace(/[*\s+>~]/g, " ").replace(/[#.]/g, " "), [n, r] = U_(n, Av), t[2] += r, t.join("");
}
function G_(e) {
	return Math.sqrt(e[0] ** 2 + e[1] ** 2);
}
function K_(e, t) {
	return (e[0] * t[0] + e[1] * t[1]) / (G_(e) * G_(t));
}
function q_(e, t) {
	return (e[0] * t[1] < e[1] * t[0] ? -1 : 1) * Math.acos(K_(e, t));
}
function J_(e) {
	return e * e * e;
}
function Y_(e) {
	return 3 * e * e * (1 - e);
}
function X_(e) {
	return 3 * e * (1 - e) * (1 - e);
}
function Z_(e) {
	return (1 - e) * (1 - e) * (1 - e);
}
function Q_(e) {
	return e * e;
}
function $_(e) {
	return 2 * e * (1 - e);
}
function ev(e) {
	return (1 - e) * (1 - e);
}
function tv(e) {
	return I_(e).trim().replace(/\)([a-zA-Z])/g, ") $1").replace(/\)(\s?,\s?)/g, ") ").split(/\s(?=[a-z])/);
}
function nv(e) {
	var [t, n] = e.split("(");
	return [t.trim(), n.trim().replace(")", "")];
}
function rv(e) {
	var t = e.trim();
	return /^('|")/.test(t) ? t : `"${t}"`;
}
function iv(e) {
	return typeof process > "u" ? e : e.trim().split(",").map(rv).join(",");
}
function av(e) {
	if (!e) return "";
	var t = e.trim().toLowerCase();
	switch (t) {
		case "normal":
		case "italic":
		case "oblique":
		case "inherit":
		case "initial":
		case "unset": return t;
		default: return /^oblique\s+(-|)\d+deg$/.test(t) ? t : "";
	}
}
function ov(e) {
	if (!e) return "";
	var t = e.trim().toLowerCase();
	switch (t) {
		case "normal":
		case "bold":
		case "lighter":
		case "bolder":
		case "inherit":
		case "initial":
		case "unset": return t;
		default: return /^[\d.]+$/.test(t) ? t : "";
	}
}
function sv(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function cv(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? sv(Object(n), !0).forEach(function(t) {
			Rg(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : sv(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function lv(e, t, n, r, i, a) {
	return e[n * r * 4 + t * 4 + a];
}
function uv(e, t, n, r, i, a, o) {
	e[n * r * 4 + t * 4 + a] = o;
}
function dv(e, t, n) {
	return e[t] * n;
}
function fv(e, t, n, r) {
	return t + Math.cos(e) * n + Math.sin(e) * r;
}
function pv(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function mv(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? pv(Object(n), !0).forEach(function(t) {
			Rg(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : pv(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
function hv(e, t) {
	var n = document.createElement("canvas");
	return n.width = e, n.height = t, n;
}
function gv(e) {
	return _v.apply(this, arguments);
}
function _v() {
	return _v = Qh(function* (e) {
		var t = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], n = document.createElement("img");
		return t && (n.crossOrigin = "Anonymous"), new Promise((t, r) => {
			n.onload = () => {
				t(n);
			}, n.onerror = (e, t, n, i, a) => {
				r(a);
			}, n.src = e;
		});
	}), _v.apply(this, arguments);
}
function vv(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function yv(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? vv(Object(n), !0).forEach(function(t) {
			Rg(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : vv(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var bv, xv, Sv, Cv, wv, Tv, Ev, Dv, Ov, kv, Av, jv, Mv, Nv, Pv, Fv, Iv, Lv, Rv, zv, Bv, Vv, Hv, Uv, Wv, Gv, Kv, qv, Jv, Yv, Xv, Zv, Qv, $v, ey, ty, ny, ry, iy, ay, oy, sy, cy, ly, uy, dy, fy, py, my, hy, gy, _y, vy, yy, by, xy, Sy, Cy, wy, Ty, Ey, Dy, Oy, ky, Ay, jy, My, Ny, Py, Fy, Iy, Ly, Ry, zy, By, Vy, Hy, Uy, Wy, Gy, Ky, qy, Jy, Yy, Xy, Zy = o((() => {
	Xh(), $h(), gg(), vg(), Sg(), Ag(), Ng(), zg(), Hg(), Ug(), Wg(), bv = /* @__PURE__ */ u(Kg(), 1), Xg(), xv = /* @__PURE__ */ u(Zg(), 1), Qg(), $g(), t_(), S_(), C_(), M_(), Sv = /*#__PURE__*/ Object.freeze({
		__proto__: null,
		offscreen: P_,
		node: F_
	}), Cv = /^[A-Z-]+$/, wv = /(\[[^\]]+\])/g, Tv = /(#[^\s+>~.[:]+)/g, Ev = /(\.[^\s+>~.[:]+)/g, Dv = /(::[^\s+>~.[:]+|:first-line|:first-letter|:before|:after)/gi, Ov = /(:[\w-]+\([^)]*\))/gi, kv = /(:[^\s+>~.[:]+)/g, Av = /([^\s+>~.[:]+)/g, jv = 1e-8, Mv = class e {
		constructor(e, t, n) {
			this.document = e, this.name = t, this.value = n, this.isNormalizedColor = !1;
		}
		static empty(t) {
			return new e(t, "EMPTY", "");
		}
		split() {
			var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : " ", { document: n, name: r } = this;
			return I_(this.getString()).trim().split(t).map((t) => new e(n, r, t));
		}
		hasValue(e) {
			var { value: t } = this;
			return t !== null && t !== "" && (e || t !== 0) && t !== void 0;
		}
		isString(e) {
			var { value: t } = this, n = typeof t == "string";
			return !n || !e ? n : e.test(t);
		}
		isUrlDefinition() {
			return this.isString(/^url\(/);
		}
		isPixels() {
			if (!this.hasValue()) return !1;
			var e = this.getString();
			switch (!0) {
				case e.endsWith("px"):
				case /^[0-9]+$/.test(e): return !0;
				default: return !1;
			}
		}
		setValue(e) {
			return this.value = e, this;
		}
		getValue(e) {
			return e === void 0 || this.hasValue() ? this.value : e;
		}
		getNumber(e) {
			if (!this.hasValue()) return e === void 0 ? 0 : parseFloat(e);
			var { value: t } = this, n = parseFloat(t);
			return this.isString(/%$/) && (n /= 100), n;
		}
		getString(e) {
			return e === void 0 || this.hasValue() ? this.value === void 0 ? "" : String(this.value) : String(e);
		}
		getColor(e) {
			var t = this.getString(e);
			return this.isNormalizedColor ? t : (this.isNormalizedColor = !0, t = H_(t), this.value = t, t);
		}
		getDpi() {
			return 96;
		}
		getRem() {
			return this.document.rootEmSize;
		}
		getEm() {
			return this.document.emSize;
		}
		getUnits() {
			return this.getString().replace(/[0-9.-]/g, "");
		}
		getPixels(e) {
			var t = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
			if (!this.hasValue()) return 0;
			var [n, r] = typeof e == "boolean" ? [void 0, e] : [e], { viewPort: i } = this.document.screen;
			switch (!0) {
				case this.isString(/vmin$/): return this.getNumber() / 100 * Math.min(i.computeSize("x"), i.computeSize("y"));
				case this.isString(/vmax$/): return this.getNumber() / 100 * Math.max(i.computeSize("x"), i.computeSize("y"));
				case this.isString(/vw$/): return this.getNumber() / 100 * i.computeSize("x");
				case this.isString(/vh$/): return this.getNumber() / 100 * i.computeSize("y");
				case this.isString(/rem$/): return this.getNumber() * this.getRem();
				case this.isString(/em$/): return this.getNumber() * this.getEm();
				case this.isString(/ex$/): return this.getNumber() * this.getEm() / 2;
				case this.isString(/px$/): return this.getNumber();
				case this.isString(/pt$/): return this.getNumber() * this.getDpi() * (1 / 72);
				case this.isString(/pc$/): return this.getNumber() * 15;
				case this.isString(/cm$/): return this.getNumber() * this.getDpi() / 2.54;
				case this.isString(/mm$/): return this.getNumber() * this.getDpi() / 25.4;
				case this.isString(/in$/): return this.getNumber() * this.getDpi();
				case this.isString(/%$/) && r: return this.getNumber() * this.getEm();
				case this.isString(/%$/): return this.getNumber() * i.computeSize(n);
				default:
					var a = this.getNumber();
					return t && a < 1 ? a * i.computeSize(n) : a;
			}
		}
		getMilliseconds() {
			return this.hasValue() ? this.isString(/ms$/) ? this.getNumber() : this.getNumber() * 1e3 : 0;
		}
		getRadians() {
			if (!this.hasValue()) return 0;
			switch (!0) {
				case this.isString(/deg$/): return this.getNumber() * (Math.PI / 180);
				case this.isString(/grad$/): return this.getNumber() * (Math.PI / 200);
				case this.isString(/rad$/): return this.getNumber();
				default: return this.getNumber() * (Math.PI / 180);
			}
		}
		getDefinition() {
			var e = this.getString(), t = /#([^)'"]+)/.exec(e);
			return t &&= t[1], t ||= e, this.document.definitions[t];
		}
		getFillStyleDefinition(e, t) {
			var n = this.getDefinition();
			if (!n) return null;
			if (typeof n.createGradient == "function") return n.createGradient(this.document.ctx, e, t);
			if (typeof n.createPattern == "function") {
				if (n.getHrefAttribute().hasValue()) {
					var r = n.getAttribute("patternTransform");
					n = n.getHrefAttribute().getDefinition(), r.hasValue() && n.getAttribute("patternTransform", !0).setValue(r.value);
				}
				return n.createPattern(this.document.ctx, e, t);
			}
			return null;
		}
		getTextBaseline() {
			return this.hasValue() ? e.textBaselineMapping[this.getString()] : null;
		}
		addOpacity(t) {
			for (var n = this.getColor(), r = n.length, i = 0, a = 0; a < r && (n[a] === "," && i++, i !== 3); a++);
			if (t.hasValue() && this.isString() && i !== 3) {
				var o = new xv.default(n);
				o.ok && (o.alpha = t.getNumber(), n = o.toRGBA());
			}
			return new e(this.document, this.name, n);
		}
	}, Mv.textBaselineMapping = {
		baseline: "alphabetic",
		"before-edge": "top",
		"text-before-edge": "top",
		middle: "middle",
		central: "middle",
		"after-edge": "bottom",
		"text-after-edge": "bottom",
		ideographic: "ideographic",
		alphabetic: "alphabetic",
		hanging: "hanging",
		mathematical: "alphabetic"
	}, Nv = class {
		constructor() {
			this.viewPorts = [];
		}
		clear() {
			this.viewPorts = [];
		}
		setCurrent(e, t) {
			this.viewPorts.push({
				width: e,
				height: t
			});
		}
		removeCurrent() {
			this.viewPorts.pop();
		}
		getCurrent() {
			var { viewPorts: e } = this;
			return e[e.length - 1];
		}
		get width() {
			return this.getCurrent().width;
		}
		get height() {
			return this.getCurrent().height;
		}
		computeSize(e) {
			return typeof e == "number" ? e : e === "x" ? this.width : e === "y" ? this.height : Math.sqrt(this.width ** 2 + this.height ** 2) / Math.sqrt(2);
		}
	}, Pv = class e {
		constructor(e, t) {
			this.x = e, this.y = t;
		}
		static parse(t) {
			var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, [r = n, i = n] = z_(t);
			return new e(r, i);
		}
		static parseScale(t) {
			var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, [r = n, i = r] = z_(t);
			return new e(r, i);
		}
		static parsePath(t) {
			for (var n = z_(t), r = n.length, i = [], a = 0; a < r; a += 2) i.push(new e(n[a], n[a + 1]));
			return i;
		}
		angleTo(e) {
			return Math.atan2(e.y - this.y, e.x - this.x);
		}
		applyTransform(e) {
			var { x: t, y: n } = this, r = t * e[0] + n * e[2] + e[4], i = t * e[1] + n * e[3] + e[5];
			this.x = r, this.y = i;
		}
	}, Fv = class {
		constructor(e) {
			this.screen = e, this.working = !1, this.events = [], this.eventElements = [], this.onClick = this.onClick.bind(this), this.onMouseMove = this.onMouseMove.bind(this);
		}
		isWorking() {
			return this.working;
		}
		start() {
			if (!this.working) {
				var { screen: e, onClick: t, onMouseMove: n } = this, r = e.ctx.canvas;
				r.onclick = t, r.onmousemove = n, this.working = !0;
			}
		}
		stop() {
			if (this.working) {
				var e = this.screen.ctx.canvas;
				this.working = !1, e.onclick = null, e.onmousemove = null;
			}
		}
		hasEvents() {
			return this.working && this.events.length > 0;
		}
		runEvents() {
			if (this.working) {
				var { screen: e, events: t, eventElements: n } = this, { style: r } = e.ctx.canvas;
				r && (r.cursor = ""), t.forEach((e, t) => {
					for (var { run: r } = e, i = n[t]; i;) r(i), i = i.parent;
				}), this.events = [], this.eventElements = [];
			}
		}
		checkPath(e, t) {
			if (!(!this.working || !t)) {
				var { events: n, eventElements: r } = this;
				n.forEach((n, i) => {
					var { x: a, y: o } = n;
					!r[i] && t.isPointInPath && t.isPointInPath(a, o) && (r[i] = e);
				});
			}
		}
		checkBoundingBox(e, t) {
			if (!(!this.working || !t)) {
				var { events: n, eventElements: r } = this;
				n.forEach((n, i) => {
					var { x: a, y: o } = n;
					!r[i] && t.isPointInBox(a, o) && (r[i] = e);
				});
			}
		}
		mapXY(e, t) {
			for (var { window: n, ctx: r } = this.screen, i = new Pv(e, t), a = r.canvas; a;) i.x -= a.offsetLeft, i.y -= a.offsetTop, a = a.offsetParent;
			return n.scrollX && (i.x += n.scrollX), n.scrollY && (i.y += n.scrollY), i;
		}
		onClick(e) {
			var { x: t, y: n } = this.mapXY(e.clientX, e.clientY);
			this.events.push({
				type: "onclick",
				x: t,
				y: n,
				run(e) {
					e.onClick && e.onClick();
				}
			});
		}
		onMouseMove(e) {
			var { x: t, y: n } = this.mapXY(e.clientX, e.clientY);
			this.events.push({
				type: "onmousemove",
				x: t,
				y: n,
				run(e) {
					e.onMouseMove && e.onMouseMove();
				}
			});
		}
	}, Iv = typeof window < "u" ? window : null, Lv = typeof fetch < "u" ? fetch.bind(void 0) : null, Rv = class {
		constructor(e) {
			var { fetch: t = Lv, window: n = Iv } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
			this.ctx = e, this.FRAMERATE = 30, this.MAX_VIRTUAL_PIXELS = 3e4, this.CLIENT_WIDTH = 800, this.CLIENT_HEIGHT = 600, this.viewPort = new Nv(), this.mouse = new Fv(this), this.animations = [], this.waits = [], this.frameDuration = 0, this.isReadyLock = !1, this.isFirstRender = !0, this.intervalId = null, this.window = n, this.fetch = t;
		}
		wait(e) {
			this.waits.push(e);
		}
		ready() {
			return this.readyPromise ? this.readyPromise : Promise.resolve();
		}
		isReady() {
			if (this.isReadyLock) return !0;
			var e = this.waits.every((e) => e());
			return e && (this.waits = [], this.resolveReady && this.resolveReady()), this.isReadyLock = e, e;
		}
		setDefaults(e) {
			e.strokeStyle = "rgba(0,0,0,0)", e.lineCap = "butt", e.lineJoin = "miter", e.miterLimit = 4;
		}
		setViewBox(e) {
			var { document: t, ctx: n, aspectRatio: r, width: i, desiredWidth: a, height: o, desiredHeight: s, minX: c = 0, minY: l = 0, refX: u, refY: d, clip: f = !1, clipX: p = 0, clipY: m = 0 } = e, [h, g] = I_(r).replace(/^defer\s/, "").split(" "), _ = h || "xMidYMid", v = g || "meet", y = i / a, b = o / s, x = Math.min(y, b), S = Math.max(y, b), C = a, w = s;
			v === "meet" && (C *= x, w *= x), v === "slice" && (C *= S, w *= S);
			var T = new Mv(t, "refX", u), E = new Mv(t, "refY", d), D = T.hasValue() && E.hasValue();
			if (D && n.translate(-x * T.getPixels("x"), -x * E.getPixels("y")), f) {
				var O = x * p, k = x * m;
				n.beginPath(), n.moveTo(O, k), n.lineTo(i, k), n.lineTo(i, o), n.lineTo(O, o), n.closePath(), n.clip();
			}
			if (!D) {
				var A = v === "meet" && x === b, j = v === "slice" && S === b, M = v === "meet" && x === y, N = v === "slice" && S === y;
				_.startsWith("xMid") && (A || j) && n.translate(i / 2 - C / 2, 0), _.endsWith("YMid") && (M || N) && n.translate(0, o / 2 - w / 2), _.startsWith("xMax") && (A || j) && n.translate(i - C, 0), _.endsWith("YMax") && (M || N) && n.translate(0, o - w);
			}
			switch (!0) {
				case _ === "none":
					n.scale(y, b);
					break;
				case v === "meet":
					n.scale(x, x);
					break;
				case v === "slice":
					n.scale(S, S);
					break;
			}
			n.translate(-c, -l);
		}
		start(e) {
			var { enableRedraw: t = !1, ignoreMouse: n = !1, ignoreAnimation: r = !1, ignoreDimensions: i = !1, ignoreClear: a = !1, forceRedraw: o, scaleWidth: s, scaleHeight: c, offsetX: l, offsetY: u } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { FRAMERATE: d, mouse: f } = this, p = 1e3 / d;
			if (this.frameDuration = p, this.readyPromise = new Promise((e) => {
				this.resolveReady = e;
			}), this.isReady() && this.render(e, i, a, s, c, l, u), t) {
				var m = Date.now(), h = m, g = 0, _ = () => {
					m = Date.now(), g = m - h, g >= p && (h = m - g % p, this.shouldUpdate(r, o) && (this.render(e, i, a, s, c, l, u), f.runEvents())), this.intervalId = (0, bv.default)(_);
				};
				n || f.start(), this.intervalId = (0, bv.default)(_);
			}
		}
		stop() {
			this.intervalId &&= (bv.default.cancel(this.intervalId), null), this.mouse.stop();
		}
		shouldUpdate(e, t) {
			if (!e) {
				var { frameDuration: n } = this;
				if (this.animations.reduce((e, t) => t.update(n) || e, !1)) return !0;
			}
			return !!(typeof t == "function" && t() || !this.isReadyLock && this.isReady() || this.mouse.hasEvents());
		}
		render(e, t, n, r, i, a, o) {
			var { CLIENT_WIDTH: s, CLIENT_HEIGHT: c, viewPort: l, ctx: u, isFirstRender: d } = this, f = u.canvas;
			l.clear(), f.width && f.height ? l.setCurrent(f.width, f.height) : l.setCurrent(s, c);
			var p = e.getStyle("width"), m = e.getStyle("height");
			!t && (d || typeof r != "number" && typeof i != "number") && (p.hasValue() && (f.width = p.getPixels("x"), f.style && (f.style.width = `${f.width}px`)), m.hasValue() && (f.height = m.getPixels("y"), f.style && (f.style.height = `${f.height}px`)));
			var h = f.clientWidth || f.width, g = f.clientHeight || f.height;
			if (t && p.hasValue() && m.hasValue() && (h = p.getPixels("x"), g = m.getPixels("y")), l.setCurrent(h, g), typeof a == "number" && e.getAttribute("x", !0).setValue(a), typeof o == "number" && e.getAttribute("y", !0).setValue(o), typeof r == "number" || typeof i == "number") {
				var _ = z_(e.getAttribute("viewBox").getString()), v = 0, y = 0;
				if (typeof r == "number") {
					var b = e.getStyle("width");
					b.hasValue() ? v = b.getPixels("x") / r : isNaN(_[2]) || (v = _[2] / r);
				}
				if (typeof i == "number") {
					var x = e.getStyle("height");
					x.hasValue() ? y = x.getPixels("y") / i : isNaN(_[3]) || (y = _[3] / i);
				}
				v ||= y, y ||= v, e.getAttribute("width", !0).setValue(r), e.getAttribute("height", !0).setValue(i);
				var S = e.getStyle("transform", !0, !0);
				S.setValue(`${S.getString()} scale(${1 / v}, ${1 / y})`);
			}
			n || u.clearRect(0, 0, h, g), e.render(u), d && (this.isFirstRender = !1);
		}
	}, Rv.defaultWindow = Iv, Rv.defaultFetch = Lv, {defaultFetch: zv} = Rv, Bv = typeof DOMParser < "u" ? DOMParser : null, Vv = class {
		constructor() {
			var { fetch: e = zv, DOMParser: t = Bv } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
			this.fetch = e, this.DOMParser = t;
		}
		parse(e) {
			var t = this;
			return Qh(function* () {
				return e.startsWith("<") ? t.parseFromString(e) : t.load(e);
			})();
		}
		parseFromString(e) {
			var t = new this.DOMParser();
			try {
				return this.checkDocument(t.parseFromString(e, "image/svg+xml"));
			} catch {
				return this.checkDocument(t.parseFromString(e, "text/xml"));
			}
		}
		checkDocument(e) {
			var t = e.getElementsByTagName("parsererror")[0];
			if (t) throw Error(t.textContent);
			return e;
		}
		load(e) {
			var t = this;
			return Qh(function* () {
				var n = yield (yield t.fetch(e)).text();
				return t.parseFromString(n);
			})();
		}
	}, Hv = class {
		constructor(e, t) {
			this.type = "translate", this.point = null, this.point = Pv.parse(t);
		}
		apply(e) {
			var { x: t, y: n } = this.point;
			e.translate(t || 0, n || 0);
		}
		unapply(e) {
			var { x: t, y: n } = this.point;
			e.translate(-1 * t || 0, -1 * n || 0);
		}
		applyToPoint(e) {
			var { x: t, y: n } = this.point;
			e.applyTransform([
				1,
				0,
				0,
				1,
				t || 0,
				n || 0
			]);
		}
	}, Uv = class {
		constructor(e, t, n) {
			this.type = "rotate", this.angle = null, this.originX = null, this.originY = null, this.cx = 0, this.cy = 0;
			var r = z_(t);
			this.angle = new Mv(e, "angle", r[0]), this.originX = n[0], this.originY = n[1], this.cx = r[1] || 0, this.cy = r[2] || 0;
		}
		apply(e) {
			var { cx: t, cy: n, originX: r, originY: i, angle: a } = this, o = t + r.getPixels("x"), s = n + i.getPixels("y");
			e.translate(o, s), e.rotate(a.getRadians()), e.translate(-o, -s);
		}
		unapply(e) {
			var { cx: t, cy: n, originX: r, originY: i, angle: a } = this, o = t + r.getPixels("x"), s = n + i.getPixels("y");
			e.translate(o, s), e.rotate(-1 * a.getRadians()), e.translate(-o, -s);
		}
		applyToPoint(e) {
			var { cx: t, cy: n, angle: r } = this, i = r.getRadians();
			e.applyTransform([
				1,
				0,
				0,
				1,
				t || 0,
				n || 0
			]), e.applyTransform([
				Math.cos(i),
				Math.sin(i),
				-Math.sin(i),
				Math.cos(i),
				0,
				0
			]), e.applyTransform([
				1,
				0,
				0,
				1,
				-t || 0,
				-n || 0
			]);
		}
	}, Wv = class {
		constructor(e, t, n) {
			this.type = "scale", this.scale = null, this.originX = null, this.originY = null;
			var r = Pv.parseScale(t);
			(r.x === 0 || r.y === 0) && (r.x = jv, r.y = jv), this.scale = r, this.originX = n[0], this.originY = n[1];
		}
		apply(e) {
			var { scale: { x: t, y: n }, originX: r, originY: i } = this, a = r.getPixels("x"), o = i.getPixels("y");
			e.translate(a, o), e.scale(t, n || t), e.translate(-a, -o);
		}
		unapply(e) {
			var { scale: { x: t, y: n }, originX: r, originY: i } = this, a = r.getPixels("x"), o = i.getPixels("y");
			e.translate(a, o), e.scale(1 / t, 1 / n || t), e.translate(-a, -o);
		}
		applyToPoint(e) {
			var { x: t, y: n } = this.scale;
			e.applyTransform([
				t || 0,
				0,
				0,
				n || 0,
				0,
				0
			]);
		}
	}, Gv = class {
		constructor(e, t, n) {
			this.type = "matrix", this.matrix = [], this.originX = null, this.originY = null, this.matrix = z_(t), this.originX = n[0], this.originY = n[1];
		}
		apply(e) {
			var { originX: t, originY: n, matrix: r } = this, i = t.getPixels("x"), a = n.getPixels("y");
			e.translate(i, a), e.transform(r[0], r[1], r[2], r[3], r[4], r[5]), e.translate(-i, -a);
		}
		unapply(e) {
			var { originX: t, originY: n, matrix: r } = this, i = r[0], a = r[2], o = r[4], s = r[1], c = r[3], l = r[5], u = 0, d = 0, f = 1, p = 1 / (i * (c * f - l * d) - a * (s * f - l * u) + o * (s * d - c * u)), m = t.getPixels("x"), h = n.getPixels("y");
			e.translate(m, h), e.transform(p * (c * f - l * d), p * (l * u - s * f), p * (o * d - a * f), p * (i * f - o * u), p * (a * l - o * c), p * (o * s - i * l)), e.translate(-m, -h);
		}
		applyToPoint(e) {
			e.applyTransform(this.matrix);
		}
	}, Kv = class extends Gv {
		constructor(e, t, n) {
			super(e, t, n), this.type = "skew", this.angle = null, this.angle = new Mv(e, "angle", t);
		}
	}, qv = class extends Kv {
		constructor(e, t, n) {
			super(e, t, n), this.type = "skewX", this.matrix = [
				1,
				0,
				Math.tan(this.angle.getRadians()),
				1,
				0,
				0
			];
		}
	}, Jv = class extends Kv {
		constructor(e, t, n) {
			super(e, t, n), this.type = "skewY", this.matrix = [
				1,
				Math.tan(this.angle.getRadians()),
				0,
				1,
				0,
				0
			];
		}
	}, Yv = class e {
		constructor(t, n, r) {
			this.document = t, this.transforms = [], tv(n).forEach((t) => {
				if (t !== "none") {
					var [n, i] = nv(t), a = e.transformTypes[n];
					a !== void 0 && this.transforms.push(new a(this.document, i, r));
				}
			});
		}
		static fromElement(t, n) {
			var r = n.getStyle("transform", !1, !0), [i, a = i] = n.getStyle("transform-origin", !1, !0).split(), o = [i, a];
			return r.hasValue() ? new e(t, r.getString(), o) : null;
		}
		apply(e) {
			for (var { transforms: t } = this, n = t.length, r = 0; r < n; r++) t[r].apply(e);
		}
		unapply(e) {
			for (var { transforms: t } = this, n = t.length - 1; n >= 0; n--) t[n].unapply(e);
		}
		applyToPoint(e) {
			for (var { transforms: t } = this, n = t.length, r = 0; r < n; r++) t[r].applyToPoint(e);
		}
	}, Yv.transformTypes = {
		translate: Hv,
		rotate: Uv,
		scale: Wv,
		matrix: Gv,
		skewX: qv,
		skewY: Jv
	}, Xv = class e {
		constructor(e, t) {
			var n = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
			if (this.document = e, this.node = t, this.captureTextNodes = n, this.attributes = Object.create(null), this.styles = Object.create(null), this.stylesSpecificity = Object.create(null), this.animationFrozen = !1, this.animationFrozenValue = "", this.parent = null, this.children = [], !(!t || t.nodeType !== 1)) {
				Array.from(t.attributes).forEach((t) => {
					var n = B_(t.nodeName);
					this.attributes[n] = new Mv(e, n, t.value);
				}), this.addStylesFromStyleDefinition(), this.getAttribute("style").hasValue() && this.getAttribute("style").getString().split(";").map((e) => e.trim()).forEach((t) => {
					if (t) {
						var [n, r] = t.split(":").map((e) => e.trim());
						this.styles[n] = new Mv(e, n, r);
					}
				});
				var { definitions: r } = e, i = this.getAttribute("id");
				i.hasValue() && (r[i.getString()] || (r[i.getString()] = this)), Array.from(t.childNodes).forEach((t) => {
					if (t.nodeType === 1) this.addChild(t);
					else if (n && (t.nodeType === 3 || t.nodeType === 4)) {
						var r = e.createTextNode(t);
						r.getText().length > 0 && this.addChild(r);
					}
				});
			}
		}
		getAttribute(e) {
			var t = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], n = this.attributes[e];
			if (!n && t) {
				var r = new Mv(this.document, e, "");
				return this.attributes[e] = r, r;
			}
			return n || Mv.empty(this.document);
		}
		getHrefAttribute() {
			for (var e in this.attributes) if (e === "href" || e.endsWith(":href")) return this.attributes[e];
			return Mv.empty(this.document);
		}
		getStyle(e) {
			var t = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], n = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], r = this.styles[e];
			if (r) return r;
			var i = this.getAttribute(e);
			if (i != null && i.hasValue()) return this.styles[e] = i, i;
			if (!n) {
				var { parent: a } = this;
				if (a) {
					var o = a.getStyle(e);
					if (o != null && o.hasValue()) return o;
				}
			}
			if (t) {
				var s = new Mv(this.document, e, "");
				return this.styles[e] = s, s;
			}
			return r || Mv.empty(this.document);
		}
		render(e) {
			if (!(this.getStyle("display").getString() === "none" || this.getStyle("visibility").getString() === "hidden")) {
				if (e.save(), this.getStyle("mask").hasValue()) {
					var t = this.getStyle("mask").getDefinition();
					t && (this.applyEffects(e), t.apply(e, this));
				} else if (this.getStyle("filter").getValue("none") !== "none") {
					var n = this.getStyle("filter").getDefinition();
					n && (this.applyEffects(e), n.apply(e, this));
				} else this.setContext(e), this.renderChildren(e), this.clearContext(e);
				e.restore();
			}
		}
		setContext(e) {}
		applyEffects(e) {
			var t = Yv.fromElement(this.document, this);
			t && t.apply(e);
			var n = this.getStyle("clip-path", !1, !0);
			if (n.hasValue()) {
				var r = n.getDefinition();
				r && r.apply(e);
			}
		}
		clearContext(e) {}
		renderChildren(e) {
			this.children.forEach((t) => {
				t.render(e);
			});
		}
		addChild(t) {
			var n = t instanceof e ? t : this.document.createElement(t);
			n.parent = this, e.ignoreChildTypes.includes(n.type) || this.children.push(n);
		}
		matchesSelector(e) {
			var { node: t } = this;
			if (typeof t.matches == "function") return t.matches(e);
			var n = t.getAttribute?.call(t, "class");
			return !n || n === "" ? !1 : n.split(" ").some((t) => `.${t}` === e);
		}
		addStylesFromStyleDefinition() {
			var { styles: e, stylesSpecificity: t } = this.document;
			for (var n in e) if (!n.startsWith("@") && this.matchesSelector(n)) {
				var r = e[n], i = t[n];
				if (r) for (var a in r) {
					var o = this.stylesSpecificity[a];
					o === void 0 && (o = "000"), i >= o && (this.styles[a] = r[a], this.stylesSpecificity[a] = i);
				}
			}
		}
		removeStyles(e, t) {
			return t.reduce((t, n) => {
				var r = e.getStyle(n);
				if (!r.hasValue()) return t;
				var i = r.getString();
				return r.setValue(""), [...t, [n, i]];
			}, []);
		}
		restoreStyles(e, t) {
			t.forEach((t) => {
				var [n, r] = t;
				e.getStyle(n, !0).setValue(r);
			});
		}
		isFirstChild() {
			return this.parent?.children.indexOf(this) === 0;
		}
	}, Xv.ignoreChildTypes = ["title"], Zv = class extends Xv {
		constructor(e, t, n) {
			super(e, t, n);
		}
	}, Qv = class e {
		constructor(t, n, r, i, a, o) {
			var s = o ? typeof o == "string" ? e.parse(o) : o : {};
			this.fontFamily = a || s.fontFamily, this.fontSize = i || s.fontSize, this.fontStyle = t || s.fontStyle, this.fontWeight = r || s.fontWeight, this.fontVariant = n || s.fontVariant;
		}
		static parse() {
			var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = arguments.length > 1 ? arguments[1] : void 0, r = "", i = "", a = "", o = "", s = "", c = I_(t).trim().split(" "), l = {
				fontSize: !1,
				fontStyle: !1,
				fontWeight: !1,
				fontVariant: !1
			};
			return c.forEach((t) => {
				switch (!0) {
					case !l.fontStyle && e.styles.includes(t):
						t !== "inherit" && (r = t), l.fontStyle = !0;
						break;
					case !l.fontVariant && e.variants.includes(t):
						t !== "inherit" && (i = t), l.fontStyle = !0, l.fontVariant = !0;
						break;
					case !l.fontWeight && e.weights.includes(t):
						t !== "inherit" && (a = t), l.fontStyle = !0, l.fontVariant = !0, l.fontWeight = !0;
						break;
					case !l.fontSize:
						t !== "inherit" && ([o] = t.split("/")), l.fontStyle = !0, l.fontVariant = !0, l.fontWeight = !0, l.fontSize = !0;
						break;
					default: t !== "inherit" && (s += t);
				}
			}), new e(r, i, a, o, s, n);
		}
		toString() {
			return [
				av(this.fontStyle),
				this.fontVariant,
				ov(this.fontWeight),
				this.fontSize,
				iv(this.fontFamily)
			].join(" ").trim();
		}
	}, Qv.styles = "normal|italic|oblique|inherit", Qv.variants = "normal|small-caps|inherit", Qv.weights = "normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900|inherit", $v = class {
		constructor() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : NaN, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : NaN, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : NaN, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : NaN;
			this.x1 = e, this.y1 = t, this.x2 = n, this.y2 = r, this.addPoint(e, t), this.addPoint(n, r);
		}
		get x() {
			return this.x1;
		}
		get y() {
			return this.y1;
		}
		get width() {
			return this.x2 - this.x1;
		}
		get height() {
			return this.y2 - this.y1;
		}
		addPoint(e, t) {
			e !== void 0 && ((isNaN(this.x1) || isNaN(this.x2)) && (this.x1 = e, this.x2 = e), e < this.x1 && (this.x1 = e), e > this.x2 && (this.x2 = e)), t !== void 0 && ((isNaN(this.y1) || isNaN(this.y2)) && (this.y1 = t, this.y2 = t), t < this.y1 && (this.y1 = t), t > this.y2 && (this.y2 = t));
		}
		addX(e) {
			this.addPoint(e, null);
		}
		addY(e) {
			this.addPoint(null, e);
		}
		addBoundingBox(e) {
			if (e) {
				var { x1: t, y1: n, x2: r, y2: i } = e;
				this.addPoint(t, n), this.addPoint(r, i);
			}
		}
		sumCubic(e, t, n, r, i) {
			return (1 - e) ** 3 * t + 3 * (1 - e) ** 2 * e * n + 3 * (1 - e) * e ** 2 * r + e ** 3 * i;
		}
		bezierCurveAdd(e, t, n, r, i) {
			var a = 6 * t - 12 * n + 6 * r, o = -3 * t + 9 * n - 9 * r + 3 * i, s = 3 * n - 3 * t;
			if (o === 0) {
				if (a === 0) return;
				var c = -s / a;
				0 < c && c < 1 && (e ? this.addX(this.sumCubic(c, t, n, r, i)) : this.addY(this.sumCubic(c, t, n, r, i)));
				return;
			}
			var l = a ** 2 - 4 * s * o;
			if (!(l < 0)) {
				var u = (-a + Math.sqrt(l)) / (2 * o);
				0 < u && u < 1 && (e ? this.addX(this.sumCubic(u, t, n, r, i)) : this.addY(this.sumCubic(u, t, n, r, i)));
				var d = (-a - Math.sqrt(l)) / (2 * o);
				0 < d && d < 1 && (e ? this.addX(this.sumCubic(d, t, n, r, i)) : this.addY(this.sumCubic(d, t, n, r, i)));
			}
		}
		addBezierCurve(e, t, n, r, i, a, o, s) {
			this.addPoint(e, t), this.addPoint(o, s), this.bezierCurveAdd(!0, e, n, i, o), this.bezierCurveAdd(!1, t, r, a, s);
		}
		addQuadraticCurve(e, t, n, r, i, a) {
			var o = e + 2 / 3 * (n - e), s = t + 2 / 3 * (r - t), c = o + 1 / 3 * (i - e), l = s + 1 / 3 * (a - t);
			this.addBezierCurve(e, t, o, c, s, l, i, a);
		}
		isPointInBox(e, t) {
			var { x1: n, y1: r, x2: i, y2: a } = this;
			return n <= e && e <= i && r <= t && t <= a;
		}
	}, ey = class extends X {
		constructor(e) {
			super(e.replace(/([+\-.])\s+/gm, "$1").replace(/[^MmZzLlHhVvCcSsQqTtAae\d\s.,+-].*/g, "")), this.control = null, this.start = null, this.current = null, this.command = null, this.commands = this.commands, this.i = -1, this.previousCommand = null, this.points = [], this.angles = [];
		}
		reset() {
			this.i = -1, this.command = null, this.previousCommand = null, this.start = new Pv(0, 0), this.control = new Pv(0, 0), this.current = new Pv(0, 0), this.points = [], this.angles = [];
		}
		isEnd() {
			var { i: e, commands: t } = this;
			return e >= t.length - 1;
		}
		next() {
			var e = this.commands[++this.i];
			return this.previousCommand = this.command, this.command = e, e;
		}
		getPoint() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "x", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "y", n = new Pv(this.command[e], this.command[t]);
			return this.makeAbsolute(n);
		}
		getAsControlPoint(e, t) {
			var n = this.getPoint(e, t);
			return this.control = n, n;
		}
		getAsCurrentPoint(e, t) {
			var n = this.getPoint(e, t);
			return this.current = n, n;
		}
		getReflectedControlPoint() {
			var e = this.previousCommand.type;
			if (e !== X.CURVE_TO && e !== X.SMOOTH_CURVE_TO && e !== X.QUAD_TO && e !== X.SMOOTH_QUAD_TO) return this.current;
			var { current: { x: t, y: n }, control: { x: r, y: i } } = this;
			return new Pv(2 * t - r, 2 * n - i);
		}
		makeAbsolute(e) {
			if (this.command.relative) {
				var { x: t, y: n } = this.current;
				e.x += t, e.y += n;
			}
			return e;
		}
		addMarker(e, t, n) {
			var { points: r, angles: i } = this;
			n && i.length > 0 && !i[i.length - 1] && (i[i.length - 1] = r[r.length - 1].angleTo(n)), this.addMarkerAngle(e, t ? t.angleTo(e) : null);
		}
		addMarkerAngle(e, t) {
			this.points.push(e), this.angles.push(t);
		}
		getMarkerPoints() {
			return this.points;
		}
		getMarkerAngles() {
			for (var { angles: e } = this, t = e.length, n = 0; n < t; n++) if (!e[n]) {
				for (var r = n + 1; r < t; r++) if (e[r]) {
					e[n] = e[r];
					break;
				}
			}
			return e;
		}
	}, ty = class extends Xv {
		constructor() {
			super(...arguments), this.modifiedEmSizeStack = !1;
		}
		calculateOpacity() {
			for (var e = 1, t = this; t;) {
				var n = t.getStyle("opacity", !1, !0);
				n.hasValue(!0) && (e *= n.getNumber()), t = t.parent;
			}
			return e;
		}
		setContext(e) {
			var t = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
			if (!t) {
				var n = this.getStyle("fill"), r = this.getStyle("fill-opacity"), i = this.getStyle("stroke"), a = this.getStyle("stroke-opacity");
				if (n.isUrlDefinition()) {
					var o = n.getFillStyleDefinition(this, r);
					o && (e.fillStyle = o);
				} else if (n.hasValue()) {
					n.getString() === "currentColor" && n.setValue(this.getStyle("color").getColor());
					var s = n.getColor();
					s !== "inherit" && (e.fillStyle = s === "none" ? "rgba(0,0,0,0)" : s);
				}
				if (r.hasValue() && (e.fillStyle = new Mv(this.document, "fill", e.fillStyle).addOpacity(r).getColor()), i.isUrlDefinition()) {
					var c = i.getFillStyleDefinition(this, a);
					c && (e.strokeStyle = c);
				} else if (i.hasValue()) {
					i.getString() === "currentColor" && i.setValue(this.getStyle("color").getColor());
					var l = i.getString();
					l !== "inherit" && (e.strokeStyle = l === "none" ? "rgba(0,0,0,0)" : l);
				}
				a.hasValue() && (e.strokeStyle = new Mv(this.document, "stroke", e.strokeStyle).addOpacity(a).getString());
				var u = this.getStyle("stroke-width");
				u.hasValue() && (e.lineWidth = u.getPixels() || jv);
				var d = this.getStyle("stroke-linecap"), f = this.getStyle("stroke-linejoin"), p = this.getStyle("stroke-miterlimit"), m = this.getStyle("stroke-dasharray"), h = this.getStyle("stroke-dashoffset");
				if (d.hasValue() && (e.lineCap = d.getString()), f.hasValue() && (e.lineJoin = f.getString()), p.hasValue() && (e.miterLimit = p.getNumber()), m.hasValue() && m.getString() !== "none") {
					var g = z_(m.getString());
					e.setLineDash === void 0 ? e.webkitLineDash === void 0 ? e.mozDash !== void 0 && !(g.length === 1 && g[0] === 0) && (e.mozDash = g) : e.webkitLineDash = g : e.setLineDash(g);
					var _ = h.getPixels();
					e.lineDashOffset === void 0 ? e.webkitLineDashOffset === void 0 ? e.mozDashOffset !== void 0 && (e.mozDashOffset = _) : e.webkitLineDashOffset = _ : e.lineDashOffset = _;
				}
			}
			if (this.modifiedEmSizeStack = !1, e.font !== void 0) {
				var v = this.getStyle("font"), y = this.getStyle("font-style"), b = this.getStyle("font-variant"), x = this.getStyle("font-weight"), S = this.getStyle("font-size"), C = this.getStyle("font-family"), w = new Qv(y.getString(), b.getString(), x.getString(), S.hasValue() ? `${S.getPixels(!0)}px` : "", C.getString(), Qv.parse(v.getString(), e.font));
				y.setValue(w.fontStyle), b.setValue(w.fontVariant), x.setValue(w.fontWeight), S.setValue(w.fontSize), C.setValue(w.fontFamily), e.font = w.toString(), S.isPixels() && (this.document.emSize = S.getPixels(), this.modifiedEmSizeStack = !0);
			}
			t || (this.applyEffects(e), e.globalAlpha = this.calculateOpacity());
		}
		clearContext(e) {
			super.clearContext(e), this.modifiedEmSizeStack && this.document.popEmSize();
		}
	}, ny = class e extends ty {
		constructor(e, t, n) {
			super(e, t, n), this.type = "path", this.pathParser = null, this.pathParser = new ey(this.getAttribute("d").getString());
		}
		path(e) {
			var { pathParser: t } = this, n = new $v();
			for (t.reset(), e && e.beginPath(); !t.isEnd();) switch (t.next().type) {
				case ey.MOVE_TO:
					this.pathM(e, n);
					break;
				case ey.LINE_TO:
					this.pathL(e, n);
					break;
				case ey.HORIZ_LINE_TO:
					this.pathH(e, n);
					break;
				case ey.VERT_LINE_TO:
					this.pathV(e, n);
					break;
				case ey.CURVE_TO:
					this.pathC(e, n);
					break;
				case ey.SMOOTH_CURVE_TO:
					this.pathS(e, n);
					break;
				case ey.QUAD_TO:
					this.pathQ(e, n);
					break;
				case ey.SMOOTH_QUAD_TO:
					this.pathT(e, n);
					break;
				case ey.ARC:
					this.pathA(e, n);
					break;
				case ey.CLOSE_PATH:
					this.pathZ(e, n);
					break;
			}
			return n;
		}
		getBoundingBox(e) {
			return this.path();
		}
		getMarkers() {
			var { pathParser: e } = this, t = e.getMarkerPoints(), n = e.getMarkerAngles();
			return t.map((e, t) => [e, n[t]]);
		}
		renderChildren(e) {
			this.path(e), this.document.screen.mouse.checkPath(this, e);
			var t = this.getStyle("fill-rule");
			e.fillStyle !== "" && (t.getString("inherit") === "inherit" ? e.fill() : e.fill(t.getString())), e.strokeStyle !== "" && (this.getAttribute("vector-effect").getString() === "non-scaling-stroke" ? (e.save(), e.setTransform(1, 0, 0, 1, 0, 0), e.stroke(), e.restore()) : e.stroke());
			var n = this.getMarkers();
			if (n) {
				var r = n.length - 1, i = this.getStyle("marker-start"), a = this.getStyle("marker-mid"), o = this.getStyle("marker-end");
				if (i.isUrlDefinition()) {
					var s = i.getDefinition(), [c, l] = n[0];
					s.render(e, c, l);
				}
				if (a.isUrlDefinition()) for (var u = a.getDefinition(), d = 1; d < r; d++) {
					var [f, p] = n[d];
					u.render(e, f, p);
				}
				if (o.isUrlDefinition()) {
					var m = o.getDefinition(), [h, g] = n[r];
					m.render(e, h, g);
				}
			}
		}
		static pathM(e) {
			var t = e.getAsCurrentPoint();
			return e.start = e.current, { point: t };
		}
		pathM(t, n) {
			var { pathParser: r } = this, { point: i } = e.pathM(r), { x: a, y: o } = i;
			r.addMarker(i), n.addPoint(a, o), t && t.moveTo(a, o);
		}
		static pathL(e) {
			var { current: t } = e;
			return {
				current: t,
				point: e.getAsCurrentPoint()
			};
		}
		pathL(t, n) {
			var { pathParser: r } = this, { current: i, point: a } = e.pathL(r), { x: o, y: s } = a;
			r.addMarker(a, i), n.addPoint(o, s), t && t.lineTo(o, s);
		}
		static pathH(e) {
			var { current: t, command: n } = e, r = new Pv((n.relative ? t.x : 0) + n.x, t.y);
			return e.current = r, {
				current: t,
				point: r
			};
		}
		pathH(t, n) {
			var { pathParser: r } = this, { current: i, point: a } = e.pathH(r), { x: o, y: s } = a;
			r.addMarker(a, i), n.addPoint(o, s), t && t.lineTo(o, s);
		}
		static pathV(e) {
			var { current: t, command: n } = e, r = new Pv(t.x, (n.relative ? t.y : 0) + n.y);
			return e.current = r, {
				current: t,
				point: r
			};
		}
		pathV(t, n) {
			var { pathParser: r } = this, { current: i, point: a } = e.pathV(r), { x: o, y: s } = a;
			r.addMarker(a, i), n.addPoint(o, s), t && t.lineTo(o, s);
		}
		static pathC(e) {
			var { current: t } = e;
			return {
				current: t,
				point: e.getPoint("x1", "y1"),
				controlPoint: e.getAsControlPoint("x2", "y2"),
				currentPoint: e.getAsCurrentPoint()
			};
		}
		pathC(t, n) {
			var { pathParser: r } = this, { current: i, point: a, controlPoint: o, currentPoint: s } = e.pathC(r);
			r.addMarker(s, o, a), n.addBezierCurve(i.x, i.y, a.x, a.y, o.x, o.y, s.x, s.y), t && t.bezierCurveTo(a.x, a.y, o.x, o.y, s.x, s.y);
		}
		static pathS(e) {
			var { current: t } = e;
			return {
				current: t,
				point: e.getReflectedControlPoint(),
				controlPoint: e.getAsControlPoint("x2", "y2"),
				currentPoint: e.getAsCurrentPoint()
			};
		}
		pathS(t, n) {
			var { pathParser: r } = this, { current: i, point: a, controlPoint: o, currentPoint: s } = e.pathS(r);
			r.addMarker(s, o, a), n.addBezierCurve(i.x, i.y, a.x, a.y, o.x, o.y, s.x, s.y), t && t.bezierCurveTo(a.x, a.y, o.x, o.y, s.x, s.y);
		}
		static pathQ(e) {
			var { current: t } = e;
			return {
				current: t,
				controlPoint: e.getAsControlPoint("x1", "y1"),
				currentPoint: e.getAsCurrentPoint()
			};
		}
		pathQ(t, n) {
			var { pathParser: r } = this, { current: i, controlPoint: a, currentPoint: o } = e.pathQ(r);
			r.addMarker(o, a, a), n.addQuadraticCurve(i.x, i.y, a.x, a.y, o.x, o.y), t && t.quadraticCurveTo(a.x, a.y, o.x, o.y);
		}
		static pathT(e) {
			var { current: t } = e, n = e.getReflectedControlPoint();
			return e.control = n, {
				current: t,
				controlPoint: n,
				currentPoint: e.getAsCurrentPoint()
			};
		}
		pathT(t, n) {
			var { pathParser: r } = this, { current: i, controlPoint: a, currentPoint: o } = e.pathT(r);
			r.addMarker(o, a, a), n.addQuadraticCurve(i.x, i.y, a.x, a.y, o.x, o.y), t && t.quadraticCurveTo(a.x, a.y, o.x, o.y);
		}
		static pathA(e) {
			var { current: t, command: n } = e, { rX: r, rY: i, xRot: a, lArcFlag: o, sweepFlag: s } = n, c = Math.PI / 180 * a, l = e.getAsCurrentPoint(), u = new Pv(Math.cos(c) * (t.x - l.x) / 2 + Math.sin(c) * (t.y - l.y) / 2, -Math.sin(c) * (t.x - l.x) / 2 + Math.cos(c) * (t.y - l.y) / 2), d = u.x ** 2 / r ** 2 + u.y ** 2 / i ** 2;
			d > 1 && (r *= Math.sqrt(d), i *= Math.sqrt(d));
			var f = (o === s ? -1 : 1) * Math.sqrt((r ** 2 * i ** 2 - r ** 2 * u.y ** 2 - i ** 2 * u.x ** 2) / (r ** 2 * u.y ** 2 + i ** 2 * u.x ** 2));
			isNaN(f) && (f = 0);
			var p = new Pv(f * r * u.y / i, f * -i * u.x / r), m = new Pv((t.x + l.x) / 2 + Math.cos(c) * p.x - Math.sin(c) * p.y, (t.y + l.y) / 2 + Math.sin(c) * p.x + Math.cos(c) * p.y), h = q_([1, 0], [(u.x - p.x) / r, (u.y - p.y) / i]), g = [(u.x - p.x) / r, (u.y - p.y) / i], _ = [(-u.x - p.x) / r, (-u.y - p.y) / i], v = q_(g, _);
			return K_(g, _) <= -1 && (v = Math.PI), K_(g, _) >= 1 && (v = 0), {
				currentPoint: l,
				rX: r,
				rY: i,
				sweepFlag: s,
				xAxisRotation: c,
				centp: m,
				a1: h,
				ad: v
			};
		}
		pathA(t, n) {
			var { pathParser: r } = this, { currentPoint: i, rX: a, rY: o, sweepFlag: s, xAxisRotation: c, centp: l, a1: u, ad: d } = e.pathA(r), f = 1 - s ? 1 : -1, p = u + d / 2 * f, m = new Pv(l.x + a * Math.cos(p), l.y + o * Math.sin(p));
			if (r.addMarkerAngle(m, p - f * Math.PI / 2), r.addMarkerAngle(i, p - f * Math.PI), n.addPoint(i.x, i.y), t && !isNaN(u) && !isNaN(d)) {
				var h = a > o ? a : o, g = a > o ? 1 : a / o, _ = a > o ? o / a : 1;
				t.translate(l.x, l.y), t.rotate(c), t.scale(g, _), t.arc(0, 0, h, u, u + d, !!(1 - s)), t.scale(1 / g, 1 / _), t.rotate(-c), t.translate(-l.x, -l.y);
			}
		}
		static pathZ(e) {
			e.current = e.start;
		}
		pathZ(t, n) {
			e.pathZ(this.pathParser), t && n.x1 !== n.x2 && n.y1 !== n.y2 && t.closePath();
		}
	}, ry = class extends ny {
		constructor(e, t, n) {
			super(e, t, n), this.type = "glyph", this.horizAdvX = this.getAttribute("horiz-adv-x").getNumber(), this.unicode = this.getAttribute("unicode").getString(), this.arabicForm = this.getAttribute("arabic-form").getString();
		}
	}, iy = class e extends ty {
		constructor(t, n, r) {
			super(t, n, new.target === e || r), this.type = "text", this.x = 0, this.y = 0, this.measureCache = -1;
		}
		setContext(e) {
			var t = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
			super.setContext(e, t);
			var n = this.getStyle("dominant-baseline").getTextBaseline() || this.getStyle("alignment-baseline").getTextBaseline();
			n && (e.textBaseline = n);
		}
		initializeCoordinates() {
			this.x = 0, this.y = 0, this.leafTexts = [], this.textChunkStart = 0, this.minX = Infinity, this.maxX = -Infinity;
		}
		getBoundingBox(e) {
			if (this.type !== "text") return this.getTElementBoundingBox(e);
			this.initializeCoordinates(), this.adjustChildCoordinatesRecursive(e);
			var t = null;
			return this.children.forEach((n, r) => {
				var i = this.getChildBoundingBox(e, this, this, r);
				t ? t.addBoundingBox(i) : t = i;
			}), t;
		}
		getFontSize() {
			var { document: e, parent: t } = this, n = Qv.parse(e.ctx.font).fontSize;
			return t.getStyle("font-size").getNumber(n);
		}
		getTElementBoundingBox(e) {
			var t = this.getFontSize();
			return new $v(this.x, this.y - t, this.x + this.measureText(e), this.y);
		}
		getGlyph(e, t, n) {
			var r = t[n], i = null;
			if (e.isArabic) {
				var a = t.length, o = t[n - 1], s = t[n + 1], c = "isolated";
				if ((n === 0 || o === " ") && n < a - 1 && s !== " " && (c = "terminal"), n > 0 && o !== " " && n < a - 1 && s !== " " && (c = "medial"), n > 0 && o !== " " && (n === a - 1 || s === " ") && (c = "initial"), e.glyphs[r] !== void 0) {
					var l = e.glyphs[r];
					i = l instanceof ry ? l : l[c];
				}
			} else i = e.glyphs[r];
			return i ||= e.missingGlyph, i;
		}
		getText() {
			return "";
		}
		getTextFromNode(e) {
			var t = e || this.node, n = Array.from(t.parentNode.childNodes), r = n.indexOf(t), i = n.length - 1, a = I_(t.textContent || "");
			return r === 0 && (a = L_(a)), r === i && (a = R_(a)), a;
		}
		renderChildren(e) {
			if (this.type !== "text") {
				this.renderTElementChildren(e);
				return;
			}
			this.initializeCoordinates(), this.adjustChildCoordinatesRecursive(e), this.children.forEach((t, n) => {
				this.renderChild(e, this, this, n);
			});
			var { mouse: t } = this.document.screen;
			t.isWorking() && t.checkBoundingBox(this, this.getBoundingBox(e));
		}
		renderTElementChildren(e) {
			var { document: t, parent: n } = this, r = this.getText(), i = n.getStyle("font-family").getDefinition();
			if (i) {
				for (var { unitsPerEm: a } = i.fontFace, o = Qv.parse(t.ctx.font), s = n.getStyle("font-size").getNumber(o.fontSize), c = n.getStyle("font-style").getString(o.fontStyle), l = s / a, u = i.isRTL ? r.split("").reverse().join("") : r, d = z_(n.getAttribute("dx").getString()), f = u.length, p = 0; p < f; p++) {
					var m = this.getGlyph(i, u, p);
					e.translate(this.x, this.y), e.scale(l, -l);
					var h = e.lineWidth;
					e.lineWidth = e.lineWidth * a / s, c === "italic" && e.transform(1, 0, .4, 1, 0, 0), m.render(e), c === "italic" && e.transform(1, 0, -.4, 1, 0, 0), e.lineWidth = h, e.scale(1 / l, -1 / l), e.translate(-this.x, -this.y), this.x += s * (m.horizAdvX || i.horizAdvX) / a, d[p] !== void 0 && !isNaN(d[p]) && (this.x += d[p]);
				}
				return;
			}
			var { x: g, y: _ } = this;
			e.fillStyle && e.fillText(r, g, _), e.strokeStyle && e.strokeText(r, g, _);
		}
		applyAnchoring() {
			if (!(this.textChunkStart >= this.leafTexts.length)) {
				var e = this.leafTexts[this.textChunkStart], t = e.getStyle("text-anchor").getString("start"), n = 0;
				n = t === "start" ? e.x - this.minX : t === "end" ? e.x - this.maxX : e.x - (this.minX + this.maxX) / 2;
				for (var r = this.textChunkStart; r < this.leafTexts.length; r++) this.leafTexts[r].x += n;
				this.minX = Infinity, this.maxX = -Infinity, this.textChunkStart = this.leafTexts.length;
			}
		}
		adjustChildCoordinatesRecursive(e) {
			this.children.forEach((t, n) => {
				this.adjustChildCoordinatesRecursiveCore(e, this, this, n);
			}), this.applyAnchoring();
		}
		adjustChildCoordinatesRecursiveCore(e, t, n, r) {
			var i = n.children[r];
			i.children.length > 0 ? i.children.forEach((n, r) => {
				t.adjustChildCoordinatesRecursiveCore(e, t, i, r);
			}) : this.adjustChildCoordinates(e, t, n, r);
		}
		adjustChildCoordinates(e, t, n, r) {
			var i = n.children[r];
			if (typeof i.measureText != "function") return i;
			e.save(), i.setContext(e, !0);
			var a = i.getAttribute("x"), o = i.getAttribute("y"), s = i.getAttribute("dx"), c = i.getAttribute("dy"), l = i.getStyle("font-family").getDefinition(), u = !!l && l.isRTL;
			r === 0 && (a.hasValue() || a.setValue(i.getInheritedAttribute("x")), o.hasValue() || o.setValue(i.getInheritedAttribute("y")), s.hasValue() || s.setValue(i.getInheritedAttribute("dx")), c.hasValue() || c.setValue(i.getInheritedAttribute("dy")));
			var d = i.measureText(e);
			return u && (t.x -= d), a.hasValue() ? (t.applyAnchoring(), i.x = a.getPixels("x"), s.hasValue() && (i.x += s.getPixels("x"))) : (s.hasValue() && (t.x += s.getPixels("x")), i.x = t.x), t.x = i.x, u || (t.x += d), o.hasValue() ? (i.y = o.getPixels("y"), c.hasValue() && (i.y += c.getPixels("y"))) : (c.hasValue() && (t.y += c.getPixels("y")), i.y = t.y), t.y = i.y, t.leafTexts.push(i), t.minX = Math.min(t.minX, i.x, i.x + d), t.maxX = Math.max(t.maxX, i.x, i.x + d), i.clearContext(e), e.restore(), i;
		}
		getChildBoundingBox(e, t, n, r) {
			var i = n.children[r];
			if (typeof i.getBoundingBox != "function") return null;
			var a = i.getBoundingBox(e);
			return a ? (i.children.forEach((n, r) => {
				var o = t.getChildBoundingBox(e, t, i, r);
				a.addBoundingBox(o);
			}), a) : null;
		}
		renderChild(e, t, n, r) {
			var i = n.children[r];
			i.render(e), i.children.forEach((n, r) => {
				t.renderChild(e, t, i, r);
			});
		}
		measureText(e) {
			var { measureCache: t } = this;
			if (~t) return t;
			var n = this.getText(), r = this.measureTargetText(e, n);
			return this.measureCache = r, r;
		}
		measureTargetText(e, t) {
			if (!t.length) return 0;
			var { parent: n } = this, r = n.getStyle("font-family").getDefinition();
			if (r) {
				for (var i = this.getFontSize(), a = r.isRTL ? t.split("").reverse().join("") : t, o = z_(n.getAttribute("dx").getString()), s = a.length, c = 0, l = 0; l < s; l++) {
					var u = this.getGlyph(r, a, l);
					c += (u.horizAdvX || r.horizAdvX) * i / r.fontFace.unitsPerEm, o[l] !== void 0 && !isNaN(o[l]) && (c += o[l]);
				}
				return c;
			}
			if (!e.measureText) return t.length * 10;
			e.save(), this.setContext(e, !0);
			var { width: d } = e.measureText(t);
			return this.clearContext(e), e.restore(), d;
		}
		getInheritedAttribute(t) {
			for (var n = this; n instanceof e && n.isFirstChild();) {
				var r = n.parent.getAttribute(t);
				if (r.hasValue(!0)) return r.getValue("0");
				n = n.parent;
			}
			return null;
		}
	}, ay = class e extends iy {
		constructor(t, n, r) {
			super(t, n, new.target === e || r), this.type = "tspan", this.text = this.children.length > 0 ? "" : this.getTextFromNode();
		}
		getText() {
			return this.text;
		}
	}, oy = class extends ay {
		constructor() {
			super(...arguments), this.type = "textNode";
		}
	}, sy = class extends ty {
		constructor() {
			super(...arguments), this.type = "svg", this.root = !1;
		}
		setContext(e) {
			var { document: t } = this, { screen: n, window: r } = t, i = e.canvas;
			if (n.setDefaults(e), i.style && e.font !== void 0 && r && r.getComputedStyle !== void 0) {
				e.font = r.getComputedStyle(i).getPropertyValue("font");
				var a = new Mv(t, "fontSize", Qv.parse(e.font).fontSize);
				a.hasValue() && (t.rootEmSize = a.getPixels("y"), t.emSize = t.rootEmSize);
			}
			this.getAttribute("x").hasValue() || this.getAttribute("x", !0).setValue(0), this.getAttribute("y").hasValue() || this.getAttribute("y", !0).setValue(0);
			var { width: o, height: s } = n.viewPort;
			this.getStyle("width").hasValue() || this.getStyle("width", !0).setValue("100%"), this.getStyle("height").hasValue() || this.getStyle("height", !0).setValue("100%"), this.getStyle("color").hasValue() || this.getStyle("color", !0).setValue("black");
			var c = this.getAttribute("refX"), l = this.getAttribute("refY"), u = this.getAttribute("viewBox"), d = u.hasValue() ? z_(u.getString()) : null, f = !this.root && this.getStyle("overflow").getValue("hidden") !== "visible", p = 0, m = 0, h = 0, g = 0;
			d && (p = d[0], m = d[1]), this.root || (o = this.getStyle("width").getPixels("x"), s = this.getStyle("height").getPixels("y"), this.type === "marker" && (h = p, g = m, p = 0, m = 0)), n.viewPort.setCurrent(o, s), this.node && (!this.parent || this.node.parentNode?.nodeName === "foreignObject") && this.getStyle("transform", !1, !0).hasValue() && !this.getStyle("transform-origin", !1, !0).hasValue() && this.getStyle("transform-origin", !0, !0).setValue("50% 50%"), super.setContext(e), e.translate(this.getAttribute("x").getPixels("x"), this.getAttribute("y").getPixels("y")), d && (o = d[2], s = d[3]), t.setViewBox({
				ctx: e,
				aspectRatio: this.getAttribute("preserveAspectRatio").getString(),
				width: n.viewPort.width,
				desiredWidth: o,
				height: n.viewPort.height,
				desiredHeight: s,
				minX: p,
				minY: m,
				refX: c.getValue(),
				refY: l.getValue(),
				clip: f,
				clipX: h,
				clipY: g
			}), d && (n.viewPort.removeCurrent(), n.viewPort.setCurrent(o, s));
		}
		clearContext(e) {
			super.clearContext(e), this.document.screen.viewPort.removeCurrent();
		}
		resize(e) {
			var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, n = arguments.length > 2 && arguments[2] !== void 0 && arguments[2], r = this.getAttribute("width", !0), i = this.getAttribute("height", !0), a = this.getAttribute("viewBox"), o = this.getAttribute("style"), s = r.getNumber(0), c = i.getNumber(0);
			if (n) if (typeof n == "string") this.getAttribute("preserveAspectRatio", !0).setValue(n);
			else {
				var l = this.getAttribute("preserveAspectRatio");
				l.hasValue() && l.setValue(l.getString().replace(/^\s*(\S.*\S)\s*$/, "$1"));
			}
			if (r.setValue(e), i.setValue(t), a.hasValue() || a.setValue(`0 0 ${s || e} ${c || t}`), o.hasValue()) {
				var u = this.getStyle("width"), d = this.getStyle("height");
				u.hasValue() && u.setValue(`${e}px`), d.hasValue() && d.setValue(`${t}px`);
			}
		}
	}, cy = class extends ny {
		constructor() {
			super(...arguments), this.type = "rect";
		}
		path(e) {
			var t = this.getAttribute("x").getPixels("x"), n = this.getAttribute("y").getPixels("y"), r = this.getStyle("width", !1, !0).getPixels("x"), i = this.getStyle("height", !1, !0).getPixels("y"), a = this.getAttribute("rx"), o = this.getAttribute("ry"), s = a.getPixels("x"), c = o.getPixels("y");
			if (a.hasValue() && !o.hasValue() && (c = s), o.hasValue() && !a.hasValue() && (s = c), s = Math.min(s, r / 2), c = Math.min(c, i / 2), e) {
				var l = 4 * ((Math.sqrt(2) - 1) / 3);
				e.beginPath(), i > 0 && r > 0 && (e.moveTo(t + s, n), e.lineTo(t + r - s, n), e.bezierCurveTo(t + r - s + l * s, n, t + r, n + c - l * c, t + r, n + c), e.lineTo(t + r, n + i - c), e.bezierCurveTo(t + r, n + i - c + l * c, t + r - s + l * s, n + i, t + r - s, n + i), e.lineTo(t + s, n + i), e.bezierCurveTo(t + s - l * s, n + i, t, n + i - c + l * c, t, n + i - c), e.lineTo(t, n + c), e.bezierCurveTo(t, n + c - l * c, t + s - l * s, n, t + s, n), e.closePath());
			}
			return new $v(t, n, t + r, n + i);
		}
		getMarkers() {
			return null;
		}
	}, ly = class extends ny {
		constructor() {
			super(...arguments), this.type = "circle";
		}
		path(e) {
			var t = this.getAttribute("cx").getPixels("x"), n = this.getAttribute("cy").getPixels("y"), r = this.getAttribute("r").getPixels();
			return e && r > 0 && (e.beginPath(), e.arc(t, n, r, 0, Math.PI * 2, !1), e.closePath()), new $v(t - r, n - r, t + r, n + r);
		}
		getMarkers() {
			return null;
		}
	}, uy = class extends ny {
		constructor() {
			super(...arguments), this.type = "ellipse";
		}
		path(e) {
			var t = 4 * ((Math.sqrt(2) - 1) / 3), n = this.getAttribute("rx").getPixels("x"), r = this.getAttribute("ry").getPixels("y"), i = this.getAttribute("cx").getPixels("x"), a = this.getAttribute("cy").getPixels("y");
			return e && n > 0 && r > 0 && (e.beginPath(), e.moveTo(i + n, a), e.bezierCurveTo(i + n, a + t * r, i + t * n, a + r, i, a + r), e.bezierCurveTo(i - t * n, a + r, i - n, a + t * r, i - n, a), e.bezierCurveTo(i - n, a - t * r, i - t * n, a - r, i, a - r), e.bezierCurveTo(i + t * n, a - r, i + n, a - t * r, i + n, a), e.closePath()), new $v(i - n, a - r, i + n, a + r);
		}
		getMarkers() {
			return null;
		}
	}, dy = class extends ny {
		constructor() {
			super(...arguments), this.type = "line";
		}
		getPoints() {
			return [new Pv(this.getAttribute("x1").getPixels("x"), this.getAttribute("y1").getPixels("y")), new Pv(this.getAttribute("x2").getPixels("x"), this.getAttribute("y2").getPixels("y"))];
		}
		path(e) {
			var [{ x: t, y: n }, { x: r, y: i }] = this.getPoints();
			return e && (e.beginPath(), e.moveTo(t, n), e.lineTo(r, i)), new $v(t, n, r, i);
		}
		getMarkers() {
			var [e, t] = this.getPoints(), n = e.angleTo(t);
			return [[e, n], [t, n]];
		}
	}, fy = class extends ny {
		constructor(e, t, n) {
			super(e, t, n), this.type = "polyline", this.points = [], this.points = Pv.parsePath(this.getAttribute("points").getString());
		}
		path(e) {
			var { points: t } = this, [{ x: n, y: r }] = t, i = new $v(n, r);
			return e && (e.beginPath(), e.moveTo(n, r)), t.forEach((t) => {
				var { x: n, y: r } = t;
				i.addPoint(n, r), e && e.lineTo(n, r);
			}), i;
		}
		getMarkers() {
			var { points: e } = this, t = e.length - 1, n = [];
			return e.forEach((r, i) => {
				i !== t && n.push([r, r.angleTo(e[i + 1])]);
			}), n.length > 0 && n.push([e[e.length - 1], n[n.length - 1][1]]), n;
		}
	}, py = class extends fy {
		constructor() {
			super(...arguments), this.type = "polygon";
		}
		path(e) {
			var t = super.path(e), [{ x: n, y: r }] = this.points;
			return e && (e.lineTo(n, r), e.closePath()), t;
		}
	}, my = class extends Xv {
		constructor() {
			super(...arguments), this.type = "pattern";
		}
		createPattern(e, t, n) {
			var r = this.getStyle("width").getPixels("x", !0), i = this.getStyle("height").getPixels("y", !0), a = new sy(this.document, null);
			a.attributes.viewBox = new Mv(this.document, "viewBox", this.getAttribute("viewBox").getValue()), a.attributes.width = new Mv(this.document, "width", `${r}px`), a.attributes.height = new Mv(this.document, "height", `${i}px`), a.attributes.transform = new Mv(this.document, "transform", this.getAttribute("patternTransform").getValue()), a.children = this.children;
			var o = this.document.createCanvas(r, i), s = o.getContext("2d"), c = this.getAttribute("x"), l = this.getAttribute("y");
			c.hasValue() && l.hasValue() && s.translate(c.getPixels("x", !0), l.getPixels("y", !0)), n.hasValue() ? this.styles["fill-opacity"] = n : Reflect.deleteProperty(this.styles, "fill-opacity");
			for (var u = -1; u <= 1; u++) for (var d = -1; d <= 1; d++) s.save(), a.attributes.x = new Mv(this.document, "x", u * o.width), a.attributes.y = new Mv(this.document, "y", d * o.height), a.render(s), s.restore();
			return e.createPattern(o, "repeat");
		}
	}, hy = class extends Xv {
		constructor() {
			super(...arguments), this.type = "marker";
		}
		render(e, t, n) {
			if (t) {
				var { x: r, y: i } = t, a = this.getAttribute("orient").getString("auto"), o = this.getAttribute("markerUnits").getString("strokeWidth");
				e.translate(r, i), a === "auto" && e.rotate(n), o === "strokeWidth" && e.scale(e.lineWidth, e.lineWidth), e.save();
				var s = new sy(this.document, null);
				s.type = this.type, s.attributes.viewBox = new Mv(this.document, "viewBox", this.getAttribute("viewBox").getValue()), s.attributes.refX = new Mv(this.document, "refX", this.getAttribute("refX").getValue()), s.attributes.refY = new Mv(this.document, "refY", this.getAttribute("refY").getValue()), s.attributes.width = new Mv(this.document, "width", this.getAttribute("markerWidth").getValue()), s.attributes.height = new Mv(this.document, "height", this.getAttribute("markerHeight").getValue()), s.attributes.overflow = new Mv(this.document, "overflow", this.getAttribute("overflow").getValue()), s.attributes.fill = new Mv(this.document, "fill", this.getAttribute("fill").getColor("black")), s.attributes.stroke = new Mv(this.document, "stroke", this.getAttribute("stroke").getValue("none")), s.children = this.children, s.render(e), e.restore(), o === "strokeWidth" && e.scale(1 / e.lineWidth, 1 / e.lineWidth), a === "auto" && e.rotate(-n), e.translate(-r, -i);
			}
		}
	}, gy = class extends Xv {
		constructor() {
			super(...arguments), this.type = "defs";
		}
		render() {}
	}, _y = class extends ty {
		constructor() {
			super(...arguments), this.type = "g";
		}
		getBoundingBox(e) {
			var t = new $v();
			return this.children.forEach((n) => {
				t.addBoundingBox(n.getBoundingBox(e));
			}), t;
		}
	}, vy = class extends Xv {
		constructor(e, t, n) {
			super(e, t, n), this.attributesToInherit = ["gradientUnits"], this.stops = [];
			var { stops: r, children: i } = this;
			i.forEach((e) => {
				e.type === "stop" && r.push(e);
			});
		}
		getGradientUnits() {
			return this.getAttribute("gradientUnits").getString("objectBoundingBox");
		}
		createGradient(e, t, n) {
			var r = this;
			this.getHrefAttribute().hasValue() && (r = this.getHrefAttribute().getDefinition(), this.inheritStopContainer(r));
			var { stops: i } = r, a = this.getGradient(e, t);
			if (!a) return this.addParentOpacity(n, i[i.length - 1].color);
			if (i.forEach((e) => {
				a.addColorStop(e.offset, this.addParentOpacity(n, e.color));
			}), this.getAttribute("gradientTransform").hasValue()) {
				var { document: o } = this, { MAX_VIRTUAL_PIXELS: s, viewPort: c } = o.screen, [l] = c.viewPorts, u = new cy(o, null);
				u.attributes.x = new Mv(o, "x", -s / 3), u.attributes.y = new Mv(o, "y", -s / 3), u.attributes.width = new Mv(o, "width", s), u.attributes.height = new Mv(o, "height", s);
				var d = new _y(o, null);
				d.attributes.transform = new Mv(o, "transform", this.getAttribute("gradientTransform").getValue()), d.children = [u];
				var f = new sy(o, null);
				f.attributes.x = new Mv(o, "x", 0), f.attributes.y = new Mv(o, "y", 0), f.attributes.width = new Mv(o, "width", l.width), f.attributes.height = new Mv(o, "height", l.height), f.children = [d];
				var p = o.createCanvas(l.width, l.height), m = p.getContext("2d");
				return m.fillStyle = a, f.render(m), m.createPattern(p, "no-repeat");
			}
			return a;
		}
		inheritStopContainer(e) {
			this.attributesToInherit.forEach((t) => {
				!this.getAttribute(t).hasValue() && e.getAttribute(t).hasValue() && this.getAttribute(t, !0).setValue(e.getAttribute(t).getValue());
			});
		}
		addParentOpacity(e, t) {
			return e.hasValue() ? new Mv(this.document, "color", t).addOpacity(e).getColor() : t;
		}
	}, yy = class extends vy {
		constructor(e, t, n) {
			super(e, t, n), this.type = "linearGradient", this.attributesToInherit.push("x1", "y1", "x2", "y2");
		}
		getGradient(e, t) {
			var n = this.getGradientUnits() === "objectBoundingBox", r = n ? t.getBoundingBox(e) : null;
			if (n && !r) return null;
			!this.getAttribute("x1").hasValue() && !this.getAttribute("y1").hasValue() && !this.getAttribute("x2").hasValue() && !this.getAttribute("y2").hasValue() && (this.getAttribute("x1", !0).setValue(0), this.getAttribute("y1", !0).setValue(0), this.getAttribute("x2", !0).setValue(1), this.getAttribute("y2", !0).setValue(0));
			var i = n ? r.x + r.width * this.getAttribute("x1").getNumber() : this.getAttribute("x1").getPixels("x"), a = n ? r.y + r.height * this.getAttribute("y1").getNumber() : this.getAttribute("y1").getPixels("y"), o = n ? r.x + r.width * this.getAttribute("x2").getNumber() : this.getAttribute("x2").getPixels("x"), s = n ? r.y + r.height * this.getAttribute("y2").getNumber() : this.getAttribute("y2").getPixels("y");
			return i === o && a === s ? null : e.createLinearGradient(i, a, o, s);
		}
	}, by = class extends vy {
		constructor(e, t, n) {
			super(e, t, n), this.type = "radialGradient", this.attributesToInherit.push("cx", "cy", "r", "fx", "fy", "fr");
		}
		getGradient(e, t) {
			var n = this.getGradientUnits() === "objectBoundingBox", r = t.getBoundingBox(e);
			if (n && !r) return null;
			this.getAttribute("cx").hasValue() || this.getAttribute("cx", !0).setValue("50%"), this.getAttribute("cy").hasValue() || this.getAttribute("cy", !0).setValue("50%"), this.getAttribute("r").hasValue() || this.getAttribute("r", !0).setValue("50%");
			var i = n ? r.x + r.width * this.getAttribute("cx").getNumber() : this.getAttribute("cx").getPixels("x"), a = n ? r.y + r.height * this.getAttribute("cy").getNumber() : this.getAttribute("cy").getPixels("y"), o = i, s = a;
			this.getAttribute("fx").hasValue() && (o = n ? r.x + r.width * this.getAttribute("fx").getNumber() : this.getAttribute("fx").getPixels("x")), this.getAttribute("fy").hasValue() && (s = n ? r.y + r.height * this.getAttribute("fy").getNumber() : this.getAttribute("fy").getPixels("y"));
			var c = n ? (r.width + r.height) / 2 * this.getAttribute("r").getNumber() : this.getAttribute("r").getPixels(), l = this.getAttribute("fr").getPixels();
			return e.createRadialGradient(o, s, l, i, a, c);
		}
	}, xy = class extends Xv {
		constructor(e, t, n) {
			super(e, t, n), this.type = "stop";
			var r = Math.max(0, Math.min(1, this.getAttribute("offset").getNumber())), i = this.getStyle("stop-opacity"), a = this.getStyle("stop-color", !0);
			a.getString() === "" && a.setValue("#000"), i.hasValue() && (a = a.addOpacity(i)), this.offset = r, this.color = a.getColor();
		}
	}, Sy = class extends Xv {
		constructor(e, t, n) {
			super(e, t, n), this.type = "animate", this.duration = 0, this.initialValue = null, this.initialUnits = "", this.removed = !1, this.frozen = !1, e.screen.animations.push(this), this.begin = this.getAttribute("begin").getMilliseconds(), this.maxDuration = this.begin + this.getAttribute("dur").getMilliseconds(), this.from = this.getAttribute("from"), this.to = this.getAttribute("to"), this.values = new Mv(e, "values", null);
			var r = this.getAttribute("values");
			r.hasValue() && this.values.setValue(r.getString().split(";"));
		}
		getProperty() {
			var e = this.getAttribute("attributeType").getString(), t = this.getAttribute("attributeName").getString();
			return e === "CSS" ? this.parent.getStyle(t, !0) : this.parent.getAttribute(t, !0);
		}
		calcValue() {
			var { initialUnits: e } = this, { progress: t, from: n, to: r } = this.getProgress(), i = n.getNumber() + (r.getNumber() - n.getNumber()) * t;
			return e === "%" && (i *= 100), `${i}${e}`;
		}
		update(e) {
			var { parent: t } = this, n = this.getProperty();
			if (this.initialValue || (this.initialValue = n.getString(), this.initialUnits = n.getUnits()), this.duration > this.maxDuration) {
				var r = this.getAttribute("fill").getString("remove");
				if (this.getAttribute("repeatCount").getString() === "indefinite" || this.getAttribute("repeatDur").getString() === "indefinite") this.duration = 0;
				else if (r === "freeze" && !this.frozen) this.frozen = !0, t.animationFrozen = !0, t.animationFrozenValue = n.getString();
				else if (r === "remove" && !this.removed) return this.removed = !0, n.setValue(t.animationFrozen ? t.animationFrozenValue : this.initialValue), !0;
				return !1;
			}
			this.duration += e;
			var i = !1;
			if (this.begin < this.duration) {
				var a = this.calcValue(), o = this.getAttribute("type");
				o.hasValue() && (a = `${o.getString()}(${a})`), n.setValue(a), i = !0;
			}
			return i;
		}
		getProgress() {
			var { document: e, values: t } = this, n = { progress: (this.duration - this.begin) / (this.maxDuration - this.begin) };
			if (t.hasValue()) {
				var r = n.progress * (t.getValue().length - 1), i = Math.floor(r), a = Math.ceil(r);
				n.from = new Mv(e, "from", parseFloat(t.getValue()[i])), n.to = new Mv(e, "to", parseFloat(t.getValue()[a])), n.progress = (r - i) / (a - i);
			} else n.from = this.from, n.to = this.to;
			return n;
		}
	}, Cy = class extends Sy {
		constructor() {
			super(...arguments), this.type = "animateColor";
		}
		calcValue() {
			var { progress: e, from: t, to: n } = this.getProgress(), r = new xv.default(t.getColor()), i = new xv.default(n.getColor());
			if (r.ok && i.ok) {
				var a = r.r + (i.r - r.r) * e, o = r.g + (i.g - r.g) * e, s = r.b + (i.b - r.b) * e;
				return `rgb(${Math.floor(a)}, ${Math.floor(o)}, ${Math.floor(s)})`;
			}
			return this.getAttribute("from").getColor();
		}
	}, wy = class extends Sy {
		constructor() {
			super(...arguments), this.type = "animateTransform";
		}
		calcValue() {
			var { progress: e, from: t, to: n } = this.getProgress(), r = z_(t.getString()), i = z_(n.getString());
			return r.map((t, n) => t + (i[n] - t) * e).join(" ");
		}
	}, Ty = class extends Xv {
		constructor(e, t, n) {
			super(e, t, n), this.type = "font", this.glyphs = Object.create(null), this.horizAdvX = this.getAttribute("horiz-adv-x").getNumber();
			var { definitions: r } = e, { children: i } = this;
			for (var a of i) switch (a.type) {
				case "font-face":
					this.fontFace = a;
					var o = a.getStyle("font-family");
					o.hasValue() && (r[o.getString()] = this);
					break;
				case "missing-glyph":
					this.missingGlyph = a;
					break;
				case "glyph":
					var s = a;
					s.arabicForm ? (this.isRTL = !0, this.isArabic = !0, this.glyphs[s.unicode] === void 0 && (this.glyphs[s.unicode] = Object.create(null)), this.glyphs[s.unicode][s.arabicForm] = s) : this.glyphs[s.unicode] = s;
					break;
			}
		}
		render() {}
	}, Ey = class extends Xv {
		constructor(e, t, n) {
			super(e, t, n), this.type = "font-face", this.ascent = this.getAttribute("ascent").getNumber(), this.descent = this.getAttribute("descent").getNumber(), this.unitsPerEm = this.getAttribute("units-per-em").getNumber();
		}
	}, Dy = class extends ny {
		constructor() {
			super(...arguments), this.type = "missing-glyph", this.horizAdvX = 0;
		}
	}, Oy = class extends iy {
		constructor() {
			super(...arguments), this.type = "tref";
		}
		getText() {
			var e = this.getHrefAttribute().getDefinition();
			if (e) {
				var t = e.children[0];
				if (t) return t.getText();
			}
			return "";
		}
	}, ky = class extends iy {
		constructor(e, t, n) {
			super(e, t, n), this.type = "a";
			var { childNodes: r } = t, i = r[0], a = r.length > 0 && Array.from(r).every((e) => e.nodeType === 3);
			this.hasText = a, this.text = a ? this.getTextFromNode(i) : "";
		}
		getText() {
			return this.text;
		}
		renderChildren(e) {
			if (this.hasText) {
				super.renderChildren(e);
				var { document: t, x: n, y: r } = this, { mouse: i } = t.screen, a = new Mv(t, "fontSize", Qv.parse(t.ctx.font).fontSize);
				i.isWorking() && i.checkBoundingBox(this, new $v(n, r - a.getPixels("y"), n + this.measureText(e), r));
			} else if (this.children.length > 0) {
				var o = new _y(this.document, null);
				o.children = this.children, o.parent = this, o.render(e);
			}
		}
		onClick() {
			var { window: e } = this.document;
			e && e.open(this.getHrefAttribute().getString());
		}
		onMouseMove() {
			var e = this.document.ctx;
			e.canvas.style.cursor = "pointer";
		}
	}, Ay = class extends iy {
		constructor(e, t, n) {
			super(e, t, n), this.type = "textPath", this.textWidth = 0, this.textHeight = 0, this.pathLength = -1, this.glyphInfo = null, this.letterSpacingCache = [], this.measuresCache = /* @__PURE__ */ new Map([["", 0]]);
			var r = this.getHrefAttribute().getDefinition();
			this.text = this.getTextFromNode(), this.dataArray = this.parsePathData(r);
		}
		getText() {
			return this.text;
		}
		path(e) {
			var { dataArray: t } = this;
			e && e.beginPath(), t.forEach((t) => {
				var { type: n, points: r } = t;
				switch (n) {
					case ey.LINE_TO:
						e && e.lineTo(r[0], r[1]);
						break;
					case ey.MOVE_TO:
						e && e.moveTo(r[0], r[1]);
						break;
					case ey.CURVE_TO:
						e && e.bezierCurveTo(r[0], r[1], r[2], r[3], r[4], r[5]);
						break;
					case ey.QUAD_TO:
						e && e.quadraticCurveTo(r[0], r[1], r[2], r[3]);
						break;
					case ey.ARC:
						var [i, a, o, s, c, l, u, d] = r, f = o > s ? o : s, p = o > s ? 1 : o / s, m = o > s ? s / o : 1;
						e && (e.translate(i, a), e.rotate(u), e.scale(p, m), e.arc(0, 0, f, c, c + l, !!(1 - d)), e.scale(1 / p, 1 / m), e.rotate(-u), e.translate(-i, -a));
						break;
					case ey.CLOSE_PATH:
						e && e.closePath();
						break;
				}
			});
		}
		renderChildren(e) {
			this.setTextData(e), e.save();
			var t = this.parent.getStyle("text-decoration").getString(), n = this.getFontSize(), { glyphInfo: r } = this, i = e.fillStyle;
			t === "underline" && e.beginPath(), r.forEach((r, i) => {
				var { p0: a, p1: o, rotation: s, text: c } = r;
				e.save(), e.translate(a.x, a.y), e.rotate(s), e.fillStyle && e.fillText(c, 0, 0), e.strokeStyle && e.strokeText(c, 0, 0), e.restore(), t === "underline" && (i === 0 && e.moveTo(a.x, a.y + n / 8), e.lineTo(o.x, o.y + n / 5));
			}), t === "underline" && (e.lineWidth = n / 20, e.strokeStyle = i, e.stroke(), e.closePath()), e.restore();
		}
		getLetterSpacingAt() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
			return this.letterSpacingCache[e] || 0;
		}
		findSegmentToFitChar(e, t, n, r, i, a, o, s, c) {
			var l = a, u = this.measureText(e, s);
			s === " " && t === "justify" && n < r && (u += (r - n) / i), c > -1 && (l += this.getLetterSpacingAt(c));
			var d = this.textHeight / 20, f = this.getEquidistantPointOnPath(l, d, 0), p = this.getEquidistantPointOnPath(l + u, d, 0), m = {
				p0: f,
				p1: p
			}, h = f && p ? Math.atan2(p.y - f.y, p.x - f.x) : 0;
			if (o) {
				var g = Math.cos(Math.PI / 2 + h) * o, _ = Math.cos(-h) * o;
				m.p0 = cv(cv({}, f), {}, {
					x: f.x + g,
					y: f.y + _
				}), m.p1 = cv(cv({}, p), {}, {
					x: p.x + g,
					y: p.y + _
				});
			}
			return l += u, {
				offset: l,
				segment: m,
				rotation: h
			};
		}
		measureText(e, t) {
			var { measuresCache: n } = this, r = t || this.getText();
			if (n.has(r)) return n.get(r);
			var i = this.measureTargetText(e, r);
			return n.set(r, i), i;
		}
		setTextData(e) {
			if (!this.glyphInfo) {
				var t = this.getText(), n = t.split(""), r = t.split(" ").length - 1, i = this.parent.getAttribute("dx").split().map((e) => e.getPixels("x")), a = this.parent.getAttribute("dy").getPixels("y"), o = this.parent.getStyle("text-anchor").getString("start"), s = this.getStyle("letter-spacing"), c = this.parent.getStyle("letter-spacing"), l = 0;
				!s.hasValue() || s.getValue() === "inherit" ? l = c.getPixels() : s.hasValue() && s.getValue() !== "initial" && s.getValue() !== "unset" && (l = s.getPixels());
				var u = [], d = t.length;
				this.letterSpacingCache = u;
				for (var f = 0; f < d; f++) u.push(i[f] === void 0 ? l : i[f]);
				var p = u.reduce((e, t, n) => n === 0 ? 0 : e + t || 0, 0), m = this.measureText(e), h = Math.max(m + p, 0);
				this.textWidth = m, this.textHeight = this.getFontSize(), this.glyphInfo = [];
				var g = this.getPathLength(), _ = this.getStyle("startOffset").getNumber(0) * g, v = 0;
				(o === "middle" || o === "center") && (v = -h / 2), (o === "end" || o === "right") && (v = -h), v += _, n.forEach((t, i) => {
					var { offset: s, segment: c, rotation: l } = this.findSegmentToFitChar(e, o, h, g, r, v, a, t, i);
					v = s, !(!c.p0 || !c.p1) && this.glyphInfo.push({
						text: n[i],
						p0: c.p0,
						p1: c.p1,
						rotation: l
					});
				});
			}
		}
		parsePathData(e) {
			if (this.pathLength = -1, !e) return [];
			var t = [], { pathParser: n } = e;
			for (n.reset(); !n.isEnd();) {
				var { current: r } = n, i = r ? r.x : 0, a = r ? r.y : 0, o = n.next(), s = o.type, c = [];
				switch (o.type) {
					case ey.MOVE_TO:
						this.pathM(n, c);
						break;
					case ey.LINE_TO:
						s = this.pathL(n, c);
						break;
					case ey.HORIZ_LINE_TO:
						s = this.pathH(n, c);
						break;
					case ey.VERT_LINE_TO:
						s = this.pathV(n, c);
						break;
					case ey.CURVE_TO:
						this.pathC(n, c);
						break;
					case ey.SMOOTH_CURVE_TO:
						s = this.pathS(n, c);
						break;
					case ey.QUAD_TO:
						this.pathQ(n, c);
						break;
					case ey.SMOOTH_QUAD_TO:
						s = this.pathT(n, c);
						break;
					case ey.ARC:
						c = this.pathA(n);
						break;
					case ey.CLOSE_PATH:
						ny.pathZ(n);
						break;
				}
				o.type === ey.CLOSE_PATH ? t.push({
					type: ey.CLOSE_PATH,
					points: [],
					pathLength: 0
				}) : t.push({
					type: s,
					points: c,
					start: {
						x: i,
						y: a
					},
					pathLength: this.calcLength(i, a, s, c)
				});
			}
			return t;
		}
		pathM(e, t) {
			var { x: n, y: r } = ny.pathM(e).point;
			t.push(n, r);
		}
		pathL(e, t) {
			var { x: n, y: r } = ny.pathL(e).point;
			return t.push(n, r), ey.LINE_TO;
		}
		pathH(e, t) {
			var { x: n, y: r } = ny.pathH(e).point;
			return t.push(n, r), ey.LINE_TO;
		}
		pathV(e, t) {
			var { x: n, y: r } = ny.pathV(e).point;
			return t.push(n, r), ey.LINE_TO;
		}
		pathC(e, t) {
			var { point: n, controlPoint: r, currentPoint: i } = ny.pathC(e);
			t.push(n.x, n.y, r.x, r.y, i.x, i.y);
		}
		pathS(e, t) {
			var { point: n, controlPoint: r, currentPoint: i } = ny.pathS(e);
			return t.push(n.x, n.y, r.x, r.y, i.x, i.y), ey.CURVE_TO;
		}
		pathQ(e, t) {
			var { controlPoint: n, currentPoint: r } = ny.pathQ(e);
			t.push(n.x, n.y, r.x, r.y);
		}
		pathT(e, t) {
			var { controlPoint: n, currentPoint: r } = ny.pathT(e);
			return t.push(n.x, n.y, r.x, r.y), ey.QUAD_TO;
		}
		pathA(e) {
			var { rX: t, rY: n, sweepFlag: r, xAxisRotation: i, centp: a, a1: o, ad: s } = ny.pathA(e);
			return r === 0 && s > 0 && (s -= 2 * Math.PI), r === 1 && s < 0 && (s += 2 * Math.PI), [
				a.x,
				a.y,
				t,
				n,
				o,
				s,
				i,
				r
			];
		}
		calcLength(e, t, n, r) {
			var i = 0, a = null, o = null, s = 0;
			switch (n) {
				case ey.LINE_TO: return this.getLineLength(e, t, r[0], r[1]);
				case ey.CURVE_TO:
					for (i = 0, a = this.getPointOnCubicBezier(0, e, t, r[0], r[1], r[2], r[3], r[4], r[5]), s = .01; s <= 1; s += .01) o = this.getPointOnCubicBezier(s, e, t, r[0], r[1], r[2], r[3], r[4], r[5]), i += this.getLineLength(a.x, a.y, o.x, o.y), a = o;
					return i;
				case ey.QUAD_TO:
					for (i = 0, a = this.getPointOnQuadraticBezier(0, e, t, r[0], r[1], r[2], r[3]), s = .01; s <= 1; s += .01) o = this.getPointOnQuadraticBezier(s, e, t, r[0], r[1], r[2], r[3]), i += this.getLineLength(a.x, a.y, o.x, o.y), a = o;
					return i;
				case ey.ARC:
					i = 0;
					var c = r[4], l = r[5], u = r[4] + l, d = Math.PI / 180;
					if (Math.abs(c - u) < d && (d = Math.abs(c - u)), a = this.getPointOnEllipticalArc(r[0], r[1], r[2], r[3], c, 0), l < 0) for (s = c - d; s > u; s -= d) o = this.getPointOnEllipticalArc(r[0], r[1], r[2], r[3], s, 0), i += this.getLineLength(a.x, a.y, o.x, o.y), a = o;
					else for (s = c + d; s < u; s += d) o = this.getPointOnEllipticalArc(r[0], r[1], r[2], r[3], s, 0), i += this.getLineLength(a.x, a.y, o.x, o.y), a = o;
					return o = this.getPointOnEllipticalArc(r[0], r[1], r[2], r[3], u, 0), i += this.getLineLength(a.x, a.y, o.x, o.y), i;
			}
			return 0;
		}
		getPointOnLine(e, t, n, r, i) {
			var a = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : t, o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : n, s = (i - n) / (r - t + jv), c = Math.sqrt(e * e / (1 + s * s));
			r < t && (c *= -1);
			var l = s * c, u = null;
			if (r === t) u = {
				x: a,
				y: o + l
			};
			else if ((o - n) / (a - t + 1e-8) === s) u = {
				x: a + c,
				y: o + l
			};
			else {
				var d = 0, f = 0, p = this.getLineLength(t, n, r, i);
				if (p < 1e-8) return null;
				var m = (a - t) * (r - t) + (o - n) * (i - n);
				m /= p * p, d = t + m * (r - t), f = n + m * (i - n);
				var h = this.getLineLength(a, o, d, f), g = Math.sqrt(e * e - h * h);
				c = Math.sqrt(g * g / (1 + s * s)), r < t && (c *= -1), l = s * c, u = {
					x: d + c,
					y: f + l
				};
			}
			return u;
		}
		getPointOnPath(e) {
			var t = this.getPathLength(), n = 0, r = null;
			if (e < -5e-5 || e - 5e-5 > t) return null;
			var { dataArray: i } = this;
			for (var a of i) {
				if (a && (a.pathLength < 5e-5 || n + a.pathLength + 5e-5 < e)) {
					n += a.pathLength;
					continue;
				}
				var o = e - n, s = 0;
				switch (a.type) {
					case ey.LINE_TO:
						r = this.getPointOnLine(o, a.start.x, a.start.y, a.points[0], a.points[1], a.start.x, a.start.y);
						break;
					case ey.ARC:
						var c = a.points[4], l = a.points[5], u = a.points[4] + l;
						if (s = c + o / a.pathLength * l, l < 0 && s < u || l >= 0 && s > u) break;
						r = this.getPointOnEllipticalArc(a.points[0], a.points[1], a.points[2], a.points[3], s, a.points[6]);
						break;
					case ey.CURVE_TO:
						s = o / a.pathLength, s > 1 && (s = 1), r = this.getPointOnCubicBezier(s, a.start.x, a.start.y, a.points[0], a.points[1], a.points[2], a.points[3], a.points[4], a.points[5]);
						break;
					case ey.QUAD_TO:
						s = o / a.pathLength, s > 1 && (s = 1), r = this.getPointOnQuadraticBezier(s, a.start.x, a.start.y, a.points[0], a.points[1], a.points[2], a.points[3]);
						break;
				}
				if (r) return r;
				break;
			}
			return null;
		}
		getLineLength(e, t, n, r) {
			return Math.sqrt((n - e) * (n - e) + (r - t) * (r - t));
		}
		getPathLength() {
			return this.pathLength === -1 && (this.pathLength = this.dataArray.reduce((e, t) => t.pathLength > 0 ? e + t.pathLength : e, 0)), this.pathLength;
		}
		getPointOnCubicBezier(e, t, n, r, i, a, o, s, c) {
			return {
				x: s * J_(e) + a * Y_(e) + r * X_(e) + t * Z_(e),
				y: c * J_(e) + o * Y_(e) + i * X_(e) + n * Z_(e)
			};
		}
		getPointOnQuadraticBezier(e, t, n, r, i, a, o) {
			return {
				x: a * Q_(e) + r * $_(e) + t * ev(e),
				y: o * Q_(e) + i * $_(e) + n * ev(e)
			};
		}
		getPointOnEllipticalArc(e, t, n, r, i, a) {
			var o = Math.cos(a), s = Math.sin(a), c = {
				x: n * Math.cos(i),
				y: r * Math.sin(i)
			};
			return {
				x: e + (c.x * o - c.y * s),
				y: t + (c.x * s + c.y * o)
			};
		}
		buildEquidistantCache(e, t) {
			var n = this.getPathLength(), r = t || .25, i = e || n / 100;
			if (!this.equidistantCache || this.equidistantCache.step !== i || this.equidistantCache.precision !== r) {
				this.equidistantCache = {
					step: i,
					precision: r,
					points: []
				};
				for (var a = 0, o = 0; o <= n; o += r) {
					var s = this.getPointOnPath(o), c = this.getPointOnPath(o + r);
					!s || !c || (a += this.getLineLength(s.x, s.y, c.x, c.y), a >= i && (this.equidistantCache.points.push({
						x: s.x,
						y: s.y,
						distance: o
					}), a -= i));
				}
			}
		}
		getEquidistantPointOnPath(e, t, n) {
			if (this.buildEquidistantCache(t, n), e < 0 || e - this.getPathLength() > 5e-5) return null;
			var r = Math.round(e / this.getPathLength() * (this.equidistantCache.points.length - 1));
			return this.equidistantCache.points[r] || null;
		}
	}, jy = /^\s*data:(([^/,;]+\/[^/,;]+)(?:;([^,;=]+=[^,;=]+))?)?(?:;(base64))?,(.*)$/i, My = class extends ty {
		constructor(e, t, n) {
			super(e, t, n), this.type = "image", this.loaded = !1;
			var r = this.getHrefAttribute().getString();
			if (r) {
				var i = r.endsWith(".svg") || /^\s*data:image\/svg\+xml/i.test(r);
				e.images.push(this), i ? this.loadSvg(r) : this.loadImage(r), this.isSvg = i;
			}
		}
		loadImage(e) {
			var t = this;
			return Qh(function* () {
				try {
					t.image = yield t.document.createImage(e);
				} catch (t) {
					console.error(`Error while loading image "${e}":`, t);
				}
				t.loaded = !0;
			})();
		}
		loadSvg(e) {
			var t = this;
			return Qh(function* () {
				var n = jy.exec(e);
				if (n) {
					var r = n[5];
					n[4] === "base64" ? t.image = atob(r) : t.image = decodeURIComponent(r);
				} else try {
					t.image = yield (yield t.document.fetch(e)).text();
				} catch (t) {
					console.error(`Error while loading image "${e}":`, t);
				}
				t.loaded = !0;
			})();
		}
		renderChildren(e) {
			var { document: t, image: n, loaded: r } = this, i = this.getAttribute("x").getPixels("x"), a = this.getAttribute("y").getPixels("y"), o = this.getStyle("width").getPixels("x"), s = this.getStyle("height").getPixels("y");
			if (!(!r || !n || !o || !s)) {
				if (e.save(), e.translate(i, a), this.isSvg) {
					var c = t.canvg.forkString(e, this.image, {
						ignoreMouse: !0,
						ignoreAnimation: !0,
						ignoreDimensions: !0,
						ignoreClear: !0,
						offsetX: 0,
						offsetY: 0,
						scaleWidth: o,
						scaleHeight: s
					});
					c.document.documentElement.parent = this, c.render();
				} else {
					var l = this.image;
					t.setViewBox({
						ctx: e,
						aspectRatio: this.getAttribute("preserveAspectRatio").getString(),
						width: o,
						desiredWidth: l.width,
						height: s,
						desiredHeight: l.height
					}), this.loaded && (l.complete === void 0 || l.complete) && e.drawImage(l, 0, 0);
				}
				e.restore();
			}
		}
		getBoundingBox() {
			var e = this.getAttribute("x").getPixels("x"), t = this.getAttribute("y").getPixels("y"), n = this.getStyle("width").getPixels("x"), r = this.getStyle("height").getPixels("y");
			return new $v(e, t, e + n, t + r);
		}
	}, Ny = class extends ty {
		constructor() {
			super(...arguments), this.type = "symbol";
		}
		render(e) {}
	}, Py = class {
		constructor(e) {
			this.document = e, this.loaded = !1, e.fonts.push(this);
		}
		load(e, t) {
			var n = this;
			return Qh(function* () {
				try {
					var { document: r } = n, i = (yield r.canvg.parser.load(t)).getElementsByTagName("font");
					Array.from(i).forEach((t) => {
						var n = r.createElement(t);
						r.definitions[e] = n;
					});
				} catch (e) {
					console.error(`Error while loading font "${t}":`, e);
				}
				n.loaded = !0;
			})();
		}
	}, Fy = class extends Xv {
		constructor(e, t, n) {
			super(e, t, n), this.type = "style", I_(Array.from(t.childNodes).map((e) => e.textContent).join("").replace(/(\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*+\/)|(^[\s]*\/\/.*)/gm, "").replace(/@import.*;/g, "")).split("}").forEach((t) => {
				var n = t.trim();
				if (n) {
					var r = n.split("{"), i = r[0].split(","), a = r[1].split(";");
					i.forEach((t) => {
						var n = t.trim();
						if (n) {
							var r = e.styles[n] || {};
							if (a.forEach((t) => {
								var n = t.indexOf(":"), i = t.substr(0, n).trim(), a = t.substr(n + 1, t.length - n).trim();
								i && a && (r[i] = new Mv(e, i, a));
							}), e.styles[n] = r, e.stylesSpecificity[n] = W_(n), n === "@font-face") {
								var i = r["font-family"].getString().replace(/"|'/g, "");
								r.src.getString().split(",").forEach((t) => {
									if (t.indexOf("format(\"svg\")") > 0) {
										var n = V_(t);
										n && new Py(e).load(i, n);
									}
								});
							}
						}
					});
				}
			});
		}
	}, Fy.parseExternalUrl = V_, Iy = class extends ty {
		constructor() {
			super(...arguments), this.type = "use";
		}
		setContext(e) {
			super.setContext(e);
			var t = this.getAttribute("x"), n = this.getAttribute("y");
			t.hasValue() && e.translate(t.getPixels("x"), 0), n.hasValue() && e.translate(0, n.getPixels("y"));
		}
		path(e) {
			var { element: t } = this;
			t && t.path(e);
		}
		renderChildren(e) {
			var { document: t, element: n } = this;
			if (n) {
				var r = n;
				if (n.type === "symbol" && (r = new sy(t, null), r.attributes.viewBox = new Mv(t, "viewBox", n.getAttribute("viewBox").getString()), r.attributes.preserveAspectRatio = new Mv(t, "preserveAspectRatio", n.getAttribute("preserveAspectRatio").getString()), r.attributes.overflow = new Mv(t, "overflow", n.getAttribute("overflow").getString()), r.children = n.children, n.styles.opacity = new Mv(t, "opacity", this.calculateOpacity())), r.type === "svg") {
					var i = this.getStyle("width", !1, !0), a = this.getStyle("height", !1, !0);
					i.hasValue() && (r.attributes.width = new Mv(t, "width", i.getString())), a.hasValue() && (r.attributes.height = new Mv(t, "height", a.getString()));
				}
				var o = r.parent;
				r.parent = this, r.render(e), r.parent = o;
			}
		}
		getBoundingBox(e) {
			var { element: t } = this;
			return t ? t.getBoundingBox(e) : null;
		}
		elementTransform() {
			var { document: e, element: t } = this;
			return Yv.fromElement(e, t);
		}
		get element() {
			return this.cachedElement ||= this.getHrefAttribute().getDefinition(), this.cachedElement;
		}
	}, Ly = class extends Xv {
		constructor(e, t, n) {
			super(e, t, n), this.type = "feColorMatrix";
			var r = z_(this.getAttribute("values").getString());
			switch (this.getAttribute("type").getString("matrix")) {
				case "saturate":
					var i = r[0];
					r = [
						.213 + .787 * i,
						.715 - .715 * i,
						.072 - .072 * i,
						0,
						0,
						.213 - .213 * i,
						.715 + .285 * i,
						.072 - .072 * i,
						0,
						0,
						.213 - .213 * i,
						.715 - .715 * i,
						.072 + .928 * i,
						0,
						0,
						0,
						0,
						0,
						1,
						0,
						0,
						0,
						0,
						0,
						1
					];
					break;
				case "hueRotate":
					var a = r[0] * Math.PI / 180;
					r = [
						fv(a, .213, .787, -.213),
						fv(a, .715, -.715, -.715),
						fv(a, .072, -.072, .928),
						0,
						0,
						fv(a, .213, -.213, .143),
						fv(a, .715, .285, .14),
						fv(a, .072, -.072, -.283),
						0,
						0,
						fv(a, .213, -.213, -.787),
						fv(a, .715, -.715, .715),
						fv(a, .072, .928, .072),
						0,
						0,
						0,
						0,
						0,
						1,
						0,
						0,
						0,
						0,
						0,
						1
					];
					break;
				case "luminanceToAlpha":
					r = [
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						0,
						.2125,
						.7154,
						.0721,
						0,
						0,
						0,
						0,
						0,
						0,
						1
					];
					break;
			}
			this.matrix = r, this.includeOpacity = this.getAttribute("includeOpacity").hasValue();
		}
		apply(e, t, n, r, i) {
			for (var { includeOpacity: a, matrix: o } = this, s = e.getImageData(0, 0, r, i), c = 0; c < i; c++) for (var l = 0; l < r; l++) {
				var u = lv(s.data, l, c, r, i, 0), d = lv(s.data, l, c, r, i, 1), f = lv(s.data, l, c, r, i, 2), p = lv(s.data, l, c, r, i, 3), m = dv(o, 0, u) + dv(o, 1, d) + dv(o, 2, f) + dv(o, 3, p) + dv(o, 4, 1), h = dv(o, 5, u) + dv(o, 6, d) + dv(o, 7, f) + dv(o, 8, p) + dv(o, 9, 1), g = dv(o, 10, u) + dv(o, 11, d) + dv(o, 12, f) + dv(o, 13, p) + dv(o, 14, 1), _ = dv(o, 15, u) + dv(o, 16, d) + dv(o, 17, f) + dv(o, 18, p) + dv(o, 19, 1);
				a && (m = 0, h = 0, g = 0, _ *= p / 255), uv(s.data, l, c, r, i, 0, m), uv(s.data, l, c, r, i, 1, h), uv(s.data, l, c, r, i, 2, g), uv(s.data, l, c, r, i, 3, _);
			}
			e.clearRect(0, 0, r, i), e.putImageData(s, 0, 0);
		}
	}, Ry = class e extends Xv {
		constructor() {
			super(...arguments), this.type = "mask";
		}
		apply(t, n) {
			var { document: r } = this, i = this.getAttribute("x").getPixels("x"), a = this.getAttribute("y").getPixels("y"), o = this.getStyle("width").getPixels("x"), s = this.getStyle("height").getPixels("y");
			if (!o && !s) {
				var c = new $v();
				this.children.forEach((e) => {
					c.addBoundingBox(e.getBoundingBox(t));
				}), i = Math.floor(c.x1), a = Math.floor(c.y1), o = Math.floor(c.width), s = Math.floor(c.height);
			}
			var l = this.removeStyles(n, e.ignoreStyles), u = r.createCanvas(i + o, a + s), d = u.getContext("2d");
			r.screen.setDefaults(d), this.renderChildren(d), new Ly(r, {
				nodeType: 1,
				childNodes: [],
				attributes: [{
					nodeName: "type",
					value: "luminanceToAlpha"
				}, {
					nodeName: "includeOpacity",
					value: "true"
				}]
			}).apply(d, 0, 0, i + o, a + s);
			var f = r.createCanvas(i + o, a + s), p = f.getContext("2d");
			r.screen.setDefaults(p), n.render(p), p.globalCompositeOperation = "destination-in", p.fillStyle = d.createPattern(u, "no-repeat"), p.fillRect(0, 0, i + o, a + s), t.fillStyle = p.createPattern(f, "no-repeat"), t.fillRect(0, 0, i + o, a + s), this.restoreStyles(n, l);
		}
		render(e) {}
	}, Ry.ignoreStyles = [
		"mask",
		"transform",
		"clip-path"
	], zy = () => {}, By = class extends Xv {
		constructor() {
			super(...arguments), this.type = "clipPath";
		}
		apply(e) {
			var { document: t } = this, n = Reflect.getPrototypeOf(e), { beginPath: r, closePath: i } = e;
			n && (n.beginPath = zy, n.closePath = zy), Reflect.apply(r, e, []), this.children.forEach((r) => {
				if (r.path !== void 0) {
					var a = r.elementTransform === void 0 ? null : r.elementTransform();
					a ||= Yv.fromElement(t, r), a && a.apply(e), r.path(e), n && (n.closePath = i), a && a.unapply(e);
				}
			}), Reflect.apply(i, e, []), e.clip(), n && (n.beginPath = r, n.closePath = i);
		}
		render(e) {}
	}, Vy = class e extends Xv {
		constructor() {
			super(...arguments), this.type = "filter";
		}
		apply(t, n) {
			var { document: r, children: i } = this, a = n.getBoundingBox(t);
			if (a) {
				var o = 0, s = 0;
				i.forEach((e) => {
					var t = e.extraFilterDistance || 0;
					o = Math.max(o, t), s = Math.max(s, t);
				});
				var c = Math.floor(a.width), l = Math.floor(a.height), u = c + 2 * o, d = l + 2 * s;
				if (!(u < 1 || d < 1)) {
					var f = Math.floor(a.x), p = Math.floor(a.y), m = this.removeStyles(n, e.ignoreStyles), h = r.createCanvas(u, d), g = h.getContext("2d");
					r.screen.setDefaults(g), g.translate(-f + o, -p + s), n.render(g), i.forEach((e) => {
						typeof e.apply == "function" && e.apply(g, 0, 0, u, d);
					}), t.drawImage(h, 0, 0, u, d, f - o, p - s, u, d), this.restoreStyles(n, m);
				}
			}
		}
		render(e) {}
	}, Vy.ignoreStyles = [
		"filter",
		"transform",
		"clip-path"
	], Hy = class extends Xv {
		constructor(e, t, n) {
			super(e, t, n), this.type = "feDropShadow", this.addStylesFromStyleDefinition();
		}
		apply(e, t, n, r, i) {}
	}, Uy = class extends Xv {
		constructor() {
			super(...arguments), this.type = "feMorphology";
		}
		apply(e, t, n, r, i) {}
	}, Wy = class extends Xv {
		constructor() {
			super(...arguments), this.type = "feComposite";
		}
		apply(e, t, n, r, i) {}
	}, Gy = class extends Xv {
		constructor(e, t, n) {
			super(e, t, n), this.type = "feGaussianBlur", this.blurRadius = Math.floor(this.getAttribute("stdDeviation").getNumber()), this.extraFilterDistance = this.blurRadius;
		}
		apply(e, t, n, r, i) {
			var { document: a, blurRadius: o } = this, s = a.window ? a.window.document.body : null, c = e.canvas;
			c.id = a.getUniqueId(), s && (c.style.display = "none", s.appendChild(c)), D_(c, t, n, r, i, o), s && s.removeChild(c);
		}
	}, Ky = class extends Xv {
		constructor() {
			super(...arguments), this.type = "title";
		}
	}, qy = class extends Xv {
		constructor() {
			super(...arguments), this.type = "desc";
		}
	}, Jy = {
		svg: sy,
		rect: cy,
		circle: ly,
		ellipse: uy,
		line: dy,
		polyline: fy,
		polygon: py,
		path: ny,
		pattern: my,
		marker: hy,
		defs: gy,
		linearGradient: yy,
		radialGradient: by,
		stop: xy,
		animate: Sy,
		animateColor: Cy,
		animateTransform: wy,
		font: Ty,
		"font-face": Ey,
		"missing-glyph": Dy,
		glyph: ry,
		text: iy,
		tspan: ay,
		tref: Oy,
		a: ky,
		textPath: Ay,
		image: My,
		g: _y,
		symbol: Ny,
		style: Fy,
		use: Iy,
		mask: Ry,
		clipPath: By,
		filter: Vy,
		feDropShadow: Hy,
		feMorphology: Uy,
		feComposite: Wy,
		feColorMatrix: Ly,
		feGaussianBlur: Gy,
		title: Ky,
		desc: qy
	}, Yy = class e {
		constructor(t) {
			var { rootEmSize: n = 12, emSize: r = 12, createCanvas: i = e.createCanvas, createImage: a = e.createImage, anonymousCrossOrigin: o } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
			this.canvg = t, this.definitions = Object.create(null), this.styles = Object.create(null), this.stylesSpecificity = Object.create(null), this.images = [], this.fonts = [], this.emSizeStack = [], this.uniqueId = 0, this.screen = t.screen, this.rootEmSize = n, this.emSize = r, this.createCanvas = i, this.createImage = this.bindCreateImage(a, o), this.screen.wait(this.isImagesLoaded.bind(this)), this.screen.wait(this.isFontsLoaded.bind(this));
		}
		bindCreateImage(e, t) {
			return typeof t == "boolean" ? (n, r) => e(n, typeof r == "boolean" ? r : t) : e;
		}
		get window() {
			return this.screen.window;
		}
		get fetch() {
			return this.screen.fetch;
		}
		get ctx() {
			return this.screen.ctx;
		}
		get emSize() {
			var { emSizeStack: e } = this;
			return e[e.length - 1];
		}
		set emSize(e) {
			var { emSizeStack: t } = this;
			t.push(e);
		}
		popEmSize() {
			var { emSizeStack: e } = this;
			e.pop();
		}
		getUniqueId() {
			return `canvg${++this.uniqueId}`;
		}
		isImagesLoaded() {
			return this.images.every((e) => e.loaded);
		}
		isFontsLoaded() {
			return this.fonts.every((e) => e.loaded);
		}
		createDocumentElement(e) {
			var t = this.createElement(e.documentElement);
			return t.root = !0, t.addStylesFromStyleDefinition(), this.documentElement = t, t;
		}
		createElement(t) {
			var n = t.nodeName.replace(/^[^:]+:/, ""), r = e.elementTypes[n];
			return r === void 0 ? new Zv(this, t) : new r(this, t);
		}
		createTextNode(e) {
			return new oy(this, e);
		}
		setViewBox(e) {
			this.screen.setViewBox(mv({ document: this }, e));
		}
	}, Yy.createCanvas = hv, Yy.createImage = gv, Yy.elementTypes = Jy, Xy = class e {
		constructor(e, t) {
			var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
			this.parser = new Vv(n), this.screen = new Rv(e, n), this.options = n;
			var r = new Yy(this, n), i = r.createDocumentElement(t);
			this.document = r, this.documentElement = i;
		}
		static from(t, n) {
			var r = arguments;
			return Qh(function* () {
				var i = r.length > 2 && r[2] !== void 0 ? r[2] : {}, a = yield new Vv(i).parse(n);
				return new e(t, a, i);
			})();
		}
		static fromString(t, n) {
			var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = new Vv(r).parseFromString(n);
			return new e(t, i, r);
		}
		fork(t, n) {
			var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
			return e.from(t, n, yv(yv({}, this.options), r));
		}
		forkString(t, n) {
			var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
			return e.fromString(t, n, yv(yv({}, this.options), r));
		}
		ready() {
			return this.screen.ready();
		}
		isReady() {
			return this.screen.isReady();
		}
		render() {
			var e = arguments, t = this;
			return Qh(function* () {
				var n = e.length > 0 && e[0] !== void 0 ? e[0] : {};
				t.start(yv({
					enableRedraw: !0,
					ignoreAnimation: !0,
					ignoreMouse: !0
				}, n)), yield t.ready(), t.stop();
			})();
		}
		start() {
			var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, { documentElement: t, screen: n, options: r } = this;
			n.start(t, yv(yv({ enableRedraw: !0 }, r), e));
		}
		stop() {
			this.screen.stop();
		}
		resize(e) {
			var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, n = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
			this.documentElement.resize(e, t, n);
		}
	};
}));
//#endregion
//#region node_modules/jspdf/dist/jspdf.es.min.js
Ia();
var Qy = function() {
	return typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : this;
}();
function $y() {
	Qy.console && typeof Qy.console.log == "function" && Qy.console.log.apply(Qy.console, arguments);
}
var eb = {
	log: $y,
	warn: function(e) {
		Qy.console && (typeof Qy.console.warn == "function" ? Qy.console.warn.apply(Qy.console, arguments) : $y.call(null, arguments));
	},
	error: function(e) {
		Qy.console && (typeof Qy.console.error == "function" ? Qy.console.error.apply(Qy.console, arguments) : $y(e));
	}
};
function tb(e, t, n) {
	var r = new XMLHttpRequest();
	r.open("GET", e), r.responseType = "blob", r.onload = function() {
		ib(r.response, t, n);
	}, r.onerror = function() {
		eb.error("could not download file");
	}, r.send();
}
function nb(e) {
	var t = new XMLHttpRequest();
	t.open("HEAD", e, !1);
	try {
		t.send();
	} catch {}
	return t.status >= 200 && t.status <= 299;
}
function rb(e) {
	try {
		e.dispatchEvent(new MouseEvent("click"));
	} catch {
		var t = document.createEvent("MouseEvents");
		t.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), e.dispatchEvent(t);
	}
}
var ib = Qy.saveAs || ((typeof window > "u" ? "undefined" : Fa(window)) !== "object" || window !== Qy ? function() {} : typeof HTMLAnchorElement < "u" && "download" in HTMLAnchorElement.prototype ? function(e, t, n) {
	var r = Qy.URL || Qy.webkitURL, i = document.createElement("a");
	t = t || e.name || "download", i.download = t, i.rel = "noopener", typeof e == "string" ? (i.href = e, i.origin === location.origin ? rb(i) : nb(i.href) ? tb(e, t, n) : rb(i, i.target = "_blank")) : (i.href = r.createObjectURL(e), setTimeout(function() {
		r.revokeObjectURL(i.href);
	}, 4e4), setTimeout(function() {
		rb(i);
	}, 0));
} : "msSaveOrOpenBlob" in navigator ? function(e, t, n) {
	if (t = t || e.name || "download", typeof e == "string") if (nb(e)) tb(e, t, n);
	else {
		var r = document.createElement("a");
		r.href = e, r.target = "_blank", setTimeout(function() {
			rb(r);
		});
	}
	else navigator.msSaveOrOpenBlob(function(e, t) {
		return t === void 0 ? t = { autoBom: !1 } : Fa(t) !== "object" && (eb.warn("Deprecated: Expected third argument to be a object"), t = { autoBom: !t }), t.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type) ? new Blob(["﻿", e], { type: e.type }) : e;
	}(e, n), t);
} : function(e, t, n, r) {
	if ((r ||= open("", "_blank")) && (r.document.title = r.document.body.innerText = "downloading..."), typeof e == "string") return tb(e, t, n);
	var i = e.type === "application/octet-stream", a = /constructor/i.test(Qy.HTMLElement) || Qy.safari, o = /CriOS\/[\d]+/.test(navigator.userAgent);
	if ((o || i && a) && (typeof FileReader > "u" ? "undefined" : Fa(FileReader)) === "object") {
		var s = new FileReader();
		s.onloadend = function() {
			var e = s.result;
			e = o ? e : e.replace(/^data:[^;]*;/, "data:attachment/file;"), r ? r.location.href = e : location = e, r = null;
		}, s.readAsDataURL(e);
	} else {
		var c = Qy.URL || Qy.webkitURL, l = c.createObjectURL(e);
		r ? r.location = l : location.href = l, r = null, setTimeout(function() {
			c.revokeObjectURL(l);
		}, 4e4);
	}
});
function ab(e) {
	var t;
	e ||= "", this.ok = !1, e.charAt(0) == "#" && (e = e.substr(1, 6)), e = {
		aliceblue: "f0f8ff",
		antiquewhite: "faebd7",
		aqua: "00ffff",
		aquamarine: "7fffd4",
		azure: "f0ffff",
		beige: "f5f5dc",
		bisque: "ffe4c4",
		black: "000000",
		blanchedalmond: "ffebcd",
		blue: "0000ff",
		blueviolet: "8a2be2",
		brown: "a52a2a",
		burlywood: "deb887",
		cadetblue: "5f9ea0",
		chartreuse: "7fff00",
		chocolate: "d2691e",
		coral: "ff7f50",
		cornflowerblue: "6495ed",
		cornsilk: "fff8dc",
		crimson: "dc143c",
		cyan: "00ffff",
		darkblue: "00008b",
		darkcyan: "008b8b",
		darkgoldenrod: "b8860b",
		darkgray: "a9a9a9",
		darkgreen: "006400",
		darkkhaki: "bdb76b",
		darkmagenta: "8b008b",
		darkolivegreen: "556b2f",
		darkorange: "ff8c00",
		darkorchid: "9932cc",
		darkred: "8b0000",
		darksalmon: "e9967a",
		darkseagreen: "8fbc8f",
		darkslateblue: "483d8b",
		darkslategray: "2f4f4f",
		darkturquoise: "00ced1",
		darkviolet: "9400d3",
		deeppink: "ff1493",
		deepskyblue: "00bfff",
		dimgray: "696969",
		dodgerblue: "1e90ff",
		feldspar: "d19275",
		firebrick: "b22222",
		floralwhite: "fffaf0",
		forestgreen: "228b22",
		fuchsia: "ff00ff",
		gainsboro: "dcdcdc",
		ghostwhite: "f8f8ff",
		gold: "ffd700",
		goldenrod: "daa520",
		gray: "808080",
		green: "008000",
		greenyellow: "adff2f",
		honeydew: "f0fff0",
		hotpink: "ff69b4",
		indianred: "cd5c5c",
		indigo: "4b0082",
		ivory: "fffff0",
		khaki: "f0e68c",
		lavender: "e6e6fa",
		lavenderblush: "fff0f5",
		lawngreen: "7cfc00",
		lemonchiffon: "fffacd",
		lightblue: "add8e6",
		lightcoral: "f08080",
		lightcyan: "e0ffff",
		lightgoldenrodyellow: "fafad2",
		lightgrey: "d3d3d3",
		lightgreen: "90ee90",
		lightpink: "ffb6c1",
		lightsalmon: "ffa07a",
		lightseagreen: "20b2aa",
		lightskyblue: "87cefa",
		lightslateblue: "8470ff",
		lightslategray: "778899",
		lightsteelblue: "b0c4de",
		lightyellow: "ffffe0",
		lime: "00ff00",
		limegreen: "32cd32",
		linen: "faf0e6",
		magenta: "ff00ff",
		maroon: "800000",
		mediumaquamarine: "66cdaa",
		mediumblue: "0000cd",
		mediumorchid: "ba55d3",
		mediumpurple: "9370d8",
		mediumseagreen: "3cb371",
		mediumslateblue: "7b68ee",
		mediumspringgreen: "00fa9a",
		mediumturquoise: "48d1cc",
		mediumvioletred: "c71585",
		midnightblue: "191970",
		mintcream: "f5fffa",
		mistyrose: "ffe4e1",
		moccasin: "ffe4b5",
		navajowhite: "ffdead",
		navy: "000080",
		oldlace: "fdf5e6",
		olive: "808000",
		olivedrab: "6b8e23",
		orange: "ffa500",
		orangered: "ff4500",
		orchid: "da70d6",
		palegoldenrod: "eee8aa",
		palegreen: "98fb98",
		paleturquoise: "afeeee",
		palevioletred: "d87093",
		papayawhip: "ffefd5",
		peachpuff: "ffdab9",
		peru: "cd853f",
		pink: "ffc0cb",
		plum: "dda0dd",
		powderblue: "b0e0e6",
		purple: "800080",
		red: "ff0000",
		rosybrown: "bc8f8f",
		royalblue: "4169e1",
		saddlebrown: "8b4513",
		salmon: "fa8072",
		sandybrown: "f4a460",
		seagreen: "2e8b57",
		seashell: "fff5ee",
		sienna: "a0522d",
		silver: "c0c0c0",
		skyblue: "87ceeb",
		slateblue: "6a5acd",
		slategray: "708090",
		snow: "fffafa",
		springgreen: "00ff7f",
		steelblue: "4682b4",
		tan: "d2b48c",
		teal: "008080",
		thistle: "d8bfd8",
		tomato: "ff6347",
		turquoise: "40e0d0",
		violet: "ee82ee",
		violetred: "d02090",
		wheat: "f5deb3",
		white: "ffffff",
		whitesmoke: "f5f5f5",
		yellow: "ffff00",
		yellowgreen: "9acd32"
	}[e = (e = e.replace(/ /g, "")).toLowerCase()] || e;
	for (var n = [
		{
			re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
			example: ["rgb(123, 234, 45)", "rgb(255,234,245)"],
			process: function(e) {
				return [
					parseInt(e[1]),
					parseInt(e[2]),
					parseInt(e[3])
				];
			}
		},
		{
			re: /^(\w{2})(\w{2})(\w{2})$/,
			example: ["#00ff00", "336699"],
			process: function(e) {
				return [
					parseInt(e[1], 16),
					parseInt(e[2], 16),
					parseInt(e[3], 16)
				];
			}
		},
		{
			re: /^(\w{1})(\w{1})(\w{1})$/,
			example: ["#fb0", "f0f"],
			process: function(e) {
				return [
					parseInt(e[1] + e[1], 16),
					parseInt(e[2] + e[2], 16),
					parseInt(e[3] + e[3], 16)
				];
			}
		}
	], r = 0; r < n.length; r++) {
		var i = n[r].re, a = n[r].process, o = i.exec(e);
		o && (t = a(o), this.r = t[0], this.g = t[1], this.b = t[2], this.ok = !0);
	}
	this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.toRGB = function() {
		return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
	}, this.toHex = function() {
		var e = this.r.toString(16), t = this.g.toString(16), n = this.b.toString(16);
		return e.length == 1 && (e = "0" + e), t.length == 1 && (t = "0" + t), n.length == 1 && (n = "0" + n), "#" + e + t + n;
	};
}
var ob = Qy.atob.bind(Qy), sb = Qy.btoa.bind(Qy);
function cb(e, t) {
	var n = e[0], r = e[1], i = e[2], a = e[3];
	n = ub(n, r, i, a, t[0], 7, -680876936), a = ub(a, n, r, i, t[1], 12, -389564586), i = ub(i, a, n, r, t[2], 17, 606105819), r = ub(r, i, a, n, t[3], 22, -1044525330), n = ub(n, r, i, a, t[4], 7, -176418897), a = ub(a, n, r, i, t[5], 12, 1200080426), i = ub(i, a, n, r, t[6], 17, -1473231341), r = ub(r, i, a, n, t[7], 22, -45705983), n = ub(n, r, i, a, t[8], 7, 1770035416), a = ub(a, n, r, i, t[9], 12, -1958414417), i = ub(i, a, n, r, t[10], 17, -42063), r = ub(r, i, a, n, t[11], 22, -1990404162), n = ub(n, r, i, a, t[12], 7, 1804603682), a = ub(a, n, r, i, t[13], 12, -40341101), i = ub(i, a, n, r, t[14], 17, -1502002290), n = db(n, r = ub(r, i, a, n, t[15], 22, 1236535329), i, a, t[1], 5, -165796510), a = db(a, n, r, i, t[6], 9, -1069501632), i = db(i, a, n, r, t[11], 14, 643717713), r = db(r, i, a, n, t[0], 20, -373897302), n = db(n, r, i, a, t[5], 5, -701558691), a = db(a, n, r, i, t[10], 9, 38016083), i = db(i, a, n, r, t[15], 14, -660478335), r = db(r, i, a, n, t[4], 20, -405537848), n = db(n, r, i, a, t[9], 5, 568446438), a = db(a, n, r, i, t[14], 9, -1019803690), i = db(i, a, n, r, t[3], 14, -187363961), r = db(r, i, a, n, t[8], 20, 1163531501), n = db(n, r, i, a, t[13], 5, -1444681467), a = db(a, n, r, i, t[2], 9, -51403784), i = db(i, a, n, r, t[7], 14, 1735328473), n = fb(n, r = db(r, i, a, n, t[12], 20, -1926607734), i, a, t[5], 4, -378558), a = fb(a, n, r, i, t[8], 11, -2022574463), i = fb(i, a, n, r, t[11], 16, 1839030562), r = fb(r, i, a, n, t[14], 23, -35309556), n = fb(n, r, i, a, t[1], 4, -1530992060), a = fb(a, n, r, i, t[4], 11, 1272893353), i = fb(i, a, n, r, t[7], 16, -155497632), r = fb(r, i, a, n, t[10], 23, -1094730640), n = fb(n, r, i, a, t[13], 4, 681279174), a = fb(a, n, r, i, t[0], 11, -358537222), i = fb(i, a, n, r, t[3], 16, -722521979), r = fb(r, i, a, n, t[6], 23, 76029189), n = fb(n, r, i, a, t[9], 4, -640364487), a = fb(a, n, r, i, t[12], 11, -421815835), i = fb(i, a, n, r, t[15], 16, 530742520), n = pb(n, r = fb(r, i, a, n, t[2], 23, -995338651), i, a, t[0], 6, -198630844), a = pb(a, n, r, i, t[7], 10, 1126891415), i = pb(i, a, n, r, t[14], 15, -1416354905), r = pb(r, i, a, n, t[5], 21, -57434055), n = pb(n, r, i, a, t[12], 6, 1700485571), a = pb(a, n, r, i, t[3], 10, -1894986606), i = pb(i, a, n, r, t[10], 15, -1051523), r = pb(r, i, a, n, t[1], 21, -2054922799), n = pb(n, r, i, a, t[8], 6, 1873313359), a = pb(a, n, r, i, t[15], 10, -30611744), i = pb(i, a, n, r, t[6], 15, -1560198380), r = pb(r, i, a, n, t[13], 21, 1309151649), n = pb(n, r, i, a, t[4], 6, -145523070), a = pb(a, n, r, i, t[11], 10, -1120210379), i = pb(i, a, n, r, t[2], 15, 718787259), r = pb(r, i, a, n, t[9], 21, -343485551), e[0] = xb(n, e[0]), e[1] = xb(r, e[1]), e[2] = xb(i, e[2]), e[3] = xb(a, e[3]);
}
function lb(e, t, n, r, i, a) {
	return t = xb(xb(t, e), xb(r, a)), xb(t << i | t >>> 32 - i, n);
}
function ub(e, t, n, r, i, a, o) {
	return lb(t & n | ~t & r, e, t, i, a, o);
}
function db(e, t, n, r, i, a, o) {
	return lb(t & r | n & ~r, e, t, i, a, o);
}
function fb(e, t, n, r, i, a, o) {
	return lb(t ^ n ^ r, e, t, i, a, o);
}
function pb(e, t, n, r, i, a, o) {
	return lb(n ^ (t | ~r), e, t, i, a, o);
}
function mb(e) {
	var t, n = e.length, r = [
		1732584193,
		-271733879,
		-1732584194,
		271733878
	];
	for (t = 64; t <= e.length; t += 64) cb(r, hb(e.substring(t - 64, t)));
	e = e.substring(t - 64);
	var i = [
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0
	];
	for (t = 0; t < e.length; t++) i[t >> 2] |= e.charCodeAt(t) << (t % 4 << 3);
	if (i[t >> 2] |= 128 << (t % 4 << 3), t > 55) for (cb(r, i), t = 0; t < 16; t++) i[t] = 0;
	return i[14] = 8 * n, cb(r, i), r;
}
function hb(e) {
	var t, n = [];
	for (t = 0; t < 64; t += 4) n[t >> 2] = e.charCodeAt(t) + (e.charCodeAt(t + 1) << 8) + (e.charCodeAt(t + 2) << 16) + (e.charCodeAt(t + 3) << 24);
	return n;
}
var gb = "0123456789abcdef".split("");
function _b(e) {
	for (var t = "", n = 0; n < 4; n++) t += gb[e >> 8 * n + 4 & 15] + gb[e >> 8 * n & 15];
	return t;
}
function vb(e) {
	return String.fromCharCode(255 & e, (65280 & e) >> 8, (16711680 & e) >> 16, (4278190080 & e) >> 24);
}
function yb(e) {
	return mb(e).map(vb).join("");
}
var bb = function(e) {
	for (var t = 0; t < e.length; t++) e[t] = _b(e[t]);
	return e.join("");
}(mb("hello")) != "5d41402abc4b2a76b9719d911017c592";
function xb(e, t) {
	if (bb) {
		var n = (65535 & e) + (65535 & t);
		return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
	}
	return e + t & 4294967295;
}
function Sb(e, t) {
	var n, r, i, a;
	if (e !== n) {
		for (var o = (i = e, a = 1 + (256 / e.length | 0), Array(a + 1).join(i)), s = [], c = 0; c < 256; c++) s[c] = c;
		var l = 0;
		for (c = 0; c < 256; c++) {
			var u = s[c];
			l = (l + u + o.charCodeAt(c)) % 256, s[c] = s[l], s[l] = u;
		}
		n = e, r = s;
	} else s = r;
	var d = t.length, f = 0, p = 0, m = "";
	for (c = 0; c < d; c++) p = (p + (u = s[f = (f + 1) % 256])) % 256, s[f] = s[p], s[p] = u, o = s[(s[f] + s[p]) % 256], m += String.fromCharCode(t.charCodeAt(c) ^ o);
	return m;
}
var Cb = {
	print: 4,
	modify: 8,
	copy: 16,
	"annot-forms": 32
};
function wb(e, t, n, r) {
	this.v = 1, this.r = 2;
	var i = 192;
	e.forEach(function(e) {
		if (Cb.perm !== void 0) throw Error("Invalid permission: " + e);
		i += Cb[e];
	}), this.padding = "(¿N^NuAd\0NVÿú\b..\0¶Ðh>/\f©þdSiz";
	var a = (t + this.padding).substr(0, 32), o = (n + this.padding).substr(0, 32);
	this.O = this.processOwnerPassword(a, o), this.P = -(1 + (255 ^ i)), this.encryptionKey = yb(a + this.O + this.lsbFirstWord(this.P) + this.hexToBytes(r)).substr(0, 5), this.U = Sb(this.encryptionKey, this.padding);
}
function Tb(e) {
	if (/[^\u0000-\u00ff]/.test(e)) throw Error("Invalid PDF Name Object: " + e + ", Only accept ASCII characters.");
	for (var t = "", n = e.length, r = 0; r < n; r++) {
		var i = e.charCodeAt(r);
		t += i < 33 || i === 35 || i === 37 || i === 40 || i === 41 || i === 47 || i === 60 || i === 62 || i === 91 || i === 93 || i === 123 || i === 125 || i > 126 ? "#" + ("0" + i.toString(16)).slice(-2) : e[r];
	}
	return t;
}
function Eb(e) {
	if (Fa(e) !== "object") throw Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
	var t = {};
	this.subscribe = function(e, n, r) {
		if (r ||= !1, typeof e != "string" || typeof n != "function" || typeof r != "boolean") throw Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
		t.hasOwnProperty(e) || (t[e] = {});
		var i = Math.random().toString(35);
		return t[e][i] = [n, !!r], i;
	}, this.unsubscribe = function(e) {
		for (var n in t) if (t[n][e]) return delete t[n][e], Object.keys(t[n]).length === 0 && delete t[n], !0;
		return !1;
	}, this.publish = function(n) {
		if (t.hasOwnProperty(n)) {
			var r = Array.prototype.slice.call(arguments, 1), i = [];
			for (var a in t[n]) {
				var o = t[n][a];
				try {
					o[0].apply(e, r);
				} catch (e) {
					Qy.console && eb.error("jsPDF PubSub Error", e.message, e);
				}
				o[1] && i.push(a);
			}
			i.length && i.forEach(this.unsubscribe);
		}
	}, this.getTopics = function() {
		return t;
	};
}
function Db(e) {
	if (!(this instanceof Db)) return new Db(e);
	var t = "opacity,stroke-opacity".split(",");
	for (var n in e) e.hasOwnProperty(n) && t.indexOf(n) >= 0 && (this[n] = e[n]);
	this.id = "", this.objectNumber = -1;
}
function Ob(e, t) {
	this.gState = e, this.matrix = t, this.id = "", this.objectNumber = -1;
}
function kb(e, t, n, r, i) {
	if (!(this instanceof kb)) return new kb(e, t, n, r, i);
	this.type = e === "axial" ? 2 : 3, this.coords = t, this.colors = n, Ob.call(this, r, i);
}
function Ab(e, t, n, r, i) {
	if (!(this instanceof Ab)) return new Ab(e, t, n, r, i);
	this.boundingBox = e, this.xStep = t, this.yStep = n, this.stream = "", this.cloneIndex = 0, Ob.call(this, r, i);
}
function jb(e) {
	var t, n = typeof arguments[0] == "string" ? arguments[0] : "p", r = arguments[1], i = arguments[2], a = arguments[3], o = [], s = 1, c = 16, l = "S", u = null;
	Fa(e ||= {}) === "object" && (n = e.orientation, r = e.unit || r, i = e.format || i, a = e.compress || e.compressPdf || a, (u = e.encryption || null) !== null && (u.userPassword = u.userPassword || "", u.ownerPassword = u.ownerPassword || "", u.userPermissions = u.userPermissions || []), s = typeof e.userUnit == "number" ? Math.abs(e.userUnit) : 1, e.precision !== void 0 && (t = e.precision), e.floatPrecision !== void 0 && (c = e.floatPrecision), l = e.defaultPathOperation || "S"), o = e.filters || (!0 === a ? ["FlateEncode"] : o), r ||= "mm", n = ("" + (n || "P")).toLowerCase();
	var d = e.putOnlyUsedFonts || !1, f = {}, p = {
		internal: {},
		__private__: {}
	};
	p.__private__.PubSub = Eb;
	var m = "1.3", h = p.__private__.getPdfVersion = function() {
		return m;
	};
	p.__private__.setPdfVersion = function(e) {
		m = e;
	};
	var g = {
		a0: [2383.94, 3370.39],
		a1: [1683.78, 2383.94],
		a2: [1190.55, 1683.78],
		a3: [841.89, 1190.55],
		a4: [595.28, 841.89],
		a5: [419.53, 595.28],
		a6: [297.64, 419.53],
		a7: [209.76, 297.64],
		a8: [147.4, 209.76],
		a9: [104.88, 147.4],
		a10: [73.7, 104.88],
		b0: [2834.65, 4008.19],
		b1: [2004.09, 2834.65],
		b2: [1417.32, 2004.09],
		b3: [1000.63, 1417.32],
		b4: [708.66, 1000.63],
		b5: [498.9, 708.66],
		b6: [354.33, 498.9],
		b7: [249.45, 354.33],
		b8: [175.75, 249.45],
		b9: [124.72, 175.75],
		b10: [87.87, 124.72],
		c0: [2599.37, 3676.54],
		c1: [1836.85, 2599.37],
		c2: [1298.27, 1836.85],
		c3: [918.43, 1298.27],
		c4: [649.13, 918.43],
		c5: [459.21, 649.13],
		c6: [323.15, 459.21],
		c7: [229.61, 323.15],
		c8: [161.57, 229.61],
		c9: [113.39, 161.57],
		c10: [79.37, 113.39],
		dl: [311.81, 623.62],
		letter: [612, 792],
		"government-letter": [576, 756],
		legal: [612, 1008],
		"junior-legal": [576, 360],
		ledger: [1224, 792],
		tabloid: [792, 1224],
		"credit-card": [153, 243]
	};
	p.__private__.getPageFormats = function() {
		return g;
	};
	var _ = p.__private__.getPageFormat = function(e) {
		return g[e];
	};
	i ||= "a4";
	var v = "compat", y = "advanced", b = v;
	function x() {
		this.saveGraphicsState(), V(new He(we, 0, 0, -we, 0, wn() * we).toString() + " cm"), this.setFontSize(this.getFontSize() / we), l = "n", b = y;
	}
	function S() {
		this.restoreGraphicsState(), l = "S", b = v;
	}
	var C = p.__private__.combineFontStyleAndFontWeight = function(e, t) {
		if (e == "bold" && t == "normal" || e == "bold" && t == 400 || e == "normal" && t == "italic" || e == "bold" && t == "italic") throw Error("Invalid Combination of fontweight and fontstyle");
		return t && (e = t == 400 || t === "normal" ? e === "italic" ? "italic" : "normal" : t != 700 && t !== "bold" || e !== "normal" ? (t == 700 ? "bold" : t) + "" + e : "bold"), e;
	};
	p.advancedAPI = function(e) {
		var t = b === v;
		return t && x.call(this), typeof e != "function" || (e(this), t && S.call(this)), this;
	}, p.compatAPI = function(e) {
		var t = b === y;
		return t && S.call(this), typeof e != "function" || (e(this), t && x.call(this)), this;
	}, p.isAdvancedAPI = function() {
		return b === y;
	};
	var w, T = function(e) {
		if (b !== y) throw Error(e + " is only available in 'advanced' API mode. You need to call advancedAPI() first.");
	}, E = p.roundToPrecision = p.__private__.roundToPrecision = function(e, n) {
		var r = t || n;
		if (isNaN(e) || isNaN(r)) throw Error("Invalid argument passed to jsPDF.roundToPrecision");
		return e.toFixed(r).replace(/0+$/, "");
	};
	w = p.hpf = p.__private__.hpf = typeof c == "number" ? function(e) {
		if (isNaN(e)) throw Error("Invalid argument passed to jsPDF.hpf");
		return E(e, c);
	} : c === "smart" ? function(e) {
		if (isNaN(e)) throw Error("Invalid argument passed to jsPDF.hpf");
		return E(e, e > -1 && e < 1 ? 16 : 5);
	} : function(e) {
		if (isNaN(e)) throw Error("Invalid argument passed to jsPDF.hpf");
		return E(e, 16);
	};
	var D = p.f2 = p.__private__.f2 = function(e) {
		if (isNaN(e)) throw Error("Invalid argument passed to jsPDF.f2");
		return E(e, 2);
	}, O = p.__private__.f3 = function(e) {
		if (isNaN(e)) throw Error("Invalid argument passed to jsPDF.f3");
		return E(e, 3);
	}, k = p.scale = p.__private__.scale = function(e) {
		if (isNaN(e)) throw Error("Invalid argument passed to jsPDF.scale");
		return b === v ? e * we : b === y ? e : void 0;
	}, A = function(e) {
		return k(function(e) {
			return b === v ? wn() - e : b === y ? e : void 0;
		}(e));
	};
	p.__private__.setPrecision = p.setPrecision = function(e) {
		typeof parseInt(e, 10) == "number" && (t = parseInt(e, 10));
	};
	var j, M = "00000000000000000000000000000000", N = p.__private__.getFileId = function() {
		return M;
	}, P = p.__private__.setFileId = function(e) {
		return M = e !== void 0 && /^[a-fA-F0-9]{32}$/.test(e) ? e.toUpperCase() : M.split("").map(function() {
			return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
		}).join(""), u !== null && (kt = new wb(u.userPermissions, u.userPassword, u.ownerPassword, M)), M;
	};
	p.setFileId = function(e) {
		return P(e), this;
	}, p.getFileId = function() {
		return N();
	};
	var F = p.__private__.convertDateToPDFDate = function(e) {
		var t = e.getTimezoneOffset(), n = t < 0 ? "+" : "-", r = Math.floor(Math.abs(t / 60)), i = Math.abs(t % 60), a = [
			n,
			te(r),
			"'",
			te(i),
			"'"
		].join("");
		return [
			"D:",
			e.getFullYear(),
			te(e.getMonth() + 1),
			te(e.getDate()),
			te(e.getHours()),
			te(e.getMinutes()),
			te(e.getSeconds()),
			a
		].join("");
	}, I = p.__private__.convertPDFDateToDate = function(e) {
		var t = parseInt(e.substr(2, 4), 10), n = parseInt(e.substr(6, 2), 10) - 1, r = parseInt(e.substr(8, 2), 10), i = parseInt(e.substr(10, 2), 10), a = parseInt(e.substr(12, 2), 10), o = parseInt(e.substr(14, 2), 10);
		return new Date(t, n, r, i, a, o, 0);
	}, ee = p.__private__.setCreationDate = function(e) {
		var t;
		if (e === void 0 && (e = /* @__PURE__ */ new Date()), e instanceof Date) t = F(e);
		else {
			if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(e)) throw Error("Invalid argument passed to jsPDF.setCreationDate");
			t = e;
		}
		return j = t;
	}, L = p.__private__.getCreationDate = function(e) {
		var t = j;
		return e === "jsDate" && (t = I(j)), t;
	};
	p.setCreationDate = function(e) {
		return ee(e), this;
	}, p.getCreationDate = function(e) {
		return L(e);
	};
	var R, te = p.__private__.padd2 = function(e) {
		return ("0" + parseInt(e)).slice(-2);
	}, z = p.__private__.padd2Hex = function(e) {
		return ("00" + (e = e.toString())).substr(e.length);
	}, ne = 0, re = [], ie = [], ae = 0, B = [], oe = [], se = !1, ce = ie;
	p.__private__.setCustomOutputDestination = function(e) {
		se = !0, ce = e;
	};
	var le = function(e) {
		se || (ce = e);
	};
	p.__private__.resetCustomOutputDestination = function() {
		se = !1, ce = ie;
	};
	var V = p.__private__.out = function(e) {
		return e = e.toString(), ae += e.length + 1, ce.push(e), ce;
	}, ue = p.__private__.write = function(e) {
		return V(arguments.length === 1 ? e.toString() : Array.prototype.join.call(arguments, " "));
	}, de = p.__private__.getArrayBuffer = function(e) {
		for (var t = e.length, n = new ArrayBuffer(t), r = new Uint8Array(n); t--;) r[t] = e.charCodeAt(t);
		return n;
	}, fe = [
		[
			"Helvetica",
			"helvetica",
			"normal",
			"WinAnsiEncoding"
		],
		[
			"Helvetica-Bold",
			"helvetica",
			"bold",
			"WinAnsiEncoding"
		],
		[
			"Helvetica-Oblique",
			"helvetica",
			"italic",
			"WinAnsiEncoding"
		],
		[
			"Helvetica-BoldOblique",
			"helvetica",
			"bolditalic",
			"WinAnsiEncoding"
		],
		[
			"Courier",
			"courier",
			"normal",
			"WinAnsiEncoding"
		],
		[
			"Courier-Bold",
			"courier",
			"bold",
			"WinAnsiEncoding"
		],
		[
			"Courier-Oblique",
			"courier",
			"italic",
			"WinAnsiEncoding"
		],
		[
			"Courier-BoldOblique",
			"courier",
			"bolditalic",
			"WinAnsiEncoding"
		],
		[
			"Times-Roman",
			"times",
			"normal",
			"WinAnsiEncoding"
		],
		[
			"Times-Bold",
			"times",
			"bold",
			"WinAnsiEncoding"
		],
		[
			"Times-Italic",
			"times",
			"italic",
			"WinAnsiEncoding"
		],
		[
			"Times-BoldItalic",
			"times",
			"bolditalic",
			"WinAnsiEncoding"
		],
		[
			"ZapfDingbats",
			"zapfdingbats",
			"normal",
			null
		],
		[
			"Symbol",
			"symbol",
			"normal",
			null
		]
	];
	p.__private__.getStandardFonts = function() {
		return fe;
	};
	var pe = e.fontSize || 16;
	p.__private__.setFontSize = p.setFontSize = function(e) {
		return pe = b === y ? e / we : e, this;
	};
	var me, he = p.__private__.getFontSize = p.getFontSize = function() {
		return b === v ? pe : pe * we;
	}, ge = e.R2L || !1;
	p.__private__.setR2L = p.setR2L = function(e) {
		return ge = e, this;
	}, p.__private__.getR2L = p.getR2L = function() {
		return ge;
	};
	var _e, ve = p.__private__.setZoomMode = function(e) {
		if (/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(e)) me = e;
		else if (isNaN(e)) {
			if ([
				void 0,
				null,
				"fullwidth",
				"fullheight",
				"fullpage",
				"original"
			].indexOf(e) === -1) throw Error("zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. \"" + e + "\" is not recognized.");
			me = e;
		} else me = parseInt(e, 10);
	};
	p.__private__.getZoomMode = function() {
		return me;
	};
	var ye, be = p.__private__.setPageMode = function(e) {
		if ([
			void 0,
			null,
			"UseNone",
			"UseOutlines",
			"UseThumbs",
			"FullScreen"
		].indexOf(e) == -1) throw Error("Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. \"" + e + "\" is not recognized.");
		_e = e;
	};
	p.__private__.getPageMode = function() {
		return _e;
	};
	var xe = p.__private__.setLayoutMode = function(e) {
		if ([
			void 0,
			null,
			"continuous",
			"single",
			"twoleft",
			"tworight",
			"two"
		].indexOf(e) == -1) throw Error("Layout mode must be one of continuous, single, twoleft, tworight. \"" + e + "\" is not recognized.");
		ye = e;
	};
	p.__private__.getLayoutMode = function() {
		return ye;
	}, p.__private__.setDisplayMode = p.setDisplayMode = function(e, t, n) {
		return ve(e), xe(t), be(n), this;
	};
	var Se = {
		title: "",
		subject: "",
		author: "",
		keywords: "",
		creator: ""
	};
	p.__private__.getDocumentProperty = function(e) {
		if (Object.keys(Se).indexOf(e) === -1) throw Error("Invalid argument passed to jsPDF.getDocumentProperty");
		return Se[e];
	}, p.__private__.getDocumentProperties = function() {
		return Se;
	}, p.__private__.setDocumentProperties = p.setProperties = p.setDocumentProperties = function(e) {
		for (var t in Se) Se.hasOwnProperty(t) && e[t] && (Se[t] = e[t]);
		return this;
	}, p.__private__.setDocumentProperty = function(e, t) {
		if (Object.keys(Se).indexOf(e) === -1) throw Error("Invalid arguments passed to jsPDF.setDocumentProperty");
		return Se[e] = t;
	};
	var Ce, we, Te, Ee, De, H = {}, Oe = {}, ke = [], Ae = {}, je = {}, Me = {}, Ne = {}, Pe = null, Fe = 0, Ie = [], Le = new Eb(p), Re = e.hotfixes || [], ze = {}, Be = {}, Ve = [], He = function e(t, n, r, i, a, o) {
		if (!(this instanceof e)) return new e(t, n, r, i, a, o);
		isNaN(t) && (t = 1), isNaN(n) && (n = 0), isNaN(r) && (r = 0), isNaN(i) && (i = 1), isNaN(a) && (a = 0), isNaN(o) && (o = 0), this._matrix = [
			t,
			n,
			r,
			i,
			a,
			o
		];
	};
	Object.defineProperty(He.prototype, "sx", {
		get: function() {
			return this._matrix[0];
		},
		set: function(e) {
			this._matrix[0] = e;
		}
	}), Object.defineProperty(He.prototype, "shy", {
		get: function() {
			return this._matrix[1];
		},
		set: function(e) {
			this._matrix[1] = e;
		}
	}), Object.defineProperty(He.prototype, "shx", {
		get: function() {
			return this._matrix[2];
		},
		set: function(e) {
			this._matrix[2] = e;
		}
	}), Object.defineProperty(He.prototype, "sy", {
		get: function() {
			return this._matrix[3];
		},
		set: function(e) {
			this._matrix[3] = e;
		}
	}), Object.defineProperty(He.prototype, "tx", {
		get: function() {
			return this._matrix[4];
		},
		set: function(e) {
			this._matrix[4] = e;
		}
	}), Object.defineProperty(He.prototype, "ty", {
		get: function() {
			return this._matrix[5];
		},
		set: function(e) {
			this._matrix[5] = e;
		}
	}), Object.defineProperty(He.prototype, "a", {
		get: function() {
			return this._matrix[0];
		},
		set: function(e) {
			this._matrix[0] = e;
		}
	}), Object.defineProperty(He.prototype, "b", {
		get: function() {
			return this._matrix[1];
		},
		set: function(e) {
			this._matrix[1] = e;
		}
	}), Object.defineProperty(He.prototype, "c", {
		get: function() {
			return this._matrix[2];
		},
		set: function(e) {
			this._matrix[2] = e;
		}
	}), Object.defineProperty(He.prototype, "d", {
		get: function() {
			return this._matrix[3];
		},
		set: function(e) {
			this._matrix[3] = e;
		}
	}), Object.defineProperty(He.prototype, "e", {
		get: function() {
			return this._matrix[4];
		},
		set: function(e) {
			this._matrix[4] = e;
		}
	}), Object.defineProperty(He.prototype, "f", {
		get: function() {
			return this._matrix[5];
		},
		set: function(e) {
			this._matrix[5] = e;
		}
	}), Object.defineProperty(He.prototype, "rotation", { get: function() {
		return Math.atan2(this.shx, this.sx);
	} }), Object.defineProperty(He.prototype, "scaleX", { get: function() {
		return this.decompose().scale.sx;
	} }), Object.defineProperty(He.prototype, "scaleY", { get: function() {
		return this.decompose().scale.sy;
	} }), Object.defineProperty(He.prototype, "isIdentity", { get: function() {
		return this.sx === 1 && this.shy === 0 && this.shx === 0 && this.sy === 1 && this.tx === 0 && this.ty === 0;
	} }), He.prototype.join = function(e) {
		return [
			this.sx,
			this.shy,
			this.shx,
			this.sy,
			this.tx,
			this.ty
		].map(w).join(e);
	}, He.prototype.multiply = function(e) {
		return new He(e.sx * this.sx + e.shy * this.shx, e.sx * this.shy + e.shy * this.sy, e.shx * this.sx + e.sy * this.shx, e.shx * this.shy + e.sy * this.sy, e.tx * this.sx + e.ty * this.shx + this.tx, e.tx * this.shy + e.ty * this.sy + this.ty);
	}, He.prototype.decompose = function() {
		var e = this.sx, t = this.shy, n = this.shx, r = this.sy, i = this.tx, a = this.ty, o = Math.sqrt(e * e + t * t), s = (e /= o) * n + (t /= o) * r;
		n -= e * s, r -= t * s;
		var c = Math.sqrt(n * n + r * r);
		return s /= c, e * (r /= c) < t * (n /= c) && (e = -e, t = -t, s = -s, o = -o), {
			scale: new He(o, 0, 0, c, 0, 0),
			translate: new He(1, 0, 0, 1, i, a),
			rotate: new He(e, t, -t, e, 0, 0),
			skew: new He(1, 0, s, 1, 0, 0)
		};
	}, He.prototype.toString = function(e) {
		return this.join(" ");
	}, He.prototype.inversed = function() {
		var e = this.sx, t = this.shy, n = this.shx, r = this.sy, i = this.tx, a = this.ty, o = 1 / (e * r - t * n), s = r * o, c = -t * o, l = -n * o, u = e * o;
		return new He(s, c, l, u, -s * i - l * a, -c * i - u * a);
	}, He.prototype.applyToPoint = function(e) {
		return new pn(e.x * this.sx + e.y * this.shx + this.tx, e.x * this.shy + e.y * this.sy + this.ty);
	}, He.prototype.applyToRectangle = function(e) {
		var t = this.applyToPoint(e), n = this.applyToPoint(new pn(e.x + e.w, e.y + e.h));
		return new mn(t.x, t.y, n.x - t.x, n.y - t.y);
	}, He.prototype.clone = function() {
		var e = this.sx, t = this.shy, n = this.shx, r = this.sy, i = this.tx, a = this.ty;
		return new He(e, t, n, r, i, a);
	}, p.Matrix = He;
	var Ue = p.matrixMult = function(e, t) {
		return t.multiply(e);
	}, We = new He(1, 0, 0, 1, 0, 0);
	p.unitMatrix = p.identityMatrix = We;
	var Ge = function(e, t) {
		if (!je[e]) {
			var n = (t instanceof kb ? "Sh" : "P") + (Object.keys(Ae).length + 1).toString(10);
			t.id = n, je[e] = n, Ae[n] = t, Le.publish("addPattern", t);
		}
	};
	p.ShadingPattern = kb, p.TilingPattern = Ab, p.addShadingPattern = function(e, t) {
		return T("addShadingPattern()"), Ge(e, t), this;
	}, p.beginTilingPattern = function(e) {
		T("beginTilingPattern()"), gn(e.boundingBox[0], e.boundingBox[1], e.boundingBox[2] - e.boundingBox[0], e.boundingBox[3] - e.boundingBox[1], e.matrix);
	}, p.endTilingPattern = function(e, t) {
		T("endTilingPattern()"), t.stream = oe[R].join("\n"), Ge(e, t), Le.publish("endTilingPattern", t), Ve.pop().restore();
	};
	var Ke, qe = p.__private__.newObject = function() {
		var e = Je();
		return Ye(e, !0), e;
	}, Je = p.__private__.newObjectDeferred = function() {
		return ne++, re[ne] = function() {
			return ae;
		}, ne;
	}, Ye = function(e, t) {
		return t = typeof t == "boolean" && t, re[e] = ae, t && V(e + " 0 obj"), e;
	}, Xe = p.__private__.newAdditionalObject = function() {
		var e = {
			objId: Je(),
			content: ""
		};
		return B.push(e), e;
	}, Ze = Je(), Qe = Je(), $e = p.__private__.decodeColorString = function(e) {
		var t = e.split(" ");
		if (t.length !== 2 || t[1] !== "g" && t[1] !== "G") t.length !== 5 || t[4] !== "k" && t[4] !== "K" || (t = [
			(1 - t[0]) * (1 - t[3]),
			(1 - t[1]) * (1 - t[3]),
			(1 - t[2]) * (1 - t[3]),
			"r"
		]);
		else {
			var n = parseFloat(t[0]);
			t = [
				n,
				n,
				n,
				"r"
			];
		}
		for (var r = "#", i = 0; i < 3; i++) r += ("0" + Math.floor(255 * parseFloat(t[i])).toString(16)).slice(-2);
		return r;
	}, et = p.__private__.encodeColorString = function(e) {
		var t;
		typeof e == "string" && (e = { ch1: e });
		var n = e.ch1, r = e.ch2, i = e.ch3, a = e.ch4, o = e.pdfColorType === "draw" ? [
			"G",
			"RG",
			"K"
		] : [
			"g",
			"rg",
			"k"
		];
		if (typeof n == "string" && n.charAt(0) !== "#") {
			var s = new ab(n);
			if (s.ok) n = s.toHex();
			else if (!/^\d*\.?\d*$/.test(n)) throw Error("Invalid color \"" + n + "\" passed to jsPDF.encodeColorString.");
		}
		if (typeof n == "string" && /^#[0-9A-Fa-f]{3}$/.test(n) && (n = "#" + n[1] + n[1] + n[2] + n[2] + n[3] + n[3]), typeof n == "string" && /^#[0-9A-Fa-f]{6}$/.test(n)) {
			var c = parseInt(n.substr(1), 16);
			n = c >> 16 & 255, r = c >> 8 & 255, i = 255 & c;
		}
		if (r === void 0 || a === void 0 && n === r && r === i) t = typeof n == "string" ? n + " " + o[0] : e.precision === 2 ? D(n / 255) + " " + o[0] : O(n / 255) + " " + o[0];
		else if (a === void 0 || Fa(a) === "object") {
			if (a && !isNaN(a.a) && a.a === 0) return [
				"1.",
				"1.",
				"1.",
				o[1]
			].join(" ");
			t = typeof n == "string" ? [
				n,
				r,
				i,
				o[1]
			].join(" ") : e.precision === 2 ? [
				D(n / 255),
				D(r / 255),
				D(i / 255),
				o[1]
			].join(" ") : [
				O(n / 255),
				O(r / 255),
				O(i / 255),
				o[1]
			].join(" ");
		} else t = typeof n == "string" ? [
			n,
			r,
			i,
			a,
			o[2]
		].join(" ") : e.precision === 2 ? [
			D(n),
			D(r),
			D(i),
			D(a),
			o[2]
		].join(" ") : [
			O(n),
			O(r),
			O(i),
			O(a),
			o[2]
		].join(" ");
		return t;
	}, tt = p.__private__.getFilters = function() {
		return o;
	}, nt = p.__private__.putStream = function(e) {
		var t = (e ||= {}).data || "", n = e.filters || tt(), r = e.alreadyAppliedFilters || [], i = e.addLength1 || !1, a = t.length, o = e.objectId, s = function(e) {
			return e;
		};
		if (u !== null && o === void 0) throw Error("ObjectId must be passed to putStream for file encryption");
		u !== null && (s = kt.encryptor(o, 0));
		var c = {};
		!0 === n && (n = ["FlateEncode"]);
		var l = e.additionalKeyValues || [], d = (c = jb.API.processDataByFilters === void 0 ? {
			data: t,
			reverseChain: []
		} : jb.API.processDataByFilters(t, n)).reverseChain + (Array.isArray(r) ? r.join(" ") : r.toString());
		if (c.data.length !== 0 && (l.push({
			key: "Length",
			value: c.data.length
		}), !0 === i && l.push({
			key: "Length1",
			value: a
		})), d.length != 0) if (d.split("/").length - 1 == 1) l.push({
			key: "Filter",
			value: d
		});
		else {
			l.push({
				key: "Filter",
				value: "[" + d + "]"
			});
			for (var f = 0; f < l.length; f += 1) if (l[f].key === "DecodeParms") {
				for (var p = [], m = 0; m < c.reverseChain.split("/").length - 1; m += 1) p.push("null");
				p.push(l[f].value), l[f].value = "[" + p.join(" ") + "]";
			}
		}
		V("<<");
		for (var h = 0; h < l.length; h++) V("/" + l[h].key + " " + l[h].value);
		V(">>"), c.data.length !== 0 && (V("stream"), V(s(c.data)), V("endstream"));
	}, rt = p.__private__.putPage = function(e) {
		var t = e.number, n = e.data, r = e.objId, i = e.contentsObjId;
		Ye(r, !0), V("<</Type /Page"), V("/Parent " + e.rootDictionaryObjId + " 0 R"), V("/Resources " + e.resourceDictionaryObjId + " 0 R"), V("/MediaBox [" + parseFloat(w(e.mediaBox.bottomLeftX)) + " " + parseFloat(w(e.mediaBox.bottomLeftY)) + " " + w(e.mediaBox.topRightX) + " " + w(e.mediaBox.topRightY) + "]"), e.cropBox !== null && V("/CropBox [" + w(e.cropBox.bottomLeftX) + " " + w(e.cropBox.bottomLeftY) + " " + w(e.cropBox.topRightX) + " " + w(e.cropBox.topRightY) + "]"), e.bleedBox !== null && V("/BleedBox [" + w(e.bleedBox.bottomLeftX) + " " + w(e.bleedBox.bottomLeftY) + " " + w(e.bleedBox.topRightX) + " " + w(e.bleedBox.topRightY) + "]"), e.trimBox !== null && V("/TrimBox [" + w(e.trimBox.bottomLeftX) + " " + w(e.trimBox.bottomLeftY) + " " + w(e.trimBox.topRightX) + " " + w(e.trimBox.topRightY) + "]"), e.artBox !== null && V("/ArtBox [" + w(e.artBox.bottomLeftX) + " " + w(e.artBox.bottomLeftY) + " " + w(e.artBox.topRightX) + " " + w(e.artBox.topRightY) + "]"), typeof e.userUnit == "number" && e.userUnit !== 1 && V("/UserUnit " + e.userUnit), Le.publish("putPage", {
			objId: r,
			pageContext: Ie[t],
			pageNumber: t,
			page: n
		}), V("/Contents " + i + " 0 R"), V(">>"), V("endobj");
		var a = n.join("\n");
		return b === y && (a += "\nQ"), Ye(i, !0), nt({
			data: a,
			filters: tt(),
			objectId: i
		}), V("endobj"), r;
	}, it = p.__private__.putPages = function() {
		var e, t, n = [];
		for (e = 1; e <= Fe; e++) Ie[e].objId = Je(), Ie[e].contentsObjId = Je();
		for (e = 1; e <= Fe; e++) n.push(rt({
			number: e,
			data: oe[e],
			objId: Ie[e].objId,
			contentsObjId: Ie[e].contentsObjId,
			mediaBox: Ie[e].mediaBox,
			cropBox: Ie[e].cropBox,
			bleedBox: Ie[e].bleedBox,
			trimBox: Ie[e].trimBox,
			artBox: Ie[e].artBox,
			userUnit: Ie[e].userUnit,
			rootDictionaryObjId: Ze,
			resourceDictionaryObjId: Qe
		}));
		Ye(Ze, !0), V("<</Type /Pages");
		var r = "/Kids [";
		for (t = 0; t < Fe; t++) r += n[t] + " 0 R ";
		V(r + "]"), V("/Count " + Fe), V(">>"), V("endobj"), Le.publish("postPutPages");
	}, at = function(e) {
		Le.publish("putFont", {
			font: e,
			out: V,
			newObject: qe,
			putStream: nt
		}), !0 !== e.isAlreadyPutted && (e.objectNumber = qe(), V("<<"), V("/Type /Font"), V("/BaseFont /" + Tb(e.postScriptName)), V("/Subtype /Type1"), typeof e.encoding == "string" && V("/Encoding /" + e.encoding), V("/FirstChar 32"), V("/LastChar 255"), V(">>"), V("endobj"));
	}, ot = function(e) {
		e.objectNumber = qe();
		var t = [];
		t.push({
			key: "Type",
			value: "/XObject"
		}), t.push({
			key: "Subtype",
			value: "/Form"
		}), t.push({
			key: "BBox",
			value: "[" + [
				w(e.x),
				w(e.y),
				w(e.x + e.width),
				w(e.y + e.height)
			].join(" ") + "]"
		}), t.push({
			key: "Matrix",
			value: "[" + e.matrix.toString() + "]"
		}), nt({
			data: e.pages[1].join("\n"),
			additionalKeyValues: t,
			objectId: e.objectNumber
		}), V("endobj");
	}, st = function(e, t) {
		t ||= 21;
		var n = qe(), r = function(e, t) {
			var n, r = [], i = 1 / (t - 1);
			for (n = 0; n < 1; n += i) r.push(n);
			if (r.push(1), e[0].offset != 0) {
				var a = {
					offset: 0,
					color: e[0].color
				};
				e.unshift(a);
			}
			if (e[e.length - 1].offset != 1) {
				var o = {
					offset: 1,
					color: e[e.length - 1].color
				};
				e.push(o);
			}
			for (var s = "", c = 0, l = 0; l < r.length; l++) {
				for (n = r[l]; n > e[c + 1].offset;) c++;
				var u = e[c].offset, d = (n - u) / (e[c + 1].offset - u), f = e[c].color, p = e[c + 1].color;
				s += z(Math.round((1 - d) * f[0] + d * p[0]).toString(16)) + z(Math.round((1 - d) * f[1] + d * p[1]).toString(16)) + z(Math.round((1 - d) * f[2] + d * p[2]).toString(16));
			}
			return s.trim();
		}(e.colors, t), i = [];
		i.push({
			key: "FunctionType",
			value: "0"
		}), i.push({
			key: "Domain",
			value: "[0.0 1.0]"
		}), i.push({
			key: "Size",
			value: "[" + t + "]"
		}), i.push({
			key: "BitsPerSample",
			value: "8"
		}), i.push({
			key: "Range",
			value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
		}), i.push({
			key: "Decode",
			value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
		}), nt({
			data: r,
			additionalKeyValues: i,
			alreadyAppliedFilters: ["/ASCIIHexDecode"],
			objectId: n
		}), V("endobj"), e.objectNumber = qe(), V("<< /ShadingType " + e.type), V("/ColorSpace /DeviceRGB");
		var a = "/Coords [" + w(parseFloat(e.coords[0])) + " " + w(parseFloat(e.coords[1])) + " ";
		e.type === 2 ? a += w(parseFloat(e.coords[2])) + " " + w(parseFloat(e.coords[3])) : a += w(parseFloat(e.coords[2])) + " " + w(parseFloat(e.coords[3])) + " " + w(parseFloat(e.coords[4])) + " " + w(parseFloat(e.coords[5])), V(a += "]"), e.matrix && V("/Matrix [" + e.matrix.toString() + "]"), V("/Function " + n + " 0 R"), V("/Extend [true true]"), V(">>"), V("endobj");
	}, ct = function(e, t) {
		var n = Je(), r = qe();
		t.push({
			resourcesOid: n,
			objectOid: r
		}), e.objectNumber = r;
		var i = [];
		i.push({
			key: "Type",
			value: "/Pattern"
		}), i.push({
			key: "PatternType",
			value: "1"
		}), i.push({
			key: "PaintType",
			value: "1"
		}), i.push({
			key: "TilingType",
			value: "1"
		}), i.push({
			key: "BBox",
			value: "[" + e.boundingBox.map(w).join(" ") + "]"
		}), i.push({
			key: "XStep",
			value: w(e.xStep)
		}), i.push({
			key: "YStep",
			value: w(e.yStep)
		}), i.push({
			key: "Resources",
			value: n + " 0 R"
		}), e.matrix && i.push({
			key: "Matrix",
			value: "[" + e.matrix.toString() + "]"
		}), nt({
			data: e.stream,
			additionalKeyValues: i,
			objectId: e.objectNumber
		}), V("endobj");
	}, lt = function(e) {
		for (var t in e.objectNumber = qe(), V("<<"), e) switch (t) {
			case "opacity":
				V("/ca " + D(e[t]));
				break;
			case "stroke-opacity": V("/CA " + D(e[t]));
		}
		V(">>"), V("endobj");
	}, ut = function(e) {
		Ye(e.resourcesOid, !0), V("<<"), V("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), function() {
			for (var e in V("/Font <<"), H) H.hasOwnProperty(e) && (!1 === d || !0 === d && f.hasOwnProperty(e)) && V("/" + e + " " + H[e].objectNumber + " 0 R");
			V(">>");
		}(), function() {
			if (Object.keys(Ae).length > 0) {
				for (var e in V("/Shading <<"), Ae) Ae.hasOwnProperty(e) && Ae[e] instanceof kb && Ae[e].objectNumber >= 0 && V("/" + e + " " + Ae[e].objectNumber + " 0 R");
				Le.publish("putShadingPatternDict"), V(">>");
			}
		}(), function(e) {
			if (Object.keys(Ae).length > 0) {
				for (var t in V("/Pattern <<"), Ae) Ae.hasOwnProperty(t) && Ae[t] instanceof p.TilingPattern && Ae[t].objectNumber >= 0 && Ae[t].objectNumber < e && V("/" + t + " " + Ae[t].objectNumber + " 0 R");
				Le.publish("putTilingPatternDict"), V(">>");
			}
		}(e.objectOid), function() {
			if (Object.keys(Me).length > 0) {
				for (var e in V("/ExtGState <<"), Me) Me.hasOwnProperty(e) && Me[e].objectNumber >= 0 && V("/" + e + " " + Me[e].objectNumber + " 0 R");
				Le.publish("putGStateDict"), V(">>");
			}
		}(), function() {
			for (var e in V("/XObject <<"), ze) ze.hasOwnProperty(e) && ze[e].objectNumber >= 0 && V("/" + e + " " + ze[e].objectNumber + " 0 R");
			Le.publish("putXobjectDict"), V(">>");
		}(), V(">>"), V("endobj");
	}, dt = function(e) {
		Oe[e.fontName] = Oe[e.fontName] || {}, Oe[e.fontName][e.fontStyle] = e.id;
	}, ft = function(e, t, n, r, i) {
		var a = {
			id: "F" + (Object.keys(H).length + 1).toString(10),
			postScriptName: e,
			fontName: t,
			fontStyle: n,
			encoding: r,
			isStandardFont: i || !1,
			metadata: {}
		};
		return Le.publish("addFont", {
			font: a,
			instance: this
		}), H[a.id] = a, dt(a), a.id;
	}, pt = p.__private__.pdfEscape = p.pdfEscape = function(e, t) {
		return function(e, t) {
			var n, r, i, a, o, s, c, l, u;
			if (i = (t ||= {}).sourceEncoding || "Unicode", o = t.outputEncoding, (t.autoencode || o) && H[Ce].metadata && H[Ce].metadata[i] && H[Ce].metadata[i].encoding && (a = H[Ce].metadata[i].encoding, !o && H[Ce].encoding && (o = H[Ce].encoding), !o && a.codePages && (o = a.codePages[0]), typeof o == "string" && (o = a[o]), o)) {
				for (c = !1, s = [], n = 0, r = e.length; n < r; n++) (l = o[e.charCodeAt(n)]) ? s.push(String.fromCharCode(l)) : s.push(e[n]), s[n].charCodeAt(0) >> 8 && (c = !0);
				e = s.join("");
			}
			for (n = e.length; c === void 0 && n !== 0;) e.charCodeAt(n - 1) >> 8 && (c = !0), n--;
			if (!c) return e;
			for (s = t.noBOM ? [] : [254, 255], n = 0, r = e.length; n < r; n++) {
				if ((u = (l = e.charCodeAt(n)) >> 8) >> 8) throw Error("Character at position " + n + " of string '" + e + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
				s.push(u), s.push(l - (u << 8));
			}
			return String.fromCharCode.apply(void 0, s);
		}(e, t).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
	}, mt = p.__private__.beginPage = function(e) {
		oe[++Fe] = [], Ie[Fe] = {
			objId: 0,
			contentsObjId: 0,
			userUnit: Number(s),
			artBox: null,
			bleedBox: null,
			cropBox: null,
			trimBox: null,
			mediaBox: {
				bottomLeftX: 0,
				bottomLeftY: 0,
				topRightX: Number(e[0]),
				topRightY: Number(e[1])
			}
		}, _t(Fe), le(oe[R]);
	}, ht = function(e, t) {
		var r, a, o;
		switch (n = t || n, typeof e == "string" && (r = _(e.toLowerCase()), Array.isArray(r) && (a = r[0], o = r[1])), Array.isArray(e) && (a = e[0] * we, o = e[1] * we), isNaN(a) && (a = i[0], o = i[1]), (a > 14400 || o > 14400) && (eb.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), a = Math.min(14400, a), o = Math.min(14400, o)), i = [a, o], n.substr(0, 1)) {
			case "l":
				o > a && (i = [o, a]);
				break;
			case "p": a > o && (i = [o, a]);
		}
		mt(i), Yt(qt), V(rn), un !== 0 && V(un + " J"), dn !== 0 && V(dn + " j"), Le.publish("addPage", { pageNumber: Fe });
	}, gt = function(e) {
		e > 0 && e <= Fe && (oe.splice(e, 1), Ie.splice(e, 1), Fe--, R > Fe && (R = Fe), this.setPage(R));
	}, _t = function(e) {
		e > 0 && e <= Fe && (R = e);
	}, vt = p.__private__.getNumberOfPages = p.getNumberOfPages = function() {
		return oe.length - 1;
	}, yt = function(e, t, n) {
		var r, i = void 0;
		return n ||= {}, e = e === void 0 ? H[Ce].fontName : e, t = t === void 0 ? H[Ce].fontStyle : t, r = e.toLowerCase(), Oe[r] !== void 0 && Oe[r][t] !== void 0 ? i = Oe[r][t] : Oe[e] !== void 0 && Oe[e][t] !== void 0 ? i = Oe[e][t] : !1 === n.disableWarning && eb.warn("Unable to look up font label for font '" + e + "', '" + t + "'. Refer to getFontList() for available fonts."), i || n.noFallback || ((i = Oe.times[t]) ?? (i = Oe.times.normal)), i;
	}, bt = p.__private__.putInfo = function() {
		var e = qe(), t = function(e) {
			return e;
		};
		for (var n in u !== null && (t = kt.encryptor(e, 0)), V("<<"), V("/Producer (" + pt(t("jsPDF " + jb.version)) + ")"), Se) Se.hasOwnProperty(n) && Se[n] && V("/" + n.substr(0, 1).toUpperCase() + n.substr(1) + " (" + pt(t(Se[n])) + ")");
		V("/CreationDate (" + pt(t(j)) + ")"), V(">>"), V("endobj");
	}, xt = p.__private__.putCatalog = function(e) {
		var t = (e ||= {}).rootDictionaryObjId || Ze;
		switch (qe(), V("<<"), V("/Type /Catalog"), V("/Pages " + t + " 0 R"), me ||= "fullwidth", me) {
			case "fullwidth":
				V("/OpenAction [3 0 R /FitH null]");
				break;
			case "fullheight":
				V("/OpenAction [3 0 R /FitV null]");
				break;
			case "fullpage":
				V("/OpenAction [3 0 R /Fit]");
				break;
			case "original":
				V("/OpenAction [3 0 R /XYZ null null 1]");
				break;
			default:
				var n = "" + me;
				n.substr(n.length - 1) === "%" && (me = parseInt(me) / 100), typeof me == "number" && V("/OpenAction [3 0 R /XYZ null null " + D(me) + "]");
		}
		switch (ye ||= "continuous", ye) {
			case "continuous":
				V("/PageLayout /OneColumn");
				break;
			case "single":
				V("/PageLayout /SinglePage");
				break;
			case "two":
			case "twoleft":
				V("/PageLayout /TwoColumnLeft");
				break;
			case "tworight": V("/PageLayout /TwoColumnRight");
		}
		_e && V("/PageMode /" + _e), Le.publish("putCatalog"), V(">>"), V("endobj");
	}, St = p.__private__.putTrailer = function() {
		V("trailer"), V("<<"), V("/Size " + (ne + 1)), V("/Root " + ne + " 0 R"), V("/Info " + (ne - 1) + " 0 R"), u !== null && V("/Encrypt " + kt.oid + " 0 R"), V("/ID [ <" + M + "> <" + M + "> ]"), V(">>");
	}, Ct = p.__private__.putHeader = function() {
		V("%PDF-" + m), V("%ºß¬à");
	}, wt = p.__private__.putXRef = function() {
		var e = "0000000000";
		V("xref"), V("0 " + (ne + 1)), V("0000000000 65535 f ");
		for (var t = 1; t <= ne; t++) typeof re[t] == "function" ? V((e + re[t]()).slice(-10) + " 00000 n ") : re[t] === void 0 ? V("0000000000 00000 n ") : V((e + re[t]).slice(-10) + " 00000 n ");
	}, Tt = p.__private__.buildDocument = function() {
		var e;
		ne = 0, ae = 0, ie = [], re = [], B = [], Ze = Je(), Qe = Je(), le(ie), Le.publish("buildDocument"), Ct(), it(), function() {
			Le.publish("putAdditionalObjects");
			for (var e = 0; e < B.length; e++) {
				var t = B[e];
				Ye(t.objId, !0), V(t.content), V("endobj");
			}
			Le.publish("postPutAdditionalObjects");
		}(), e = [], function() {
			for (var e in H) H.hasOwnProperty(e) && (!1 === d || !0 === d && f.hasOwnProperty(e)) && at(H[e]);
		}(), function() {
			for (var e in Me) Me.hasOwnProperty(e) && lt(Me[e]);
		}(), function() {
			for (var e in ze) ze.hasOwnProperty(e) && ot(ze[e]);
		}(), function(e) {
			for (var t in Ae) Ae.hasOwnProperty(t) && (Ae[t] instanceof kb ? st(Ae[t]) : Ae[t] instanceof Ab && ct(Ae[t], e));
		}(e), Le.publish("putResources"), e.forEach(ut), ut({
			resourcesOid: Qe,
			objectOid: 2 ** 53 - 1
		}), Le.publish("postPutResources"), u !== null && (kt.oid = qe(), V("<<"), V("/Filter /Standard"), V("/V " + kt.v), V("/R " + kt.r), V("/U <" + kt.toHexString(kt.U) + ">"), V("/O <" + kt.toHexString(kt.O) + ">"), V("/P " + kt.P), V(">>"), V("endobj")), bt(), xt();
		var t = ae;
		return wt(), St(), V("startxref"), V("" + t), V("%%EOF"), le(oe[R]), ie.join("\n");
	}, Et = p.__private__.getBlob = function(e) {
		return new Blob([de(e)], { type: "application/pdf" });
	}, Dt = function(e) {
		for (; e.firstChild;) e.removeChild(e.firstChild);
	}, Ot = function(e) {
		var t, n = e.document, r = n.documentElement, i = n.head, a = n.body;
		return i || (i = n.createElement("head"), r.appendChild(i)), a || (a = n.createElement("body"), r.appendChild(a)), Dt(i), Dt(a), (t = n.createElement("style")).appendChild(n.createTextNode("html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}")), i.appendChild(t), {
			document: n,
			body: a
		};
	}, U = p.output = p.__private__.output = (Ke = function(e, t) {
		switch (typeof (t ||= {}) == "string" ? t = { filename: t } : t.filename = t.filename || "generated.pdf", e) {
			case void 0: return Tt();
			case "save":
				p.save(t.filename);
				break;
			case "arraybuffer": return de(Tt());
			case "blob": return Et(Tt());
			case "bloburi":
			case "bloburl":
				if (Qy.URL !== void 0 && typeof Qy.URL.createObjectURL == "function") return Qy.URL && Qy.URL.createObjectURL(Et(Tt())) || void 0;
				eb.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
				break;
			case "datauristring":
			case "dataurlstring":
				var n = "", r = Tt();
				try {
					n = sb(r);
				} catch {
					n = sb(unescape(encodeURIComponent(r)));
				}
				return "data:application/pdf;filename=" + encodeURIComponent(t.filename) + ";base64," + n;
			case "pdfobjectnewwindow":
				if (Object.prototype.toString.call(Qy) === "[object Window]") {
					var i = "https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js", a = !t.pdfObjectUrl;
					a || (i = t.pdfObjectUrl);
					var o = Qy.open();
					if (o !== null) {
						var s = Ot(o), c = s.document.createElement("script"), l = this;
						c.src = i, a && (c.integrity = "sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==", c.crossOrigin = "anonymous"), c.onload = function() {
							o.PDFObject.embed(l.output("dataurlstring"), t);
						}, s.body.appendChild(c);
					}
					return o;
				}
				throw Error("The option pdfobjectnewwindow just works in a browser-environment.");
			case "pdfjsnewwindow":
				if (Object.prototype.toString.call(Qy) === "[object Window]") {
					var u = t.pdfJsUrl || "examples/PDF.js/web/viewer.html", d = Qy.open();
					if (d !== null) {
						var f = Ot(d), m = f.document.createElement("iframe"), h = u.indexOf("?") === -1 ? "?" : "&";
						l = this, m.id = "pdfViewer", m.width = "500px", m.height = "400px", m.src = u + h + "file=&downloadName=" + encodeURIComponent(t.filename), m.onload = function() {
							d.document.title = t.filename, m.contentWindow.PDFViewerApplication.open(l.output("bloburl"));
						}, f.body.appendChild(m);
					}
					return d;
				}
				throw Error("The option pdfjsnewwindow just works in a browser-environment.");
			case "dataurlnewwindow":
				if (Object.prototype.toString.call(Qy) !== "[object Window]") throw Error("The option dataurlnewwindow just works in a browser-environment.");
				var g = Qy.open();
				if (g !== null) {
					var _ = Ot(g), v = _.document.createElement("iframe");
					v.src = this.output("datauristring", t), _.body.appendChild(v), g.document.title = t.filename;
				}
				if (g || typeof safari > "u") return g;
				break;
			case "datauri":
			case "dataurl": return Qy.document.location.href = this.output("datauristring", t);
			default: return null;
		}
	}, Ke.foo = function() {
		try {
			return Ke.apply(this, arguments);
		} catch (n) {
			var e = n.stack || "";
			~e.indexOf(" at ") && (e = e.split(" at ")[1]);
			var t = "Error in function " + e.split("\n")[0].split("<")[0] + ": " + n.message;
			if (!Qy.console) throw Error(t);
			Qy.console.error(t, n), Qy.alert && alert(t);
		}
	}, Ke.foo.bar = Ke, Ke.foo), W = function(e) {
		return !0 === Array.isArray(Re) && Re.indexOf(e) > -1;
	};
	switch (r) {
		case "pt":
			we = 1;
			break;
		case "mm":
			we = 72 / 25.4;
			break;
		case "cm":
			we = 72 / 2.54;
			break;
		case "in":
			we = 72;
			break;
		case "px":
			we = W("px_scaling") == 1 ? .75 : 96 / 72;
			break;
		case "pc":
		case "em":
			we = 12;
			break;
		case "ex":
			we = 6;
			break;
		default:
			if (typeof r != "number") throw Error("Invalid unit: " + r);
			we = r;
	}
	var kt = null;
	ee(), P();
	var At = p.__private__.getPageInfo = p.getPageInfo = function(e) {
		if (isNaN(e) || e % 1 != 0) throw Error("Invalid argument passed to jsPDF.getPageInfo");
		return {
			objId: Ie[e].objId,
			pageNumber: e,
			pageContext: Ie[e]
		};
	}, jt = p.__private__.getPageInfoByObjId = function(e) {
		if (isNaN(e) || e % 1 != 0) throw Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
		for (var t in Ie) if (Ie[t].objId === e) break;
		return At(t);
	}, Mt = p.__private__.getCurrentPageInfo = p.getCurrentPageInfo = function() {
		return {
			objId: Ie[R].objId,
			pageNumber: R,
			pageContext: Ie[R]
		};
	};
	p.addPage = function() {
		return ht.apply(this, arguments), this;
	}, p.setPage = function() {
		return _t.apply(this, arguments), le.call(this, oe[R]), this;
	}, p.insertPage = function(e) {
		return this.addPage(), this.movePage(R, e), this;
	}, p.movePage = function(e, t) {
		var n, r;
		if (e > t) {
			n = oe[e], r = Ie[e];
			for (var i = e; i > t; i--) oe[i] = oe[i - 1], Ie[i] = Ie[i - 1];
			oe[t] = n, Ie[t] = r, this.setPage(t);
		} else if (e < t) {
			n = oe[e], r = Ie[e];
			for (var a = e; a < t; a++) oe[a] = oe[a + 1], Ie[a] = Ie[a + 1];
			oe[t] = n, Ie[t] = r, this.setPage(t);
		}
		return this;
	}, p.deletePage = function() {
		return gt.apply(this, arguments), this;
	}, p.__private__.text = p.text = function(e, t, n, r, i) {
		var a, o, s, c, l, u, d, p, m, h = (r ||= {}).scope || this;
		if (typeof e == "number" && typeof t == "number" && (typeof n == "string" || Array.isArray(n))) {
			var g = n;
			n = t, t = e, e = g;
		}
		if (arguments[3] instanceof He == 0 ? (s = arguments[4], c = arguments[5], Fa(d = arguments[3]) === "object" && d !== null || (typeof s == "string" && (c = s, s = null), typeof d == "string" && (c = d, d = null), typeof d == "number" && (s = d, d = null), r = {
			flags: d,
			angle: s,
			align: c
		})) : (T("The transform parameter of text() with a Matrix value"), m = i), isNaN(t) || isNaN(n) || e == null) throw Error("Invalid arguments passed to jsPDF.text");
		if (e.length === 0) return h;
		var _, v = "", x = typeof r.lineHeightFactor == "number" ? r.lineHeightFactor : Kt, S = h.internal.scaleFactor;
		function C(e) {
			return e = e.split("	").join(Array(r.TabLen || 9).join(" ")), pt(e, d);
		}
		function E(e) {
			for (var t, n = e.concat(), r = [], i = n.length; i--;) typeof (t = n.shift()) == "string" ? r.push(t) : Array.isArray(e) && (t.length === 1 || t[1] === void 0 && t[2] === void 0) ? r.push(t[0]) : r.push([
				t[0],
				t[1],
				t[2]
			]);
			return r;
		}
		function D(e, t) {
			var n;
			if (typeof e == "string") n = t(e)[0];
			else if (Array.isArray(e)) {
				for (var r, i, a = e.concat(), o = [], s = a.length; s--;) typeof (r = a.shift()) == "string" ? o.push(t(r)[0]) : Array.isArray(r) && typeof r[0] == "string" && (i = t(r[0], r[1], r[2]), o.push([
					i[0],
					i[1],
					i[2]
				]));
				n = o;
			}
			return n;
		}
		var O = !1, A = !0;
		if (typeof e == "string") O = !0;
		else if (Array.isArray(e)) {
			var j = e.concat();
			o = [];
			for (var M, N = j.length; N--;) (typeof (M = j.shift()) != "string" || Array.isArray(M) && typeof M[0] != "string") && (A = !1);
			O = A;
		}
		if (!1 === O) throw Error("Type of text must be string or Array. \"" + e + "\" is not recognized.");
		typeof e == "string" && (e = e.match(/[\r?\n]/) ? e.split(/\r\n|\r|\n/g) : [e]);
		var P = pe / h.internal.scaleFactor, F = P * (x - 1);
		switch (r.baseline) {
			case "bottom":
				n -= F;
				break;
			case "top":
				n += P - F;
				break;
			case "hanging":
				n += P - 2 * F;
				break;
			case "middle": n += P / 2 - F;
		}
		if ((u = r.maxWidth || 0) > 0 && (typeof e == "string" ? e = h.splitTextToSize(e, u) : Object.prototype.toString.call(e) === "[object Array]" && (e = e.reduce(function(e, t) {
			return e.concat(h.splitTextToSize(t, u));
		}, []))), a = {
			text: e,
			x: t,
			y: n,
			options: r,
			mutex: {
				pdfEscape: pt,
				activeFontKey: Ce,
				fonts: H,
				activeFontSize: pe
			}
		}, Le.publish("preProcessText", a), e = a.text, s = (r = a.options).angle, m instanceof He == 0 && s && typeof s == "number") {
			s *= Math.PI / 180, r.rotationDirection === 0 && (s = -s), b === y && (s = -s);
			var I = Math.cos(s), ee = Math.sin(s);
			m = new He(I, ee, -ee, I, 0, 0);
		} else s && s instanceof He && (m = s);
		b !== y || m || (m = We), (l = r.charSpace || cn) !== void 0 && (v += w(k(l)) + " Tc\n", this.setCharSpace(this.getCharSpace() || 0)), (p = r.horizontalScale) !== void 0 && (v += w(100 * p) + " Tz\n"), r.lang;
		var L = -1, R = r.renderingMode === void 0 ? r.stroke : r.renderingMode, te = h.internal.getCurrentPageInfo().pageContext;
		switch (R) {
			case 0:
			case !1:
			case "fill":
				L = 0;
				break;
			case 1:
			case !0:
			case "stroke":
				L = 1;
				break;
			case 2:
			case "fillThenStroke":
				L = 2;
				break;
			case 3:
			case "invisible":
				L = 3;
				break;
			case 4:
			case "fillAndAddForClipping":
				L = 4;
				break;
			case 5:
			case "strokeAndAddPathForClipping":
				L = 5;
				break;
			case 6:
			case "fillThenStrokeAndAddToPathForClipping":
				L = 6;
				break;
			case 7:
			case "addToPathForClipping": L = 7;
		}
		var z = te.usedRenderingMode === void 0 ? -1 : te.usedRenderingMode;
		L === -1 ? z !== -1 && (v += "0 Tr\n") : v += L + " Tr\n", L !== -1 && (te.usedRenderingMode = L), c = r.align || "left";
		var ne, re = pe * x, ie = h.internal.pageSize.getWidth(), ae = H[Ce];
		l = r.charSpace || cn, u = r.maxWidth || 0, d = Object.assign({
			autoencode: !0,
			noBOM: !0
		}, r.flags);
		var B = [], oe = function(e) {
			return h.getStringUnitWidth(e, {
				font: ae,
				charSpace: l,
				fontSize: pe,
				doKerning: !1
			}) * pe / S;
		};
		if (Object.prototype.toString.call(e) === "[object Array]") {
			var se;
			o = E(e), c !== "left" && (ne = o.map(oe));
			var ce, le = 0;
			if (c === "right") {
				t -= ne[0], e = [], N = o.length;
				for (var ue = 0; ue < N; ue++) ue === 0 ? (ce = $t(t), se = en(n)) : (ce = k(le - ne[ue]), se = -re), e.push([
					o[ue],
					ce,
					se
				]), le = ne[ue];
			} else if (c === "center") {
				t -= ne[0] / 2, e = [], N = o.length;
				for (var de = 0; de < N; de++) de === 0 ? (ce = $t(t), se = en(n)) : (ce = k((le - ne[de]) / 2), se = -re), e.push([
					o[de],
					ce,
					se
				]), le = ne[de];
			} else if (c === "left") {
				e = [], N = o.length;
				for (var fe = 0; fe < N; fe++) e.push(o[fe]);
			} else if (c === "justify" && ae.encoding === "Identity-H") {
				e = [], N = o.length, u = u === 0 ? ie : u;
				for (var me = 0, he = 0; he < N; he++) if (se = he === 0 ? en(n) : -re, ce = he === 0 ? $t(t) : me, he < N - 1) {
					var _e = k((u - ne[he]) / (o[he].split(" ").length - 1)), ve = o[he].split(" ");
					e.push([
						ve[0] + " ",
						ce,
						se
					]), me = 0;
					for (var ye = 1; ye < ve.length; ye++) {
						var be = (oe(ve[ye - 1] + " " + ve[ye]) - oe(ve[ye])) * S + _e;
						ye == ve.length - 1 ? e.push([
							ve[ye],
							be,
							0
						]) : e.push([
							ve[ye] + " ",
							be,
							0
						]), me -= be;
					}
				} else e.push([
					o[he],
					ce,
					se
				]);
				e.push([
					"",
					me,
					0
				]);
			} else {
				if (c !== "justify") throw Error("Unrecognized alignment option, use \"left\", \"center\", \"right\" or \"justify\".");
				for (e = [], N = o.length, u = u === 0 ? ie : u, he = 0; he < N; he++) {
					se = he === 0 ? en(n) : -re, ce = he === 0 ? $t(t) : 0;
					var xe = o[he].split(" ").length - 1, Se = xe > 0 ? (u - ne[he]) / xe : 0;
					he < N - 1 ? B.push(w(k(Se))) : B.push(0), e.push([
						o[he],
						ce,
						se
					]);
				}
			}
		}
		!0 === (typeof r.R2L == "boolean" ? r.R2L : ge) && (e = D(e, function(e, t, n) {
			return [
				e.split("").reverse().join(""),
				t,
				n
			];
		})), a = {
			text: e,
			x: t,
			y: n,
			options: r,
			mutex: {
				pdfEscape: pt,
				activeFontKey: Ce,
				fonts: H,
				activeFontSize: pe
			}
		}, Le.publish("postProcessText", a), e = a.text, _ = a.mutex.isHex || !1;
		var we = H[Ce].encoding;
		we !== "WinAnsiEncoding" && we !== "StandardEncoding" || (e = D(e, function(e, t, n) {
			return [
				C(e),
				t,
				n
			];
		})), o = E(e), e = [];
		for (var Te, Ee, De, Oe = +!!Array.isArray(o[0]), ke = "", Ae = function(e, t, n) {
			var i = "";
			return n instanceof He ? (n = typeof r.angle == "number" ? Ue(n, new He(1, 0, 0, 1, e, t)) : Ue(new He(1, 0, 0, 1, e, t), n), b === y && (n = Ue(new He(1, 0, 0, -1, 0, 0), n)), i = n.join(" ") + " Tm\n") : i = w(e) + " " + w(t) + " Td\n", i;
		}, je = 0; je < o.length; je++) {
			switch (ke = "", Oe) {
				case 1:
					De = (_ ? "<" : "(") + o[je][0] + (_ ? ">" : ")"), Te = parseFloat(o[je][1]), Ee = parseFloat(o[je][2]);
					break;
				case 0: De = (_ ? "<" : "(") + o[je] + (_ ? ">" : ")"), Te = $t(t), Ee = en(n);
			}
			B !== void 0 && B[je] !== void 0 && (ke = B[je] + " Tw\n"), je === 0 ? e.push(ke + Ae(Te, Ee, m) + De) : Oe === 0 ? e.push(ke + De) : Oe === 1 && e.push(ke + Ae(Te, Ee, m) + De);
		}
		e = Oe === 0 ? e.join(" Tj\nT* ") : e.join(" Tj\n"), e += " Tj\n";
		var Me = "BT\n/";
		return Me += Ce + " " + pe + " Tf\n", Me += w(pe * x) + " TL\n", Me += on + "\n", Me += v, Me += e, V(Me += "ET"), f[Ce] = !0, h;
	};
	var Nt = p.__private__.clip = p.clip = function(e) {
		return V(e === "evenodd" ? "W*" : "W"), this;
	};
	p.clipEvenOdd = function() {
		return Nt("evenodd");
	}, p.__private__.discardPath = p.discardPath = function() {
		return V("n"), this;
	};
	var Pt = p.__private__.isValidStyle = function(e) {
		var t = !1;
		return [
			void 0,
			null,
			"S",
			"D",
			"F",
			"DF",
			"FD",
			"f",
			"f*",
			"B",
			"B*",
			"n"
		].indexOf(e) !== -1 && (t = !0), t;
	};
	p.__private__.setDefaultPathOperation = p.setDefaultPathOperation = function(e) {
		return Pt(e) && (l = e), this;
	};
	var Ft = p.__private__.getStyle = p.getStyle = function(e) {
		var t = l;
		switch (e) {
			case "D":
			case "S":
				t = "S";
				break;
			case "F":
				t = "f";
				break;
			case "FD":
			case "DF":
				t = "B";
				break;
			case "f":
			case "f*":
			case "B":
			case "B*": t = e;
		}
		return t;
	}, It = p.close = function() {
		return V("h"), this;
	};
	p.stroke = function() {
		return V("S"), this;
	}, p.fill = function(e) {
		return Lt("f", e), this;
	}, p.fillEvenOdd = function(e) {
		return Lt("f*", e), this;
	}, p.fillStroke = function(e) {
		return Lt("B", e), this;
	}, p.fillStrokeEvenOdd = function(e) {
		return Lt("B*", e), this;
	};
	var Lt = function(e, t) {
		Fa(t) === "object" ? Bt(t, e) : V(e);
	}, Rt = function(e) {
		e === null || b === y && e === void 0 || (e = Ft(e), V(e));
	};
	function zt(e, t, n, r, i) {
		var a = new Ab(t || this.boundingBox, n || this.xStep, r || this.yStep, this.gState, i || this.matrix);
		return a.stream = this.stream, Ge(e + "$$" + this.cloneIndex++ + "$$", a), a;
	}
	var Bt = function(e, t) {
		var n = je[e.key], r = Ae[n];
		if (r instanceof kb) V("q"), V(Vt(t)), r.gState && p.setGState(r.gState), V(e.matrix.toString() + " cm"), V("/" + n + " sh"), V("Q");
		else if (r instanceof Ab) {
			var i = new He(1, 0, 0, -1, 0, wn());
			e.matrix && (i = i.multiply(e.matrix || We), n = zt.call(r, e.key, e.boundingBox, e.xStep, e.yStep, i).id), V("q"), V("/Pattern cs"), V("/" + n + " scn"), r.gState && p.setGState(r.gState), V(t), V("Q");
		}
	}, Vt = function(e) {
		switch (e) {
			case "f":
			case "F":
			case "n": return "W n";
			case "f*": return "W* n";
			case "B":
			case "S": return "W S";
			case "B*": return "W* S";
		}
	}, Ht = p.moveTo = function(e, t) {
		return V(w(k(e)) + " " + w(A(t)) + " m"), this;
	}, Ut = p.lineTo = function(e, t) {
		return V(w(k(e)) + " " + w(A(t)) + " l"), this;
	}, Wt = p.curveTo = function(e, t, n, r, i, a) {
		return V([
			w(k(e)),
			w(A(t)),
			w(k(n)),
			w(A(r)),
			w(k(i)),
			w(A(a)),
			"c"
		].join(" ")), this;
	};
	p.__private__.line = p.line = function(e, t, n, r, i) {
		if (isNaN(e) || isNaN(t) || isNaN(n) || isNaN(r) || !Pt(i)) throw Error("Invalid arguments passed to jsPDF.line");
		return b === v ? this.lines([[n - e, r - t]], e, t, [1, 1], i || "S") : this.lines([[n - e, r - t]], e, t, [1, 1]).stroke();
	}, p.__private__.lines = p.lines = function(e, t, n, r, i, a) {
		var o, s, c, l, u, d, f, p, m, h, g, _;
		if (typeof e == "number" && (_ = n, n = t, t = e, e = _), r ||= [1, 1], a ||= !1, isNaN(t) || isNaN(n) || !Array.isArray(e) || !Array.isArray(r) || !Pt(i) || typeof a != "boolean") throw Error("Invalid arguments passed to jsPDF.lines");
		for (Ht(t, n), o = r[0], s = r[1], l = e.length, h = t, g = n, c = 0; c < l; c++) (u = e[c]).length === 2 ? (h = u[0] * o + h, g = u[1] * s + g, Ut(h, g)) : (d = u[0] * o + h, f = u[1] * s + g, p = u[2] * o + h, m = u[3] * s + g, h = u[4] * o + h, g = u[5] * s + g, Wt(d, f, p, m, h, g));
		return a && It(), Rt(i), this;
	}, p.path = function(e) {
		for (var t = 0; t < e.length; t++) {
			var n = e[t], r = n.c;
			switch (n.op) {
				case "m":
					Ht(r[0], r[1]);
					break;
				case "l":
					Ut(r[0], r[1]);
					break;
				case "c":
					Wt.apply(this, r);
					break;
				case "h": It();
			}
		}
		return this;
	}, p.__private__.rect = p.rect = function(e, t, n, r, i) {
		if (isNaN(e) || isNaN(t) || isNaN(n) || isNaN(r) || !Pt(i)) throw Error("Invalid arguments passed to jsPDF.rect");
		return b === v && (r = -r), V([
			w(k(e)),
			w(A(t)),
			w(k(n)),
			w(k(r)),
			"re"
		].join(" ")), Rt(i), this;
	}, p.__private__.triangle = p.triangle = function(e, t, n, r, i, a, o) {
		if (isNaN(e) || isNaN(t) || isNaN(n) || isNaN(r) || isNaN(i) || isNaN(a) || !Pt(o)) throw Error("Invalid arguments passed to jsPDF.triangle");
		return this.lines([
			[n - e, r - t],
			[i - n, a - r],
			[e - i, t - a]
		], e, t, [1, 1], o, !0), this;
	}, p.__private__.roundedRect = p.roundedRect = function(e, t, n, r, i, a, o) {
		if (isNaN(e) || isNaN(t) || isNaN(n) || isNaN(r) || isNaN(i) || isNaN(a) || !Pt(o)) throw Error("Invalid arguments passed to jsPDF.roundedRect");
		var s = 4 / 3 * (Math.SQRT2 - 1);
		return i = Math.min(i, .5 * n), a = Math.min(a, .5 * r), this.lines([
			[n - 2 * i, 0],
			[
				i * s,
				0,
				i,
				a - a * s,
				i,
				a
			],
			[0, r - 2 * a],
			[
				0,
				a * s,
				-i * s,
				a,
				-i,
				a
			],
			[2 * i - n, 0],
			[
				-i * s,
				0,
				-i,
				-a * s,
				-i,
				-a
			],
			[0, 2 * a - r],
			[
				0,
				-a * s,
				i * s,
				-a,
				i,
				-a
			]
		], e + i, t, [1, 1], o, !0), this;
	}, p.__private__.ellipse = p.ellipse = function(e, t, n, r, i) {
		if (isNaN(e) || isNaN(t) || isNaN(n) || isNaN(r) || !Pt(i)) throw Error("Invalid arguments passed to jsPDF.ellipse");
		var a = 4 / 3 * (Math.SQRT2 - 1) * n, o = 4 / 3 * (Math.SQRT2 - 1) * r;
		return Ht(e + n, t), Wt(e + n, t - o, e + a, t - r, e, t - r), Wt(e - a, t - r, e - n, t - o, e - n, t), Wt(e - n, t + o, e - a, t + r, e, t + r), Wt(e + a, t + r, e + n, t + o, e + n, t), Rt(i), this;
	}, p.__private__.circle = p.circle = function(e, t, n, r) {
		if (isNaN(e) || isNaN(t) || isNaN(n) || !Pt(r)) throw Error("Invalid arguments passed to jsPDF.circle");
		return this.ellipse(e, t, n, n, r);
	}, p.setFont = function(e, t, n) {
		return n && (t = C(t, n)), Ce = yt(e, t, { disableWarning: !1 }), this;
	};
	var Gt = p.__private__.getFont = p.getFont = function() {
		return H[yt.apply(p, arguments)];
	};
	p.__private__.getFontList = p.getFontList = function() {
		var e, t, n = {};
		for (e in Oe) if (Oe.hasOwnProperty(e)) for (t in n[e] = [], Oe[e]) Oe[e].hasOwnProperty(t) && n[e].push(t);
		return n;
	}, p.addFont = function(e, t, n, r, i) {
		var a = [
			"StandardEncoding",
			"MacRomanEncoding",
			"Identity-H",
			"WinAnsiEncoding"
		];
		return arguments[3] && a.indexOf(arguments[3]) !== -1 ? i = arguments[3] : arguments[3] && a.indexOf(arguments[3]) == -1 && (n = C(n, r)), ft.call(this, e, t, n, i ||= "Identity-H");
	};
	var Kt, qt = e.lineWidth || .200025, Jt = p.__private__.getLineWidth = p.getLineWidth = function() {
		return qt;
	}, Yt = p.__private__.setLineWidth = p.setLineWidth = function(e) {
		return qt = e, V(w(k(e)) + " w"), this;
	};
	p.__private__.setLineDash = jb.API.setLineDash = jb.API.setLineDashPattern = function(e, t) {
		if (e ||= [], t ||= 0, isNaN(t) || !Array.isArray(e)) throw Error("Invalid arguments passed to jsPDF.setLineDash");
		return e = e.map(function(e) {
			return w(k(e));
		}).join(" "), t = w(k(t)), V("[" + e + "] " + t + " d"), this;
	};
	var Xt = p.__private__.getLineHeight = p.getLineHeight = function() {
		return pe * Kt;
	};
	p.__private__.getLineHeight = p.getLineHeight = function() {
		return pe * Kt;
	};
	var Zt = p.__private__.setLineHeightFactor = p.setLineHeightFactor = function(e) {
		return typeof (e ||= 1.15) == "number" && (Kt = e), this;
	}, Qt = p.__private__.getLineHeightFactor = p.getLineHeightFactor = function() {
		return Kt;
	};
	Zt(e.lineHeight);
	var $t = p.__private__.getHorizontalCoordinate = function(e) {
		return k(e);
	}, en = p.__private__.getVerticalCoordinate = function(e) {
		return b === y ? e : Ie[R].mediaBox.topRightY - Ie[R].mediaBox.bottomLeftY - k(e);
	}, tn = p.__private__.getHorizontalCoordinateString = p.getHorizontalCoordinateString = function(e) {
		return w($t(e));
	}, nn = p.__private__.getVerticalCoordinateString = p.getVerticalCoordinateString = function(e) {
		return w(en(e));
	}, rn = e.strokeColor || "0 G";
	p.__private__.getStrokeColor = p.getDrawColor = function() {
		return $e(rn);
	}, p.__private__.setStrokeColor = p.setDrawColor = function(e, t, n, r) {
		return rn = et({
			ch1: e,
			ch2: t,
			ch3: n,
			ch4: r,
			pdfColorType: "draw",
			precision: 2
		}), V(rn), this;
	};
	var an = e.fillColor || "0 g";
	p.__private__.getFillColor = p.getFillColor = function() {
		return $e(an);
	}, p.__private__.setFillColor = p.setFillColor = function(e, t, n, r) {
		return an = et({
			ch1: e,
			ch2: t,
			ch3: n,
			ch4: r,
			pdfColorType: "fill",
			precision: 2
		}), V(an), this;
	};
	var on = e.textColor || "0 g", sn = p.__private__.getTextColor = p.getTextColor = function() {
		return $e(on);
	};
	p.__private__.setTextColor = p.setTextColor = function(e, t, n, r) {
		return on = et({
			ch1: e,
			ch2: t,
			ch3: n,
			ch4: r,
			pdfColorType: "text",
			precision: 3
		}), this;
	};
	var cn = e.charSpace, ln = p.__private__.getCharSpace = p.getCharSpace = function() {
		return parseFloat(cn || 0);
	};
	p.__private__.setCharSpace = p.setCharSpace = function(e) {
		if (isNaN(e)) throw Error("Invalid argument passed to jsPDF.setCharSpace");
		return cn = e, this;
	};
	var un = 0;
	p.CapJoinStyles = {
		0: 0,
		butt: 0,
		but: 0,
		miter: 0,
		1: 1,
		round: 1,
		rounded: 1,
		circle: 1,
		2: 2,
		projecting: 2,
		project: 2,
		square: 2,
		bevel: 2
	}, p.__private__.setLineCap = p.setLineCap = function(e) {
		var t = p.CapJoinStyles[e];
		if (t === void 0) throw Error("Line cap style of '" + e + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
		return un = t, V(t + " J"), this;
	};
	var dn = 0;
	p.__private__.setLineJoin = p.setLineJoin = function(e) {
		var t = p.CapJoinStyles[e];
		if (t === void 0) throw Error("Line join style of '" + e + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
		return dn = t, V(t + " j"), this;
	}, p.__private__.setLineMiterLimit = p.__private__.setMiterLimit = p.setLineMiterLimit = p.setMiterLimit = function(e) {
		if (e ||= 0, isNaN(e)) throw Error("Invalid argument passed to jsPDF.setLineMiterLimit");
		return V(w(k(e)) + " M"), this;
	}, p.GState = Db, p.setGState = function(e) {
		(e = typeof e == "string" ? Me[Ne[e]] : fn(null, e)).equals(Pe) || (V("/" + e.id + " gs"), Pe = e);
	};
	var fn = function(e, t) {
		if (!e || !Ne[e]) {
			var n = !1;
			for (var r in Me) if (Me.hasOwnProperty(r) && Me[r].equals(t)) {
				n = !0;
				break;
			}
			if (n) t = Me[r];
			else {
				var i = "GS" + (Object.keys(Me).length + 1).toString(10);
				Me[i] = t, t.id = i;
			}
			return e && (Ne[e] = t.id), Le.publish("addGState", t), t;
		}
	};
	p.addGState = function(e, t) {
		return fn(e, t), this;
	}, p.saveGraphicsState = function() {
		return V("q"), ke.push({
			key: Ce,
			size: pe,
			color: on
		}), this;
	}, p.restoreGraphicsState = function() {
		V("Q");
		var e = ke.pop();
		return Ce = e.key, pe = e.size, on = e.color, Pe = null, this;
	}, p.setCurrentTransformationMatrix = function(e) {
		return V(e.toString() + " cm"), this;
	}, p.comment = function(e) {
		return V("#" + e), this;
	};
	var pn = function(e, t) {
		var n = e || 0;
		Object.defineProperty(this, "x", {
			enumerable: !0,
			get: function() {
				return n;
			},
			set: function(e) {
				isNaN(e) || (n = parseFloat(e));
			}
		});
		var r = t || 0;
		Object.defineProperty(this, "y", {
			enumerable: !0,
			get: function() {
				return r;
			},
			set: function(e) {
				isNaN(e) || (r = parseFloat(e));
			}
		});
		var i = "pt";
		return Object.defineProperty(this, "type", {
			enumerable: !0,
			get: function() {
				return i;
			},
			set: function(e) {
				i = e.toString();
			}
		}), this;
	}, mn = function(e, t, n, r) {
		pn.call(this, e, t), this.type = "rect";
		var i = n || 0;
		Object.defineProperty(this, "w", {
			enumerable: !0,
			get: function() {
				return i;
			},
			set: function(e) {
				isNaN(e) || (i = parseFloat(e));
			}
		});
		var a = r || 0;
		return Object.defineProperty(this, "h", {
			enumerable: !0,
			get: function() {
				return a;
			},
			set: function(e) {
				isNaN(e) || (a = parseFloat(e));
			}
		}), this;
	}, hn = function() {
		this.page = Fe, this.currentPage = R, this.pages = oe.slice(0), this.pagesContext = Ie.slice(0), this.x = Te, this.y = Ee, this.matrix = De, this.width = vn(R), this.height = bn(R), this.outputDestination = ce, this.id = "", this.objectNumber = -1;
	};
	hn.prototype.restore = function() {
		Fe = this.page, R = this.currentPage, Ie = this.pagesContext, oe = this.pages, Te = this.x, Ee = this.y, De = this.matrix, yn(R, this.width), xn(R, this.height), ce = this.outputDestination;
	};
	var gn = function(e, t, n, r, i) {
		Ve.push(new hn()), Fe = R = 0, oe = [], Te = e, Ee = t, De = i, mt([n, r]);
	};
	for (var _n in p.beginFormObject = function(e, t, n, r, i) {
		return gn(e, t, n, r, i), this;
	}, p.endFormObject = function(e) {
		return function(e) {
			if (Be[e]) Ve.pop().restore();
			else {
				var t = new hn(), n = "Xo" + (Object.keys(ze).length + 1).toString(10);
				t.id = n, Be[e] = n, ze[n] = t, Le.publish("addFormObject", t), Ve.pop().restore();
			}
		}(e), this;
	}, p.doFormObject = function(e, t) {
		var n = ze[Be[e]];
		return V("q"), V(t.toString() + " cm"), V("/" + n.id + " Do"), V("Q"), this;
	}, p.getFormObject = function(e) {
		var t = ze[Be[e]];
		return {
			x: t.x,
			y: t.y,
			width: t.width,
			height: t.height,
			matrix: t.matrix
		};
	}, p.save = function(e, t) {
		return e ||= "generated.pdf", (t ||= {}).returnPromise = t.returnPromise || !1, !1 === t.returnPromise ? (ib(Et(Tt()), e), typeof ib.unload == "function" && Qy.setTimeout && setTimeout(ib.unload, 911), this) : new Promise(function(t, n) {
			try {
				var r = ib(Et(Tt()), e);
				typeof ib.unload == "function" && Qy.setTimeout && setTimeout(ib.unload, 911), t(r);
			} catch (e) {
				n(e.message);
			}
		});
	}, jb.API) jb.API.hasOwnProperty(_n) && (_n === "events" && jb.API.events.length ? function(e, t) {
		var n, r, i;
		for (i = t.length - 1; i !== -1; i--) n = t[i][0], r = t[i][1], e.subscribe.apply(e, [n].concat(typeof r == "function" ? [r] : r));
	}(Le, jb.API.events) : p[_n] = jb.API[_n]);
	function vn(e) {
		return Ie[e].mediaBox.topRightX - Ie[e].mediaBox.bottomLeftX;
	}
	function yn(e, t) {
		Ie[e].mediaBox.topRightX = t + Ie[e].mediaBox.bottomLeftX;
	}
	function bn(e) {
		return Ie[e].mediaBox.topRightY - Ie[e].mediaBox.bottomLeftY;
	}
	function xn(e, t) {
		Ie[e].mediaBox.topRightY = t + Ie[e].mediaBox.bottomLeftY;
	}
	var Sn = p.getPageWidth = function(e) {
		return vn(e ||= R) / we;
	}, Cn = p.setPageWidth = function(e, t) {
		yn(e, t * we);
	}, wn = p.getPageHeight = function(e) {
		return bn(e ||= R) / we;
	}, Tn = p.setPageHeight = function(e, t) {
		xn(e, t * we);
	};
	return p.internal = {
		pdfEscape: pt,
		getStyle: Ft,
		getFont: Gt,
		getFontSize: he,
		getCharSpace: ln,
		getTextColor: sn,
		getLineHeight: Xt,
		getLineHeightFactor: Qt,
		getLineWidth: Jt,
		write: ue,
		getHorizontalCoordinate: $t,
		getVerticalCoordinate: en,
		getCoordinateString: tn,
		getVerticalCoordinateString: nn,
		collections: {},
		newObject: qe,
		newAdditionalObject: Xe,
		newObjectDeferred: Je,
		newObjectDeferredBegin: Ye,
		getFilters: tt,
		putStream: nt,
		events: Le,
		scaleFactor: we,
		pageSize: {
			getWidth: function() {
				return Sn(R);
			},
			setWidth: function(e) {
				Cn(R, e);
			},
			getHeight: function() {
				return wn(R);
			},
			setHeight: function(e) {
				Tn(R, e);
			}
		},
		encryptionOptions: u,
		encryption: kt,
		getEncryptor: function(e) {
			return u === null ? function(e) {
				return e;
			} : kt.encryptor(e, 0);
		},
		output: U,
		getNumberOfPages: vt,
		get pages() {
			return oe;
		},
		out: V,
		f2: D,
		f3: O,
		getPageInfo: At,
		getPageInfoByObjId: jt,
		getCurrentPageInfo: Mt,
		getPDFVersion: h,
		Point: pn,
		Rectangle: mn,
		Matrix: He,
		hasHotfix: W
	}, Object.defineProperty(p.internal.pageSize, "width", {
		get: function() {
			return Sn(R);
		},
		set: function(e) {
			Cn(R, e);
		},
		enumerable: !0,
		configurable: !0
	}), Object.defineProperty(p.internal.pageSize, "height", {
		get: function() {
			return wn(R);
		},
		set: function(e) {
			Tn(R, e);
		},
		enumerable: !0,
		configurable: !0
	}), function(e) {
		for (var t = 0, n = fe.length; t < n; t++) {
			var r = ft.call(this, e[t][0], e[t][1], e[t][2], fe[t][3], !0);
			!1 === d && (f[r] = !0);
			var i = e[t][0].split("-");
			dt({
				id: r,
				fontName: i[0],
				fontStyle: i[1] || ""
			});
		}
		Le.publish("addFonts", {
			fonts: H,
			dictionary: Oe
		});
	}.call(p, fe), Ce = "F1", ht(i, n), Le.publish("initialized"), p;
}
wb.prototype.lsbFirstWord = function(e) {
	return String.fromCharCode(255 & e, e >> 8 & 255, e >> 16 & 255, e >> 24 & 255);
}, wb.prototype.toHexString = function(e) {
	return e.split("").map(function(e) {
		return ("0" + (255 & e.charCodeAt(0)).toString(16)).slice(-2);
	}).join("");
}, wb.prototype.hexToBytes = function(e) {
	for (var t = [], n = 0; n < e.length; n += 2) t.push(String.fromCharCode(parseInt(e.substr(n, 2), 16)));
	return t.join("");
}, wb.prototype.processOwnerPassword = function(e, t) {
	return Sb(yb(t).substr(0, 5), e);
}, wb.prototype.encryptor = function(e, t) {
	var n = yb(this.encryptionKey + String.fromCharCode(255 & e, e >> 8 & 255, e >> 16 & 255, 255 & t, t >> 8 & 255)).substr(0, 10);
	return function(e) {
		return Sb(n, e);
	};
}, Db.prototype.equals = function(e) {
	var t, n = "id,objectNumber,equals";
	if (!e || Fa(e) !== Fa(this)) return !1;
	var r = 0;
	for (t in this) if (!(n.indexOf(t) >= 0)) {
		if (this.hasOwnProperty(t) && !e.hasOwnProperty(t) || this[t] !== e[t]) return !1;
		r++;
	}
	for (t in e) e.hasOwnProperty(t) && n.indexOf(t) < 0 && r--;
	return r === 0;
}, jb.API = { events: [] }, jb.version = "4.2.1";
var Mb = jb.API, Nb = 1, Pb = function(e) {
	return e.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
}, Fb = function(e) {
	return e.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
}, Ib = function(e) {
	return e.toString().replace(/#/g, "#23").replace(/[\s\n\r()<>[\]{}\/%]/g, function(e) {
		var t = e.charCodeAt(0).toString(16).toUpperCase();
		return "#" + (t.length === 1 ? "0" + t : t);
	});
}, Lb = function(e) {
	return e.toFixed(2);
}, Rb = function(e) {
	return e.toFixed(5);
};
Mb.__acroform__ = {};
var zb = function(e, t) {
	e.prototype = Object.create(t.prototype), e.prototype.constructor = e;
}, Bb = function(e) {
	return e * Nb;
}, Vb = function(e) {
	var t = new ix(), n = Z.internal.getHeight(e) || 0, r = Z.internal.getWidth(e) || 0;
	return t.BBox = [
		0,
		0,
		Number(Lb(r)),
		Number(Lb(n))
	], t;
}, Hb = Mb.__acroform__.setBit = function(e, t) {
	if (e ||= 0, t ||= 0, isNaN(e) || isNaN(t)) throw Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
	return e | 1 << t;
}, Ub = Mb.__acroform__.clearBit = function(e, t) {
	if (e ||= 0, t ||= 0, isNaN(e) || isNaN(t)) throw Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
	return e & ~(1 << t);
}, Wb = Mb.__acroform__.getBit = function(e, t) {
	if (isNaN(e) || isNaN(t)) throw Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
	return e & 1 << t ? 1 : 0;
}, Gb = Mb.__acroform__.getBitForPdf = function(e, t) {
	if (isNaN(e) || isNaN(t)) throw Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
	return Wb(e, t - 1);
}, Kb = Mb.__acroform__.setBitForPdf = function(e, t) {
	if (isNaN(e) || isNaN(t)) throw Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
	return Hb(e, t - 1);
}, qb = Mb.__acroform__.clearBitForPdf = function(e, t) {
	if (isNaN(e) || isNaN(t)) throw Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
	return Ub(e, t - 1);
}, Jb = Mb.__acroform__.calculateCoordinates = function(e, t) {
	var n = t.internal.getHorizontalCoordinate, r = t.internal.getVerticalCoordinate, i = e[0], a = e[1], o = e[2], s = e[3], c = {};
	return c.lowerLeft_X = n(i) || 0, c.lowerLeft_Y = r(a + s) || 0, c.upperRight_X = n(i + o) || 0, c.upperRight_Y = r(a) || 0, [
		Number(Lb(c.lowerLeft_X)),
		Number(Lb(c.lowerLeft_Y)),
		Number(Lb(c.upperRight_X)),
		Number(Lb(c.upperRight_Y))
	];
}, Yb = function(e) {
	if (e.appearanceStreamContent) return e.appearanceStreamContent;
	if (e.V || e.DV) {
		var t = [], n = Xb(e, e._V || e.DV), r = e.scope.internal.getFont(e.fontName, e.fontStyle).id;
		t.push("/Tx BMC"), t.push("q"), t.push("BT"), t.push(e.scope.__private__.encodeColorString(e.color)), t.push("/" + r + " " + Lb(n.fontSize) + " Tf"), t.push("1 0 0 1 0 0 Tm"), t.push(n.text), t.push("ET"), t.push("Q"), t.push("EMC");
		var i = Vb(e);
		return i.scope = e.scope, i.stream = t.join("\n"), i;
	}
}, Xb = function(e, t) {
	var n = e.fontSize === 0 ? e.maxFontSize : e.fontSize, r = {
		text: "",
		fontSize: ""
	}, i = (t = (t = t.substr(0, 1) == "(" ? t.substr(1) : t).substr(t.length - 1) == ")" ? t.substr(0, t.length - 1) : t).split(" ");
	i = e.multiline ? i.map(function(e) {
		return e.split("\n");
	}) : i.map(function(e) {
		return [e];
	});
	var a = n, o = Z.internal.getHeight(e) || 0;
	o = o < 0 ? -o : o;
	var s = Z.internal.getWidth(e) || 0;
	s = s < 0 ? -s : s;
	var c = function(t, n, r) {
		return t + 1 < i.length && Zb(n + " " + i[t + 1][0], e, r).width <= s - 4;
	};
	a++;
	t: for (; a > 0;) {
		t = "", a--;
		var l, u, d = Zb("3", e, a).height, f = e.multiline ? o - a : (o - d) / 2, p = f += 2, m = 0, h = 0, g = 0;
		if (a <= 0) {
			t = "(...) Tj\n", t += "% Width of Text: " + Zb(t, e, a = 12).width + ", FieldWidth:" + s + "\n";
			break;
		}
		for (var _ = "", v = 0, y = 0; y < i.length; y++) if (i.hasOwnProperty(y)) {
			var b = !1;
			if (i[y].length !== 1 && g !== i[y].length - 1) {
				if ((d + 2) * (v + 2) + 2 > o) continue t;
				_ += i[y][g], b = !0, h = y, y--;
			} else {
				_ = (_ += i[y][g] + " ").substr(_.length - 1) == " " ? _.substr(0, _.length - 1) : _;
				var x = parseInt(y), S = c(x, _, a), C = y >= i.length - 1;
				if (S && !C) {
					_ += " ", g = 0;
					continue;
				}
				if (S || C) {
					if (C) h = x;
					else if (e.multiline && (d + 2) * (v + 2) + 2 > o) continue t;
				} else {
					if (!e.multiline || (d + 2) * (v + 2) + 2 > o) continue t;
					h = x;
				}
			}
			for (var w = "", T = m; T <= h; T++) {
				var E = i[T];
				if (e.multiline) {
					if (T === h) {
						w += E[g] + " ", g = (g + 1) % E.length;
						continue;
					}
					if (T === m) {
						w += E[E.length - 1] + " ";
						continue;
					}
				}
				w += E[0] + " ";
			}
			switch (w = w.substr(w.length - 1) == " " ? w.substr(0, w.length - 1) : w, u = Zb(w, e, a).width, e.textAlign) {
				case "right":
					l = s - u - 2;
					break;
				case "center":
					l = (s - u) / 2;
					break;
				default: l = 2;
			}
			t += Lb(l) + " " + Lb(p) + " Td\n", t += "(" + Pb(w) + ") Tj\n", t += -Lb(l) + " 0 Td\n", p = -(a + 2), u = 0, m = b ? h : h + 1, v++, _ = "";
		}
		break;
	}
	return r.text = t, r.fontSize = a, r;
}, Zb = function(e, t, n) {
	var r = t.scope.internal.getFont(t.fontName, t.fontStyle), i = t.scope.getStringUnitWidth(e, {
		font: r,
		fontSize: parseFloat(n),
		charSpace: 0
	}) * parseFloat(n);
	return {
		height: t.scope.getStringUnitWidth("3", {
			font: r,
			fontSize: parseFloat(n),
			charSpace: 0
		}) * parseFloat(n) * 1.5,
		width: i
	};
}, Qb = {
	fields: [],
	xForms: [],
	acroFormDictionaryRoot: null,
	printedOut: !1,
	internal: null,
	isInitialized: !1
}, $b = function(e, t) {
	var n = {
		type: "reference",
		object: e
	};
	t.internal.getPageInfo(e.page).pageContext.annotations.find(function(e) {
		return e.type === n.type && e.object === n.object;
	}) === void 0 && t.internal.getPageInfo(e.page).pageContext.annotations.push(n);
}, ex = function(e, t) {
	if (t.scope = e, e.internal !== void 0 && (e.internal.acroformPlugin === void 0 || !1 === e.internal.acroformPlugin.isInitialized)) {
		if (ox.FieldNum = 0, e.internal.acroformPlugin = JSON.parse(JSON.stringify(Qb)), e.internal.acroformPlugin.acroFormDictionaryRoot) throw Error("Exception while creating AcroformDictionary");
		Nb = e.internal.scaleFactor, e.internal.acroformPlugin.acroFormDictionaryRoot = new ax(), e.internal.acroformPlugin.acroFormDictionaryRoot.scope = e, e.internal.acroformPlugin.acroFormDictionaryRoot._eventID = e.internal.events.subscribe("postPutResources", function() {
			(function(e) {
				e.internal.events.unsubscribe(e.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete e.internal.acroformPlugin.acroFormDictionaryRoot._eventID, e.internal.acroformPlugin.printedOut = !0;
			})(e);
		}), e.internal.events.subscribe("buildDocument", function() {
			(function(e) {
				e.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
				var t = e.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
				for (var n in t) if (t.hasOwnProperty(n)) {
					var r = t[n];
					r.objId = void 0, r.hasAnnotation && $b(r, e);
				}
			})(e);
		}), e.internal.events.subscribe("putCatalog", function() {
			(function(e) {
				if (e.internal.acroformPlugin.acroFormDictionaryRoot === void 0) throw Error("putCatalogCallback: Root missing.");
				e.internal.write("/AcroForm " + e.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
			})(e);
		}), e.internal.events.subscribe("postPutPages", function(t) {
			(function(e, t) {
				var n = !e;
				for (var r in e || (t.internal.newObjectDeferredBegin(t.internal.acroformPlugin.acroFormDictionaryRoot.objId, !0), t.internal.acroformPlugin.acroFormDictionaryRoot.putStream()), e ||= t.internal.acroformPlugin.acroFormDictionaryRoot.Kids) if (e.hasOwnProperty(r)) {
					var i = e[r], a = [], o = i.Rect;
					if (i.Rect &&= Jb(i.Rect, t), t.internal.newObjectDeferredBegin(i.objId, !0), i.DA = Z.createDefaultAppearanceStream(i), Fa(i) === "object" && typeof i.getKeyValueListForStream == "function" && (a = i.getKeyValueListForStream()), i.Rect = o, i.hasAppearanceStream && !i.appearanceStreamContent) {
						var s = Yb(i);
						a.push({
							key: "AP",
							value: "<</N " + s + ">>"
						}), t.internal.acroformPlugin.xForms.push(s);
					}
					if (i.appearanceStreamContent) {
						var c = "";
						for (var l in i.appearanceStreamContent) if (i.appearanceStreamContent.hasOwnProperty(l)) {
							var u = i.appearanceStreamContent[l];
							if (c += "/" + l + " ", c += "<<", Object.keys(u).length >= 1 || Array.isArray(u)) {
								for (var r in u) if (u.hasOwnProperty(r)) {
									var d = u[r];
									typeof d == "function" && (d = d.call(t, i)), c += "/" + r + " " + d + " ", t.internal.acroformPlugin.xForms.indexOf(d) >= 0 || t.internal.acroformPlugin.xForms.push(d);
								}
							} else typeof (d = u) == "function" && (d = d.call(t, i)), c += "/" + r + " " + d, t.internal.acroformPlugin.xForms.indexOf(d) >= 0 || t.internal.acroformPlugin.xForms.push(d);
							c += ">>";
						}
						a.push({
							key: "AP",
							value: "<<\n" + c + ">>"
						});
					}
					t.internal.putStream({
						additionalKeyValues: a,
						objectId: i.objId
					}), t.internal.out("endobj");
				}
				n && function(e, t) {
					for (var n in e) if (e.hasOwnProperty(n)) {
						var r = n, i = e[n];
						t.internal.newObjectDeferredBegin(i.objId, !0), Fa(i) === "object" && typeof i.putStream == "function" && i.putStream(), delete e[r];
					}
				}(t.internal.acroformPlugin.xForms, t);
			})(t, e);
		}), e.internal.acroformPlugin.isInitialized = !0;
	}
}, tx = Mb.__acroform__.arrayToPdfArray = function(e, t, n) {
	var r = function(e) {
		return e;
	};
	if (Array.isArray(e)) {
		for (var i = "[", a = 0; a < e.length; a++) switch (a !== 0 && (i += " "), Fa(e[a])) {
			case "boolean":
			case "number":
			case "object":
				i += e[a].toString();
				break;
			case "string": e[a].substr(0, 1) === "/" ? i += "/" + Ib(e[a].substr(1)) : (t !== void 0 && n && (r = n.internal.getEncryptor(t)), i += "(" + Pb(r(e[a].toString())) + ")");
		}
		return i + "]";
	}
	throw Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
}, nx = function(e, t, n) {
	var r = function(e) {
		return e;
	};
	return t !== void 0 && n && (r = n.internal.getEncryptor(t)), (e ||= "").toString(), "(" + Pb(r(e)) + ")";
}, rx = function() {
	this._objId = void 0, this._scope = void 0, Object.defineProperty(this, "objId", {
		get: function() {
			if (this._objId === void 0) {
				if (this.scope === void 0) return;
				this._objId = this.scope.internal.newObjectDeferred();
			}
			return this._objId;
		},
		set: function(e) {
			this._objId = e;
		}
	}), Object.defineProperty(this, "scope", {
		value: this._scope,
		writable: !0
	});
};
rx.prototype.toString = function() {
	return this.objId + " 0 R";
}, rx.prototype.putStream = function() {
	var e = this.getKeyValueListForStream();
	this.scope.internal.putStream({
		data: this.stream,
		additionalKeyValues: e,
		objectId: this.objId
	}), this.scope.internal.out("endobj");
}, rx.prototype.getKeyValueListForStream = function() {
	var e = [], t = Object.getOwnPropertyNames(this).filter(function(e) {
		return e != "content" && e != "appearanceStreamContent" && e != "scope" && e != "objId" && e.substring(0, 1) != "_";
	});
	for (var n in t) if (!1 === Object.getOwnPropertyDescriptor(this, t[n]).configurable) {
		var r = t[n], i = this[r];
		i && (Array.isArray(i) ? e.push({
			key: r,
			value: tx(i, this.objId, this.scope)
		}) : i instanceof rx ? (i.scope = this.scope, e.push({
			key: r,
			value: i.objId + " 0 R"
		})) : typeof i != "function" && e.push({
			key: r,
			value: i
		}));
	}
	return e;
};
var ix = function() {
	rx.call(this), Object.defineProperty(this, "Type", {
		value: "/XObject",
		configurable: !1,
		writable: !0
	}), Object.defineProperty(this, "Subtype", {
		value: "/Form",
		configurable: !1,
		writable: !0
	}), Object.defineProperty(this, "FormType", {
		value: 1,
		configurable: !1,
		writable: !0
	});
	var e, t = [];
	Object.defineProperty(this, "BBox", {
		configurable: !1,
		get: function() {
			return t;
		},
		set: function(e) {
			t = e;
		}
	}), Object.defineProperty(this, "Resources", {
		value: "2 0 R",
		configurable: !1,
		writable: !0
	}), Object.defineProperty(this, "stream", {
		enumerable: !1,
		configurable: !0,
		set: function(t) {
			e = t.trim();
		},
		get: function() {
			return e || null;
		}
	});
};
zb(ix, rx);
var ax = function() {
	rx.call(this);
	var e, t = [];
	Object.defineProperty(this, "Kids", {
		enumerable: !1,
		configurable: !0,
		get: function() {
			return t.length > 0 ? t : void 0;
		}
	}), Object.defineProperty(this, "Fields", {
		enumerable: !1,
		configurable: !1,
		get: function() {
			return t;
		}
	}), Object.defineProperty(this, "DA", {
		enumerable: !1,
		configurable: !1,
		get: function() {
			if (e) {
				var t = function(e) {
					return e;
				};
				return this.scope && (t = this.scope.internal.getEncryptor(this.objId)), "(" + Pb(t(e)) + ")";
			}
		},
		set: function(t) {
			e = t;
		}
	});
};
zb(ax, rx);
var ox = function e() {
	rx.call(this);
	var t = 4;
	Object.defineProperty(this, "F", {
		enumerable: !1,
		configurable: !1,
		get: function() {
			return t;
		},
		set: function(e) {
			if (isNaN(e)) throw Error("Invalid value \"" + e + "\" for attribute F supplied.");
			t = e;
		}
	}), Object.defineProperty(this, "showWhenPrinted", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !!Gb(t, 3);
		},
		set: function(e) {
			!!e == 1 ? this.F = Kb(t, 3) : this.F = qb(t, 3);
		}
	});
	var n = 0;
	Object.defineProperty(this, "Ff", {
		enumerable: !1,
		configurable: !1,
		get: function() {
			return n;
		},
		set: function(e) {
			if (isNaN(e)) throw Error("Invalid value \"" + e + "\" for attribute Ff supplied.");
			n = e;
		}
	});
	var r = [];
	Object.defineProperty(this, "Rect", {
		enumerable: !1,
		configurable: !1,
		get: function() {
			if (r.length !== 0) return r;
		},
		set: function(e) {
			r = e === void 0 ? [] : e;
		}
	}), Object.defineProperty(this, "x", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !r || isNaN(r[0]) ? 0 : r[0];
		},
		set: function(e) {
			r[0] = e;
		}
	}), Object.defineProperty(this, "y", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !r || isNaN(r[1]) ? 0 : r[1];
		},
		set: function(e) {
			r[1] = e;
		}
	}), Object.defineProperty(this, "width", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !r || isNaN(r[2]) ? 0 : r[2];
		},
		set: function(e) {
			r[2] = e;
		}
	}), Object.defineProperty(this, "height", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !r || isNaN(r[3]) ? 0 : r[3];
		},
		set: function(e) {
			r[3] = e;
		}
	});
	var i = "";
	Object.defineProperty(this, "FT", {
		enumerable: !0,
		configurable: !1,
		get: function() {
			return i;
		},
		set: function(e) {
			switch (e) {
				case "/Btn":
				case "/Tx":
				case "/Ch":
				case "/Sig":
					i = e;
					break;
				default: throw Error("Invalid value \"" + e + "\" for attribute FT supplied.");
			}
		}
	});
	var a = null;
	Object.defineProperty(this, "T", {
		enumerable: !0,
		configurable: !1,
		get: function() {
			if (!a || a.length < 1) {
				if (this instanceof mx) return;
				a = "FieldObject" + e.FieldNum++;
			}
			var t = function(e) {
				return e;
			};
			return this.scope && (t = this.scope.internal.getEncryptor(this.objId)), "(" + Pb(t(a)) + ")";
		},
		set: function(e) {
			a = e.toString();
		}
	}), Object.defineProperty(this, "fieldName", {
		configurable: !0,
		enumerable: !0,
		get: function() {
			return a;
		},
		set: function(e) {
			a = e;
		}
	});
	var o = "helvetica";
	Object.defineProperty(this, "fontName", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return o;
		},
		set: function(e) {
			o = e;
		}
	});
	var s = "normal";
	Object.defineProperty(this, "fontStyle", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return s;
		},
		set: function(e) {
			s = e;
		}
	});
	var c = 0;
	Object.defineProperty(this, "fontSize", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return c;
		},
		set: function(e) {
			c = e;
		}
	});
	var l = void 0;
	Object.defineProperty(this, "maxFontSize", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return l === void 0 ? 50 / Nb : l;
		},
		set: function(e) {
			l = e;
		}
	});
	var u = "black";
	Object.defineProperty(this, "color", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return u;
		},
		set: function(e) {
			u = e;
		}
	});
	var d = "/F1 0 Tf 0 g";
	Object.defineProperty(this, "DA", {
		enumerable: !0,
		configurable: !1,
		get: function() {
			if (!(!d || this instanceof mx || this instanceof gx)) return nx(d, this.objId, this.scope);
		},
		set: function(e) {
			e = e.toString(), d = e;
		}
	});
	var f = null;
	Object.defineProperty(this, "DV", {
		enumerable: !1,
		configurable: !1,
		get: function() {
			if (f) return this instanceof dx == 0 ? nx(f, this.objId, this.scope) : f;
		},
		set: function(e) {
			e = e.toString(), f = this instanceof dx == 0 ? e.substr(0, 1) === "(" ? Fb(e.substr(1, e.length - 2)) : Fb(e) : e;
		}
	}), Object.defineProperty(this, "defaultValue", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return this instanceof dx == 1 ? Fb(f.substr(1, f.length - 1)) : f;
		},
		set: function(e) {
			e = e.toString(), f = this instanceof dx == 1 ? "/" + Ib(e) : e;
		}
	});
	var p = null;
	Object.defineProperty(this, "_V", {
		enumerable: !1,
		configurable: !1,
		get: function() {
			if (p) return p;
		},
		set: function(e) {
			this.V = e;
		}
	}), Object.defineProperty(this, "V", {
		enumerable: !1,
		configurable: !1,
		get: function() {
			if (p) return this instanceof dx == 0 ? nx(p, this.objId, this.scope) : p;
		},
		set: function(e) {
			e = e.toString(), p = this instanceof dx == 0 ? e.substr(0, 1) === "(" ? Fb(e.substr(1, e.length - 2)) : Fb(e) : e;
		}
	}), Object.defineProperty(this, "value", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return this instanceof dx == 1 ? Fb(p.substr(1, p.length - 1)) : p;
		},
		set: function(e) {
			e = e.toString(), p = this instanceof dx == 1 ? "/" + Ib(e) : e;
		}
	}), Object.defineProperty(this, "hasAnnotation", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return this.Rect;
		}
	}), Object.defineProperty(this, "Type", {
		enumerable: !0,
		configurable: !1,
		get: function() {
			return this.hasAnnotation ? "/Annot" : null;
		}
	}), Object.defineProperty(this, "Subtype", {
		enumerable: !0,
		configurable: !1,
		get: function() {
			return this.hasAnnotation ? "/Widget" : null;
		}
	});
	var m, h = !1;
	Object.defineProperty(this, "hasAppearanceStream", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return h;
		},
		set: function(e) {
			e = !!e, h = e;
		}
	}), Object.defineProperty(this, "page", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			if (m) return m;
		},
		set: function(e) {
			m = e;
		}
	}), Object.defineProperty(this, "readOnly", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !!Gb(this.Ff, 1);
		},
		set: function(e) {
			!!e == 1 ? this.Ff = Kb(this.Ff, 1) : this.Ff = qb(this.Ff, 1);
		}
	}), Object.defineProperty(this, "required", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !!Gb(this.Ff, 2);
		},
		set: function(e) {
			!!e == 1 ? this.Ff = Kb(this.Ff, 2) : this.Ff = qb(this.Ff, 2);
		}
	}), Object.defineProperty(this, "noExport", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !!Gb(this.Ff, 3);
		},
		set: function(e) {
			!!e == 1 ? this.Ff = Kb(this.Ff, 3) : this.Ff = qb(this.Ff, 3);
		}
	});
	var g = null;
	Object.defineProperty(this, "Q", {
		enumerable: !0,
		configurable: !1,
		get: function() {
			if (g !== null) return g;
		},
		set: function(e) {
			if ([
				0,
				1,
				2
			].indexOf(e) === -1) throw Error("Invalid value \"" + e + "\" for attribute Q supplied.");
			g = e;
		}
	}), Object.defineProperty(this, "textAlign", {
		get: function() {
			var e;
			switch (g) {
				case 0:
				default:
					e = "left";
					break;
				case 1:
					e = "center";
					break;
				case 2: e = "right";
			}
			return e;
		},
		configurable: !0,
		enumerable: !0,
		set: function(e) {
			switch (e) {
				case "right":
				case 2:
					g = 2;
					break;
				case "center":
				case 1:
					g = 1;
					break;
				default: g = 0;
			}
		}
	});
};
zb(ox, rx);
var sx = function() {
	ox.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
	var e = 0;
	Object.defineProperty(this, "TI", {
		enumerable: !0,
		configurable: !1,
		get: function() {
			return e;
		},
		set: function(t) {
			e = t;
		}
	}), Object.defineProperty(this, "topIndex", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return e;
		},
		set: function(t) {
			e = t;
		}
	});
	var t = [];
	Object.defineProperty(this, "Opt", {
		enumerable: !0,
		configurable: !1,
		get: function() {
			return tx(t, this.objId, this.scope);
		},
		set: function(e) {
			var n, r = [];
			typeof (n = e) == "string" && (r = function(e, t, n) {
				n ||= 1;
				for (var r, i = []; r = t.exec(e);) i.push(r[n]);
				return i;
			}(n, /\((.*?)\)/g)), t = r;
		}
	}), this.getOptions = function() {
		return t;
	}, this.setOptions = function(e) {
		t = e, this.sort && t.sort();
	}, this.addOption = function(e) {
		e = (e ||= "").toString(), t.push(e), this.sort && t.sort();
	}, this.removeOption = function(e, n) {
		for (n ||= !1, e = (e ||= "").toString(); t.indexOf(e) !== -1 && (t.splice(t.indexOf(e), 1), !1 !== n););
	}, Object.defineProperty(this, "combo", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !!Gb(this.Ff, 18);
		},
		set: function(e) {
			!!e == 1 ? this.Ff = Kb(this.Ff, 18) : this.Ff = qb(this.Ff, 18);
		}
	}), Object.defineProperty(this, "edit", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !!Gb(this.Ff, 19);
		},
		set: function(e) {
			!0 === this.combo && (!!e == 1 ? this.Ff = Kb(this.Ff, 19) : this.Ff = qb(this.Ff, 19));
		}
	}), Object.defineProperty(this, "sort", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !!Gb(this.Ff, 20);
		},
		set: function(e) {
			!!e == 1 ? (this.Ff = Kb(this.Ff, 20), t.sort()) : this.Ff = qb(this.Ff, 20);
		}
	}), Object.defineProperty(this, "multiSelect", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !!Gb(this.Ff, 22);
		},
		set: function(e) {
			!!e == 1 ? this.Ff = Kb(this.Ff, 22) : this.Ff = qb(this.Ff, 22);
		}
	}), Object.defineProperty(this, "doNotSpellCheck", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !!Gb(this.Ff, 23);
		},
		set: function(e) {
			!!e == 1 ? this.Ff = Kb(this.Ff, 23) : this.Ff = qb(this.Ff, 23);
		}
	}), Object.defineProperty(this, "commitOnSelChange", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !!Gb(this.Ff, 27);
		},
		set: function(e) {
			!!e == 1 ? this.Ff = Kb(this.Ff, 27) : this.Ff = qb(this.Ff, 27);
		}
	}), this.hasAppearanceStream = !1;
};
zb(sx, ox);
var cx = function() {
	sx.call(this), this.fontName = "helvetica", this.combo = !1;
};
zb(cx, sx);
var lx = function() {
	cx.call(this), this.combo = !0;
};
zb(lx, cx);
var ux = function() {
	lx.call(this), this.edit = !0;
};
zb(ux, lx);
var dx = function() {
	ox.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !!Gb(this.Ff, 15);
		},
		set: function(e) {
			!!e == 1 ? this.Ff = Kb(this.Ff, 15) : this.Ff = qb(this.Ff, 15);
		}
	}), Object.defineProperty(this, "radio", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !!Gb(this.Ff, 16);
		},
		set: function(e) {
			!!e == 1 ? this.Ff = Kb(this.Ff, 16) : this.Ff = qb(this.Ff, 16);
		}
	}), Object.defineProperty(this, "pushButton", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !!Gb(this.Ff, 17);
		},
		set: function(e) {
			!!e == 1 ? this.Ff = Kb(this.Ff, 17) : this.Ff = qb(this.Ff, 17);
		}
	}), Object.defineProperty(this, "radioIsUnison", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !!Gb(this.Ff, 26);
		},
		set: function(e) {
			!!e == 1 ? this.Ff = Kb(this.Ff, 26) : this.Ff = qb(this.Ff, 26);
		}
	});
	var e, t = {};
	Object.defineProperty(this, "MK", {
		enumerable: !1,
		configurable: !1,
		get: function() {
			var e = function(e) {
				return e;
			};
			if (this.scope && (e = this.scope.internal.getEncryptor(this.objId)), Object.keys(t).length !== 0) {
				var n, r = [];
				for (n in r.push("<<"), t) r.push("/" + n + " (" + Pb(e(t[n])) + ")");
				return r.push(">>"), r.join("\n");
			}
		},
		set: function(e) {
			Fa(e) === "object" && (t = e);
		}
	}), Object.defineProperty(this, "caption", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return t.CA || "";
		},
		set: function(e) {
			typeof e == "string" && (t.CA = e);
		}
	}), Object.defineProperty(this, "AS", {
		enumerable: !1,
		configurable: !1,
		get: function() {
			return e;
		},
		set: function(t) {
			var n = t == null ? "" : t.toString();
			n.substr(0, 1) === "/" && (n = n.substr(1)), e = "/" + Ib(n);
		}
	}), Object.defineProperty(this, "appearanceState", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return e.substr(1, e.length - 1);
		},
		set: function(t) {
			e = "/" + Ib(t);
		}
	});
};
zb(dx, ox);
var fx = function() {
	dx.call(this), this.pushButton = !0;
};
zb(fx, dx);
var px = function() {
	dx.call(this), this.radio = !0, this.pushButton = !1;
	var e = [];
	Object.defineProperty(this, "Kids", {
		enumerable: !0,
		configurable: !1,
		get: function() {
			return e;
		},
		set: function(t) {
			e = t === void 0 ? [] : t;
		}
	});
};
zb(px, dx);
var mx = function() {
	var e, t;
	ox.call(this), Object.defineProperty(this, "Parent", {
		enumerable: !1,
		configurable: !1,
		get: function() {
			return e;
		},
		set: function(t) {
			e = t;
		}
	}), Object.defineProperty(this, "optionName", {
		enumerable: !1,
		configurable: !0,
		get: function() {
			return t;
		},
		set: function(e) {
			t = e;
		}
	});
	var n, r = {};
	Object.defineProperty(this, "MK", {
		enumerable: !1,
		configurable: !1,
		get: function() {
			var e = function(e) {
				return e;
			};
			this.scope && (e = this.scope.internal.getEncryptor(this.objId));
			var t, n = [];
			for (t in n.push("<<"), r) n.push("/" + t + " (" + Pb(e(r[t])) + ")");
			return n.push(">>"), n.join("\n");
		},
		set: function(e) {
			Fa(e) === "object" && (r = e);
		}
	}), Object.defineProperty(this, "caption", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return r.CA || "";
		},
		set: function(e) {
			typeof e == "string" && (r.CA = e);
		}
	}), Object.defineProperty(this, "AS", {
		enumerable: !1,
		configurable: !1,
		get: function() {
			return n;
		},
		set: function(e) {
			var t = e == null ? "" : e.toString();
			t.substr(0, 1) === "/" && (t = t.substr(1)), n = "/" + Ib(t);
		}
	}), Object.defineProperty(this, "appearanceState", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return n.substr(1, n.length - 1);
		},
		set: function(e) {
			var t = e == null ? "" : e.toString();
			t.substr(0, 1) === "/" && (t = t.substr(1)), n = "/" + Ib(t);
		}
	}), this.caption = "l", this.appearanceState = "Off", this._AppearanceType = Z.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(this.optionName);
};
zb(mx, ox), px.prototype.setAppearance = function(e) {
	if (!("createAppearanceStream" in e) || !("getCA" in e)) throw Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
	for (var t in this.Kids) if (this.Kids.hasOwnProperty(t)) {
		var n = this.Kids[t];
		n.appearanceStreamContent = e.createAppearanceStream(n.optionName), n.caption = e.getCA();
	}
}, px.prototype.createOption = function(e) {
	var t = new mx();
	return t.Parent = this, t.optionName = e, this.Kids.push(t), vx.call(this.scope, t), t;
};
var hx = function() {
	dx.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = Z.CheckBox.createAppearanceStream();
};
zb(hx, dx);
var gx = function() {
	ox.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !!Gb(this.Ff, 13);
		},
		set: function(e) {
			!!e == 1 ? this.Ff = Kb(this.Ff, 13) : this.Ff = qb(this.Ff, 13);
		}
	}), Object.defineProperty(this, "fileSelect", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !!Gb(this.Ff, 21);
		},
		set: function(e) {
			!!e == 1 ? this.Ff = Kb(this.Ff, 21) : this.Ff = qb(this.Ff, 21);
		}
	}), Object.defineProperty(this, "doNotSpellCheck", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !!Gb(this.Ff, 23);
		},
		set: function(e) {
			!!e == 1 ? this.Ff = Kb(this.Ff, 23) : this.Ff = qb(this.Ff, 23);
		}
	}), Object.defineProperty(this, "doNotScroll", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !!Gb(this.Ff, 24);
		},
		set: function(e) {
			!!e == 1 ? this.Ff = Kb(this.Ff, 24) : this.Ff = qb(this.Ff, 24);
		}
	}), Object.defineProperty(this, "comb", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !!Gb(this.Ff, 25);
		},
		set: function(e) {
			!!e == 1 ? this.Ff = Kb(this.Ff, 25) : this.Ff = qb(this.Ff, 25);
		}
	}), Object.defineProperty(this, "richText", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !!Gb(this.Ff, 26);
		},
		set: function(e) {
			!!e == 1 ? this.Ff = Kb(this.Ff, 26) : this.Ff = qb(this.Ff, 26);
		}
	});
	var e = null;
	Object.defineProperty(this, "MaxLen", {
		enumerable: !0,
		configurable: !1,
		get: function() {
			return e;
		},
		set: function(t) {
			e = t;
		}
	}), Object.defineProperty(this, "maxLength", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return e;
		},
		set: function(t) {
			Number.isInteger(t) && (e = t);
		}
	}), Object.defineProperty(this, "hasAppearanceStream", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return this.V || this.DV;
		}
	});
};
zb(gx, ox);
var _x = function() {
	gx.call(this), Object.defineProperty(this, "password", {
		enumerable: !0,
		configurable: !0,
		get: function() {
			return !!Gb(this.Ff, 14);
		},
		set: function(e) {
			!!e == 1 ? this.Ff = Kb(this.Ff, 14) : this.Ff = qb(this.Ff, 14);
		}
	}), this.password = !0;
};
zb(_x, gx);
var Z = {
	CheckBox: {
		createAppearanceStream: function() {
			return {
				N: { On: Z.CheckBox.YesNormal },
				D: {
					On: Z.CheckBox.YesPushDown,
					Off: Z.CheckBox.OffPushDown
				}
			};
		},
		YesPushDown: function(e) {
			var t = Vb(e);
			t.scope = e.scope;
			var n = [], r = e.scope.internal.getFont(e.fontName, e.fontStyle).id, i = e.scope.__private__.encodeColorString(e.color), a = Xb(e, e.caption);
			return n.push("0.749023 g"), n.push("0 0 " + Lb(Z.internal.getWidth(e)) + " " + Lb(Z.internal.getHeight(e)) + " re"), n.push("f"), n.push("BMC"), n.push("q"), n.push("0 0 1 rg"), n.push("/" + r + " " + Lb(a.fontSize) + " Tf " + i), n.push("BT"), n.push(a.text), n.push("ET"), n.push("Q"), n.push("EMC"), t.stream = n.join("\n"), t;
		},
		YesNormal: function(e) {
			var t = Vb(e);
			t.scope = e.scope;
			var n = e.scope.internal.getFont(e.fontName, e.fontStyle).id, r = e.scope.__private__.encodeColorString(e.color), i = [], a = Z.internal.getHeight(e), o = Z.internal.getWidth(e), s = Xb(e, e.caption);
			return i.push("1 g"), i.push("0 0 " + Lb(o) + " " + Lb(a) + " re"), i.push("f"), i.push("q"), i.push("0 0 1 rg"), i.push("0 0 " + Lb(o - 1) + " " + Lb(a - 1) + " re"), i.push("W"), i.push("n"), i.push("0 g"), i.push("BT"), i.push("/" + n + " " + Lb(s.fontSize) + " Tf " + r), i.push(s.text), i.push("ET"), i.push("Q"), t.stream = i.join("\n"), t;
		},
		OffPushDown: function(e) {
			var t = Vb(e);
			t.scope = e.scope;
			var n = [];
			return n.push("0.749023 g"), n.push("0 0 " + Lb(Z.internal.getWidth(e)) + " " + Lb(Z.internal.getHeight(e)) + " re"), n.push("f"), t.stream = n.join("\n"), t;
		}
	},
	RadioButton: {
		Circle: {
			createAppearanceStream: function(e) {
				var t = {
					D: { Off: Z.RadioButton.Circle.OffPushDown },
					N: {}
				};
				return t.N[e] = Z.RadioButton.Circle.YesNormal, t.D[e] = Z.RadioButton.Circle.YesPushDown, t;
			},
			getCA: function() {
				return "l";
			},
			YesNormal: function(e) {
				var t = Vb(e);
				t.scope = e.scope;
				var n = [], r = Z.internal.getWidth(e) <= Z.internal.getHeight(e) ? Z.internal.getWidth(e) / 4 : Z.internal.getHeight(e) / 4;
				r = Number((.9 * r).toFixed(5));
				var i = Z.internal.Bezier_C, a = Number((r * i).toFixed(5));
				return n.push("q"), n.push("1 0 0 1 " + Rb(Z.internal.getWidth(e) / 2) + " " + Rb(Z.internal.getHeight(e) / 2) + " cm"), n.push(r + " 0 m"), n.push(r + " " + a + " " + a + " " + r + " 0 " + r + " c"), n.push("-" + a + " " + r + " -" + r + " " + a + " -" + r + " 0 c"), n.push("-" + r + " -" + a + " -" + a + " -" + r + " 0 -" + r + " c"), n.push(a + " -" + r + " " + r + " -" + a + " " + r + " 0 c"), n.push("f"), n.push("Q"), t.stream = n.join("\n"), t;
			},
			YesPushDown: function(e) {
				var t = Vb(e);
				t.scope = e.scope;
				var n = [], r = Z.internal.getWidth(e) <= Z.internal.getHeight(e) ? Z.internal.getWidth(e) / 4 : Z.internal.getHeight(e) / 4;
				r = Number((.9 * r).toFixed(5));
				var i = Number((2 * r).toFixed(5)), a = Number((i * Z.internal.Bezier_C).toFixed(5)), o = Number((r * Z.internal.Bezier_C).toFixed(5));
				return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + Rb(Z.internal.getWidth(e) / 2) + " " + Rb(Z.internal.getHeight(e) / 2) + " cm"), n.push(i + " 0 m"), n.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), n.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), n.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), n.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), n.push("f"), n.push("Q"), n.push("0 g"), n.push("q"), n.push("1 0 0 1 " + Rb(Z.internal.getWidth(e) / 2) + " " + Rb(Z.internal.getHeight(e) / 2) + " cm"), n.push(r + " 0 m"), n.push(r + " " + o + " " + o + " " + r + " 0 " + r + " c"), n.push("-" + o + " " + r + " -" + r + " " + o + " -" + r + " 0 c"), n.push("-" + r + " -" + o + " -" + o + " -" + r + " 0 -" + r + " c"), n.push(o + " -" + r + " " + r + " -" + o + " " + r + " 0 c"), n.push("f"), n.push("Q"), t.stream = n.join("\n"), t;
			},
			OffPushDown: function(e) {
				var t = Vb(e);
				t.scope = e.scope;
				var n = [], r = Z.internal.getWidth(e) <= Z.internal.getHeight(e) ? Z.internal.getWidth(e) / 4 : Z.internal.getHeight(e) / 4;
				r = Number((.9 * r).toFixed(5));
				var i = Number((2 * r).toFixed(5)), a = Number((i * Z.internal.Bezier_C).toFixed(5));
				return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + Rb(Z.internal.getWidth(e) / 2) + " " + Rb(Z.internal.getHeight(e) / 2) + " cm"), n.push(i + " 0 m"), n.push(i + " " + a + " " + a + " " + i + " 0 " + i + " c"), n.push("-" + a + " " + i + " -" + i + " " + a + " -" + i + " 0 c"), n.push("-" + i + " -" + a + " -" + a + " -" + i + " 0 -" + i + " c"), n.push(a + " -" + i + " " + i + " -" + a + " " + i + " 0 c"), n.push("f"), n.push("Q"), t.stream = n.join("\n"), t;
			}
		},
		Cross: {
			createAppearanceStream: function(e) {
				var t = {
					D: { Off: Z.RadioButton.Cross.OffPushDown },
					N: {}
				};
				return t.N[e] = Z.RadioButton.Cross.YesNormal, t.D[e] = Z.RadioButton.Cross.YesPushDown, t;
			},
			getCA: function() {
				return "8";
			},
			YesNormal: function(e) {
				var t = Vb(e);
				t.scope = e.scope;
				var n = [], r = Z.internal.calculateCross(e);
				return n.push("q"), n.push("1 1 " + Lb(Z.internal.getWidth(e) - 2) + " " + Lb(Z.internal.getHeight(e) - 2) + " re"), n.push("W"), n.push("n"), n.push(Lb(r.x1.x) + " " + Lb(r.x1.y) + " m"), n.push(Lb(r.x2.x) + " " + Lb(r.x2.y) + " l"), n.push(Lb(r.x4.x) + " " + Lb(r.x4.y) + " m"), n.push(Lb(r.x3.x) + " " + Lb(r.x3.y) + " l"), n.push("s"), n.push("Q"), t.stream = n.join("\n"), t;
			},
			YesPushDown: function(e) {
				var t = Vb(e);
				t.scope = e.scope;
				var n = Z.internal.calculateCross(e), r = [];
				return r.push("0.749023 g"), r.push("0 0 " + Lb(Z.internal.getWidth(e)) + " " + Lb(Z.internal.getHeight(e)) + " re"), r.push("f"), r.push("q"), r.push("1 1 " + Lb(Z.internal.getWidth(e) - 2) + " " + Lb(Z.internal.getHeight(e) - 2) + " re"), r.push("W"), r.push("n"), r.push(Lb(n.x1.x) + " " + Lb(n.x1.y) + " m"), r.push(Lb(n.x2.x) + " " + Lb(n.x2.y) + " l"), r.push(Lb(n.x4.x) + " " + Lb(n.x4.y) + " m"), r.push(Lb(n.x3.x) + " " + Lb(n.x3.y) + " l"), r.push("s"), r.push("Q"), t.stream = r.join("\n"), t;
			},
			OffPushDown: function(e) {
				var t = Vb(e);
				t.scope = e.scope;
				var n = [];
				return n.push("0.749023 g"), n.push("0 0 " + Lb(Z.internal.getWidth(e)) + " " + Lb(Z.internal.getHeight(e)) + " re"), n.push("f"), t.stream = n.join("\n"), t;
			}
		}
	},
	createDefaultAppearanceStream: function(e) {
		var t = e.scope.internal.getFont(e.fontName, e.fontStyle).id, n = e.scope.__private__.encodeColorString(e.color);
		return "/" + t + " " + e.fontSize + " Tf " + n;
	}
};
Z.internal = {
	Bezier_C: .551915024494,
	calculateCross: function(e) {
		var t = Z.internal.getWidth(e), n = Z.internal.getHeight(e), r = Math.min(t, n);
		return {
			x1: {
				x: (t - r) / 2,
				y: (n - r) / 2 + r
			},
			x2: {
				x: (t - r) / 2 + r,
				y: (n - r) / 2
			},
			x3: {
				x: (t - r) / 2,
				y: (n - r) / 2
			},
			x4: {
				x: (t - r) / 2 + r,
				y: (n - r) / 2 + r
			}
		};
	}
}, Z.internal.getWidth = function(e) {
	var t = 0;
	return Fa(e) === "object" && (t = Bb(e.Rect[2])), t;
}, Z.internal.getHeight = function(e) {
	var t = 0;
	return Fa(e) === "object" && (t = Bb(e.Rect[3])), t;
};
var vx = Mb.addField = function(e) {
	if (ex(this, e), !(e instanceof ox)) throw Error("Invalid argument passed to jsPDF.addField.");
	var t;
	return (t = e).scope.internal.acroformPlugin.printedOut && (t.scope.internal.acroformPlugin.printedOut = !1, t.scope.internal.acroformPlugin.acroFormDictionaryRoot = null), t.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(t), e.page = e.scope.internal.getCurrentPageInfo().pageNumber, this;
};
Mb.AcroFormChoiceField = sx, Mb.AcroFormListBox = cx, Mb.AcroFormComboBox = lx, Mb.AcroFormEditBox = ux, Mb.AcroFormButton = dx, Mb.AcroFormPushButton = fx, Mb.AcroFormRadioButton = px, Mb.AcroFormCheckBox = hx, Mb.AcroFormTextField = gx, Mb.AcroFormPasswordField = _x, Mb.AcroFormAppearance = Z, Mb.AcroForm = {
	ChoiceField: sx,
	ListBox: cx,
	ComboBox: lx,
	EditBox: ux,
	Button: dx,
	PushButton: fx,
	RadioButton: px,
	CheckBox: hx,
	TextField: gx,
	PasswordField: _x,
	Appearance: Z
}, jb.AcroForm = {
	ChoiceField: sx,
	ListBox: cx,
	ComboBox: lx,
	EditBox: ux,
	Button: dx,
	PushButton: fx,
	RadioButton: px,
	CheckBox: hx,
	TextField: gx,
	PasswordField: _x,
	Appearance: Z
}, jb.AcroForm;
function yx(e) {
	return e.reduce(function(e, t, n) {
		return e[t] = n, e;
	}, {});
}
(function(e) {
	e.__addimage__ = {};
	var t = "UNKNOWN", n = {
		PNG: [[
			137,
			80,
			78,
			71
		]],
		TIFF: [[
			77,
			77,
			0,
			42
		], [
			73,
			73,
			42,
			0
		]],
		JPEG: [
			[
				255,
				216,
				255,
				224,
				void 0,
				void 0,
				74,
				70,
				73,
				70,
				0
			],
			[
				255,
				216,
				255,
				225,
				void 0,
				void 0,
				69,
				120,
				105,
				102,
				0,
				0
			],
			[
				255,
				216,
				255,
				219
			],
			[
				255,
				216,
				255,
				238
			]
		],
		JPEG2000: [[
			0,
			0,
			0,
			12,
			106,
			80,
			32,
			32
		]],
		GIF87a: [[
			71,
			73,
			70,
			56,
			55,
			97
		]],
		GIF89a: [[
			71,
			73,
			70,
			56,
			57,
			97
		]],
		WEBP: [[
			82,
			73,
			70,
			70,
			void 0,
			void 0,
			void 0,
			void 0,
			87,
			69,
			66,
			80
		]],
		BMP: [
			[66, 77],
			[66, 65],
			[67, 73],
			[67, 80],
			[73, 67],
			[80, 84]
		]
	}, r = e.__addimage__.getImageFileTypeByImageData = function(e, r) {
		var i, a, o, s, c, l = t;
		if ((r ||= t) === "RGBA" || e.data !== void 0 && e.data instanceof Uint8ClampedArray && "height" in e && "width" in e) return "RGBA";
		if (x(e)) for (c in n) for (o = n[c], i = 0; i < o.length; i += 1) {
			for (s = !0, a = 0; a < o[i].length; a += 1) if (o[i][a] !== void 0 && o[i][a] !== e[a]) {
				s = !1;
				break;
			}
			if (!0 === s) {
				l = c;
				break;
			}
		}
		else for (c in n) for (o = n[c], i = 0; i < o.length; i += 1) {
			for (s = !0, a = 0; a < o[i].length; a += 1) if (o[i][a] !== void 0 && o[i][a] !== e.charCodeAt(a)) {
				s = !1;
				break;
			}
			if (!0 === s) {
				l = c;
				break;
			}
		}
		return l === t && r !== t && (l = r), l;
	}, i = function e(t) {
		for (var n = this.internal.write, r = this.internal.putStream, i = (0, this.internal.getFilters)(); i.indexOf("FlateEncode") !== -1;) i.splice(i.indexOf("FlateEncode"), 1);
		t.objectId = this.internal.newObject();
		var a = [];
		if (a.push({
			key: "Type",
			value: "/XObject"
		}), a.push({
			key: "Subtype",
			value: "/Image"
		}), a.push({
			key: "Width",
			value: t.width
		}), a.push({
			key: "Height",
			value: t.height
		}), t.colorSpace === g.INDEXED ? a.push({
			key: "ColorSpace",
			value: "[/Indexed /DeviceRGB " + (t.palette.length / 3 - 1) + " " + ("sMask" in t && t.sMask !== void 0 ? t.objectId + 2 : t.objectId + 1) + " 0 R]"
		}) : (a.push({
			key: "ColorSpace",
			value: "/" + t.colorSpace
		}), t.colorSpace === g.DEVICE_CMYK && a.push({
			key: "Decode",
			value: "[1 0 1 0 1 0 1 0]"
		})), a.push({
			key: "BitsPerComponent",
			value: t.bitsPerComponent
		}), "decodeParameters" in t && t.decodeParameters !== void 0 && a.push({
			key: "DecodeParms",
			value: "<<" + t.decodeParameters + ">>"
		}), "transparency" in t && Array.isArray(t.transparency) && t.transparency.length > 0) {
			for (var o = "", s = 0, c = t.transparency.length; s < c; s++) o += t.transparency[s] + " " + t.transparency[s] + " ";
			a.push({
				key: "Mask",
				value: "[" + o + "]"
			});
		}
		t.sMask !== void 0 && a.push({
			key: "SMask",
			value: t.objectId + 1 + " 0 R"
		});
		var l = t.filter === void 0 ? void 0 : ["/" + t.filter];
		if (r({
			data: t.data,
			additionalKeyValues: a,
			alreadyAppliedFilters: l,
			objectId: t.objectId
		}), n("endobj"), "sMask" in t && t.sMask !== void 0) {
			var u = t.sMaskBitsPerComponent ?? t.bitsPerComponent, d = {
				width: t.width,
				height: t.height,
				colorSpace: "DeviceGray",
				bitsPerComponent: u,
				data: t.sMask
			};
			"filter" in t && (d.decodeParameters = `/Predictor ${t.predictor} /Colors 1 /BitsPerComponent ${u} /Columns ${t.width}`, d.filter = t.filter), e.call(this, d);
		}
		if (t.colorSpace === g.INDEXED) {
			var f = this.internal.newObject();
			r({
				data: C(new Uint8Array(t.palette)),
				objectId: f
			}), n("endobj");
		}
	}, a = function() {
		var e = this.internal.collections.addImage_images;
		for (var t in e) i.call(this, e[t]);
	}, o = function() {
		var e, t = this.internal.collections.addImage_images, n = this.internal.write;
		for (var r in t) n("/I" + (e = t[r]).index, e.objectId, "0", "R");
	}, s = function() {
		this.internal.collections.addImage_images || (this.internal.collections.addImage_images = {}, this.internal.events.subscribe("putResources", a), this.internal.events.subscribe("putXobjectDict", o));
	}, c = function() {
		var e = this.internal.collections.addImage_images;
		return s.call(this), e;
	}, l = function() {
		return Object.keys(this.internal.collections.addImage_images).length;
	}, u = function(t) {
		return typeof e["process" + t.toUpperCase()] == "function";
	}, d = function(e) {
		return Fa(e) === "object" && e.nodeType === 1;
	}, f = function(t, n) {
		if (t.nodeName === "IMG" && t.hasAttribute("src")) {
			var r = "" + t.getAttribute("src");
			if (r.indexOf("data:image/") === 0) return ob(unescape(r).split("base64,").pop());
			var i = e.loadFile(r, !0);
			if (i !== void 0) return i;
		}
		if (t.nodeName === "CANVAS") {
			if (t.width === 0 || t.height === 0) throw Error("Given canvas must have data. Canvas width: " + t.width + ", height: " + t.height);
			var a;
			switch (n) {
				case "PNG":
					a = "image/png";
					break;
				case "WEBP":
					a = "image/webp";
					break;
				default: a = "image/jpeg";
			}
			return ob(t.toDataURL(a, 1).split("base64,").pop());
		}
	}, p = function(e) {
		var t = this.internal.collections.addImage_images;
		if (t) {
			for (var n in t) if (e === t[n].alias) return t[n];
		}
	}, m = function(e, t, n) {
		return e || t || (e = -96, t = -96), e < 0 && (e = -1 * n.width * 72 / e / this.internal.scaleFactor), t < 0 && (t = -1 * n.height * 72 / t / this.internal.scaleFactor), e === 0 && (e = t * n.width / n.height), t === 0 && (t = e * n.height / n.width), [e, t];
	}, h = function(e, t, n, r, i, a) {
		var o = m.call(this, n, r, i), s = this.internal.getCoordinateString, l = this.internal.getVerticalCoordinateString, u = c.call(this);
		if (n = o[0], r = o[1], u[i.index] = i, a) {
			a *= Math.PI / 180;
			var d = Math.cos(a), f = Math.sin(a), p = function(e) {
				return e.toFixed(4);
			}, h = [
				p(d),
				p(f),
				p(-1 * f),
				p(d),
				0,
				0,
				"cm"
			];
		}
		this.internal.write("q"), a ? (this.internal.write([
			1,
			"0",
			"0",
			1,
			s(e),
			l(t + r),
			"cm"
		].join(" ")), this.internal.write(h.join(" ")), this.internal.write([
			s(n),
			"0",
			"0",
			s(r),
			"0",
			"0",
			"cm"
		].join(" "))) : this.internal.write([
			s(n),
			"0",
			"0",
			s(r),
			s(e),
			l(t + r),
			"cm"
		].join(" ")), this.isAdvancedAPI() && this.internal.write([
			1,
			0,
			0,
			-1,
			0,
			0,
			"cm"
		].join(" ")), this.internal.write("/I" + i.index + " Do"), this.internal.write("Q");
	}, g = e.color_spaces = {
		DEVICE_RGB: "DeviceRGB",
		DEVICE_GRAY: "DeviceGray",
		DEVICE_CMYK: "DeviceCMYK",
		CAL_GREY: "CalGray",
		CAL_RGB: "CalRGB",
		LAB: "Lab",
		ICC_BASED: "ICCBased",
		INDEXED: "Indexed",
		PATTERN: "Pattern",
		SEPARATION: "Separation",
		DEVICE_N: "DeviceN"
	};
	e.decode = {
		DCT_DECODE: "DCTDecode",
		FLATE_DECODE: "FlateDecode",
		LZW_DECODE: "LZWDecode",
		JPX_DECODE: "JPXDecode",
		JBIG2_DECODE: "JBIG2Decode",
		ASCII85_DECODE: "ASCII85Decode",
		ASCII_HEX_DECODE: "ASCIIHexDecode",
		RUN_LENGTH_DECODE: "RunLengthDecode",
		CCITT_FAX_DECODE: "CCITTFaxDecode"
	};
	var _ = e.image_compression = {
		NONE: "NONE",
		FAST: "FAST",
		MEDIUM: "MEDIUM",
		SLOW: "SLOW"
	}, v = e.__addimage__.sHashCode = function(e) {
		var t, n, r = 0;
		if (typeof e == "string") for (n = e.length, t = 0; t < n; t++) r = (r << 5) - r + e.charCodeAt(t), r |= 0;
		else if (x(e)) for (n = e.byteLength / 2, t = 0; t < n; t++) r = (r << 5) - r + e[t], r |= 0;
		return r;
	}, y = e.__addimage__.validateStringAsBase64 = function(e) {
		(e ||= "").toString().trim();
		var t = !0;
		return e.length === 0 && (t = !1), e.length % 4 != 0 && (t = !1), !1 === /^[A-Za-z0-9+/]+$/.test(e.substr(0, e.length - 2)) && (t = !1), !1 === /^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(e.substr(-2)) && (t = !1), t;
	}, b = e.__addimage__.extractImageFromDataUrl = function(e) {
		if (e == null || !(e = e.trim()).startsWith("data:")) return null;
		var t = e.indexOf(",");
		return t < 0 ? null : e.substring(0, t).trim().endsWith("base64") ? e.substring(t + 1) : null;
	};
	e.__addimage__.isArrayBuffer = function(e) {
		return e instanceof ArrayBuffer;
	};
	var x = e.__addimage__.isArrayBufferView = function(e) {
		return e instanceof Int8Array || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Int16Array || e instanceof Uint16Array || e instanceof Int32Array || e instanceof Uint32Array || e instanceof Float32Array || e instanceof Float64Array;
	}, S = e.__addimage__.binaryStringToUint8Array = function(e) {
		for (var t = e.length, n = new Uint8Array(t), r = 0; r < t; r++) n[r] = e.charCodeAt(r);
		return n;
	}, C = e.__addimage__.arrayBufferToBinaryString = function(e) {
		for (var t = "", n = x(e) ? e : new Uint8Array(e), r = 0; r < n.length; r += 8192) t += String.fromCharCode.apply(null, n.subarray(r, r + 8192));
		return t;
	};
	e.addImage = function() {
		var e, n, r, i, a, o, c, l, u;
		if (typeof arguments[1] == "number" ? (n = t, r = arguments[1], i = arguments[2], a = arguments[3], o = arguments[4], c = arguments[5], l = arguments[6], u = arguments[7]) : (n = arguments[1], r = arguments[2], i = arguments[3], a = arguments[4], o = arguments[5], c = arguments[6], l = arguments[7], u = arguments[8]), Fa(e = arguments[0]) === "object" && !d(e) && "imageData" in e) {
			var f = e;
			e = f.imageData, n = f.format || n || t, r = f.x || r || 0, i = f.y || i || 0, a = f.w || f.width || a, o = f.h || f.height || o, c = f.alias || c, l = f.compression || l, u = f.rotation || f.angle || u;
		}
		var p = this.internal.getFilters();
		if (l === void 0 && p.indexOf("FlateEncode") !== -1 && (l = "SLOW"), isNaN(r) || isNaN(i)) throw Error("Invalid coordinates passed to jsPDF.addImage");
		s.call(this);
		var m = w.call(this, e, n, c, l);
		return h.call(this, r, i, a, o, m, u), this;
	};
	var w = function(n, i, a, o) {
		var s, c, m;
		if (typeof n == "string" && r(n) === t) {
			n = unescape(n);
			var h = T(n, !1);
			(h !== "" || (h = e.loadFile(n, !0)) !== void 0) && (n = h);
		}
		if (d(n) && (n = f(n, i)), i = r(n, i), !u(i)) throw Error("addImage does not support files of type '" + i + "', please ensure that a plugin for '" + i + "' support is added.");
		if (((m = a) == null || m.length === 0) && (a = function(e) {
			return typeof e == "string" || x(e) ? v(e) : x(e.data) ? v(e.data) : null;
		}(n)), (s = p.call(this, a)) || (n instanceof Uint8Array || i === "RGBA" || (c = n, n = S(n)), s = this["process" + i.toUpperCase()](n, l.call(this), a, function(t) {
			return t && typeof t == "string" && (t = t.toUpperCase()), t in e.image_compression ? t : _.NONE;
		}(o), c)), !s) throw Error("An unknown error occurred whilst processing the image.");
		return s;
	}, T = e.__addimage__.convertBase64ToBinaryString = function(e, t) {
		t = typeof t != "boolean" || t;
		var n, r = "";
		if (typeof e == "string") {
			n = b(e) ?? e;
			try {
				r = ob(n);
			} catch (e) {
				if (t) throw y(n) ? /* @__PURE__ */ Error("atob-Error in jsPDF.convertBase64ToBinaryString " + e.message) : /* @__PURE__ */ Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ");
			}
		}
		return r;
	};
	e.getImageProperties = function(n) {
		var i, a, o = "";
		if (d(n) && (n = f(n)), typeof n == "string" && r(n) === t && ((o = T(n, !1)) === "" && (o = e.loadFile(n) || ""), n = o), a = r(n), !u(a)) throw Error("addImage does not support files of type '" + a + "', please ensure that a plugin for '" + a + "' support is added.");
		if (n instanceof Uint8Array || (n = S(n)), !(i = this["process" + a.toUpperCase()](n))) throw Error("An unknown error occurred whilst processing the image");
		return i.fileType = a, i;
	};
})(jb.API), function(e) {
	var t = function(e) {
		if (e !== void 0 && e != "") return !0;
	};
	jb.API.events.push(["addPage", function(e) {
		this.internal.getPageInfo(e.pageNumber).pageContext.annotations = [];
	}]), e.events.push(["putPage", function(e) {
		for (var n, r, i, a = this.internal.getCoordinateString, o = this.internal.getVerticalCoordinateString, s = this.internal.getPageInfoByObjId(e.objId), c = e.pageContext.annotations, l = !1, u = 0; u < c.length && !l; u++) switch ((n = c[u]).type) {
			case "link":
				(t(n.options.url) || t(n.options.pageNumber)) && (l = !0);
				break;
			case "reference":
			case "text":
			case "freetext": l = !0;
		}
		if (l != 0) {
			this.internal.write("/Annots [");
			for (var d = 0; d < c.length; d++) {
				n = c[d];
				var f = this.internal.pdfEscape, p = this.internal.getEncryptor(e.objId);
				switch (n.type) {
					case "reference":
						this.internal.write(" " + n.object.objId + " 0 R ");
						break;
					case "text":
						var m = this.internal.newAdditionalObject(), h = this.internal.newAdditionalObject(), g = this.internal.getEncryptor(m.objId), _ = n.title || "Note";
						i = "<</Type /Annot /Subtype /Text " + (r = "/Rect [" + a(n.bounds.x) + " " + o(n.bounds.y + n.bounds.h) + " " + a(n.bounds.x + n.bounds.w) + " " + o(n.bounds.y) + "] ") + "/Contents (" + f(g(n.contents)) + ")", i += " /Popup " + h.objId + " 0 R", i += " /P " + s.objId + " 0 R", i += " /T (" + f(g(_)) + ") >>", m.content = i;
						var v = m.objId + " 0 R";
						i = "<</Type /Annot /Subtype /Popup " + (r = "/Rect [" + a(n.bounds.x + 30) + " " + o(n.bounds.y + n.bounds.h) + " " + a(n.bounds.x + n.bounds.w + 30) + " " + o(n.bounds.y) + "] ") + " /Parent " + v, n.open && (i += " /Open true"), i += " >>", h.content = i, this.internal.write(m.objId, "0 R", h.objId, "0 R");
						break;
					case "freetext":
						r = "/Rect [" + a(n.bounds.x) + " " + o(n.bounds.y) + " " + a(n.bounds.x + n.bounds.w) + " " + o(n.bounds.y + n.bounds.h) + "] ";
						var y = "font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + (n.color || "#000000");
						i = "<</Type /Annot /Subtype /FreeText " + r + "/Contents (" + f(p(n.contents)) + ")", i += " /DS(" + f(p(y)) + ")", i += " /Border [0 0 0]", i += " >>", this.internal.write(i);
						break;
					case "link":
						if (n.options.name) {
							var b = this.annotations._nameMap[n.options.name];
							n.options.pageNumber = b.page, n.options.top = b.y;
						} else n.options.top || (n.options.top = 0);
						if (r = "/Rect [" + n.finalBounds.x + " " + n.finalBounds.y + " " + n.finalBounds.w + " " + n.finalBounds.h + "] ", i = "", n.options.url) i = "<</Type /Annot /Subtype /Link " + r + "/Border [0 0 0] /A <</S /URI /URI (" + f(p(n.options.url)) + ") >>";
						else if (n.options.pageNumber) switch (i = "<</Type /Annot /Subtype /Link " + r + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(n.options.pageNumber).objId + " 0 R", n.options.magFactor = n.options.magFactor || "XYZ", n.options.magFactor) {
							case "Fit":
								i += " /Fit]";
								break;
							case "FitH":
								i += " /FitH " + n.options.top + "]";
								break;
							case "FitV":
								n.options.left = n.options.left || 0, i += " /FitV " + n.options.left + "]";
								break;
							default:
								var x = o(n.options.top);
								n.options.left = n.options.left || 0, n.options.zoom === void 0 && (n.options.zoom = 0), i += " /XYZ " + n.options.left + " " + x + " " + n.options.zoom + "]";
						}
						i != "" && (i += " >>", this.internal.write(i));
				}
			}
			this.internal.write("]");
		}
	}]), e.createAnnotation = function(e) {
		var t = this.internal.getCurrentPageInfo();
		switch (e.type) {
			case "link":
				this.link(e.bounds.x, e.bounds.y, e.bounds.w, e.bounds.h, e);
				break;
			case "text":
			case "freetext": t.pageContext.annotations.push(e);
		}
	}, e.link = function(e, t, n, r, i) {
		var a = this.internal.getCurrentPageInfo(), o = this.internal.getCoordinateString, s = this.internal.getVerticalCoordinateString;
		a.pageContext.annotations.push({
			finalBounds: {
				x: o(e),
				y: s(t),
				w: o(e + n),
				h: s(t + r)
			},
			options: i,
			type: "link"
		});
	}, e.textWithLink = function(e, t, n, r) {
		var i, a, o = this.getTextWidth(e), s = this.internal.getLineHeight() / this.internal.scaleFactor;
		if (r.maxWidth !== void 0) {
			a = r.maxWidth;
			var c = this.splitTextToSize(e, a).length;
			i = Math.ceil(s * c);
		} else a = o, i = s;
		return this.text(e, t, n, r), n += .2 * s, r.align === "center" && (t -= o / 2), r.align === "right" && (t -= o), this.link(t, n - s, a, i, r), o;
	}, e.getTextWidth = function(e) {
		var t = this.internal.getFontSize();
		return this.getStringUnitWidth(e) * t / this.internal.scaleFactor;
	};
}(jb.API), function(e) {
	var t = {
		1569: [65152],
		1570: [65153, 65154],
		1571: [65155, 65156],
		1572: [65157, 65158],
		1573: [65159, 65160],
		1574: [
			65161,
			65162,
			65163,
			65164
		],
		1575: [65165, 65166],
		1576: [
			65167,
			65168,
			65169,
			65170
		],
		1577: [65171, 65172],
		1578: [
			65173,
			65174,
			65175,
			65176
		],
		1579: [
			65177,
			65178,
			65179,
			65180
		],
		1580: [
			65181,
			65182,
			65183,
			65184
		],
		1581: [
			65185,
			65186,
			65187,
			65188
		],
		1582: [
			65189,
			65190,
			65191,
			65192
		],
		1583: [65193, 65194],
		1584: [65195, 65196],
		1585: [65197, 65198],
		1586: [65199, 65200],
		1587: [
			65201,
			65202,
			65203,
			65204
		],
		1588: [
			65205,
			65206,
			65207,
			65208
		],
		1589: [
			65209,
			65210,
			65211,
			65212
		],
		1590: [
			65213,
			65214,
			65215,
			65216
		],
		1591: [
			65217,
			65218,
			65219,
			65220
		],
		1592: [
			65221,
			65222,
			65223,
			65224
		],
		1593: [
			65225,
			65226,
			65227,
			65228
		],
		1594: [
			65229,
			65230,
			65231,
			65232
		],
		1601: [
			65233,
			65234,
			65235,
			65236
		],
		1602: [
			65237,
			65238,
			65239,
			65240
		],
		1603: [
			65241,
			65242,
			65243,
			65244
		],
		1604: [
			65245,
			65246,
			65247,
			65248
		],
		1605: [
			65249,
			65250,
			65251,
			65252
		],
		1606: [
			65253,
			65254,
			65255,
			65256
		],
		1607: [
			65257,
			65258,
			65259,
			65260
		],
		1608: [65261, 65262],
		1609: [
			65263,
			65264,
			64488,
			64489
		],
		1610: [
			65265,
			65266,
			65267,
			65268
		],
		1649: [64336, 64337],
		1655: [64477],
		1657: [
			64358,
			64359,
			64360,
			64361
		],
		1658: [
			64350,
			64351,
			64352,
			64353
		],
		1659: [
			64338,
			64339,
			64340,
			64341
		],
		1662: [
			64342,
			64343,
			64344,
			64345
		],
		1663: [
			64354,
			64355,
			64356,
			64357
		],
		1664: [
			64346,
			64347,
			64348,
			64349
		],
		1667: [
			64374,
			64375,
			64376,
			64377
		],
		1668: [
			64370,
			64371,
			64372,
			64373
		],
		1670: [
			64378,
			64379,
			64380,
			64381
		],
		1671: [
			64382,
			64383,
			64384,
			64385
		],
		1672: [64392, 64393],
		1676: [64388, 64389],
		1677: [64386, 64387],
		1678: [64390, 64391],
		1681: [64396, 64397],
		1688: [64394, 64395],
		1700: [
			64362,
			64363,
			64364,
			64365
		],
		1702: [
			64366,
			64367,
			64368,
			64369
		],
		1705: [
			64398,
			64399,
			64400,
			64401
		],
		1709: [
			64467,
			64468,
			64469,
			64470
		],
		1711: [
			64402,
			64403,
			64404,
			64405
		],
		1713: [
			64410,
			64411,
			64412,
			64413
		],
		1715: [
			64406,
			64407,
			64408,
			64409
		],
		1722: [64414, 64415],
		1723: [
			64416,
			64417,
			64418,
			64419
		],
		1726: [
			64426,
			64427,
			64428,
			64429
		],
		1728: [64420, 64421],
		1729: [
			64422,
			64423,
			64424,
			64425
		],
		1733: [64480, 64481],
		1734: [64473, 64474],
		1735: [64471, 64472],
		1736: [64475, 64476],
		1737: [64482, 64483],
		1739: [64478, 64479],
		1740: [
			64508,
			64509,
			64510,
			64511
		],
		1744: [
			64484,
			64485,
			64486,
			64487
		],
		1746: [64430, 64431],
		1747: [64432, 64433]
	}, n = {
		65247: {
			65154: 65269,
			65156: 65271,
			65160: 65273,
			65166: 65275
		},
		65248: {
			65154: 65270,
			65156: 65272,
			65160: 65274,
			65166: 65276
		},
		65165: { 65247: { 65248: { 65258: 65010 } } },
		1617: {
			1612: 64606,
			1613: 64607,
			1614: 64608,
			1615: 64609,
			1616: 64610
		}
	}, r = {
		1612: 64606,
		1613: 64607,
		1614: 64608,
		1615: 64609,
		1616: 64610
	}, i = [
		1570,
		1571,
		1573,
		1575
	];
	e.__arabicParser__ = {};
	var a = e.__arabicParser__.isInArabicSubstitutionA = function(e) {
		return t[e.charCodeAt(0)] !== void 0;
	}, o = e.__arabicParser__.isArabicLetter = function(e) {
		return typeof e == "string" && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(e);
	}, s = e.__arabicParser__.isArabicEndLetter = function(e) {
		return o(e) && a(e) && t[e.charCodeAt(0)].length <= 2;
	}, c = e.__arabicParser__.isArabicAlfLetter = function(e) {
		return o(e) && i.indexOf(e.charCodeAt(0)) >= 0;
	};
	e.__arabicParser__.arabicLetterHasIsolatedForm = function(e) {
		return o(e) && a(e) && t[e.charCodeAt(0)].length >= 1;
	};
	var l = e.__arabicParser__.arabicLetterHasFinalForm = function(e) {
		return o(e) && a(e) && t[e.charCodeAt(0)].length >= 2;
	};
	e.__arabicParser__.arabicLetterHasInitialForm = function(e) {
		return o(e) && a(e) && t[e.charCodeAt(0)].length >= 3;
	};
	var u = e.__arabicParser__.arabicLetterHasMedialForm = function(e) {
		return o(e) && a(e) && t[e.charCodeAt(0)].length == 4;
	}, d = e.__arabicParser__.resolveLigatures = function(e) {
		var t = 0, r = n, i = "", a = 0;
		for (t = 0; t < e.length; t += 1) r[e.charCodeAt(t)] === void 0 ? (r = n, i += e.charAt(t - a), t -= a, a = 0) : (a++, typeof (r = r[e.charCodeAt(t)]) == "number" && (i += String.fromCharCode(r), r = n, a = 0), t === e.length - 1 && (r = n, i += e.charAt(t - (a - 1)), t -= a - 1, a = 0));
		return i;
	};
	e.__arabicParser__.isArabicDiacritic = function(e) {
		return e !== void 0 && r[e.charCodeAt(0)] !== void 0;
	};
	var f = e.__arabicParser__.getCorrectForm = function(e, t, n) {
		return o(e) ? !1 === a(e) ? -1 : !l(e) || !o(t) && !o(n) || !o(n) && s(t) || s(e) && !o(t) || s(e) && c(t) || s(e) && s(t) ? 0 : u(e) && o(t) && !s(t) && o(n) && l(n) ? 3 : s(e) || !o(n) ? 1 : 2 : -1;
	}, p = function(e) {
		var n = 0, r = 0, i = 0, a = "", s = "", c = "", l = (e ||= "").split("\\s+"), u = [];
		for (n = 0; n < l.length; n += 1) {
			for (u.push(""), r = 0; r < l[n].length; r += 1) a = l[n][r], s = l[n][r - 1], c = l[n][r + 1], o(a) ? (i = f(a, s, c), u[n] += i === -1 ? a : String.fromCharCode(t[a.charCodeAt(0)][i])) : u[n] += a;
			u[n] = d(u[n]);
		}
		return u.join(" ");
	}, m = e.__arabicParser__.processArabic = e.processArabic = function() {
		var e, t = typeof arguments[0] == "string" ? arguments[0] : arguments[0].text, n = [];
		if (Array.isArray(t)) {
			var r = 0;
			for (n = [], r = 0; r < t.length; r += 1) Array.isArray(t[r]) ? n.push([
				p(t[r][0]),
				t[r][1],
				t[r][2]
			]) : n.push([p(t[r])]);
			e = n;
		} else e = p(t);
		return typeof arguments[0] == "string" ? e : (arguments[0].text = e, arguments[0]);
	};
	e.events.push(["preProcessText", m]);
}(jb.API), jb.API.autoPrint = function(e) {
	var t;
	return (e ||= {}).variant = e.variant || "non-conform", e.variant === "javascript" ? this.addJS("print({});") : (this.internal.events.subscribe("postPutResources", function() {
		t = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
	}), this.internal.events.subscribe("putCatalog", function() {
		this.internal.out("/OpenAction " + t + " 0 R");
	})), this;
}, function(e) {
	var t = function() {
		var e = void 0;
		Object.defineProperty(this, "pdf", {
			get: function() {
				return e;
			},
			set: function(t) {
				e = t;
			}
		});
		var t = 150;
		Object.defineProperty(this, "width", {
			get: function() {
				return t;
			},
			set: function(e) {
				t = isNaN(e) || !1 === Number.isInteger(e) || e < 0 ? 150 : e, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = t + 1);
			}
		});
		var n = 300;
		Object.defineProperty(this, "height", {
			get: function() {
				return n;
			},
			set: function(e) {
				n = isNaN(e) || !1 === Number.isInteger(e) || e < 0 ? 300 : e, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = n + 1);
			}
		});
		var r = [];
		Object.defineProperty(this, "childNodes", {
			get: function() {
				return r;
			},
			set: function(e) {
				r = e;
			}
		});
		var i = {};
		Object.defineProperty(this, "style", {
			get: function() {
				return i;
			},
			set: function(e) {
				i = e;
			}
		}), Object.defineProperty(this, "parentNode", {});
	};
	t.prototype.getContext = function(e, t) {
		var n;
		if ((e ||= "2d") !== "2d") return null;
		for (n in t) this.pdf.context2d.hasOwnProperty(n) && (this.pdf.context2d[n] = t[n]);
		return this.pdf.context2d._canvas = this, this.pdf.context2d;
	}, t.prototype.toDataURL = function() {
		throw Error("toDataURL is not implemented.");
	}, e.events.push(["initialized", function() {
		this.canvas = new t(), this.canvas.pdf = this;
	}]);
}(jb.API), function(e) {
	var t = {
		left: 0,
		top: 0,
		bottom: 0,
		right: 0
	}, n = !1, r = function() {
		this.internal.__cell__ === void 0 && (this.internal.__cell__ = {}, this.internal.__cell__.padding = 3, this.internal.__cell__.headerFunction = void 0, this.internal.__cell__.margins = Object.assign({}, t), this.internal.__cell__.margins.width = this.getPageWidth(), i.call(this));
	}, i = function() {
		this.internal.__cell__.lastCell = new a(), this.internal.__cell__.pages = 1;
	}, a = function() {
		var e = arguments[0];
		Object.defineProperty(this, "x", {
			enumerable: !0,
			get: function() {
				return e;
			},
			set: function(t) {
				e = t;
			}
		});
		var t = arguments[1];
		Object.defineProperty(this, "y", {
			enumerable: !0,
			get: function() {
				return t;
			},
			set: function(e) {
				t = e;
			}
		});
		var n = arguments[2];
		Object.defineProperty(this, "width", {
			enumerable: !0,
			get: function() {
				return n;
			},
			set: function(e) {
				n = e;
			}
		});
		var r = arguments[3];
		Object.defineProperty(this, "height", {
			enumerable: !0,
			get: function() {
				return r;
			},
			set: function(e) {
				r = e;
			}
		});
		var i = arguments[4];
		Object.defineProperty(this, "text", {
			enumerable: !0,
			get: function() {
				return i;
			},
			set: function(e) {
				i = e;
			}
		});
		var a = arguments[5];
		Object.defineProperty(this, "lineNumber", {
			enumerable: !0,
			get: function() {
				return a;
			},
			set: function(e) {
				a = e;
			}
		});
		var o = arguments[6];
		return Object.defineProperty(this, "align", {
			enumerable: !0,
			get: function() {
				return o;
			},
			set: function(e) {
				o = e;
			}
		}), this;
	};
	a.prototype.clone = function() {
		return new a(this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align);
	}, a.prototype.toArray = function() {
		return [
			this.x,
			this.y,
			this.width,
			this.height,
			this.text,
			this.lineNumber,
			this.align
		];
	}, e.setHeaderFunction = function(e) {
		return r.call(this), this.internal.__cell__.headerFunction = typeof e == "function" ? e : void 0, this;
	}, e.getTextDimensions = function(e, t) {
		r.call(this);
		var n = (t ||= {}).fontSize || this.getFontSize(), i = t.font || this.getFont(), a = t.scaleFactor || this.internal.scaleFactor, o = 0, s = 0, c = 0, l = this;
		if (!Array.isArray(e) && typeof e != "string") {
			if (typeof e != "number") throw Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");
			e = String(e);
		}
		var u = t.maxWidth;
		u > 0 ? typeof e == "string" ? e = this.splitTextToSize(e, u) : Object.prototype.toString.call(e) === "[object Array]" && (e = e.reduce(function(e, t) {
			return e.concat(l.splitTextToSize(t, u));
		}, [])) : e = Array.isArray(e) ? e : [e];
		for (var d = 0; d < e.length; d++) o < (c = this.getStringUnitWidth(e[d], { font: i }) * n) && (o = c);
		return o !== 0 && (s = e.length), {
			w: o /= a,
			h: Math.max((s * n * this.getLineHeightFactor() - n * (this.getLineHeightFactor() - 1)) / a, 0)
		};
	}, e.cellAddPage = function() {
		r.call(this), this.addPage();
		var e = this.internal.__cell__.margins || t;
		return this.internal.__cell__.lastCell = new a(e.left, e.top, void 0, void 0), this.internal.__cell__.pages += 1, this;
	};
	var o = e.cell = function() {
		var e = arguments[0] instanceof a ? arguments[0] : new a(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6]);
		r.call(this);
		var i = this.internal.__cell__.lastCell, o = this.internal.__cell__.padding, s = this.internal.__cell__.margins || t, c = this.internal.__cell__.tableHeaderRow, l = this.internal.__cell__.printHeaders;
		return i.lineNumber !== void 0 && (i.lineNumber === e.lineNumber ? (e.x = (i.x || 0) + (i.width || 0), e.y = i.y || 0) : i.y + i.height + e.height + s.bottom > this.getPageHeight() ? (this.cellAddPage(), e.y = s.top, l && c && (this.printHeaderRow(e.lineNumber, !0), e.y += c[0].height)) : e.y = i.y + i.height || e.y), e.text[0] !== void 0 && (this.rect(e.x, e.y, e.width, e.height, !0 === n ? "FD" : void 0), e.align === "right" ? this.text(e.text, e.x + e.width - o, e.y + o, {
			align: "right",
			baseline: "top"
		}) : e.align === "center" ? this.text(e.text, e.x + e.width / 2, e.y + o, {
			align: "center",
			baseline: "top",
			maxWidth: e.width - o - o
		}) : this.text(e.text, e.x + o, e.y + o, {
			align: "left",
			baseline: "top",
			maxWidth: e.width - o - o
		})), this.internal.__cell__.lastCell = e, this;
	};
	e.table = function(e, n, c, l, u) {
		if (r.call(this), !c) throw Error("No data for PDF table.");
		var d, f, p, m, h = [], g = [], _ = [], v = {}, y = {}, b = [], x = [], S = (u ||= {}).autoSize || !1, C = !1 !== u.printHeaders, w = u.css && u.css["font-size"] !== void 0 ? 16 * u.css["font-size"] : u.fontSize || 12, T = u.margins || Object.assign({ width: this.getPageWidth() }, t), E = typeof u.padding == "number" ? u.padding : 3, D = u.headerBackgroundColor || "#c8c8c8", O = u.headerTextColor || "#000";
		if (i.call(this), this.internal.__cell__.printHeaders = C, this.internal.__cell__.margins = T, this.internal.__cell__.table_font_size = w, this.internal.__cell__.padding = E, this.internal.__cell__.headerBackgroundColor = D, this.internal.__cell__.headerTextColor = O, this.setFontSize(w), l == null) g = h = Object.keys(c[0]), _ = h.map(function() {
			return "left";
		});
		else if (Array.isArray(l) && Fa(l[0]) === "object") for (h = l.map(function(e) {
			return e.name;
		}), g = l.map(function(e) {
			return e.prompt || e.name || "";
		}), _ = l.map(function(e) {
			return e.align || "left";
		}), d = 0; d < l.length; d += 1) y[l[d].name] = .7499990551181103 * l[d].width;
		else Array.isArray(l) && typeof l[0] == "string" && (g = h = l, _ = h.map(function() {
			return "left";
		}));
		if (S || Array.isArray(l) && typeof l[0] == "string") for (d = 0; d < h.length; d += 1) {
			for (v[m = h[d]] = c.map(function(e) {
				return e[m];
			}), this.setFont(void 0, "bold"), b.push(this.getTextDimensions(g[d], {
				fontSize: this.internal.__cell__.table_font_size,
				scaleFactor: this.internal.scaleFactor
			}).w), f = v[m], this.setFont(void 0, "normal"), p = 0; p < f.length; p += 1) b.push(this.getTextDimensions(f[p], {
				fontSize: this.internal.__cell__.table_font_size,
				scaleFactor: this.internal.scaleFactor
			}).w);
			y[m] = Math.max.apply(null, b) + E + E, b = [];
		}
		if (C) {
			var k = {};
			for (d = 0; d < h.length; d += 1) k[h[d]] = {}, k[h[d]].text = g[d], k[h[d]].align = _[d];
			var A = s.call(this, k, y);
			x = h.map(function(t) {
				return new a(e, n, y[t], A, k[t].text, void 0, k[t].align);
			}), this.setTableHeaderRow(x), this.printHeaderRow(1, !1);
		}
		var j = l.reduce(function(e, t) {
			return e[t.name] = t.align, e;
		}, {});
		for (d = 0; d < c.length; d += 1) {
			"rowStart" in u && u.rowStart instanceof Function && u.rowStart({
				row: d,
				data: c[d]
			}, this);
			var M = s.call(this, c[d], y);
			for (p = 0; p < h.length; p += 1) {
				var N = c[d][h[p]];
				"cellStart" in u && u.cellStart instanceof Function && u.cellStart({
					row: d,
					col: p,
					data: N
				}, this), o.call(this, new a(e, n, y[h[p]], M, N, d + 2, j[h[p]]));
			}
		}
		return this.internal.__cell__.table_x = e, this.internal.__cell__.table_y = n, this;
	};
	var s = function(e, t) {
		var n = this.internal.__cell__.padding, r = this.internal.__cell__.table_font_size, i = this.internal.scaleFactor;
		return Object.keys(e).map(function(r) {
			var i = e[r];
			return this.splitTextToSize(i.hasOwnProperty("text") ? i.text : i, t[r] - n - n);
		}, this).map(function(e) {
			return this.getLineHeightFactor() * e.length * r / i + n + n;
		}, this).reduce(function(e, t) {
			return Math.max(e, t);
		}, 0);
	};
	e.setTableHeaderRow = function(e) {
		r.call(this), this.internal.__cell__.tableHeaderRow = e;
	}, e.printHeaderRow = function(e, t) {
		if (r.call(this), !this.internal.__cell__.tableHeaderRow) throw Error("Property tableHeaderRow does not exist.");
		var i;
		if (n = !0, typeof this.internal.__cell__.headerFunction == "function") {
			var s = this.internal.__cell__.headerFunction(this, this.internal.__cell__.pages);
			this.internal.__cell__.lastCell = new a(s[0], s[1], s[2], s[3], void 0, -1);
		}
		this.setFont(void 0, "bold");
		for (var c = [], l = 0; l < this.internal.__cell__.tableHeaderRow.length; l += 1) {
			i = this.internal.__cell__.tableHeaderRow[l].clone(), t && (i.y = this.internal.__cell__.margins.top || 0, c.push(i)), i.lineNumber = e;
			var u = this.getTextColor();
			this.setTextColor(this.internal.__cell__.headerTextColor), this.setFillColor(this.internal.__cell__.headerBackgroundColor), o.call(this, i), this.setTextColor(u);
		}
		c.length > 0 && this.setTableHeaderRow(c), this.setFont(void 0, "normal"), n = !1;
	};
}(jb.API);
var bx = {
	italic: [
		"italic",
		"oblique",
		"normal"
	],
	oblique: [
		"oblique",
		"italic",
		"normal"
	],
	normal: [
		"normal",
		"oblique",
		"italic"
	]
}, xx = [
	"ultra-condensed",
	"extra-condensed",
	"condensed",
	"semi-condensed",
	"normal",
	"semi-expanded",
	"expanded",
	"extra-expanded",
	"ultra-expanded"
], Sx = yx(xx), Cx = [
	100,
	200,
	300,
	400,
	500,
	600,
	700,
	800,
	900
], wx = yx(Cx);
function Tx(e) {
	var t = e.family.replace(/"|'/g, "").toLowerCase(), n = function(e) {
		return bx[e ||= "normal"] ? e : "normal";
	}(e.style), r = function(e) {
		return e ? typeof e == "number" ? e >= 100 && e <= 900 && e % 100 == 0 ? e : 400 : /^\d00$/.test(e) ? parseInt(e) : e === "bold" ? 700 : 400 : 400;
	}(e.weight), i = function(e) {
		return typeof Sx[e ||= "normal"] == "number" ? e : "normal";
	}(e.stretch);
	return {
		family: t,
		style: n,
		weight: r,
		stretch: i,
		src: e.src || [],
		ref: e.ref || {
			name: t,
			style: [
				i,
				n,
				r
			].join(" ")
		}
	};
}
function Ex(e, t, n, r) {
	var i;
	for (i = n; i >= 0 && i < t.length; i += r) if (e[t[i]]) return e[t[i]];
	for (i = n; i >= 0 && i < t.length; i -= r) if (e[t[i]]) return e[t[i]];
}
var Dx = {
	"sans-serif": "helvetica",
	fixed: "courier",
	monospace: "courier",
	terminal: "courier",
	cursive: "times",
	fantasy: "times",
	serif: "times"
}, Ox = {
	caption: "times",
	icon: "times",
	menu: "times",
	"message-box": "times",
	"small-caption": "times",
	"status-bar": "times"
};
function kx(e) {
	return [
		e.stretch,
		e.style,
		e.weight,
		e.family
	].join(" ");
}
function Ax(e) {
	return e.trimLeft();
}
function jx(e, t) {
	for (var n = 0; n < e.length;) {
		if (e.charAt(n) === t) return [e.substring(0, n), e.substring(n + 1)];
		n += 1;
	}
	return null;
}
function Mx(e) {
	var t = e.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);
	return t === null ? null : [t[0], e.substring(t[0].length)];
}
var Nx, Px, Fx, Ix, Lx, Rx = ["times"];
function zx(e, t, n, r, i) {
	var a = 4, o = Hx;
	switch (i) {
		case jb.API.image_compression.FAST:
			a = 1, o = Vx;
			break;
		case jb.API.image_compression.MEDIUM:
			a = 6, o = Ux;
			break;
		case jb.API.image_compression.SLOW: a = 9, o = Wx;
	}
	e = function(e, t, n, r) {
		for (var i, a = e.length / t, o = new Uint8Array(e.length + a), s = [
			Bx,
			Vx,
			Hx,
			Ux,
			Wx
		], c = 0; c < a; c += 1) {
			var l = c * t, u = e.subarray(l, l + t);
			if (r) o.set(r(u, n, i), l + c);
			else {
				for (var d = s.length, f = [], p = 0; p < d; p += 1) f[p] = s[p](u, n, i);
				var m = Kx(f.concat());
				o.set(f[m], l + c);
			}
			i = u;
		}
		return o;
	}(e, t, Math.ceil(n * r / 8), o);
	var s = xo(e, { level: a });
	return jb.API.__addimage__.arrayBufferToBinaryString(s);
}
function Bx(e) {
	var t = Array.apply([], e);
	return t.unshift(0), t;
}
function Vx(e, t) {
	var n = e.length, r = [];
	r[0] = 1;
	for (var i = 0; i < n; i += 1) {
		var a = e[i - t] || 0;
		r[i + 1] = e[i] - a + 256 & 255;
	}
	return r;
}
function Hx(e, t, n) {
	var r = e.length, i = [];
	i[0] = 2;
	for (var a = 0; a < r; a += 1) {
		var o = n && n[a] || 0;
		i[a + 1] = e[a] - o + 256 & 255;
	}
	return i;
}
function Ux(e, t, n) {
	var r = e.length, i = [];
	i[0] = 3;
	for (var a = 0; a < r; a += 1) {
		var o = e[a - t] || 0, s = n && n[a] || 0;
		i[a + 1] = e[a] + 256 - (o + s >>> 1) & 255;
	}
	return i;
}
function Wx(e, t, n) {
	var r = e.length, i = [];
	i[0] = 4;
	for (var a = 0; a < r; a += 1) {
		var o = Gx(e[a - t] || 0, n && n[a] || 0, n && n[a - t] || 0);
		i[a + 1] = e[a] - o + 256 & 255;
	}
	return i;
}
function Gx(e, t, n) {
	if (e === t && t === n) return e;
	var r = Math.abs(t - n), i = Math.abs(e - n), a = Math.abs(e + t - n - n);
	return r <= i && r <= a ? e : i <= a ? t : n;
}
function Kx(e) {
	var t = e.map(function(e) {
		return e.reduce(function(e, t) {
			return e + Math.abs(t);
		}, 0);
	});
	return t.indexOf(Math.min.apply(null, t));
}
function qx(e, t, n) {
	var r = t * n, i = Math.floor(r / 8), a = 16 - (r - 8 * i + n), o = (1 << n) - 1;
	return Yx(e, i) >> a & o;
}
function Jx(e, t, n, r) {
	var i = n * r, a = Math.floor(i / 8), o = 16 - (i - 8 * a + r), s = (1 << r) - 1, c = (t & s) << o;
	(function(e, t, n) {
		if (t + 1 < e.byteLength) e.setUint16(t, n, !1);
		else {
			var r = n >> 8 & 255;
			e.setUint8(t, r);
		}
	})(e, a, Yx(e, a) & ~(s << o) & 65535 | c);
}
function Yx(e, t) {
	return t + 1 < e.byteLength ? e.getUint16(t, !1) : e.getUint8(t) << 8;
}
function Xx(e) {
	var t = 0;
	if (e[t++] !== 71 || e[t++] !== 73 || e[t++] !== 70 || e[t++] !== 56 || (e[t++] + 1 & 253) != 56 || e[t++] !== 97) throw Error("Invalid GIF 87a/89a header.");
	var n = e[t++] | e[t++] << 8, r = e[t++] | e[t++] << 8, i = e[t++], a = i >> 7, o = 1 << 1 + (7 & i);
	e[t++], e[t++];
	var s = null, c = null;
	a && (s = t, c = o, t += 3 * o);
	var l = !0, u = [], d = 0, f = null, p = 0, m = null;
	for (this.width = n, this.height = r; l && t < e.length;) switch (e[t++]) {
		case 33:
			switch (e[t++]) {
				case 255:
					if (e[t] !== 11 || e[t + 1] == 78 && e[t + 2] == 69 && e[t + 3] == 84 && e[t + 4] == 83 && e[t + 5] == 67 && e[t + 6] == 65 && e[t + 7] == 80 && e[t + 8] == 69 && e[t + 9] == 50 && e[t + 10] == 46 && e[t + 11] == 48 && e[t + 12] == 3 && e[t + 13] == 1 && e[t + 16] == 0) t += 14, m = e[t++] | e[t++] << 8, t++;
					else for (t += 12;;) {
						if (!((D = e[t++]) >= 0)) throw Error("Invalid block size");
						if (D === 0) break;
						t += D;
					}
					break;
				case 249:
					if (e[t++] !== 4 || e[t + 4] !== 0) throw Error("Invalid graphics extension block.");
					var h = e[t++];
					d = e[t++] | e[t++] << 8, f = e[t++], 1 & h || (f = null), p = h >> 2 & 7, t++;
					break;
				case 254:
					for (;;) {
						if (!((D = e[t++]) >= 0)) throw Error("Invalid block size");
						if (D === 0) break;
						t += D;
					}
					break;
				default: throw Error("Unknown graphic control label: 0x" + e[t - 1].toString(16));
			}
			break;
		case 44:
			var g = e[t++] | e[t++] << 8, _ = e[t++] | e[t++] << 8, v = e[t++] | e[t++] << 8, y = e[t++] | e[t++] << 8, b = e[t++], x = b >> 6 & 1, S = 1 << 1 + (7 & b), C = s, w = c, T = !1;
			b >> 7 && (T = !0, C = t, w = S, t += 3 * S);
			var E = t;
			for (t++;;) {
				var D;
				if (!((D = e[t++]) >= 0)) throw Error("Invalid block size");
				if (D === 0) break;
				t += D;
			}
			u.push({
				x: g,
				y: _,
				width: v,
				height: y,
				has_local_palette: T,
				palette_offset: C,
				palette_size: w,
				data_offset: E,
				data_length: t - E,
				transparent_index: f,
				interlaced: !!x,
				delay: d,
				disposal: p
			});
			break;
		case 59:
			l = !1;
			break;
		default: throw Error("Unknown gif block: 0x" + e[t - 1].toString(16));
	}
	this.numFrames = function() {
		return u.length;
	}, this.loopCount = function() {
		return m;
	}, this.frameInfo = function(e) {
		if (e < 0 || e >= u.length) throw Error("Frame index out of range.");
		return u[e];
	}, this.decodeAndBlitFrameBGRA = function(t, r) {
		var i = this.frameInfo(t), a = i.width * i.height;
		if (a > 536870912) throw Error("Image dimensions exceed 512MB, which is too large.");
		var o = new Uint8Array(a);
		Zx(e, i.data_offset, o, a);
		var s = i.palette_offset, c = i.transparent_index;
		c === null && (c = 256);
		var l = i.width, u = n - l, d = l, f = 4 * (i.y * n + i.x), p = 4 * ((i.y + i.height) * n + i.x), m = f, h = 4 * u;
		!0 === i.interlaced && (h += 4 * n * 7);
		for (var g = 8, _ = 0, v = o.length; _ < v; ++_) {
			var y = o[_];
			if (d === 0 && (d = l, (m += h) >= p && (h = 4 * u + 4 * n * (g - 1), m = f + (l + u) * (g << 1), g >>= 1)), y === c) m += 4;
			else {
				var b = e[s + 3 * y], x = e[s + 3 * y + 1], S = e[s + 3 * y + 2];
				r[m++] = S, r[m++] = x, r[m++] = b, r[m++] = 255;
			}
			--d;
		}
	}, this.decodeAndBlitFrameRGBA = function(t, r) {
		var i = this.frameInfo(t), a = i.width * i.height;
		if (a > 536870912) throw Error("Image dimensions exceed 512MB, which is too large.");
		var o = new Uint8Array(a);
		Zx(e, i.data_offset, o, a);
		var s = i.palette_offset, c = i.transparent_index;
		c === null && (c = 256);
		var l = i.width, u = n - l, d = l, f = 4 * (i.y * n + i.x), p = 4 * ((i.y + i.height) * n + i.x), m = f, h = 4 * u;
		!0 === i.interlaced && (h += 4 * n * 7);
		for (var g = 8, _ = 0, v = o.length; _ < v; ++_) {
			var y = o[_];
			if (d === 0 && (d = l, (m += h) >= p && (h = 4 * u + 4 * n * (g - 1), m = f + (l + u) * (g << 1), g >>= 1)), y === c) m += 4;
			else {
				var b = e[s + 3 * y], x = e[s + 3 * y + 1], S = e[s + 3 * y + 2];
				r[m++] = b, r[m++] = x, r[m++] = S, r[m++] = 255;
			}
			--d;
		}
	};
}
function Zx(e, t, n, r) {
	for (var i = e[t++], a = 1 << i, o = a + 1, s = o + 1, c = i + 1, l = (1 << c) - 1, u = 0, d = 0, f = 0, p = e[t++], m = /* @__PURE__ */ new Int32Array(4096), h = null;;) {
		for (; u < 16 && p !== 0;) d |= e[t++] << u, u += 8, p === 1 ? p = e[t++] : --p;
		if (u < c) break;
		var g = d & l;
		if (d >>= c, u -= c, g !== a) {
			if (g === o) break;
			for (var _ = g < s ? g : h, v = 0, y = _; y > a;) y = m[y] >> 8, ++v;
			var b = y;
			if (f + v + (_ === g ? 0 : 1) > r) return void eb.log("Warning, gif stream longer than expected.");
			n[f++] = b;
			var x = f += v;
			for (_ !== g && (n[f++] = b), y = _; v--;) y = m[y], n[--x] = 255 & y, y >>= 8;
			h !== null && s < 4096 && (m[s++] = h << 8 | b, s >= l + 1 && c < 12 && (++c, l = l << 1 | 1)), h = g;
		} else s = o + 1, l = (1 << (c = i + 1)) - 1, h = null;
	}
	return f !== r && eb.log("Warning, gif stream shorter than expected."), n;
}
function Qx(e) {
	var t, n, r, i, a, o = Math.floor, s = Array(64), c = Array(64), l = Array(64), u = Array(64), d = Array(65535), f = Array(65535), p = Array(64), m = Array(64), h = [], g = 0, _ = 7, v = Array(64), y = Array(64), b = Array(64), x = Array(256), S = Array(2048), C = [
		0,
		1,
		5,
		6,
		14,
		15,
		27,
		28,
		2,
		4,
		7,
		13,
		16,
		26,
		29,
		42,
		3,
		8,
		12,
		17,
		25,
		30,
		41,
		43,
		9,
		11,
		18,
		24,
		31,
		40,
		44,
		53,
		10,
		19,
		23,
		32,
		39,
		45,
		52,
		54,
		20,
		22,
		33,
		38,
		46,
		51,
		55,
		60,
		21,
		34,
		37,
		47,
		50,
		56,
		59,
		61,
		35,
		36,
		48,
		49,
		57,
		58,
		62,
		63
	], w = [
		0,
		0,
		1,
		5,
		1,
		1,
		1,
		1,
		1,
		1,
		0,
		0,
		0,
		0,
		0,
		0,
		0
	], T = [
		0,
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		10,
		11
	], E = [
		0,
		0,
		2,
		1,
		3,
		3,
		2,
		4,
		3,
		5,
		5,
		4,
		4,
		0,
		0,
		1,
		125
	], D = [
		1,
		2,
		3,
		0,
		4,
		17,
		5,
		18,
		33,
		49,
		65,
		6,
		19,
		81,
		97,
		7,
		34,
		113,
		20,
		50,
		129,
		145,
		161,
		8,
		35,
		66,
		177,
		193,
		21,
		82,
		209,
		240,
		36,
		51,
		98,
		114,
		130,
		9,
		10,
		22,
		23,
		24,
		25,
		26,
		37,
		38,
		39,
		40,
		41,
		42,
		52,
		53,
		54,
		55,
		56,
		57,
		58,
		67,
		68,
		69,
		70,
		71,
		72,
		73,
		74,
		83,
		84,
		85,
		86,
		87,
		88,
		89,
		90,
		99,
		100,
		101,
		102,
		103,
		104,
		105,
		106,
		115,
		116,
		117,
		118,
		119,
		120,
		121,
		122,
		131,
		132,
		133,
		134,
		135,
		136,
		137,
		138,
		146,
		147,
		148,
		149,
		150,
		151,
		152,
		153,
		154,
		162,
		163,
		164,
		165,
		166,
		167,
		168,
		169,
		170,
		178,
		179,
		180,
		181,
		182,
		183,
		184,
		185,
		186,
		194,
		195,
		196,
		197,
		198,
		199,
		200,
		201,
		202,
		210,
		211,
		212,
		213,
		214,
		215,
		216,
		217,
		218,
		225,
		226,
		227,
		228,
		229,
		230,
		231,
		232,
		233,
		234,
		241,
		242,
		243,
		244,
		245,
		246,
		247,
		248,
		249,
		250
	], O = [
		0,
		0,
		3,
		1,
		1,
		1,
		1,
		1,
		1,
		1,
		1,
		1,
		0,
		0,
		0,
		0,
		0
	], k = [
		0,
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		10,
		11
	], A = [
		0,
		0,
		2,
		1,
		2,
		4,
		4,
		3,
		4,
		7,
		5,
		4,
		4,
		0,
		1,
		2,
		119
	], j = [
		0,
		1,
		2,
		3,
		17,
		4,
		5,
		33,
		49,
		6,
		18,
		65,
		81,
		7,
		97,
		113,
		19,
		34,
		50,
		129,
		8,
		20,
		66,
		145,
		161,
		177,
		193,
		9,
		35,
		51,
		82,
		240,
		21,
		98,
		114,
		209,
		10,
		22,
		36,
		52,
		225,
		37,
		241,
		23,
		24,
		25,
		26,
		38,
		39,
		40,
		41,
		42,
		53,
		54,
		55,
		56,
		57,
		58,
		67,
		68,
		69,
		70,
		71,
		72,
		73,
		74,
		83,
		84,
		85,
		86,
		87,
		88,
		89,
		90,
		99,
		100,
		101,
		102,
		103,
		104,
		105,
		106,
		115,
		116,
		117,
		118,
		119,
		120,
		121,
		122,
		130,
		131,
		132,
		133,
		134,
		135,
		136,
		137,
		138,
		146,
		147,
		148,
		149,
		150,
		151,
		152,
		153,
		154,
		162,
		163,
		164,
		165,
		166,
		167,
		168,
		169,
		170,
		178,
		179,
		180,
		181,
		182,
		183,
		184,
		185,
		186,
		194,
		195,
		196,
		197,
		198,
		199,
		200,
		201,
		202,
		210,
		211,
		212,
		213,
		214,
		215,
		216,
		217,
		218,
		226,
		227,
		228,
		229,
		230,
		231,
		232,
		233,
		234,
		242,
		243,
		244,
		245,
		246,
		247,
		248,
		249,
		250
	];
	function M(e, t) {
		for (var n = 0, r = 0, i = [], a = 1; a <= 16; a++) {
			for (var o = 1; o <= e[a]; o++) i[t[r]] = [], i[t[r]][0] = n, i[t[r]][1] = a, r++, n++;
			n *= 2;
		}
		return i;
	}
	function N(e) {
		for (var t = e[0], n = e[1] - 1; n >= 0;) t & 1 << n && (g |= 1 << _), n--, --_ < 0 && (g == 255 ? (P(255), P(0)) : P(g), _ = 7, g = 0);
	}
	function P(e) {
		h.push(e);
	}
	function F(e) {
		P(e >> 8 & 255), P(255 & e);
	}
	function I(e, t, n, r, i) {
		for (var a, o = i[0], s = i[240], c = function(e, t) {
			var n, r, i, a, o, s, c, l, u, d, f = 0;
			for (u = 0; u < 8; ++u) {
				n = e[f], r = e[f + 1], i = e[f + 2], a = e[f + 3], o = e[f + 4], s = e[f + 5], c = e[f + 6];
				var m = n + (l = e[f + 7]), h = n - l, g = r + c, _ = r - c, v = i + s, y = i - s, b = a + o, x = a - o, S = m + b, C = m - b, w = g + v, T = g - v;
				e[f] = S + w, e[f + 4] = S - w;
				var E = .707106781 * (T + C);
				e[f + 2] = C + E, e[f + 6] = C - E;
				var D = .382683433 * ((S = x + y) - (T = _ + h)), O = .5411961 * S + D, k = 1.306562965 * T + D, A = .707106781 * (w = y + _), j = h + A, M = h - A;
				e[f + 5] = M + O, e[f + 3] = M - O, e[f + 1] = j + k, e[f + 7] = j - k, f += 8;
			}
			for (f = 0, u = 0; u < 8; ++u) {
				n = e[f], r = e[f + 8], i = e[f + 16], a = e[f + 24], o = e[f + 32], s = e[f + 40], c = e[f + 48];
				var N = n + (l = e[f + 56]), P = n - l, F = r + c, I = r - c, ee = i + s, L = i - s, R = a + o, te = a - o, z = N + R, ne = N - R, re = F + ee, ie = F - ee;
				e[f] = z + re, e[f + 32] = z - re;
				var ae = .707106781 * (ie + ne);
				e[f + 16] = ne + ae, e[f + 48] = ne - ae;
				var B = .382683433 * ((z = te + L) - (ie = I + P)), oe = .5411961 * z + B, se = 1.306562965 * ie + B, ce = .707106781 * (re = L + I), le = P + ce, V = P - ce;
				e[f + 40] = V + oe, e[f + 24] = V - oe, e[f + 8] = le + se, e[f + 56] = le - se, f++;
			}
			for (u = 0; u < 64; ++u) d = e[u] * t[u], p[u] = d > 0 ? d + .5 | 0 : d - .5 | 0;
			return p;
		}(e, t), l = 0; l < 64; ++l) m[C[l]] = c[l];
		var u = m[0] - n;
		n = m[0], u == 0 ? N(r[0]) : (N(r[f[a = 32767 + u]]), N(d[a]));
		for (var h = 63; h > 0 && m[h] == 0;) h--;
		if (h == 0) return N(o), n;
		for (var g, _ = 1; _ <= h;) {
			for (var v = _; m[_] == 0 && _ <= h;) ++_;
			var y = _ - v;
			if (y >= 16) {
				g = y >> 4;
				for (var b = 1; b <= g; ++b) N(s);
				y &= 15;
			}
			a = 32767 + m[_], N(i[(y << 4) + f[a]]), N(d[a]), _++;
		}
		return h != 63 && N(o), n;
	}
	function ee(e) {
		e = Math.min(Math.max(e, 1), 100), a != e && (function(e) {
			for (var t = [
				16,
				11,
				10,
				16,
				24,
				40,
				51,
				61,
				12,
				12,
				14,
				19,
				26,
				58,
				60,
				55,
				14,
				13,
				16,
				24,
				40,
				57,
				69,
				56,
				14,
				17,
				22,
				29,
				51,
				87,
				80,
				62,
				18,
				22,
				37,
				56,
				68,
				109,
				103,
				77,
				24,
				35,
				55,
				64,
				81,
				104,
				113,
				92,
				49,
				64,
				78,
				87,
				103,
				121,
				120,
				101,
				72,
				92,
				95,
				98,
				112,
				100,
				103,
				99
			], n = 0; n < 64; n++) {
				var r = o((t[n] * e + 50) / 100);
				r = Math.min(Math.max(r, 1), 255), s[C[n]] = r;
			}
			for (var i = [
				17,
				18,
				24,
				47,
				99,
				99,
				99,
				99,
				18,
				21,
				26,
				66,
				99,
				99,
				99,
				99,
				24,
				26,
				56,
				99,
				99,
				99,
				99,
				99,
				47,
				66,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99,
				99
			], a = 0; a < 64; a++) {
				var d = o((i[a] * e + 50) / 100);
				d = Math.min(Math.max(d, 1), 255), c[C[a]] = d;
			}
			for (var f = [
				1,
				1.387039845,
				1.306562965,
				1.175875602,
				1,
				.785694958,
				.5411961,
				.275899379
			], p = 0, m = 0; m < 8; m++) for (var h = 0; h < 8; h++) l[p] = 1 / (s[C[p]] * f[m] * f[h] * 8), u[p] = 1 / (c[C[p]] * f[m] * f[h] * 8), p++;
		}(Math.floor(e < 50 ? 5e3 / e : 200 - 2 * e)), a = e);
	}
	this.encode = function(e, a) {
		a && ee(a), h = [], g = 0, _ = 7, F(65496), F(65504), F(16), P(74), P(70), P(73), P(70), P(0), P(1), P(1), P(0), F(1), F(1), P(0), P(0), function() {
			F(65499), F(132), P(0);
			for (var e = 0; e < 64; e++) P(s[e]);
			P(1);
			for (var t = 0; t < 64; t++) P(c[t]);
		}(), function(e, t) {
			F(65472), F(17), P(8), F(t), F(e), P(3), P(1), P(17), P(0), P(2), P(17), P(1), P(3), P(17), P(1);
		}(e.width, e.height), function() {
			F(65476), F(418), P(0);
			for (var e = 0; e < 16; e++) P(w[e + 1]);
			for (var t = 0; t <= 11; t++) P(T[t]);
			P(16);
			for (var n = 0; n < 16; n++) P(E[n + 1]);
			for (var r = 0; r <= 161; r++) P(D[r]);
			P(1);
			for (var i = 0; i < 16; i++) P(O[i + 1]);
			for (var a = 0; a <= 11; a++) P(k[a]);
			P(17);
			for (var o = 0; o < 16; o++) P(A[o + 1]);
			for (var s = 0; s <= 161; s++) P(j[s]);
		}(), F(65498), F(12), P(3), P(1), P(0), P(2), P(17), P(3), P(17), P(0), P(63), P(0);
		var o = 0, d = 0, f = 0;
		g = 0, _ = 7, this.encode.displayName = "_encode_";
		for (var p, m, x, C, M, L, R, te, z, ne = e.data, re = e.width, ie = e.height, ae = 4 * re, B = 0; B < ie;) {
			for (p = 0; p < ae;) {
				for (M = ae * B + p, R = -1, te = 0, z = 0; z < 64; z++) L = M + (te = z >> 3) * ae + (R = 4 * (7 & z)), B + te >= ie && (L -= ae * (B + 1 + te - ie)), p + R >= ae && (L -= p + R - ae + 4), m = ne[L++], x = ne[L++], C = ne[L++], v[z] = (S[m] + S[x + 256 | 0] + S[C + 512 | 0] >> 16) - 128, y[z] = (S[m + 768 | 0] + S[x + 1024 | 0] + S[C + 1280 | 0] >> 16) - 128, b[z] = (S[m + 1280 | 0] + S[x + 1536 | 0] + S[C + 1792 | 0] >> 16) - 128;
				o = I(v, l, o, t, r), d = I(y, u, d, n, i), f = I(b, u, f, n, i), p += 32;
			}
			B += 8;
		}
		if (_ >= 0) {
			var oe = [];
			oe[1] = _ + 1, oe[0] = (1 << _ + 1) - 1, N(oe);
		}
		return F(65497), new Uint8Array(h);
	}, e ||= 50, function() {
		for (var e = String.fromCharCode, t = 0; t < 256; t++) x[t] = e(t);
	}(), t = M(w, T), n = M(O, k), r = M(E, D), i = M(A, j), function() {
		for (var e = 1, t = 2, n = 1; n <= 15; n++) {
			for (var r = e; r < t; r++) f[32767 + r] = n, d[32767 + r] = [], d[32767 + r][1] = n, d[32767 + r][0] = r;
			for (var i = -(t - 1); i <= -e; i++) f[32767 + i] = n, d[32767 + i] = [], d[32767 + i][1] = n, d[32767 + i][0] = t - 1 + i;
			e <<= 1, t <<= 1;
		}
	}(), function() {
		for (var e = 0; e < 256; e++) S[e] = 19595 * e, S[e + 256 | 0] = 38470 * e, S[e + 512 | 0] = 7471 * e + 32768, S[e + 768 | 0] = -11059 * e, S[e + 1024 | 0] = -21709 * e, S[e + 1280 | 0] = 32768 * e + 8421375, S[e + 1536 | 0] = -27439 * e, S[e + 1792 | 0] = -5329 * e;
	}(), ee(e);
}
function $x(e, t) {
	if (this.pos = 0, this.buffer = e, this.datav = new DataView(e.buffer), this.is_with_alpha = !!t, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, [
		"BM",
		"BA",
		"CI",
		"CP",
		"IC",
		"PT"
	].indexOf(this.flag) === -1) throw Error("Invalid BMP File");
	this.parseHeader(), this.parseBGR();
}
function eS(e) {
	function t(e) {
		if (!e) throw Error("assert :P");
	}
	function n(e, t, n) {
		for (var r = 0; 4 > r; r++) if (e[t + r] != n.charCodeAt(r)) return !0;
		return !1;
	}
	function r(e, t, n, r, i) {
		for (var a = 0; a < i; a++) e[t + a] = n[r + a];
	}
	function i(e, t, n, r) {
		for (var i = 0; i < r; i++) e[t + i] = n;
	}
	function a(e) {
		return new Int32Array(e);
	}
	function o(e, t) {
		for (var n = [], r = 0; r < e; r++) n.push(new t());
		return n;
	}
	function s(e, t) {
		var n = [];
		return function e(n, r, i) {
			for (var a = i[r], o = 0; o < a && (n.push(i.length > r + 1 ? [] : new t()), !(i.length < r + 1)); o++) e(n[o], r + 1, i);
		}(n, 0, e), n;
	}
	var c = function() {
		var e = this;
		function c(e, t) {
			for (var n = 1 << t - 1 >>> 0; e & n;) n >>>= 1;
			return n ? (e & n - 1) + n : e;
		}
		function l(e, n, r, i, a) {
			t(!(i % r));
			do
				e[n + (i -= r)] = a;
			while (0 < i);
		}
		function u(e, n, r, i, o) {
			if (t(2328 >= o), 512 >= o) var s = a(512);
			else if ((s = a(o)) == null) return 0;
			return function(e, n, r, i, o, s) {
				var u, f, p = n, m = 1 << r, h = a(16), g = a(16);
				for (t(o != 0), t(i != null), t(e != null), t(0 < r), f = 0; f < o; ++f) {
					if (15 < i[f]) return 0;
					++h[i[f]];
				}
				if (h[0] == o) return 0;
				for (g[1] = 0, u = 1; 15 > u; ++u) {
					if (h[u] > 1 << u) return 0;
					g[u + 1] = g[u] + h[u];
				}
				for (f = 0; f < o; ++f) u = i[f], 0 < i[f] && (s[g[u]++] = f);
				if (g[15] == 1) return (i = new d()).g = 0, i.value = s[0], l(e, p, 1, m, i), m;
				var _, v = -1, y = m - 1, b = 0, x = 1, S = 1, C = 1 << r;
				for (f = 0, u = 1, o = 2; u <= r; ++u, o <<= 1) {
					if (x += S <<= 1, 0 > (S -= h[u])) return 0;
					for (; 0 < h[u]; --h[u]) (i = new d()).g = u, i.value = s[f++], l(e, p + b, o, C, i), b = c(b, u);
				}
				for (u = r + 1, o = 2; 15 >= u; ++u, o <<= 1) {
					if (x += S <<= 1, 0 > (S -= h[u])) return 0;
					for (; 0 < h[u]; --h[u]) {
						if (i = new d(), (b & y) != v) {
							for (p += C, _ = 1 << (v = u) - r; 15 > v && !(0 >= (_ -= h[v]));) ++v, _ <<= 1;
							m += C = 1 << (_ = v - r), e[n + (v = b & y)].g = _ + r, e[n + v].value = p - n - v;
						}
						i.g = u - r, i.value = s[f++], l(e, p + (b >> r), o, C, i), b = c(b, u);
					}
				}
				return x == 2 * g[15] - 1 ? m : 0;
			}(e, n, r, i, o, s);
		}
		function d() {
			this.value = this.g = 0;
		}
		function f() {
			this.value = this.g = 0;
		}
		function p() {
			this.G = o(5, d), this.H = a(5), this.jc = this.Qb = this.qb = this.nd = 0, this.pd = o(qn, f);
		}
		function m(e, n, r, i) {
			t(e != null), t(n != null), t(2147483648 > i), e.Ca = 254, e.I = 0, e.b = -8, e.Ka = 0, e.oa = n, e.pa = r, e.Jd = n, e.Yc = r + i, e.Zc = 4 <= i ? r + i - 4 + 1 : r, E(e);
		}
		function h(e, t) {
			for (var n = 0; 0 < t--;) n |= O(e, 128) << t;
			return n;
		}
		function g(e, t) {
			var n = h(e, t);
			return D(e) ? -n : n;
		}
		function _(e, n, r, i) {
			var a, o = 0;
			for (t(e != null), t(n != null), t(4294967288 > i), e.Sb = i, e.Ra = 0, e.u = 0, e.h = 0, 4 < i && (i = 4), a = 0; a < i; ++a) o += n[r + a] << 8 * a;
			e.Ra = o, e.bb = i, e.oa = n, e.pa = r;
		}
		function v(e) {
			for (; 8 <= e.u && e.bb < e.Sb;) e.Ra >>>= 8, e.Ra += e.oa[e.pa + e.bb] << Xn - 8 >>> 0, ++e.bb, e.u -= 8;
			C(e) && (e.h = 1, e.u = 0);
		}
		function y(e, n) {
			if (t(0 <= n), !e.h && n <= Yn) {
				var r = S(e) & Jn[n];
				return e.u += n, v(e), r;
			}
			return e.h = 1, e.u = 0;
		}
		function b() {
			this.b = this.Ca = this.I = 0, this.oa = [], this.pa = 0, this.Jd = [], this.Yc = 0, this.Zc = [], this.Ka = 0;
		}
		function x() {
			this.Ra = 0, this.oa = [], this.h = this.u = this.bb = this.Sb = this.pa = 0;
		}
		function S(e) {
			return e.Ra >>> (e.u & Xn - 1) >>> 0;
		}
		function C(e) {
			return t(e.bb <= e.Sb), e.h || e.bb == e.Sb && e.u > Xn;
		}
		function w(e, t) {
			e.u = t, e.h = C(e);
		}
		function T(e) {
			e.u >= Zn && (t(e.u >= Zn), v(e));
		}
		function E(e) {
			t(e != null && e.oa != null), e.pa < e.Zc ? (e.I = (e.oa[e.pa++] | e.I << 8) >>> 0, e.b += 8) : (t(e != null && e.oa != null), e.pa < e.Yc ? (e.b += 8, e.I = e.oa[e.pa++] | e.I << 8) : e.Ka ? e.b = 0 : (e.I <<= 8, e.b += 8, e.Ka = 1));
		}
		function D(e) {
			return h(e, 1);
		}
		function O(e, t) {
			var n = e.Ca;
			0 > e.b && E(e);
			var r = e.b, i = n * t >>> 8, a = (e.I >>> r > i) + 0;
			for (a ? (n -= i, e.I -= i + 1 << r >>> 0) : n = i + 1, r = n, i = 0; 256 <= r;) i += 8, r >>= 8;
			return r = 7 ^ i + Qn[r], e.b -= r, e.Ca = (n << r) - 1, a;
		}
		function k(e, t, n) {
			e[t + 0] = n >> 24 & 255, e[t + 1] = n >> 16 & 255, e[t + 2] = n >> 8 & 255, e[t + 3] = 255 & n;
		}
		function A(e, t) {
			return e[t + 0] | e[t + 1] << 8;
		}
		function j(e, t) {
			return A(e, t) | e[t + 2] << 16;
		}
		function M(e, t) {
			return A(e, t) | A(e, t + 2) << 16;
		}
		function N(e, n) {
			var r = 1 << n;
			return t(e != null), t(0 < n), e.X = a(r), e.X == null ? 0 : (e.Mb = 32 - n, e.Xa = n, 1);
		}
		function P(e, n) {
			t(e != null), t(n != null), t(e.Xa == n.Xa), r(n.X, 0, e.X, 0, 1 << n.Xa);
		}
		function F() {
			this.X = [], this.Xa = this.Mb = 0;
		}
		function I(e, n, r, i) {
			t(r != null), t(i != null);
			var a = r[0], o = i[0];
			return a == 0 && (a = (e * o + n / 2) / n), o == 0 && (o = (n * a + e / 2) / e), 0 >= a || 0 >= o ? 0 : (r[0] = a, i[0] = o, 1);
		}
		function ee(e, t) {
			return e + (1 << t) - 1 >>> t;
		}
		function L(e, t) {
			return ((4278255360 & e) + (4278255360 & t) >>> 0 & 4278255360) + ((16711935 & e) + (16711935 & t) >>> 0 & 16711935) >>> 0;
		}
		function R(t, n) {
			e[n] = function(n, r, i, a, o, s, c) {
				var l;
				for (l = 0; l < o; ++l) {
					var u = e[t](s[c + l - 1], i, a + l);
					s[c + l] = L(n[r + l], u);
				}
			};
		}
		function te() {
			this.ud = this.hd = this.jd = 0;
		}
		function z(e, t) {
			return ((4278124286 & (e ^ t)) >>> 1) + (e & t) >>> 0;
		}
		function ne(e) {
			return 0 <= e && 256 > e ? e : 0 > e ? 0 : 255 < e ? 255 : void 0;
		}
		function re(e, t) {
			return ne(e + (e - t + .5 >> 1));
		}
		function ie(e, t, n) {
			return Math.abs(t - n) - Math.abs(e - n);
		}
		function ae(e, t, n, r, i, a, o) {
			for (r = a[o - 1], n = 0; n < i; ++n) a[o + n] = r = L(e[t + n], r);
		}
		function B(e, t, n, r, i) {
			var a;
			for (a = 0; a < n; ++a) {
				var o = e[t + a], s = o >> 8 & 255, c = 16711935 & (c = (c = 16711935 & o) + ((s << 16) + s));
				r[i + a] = (4278255360 & o) + c >>> 0;
			}
		}
		function oe(e, t) {
			t.jd = 255 & e, t.hd = e >> 8 & 255, t.ud = e >> 16 & 255;
		}
		function se(e, t, n, r, i, a) {
			var o;
			for (o = 0; o < r; ++o) {
				var s = t[n + o], c = s >>> 8, l = s, u = 255 & (u = (u = s >>> 16) + ((e.jd << 24 >> 24) * (c << 24 >> 24) >>> 5));
				l = 255 & (l = (l += (e.hd << 24 >> 24) * (c << 24 >> 24) >>> 5) + ((e.ud << 24 >> 24) * (u << 24 >> 24) >>> 5)), i[a + o] = (4278255360 & s) + (u << 16) + l;
			}
		}
		function ce(t, n, r, i, a) {
			e[n] = function(e, t, n, r, o, s, c, l, u) {
				for (r = c; r < l; ++r) for (c = 0; c < u; ++c) o[s++] = a(n[i(e[t++])]);
			}, e[t] = function(t, n, o, s, c, l, u) {
				var d = 8 >> t.b, f = t.Ea, p = t.K[0], m = t.w;
				if (8 > d) for (t = (1 << t.b) - 1, m = (1 << d) - 1; n < o; ++n) {
					var h, g = 0;
					for (h = 0; h < f; ++h) h & t || (g = i(s[c++])), l[u++] = a(p[g & m]), g >>= d;
				}
				else e["VP8LMapColor" + r](s, c, p, m, l, u, n, o, f);
			};
		}
		function le(e, t, n, r, i) {
			for (n = t + n; t < n;) {
				var a = e[t++];
				r[i++] = a >> 16 & 255, r[i++] = a >> 8 & 255, r[i++] = 255 & a;
			}
		}
		function V(e, t, n, r, i) {
			for (n = t + n; t < n;) {
				var a = e[t++];
				r[i++] = a >> 16 & 255, r[i++] = a >> 8 & 255, r[i++] = 255 & a, r[i++] = a >> 24 & 255;
			}
		}
		function ue(e, t, n, r, i) {
			for (n = t + n; t < n;) {
				var a = (o = e[t++]) >> 16 & 240 | o >> 12 & 15, o = 240 & o | o >> 28 & 15;
				r[i++] = a, r[i++] = o;
			}
		}
		function de(e, t, n, r, i) {
			for (n = t + n; t < n;) {
				var a = (o = e[t++]) >> 16 & 248 | o >> 13 & 7, o = o >> 5 & 224 | o >> 3 & 31;
				r[i++] = a, r[i++] = o;
			}
		}
		function fe(e, t, n, r, i) {
			for (n = t + n; t < n;) {
				var a = e[t++];
				r[i++] = 255 & a, r[i++] = a >> 8 & 255, r[i++] = a >> 16 & 255;
			}
		}
		function pe(e, t, n, i, a, o) {
			if (o == 0) for (n = t + n; t < n;) k(i, ((o = e[t++])[0] >> 24 | o[1] >> 8 & 65280 | o[2] << 8 & 16711680 | o[3] << 24) >>> 0), a += 32;
			else r(i, a, e, t, n);
		}
		function me(t, n) {
			e[n][0] = e[t + "0"], e[n][1] = e[t + "1"], e[n][2] = e[t + "2"], e[n][3] = e[t + "3"], e[n][4] = e[t + "4"], e[n][5] = e[t + "5"], e[n][6] = e[t + "6"], e[n][7] = e[t + "7"], e[n][8] = e[t + "8"], e[n][9] = e[t + "9"], e[n][10] = e[t + "10"], e[n][11] = e[t + "11"], e[n][12] = e[t + "12"], e[n][13] = e[t + "13"], e[n][14] = e[t + "0"], e[n][15] = e[t + "0"];
		}
		function he(e) {
			return e == Xr || e == Zr || e == K || e == Qr;
		}
		function ge() {
			this.eb = [], this.size = this.A = this.fb = 0;
		}
		function _e() {
			this.y = [], this.f = [], this.ea = [], this.F = [], this.Tc = this.Ed = this.Cd = this.Fd = this.lb = this.Db = this.Ab = this.fa = this.J = this.W = this.N = this.O = 0;
		}
		function ve() {
			this.Rd = this.height = this.width = this.S = 0, this.f = {}, this.f.RGBA = new ge(), this.f.kb = new _e(), this.sd = null;
		}
		function ye() {
			this.width = [0], this.height = [0], this.Pd = [0], this.Qd = [0], this.format = [0];
		}
		function be() {
			this.Id = this.fd = this.Md = this.hb = this.ib = this.da = this.bd = this.cd = this.j = this.v = this.Da = this.Sd = this.ob = 0;
		}
		function xe(e) {
			return alert("todo:WebPSamplerProcessPlane"), e.T;
		}
		function Se(e, t) {
			var n = e.T, i = t.ba.f.RGBA, a = i.eb, o = i.fb + e.ka * i.A, s = Ci[t.ba.S], c = e.y, l = e.O, u = e.f, d = e.N, f = e.ea, p = e.W, m = t.cc, h = t.dc, g = t.Mc, _ = t.Nc, v = e.ka, y = e.ka + e.T, b = e.U, x = b + 1 >> 1;
			for (v == 0 ? s(c, l, null, null, u, d, f, p, u, d, f, p, a, o, null, null, b) : (s(t.ec, t.fc, c, l, m, h, g, _, u, d, f, p, a, o - i.A, a, o, b), ++n); v + 2 < y; v += 2) m = u, h = d, g = f, _ = p, d += e.Rc, p += e.Rc, o += 2 * i.A, s(c, (l += 2 * e.fa) - e.fa, c, l, m, h, g, _, u, d, f, p, a, o - i.A, a, o, b);
			return l += e.fa, e.j + y < e.o ? (r(t.ec, t.fc, c, l, b), r(t.cc, t.dc, u, d, x), r(t.Mc, t.Nc, f, p, x), n--) : 1 & y || s(c, l, null, null, u, d, f, p, u, d, f, p, a, o + i.A, null, null, b), n;
		}
		function Ce(e, n, r) {
			var i = e.F, a = [e.J];
			if (i != null) {
				var o = e.U, s = n.ba.S, c = s == qr || s == K;
				n = n.ba.f.RGBA;
				var l = [0], u = e.ka;
				l[0] = e.T, e.Kb && (u == 0 ? --l[0] : (--u, a[0] -= e.width), e.j + e.ka + e.T == e.o && (l[0] = e.o - e.j - u));
				var d = n.eb;
				u = n.fb + u * n.A, e = Nr(i, a[0], e.width, o, l, d, u + (c ? 0 : 3), n.A), t(r == l), e && he(s) && jr(d, u, c, o, l, n.A);
			}
			return 0;
		}
		function we(e) {
			var t = e.ma, n = t.ba.S, r = 11 > n, i = n == Wr || n == Kr || n == qr || n == Jr || n == 12 || he(n);
			if (t.memory = null, t.Ib = null, t.Jb = null, t.Nd = null, !Wn(t.Oa, e, i ? 11 : 12)) return 0;
			if (i && he(n) && Dn(), e.da) alert("todo:use_scaling");
			else {
				if (r) {
					if (t.Ib = xe, e.Kb) {
						if (n = e.U + 1 >> 1, t.memory = a(e.U + 2 * n), t.memory == null) return 0;
						t.ec = t.memory, t.fc = 0, t.cc = t.ec, t.dc = t.fc + e.U, t.Mc = t.cc, t.Nc = t.dc + n, t.Ib = Se, Dn();
					}
				} else alert("todo:EmitYUV");
				i && (t.Jb = Ce, r && Tn());
			}
			if (r && !Li) {
				for (e = 0; 256 > e; ++e) Ri[e] = 89858 * (e - 128) + Mi >> ji, Vi[e] = -22014 * (e - 128) + Mi, Bi[e] = -45773 * (e - 128), zi[e] = 113618 * (e - 128) + Mi >> ji;
				for (e = Ni; e < Pi; ++e) t = 76283 * (e - 16) + Mi >> ji, Hi[e - Ni] = nt(t, 255), Ui[e - Ni] = nt(t + 8 >> 4, 15);
				Li = 1;
			}
			return 1;
		}
		function Te(e) {
			var n = e.ma, r = e.U, i = e.T;
			return t(!(1 & e.ka)), 0 >= r || 0 >= i ? 0 : (r = n.Ib(e, n), n.Jb != null && n.Jb(e, n, r), n.Dc += r, 1);
		}
		function Ee(e) {
			e.ma.memory = null;
		}
		function De(e, t, n, r) {
			return y(e, 8) == 47 ? (t[0] = y(e, 14) + 1, n[0] = y(e, 14) + 1, r[0] = y(e, 1), y(e, 3) == 0 ? !e.h : 0) : 0;
		}
		function H(e, t) {
			if (4 > e) return e + 1;
			var n = e - 2 >> 1;
			return (2 + (1 & e) << n) + y(t, n) + 1;
		}
		function Oe(e, t) {
			return 120 < t ? t - 120 : 1 <= (n = ((n = ii[t - 1]) >> 4) * e + (8 - (15 & n))) ? n : 1;
			var n;
		}
		function ke(e, t, n) {
			var r = S(n), i = e[t += 255 & r].g - 8;
			return 0 < i && (w(n, n.u + 8), r = S(n), t += e[t].value, t += r & (1 << i) - 1), w(n, n.u + e[t].g), e[t].value;
		}
		function Ae(e, n, r) {
			return r.g += e.g, r.value += e.value << n >>> 0, t(8 >= r.g), e.g;
		}
		function je(e, n, r) {
			var i = e.xc;
			return t((n = i == 0 ? 0 : e.vc[e.md * (r >> i) + (n >> i)]) < e.Wb), e.Ya[n];
		}
		function Me(e, n, i, a) {
			var o = e.ab, s = e.c * n, c = e.C;
			n = c + n;
			var l = i, u = a;
			for (a = e.Ta, i = e.Ua; 0 < o--;) {
				var d = e.gc[o], f = c, p = n, m = l, h = u, g = (u = a, l = i, d.Ea);
				switch (t(f < p), t(p <= d.nc), d.hc) {
					case 2:
						tr(m, h, (p - f) * g, u, l);
						break;
					case 0:
						var _ = f, v = p, y = u, b = l, x = (E = d).Ea;
						_ == 0 && ($n(m, h, null, null, 1, y, b), ae(m, h + 1, 0, 0, x - 1, y, b + 1), h += x, b += x, ++_);
						for (var S = 1 << E.b, C = S - 1, w = ee(x, E.b), T = E.K, E = E.w + (_ >> E.b) * w; _ < v;) {
							var D = T, O = E, k = 1;
							for (er(m, h, y, b - x, 1, y, b); k < x;) {
								var A = (k & ~C) + S;
								A > x && (A = x), (0, or[D[O++] >> 8 & 15])(m, h + +k, y, b + k - x, A - k, y, b + k), k = A;
							}
							h += x, b += x, ++_ & C || (E += w);
						}
						p != d.nc && r(u, l - g, u, l + (p - f - 1) * g, g);
						break;
					case 1:
						for (g = m, v = h, x = (m = d.Ea) - (b = m & ~(y = (h = 1 << d.b) - 1)), _ = ee(m, d.b), S = d.K, d = d.w + (f >> d.b) * _; f < p;) {
							for (C = S, w = d, T = new te(), E = v + b, D = v + m; v < E;) oe(C[w++], T), sr(T, g, v, h, u, l), v += h, l += h;
							v < D && (oe(C[w++], T), sr(T, g, v, x, u, l), v += x, l += x), ++f & y || (d += _);
						}
						break;
					case 3: if (m == u && h == l && 0 < d.b) {
						for (v = u, m = g = l + (p - f) * g - (b = (p - f) * ee(d.Ea, d.b)), h = u, y = l, _ = [], b = (x = b) - 1; 0 <= b; --b) _[b] = h[y + b];
						for (b = x - 1; 0 <= b; --b) v[m + b] = _[b];
						nr(d, f, p, u, g, u, l);
					} else nr(d, f, p, m, h, u, l);
				}
				l = a, u = i;
			}
			u != i && r(a, i, l, u, s);
		}
		function Ne(e, n) {
			var r = e.V, i = e.Ba + e.c * e.C, a = n - e.C;
			if (t(n <= e.l.o), t(16 >= a), 0 < a) {
				var o = e.l, s = e.Ta, c = e.Ua, l = o.width;
				if (Me(e, a, r, i), a = c = [c], t((r = e.C) < (i = n)), t(o.v < o.va), i > o.o && (i = o.o), r < o.j) {
					var u = o.j - r;
					r = o.j, a[0] += u * l;
				}
				if (r >= i ? r = 0 : (a[0] += 4 * o.v, o.ka = r - o.j, o.U = o.va - o.v, o.T = i - r, r = 1), r) {
					if (c = c[0], 11 > (r = e.ca).S) {
						var d = r.f.RGBA, f = (i = r.S, a = o.U, o = o.T, u = d.eb, d.A), p = o;
						for (d = d.fb + e.Ma * d.A; 0 < p--;) {
							var m = s, h = c, g = a, _ = u, v = d;
							switch (i) {
								case Ur:
									cr(m, h, g, _, v);
									break;
								case Wr:
									lr(m, h, g, _, v);
									break;
								case Xr:
									lr(m, h, g, _, v), jr(_, v, 0, g, 1, 0);
									break;
								case Gr:
									fr(m, h, g, _, v);
									break;
								case Kr:
									pe(m, h, g, _, v, 1);
									break;
								case Zr:
									pe(m, h, g, _, v, 1), jr(_, v, 0, g, 1, 0);
									break;
								case qr:
									pe(m, h, g, _, v, 0);
									break;
								case K:
									pe(m, h, g, _, v, 0), jr(_, v, 1, g, 1, 0);
									break;
								case Jr:
									ur(m, h, g, _, v);
									break;
								case Qr:
									ur(m, h, g, _, v), Mr(_, v, g, 1, 0);
									break;
								case Yr:
									dr(m, h, g, _, v);
									break;
								default: t(0);
							}
							c += l, d += f;
						}
						e.Ma += o;
					} else alert("todo:EmitRescaledRowsYUVA");
					t(e.Ma <= r.height);
				}
			}
			e.C = n, t(e.C <= e.i);
		}
		function Pe(e) {
			var t;
			if (0 < e.ua) return 0;
			for (t = 0; t < e.Wb; ++t) {
				var n = e.Ya[t].G, r = e.Ya[t].H;
				if (0 < n[1][r[1] + 0].g || 0 < n[2][r[2] + 0].g || 0 < n[3][r[3] + 0].g) return 0;
			}
			return 1;
		}
		function Fe(e, n, r, i, a, o) {
			if (e.Z != 0) {
				var s = e.qd, c = e.rd;
				for (t(Si[e.Z] != null); n < r; ++n) Si[e.Z](s, c, i, a, i, a, o), s = i, c = a, a += o;
				e.qd = s, e.rd = c;
			}
		}
		function Ie(e, n) {
			var r = e.l.ma, i = r.Z == 0 || r.Z == 1 ? e.l.j : e.C;
			if (i = e.C < i ? i : e.C, t(n <= e.l.o), n > i) {
				var a = e.l.width, o = r.ca, s = r.tb + a * i, c = e.V, l = e.Ba + e.c * i, u = e.gc;
				t(e.ab == 1), t(u[0].hc == 3), ir(u[0], i, n, c, l, o, s), Fe(r, i, n, o, s, a);
			}
			e.C = e.Ma = n;
		}
		function Le(e, n, r, i, a, o, s) {
			var c = e.$ / i, l = e.$ % i, u = e.m, d = e.s, f = r + e.$, p = f;
			a = r + i * a;
			var m = r + i * o, h = 280 + d.ua, g = e.Pb ? c : 16777216, _ = 0 < d.ua ? d.Wa : null, v = d.wc, y = f < m ? je(d, l, c) : null;
			t(e.C < o), t(m <= a);
			var b = !1;
			t: for (;;) {
				for (; b || f < m;) {
					var x = 0;
					if (c >= g) {
						var E = f - r;
						t((g = e).Pb), g.wd = g.m, g.xd = E, 0 < g.s.ua && P(g.s.Wa, g.s.vb), g = c + oi;
					}
					if (l & v || (y = je(d, l, c)), t(y != null), y.Qb && (n[f] = y.qb, b = !0), !b) if (T(u), y.jc) {
						x = u, E = n;
						var D = f, O = y.pd[S(x) & qn - 1];
						t(y.jc), 256 > O.g ? (w(x, x.u + O.g), E[D] = O.value, x = 0) : (w(x, x.u + O.g - 256), t(256 <= O.value), x = O.value), x == 0 && (b = !0);
					} else x = ke(y.G[0], y.H[0], u);
					if (u.h) break;
					if (b || 256 > x) {
						if (!b) if (y.nd) n[f] = (y.qb | x << 8) >>> 0;
						else {
							if (T(u), b = ke(y.G[1], y.H[1], u), T(u), E = ke(y.G[2], y.H[2], u), D = ke(y.G[3], y.H[3], u), u.h) break;
							n[f] = (D << 24 | b << 16 | x << 8 | E) >>> 0;
						}
						if (b = !1, ++f, ++l >= i && (l = 0, ++c, s != null && c <= o && !(c % 16) && s(e, c), _ != null)) for (; p < f;) x = n[p++], _.X[(506832829 * x & 4294967295) >>> _.Mb] = x;
					} else if (280 > x) {
						if (x = H(x - 256, u), E = ke(y.G[4], y.H[4], u), T(u), E = Oe(i, E = H(E, u)), u.h) break;
						if (f - r < E || a - f < x) break t;
						for (D = 0; D < x; ++D) n[f + D] = n[f + D - E];
						for (f += x, l += x; l >= i;) l -= i, ++c, s != null && c <= o && !(c % 16) && s(e, c);
						if (t(f <= a), l & v && (y = je(d, l, c)), _ != null) for (; p < f;) x = n[p++], _.X[(506832829 * x & 4294967295) >>> _.Mb] = x;
					} else {
						if (!(x < h)) break t;
						for (b = x - 280, t(_ != null); p < f;) x = n[p++], _.X[(506832829 * x & 4294967295) >>> _.Mb] = x;
						x = f, t(!(b >>> (E = _).Xa)), n[x] = E.X[b], b = !0;
					}
					b || t(u.h == C(u));
				}
				if (e.Pb && u.h && f < a) t(e.m.h), e.a = 5, e.m = e.wd, e.$ = e.xd, 0 < e.s.ua && P(e.s.vb, e.s.Wa);
				else {
					if (u.h) break t;
					s?.(e, c > o ? o : c), e.a = 0, e.$ = f - r;
				}
				return 1;
			}
			return e.a = 3, 0;
		}
		function Re(e) {
			t(e != null), e.vc = null, e.yc = null, e.Ya = null;
			var n = e.Wa;
			n != null && (n.X = null), e.vb = null, t(e != null);
		}
		function ze() {
			var t = new hn();
			return t == null ? null : (t.a = 0, t.xb = xi, me("Predictor", "VP8LPredictors"), me("Predictor", "VP8LPredictors_C"), me("PredictorAdd", "VP8LPredictorsAdd"), me("PredictorAdd", "VP8LPredictorsAdd_C"), tr = B, sr = se, cr = le, lr = V, ur = ue, dr = de, fr = fe, e.VP8LMapColor32b = rr, e.VP8LMapColor8b = ar, t);
		}
		function Be(e, n, r, s, c) {
			var l = 1, f = [e], m = [n], h = s.m, g = s.s, _ = null, v = 0;
			t: for (;;) {
				if (r) for (; l && y(h, 1);) {
					var b = f, x = m, C = s, E = 1, D = C.m, O = C.gc[C.ab], k = y(D, 2);
					if (C.Oc & 1 << k) l = 0;
					else {
						switch (C.Oc |= 1 << k, O.hc = k, O.Ea = b[0], O.nc = x[0], O.K = [null], ++C.ab, t(4 >= C.ab), k) {
							case 0:
							case 1:
								O.b = y(D, 3) + 2, E = Be(ee(O.Ea, O.b), ee(O.nc, O.b), 0, C, O.K), O.K = O.K[0];
								break;
							case 3:
								var A, j = y(D, 8) + 1, M = 16 < j ? 0 : 4 < j ? 1 : 2 < j ? 2 : 3;
								if (b[0] = ee(O.Ea, M), O.b = M, A = E = Be(j, 1, 0, C, O.K)) {
									var P, F = j, I = O, R = 1 << (8 >> I.b), te = a(R);
									if (te == null) A = 0;
									else {
										var z = I.K[0], ne = I.w;
										for (te[0] = I.K[0][0], P = 1; P < 1 * F; ++P) te[P] = L(z[ne + P], te[P - 1]);
										for (; P < 4 * R; ++P) te[P] = 0;
										I.K[0] = null, I.K[0] = te, A = 1;
									}
								}
								E = A;
								break;
							case 2: break;
							default: t(0);
						}
						l = E;
					}
				}
				if (f = f[0], m = m[0], l && y(h, 1) && !(l = 1 <= (v = y(h, 4)) && 11 >= v)) {
					s.a = 3;
					break t;
				}
				var re;
				if (re = l) e: {
					var ie, ae, B, oe = s, se = f, ce = m, le = v, V = r, ue = oe.m, de = oe.s, fe = [null], pe = 1, me = 0, he = ai[le];
					r: for (;;) {
						if (V && y(ue, 1)) {
							var ge = y(ue, 3) + 2, _e = ee(se, ge), ve = ee(ce, ge), ye = _e * ve;
							if (!Be(_e, ve, 0, oe, fe)) break r;
							for (fe = fe[0], de.xc = ge, ie = 0; ie < ye; ++ie) {
								var be = fe[ie] >> 8 & 65535;
								fe[ie] = be, be >= pe && (pe = be + 1);
							}
						}
						if (ue.h) break r;
						for (ae = 0; 5 > ae; ++ae) {
							var xe = ti[ae];
							!ae && 0 < le && (xe += 1 << le), me < xe && (me = xe);
						}
						var Se = o(pe * he, d), Ce = pe, we = o(Ce, p);
						if (we == null) var Te = null;
						else t(65536 >= Ce), Te = we;
						var Ee = a(me);
						if (Te == null || Ee == null || Se == null) {
							oe.a = 1;
							break r;
						}
						var De = Se;
						for (ie = B = 0; ie < pe; ++ie) {
							var H = Te[ie], Oe = H.G, ke = H.H, je = 0, Me = 1, Ne = 0;
							for (ae = 0; 5 > ae; ++ae) {
								xe = ti[ae], Oe[ae] = De, ke[ae] = B, !ae && 0 < le && (xe += 1 << le);
								n: {
									var Pe, Fe = xe, Ie = oe, ze = Ee, Ve = De, He = B, Ue = 0, We = Ie.m, Ge = y(We, 1);
									if (i(ze, 0, 0, Fe), Ge) {
										var Ke = y(We, 1) + 1, qe = y(We, y(We, 1) == 0 ? 1 : 8);
										ze[qe] = 1, Ke == 2 && (ze[qe = y(We, 8)] = 1);
										var Je = 1;
									} else {
										var Ye = a(19), Xe = y(We, 4) + 4;
										if (19 < Xe) {
											Ie.a = 3;
											var Ze = 0;
											break n;
										}
										for (Pe = 0; Pe < Xe; ++Pe) Ye[ri[Pe]] = y(We, 3);
										var Qe = void 0, $e = void 0, et = Ie, tt = Ye, nt = Fe, rt = ze, it = 0, at = et.m, ot = 8, st = o(128, d);
										i: for (; u(st, 0, 7, tt, 19);) {
											if (y(at, 1)) {
												if ((Qe = 2 + y(at, 2 + 2 * y(at, 3))) > nt) break i;
											} else Qe = nt;
											for ($e = 0; $e < nt && Qe--;) {
												T(at);
												var ct = st[0 + (127 & S(at))];
												w(at, at.u + ct.g);
												var lt = ct.value;
												if (16 > lt) rt[$e++] = lt, lt != 0 && (ot = lt);
												else {
													var ut = lt == 16, dt = lt - 16, ft = ei[dt], pt = y(at, $r[dt]) + ft;
													if ($e + pt > nt) break i;
													for (var mt = ut ? ot : 0; 0 < pt--;) rt[$e++] = mt;
												}
											}
											it = 1;
											break i;
										}
										it || (et.a = 3), Je = it;
									}
									(Je &&= !We.h) && (Ue = u(Ve, He, 8, ze, Fe)), Je && Ue != 0 ? Ze = Ue : (Ie.a = 3, Ze = 0);
								}
								if (Ze == 0) break r;
								if (Me && ni[ae] == 1 && (Me = De[B].g == 0), je += De[B].g, B += Ze, 3 >= ae) {
									var ht, gt = Ee[0];
									for (ht = 1; ht < xe; ++ht) Ee[ht] > gt && (gt = Ee[ht]);
									Ne += gt;
								}
							}
							if (H.nd = Me, H.Qb = 0, Me && (H.qb = (Oe[3][ke[3] + 0].value << 24 | Oe[1][ke[1] + 0].value << 16 | Oe[2][ke[2] + 0].value) >>> 0, je == 0 && 256 > Oe[0][ke[0] + 0].value && (H.Qb = 1, H.qb += Oe[0][ke[0] + 0].value << 8)), H.jc = !H.Qb && 6 > Ne, H.jc) {
								var _t, vt = H;
								for (_t = 0; _t < qn; ++_t) {
									var yt = _t, bt = vt.pd[yt], xt = vt.G[0][vt.H[0] + yt];
									256 <= xt.value ? (bt.g = xt.g + 256, bt.value = xt.value) : (bt.g = 0, bt.value = 0, yt >>= Ae(xt, 8, bt), yt >>= Ae(vt.G[1][vt.H[1] + yt], 16, bt), yt >>= Ae(vt.G[2][vt.H[2] + yt], 0, bt), Ae(vt.G[3][vt.H[3] + yt], 24, bt));
								}
							}
						}
						de.vc = fe, de.Wb = pe, de.Ya = Te, de.yc = Se, re = 1;
						break e;
					}
					re = 0;
				}
				if (!(l = re)) {
					s.a = 3;
					break t;
				}
				if (0 < v) {
					if (g.ua = 1 << v, !N(g.Wa, v)) {
						s.a = 1, l = 0;
						break t;
					}
				} else g.ua = 0;
				var St = s, Ct = f, wt = m, Tt = St.s, Et = Tt.xc;
				if (St.c = Ct, St.i = wt, Tt.md = ee(Ct, Et), Tt.wc = Et == 0 ? -1 : (1 << Et) - 1, r) {
					s.xb = bi;
					break t;
				}
				if ((_ = a(f * m)) == null) {
					s.a = 1, l = 0;
					break t;
				}
				l = (l = Le(s, _, 0, f, m, m, null)) && !h.h;
				break t;
			}
			return l ? (c == null ? (t(_ == null), t(r)) : c[0] = _, s.$ = 0, r || Re(g)) : Re(g), l;
		}
		function Ve(e, n) {
			var r = e.c * e.i, i = r + n + 16 * n;
			return t(e.c <= n), e.V = a(i), e.V == null ? (e.Ta = null, e.Ua = 0, e.a = 1, 0) : (e.Ta = e.V, e.Ua = e.Ba + r + n, 1);
		}
		function He(e, n) {
			var r = e.C, i = n - r, a = e.V, o = e.Ba + e.c * r;
			for (t(n <= e.l.o); 0 < i;) {
				var s = 16 < i ? 16 : i, c = e.l.ma, l = e.l.width, u = l * s, d = c.ca, f = c.tb + l * r, p = e.Ta, m = e.Ua;
				Me(e, s, a, o), Pr(p, m, d, f, u), Fe(c, r, r + s, d, f, l), i -= s, a += s * e.c, r += s;
			}
			t(r == n), e.C = e.Ma = n;
		}
		function Ue() {
			this.ub = this.yd = this.td = this.Rb = 0;
		}
		function We() {
			this.Kd = this.Ld = this.Ud = this.Td = this.i = this.c = 0;
		}
		function Ge() {
			this.Fb = this.Bb = this.Cb = 0, this.Zb = a(4), this.Lb = a(4);
		}
		function Ke() {
			this.Yb = function() {
				var e = [];
				return function e(t, n, r) {
					for (var i = r[n], a = 0; a < i && (t.push(r.length > n + 1 ? [] : 0), !(r.length < n + 1)); a++) e(t[a], n + 1, r);
				}(e, 0, [3, 11]), e;
			}();
		}
		function qe() {
			this.jb = a(3), this.Wc = s([4, 8], Ke), this.Xc = s([4, 17], Ke);
		}
		function Je() {
			this.Pc = this.wb = this.Tb = this.zd = 0, this.vd = new a(4), this.od = new a(4);
		}
		function Ye() {
			this.ld = this.La = this.dd = this.tc = 0;
		}
		function Xe() {
			this.Na = this.la = 0;
		}
		function Ze() {
			this.Sc = [0, 0], this.Eb = [0, 0], this.Qc = [0, 0], this.ia = this.lc = 0;
		}
		function Qe() {
			this.ad = a(384), this.Za = 0, this.Ob = a(16), this.$b = this.Ad = this.ia = this.Gc = this.Hc = this.Dd = 0;
		}
		function $e() {
			this.uc = this.M = this.Nb = 0, this.wa = Array(new Ye()), this.Y = 0, this.ya = Array(new Qe()), this.aa = 0, this.l = new rt();
		}
		function et() {
			this.y = a(16), this.f = a(8), this.ea = a(8);
		}
		function tt() {
			this.cb = this.a = 0, this.sc = "", this.m = new b(), this.Od = new Ue(), this.Kc = new We(), this.ed = new Je(), this.Qa = new Ge(), this.Ic = this.$c = this.Aa = 0, this.D = new $e(), this.Xb = this.Va = this.Hb = this.zb = this.yb = this.Ub = this.za = 0, this.Jc = o(8, b), this.ia = 0, this.pb = o(4, Ze), this.Pa = new qe(), this.Bd = this.kc = 0, this.Ac = [], this.Bc = 0, this.zc = [
				0,
				0,
				0,
				0
			], this.Gd = Array(new et()), this.Hd = 0, this.rb = Array(new Xe()), this.sb = 0, this.wa = Array(new Ye()), this.Y = 0, this.oc = [], this.pc = 0, this.sa = [], this.ta = 0, this.qa = [], this.ra = 0, this.Ha = [], this.B = this.R = this.Ia = 0, this.Ec = [], this.M = this.ja = this.Vb = this.Fc = 0, this.ya = Array(new Qe()), this.L = this.aa = 0, this.gd = s([4, 2], Ye), this.ga = null, this.Fa = [], this.Cc = this.qc = this.P = 0, this.Gb = [], this.Uc = 0, this.mb = [], this.nb = 0, this.rc = [], this.Ga = this.Vc = 0;
		}
		function nt(e, t) {
			return 0 > e ? 0 : e > t ? t : e;
		}
		function rt() {
			this.T = this.U = this.ka = this.height = this.width = 0, this.y = [], this.f = [], this.ea = [], this.Rc = this.fa = this.W = this.N = this.O = 0, this.ma = "void", this.put = "VP8IoPutHook", this.ac = "VP8IoSetupHook", this.bc = "VP8IoTeardownHook", this.ha = this.Kb = 0, this.data = [], this.hb = this.ib = this.da = this.o = this.j = this.va = this.v = this.Da = this.ob = this.w = 0, this.F = [], this.J = 0;
		}
		function it() {
			var e = new tt();
			return e != null && (e.a = 0, e.sc = "OK", e.cb = 0, e.Xb = 0, li ||= ct), e;
		}
		function at(e, t, n) {
			return e.a == 0 && (e.a = t, e.sc = n, e.cb = 0), 0;
		}
		function ot(e, t, n) {
			return 3 <= n && e[t + 0] == 157 && e[t + 1] == 1 && e[t + 2] == 42;
		}
		function st(e, n) {
			if (e == null) return 0;
			if (e.a = 0, e.sc = "OK", n == null) return at(e, 2, "null VP8Io passed to VP8GetHeaders()");
			var r = n.data, a = n.w, o = n.ha;
			if (4 > o) return at(e, 7, "Truncated header.");
			var s = r[a + 0] | r[a + 1] << 8 | r[a + 2] << 16, c = e.Od;
			if (c.Rb = !(1 & s), c.td = s >> 1 & 7, c.yd = s >> 4 & 1, c.ub = s >> 5, 3 < c.td) return at(e, 3, "Incorrect keyframe parameters.");
			if (!c.yd) return at(e, 4, "Frame not displayable.");
			a += 3, o -= 3;
			var l = e.Kc;
			if (c.Rb) {
				if (7 > o) return at(e, 7, "cannot parse picture header");
				if (!ot(r, a, o)) return at(e, 3, "Bad code word");
				l.c = 16383 & (r[a + 4] << 8 | r[a + 3]), l.Td = r[a + 4] >> 6, l.i = 16383 & (r[a + 6] << 8 | r[a + 5]), l.Ud = r[a + 6] >> 6, a += 7, o -= 7, e.za = l.c + 15 >> 4, e.Ub = l.i + 15 >> 4, n.width = l.c, n.height = l.i, n.Da = 0, n.j = 0, n.v = 0, n.va = n.width, n.o = n.height, n.da = 0, n.ib = n.width, n.hb = n.height, n.U = n.width, n.T = n.height, i((s = e.Pa).jb, 0, 255, s.jb.length), t((s = e.Qa) != null), s.Cb = 0, s.Bb = 0, s.Fb = 1, i(s.Zb, 0, 0, s.Zb.length), i(s.Lb, 0, 0, s.Lb);
			}
			if (c.ub > o) return at(e, 7, "bad partition length");
			m(s = e.m, r, a, c.ub), a += c.ub, o -= c.ub, c.Rb && (l.Ld = D(s), l.Kd = D(s)), l = e.Qa;
			var u, d = e.Pa;
			if (t(s != null), t(l != null), l.Cb = D(s), l.Cb) {
				if (l.Bb = D(s), D(s)) {
					for (l.Fb = D(s), u = 0; 4 > u; ++u) l.Zb[u] = D(s) ? g(s, 7) : 0;
					for (u = 0; 4 > u; ++u) l.Lb[u] = D(s) ? g(s, 6) : 0;
				}
				if (l.Bb) for (u = 0; 3 > u; ++u) d.jb[u] = D(s) ? h(s, 8) : 255;
			} else l.Bb = 0;
			if (s.Ka) return at(e, 3, "cannot parse segment header");
			if ((l = e.ed).zd = D(s), l.Tb = h(s, 6), l.wb = h(s, 3), l.Pc = D(s), l.Pc && D(s)) {
				for (d = 0; 4 > d; ++d) D(s) && (l.vd[d] = g(s, 6));
				for (d = 0; 4 > d; ++d) D(s) && (l.od[d] = g(s, 6));
			}
			if (e.L = l.Tb == 0 ? 0 : l.zd ? 1 : 2, s.Ka) return at(e, 3, "cannot parse filter header");
			var f = o;
			if (o = u = a, a = u + f, l = f, e.Xb = (1 << h(e.m, 2)) - 1, f < 3 * (d = e.Xb)) r = 7;
			else {
				for (u += 3 * d, l -= 3 * d, f = 0; f < d; ++f) {
					var p = r[o + 0] | r[o + 1] << 8 | r[o + 2] << 16;
					p > l && (p = l), m(e.Jc[+f], r, u, p), u += p, l -= p, o += 3;
				}
				m(e.Jc[+d], r, u, l), r = u < a ? 0 : 5;
			}
			if (r != 0) return at(e, r, "cannot parse partitions");
			for (r = h(u = e.m, 7), o = D(u) ? g(u, 4) : 0, a = D(u) ? g(u, 4) : 0, l = D(u) ? g(u, 4) : 0, d = D(u) ? g(u, 4) : 0, u = D(u) ? g(u, 4) : 0, f = e.Qa, p = 0; 4 > p; ++p) {
				if (f.Cb) {
					var _ = f.Zb[p];
					f.Fb || (_ += r);
				} else {
					if (0 < p) {
						e.pb[p] = e.pb[0];
						continue;
					}
					_ = r;
				}
				var v = e.pb[p];
				v.Sc[0] = si[nt(_ + o, 127)], v.Sc[1] = ci[nt(_ + 0, 127)], v.Eb[0] = 2 * si[nt(_ + a, 127)], v.Eb[1] = 101581 * ci[nt(_ + l, 127)] >> 16, 8 > v.Eb[1] && (v.Eb[1] = 8), v.Qc[0] = si[nt(_ + d, 117)], v.Qc[1] = ci[nt(_ + u, 127)], v.lc = _ + u;
			}
			if (!c.Rb) return at(e, 4, "Not a key frame.");
			for (D(s), c = e.Pa, r = 0; 4 > r; ++r) {
				for (o = 0; 8 > o; ++o) for (a = 0; 3 > a; ++a) for (l = 0; 11 > l; ++l) d = O(s, hi[r][o][a][l]) ? h(s, 8) : pi[r][o][a][l], c.Wc[r][o].Yb[a][l] = d;
				for (o = 0; 17 > o; ++o) c.Xc[r][o] = c.Wc[r][gi[o]];
			}
			return e.kc = D(s), e.kc && (e.Bd = h(s, 8)), e.cb = 1;
		}
		function ct(e, t, n, r, i, a, o) {
			var s = t[i].Yb[n];
			for (n = 0; 16 > i; ++i) {
				if (!O(e, s[n + 0])) return i;
				for (; !O(e, s[n + 1]);) if (s = t[++i].Yb[0], n = 0, i == 16) return 16;
				var c = t[i + 1].Yb;
				if (O(e, s[n + 2])) {
					var l = e, u = 0;
					if (O(l, (f = s)[(d = n) + 3])) if (O(l, f[d + 6])) {
						for (s = 0, d = 2 * (u = O(l, f[d + 8])) + (f = O(l, f[d + 9 + u])), u = 0, f = ui[d]; f[s]; ++s) u += u + O(l, f[s]);
						u += 3 + (8 << d);
					} else O(l, f[d + 7]) ? (u = 7 + 2 * O(l, 165), u += O(l, 145)) : u = 5 + O(l, 159);
					else u = O(l, f[d + 4]) ? 3 + O(l, f[d + 5]) : 2;
					s = c[2];
				} else u = 1, s = c[1];
				c = o + di[i], 0 > (l = e).b && E(l);
				var d, f = l.b, p = (d = l.Ca >> 1) - (l.I >> f) >> 31;
				--l.b, l.Ca += p, l.Ca |= 1, l.I -= (d + 1 & p) << f, a[c] = ((u ^ p) - p) * r[(0 < i) + 0];
			}
			return 16;
		}
		function lt(e) {
			var t = e.rb[e.sb - 1];
			t.la = 0, t.Na = 0, i(e.zc, 0, 0, e.zc.length), e.ja = 0;
		}
		function ut(e, t, n, r, i) {
			i = e[t + n + 32 * r] + (i >> 3), e[t + n + 32 * r] = -256 & i ? 0 > i ? 0 : 255 : i;
		}
		function dt(e, t, n, r, i, a) {
			ut(e, t, 0, n, r + i), ut(e, t, 1, n, r + a), ut(e, t, 2, n, r - a), ut(e, t, 3, n, r - i);
		}
		function ft(e) {
			return (20091 * e >> 16) + e;
		}
		function pt(e, t, n, r) {
			var i, o = 0, s = a(16);
			for (i = 0; 4 > i; ++i) {
				var c = e[t + 0] + e[t + 8], l = e[t + 0] - e[t + 8], u = (35468 * e[t + 4] >> 16) - ft(e[t + 12]), d = ft(e[t + 4]) + (35468 * e[t + 12] >> 16);
				s[o + 0] = c + d, s[o + 1] = l + u, s[o + 2] = l - u, s[o + 3] = c - d, o += 4, t++;
			}
			for (i = o = 0; 4 > i; ++i) c = (e = s[o + 0] + 4) + s[o + 8], l = e - s[o + 8], u = (35468 * s[o + 4] >> 16) - ft(s[o + 12]), ut(n, r, 0, 0, c + (d = ft(s[o + 4]) + (35468 * s[o + 12] >> 16))), ut(n, r, 1, 0, l + u), ut(n, r, 2, 0, l - u), ut(n, r, 3, 0, c - d), o++, r += 32;
		}
		function mt(e, t, n, r) {
			var i = e[t + 0] + 4, a = 35468 * e[t + 4] >> 16, o = ft(e[t + 4]), s = 35468 * e[t + 1] >> 16;
			dt(n, r, 0, i + o, e = ft(e[t + 1]), s), dt(n, r, 1, i + a, e, s), dt(n, r, 2, i - a, e, s), dt(n, r, 3, i - o, e, s);
		}
		function ht(e, t, n, r, i) {
			pt(e, t, n, r), i && pt(e, t + 16, n, r + 4);
		}
		function gt(e, t, n, r) {
			mr(e, t + 0, n, r, 1), mr(e, t + 32, n, r + 128, 1);
		}
		function _t(e, t, n, r) {
			var i;
			for (e = e[t + 0] + 4, i = 0; 4 > i; ++i) for (t = 0; 4 > t; ++t) ut(n, r, t, i, e);
		}
		function vt(e, t, n, r) {
			e[t + 0] && _r(e, t + 0, n, r), e[t + 16] && _r(e, t + 16, n, r + 4), e[t + 32] && _r(e, t + 32, n, r + 128), e[t + 48] && _r(e, t + 48, n, r + 128 + 4);
		}
		function yt(e, t, n, r) {
			var i, o = a(16);
			for (i = 0; 4 > i; ++i) {
				var s = e[t + 0 + i] + e[t + 12 + i], c = e[t + 4 + i] + e[t + 8 + i], l = e[t + 4 + i] - e[t + 8 + i], u = e[t + 0 + i] - e[t + 12 + i];
				o[0 + i] = s + c, o[8 + i] = s - c, o[4 + i] = u + l, o[12 + i] = u - l;
			}
			for (i = 0; 4 > i; ++i) s = (e = o[0 + 4 * i] + 3) + o[3 + 4 * i], c = o[1 + 4 * i] + o[2 + 4 * i], l = o[1 + 4 * i] - o[2 + 4 * i], u = e - o[3 + 4 * i], n[r + 0] = s + c >> 3, n[r + 16] = u + l >> 3, n[r + 32] = s - c >> 3, n[r + 48] = u - l >> 3, r += 64;
		}
		function bt(e, t, n) {
			var r, i = t - 32, a = Vr, o = 255 - e[i - 1];
			for (r = 0; r < n; ++r) {
				var s, c = a, l = o + e[t - 1];
				for (s = 0; s < n; ++s) e[t + s] = c[l + e[i + s]];
				t += 32;
			}
		}
		function xt(e, t) {
			bt(e, t, 4);
		}
		function St(e, t) {
			bt(e, t, 8);
		}
		function Ct(e, t) {
			bt(e, t, 16);
		}
		function wt(e, t) {
			var n;
			for (n = 0; 16 > n; ++n) r(e, t + 32 * n, e, t - 32, 16);
		}
		function Tt(e, t) {
			var n;
			for (n = 16; 0 < n; --n) i(e, t, e[t - 1], 16), t += 32;
		}
		function Et(e, t, n) {
			var r;
			for (r = 0; 16 > r; ++r) i(t, n + 32 * r, e, 16);
		}
		function Dt(e, t) {
			var n, r = 16;
			for (n = 0; 16 > n; ++n) r += e[t - 1 + 32 * n] + e[t + n - 32];
			Et(r >> 5, e, t);
		}
		function Ot(e, t) {
			var n, r = 8;
			for (n = 0; 16 > n; ++n) r += e[t - 1 + 32 * n];
			Et(r >> 4, e, t);
		}
		function U(e, t) {
			var n, r = 8;
			for (n = 0; 16 > n; ++n) r += e[t + n - 32];
			Et(r >> 4, e, t);
		}
		function W(e, t) {
			Et(128, e, t);
		}
		function kt(e, t, n) {
			return e + 2 * t + n + 2 >> 2;
		}
		function At(e, t) {
			var n, i = t - 32;
			for (i = new Uint8Array([
				kt(e[i - 1], e[i + 0], e[i + 1]),
				kt(e[i + 0], e[i + 1], e[i + 2]),
				kt(e[i + 1], e[i + 2], e[i + 3]),
				kt(e[i + 2], e[i + 3], e[i + 4])
			]), n = 0; 4 > n; ++n) r(e, t + 32 * n, i, 0, i.length);
		}
		function jt(e, t) {
			var n = e[t - 1], r = e[t - 1 + 32], i = e[t - 1 + 64], a = e[t - 1 + 96];
			k(e, t + 0, 16843009 * kt(e[t - 1 - 32], n, r)), k(e, t + 32, 16843009 * kt(n, r, i)), k(e, t + 64, 16843009 * kt(r, i, a)), k(e, t + 96, 16843009 * kt(i, a, a));
		}
		function Mt(e, t) {
			var n, r = 4;
			for (n = 0; 4 > n; ++n) r += e[t + n - 32] + e[t - 1 + 32 * n];
			for (r >>= 3, n = 0; 4 > n; ++n) i(e, t + 32 * n, r, 4);
		}
		function Nt(e, t) {
			var n = e[t - 1 + 0], r = e[t - 1 + 32], i = e[t - 1 + 64], a = e[t - 1 - 32], o = e[t + 0 - 32], s = e[t + 1 - 32], c = e[t + 2 - 32], l = e[t + 3 - 32];
			e[t + 0 + 96] = kt(r, i, e[t - 1 + 96]), e[t + 1 + 96] = e[t + 0 + 64] = kt(n, r, i), e[t + 2 + 96] = e[t + 1 + 64] = e[t + 0 + 32] = kt(a, n, r), e[t + 3 + 96] = e[t + 2 + 64] = e[t + 1 + 32] = e[t + 0 + 0] = kt(o, a, n), e[t + 3 + 64] = e[t + 2 + 32] = e[t + 1 + 0] = kt(s, o, a), e[t + 3 + 32] = e[t + 2 + 0] = kt(c, s, o), e[t + 3 + 0] = kt(l, c, s);
		}
		function Pt(e, t) {
			var n = e[t + 1 - 32], r = e[t + 2 - 32], i = e[t + 3 - 32], a = e[t + 4 - 32], o = e[t + 5 - 32], s = e[t + 6 - 32], c = e[t + 7 - 32];
			e[t + 0 + 0] = kt(e[t + 0 - 32], n, r), e[t + 1 + 0] = e[t + 0 + 32] = kt(n, r, i), e[t + 2 + 0] = e[t + 1 + 32] = e[t + 0 + 64] = kt(r, i, a), e[t + 3 + 0] = e[t + 2 + 32] = e[t + 1 + 64] = e[t + 0 + 96] = kt(i, a, o), e[t + 3 + 32] = e[t + 2 + 64] = e[t + 1 + 96] = kt(a, o, s), e[t + 3 + 64] = e[t + 2 + 96] = kt(o, s, c), e[t + 3 + 96] = kt(s, c, c);
		}
		function Ft(e, t) {
			var n = e[t - 1 + 0], r = e[t - 1 + 32], i = e[t - 1 + 64], a = e[t - 1 - 32], o = e[t + 0 - 32], s = e[t + 1 - 32], c = e[t + 2 - 32], l = e[t + 3 - 32];
			e[t + 0 + 0] = e[t + 1 + 64] = a + o + 1 >> 1, e[t + 1 + 0] = e[t + 2 + 64] = o + s + 1 >> 1, e[t + 2 + 0] = e[t + 3 + 64] = s + c + 1 >> 1, e[t + 3 + 0] = c + l + 1 >> 1, e[t + 0 + 96] = kt(i, r, n), e[t + 0 + 64] = kt(r, n, a), e[t + 0 + 32] = e[t + 1 + 96] = kt(n, a, o), e[t + 1 + 32] = e[t + 2 + 96] = kt(a, o, s), e[t + 2 + 32] = e[t + 3 + 96] = kt(o, s, c), e[t + 3 + 32] = kt(s, c, l);
		}
		function It(e, t) {
			var n = e[t + 0 - 32], r = e[t + 1 - 32], i = e[t + 2 - 32], a = e[t + 3 - 32], o = e[t + 4 - 32], s = e[t + 5 - 32], c = e[t + 6 - 32], l = e[t + 7 - 32];
			e[t + 0 + 0] = n + r + 1 >> 1, e[t + 1 + 0] = e[t + 0 + 64] = r + i + 1 >> 1, e[t + 2 + 0] = e[t + 1 + 64] = i + a + 1 >> 1, e[t + 3 + 0] = e[t + 2 + 64] = a + o + 1 >> 1, e[t + 0 + 32] = kt(n, r, i), e[t + 1 + 32] = e[t + 0 + 96] = kt(r, i, a), e[t + 2 + 32] = e[t + 1 + 96] = kt(i, a, o), e[t + 3 + 32] = e[t + 2 + 96] = kt(a, o, s), e[t + 3 + 64] = kt(o, s, c), e[t + 3 + 96] = kt(s, c, l);
		}
		function Lt(e, t) {
			var n = e[t - 1 + 0], r = e[t - 1 + 32], i = e[t - 1 + 64], a = e[t - 1 + 96];
			e[t + 0 + 0] = n + r + 1 >> 1, e[t + 2 + 0] = e[t + 0 + 32] = r + i + 1 >> 1, e[t + 2 + 32] = e[t + 0 + 64] = i + a + 1 >> 1, e[t + 1 + 0] = kt(n, r, i), e[t + 3 + 0] = e[t + 1 + 32] = kt(r, i, a), e[t + 3 + 32] = e[t + 1 + 64] = kt(i, a, a), e[t + 3 + 64] = e[t + 2 + 64] = e[t + 0 + 96] = e[t + 1 + 96] = e[t + 2 + 96] = e[t + 3 + 96] = a;
		}
		function Rt(e, t) {
			var n = e[t - 1 + 0], r = e[t - 1 + 32], i = e[t - 1 + 64], a = e[t - 1 + 96], o = e[t - 1 - 32], s = e[t + 0 - 32], c = e[t + 1 - 32], l = e[t + 2 - 32];
			e[t + 0 + 0] = e[t + 2 + 32] = n + o + 1 >> 1, e[t + 0 + 32] = e[t + 2 + 64] = r + n + 1 >> 1, e[t + 0 + 64] = e[t + 2 + 96] = i + r + 1 >> 1, e[t + 0 + 96] = a + i + 1 >> 1, e[t + 3 + 0] = kt(s, c, l), e[t + 2 + 0] = kt(o, s, c), e[t + 1 + 0] = e[t + 3 + 32] = kt(n, o, s), e[t + 1 + 32] = e[t + 3 + 64] = kt(r, n, o), e[t + 1 + 64] = e[t + 3 + 96] = kt(i, r, n), e[t + 1 + 96] = kt(a, i, r);
		}
		function zt(e, t) {
			var n;
			for (n = 0; 8 > n; ++n) r(e, t + 32 * n, e, t - 32, 8);
		}
		function Bt(e, t) {
			var n;
			for (n = 0; 8 > n; ++n) i(e, t, e[t - 1], 8), t += 32;
		}
		function Vt(e, t, n) {
			var r;
			for (r = 0; 8 > r; ++r) i(t, n + 32 * r, e, 8);
		}
		function Ht(e, t) {
			var n, r = 8;
			for (n = 0; 8 > n; ++n) r += e[t + n - 32] + e[t - 1 + 32 * n];
			Vt(r >> 4, e, t);
		}
		function Ut(e, t) {
			var n, r = 4;
			for (n = 0; 8 > n; ++n) r += e[t + n - 32];
			Vt(r >> 3, e, t);
		}
		function Wt(e, t) {
			var n, r = 4;
			for (n = 0; 8 > n; ++n) r += e[t - 1 + 32 * n];
			Vt(r >> 3, e, t);
		}
		function Gt(e, t) {
			Vt(128, e, t);
		}
		function Kt(e, t, n) {
			var r = e[t - n], i = e[t + 0], a = 3 * (i - r) + zr[1020 + e[t - 2 * n] - e[t + n]], o = Br[112 + (a + 4 >> 3)];
			e[t - n] = Vr[255 + r + Br[112 + (a + 3 >> 3)]], e[t + 0] = Vr[255 + i - o];
		}
		function qt(e, t, n, r) {
			var i = e[t + 0], a = e[t + n];
			return Hr[255 + e[t - 2 * n] - e[t - n]] > r || Hr[255 + a - i] > r;
		}
		function Jt(e, t, n, r) {
			return 4 * Hr[255 + e[t - n] - e[t + 0]] + Hr[255 + e[t - 2 * n] - e[t + n]] <= r;
		}
		function Yt(e, t, n, r, i) {
			var a = e[t - 3 * n], o = e[t - 2 * n], s = e[t - n], c = e[t + 0], l = e[t + n], u = e[t + 2 * n], d = e[t + 3 * n];
			return 4 * Hr[255 + s - c] + Hr[255 + o - l] > r ? 0 : Hr[255 + e[t - 4 * n] - a] <= i && Hr[255 + a - o] <= i && Hr[255 + o - s] <= i && Hr[255 + d - u] <= i && Hr[255 + u - l] <= i && Hr[255 + l - c] <= i;
		}
		function Xt(e, t, n, r) {
			var i = 2 * r + 1;
			for (r = 0; 16 > r; ++r) Jt(e, t + r, n, i) && Kt(e, t + r, n);
		}
		function Zt(e, t, n, r) {
			var i = 2 * r + 1;
			for (r = 0; 16 > r; ++r) Jt(e, t + r * n, 1, i) && Kt(e, t + r * n, 1);
		}
		function Qt(e, t, n, r) {
			var i;
			for (i = 3; 0 < i; --i) Xt(e, t += 4 * n, n, r);
		}
		function $t(e, t, n, r) {
			var i;
			for (i = 3; 0 < i; --i) Zt(e, t += 4, n, r);
		}
		function en(e, t, n, r, i, a, o, s) {
			for (a = 2 * a + 1; 0 < i--;) {
				if (Yt(e, t, n, a, o)) if (qt(e, t, n, s)) Kt(e, t, n);
				else {
					var c = e, l = t, u = n, d = c[l - 2 * u], f = c[l - u], p = c[l + 0], m = c[l + u], h = c[l + 2 * u], g = 27 * (v = zr[1020 + 3 * (p - f) + zr[1020 + d - m]]) + 63 >> 7, _ = 18 * v + 63 >> 7, v = 9 * v + 63 >> 7;
					c[l - 3 * u] = Vr[255 + c[l - 3 * u] + v], c[l - 2 * u] = Vr[255 + d + _], c[l - u] = Vr[255 + f + g], c[l + 0] = Vr[255 + p - g], c[l + u] = Vr[255 + m - _], c[l + 2 * u] = Vr[255 + h - v];
				}
				t += r;
			}
		}
		function tn(e, t, n, r, i, a, o, s) {
			for (a = 2 * a + 1; 0 < i--;) {
				if (Yt(e, t, n, a, o)) if (qt(e, t, n, s)) Kt(e, t, n);
				else {
					var c = e, l = t, u = n, d = c[l - u], f = c[l + 0], p = c[l + u], m = Br[112 + (4 + (h = 3 * (f - d)) >> 3)], h = Br[112 + (h + 3 >> 3)], g = m + 1 >> 1;
					c[l - 2 * u] = Vr[255 + c[l - 2 * u] + g], c[l - u] = Vr[255 + d + h], c[l + 0] = Vr[255 + f - m], c[l + u] = Vr[255 + p - g];
				}
				t += r;
			}
		}
		function nn(e, t, n, r, i, a) {
			en(e, t, n, 1, 16, r, i, a);
		}
		function rn(e, t, n, r, i, a) {
			en(e, t, 1, n, 16, r, i, a);
		}
		function an(e, t, n, r, i, a) {
			var o;
			for (o = 3; 0 < o; --o) tn(e, t += 4 * n, n, 1, 16, r, i, a);
		}
		function on(e, t, n, r, i, a) {
			var o;
			for (o = 3; 0 < o; --o) tn(e, t += 4, 1, n, 16, r, i, a);
		}
		function sn(e, t, n, r, i, a, o, s) {
			en(e, t, i, 1, 8, a, o, s), en(n, r, i, 1, 8, a, o, s);
		}
		function cn(e, t, n, r, i, a, o, s) {
			en(e, t, 1, i, 8, a, o, s), en(n, r, 1, i, 8, a, o, s);
		}
		function ln(e, t, n, r, i, a, o, s) {
			tn(e, t + 4 * i, i, 1, 8, a, o, s), tn(n, r + 4 * i, i, 1, 8, a, o, s);
		}
		function un(e, t, n, r, i, a, o, s) {
			tn(e, t + 4, 1, i, 8, a, o, s), tn(n, r + 4, 1, i, 8, a, o, s);
		}
		function dn() {
			this.ba = new ve(), this.ec = [], this.cc = [], this.Mc = [], this.Dc = this.Nc = this.dc = this.fc = 0, this.Oa = new be(), this.memory = 0, this.Ib = "OutputFunc", this.Jb = "OutputAlphaFunc", this.Nd = "OutputRowFunc";
		}
		function fn() {
			this.data = [], this.offset = this.kd = this.ha = this.w = 0, this.na = [], this.xa = this.gb = this.Ja = this.Sa = this.P = 0;
		}
		function pn() {
			this.nc = this.Ea = this.b = this.hc = 0, this.K = [], this.w = 0;
		}
		function mn() {
			this.ua = 0, this.Wa = new F(), this.vb = new F(), this.md = this.xc = this.wc = 0, this.vc = [], this.Wb = 0, this.Ya = new p(), this.yc = new d();
		}
		function hn() {
			this.xb = this.a = 0, this.l = new rt(), this.ca = new ve(), this.V = [], this.Ba = 0, this.Ta = [], this.Ua = 0, this.m = new x(), this.Pb = 0, this.wd = new x(), this.Ma = this.$ = this.C = this.i = this.c = this.xd = 0, this.s = new mn(), this.ab = 0, this.gc = o(4, pn), this.Oc = 0;
		}
		function gn() {
			this.Lc = this.Z = this.$a = this.i = this.c = 0, this.l = new rt(), this.ic = 0, this.ca = [], this.tb = 0, this.qd = null, this.rd = 0;
		}
		function _n(e, t, n, r, i, a, o) {
			for (e = e == null ? 0 : e[t + 0], t = 0; t < o; ++t) i[a + t] = e + n[r + t] & 255, e = i[a + t];
		}
		function vn(e, t, n, r, i, a, o) {
			var s;
			if (e == null) _n(null, null, n, r, i, a, o);
			else for (s = 0; s < o; ++s) i[a + s] = e[t + s] + n[r + s] & 255;
		}
		function yn(e, t, n, r, i, a, o) {
			if (e == null) _n(null, null, n, r, i, a, o);
			else {
				var s, c = e[t + 0], l = c, u = c;
				for (s = 0; s < o; ++s) l = u + (c = e[t + s]) - l, u = n[r + s] + (-256 & l ? 0 > l ? 0 : 255 : l) & 255, l = c, i[a + s] = u;
			}
		}
		function bn(e, n, i, o) {
			var s = n.width, c = n.o;
			if (t(e != null && n != null), 0 > i || 0 >= o || i + o > c) return null;
			if (!e.Cc) {
				if (e.ga == null) {
					var l;
					if (e.ga = new gn(), (l = e.ga == null) || (l = n.width * n.o, t(e.Gb.length == 0), e.Gb = a(l), e.Uc = 0, e.Gb == null ? l = 0 : (e.mb = e.Gb, e.nb = e.Uc, e.rc = null, l = 1), l = !l), !l) {
						l = e.ga;
						var u = e.Fa, d = e.P, f = e.qc, p = e.mb, m = e.nb, h = d + 1, g = f - 1, v = l.l;
						if (t(u != null && p != null && n != null), Si[0] = null, Si[1] = _n, Si[2] = vn, Si[3] = yn, l.ca = p, l.tb = m, l.c = n.width, l.i = n.height, t(0 < l.c && 0 < l.i), 1 >= f) n = 0;
						else if (l.$a = 3 & u[d + 0], l.Z = u[d + 0] >> 2 & 3, l.Lc = u[d + 0] >> 4 & 3, d = u[d + 0] >> 6 & 3, 0 > l.$a || 1 < l.$a || 4 <= l.Z || 1 < l.Lc || d) n = 0;
						else if (v.put = Te, v.ac = we, v.bc = Ee, v.ma = l, v.width = n.width, v.height = n.height, v.Da = n.Da, v.v = n.v, v.va = n.va, v.j = n.j, v.o = n.o, l.$a) t: {
							t(l.$a == 1), n = ze();
							e: for (;;) {
								if (n == null) {
									n = 0;
									break t;
								}
								if (t(l != null), l.mc = n, n.c = l.c, n.i = l.i, n.l = l.l, n.l.ma = l, n.l.width = l.c, n.l.height = l.i, n.a = 0, _(n.m, u, h, g), !Be(l.c, l.i, 1, n, null) || (n.ab == 1 && n.gc[0].hc == 3 && Pe(n.s) ? (l.ic = 1, u = n.c * n.i, n.Ta = null, n.Ua = 0, n.V = a(u), n.Ba = 0, n.V == null ? (n.a = 1, n = 0) : n = 1) : (l.ic = 0, n = Ve(n, l.c)), !n)) break e;
								n = 1;
								break t;
							}
							l.mc = null, n = 0;
						}
						else n = g >= l.c * l.i;
						l = !n;
					}
					if (l) return null;
					e.ga.Lc == 1 ? o = c - i : e.Ga = 0;
				}
				t(e.ga != null), t(i + o <= c);
				t: {
					if (n = (u = e.ga).c, c = u.l.o, u.$a == 0) {
						if (h = e.rc, g = e.Vc, v = e.Fa, d = e.P + 1 + i * n, f = e.mb, p = e.nb + i * n, t(d <= e.P + e.qc), u.Z != 0) for (t(Si[u.Z] != null), l = 0; l < o; ++l) Si[u.Z](h, g, v, d, f, p, n), h = f, g = p, p += n, d += n;
						else for (l = 0; l < o; ++l) r(f, p, v, d, n), h = f, g = p, p += n, d += n;
						e.rc = h, e.Vc = g;
					} else {
						if (t(u.mc != null), n = i + o, t((l = u.mc) != null), t(n <= l.i), l.C >= n) n = 1;
						else if (u.ic || Tn(), u.ic) {
							u = l.V, h = l.Ba, g = l.c;
							var y = l.i, b = (v = 1, d = l.$ / g, f = l.$ % g, p = l.m, m = l.s, l.$), x = g * y, S = g * n, w = m.wc, E = b < S ? je(m, f, d) : null;
							t(b <= x), t(n <= y), t(Pe(m));
							e: for (;;) {
								for (; !p.h && b < S;) {
									if (f & w || (E = je(m, f, d)), t(E != null), T(p), 256 > (y = ke(E.G[0], E.H[0], p))) u[h + b] = y, ++b, ++f >= g && (f = 0, ++d <= n && !(d % 16) && Ie(l, d));
									else {
										if (!(280 > y)) {
											v = 0;
											break e;
										}
										y = H(y - 256, p);
										var D, O = ke(E.G[4], E.H[4], p);
										if (T(p), !(b >= (O = Oe(g, O = H(O, p))) && x - b >= y)) {
											v = 0;
											break e;
										}
										for (D = 0; D < y; ++D) u[h + b + D] = u[h + b + D - O];
										for (b += y, f += y; f >= g;) f -= g, ++d <= n && !(d % 16) && Ie(l, d);
										b < S && f & w && (E = je(m, f, d));
									}
									t(p.h == C(p));
								}
								Ie(l, d > n ? n : d);
								break e;
							}
							!v || p.h && b < x ? (v = 0, l.a = p.h ? 5 : 3) : l.$ = b, n = v;
						} else n = Le(l, l.V, l.Ba, l.c, l.i, n, He);
						if (!n) {
							o = 0;
							break t;
						}
					}
					i + o >= c && (e.Cc = 1), o = 1;
				}
				if (!o) return null;
				if (e.Cc && ((o = e.ga) != null && (o.mc = null), e.ga = null, 0 < e.Ga)) return alert("todo:WebPDequantizeLevels"), null;
			}
			return e.nb + i * s;
		}
		function xn(e, t, n, r, i, a) {
			for (; 0 < i--;) {
				var o, s = e, c = t + +!!n, l = e, u = t + (n ? 0 : 3);
				for (o = 0; o < r; ++o) {
					var d = l[u + 4 * o];
					d != 255 && (d *= 32897, s[c + 4 * o + 0] = s[c + 4 * o + 0] * d >> 23, s[c + 4 * o + 1] = s[c + 4 * o + 1] * d >> 23, s[c + 4 * o + 2] = s[c + 4 * o + 2] * d >> 23);
				}
				t += a;
			}
		}
		function Sn(e, t, n, r, i) {
			for (; 0 < r--;) {
				var a;
				for (a = 0; a < n; ++a) {
					var o = e[t + 2 * a + 0], s = 15 & (l = e[t + 2 * a + 1]), c = 4369 * s, l = (240 & l | l >> 4) * c >> 16;
					e[t + 2 * a + 0] = (240 & o | o >> 4) * c >> 16 & 240 | (15 & o | o << 4) * c >> 16 >> 4 & 15, e[t + 2 * a + 1] = 240 & l | s;
				}
				t += i;
			}
		}
		function Cn(e, t, n, r, i, a, o, s) {
			var c, l, u = 255;
			for (l = 0; l < i; ++l) {
				for (c = 0; c < r; ++c) {
					var d = e[t + c];
					a[o + 4 * c] = d, u &= d;
				}
				t += n, o += s;
			}
			return u != 255;
		}
		function wn(e, t, n, r, i) {
			var a;
			for (a = 0; a < i; ++a) n[r + a] = e[t + a] >> 8;
		}
		function Tn() {
			jr = xn, Mr = Sn, Nr = Cn, Pr = wn;
		}
		function En(n, r, i) {
			e[n] = function(e, n, a, o, s, c, l, u, d, f, p, m, h, g, _, v, y) {
				var b, x = y - 1 >> 1, S = s[c + 0] | l[u + 0] << 16, C = d[f + 0] | p[m + 0] << 16;
				t(e != null);
				var w = 3 * S + C + 131074 >> 2;
				for (r(e[n + 0], 255 & w, w >> 16, h, g), a != null && (w = 3 * C + S + 131074 >> 2, r(a[o + 0], 255 & w, w >> 16, _, v)), b = 1; b <= x; ++b) {
					var T = s[c + b] | l[u + b] << 16, E = d[f + b] | p[m + b] << 16, D = S + T + C + E + 524296, O = D + 2 * (T + C) >> 3;
					w = O + S >> 1, S = (D = D + 2 * (S + E) >> 3) + T >> 1, r(e[n + 2 * b - 1], 255 & w, w >> 16, h, g + (2 * b - 1) * i), r(e[n + 2 * b - 0], 255 & S, S >> 16, h, g + (2 * b - 0) * i), a != null && (w = D + C >> 1, S = O + E >> 1, r(a[o + 2 * b - 1], 255 & w, w >> 16, _, v + (2 * b - 1) * i), r(a[o + 2 * b + 0], 255 & S, S >> 16, _, v + (2 * b + 0) * i)), S = T, C = E;
				}
				1 & y || (w = 3 * S + C + 131074 >> 2, r(e[n + y - 1], 255 & w, w >> 16, h, g + (y - 1) * i), a != null && (w = 3 * C + S + 131074 >> 2, r(a[o + y - 1], 255 & w, w >> 16, _, v + (y - 1) * i)));
			};
		}
		function Dn() {
			Ci[Ur] = wi, Ci[Wr] = Ei, Ci[Gr] = Ti, Ci[Kr] = Di, Ci[qr] = Oi, Ci[Jr] = ki, Ci[Yr] = Ai, Ci[Xr] = Ei, Ci[Zr] = Di, Ci[K] = Oi, Ci[Qr] = ki;
		}
		function On(e) {
			return e & ~Ii ? 0 > e ? 0 : 255 : e >> Fi;
		}
		function kn(e, t) {
			return On((19077 * e >> 8) + (26149 * t >> 8) - 14234);
		}
		function An(e, t, n) {
			return On((19077 * e >> 8) - (6419 * t >> 8) - (13320 * n >> 8) + 8708);
		}
		function jn(e, t) {
			return On((19077 * e >> 8) + (33050 * t >> 8) - 17685);
		}
		function Mn(e, t, n, r, i) {
			r[i + 0] = kn(e, n), r[i + 1] = An(e, t, n), r[i + 2] = jn(e, t);
		}
		function Nn(e, t, n, r, i) {
			r[i + 0] = jn(e, t), r[i + 1] = An(e, t, n), r[i + 2] = kn(e, n);
		}
		function Pn(e, t, n, r, i) {
			var a = An(e, t, n);
			t = a << 3 & 224 | jn(e, t) >> 3, r[i + 0] = 248 & kn(e, n) | a >> 5, r[i + 1] = t;
		}
		function Fn(e, t, n, r, i) {
			var a = 240 & jn(e, t) | 15;
			r[i + 0] = 240 & kn(e, n) | An(e, t, n) >> 4, r[i + 1] = a;
		}
		function In(e, t, n, r, i) {
			r[i + 0] = 255, Mn(e, t, n, r, i + 1);
		}
		function Ln(e, t, n, r, i) {
			Nn(e, t, n, r, i), r[i + 3] = 255;
		}
		function Rn(e, t, n, r, i) {
			Mn(e, t, n, r, i), r[i + 3] = 255;
		}
		function zn(t, n, r) {
			e[t] = function(e, t, i, a, o, s, c, l, u) {
				for (var d = l + (-2 & u) * r; l != d;) n(e[t + 0], i[a + 0], o[s + 0], c, l), n(e[t + 1], i[a + 0], o[s + 0], c, l + r), t += 2, ++a, ++s, l += 2 * r;
				1 & u && n(e[t + 0], i[a + 0], o[s + 0], c, l);
			};
		}
		function Bn(e, t, n) {
			return n == 0 ? e == 0 ? t == 0 ? 6 : 5 : t == 0 ? 4 : 0 : n;
		}
		function Vn(e, t, n, r, i) {
			switch (e >>> 30) {
				case 3:
					mr(t, n, r, i, 0);
					break;
				case 2:
					hr(t, n, r, i);
					break;
				case 1: _r(t, n, r, i);
			}
		}
		function Hn(e, t) {
			var n, a, o = t.M, s = t.Nb, c = e.oc, l = e.pc + 40, u = e.oc, d = e.pc + 584, f = e.oc, p = e.pc + 600;
			for (n = 0; 16 > n; ++n) c[l + 32 * n - 1] = 129;
			for (n = 0; 8 > n; ++n) u[d + 32 * n - 1] = 129, f[p + 32 * n - 1] = 129;
			for (0 < o ? c[l - 1 - 32] = u[d - 1 - 32] = f[p - 1 - 32] = 129 : (i(c, l - 32 - 1, 127, 21), i(u, d - 32 - 1, 127, 9), i(f, p - 32 - 1, 127, 9)), a = 0; a < e.za; ++a) {
				var m = t.ya[t.aa + a];
				if (0 < a) {
					for (n = -1; 16 > n; ++n) r(c, l + 32 * n - 4, c, l + 32 * n + 12, 4);
					for (n = -1; 8 > n; ++n) r(u, d + 32 * n - 4, u, d + 32 * n + 4, 4), r(f, p + 32 * n - 4, f, p + 32 * n + 4, 4);
				}
				var h = e.Gd, g = e.Hd + a, _ = m.ad, v = m.Hc;
				if (0 < o && (r(c, l - 32, h[g].y, 0, 16), r(u, d - 32, h[g].f, 0, 8), r(f, p - 32, h[g].ea, 0, 8)), m.Za) {
					var y = c, b = l - 32 + 16;
					for (0 < o && (a >= e.za - 1 ? i(y, b, h[g].y[15], 4) : r(y, b, h[g + 1].y, 0, 4)), n = 0; 4 > n; n++) y[b + 128 + n] = y[b + 256 + n] = y[b + 384 + n] = y[b + 0 + n];
					for (n = 0; 16 > n; ++n, v <<= 2) y = c, b = l + Wi[n], vi[m.Ob[n]](y, b), Vn(v, _, 16 * n, y, b);
				} else if (y = Bn(a, o, m.Ob[0]), _i[y](c, l), v != 0) for (n = 0; 16 > n; ++n, v <<= 2) Vn(v, _, 16 * n, c, l + Wi[n]);
				for (n = m.Gc, y = Bn(a, o, m.Dd), yi[y](u, d), yi[y](f, p), v = _, y = u, b = d, 255 & (m = 0 | n) && (170 & m ? gr(v, 256, y, b) : vr(v, 256, y, b)), m = f, v = p, 255 & (n >>= 8) && (170 & n ? gr(_, 320, m, v) : vr(_, 320, m, v)), o < e.Ub - 1 && (r(h[g].y, 0, c, l + 480, 16), r(h[g].f, 0, u, d + 224, 8), r(h[g].ea, 0, f, p + 224, 8)), n = 8 * s * e.B, h = e.sa, g = e.ta + 16 * a + 16 * s * e.R, _ = e.qa, m = e.ra + 8 * a + n, v = e.Ha, y = e.Ia + 8 * a + n, n = 0; 16 > n; ++n) r(h, g + n * e.R, c, l + 32 * n, 16);
				for (n = 0; 8 > n; ++n) r(_, m + n * e.B, u, d + 32 * n, 8), r(v, y + n * e.B, f, p + 32 * n, 8);
			}
		}
		function Un(e, r, i, a, o, s, c, l, u) {
			var d = [0], f = [0], p = 0, m = u == null ? 0 : u.kd, h = u ?? new fn();
			if (e == null || 12 > i) return 7;
			h.data = e, h.w = r, h.ha = i, r = [r], i = [i], h.gb = [h.gb];
			t: {
				var g = r, v = i, y = h.gb;
				if (t(e != null), t(v != null), t(y != null), y[0] = 0, 12 <= v[0] && !n(e, g[0], "RIFF")) {
					if (n(e, g[0] + 8, "WEBP")) {
						y = 3;
						break t;
					}
					var b = M(e, g[0] + 4);
					if (12 > b || 4294967286 < b) {
						y = 3;
						break t;
					}
					if (m && b > v[0] - 8) {
						y = 7;
						break t;
					}
					y[0] = b, g[0] += 12, v[0] -= 12;
				}
				y = 0;
			}
			if (y != 0) return y;
			for (b = 0 < h.gb[0], i = i[0];;) {
				t: {
					var S = e;
					v = r, y = i;
					var C = d, w = f, T = g = [0];
					if ((O = p = [p])[0] = 0, 8 > y[0]) y = 7;
					else {
						if (!n(S, v[0], "VP8X")) {
							if (M(S, v[0] + 4) != 10) {
								y = 3;
								break t;
							}
							if (18 > y[0]) {
								y = 7;
								break t;
							}
							var E = M(S, v[0] + 8), D = 1 + j(S, v[0] + 12);
							if (2147483648 <= D * (S = 1 + j(S, v[0] + 15))) {
								y = 3;
								break t;
							}
							T != null && (T[0] = E), C != null && (C[0] = D), w != null && (w[0] = S), v[0] += 18, y[0] -= 18, O[0] = 1;
						}
						y = 0;
					}
				}
				if (p = p[0], g = g[0], y != 0) return y;
				if (v = !!(2 & g), !b && p) return 3;
				if (s != null && (s[0] = !!(16 & g)), c != null && (c[0] = v), l != null && (l[0] = 0), c = d[0], g = f[0], p && v && u == null) {
					y = 0;
					break;
				}
				if (4 > i) {
					y = 7;
					break;
				}
				if (b && p || !b && !p && !n(e, r[0], "ALPH")) {
					i = [i], h.na = [h.na], h.P = [h.P], h.Sa = [h.Sa];
					t: {
						E = e, y = r, b = i;
						var O = h.gb;
						C = h.na, w = h.P, T = h.Sa, D = 22, t(E != null), t(b != null), S = y[0];
						var k = b[0];
						for (t(C != null), t(T != null), C[0] = null, w[0] = null, T[0] = 0;;) {
							if (y[0] = S, b[0] = k, 8 > k) {
								y = 7;
								break t;
							}
							var A = M(E, S + 4);
							if (4294967286 < A) {
								y = 3;
								break t;
							}
							var N = 8 + A + 1 & -2;
							if (D += N, 0 < O && D > O) {
								y = 3;
								break t;
							}
							if (!n(E, S, "VP8 ") || !n(E, S, "VP8L")) {
								y = 0;
								break t;
							}
							if (k[0] < N) {
								y = 7;
								break t;
							}
							n(E, S, "ALPH") || (C[0] = E, w[0] = S + 8, T[0] = A), S += N, k -= N;
						}
					}
					if (i = i[0], h.na = h.na[0], h.P = h.P[0], h.Sa = h.Sa[0], y != 0) break;
				}
				i = [i], h.Ja = [h.Ja], h.xa = [h.xa];
				t: if (O = e, y = r, b = i, C = h.gb[0], w = h.Ja, T = h.xa, E = y[0], S = !n(O, E, "VP8 "), D = !n(O, E, "VP8L"), t(O != null), t(b != null), t(w != null), t(T != null), 8 > b[0]) y = 7;
				else {
					if (S || D) {
						if (O = M(O, E + 4), 12 <= C && O > C - 12) {
							y = 3;
							break t;
						}
						if (m && O > b[0] - 8) {
							y = 7;
							break t;
						}
						w[0] = O, y[0] += 8, b[0] -= 8, T[0] = D;
					} else T[0] = 5 <= b[0] && O[E + 0] == 47 && !(O[E + 4] >> 5), w[0] = b[0];
					y = 0;
				}
				if (i = i[0], h.Ja = h.Ja[0], h.xa = h.xa[0], r = r[0], y != 0) break;
				if (4294967286 < h.Ja) return 3;
				if (l == null || v || (l[0] = h.xa ? 2 : 1), c = [c], g = [g], h.xa) {
					if (5 > i) {
						y = 7;
						break;
					}
					l = c, m = g, v = s, e == null || 5 > i ? e = 0 : 5 <= i && e[r + 0] == 47 && !(e[r + 4] >> 5) ? (b = [0], O = [0], C = [0], _(w = new x(), e, r, i), De(w, b, O, C) ? (l != null && (l[0] = b[0]), m != null && (m[0] = O[0]), v != null && (v[0] = C[0]), e = 1) : e = 0) : e = 0;
				} else {
					if (10 > i) {
						y = 7;
						break;
					}
					l = g, e == null || 10 > i || !ot(e, r + 3, i - 3) ? e = 0 : (m = e[r + 0] | e[r + 1] << 8 | e[r + 2] << 16, v = 16383 & (e[r + 7] << 8 | e[r + 6]), e = 16383 & (e[r + 9] << 8 | e[r + 8]), 1 & m || 3 < (m >> 1 & 7) || !(m >> 4 & 1) || m >> 5 >= h.Ja || !v || !e ? e = 0 : (c && (c[0] = v), l && (l[0] = e), e = 1));
				}
				if (!e || (c = c[0], g = g[0], p && (d[0] != c || f[0] != g))) return 3;
				u != null && (u[0] = h, u.offset = r - u.w, t(4294967286 > r - u.w), t(u.offset == u.ha - i));
				break;
			}
			return y == 0 || y == 7 && p && u == null ? (s != null && (s[0] |= h.na != null && 0 < h.na.length), a != null && (a[0] = c), o != null && (o[0] = g), 0) : y;
		}
		function Wn(e, t, n) {
			var r = t.width, i = t.height, a = 0, o = 0, s = r, c = i;
			if (t.Da = e != null && 0 < e.Da, t.Da && (s = e.cd, c = e.bd, a = e.v, o = e.j, 11 > n || (a &= -2, o &= -2), 0 > a || 0 > o || 0 >= s || 0 >= c || a + s > r || o + c > i)) return 0;
			if (t.v = a, t.j = o, t.va = a + s, t.o = o + c, t.U = s, t.T = c, t.da = e != null && 0 < e.da, t.da) {
				if (!I(s, c, n = [e.ib], a = [e.hb])) return 0;
				t.ib = n[0], t.hb = a[0];
			}
			return t.ob = e != null && e.ob, t.Kb = e == null || !e.Sd, t.da && (t.ob = t.ib < 3 * r / 4 && t.hb < 3 * i / 4, t.Kb = 0), 1;
		}
		function Gn(e) {
			if (e == null) return 2;
			if (11 > e.S) {
				var t = e.f.RGBA;
				t.fb += (e.height - 1) * t.A, t.A = -t.A;
			} else t = e.f.kb, e = e.height, t.O += (e - 1) * t.fa, t.fa = -t.fa, t.N += (e - 1 >> 1) * t.Ab, t.Ab = -t.Ab, t.W += (e - 1 >> 1) * t.Db, t.Db = -t.Db, t.F != null && (t.J += (e - 1) * t.lb, t.lb = -t.lb);
			return 0;
		}
		function Kn(e, t, n, r) {
			if (r == null || 0 >= e || 0 >= t) return 2;
			if (n != null) {
				if (n.Da) {
					var i = n.cd, o = n.bd, s = -2 & n.v, c = -2 & n.j;
					if (0 > s || 0 > c || 0 >= i || 0 >= o || s + i > e || c + o > t) return 2;
					e = i, t = o;
				}
				if (n.da) {
					if (!I(e, t, i = [n.ib], o = [n.hb])) return 2;
					e = i[0], t = o[0];
				}
			}
			r.width = e, r.height = t;
			t: {
				var l = r.width, u = r.height;
				if (e = r.S, 0 >= l || 0 >= u || !(e >= Ur && 13 > e)) e = 2;
				else {
					if (0 >= r.Rd && r.sd == null) {
						s = o = i = t = 0;
						var d = (c = l * Ji[e]) * u;
						if (11 > e || (o = (u + 1) / 2 * (t = (l + 1) / 2), e == 12 && (s = (i = l) * u)), (u = a(d + 2 * o + s)) == null) {
							e = 1;
							break t;
						}
						r.sd = u, 11 > e ? ((l = r.f.RGBA).eb = u, l.fb = 0, l.A = c, l.size = d) : ((l = r.f.kb).y = u, l.O = 0, l.fa = c, l.Fd = d, l.f = u, l.N = 0 + d, l.Ab = t, l.Cd = o, l.ea = u, l.W = 0 + d + o, l.Db = t, l.Ed = o, e == 12 && (l.F = u, l.J = 0 + d + 2 * o), l.Tc = s, l.lb = i);
					}
					if (t = 1, i = r.S, o = r.width, s = r.height, i >= Ur && 13 > i) if (11 > i) e = r.f.RGBA, t &= (c = Math.abs(e.A)) * (s - 1) + o <= e.size, t &= c >= o * Ji[i], t &= e.eb != null;
					else {
						e = r.f.kb, c = (o + 1) / 2, d = (s + 1) / 2, l = Math.abs(e.fa), u = Math.abs(e.Ab);
						var f = Math.abs(e.Db), p = Math.abs(e.lb), m = p * (s - 1) + o;
						t &= l * (s - 1) + o <= e.Fd, t &= u * (d - 1) + c <= e.Cd, t = (t &= f * (d - 1) + c <= e.Ed) & l >= o & u >= c & f >= c, t &= e.y != null, t &= e.f != null, t &= e.ea != null, i == 12 && (t &= p >= o, t &= m <= e.Tc, t &= e.F != null);
					}
					else t = 0;
					e = t ? 0 : 2;
				}
			}
			return e != 0 || n != null && n.fd && (e = Gn(r)), e;
		}
		var qn = 64, Jn = [
			0,
			1,
			3,
			7,
			15,
			31,
			63,
			127,
			255,
			511,
			1023,
			2047,
			4095,
			8191,
			16383,
			32767,
			65535,
			131071,
			262143,
			524287,
			1048575,
			2097151,
			4194303,
			8388607,
			16777215
		], Yn = 24, Xn = 32, Zn = 8, Qn = [
			0,
			0,
			1,
			1,
			2,
			2,
			2,
			2,
			3,
			3,
			3,
			3,
			3,
			3,
			3,
			3,
			4,
			4,
			4,
			4,
			4,
			4,
			4,
			4,
			4,
			4,
			4,
			4,
			4,
			4,
			4,
			4,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			5,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7,
			7
		];
		R("Predictor0", "PredictorAdd0"), e.Predictor0 = function() {
			return 4278190080;
		}, e.Predictor1 = function(e) {
			return e;
		}, e.Predictor2 = function(e, t, n) {
			return t[n + 0];
		}, e.Predictor3 = function(e, t, n) {
			return t[n + 1];
		}, e.Predictor4 = function(e, t, n) {
			return t[n - 1];
		}, e.Predictor5 = function(e, t, n) {
			return z(z(e, t[n + 1]), t[n + 0]);
		}, e.Predictor6 = function(e, t, n) {
			return z(e, t[n - 1]);
		}, e.Predictor7 = function(e, t, n) {
			return z(e, t[n + 0]);
		}, e.Predictor8 = function(e, t, n) {
			return z(t[n - 1], t[n + 0]);
		}, e.Predictor9 = function(e, t, n) {
			return z(t[n + 0], t[n + 1]);
		}, e.Predictor10 = function(e, t, n) {
			return z(z(e, t[n - 1]), z(t[n + 0], t[n + 1]));
		}, e.Predictor11 = function(e, t, n) {
			var r = t[n + 0];
			return 0 >= ie(r >> 24 & 255, e >> 24 & 255, (t = t[n - 1]) >> 24 & 255) + ie(r >> 16 & 255, e >> 16 & 255, t >> 16 & 255) + ie(r >> 8 & 255, e >> 8 & 255, t >> 8 & 255) + ie(255 & r, 255 & e, 255 & t) ? r : e;
		}, e.Predictor12 = function(e, t, n) {
			var r = t[n + 0];
			return (ne((e >> 24 & 255) + (r >> 24 & 255) - ((t = t[n - 1]) >> 24 & 255)) << 24 | ne((e >> 16 & 255) + (r >> 16 & 255) - (t >> 16 & 255)) << 16 | ne((e >> 8 & 255) + (r >> 8 & 255) - (t >> 8 & 255)) << 8 | ne((255 & e) + (255 & r) - (255 & t))) >>> 0;
		}, e.Predictor13 = function(e, t, n) {
			var r = t[n - 1];
			return (re((e = z(e, t[n + 0])) >> 24 & 255, r >> 24 & 255) << 24 | re(e >> 16 & 255, r >> 16 & 255) << 16 | re(e >> 8 & 255, r >> 8 & 255) << 8 | re(255 & e, 255 & r)) >>> 0;
		};
		var $n = e.PredictorAdd0;
		e.PredictorAdd1 = ae, R("Predictor2", "PredictorAdd2"), R("Predictor3", "PredictorAdd3"), R("Predictor4", "PredictorAdd4"), R("Predictor5", "PredictorAdd5"), R("Predictor6", "PredictorAdd6"), R("Predictor7", "PredictorAdd7"), R("Predictor8", "PredictorAdd8"), R("Predictor9", "PredictorAdd9"), R("Predictor10", "PredictorAdd10"), R("Predictor11", "PredictorAdd11"), R("Predictor12", "PredictorAdd12"), R("Predictor13", "PredictorAdd13");
		var er = e.PredictorAdd2;
		ce("ColorIndexInverseTransform", "MapARGB", "32b", function(e) {
			return e >> 8 & 255;
		}, function(e) {
			return e;
		}), ce("VP8LColorIndexInverseTransformAlpha", "MapAlpha", "8b", function(e) {
			return e;
		}, function(e) {
			return e >> 8 & 255;
		});
		var tr, nr = e.ColorIndexInverseTransform, rr = e.MapARGB, ir = e.VP8LColorIndexInverseTransformAlpha, ar = e.MapAlpha, or = e.VP8LPredictorsAdd = [];
		or.length = 16, (e.VP8LPredictors = []).length = 16, (e.VP8LPredictorsAdd_C = []).length = 16, (e.VP8LPredictors_C = []).length = 16;
		var sr, cr, lr, ur, dr, fr, pr, mr, hr, gr, _r, vr, yr, br, xr, Sr, Cr, wr, Tr, Er, Dr, Or, kr, Ar, jr, Mr, Nr, Pr, Fr = a(511), G = a(2041), Ir = a(225), Lr = a(767), Rr = 0, zr = G, Br = Ir, Vr = Lr, Hr = Fr, Ur = 0, Wr = 1, Gr = 2, Kr = 3, qr = 4, Jr = 5, Yr = 6, Xr = 7, Zr = 8, K = 9, Qr = 10, $r = [
			2,
			3,
			7
		], ei = [
			3,
			3,
			11
		], ti = [
			280,
			256,
			256,
			256,
			40
		], ni = [
			0,
			1,
			1,
			1,
			0
		], ri = [
			17,
			18,
			0,
			1,
			2,
			3,
			4,
			5,
			16,
			6,
			7,
			8,
			9,
			10,
			11,
			12,
			13,
			14,
			15
		], ii = [
			24,
			7,
			23,
			25,
			40,
			6,
			39,
			41,
			22,
			26,
			38,
			42,
			56,
			5,
			55,
			57,
			21,
			27,
			54,
			58,
			37,
			43,
			72,
			4,
			71,
			73,
			20,
			28,
			53,
			59,
			70,
			74,
			36,
			44,
			88,
			69,
			75,
			52,
			60,
			3,
			87,
			89,
			19,
			29,
			86,
			90,
			35,
			45,
			68,
			76,
			85,
			91,
			51,
			61,
			104,
			2,
			103,
			105,
			18,
			30,
			102,
			106,
			34,
			46,
			84,
			92,
			67,
			77,
			101,
			107,
			50,
			62,
			120,
			1,
			119,
			121,
			83,
			93,
			17,
			31,
			100,
			108,
			66,
			78,
			118,
			122,
			33,
			47,
			117,
			123,
			49,
			63,
			99,
			109,
			82,
			94,
			0,
			116,
			124,
			65,
			79,
			16,
			32,
			98,
			110,
			48,
			115,
			125,
			81,
			95,
			64,
			114,
			126,
			97,
			111,
			80,
			113,
			127,
			96,
			112
		], ai = [
			2954,
			2956,
			2958,
			2962,
			2970,
			2986,
			3018,
			3082,
			3212,
			3468,
			3980,
			5004
		], oi = 8, si = [
			4,
			5,
			6,
			7,
			8,
			9,
			10,
			10,
			11,
			12,
			13,
			14,
			15,
			16,
			17,
			17,
			18,
			19,
			20,
			20,
			21,
			21,
			22,
			22,
			23,
			23,
			24,
			25,
			25,
			26,
			27,
			28,
			29,
			30,
			31,
			32,
			33,
			34,
			35,
			36,
			37,
			37,
			38,
			39,
			40,
			41,
			42,
			43,
			44,
			45,
			46,
			46,
			47,
			48,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			57,
			58,
			59,
			60,
			61,
			62,
			63,
			64,
			65,
			66,
			67,
			68,
			69,
			70,
			71,
			72,
			73,
			74,
			75,
			76,
			76,
			77,
			78,
			79,
			80,
			81,
			82,
			83,
			84,
			85,
			86,
			87,
			88,
			89,
			91,
			93,
			95,
			96,
			98,
			100,
			101,
			102,
			104,
			106,
			108,
			110,
			112,
			114,
			116,
			118,
			122,
			124,
			126,
			128,
			130,
			132,
			134,
			136,
			138,
			140,
			143,
			145,
			148,
			151,
			154,
			157
		], ci = [
			4,
			5,
			6,
			7,
			8,
			9,
			10,
			11,
			12,
			13,
			14,
			15,
			16,
			17,
			18,
			19,
			20,
			21,
			22,
			23,
			24,
			25,
			26,
			27,
			28,
			29,
			30,
			31,
			32,
			33,
			34,
			35,
			36,
			37,
			38,
			39,
			40,
			41,
			42,
			43,
			44,
			45,
			46,
			47,
			48,
			49,
			50,
			51,
			52,
			53,
			54,
			55,
			56,
			57,
			58,
			60,
			62,
			64,
			66,
			68,
			70,
			72,
			74,
			76,
			78,
			80,
			82,
			84,
			86,
			88,
			90,
			92,
			94,
			96,
			98,
			100,
			102,
			104,
			106,
			108,
			110,
			112,
			114,
			116,
			119,
			122,
			125,
			128,
			131,
			134,
			137,
			140,
			143,
			146,
			149,
			152,
			155,
			158,
			161,
			164,
			167,
			170,
			173,
			177,
			181,
			185,
			189,
			193,
			197,
			201,
			205,
			209,
			213,
			217,
			221,
			225,
			229,
			234,
			239,
			245,
			249,
			254,
			259,
			264,
			269,
			274,
			279,
			284
		], li = null, ui = [
			[
				173,
				148,
				140,
				0
			],
			[
				176,
				155,
				140,
				135,
				0
			],
			[
				180,
				157,
				141,
				134,
				130,
				0
			],
			[
				254,
				254,
				243,
				230,
				196,
				177,
				153,
				140,
				133,
				130,
				129,
				0
			]
		], di = [
			0,
			1,
			4,
			8,
			5,
			2,
			3,
			6,
			9,
			12,
			13,
			10,
			7,
			11,
			14,
			15
		], fi = [
			-0,
			1,
			-1,
			2,
			-2,
			3,
			4,
			6,
			-3,
			5,
			-4,
			-5,
			-6,
			7,
			-7,
			8,
			-8,
			-9
		], pi = [
			[
				[
					[
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128
					],
					[
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128
					],
					[
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128
					]
				],
				[
					[
						253,
						136,
						254,
						255,
						228,
						219,
						128,
						128,
						128,
						128,
						128
					],
					[
						189,
						129,
						242,
						255,
						227,
						213,
						255,
						219,
						128,
						128,
						128
					],
					[
						106,
						126,
						227,
						252,
						214,
						209,
						255,
						255,
						128,
						128,
						128
					]
				],
				[
					[
						1,
						98,
						248,
						255,
						236,
						226,
						255,
						255,
						128,
						128,
						128
					],
					[
						181,
						133,
						238,
						254,
						221,
						234,
						255,
						154,
						128,
						128,
						128
					],
					[
						78,
						134,
						202,
						247,
						198,
						180,
						255,
						219,
						128,
						128,
						128
					]
				],
				[
					[
						1,
						185,
						249,
						255,
						243,
						255,
						128,
						128,
						128,
						128,
						128
					],
					[
						184,
						150,
						247,
						255,
						236,
						224,
						128,
						128,
						128,
						128,
						128
					],
					[
						77,
						110,
						216,
						255,
						236,
						230,
						128,
						128,
						128,
						128,
						128
					]
				],
				[
					[
						1,
						101,
						251,
						255,
						241,
						255,
						128,
						128,
						128,
						128,
						128
					],
					[
						170,
						139,
						241,
						252,
						236,
						209,
						255,
						255,
						128,
						128,
						128
					],
					[
						37,
						116,
						196,
						243,
						228,
						255,
						255,
						255,
						128,
						128,
						128
					]
				],
				[
					[
						1,
						204,
						254,
						255,
						245,
						255,
						128,
						128,
						128,
						128,
						128
					],
					[
						207,
						160,
						250,
						255,
						238,
						128,
						128,
						128,
						128,
						128,
						128
					],
					[
						102,
						103,
						231,
						255,
						211,
						171,
						128,
						128,
						128,
						128,
						128
					]
				],
				[
					[
						1,
						152,
						252,
						255,
						240,
						255,
						128,
						128,
						128,
						128,
						128
					],
					[
						177,
						135,
						243,
						255,
						234,
						225,
						128,
						128,
						128,
						128,
						128
					],
					[
						80,
						129,
						211,
						255,
						194,
						224,
						128,
						128,
						128,
						128,
						128
					]
				],
				[
					[
						1,
						1,
						255,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128
					],
					[
						246,
						1,
						255,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128
					],
					[
						255,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128
					]
				]
			],
			[
				[
					[
						198,
						35,
						237,
						223,
						193,
						187,
						162,
						160,
						145,
						155,
						62
					],
					[
						131,
						45,
						198,
						221,
						172,
						176,
						220,
						157,
						252,
						221,
						1
					],
					[
						68,
						47,
						146,
						208,
						149,
						167,
						221,
						162,
						255,
						223,
						128
					]
				],
				[
					[
						1,
						149,
						241,
						255,
						221,
						224,
						255,
						255,
						128,
						128,
						128
					],
					[
						184,
						141,
						234,
						253,
						222,
						220,
						255,
						199,
						128,
						128,
						128
					],
					[
						81,
						99,
						181,
						242,
						176,
						190,
						249,
						202,
						255,
						255,
						128
					]
				],
				[
					[
						1,
						129,
						232,
						253,
						214,
						197,
						242,
						196,
						255,
						255,
						128
					],
					[
						99,
						121,
						210,
						250,
						201,
						198,
						255,
						202,
						128,
						128,
						128
					],
					[
						23,
						91,
						163,
						242,
						170,
						187,
						247,
						210,
						255,
						255,
						128
					]
				],
				[
					[
						1,
						200,
						246,
						255,
						234,
						255,
						128,
						128,
						128,
						128,
						128
					],
					[
						109,
						178,
						241,
						255,
						231,
						245,
						255,
						255,
						128,
						128,
						128
					],
					[
						44,
						130,
						201,
						253,
						205,
						192,
						255,
						255,
						128,
						128,
						128
					]
				],
				[
					[
						1,
						132,
						239,
						251,
						219,
						209,
						255,
						165,
						128,
						128,
						128
					],
					[
						94,
						136,
						225,
						251,
						218,
						190,
						255,
						255,
						128,
						128,
						128
					],
					[
						22,
						100,
						174,
						245,
						186,
						161,
						255,
						199,
						128,
						128,
						128
					]
				],
				[
					[
						1,
						182,
						249,
						255,
						232,
						235,
						128,
						128,
						128,
						128,
						128
					],
					[
						124,
						143,
						241,
						255,
						227,
						234,
						128,
						128,
						128,
						128,
						128
					],
					[
						35,
						77,
						181,
						251,
						193,
						211,
						255,
						205,
						128,
						128,
						128
					]
				],
				[
					[
						1,
						157,
						247,
						255,
						236,
						231,
						255,
						255,
						128,
						128,
						128
					],
					[
						121,
						141,
						235,
						255,
						225,
						227,
						255,
						255,
						128,
						128,
						128
					],
					[
						45,
						99,
						188,
						251,
						195,
						217,
						255,
						224,
						128,
						128,
						128
					]
				],
				[
					[
						1,
						1,
						251,
						255,
						213,
						255,
						128,
						128,
						128,
						128,
						128
					],
					[
						203,
						1,
						248,
						255,
						255,
						128,
						128,
						128,
						128,
						128,
						128
					],
					[
						137,
						1,
						177,
						255,
						224,
						255,
						128,
						128,
						128,
						128,
						128
					]
				]
			],
			[
				[
					[
						253,
						9,
						248,
						251,
						207,
						208,
						255,
						192,
						128,
						128,
						128
					],
					[
						175,
						13,
						224,
						243,
						193,
						185,
						249,
						198,
						255,
						255,
						128
					],
					[
						73,
						17,
						171,
						221,
						161,
						179,
						236,
						167,
						255,
						234,
						128
					]
				],
				[
					[
						1,
						95,
						247,
						253,
						212,
						183,
						255,
						255,
						128,
						128,
						128
					],
					[
						239,
						90,
						244,
						250,
						211,
						209,
						255,
						255,
						128,
						128,
						128
					],
					[
						155,
						77,
						195,
						248,
						188,
						195,
						255,
						255,
						128,
						128,
						128
					]
				],
				[
					[
						1,
						24,
						239,
						251,
						218,
						219,
						255,
						205,
						128,
						128,
						128
					],
					[
						201,
						51,
						219,
						255,
						196,
						186,
						128,
						128,
						128,
						128,
						128
					],
					[
						69,
						46,
						190,
						239,
						201,
						218,
						255,
						228,
						128,
						128,
						128
					]
				],
				[
					[
						1,
						191,
						251,
						255,
						255,
						128,
						128,
						128,
						128,
						128,
						128
					],
					[
						223,
						165,
						249,
						255,
						213,
						255,
						128,
						128,
						128,
						128,
						128
					],
					[
						141,
						124,
						248,
						255,
						255,
						128,
						128,
						128,
						128,
						128,
						128
					]
				],
				[
					[
						1,
						16,
						248,
						255,
						255,
						128,
						128,
						128,
						128,
						128,
						128
					],
					[
						190,
						36,
						230,
						255,
						236,
						255,
						128,
						128,
						128,
						128,
						128
					],
					[
						149,
						1,
						255,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128
					]
				],
				[
					[
						1,
						226,
						255,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128
					],
					[
						247,
						192,
						255,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128
					],
					[
						240,
						128,
						255,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128
					]
				],
				[
					[
						1,
						134,
						252,
						255,
						255,
						128,
						128,
						128,
						128,
						128,
						128
					],
					[
						213,
						62,
						250,
						255,
						255,
						128,
						128,
						128,
						128,
						128,
						128
					],
					[
						55,
						93,
						255,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128
					]
				],
				[
					[
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128
					],
					[
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128
					],
					[
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128
					]
				]
			],
			[
				[
					[
						202,
						24,
						213,
						235,
						186,
						191,
						220,
						160,
						240,
						175,
						255
					],
					[
						126,
						38,
						182,
						232,
						169,
						184,
						228,
						174,
						255,
						187,
						128
					],
					[
						61,
						46,
						138,
						219,
						151,
						178,
						240,
						170,
						255,
						216,
						128
					]
				],
				[
					[
						1,
						112,
						230,
						250,
						199,
						191,
						247,
						159,
						255,
						255,
						128
					],
					[
						166,
						109,
						228,
						252,
						211,
						215,
						255,
						174,
						128,
						128,
						128
					],
					[
						39,
						77,
						162,
						232,
						172,
						180,
						245,
						178,
						255,
						255,
						128
					]
				],
				[
					[
						1,
						52,
						220,
						246,
						198,
						199,
						249,
						220,
						255,
						255,
						128
					],
					[
						124,
						74,
						191,
						243,
						183,
						193,
						250,
						221,
						255,
						255,
						128
					],
					[
						24,
						71,
						130,
						219,
						154,
						170,
						243,
						182,
						255,
						255,
						128
					]
				],
				[
					[
						1,
						182,
						225,
						249,
						219,
						240,
						255,
						224,
						128,
						128,
						128
					],
					[
						149,
						150,
						226,
						252,
						216,
						205,
						255,
						171,
						128,
						128,
						128
					],
					[
						28,
						108,
						170,
						242,
						183,
						194,
						254,
						223,
						255,
						255,
						128
					]
				],
				[
					[
						1,
						81,
						230,
						252,
						204,
						203,
						255,
						192,
						128,
						128,
						128
					],
					[
						123,
						102,
						209,
						247,
						188,
						196,
						255,
						233,
						128,
						128,
						128
					],
					[
						20,
						95,
						153,
						243,
						164,
						173,
						255,
						203,
						128,
						128,
						128
					]
				],
				[
					[
						1,
						222,
						248,
						255,
						216,
						213,
						128,
						128,
						128,
						128,
						128
					],
					[
						168,
						175,
						246,
						252,
						235,
						205,
						255,
						255,
						128,
						128,
						128
					],
					[
						47,
						116,
						215,
						255,
						211,
						212,
						255,
						255,
						128,
						128,
						128
					]
				],
				[
					[
						1,
						121,
						236,
						253,
						212,
						214,
						255,
						255,
						128,
						128,
						128
					],
					[
						141,
						84,
						213,
						252,
						201,
						202,
						255,
						219,
						128,
						128,
						128
					],
					[
						42,
						80,
						160,
						240,
						162,
						185,
						255,
						205,
						128,
						128,
						128
					]
				],
				[
					[
						1,
						1,
						255,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128
					],
					[
						244,
						1,
						255,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128
					],
					[
						238,
						1,
						255,
						128,
						128,
						128,
						128,
						128,
						128,
						128,
						128
					]
				]
			]
		], mi = [
			[
				[
					231,
					120,
					48,
					89,
					115,
					113,
					120,
					152,
					112
				],
				[
					152,
					179,
					64,
					126,
					170,
					118,
					46,
					70,
					95
				],
				[
					175,
					69,
					143,
					80,
					85,
					82,
					72,
					155,
					103
				],
				[
					56,
					58,
					10,
					171,
					218,
					189,
					17,
					13,
					152
				],
				[
					114,
					26,
					17,
					163,
					44,
					195,
					21,
					10,
					173
				],
				[
					121,
					24,
					80,
					195,
					26,
					62,
					44,
					64,
					85
				],
				[
					144,
					71,
					10,
					38,
					171,
					213,
					144,
					34,
					26
				],
				[
					170,
					46,
					55,
					19,
					136,
					160,
					33,
					206,
					71
				],
				[
					63,
					20,
					8,
					114,
					114,
					208,
					12,
					9,
					226
				],
				[
					81,
					40,
					11,
					96,
					182,
					84,
					29,
					16,
					36
				]
			],
			[
				[
					134,
					183,
					89,
					137,
					98,
					101,
					106,
					165,
					148
				],
				[
					72,
					187,
					100,
					130,
					157,
					111,
					32,
					75,
					80
				],
				[
					66,
					102,
					167,
					99,
					74,
					62,
					40,
					234,
					128
				],
				[
					41,
					53,
					9,
					178,
					241,
					141,
					26,
					8,
					107
				],
				[
					74,
					43,
					26,
					146,
					73,
					166,
					49,
					23,
					157
				],
				[
					65,
					38,
					105,
					160,
					51,
					52,
					31,
					115,
					128
				],
				[
					104,
					79,
					12,
					27,
					217,
					255,
					87,
					17,
					7
				],
				[
					87,
					68,
					71,
					44,
					114,
					51,
					15,
					186,
					23
				],
				[
					47,
					41,
					14,
					110,
					182,
					183,
					21,
					17,
					194
				],
				[
					66,
					45,
					25,
					102,
					197,
					189,
					23,
					18,
					22
				]
			],
			[
				[
					88,
					88,
					147,
					150,
					42,
					46,
					45,
					196,
					205
				],
				[
					43,
					97,
					183,
					117,
					85,
					38,
					35,
					179,
					61
				],
				[
					39,
					53,
					200,
					87,
					26,
					21,
					43,
					232,
					171
				],
				[
					56,
					34,
					51,
					104,
					114,
					102,
					29,
					93,
					77
				],
				[
					39,
					28,
					85,
					171,
					58,
					165,
					90,
					98,
					64
				],
				[
					34,
					22,
					116,
					206,
					23,
					34,
					43,
					166,
					73
				],
				[
					107,
					54,
					32,
					26,
					51,
					1,
					81,
					43,
					31
				],
				[
					68,
					25,
					106,
					22,
					64,
					171,
					36,
					225,
					114
				],
				[
					34,
					19,
					21,
					102,
					132,
					188,
					16,
					76,
					124
				],
				[
					62,
					18,
					78,
					95,
					85,
					57,
					50,
					48,
					51
				]
			],
			[
				[
					193,
					101,
					35,
					159,
					215,
					111,
					89,
					46,
					111
				],
				[
					60,
					148,
					31,
					172,
					219,
					228,
					21,
					18,
					111
				],
				[
					112,
					113,
					77,
					85,
					179,
					255,
					38,
					120,
					114
				],
				[
					40,
					42,
					1,
					196,
					245,
					209,
					10,
					25,
					109
				],
				[
					88,
					43,
					29,
					140,
					166,
					213,
					37,
					43,
					154
				],
				[
					61,
					63,
					30,
					155,
					67,
					45,
					68,
					1,
					209
				],
				[
					100,
					80,
					8,
					43,
					154,
					1,
					51,
					26,
					71
				],
				[
					142,
					78,
					78,
					16,
					255,
					128,
					34,
					197,
					171
				],
				[
					41,
					40,
					5,
					102,
					211,
					183,
					4,
					1,
					221
				],
				[
					51,
					50,
					17,
					168,
					209,
					192,
					23,
					25,
					82
				]
			],
			[
				[
					138,
					31,
					36,
					171,
					27,
					166,
					38,
					44,
					229
				],
				[
					67,
					87,
					58,
					169,
					82,
					115,
					26,
					59,
					179
				],
				[
					63,
					59,
					90,
					180,
					59,
					166,
					93,
					73,
					154
				],
				[
					40,
					40,
					21,
					116,
					143,
					209,
					34,
					39,
					175
				],
				[
					47,
					15,
					16,
					183,
					34,
					223,
					49,
					45,
					183
				],
				[
					46,
					17,
					33,
					183,
					6,
					98,
					15,
					32,
					183
				],
				[
					57,
					46,
					22,
					24,
					128,
					1,
					54,
					17,
					37
				],
				[
					65,
					32,
					73,
					115,
					28,
					128,
					23,
					128,
					205
				],
				[
					40,
					3,
					9,
					115,
					51,
					192,
					18,
					6,
					223
				],
				[
					87,
					37,
					9,
					115,
					59,
					77,
					64,
					21,
					47
				]
			],
			[
				[
					104,
					55,
					44,
					218,
					9,
					54,
					53,
					130,
					226
				],
				[
					64,
					90,
					70,
					205,
					40,
					41,
					23,
					26,
					57
				],
				[
					54,
					57,
					112,
					184,
					5,
					41,
					38,
					166,
					213
				],
				[
					30,
					34,
					26,
					133,
					152,
					116,
					10,
					32,
					134
				],
				[
					39,
					19,
					53,
					221,
					26,
					114,
					32,
					73,
					255
				],
				[
					31,
					9,
					65,
					234,
					2,
					15,
					1,
					118,
					73
				],
				[
					75,
					32,
					12,
					51,
					192,
					255,
					160,
					43,
					51
				],
				[
					88,
					31,
					35,
					67,
					102,
					85,
					55,
					186,
					85
				],
				[
					56,
					21,
					23,
					111,
					59,
					205,
					45,
					37,
					192
				],
				[
					55,
					38,
					70,
					124,
					73,
					102,
					1,
					34,
					98
				]
			],
			[
				[
					125,
					98,
					42,
					88,
					104,
					85,
					117,
					175,
					82
				],
				[
					95,
					84,
					53,
					89,
					128,
					100,
					113,
					101,
					45
				],
				[
					75,
					79,
					123,
					47,
					51,
					128,
					81,
					171,
					1
				],
				[
					57,
					17,
					5,
					71,
					102,
					57,
					53,
					41,
					49
				],
				[
					38,
					33,
					13,
					121,
					57,
					73,
					26,
					1,
					85
				],
				[
					41,
					10,
					67,
					138,
					77,
					110,
					90,
					47,
					114
				],
				[
					115,
					21,
					2,
					10,
					102,
					255,
					166,
					23,
					6
				],
				[
					101,
					29,
					16,
					10,
					85,
					128,
					101,
					196,
					26
				],
				[
					57,
					18,
					10,
					102,
					102,
					213,
					34,
					20,
					43
				],
				[
					117,
					20,
					15,
					36,
					163,
					128,
					68,
					1,
					26
				]
			],
			[
				[
					102,
					61,
					71,
					37,
					34,
					53,
					31,
					243,
					192
				],
				[
					69,
					60,
					71,
					38,
					73,
					119,
					28,
					222,
					37
				],
				[
					68,
					45,
					128,
					34,
					1,
					47,
					11,
					245,
					171
				],
				[
					62,
					17,
					19,
					70,
					146,
					85,
					55,
					62,
					70
				],
				[
					37,
					43,
					37,
					154,
					100,
					163,
					85,
					160,
					1
				],
				[
					63,
					9,
					92,
					136,
					28,
					64,
					32,
					201,
					85
				],
				[
					75,
					15,
					9,
					9,
					64,
					255,
					184,
					119,
					16
				],
				[
					86,
					6,
					28,
					5,
					64,
					255,
					25,
					248,
					1
				],
				[
					56,
					8,
					17,
					132,
					137,
					255,
					55,
					116,
					128
				],
				[
					58,
					15,
					20,
					82,
					135,
					57,
					26,
					121,
					40
				]
			],
			[
				[
					164,
					50,
					31,
					137,
					154,
					133,
					25,
					35,
					218
				],
				[
					51,
					103,
					44,
					131,
					131,
					123,
					31,
					6,
					158
				],
				[
					86,
					40,
					64,
					135,
					148,
					224,
					45,
					183,
					128
				],
				[
					22,
					26,
					17,
					131,
					240,
					154,
					14,
					1,
					209
				],
				[
					45,
					16,
					21,
					91,
					64,
					222,
					7,
					1,
					197
				],
				[
					56,
					21,
					39,
					155,
					60,
					138,
					23,
					102,
					213
				],
				[
					83,
					12,
					13,
					54,
					192,
					255,
					68,
					47,
					28
				],
				[
					85,
					26,
					85,
					85,
					128,
					128,
					32,
					146,
					171
				],
				[
					18,
					11,
					7,
					63,
					144,
					171,
					4,
					4,
					246
				],
				[
					35,
					27,
					10,
					146,
					174,
					171,
					12,
					26,
					128
				]
			],
			[
				[
					190,
					80,
					35,
					99,
					180,
					80,
					126,
					54,
					45
				],
				[
					85,
					126,
					47,
					87,
					176,
					51,
					41,
					20,
					32
				],
				[
					101,
					75,
					128,
					139,
					118,
					146,
					116,
					128,
					85
				],
				[
					56,
					41,
					15,
					176,
					236,
					85,
					37,
					9,
					62
				],
				[
					71,
					30,
					17,
					119,
					118,
					255,
					17,
					18,
					138
				],
				[
					101,
					38,
					60,
					138,
					55,
					70,
					43,
					26,
					142
				],
				[
					146,
					36,
					19,
					30,
					171,
					255,
					97,
					27,
					20
				],
				[
					138,
					45,
					61,
					62,
					219,
					1,
					81,
					188,
					64
				],
				[
					32,
					41,
					20,
					117,
					151,
					142,
					20,
					21,
					163
				],
				[
					112,
					19,
					12,
					61,
					195,
					128,
					48,
					4,
					24
				]
			]
		], hi = [
			[
				[
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						176,
						246,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						223,
						241,
						252,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						249,
						253,
						253,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						244,
						252,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						234,
						254,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						253,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						246,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						239,
						253,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						254,
						255,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						248,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						251,
						255,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						253,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						251,
						254,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						254,
						255,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						254,
						253,
						255,
						254,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						250,
						255,
						254,
						255,
						254,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				]
			],
			[
				[
					[
						217,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						225,
						252,
						241,
						253,
						255,
						255,
						254,
						255,
						255,
						255,
						255
					],
					[
						234,
						250,
						241,
						250,
						253,
						255,
						253,
						254,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						223,
						254,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						238,
						253,
						254,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						248,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						249,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						253,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						247,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						253,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						252,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						254,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						253,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						254,
						253,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						250,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				]
			],
			[
				[
					[
						186,
						251,
						250,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						234,
						251,
						244,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						251,
						251,
						243,
						253,
						254,
						255,
						254,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						253,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						236,
						253,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						251,
						253,
						253,
						254,
						254,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						254,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						254,
						254,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						254,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				]
			],
			[
				[
					[
						248,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						250,
						254,
						252,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						248,
						254,
						249,
						253,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						253,
						253,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						246,
						253,
						253,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						252,
						254,
						251,
						254,
						254,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						254,
						252,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						248,
						254,
						253,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						253,
						255,
						254,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						251,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						245,
						251,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						253,
						253,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						251,
						253,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						252,
						253,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						255,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						252,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						249,
						255,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						255,
						255,
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						255,
						253,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						250,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				],
				[
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						254,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					],
					[
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255,
						255
					]
				]
			]
		], gi = [
			0,
			1,
			2,
			3,
			6,
			4,
			5,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			6,
			7,
			0
		], _i = [], vi = [], yi = [], bi = 1, xi = 2, Si = [], Ci = [];
		En("UpsampleRgbLinePair", Mn, 3), En("UpsampleBgrLinePair", Nn, 3), En("UpsampleRgbaLinePair", Rn, 4), En("UpsampleBgraLinePair", Ln, 4), En("UpsampleArgbLinePair", In, 4), En("UpsampleRgba4444LinePair", Fn, 2), En("UpsampleRgb565LinePair", Pn, 2);
		var wi = e.UpsampleRgbLinePair, Ti = e.UpsampleBgrLinePair, Ei = e.UpsampleRgbaLinePair, Di = e.UpsampleBgraLinePair, Oi = e.UpsampleArgbLinePair, ki = e.UpsampleRgba4444LinePair, Ai = e.UpsampleRgb565LinePair, ji = 16, Mi = 1 << ji - 1, Ni = -227, Pi = 482, Fi = 6, Ii = (256 << Fi) - 1, Li = 0, Ri = a(256), zi = a(256), Bi = a(256), Vi = a(256), Hi = a(Pi - Ni), Ui = a(Pi - Ni);
		zn("YuvToRgbRow", Mn, 3), zn("YuvToBgrRow", Nn, 3), zn("YuvToRgbaRow", Rn, 4), zn("YuvToBgraRow", Ln, 4), zn("YuvToArgbRow", In, 4), zn("YuvToRgba4444Row", Fn, 2), zn("YuvToRgb565Row", Pn, 2);
		var Wi = [
			0,
			4,
			8,
			12,
			128,
			132,
			136,
			140,
			256,
			260,
			264,
			268,
			384,
			388,
			392,
			396
		], Gi = [
			0,
			2,
			8
		], Ki = [
			8,
			7,
			6,
			4,
			4,
			2,
			2,
			2,
			1,
			1,
			1,
			1
		], qi = 1;
		this.WebPDecodeRGBA = function(e, n, s, c, l) {
			var u = Wr, d = new dn(), f = new ve();
			d.ba = f, f.S = u, f.width = [f.width], f.height = [f.height];
			var p = f.width, m = f.height, h = new ye();
			if (h == null || e == null) var g = 2;
			else t(h != null), g = Un(e, n, s, h.width, h.height, h.Pd, h.Qd, h.format, null);
			if (g == 0 ? (p != null && (p[0] = h.width[0]), m != null && (m[0] = h.height[0]), p = 1) : p = 0, p) {
				f.width = f.width[0], f.height = f.height[0], c != null && (c[0] = f.width), l != null && (l[0] = f.height);
				t: {
					if (c = new rt(), (l = new fn()).data = e, l.w = n, l.ha = s, l.kd = 1, n = [0], t(l != null), ((e = Un(l.data, l.w, l.ha, null, null, null, n, null, l)) == 0 || e == 7) && n[0] && (e = 4), (n = e) == 0) {
						if (t(d != null), c.data = l.data, c.w = l.w + l.offset, c.ha = l.ha - l.offset, c.put = Te, c.ac = we, c.bc = Ee, c.ma = d, l.xa) {
							if ((e = ze()) == null) {
								d = 1;
								break t;
							}
							if (function(e, n) {
								var r = [0], i = [0], a = [0];
								e: for (;;) {
									if (e == null) return 0;
									if (n == null) return e.a = 2, 0;
									if (e.l = n, e.a = 0, _(e.m, n.data, n.w, n.ha), !De(e.m, r, i, a)) {
										e.a = 3;
										break e;
									}
									if (e.xb = xi, n.width = r[0], n.height = i[0], !Be(r[0], i[0], 1, e, null)) break e;
									return 1;
								}
								return t(e.a != 0), 0;
							}(e, c)) {
								if (c = (n = Kn(c.width, c.height, d.Oa, d.ba)) == 0) {
									e: {
										c = e;
										r: for (;;) {
											if (c == null) {
												c = 0;
												break e;
											}
											if (t(c.s.yc != null), t(c.s.Ya != null), t(0 < c.s.Wb), t((s = c.l) != null), t((l = s.ma) != null), c.xb != 0) {
												if (c.ca = l.ba, c.tb = l.tb, t(c.ca != null), !Wn(l.Oa, s, Kr)) {
													c.a = 2;
													break r;
												}
												if (!Ve(c, s.width) || s.da) break r;
												if ((s.da || he(c.ca.S)) && Tn(), 11 > c.ca.S || (alert("todo:WebPInitConvertARGBToYUV"), c.ca.f.kb.F != null && Tn()), c.Pb && 0 < c.s.ua && c.s.vb.X == null && !N(c.s.vb, c.s.Wa.Xa)) {
													c.a = 1;
													break r;
												}
												c.xb = 0;
											}
											if (!Le(c, c.V, c.Ba, c.c, c.i, s.o, Ne)) break r;
											l.Dc = c.Ma, c = 1;
											break e;
										}
										t(c.a != 0), c = 0;
									}
									c = !c;
								}
								c && (n = e.a);
							} else n = e.a;
						} else {
							if ((e = new it()) == null) {
								d = 1;
								break t;
							}
							if (e.Fa = l.na, e.P = l.P, e.qc = l.Sa, st(e, c)) {
								if ((n = Kn(c.width, c.height, d.Oa, d.ba)) == 0) {
									if (e.Aa = 0, s = d.Oa, t((l = e) != null), s != null) {
										if (0 < (p = 0 > (p = s.Md) ? 0 : 100 < p ? 255 : 255 * p / 100)) {
											for (m = h = 0; 4 > m; ++m) 12 > (g = l.pb[m]).lc && (g.ia = p * Ki[0 > g.lc ? 0 : g.lc] >> 3), h |= g.ia;
											h && (alert("todo:VP8InitRandom"), l.ia = 1);
										}
										l.Ga = s.Id, 100 < l.Ga ? l.Ga = 100 : 0 > l.Ga && (l.Ga = 0);
									}
									(function(e, n) {
										if (e == null) return 0;
										if (n == null) return at(e, 2, "NULL VP8Io parameter in VP8Decode().");
										if (!e.cb && !st(e, n)) return 0;
										if (t(e.cb), n.ac == null || n.ac(n)) {
											n.ob && (e.L = 0);
											var s = Gi[e.L];
											if (e.L == 2 ? (e.yb = 0, e.zb = 0) : (e.yb = n.v - s >> 4, e.zb = n.j - s >> 4, 0 > e.yb && (e.yb = 0), 0 > e.zb && (e.zb = 0)), e.Va = n.o + 15 + s >> 4, e.Hb = n.va + 15 + s >> 4, e.Hb > e.za && (e.Hb = e.za), e.Va > e.Ub && (e.Va = e.Ub), 0 < e.L) {
												var c = e.ed;
												for (s = 0; 4 > s; ++s) {
													var l;
													if (e.Qa.Cb) {
														var u = e.Qa.Lb[s];
														e.Qa.Fb || (u += c.Tb);
													} else u = c.Tb;
													for (l = 0; 1 >= l; ++l) {
														var d = e.gd[s][l], f = u;
														if (c.Pc && (f += c.vd[0], l && (f += c.od[0])), 0 < (f = 0 > f ? 0 : 63 < f ? 63 : f)) {
															var p = f;
															0 < c.wb && (p = 4 < c.wb ? p >> 2 : p >> 1) > 9 - c.wb && (p = 9 - c.wb), 1 > p && (p = 1), d.dd = p, d.tc = 2 * f + p, d.ld = 40 <= f ? 2 : +(15 <= f);
														} else d.tc = 0;
														d.La = l;
													}
												}
											}
											s = 0;
										} else at(e, 6, "Frame setup failed"), s = e.a;
										if (s = s == 0) {
											if (s) {
												e.$c = 0, 0 < e.Aa || (e.Ic = qi);
												e: {
													s = e.Ic, c = 4 * (p = e.za);
													var m = 32 * p, h = p + 1, g = 0 < e.L ? p * (0 < e.Aa ? 2 : 1) : 0, _ = (e.Aa == 2 ? 2 : 1) * p;
													if ((d = c + 832 + (l = 3 * (16 * s + Gi[e.L]) / 2 * m) + (u = e.Fa != null && 0 < e.Fa.length ? e.Kc.c * e.Kc.i : 0)) != d) s = 0;
													else {
														if (d > e.Vb) {
															if (e.Vb = 0, e.Ec = a(d), e.Fc = 0, e.Ec == null) {
																s = at(e, 1, "no memory during frame initialization.");
																break e;
															}
															e.Vb = d;
														}
														d = e.Ec, f = e.Fc, e.Ac = d, e.Bc = f, f += c, e.Gd = o(m, et), e.Hd = 0, e.rb = o(h + 1, Xe), e.sb = 1, e.wa = g ? o(g, Ye) : null, e.Y = 0, e.D.Nb = 0, e.D.wa = e.wa, e.D.Y = e.Y, 0 < e.Aa && (e.D.Y += p), t(!0), e.oc = d, e.pc = f, f += 832, e.ya = o(_, Qe), e.aa = 0, e.D.ya = e.ya, e.D.aa = e.aa, e.Aa == 2 && (e.D.aa += p), e.R = 16 * p, e.B = 8 * p, p = (m = Gi[e.L]) * e.R, m = m / 2 * e.B, e.sa = d, e.ta = f + p, e.qa = e.sa, e.ra = e.ta + 16 * s * e.R + m, e.Ha = e.qa, e.Ia = e.ra + 8 * s * e.B + m, e.$c = 0, f += l, e.mb = u ? d : null, e.nb = u ? f : null, t(f + u <= e.Fc + e.Vb), lt(e), i(e.Ac, e.Bc, 0, c), s = 1;
													}
												}
												if (s) {
													if (n.ka = 0, n.y = e.sa, n.O = e.ta, n.f = e.qa, n.N = e.ra, n.ea = e.Ha, n.Vd = e.Ia, n.fa = e.R, n.Rc = e.B, n.F = null, n.J = 0, !Rr) {
														for (s = -255; 255 >= s; ++s) Fr[255 + s] = 0 > s ? -s : s;
														for (s = -1020; 1020 >= s; ++s) G[1020 + s] = -128 > s ? -128 : 127 < s ? 127 : s;
														for (s = -112; 112 >= s; ++s) Ir[112 + s] = -16 > s ? -16 : 15 < s ? 15 : s;
														for (s = -255; 510 >= s; ++s) Lr[255 + s] = 0 > s ? 0 : 255 < s ? 255 : s;
														Rr = 1;
													}
													pr = yt, mr = ht, gr = gt, _r = _t, vr = vt, hr = mt, yr = nn, br = rn, xr = sn, Sr = cn, Cr = an, wr = on, Tr = ln, Er = un, Dr = Xt, Or = Zt, kr = Qt, Ar = $t, vi[0] = Mt, vi[1] = xt, vi[2] = At, vi[3] = jt, vi[4] = Nt, vi[5] = Ft, vi[6] = Pt, vi[7] = It, vi[8] = Rt, vi[9] = Lt, _i[0] = Dt, _i[1] = Ct, _i[2] = wt, _i[3] = Tt, _i[4] = Ot, _i[5] = U, _i[6] = W, yi[0] = Ht, yi[1] = St, yi[2] = zt, yi[3] = Bt, yi[4] = Wt, yi[5] = Ut, yi[6] = Gt, s = 1;
												} else s = 0;
											}
											s &&= function(e, n) {
												for (e.M = 0; e.M < e.Va; ++e.M) {
													var o, s = e.Jc[e.M & e.Xb], c = e.m, l = e;
													for (o = 0; o < l.za; ++o) {
														var u = c, d = l, f = d.Ac, p = d.Bc + 4 * o, m = d.zc, h = d.ya[d.aa + o];
														if (d.Qa.Bb ? h.$b = O(u, d.Pa.jb[0]) ? 2 + O(u, d.Pa.jb[2]) : O(u, d.Pa.jb[1]) : h.$b = 0, d.kc && (h.Ad = O(u, d.Bd)), h.Za = !O(u, 145) + 0, h.Za) {
															var g = h.Ob, _ = 0;
															for (d = 0; 4 > d; ++d) {
																var v, y = m[0 + d];
																for (v = 0; 4 > v; ++v) {
																	y = mi[f[p + v]][y];
																	for (var b = fi[O(u, y[0])]; 0 < b;) b = fi[2 * b + O(u, y[b])];
																	y = -b, f[p + v] = y;
																}
																r(g, _, f, p, 4), _ += 4, m[0 + d] = y;
															}
														} else y = O(u, 156) ? O(u, 128) ? 1 : 3 : O(u, 163) ? 2 : 0, h.Ob[0] = y, i(f, p, y, 4), i(m, 0, y, 4);
														h.Dd = O(u, 142) ? O(u, 114) ? O(u, 183) ? 1 : 3 : 2 : 0;
													}
													if (l.m.Ka) return at(e, 7, "Premature end-of-partition0 encountered.");
													for (; e.ja < e.za; ++e.ja) {
														if (l = s, u = (c = e).rb[c.sb - 1], f = c.rb[c.sb + c.ja], o = c.ya[c.aa + c.ja], p = c.kc ? o.Ad : 0) u.la = f.la = 0, o.Za || (u.Na = f.Na = 0), o.Hc = 0, o.Gc = 0, o.ia = 0;
														else {
															var x, S;
															if (u = f, f = l, p = c.Pa.Xc, m = c.ya[c.aa + c.ja], h = c.pb[m.$b], d = m.ad, g = 0, _ = c.rb[c.sb - 1], y = v = 0, i(d, g, 0, 384), m.Za) var C = 0, w = p[3];
															else {
																b = a(16);
																var T = u.Na + _.Na;
																if (T = li(f, p[1], T, h.Eb, 0, b, 0), u.Na = _.Na = (0 < T) + 0, 1 < T) pr(b, 0, d, g);
																else {
																	var E = b[0] + 3 >> 3;
																	for (b = 0; 256 > b; b += 16) d[g + b] = E;
																}
																C = 1, w = p[0];
															}
															var D = 15 & u.la, k = 15 & _.la;
															for (b = 0; 4 > b; ++b) {
																var A = 1 & k;
																for (E = S = 0; 4 > E; ++E) D = D >> 1 | (A = (T = li(f, w, T = A + (1 & D), h.Sc, C, d, g)) > C) << 7, S = S << 2 | (3 < T ? 3 : 1 < T ? 2 : d[g + 0] != 0), g += 16;
																D >>= 4, k = k >> 1 | A << 7, v = (v << 8 | S) >>> 0;
															}
															for (w = D, C = k >> 4, x = 0; 4 > x; x += 2) {
																for (S = 0, D = u.la >> 4 + x, k = _.la >> 4 + x, b = 0; 2 > b; ++b) {
																	for (A = 1 & k, E = 0; 2 > E; ++E) T = A + (1 & D), D = D >> 1 | (A = 0 < (T = li(f, p[2], T, h.Qc, 0, d, g))) << 3, S = S << 2 | (3 < T ? 3 : 1 < T ? 2 : d[g + 0] != 0), g += 16;
																	D >>= 2, k = k >> 1 | A << 5;
																}
																y |= S << 4 * x, w |= D << 4 << x, C |= (240 & k) << x;
															}
															u.la = w, _.la = C, m.Hc = v, m.Gc = y, m.ia = 43690 & y ? 0 : h.ia, p = !(v | y);
														}
														if (0 < c.L && (c.wa[c.Y + c.ja] = c.gd[o.$b][o.Za], c.wa[c.Y + c.ja].La |= !p), l.Ka) return at(e, 7, "Premature end-of-file encountered.");
													}
													if (lt(e), c = n, l = 1, o = (s = e).D, u = 0 < s.L && s.M >= s.zb && s.M <= s.Va, s.Aa == 0) e: {
														if (o.M = s.M, o.uc = u, Hn(s, o), l = 1, o = (S = s.D).Nb, u = (y = Gi[s.L]) * s.R, f = y / 2 * s.B, b = 16 * o * s.R, E = 8 * o * s.B, p = s.sa, m = s.ta - u + b, h = s.qa, d = s.ra - f + E, g = s.Ha, _ = s.Ia - f + E, k = (D = S.M) == 0, v = D >= s.Va - 1, s.Aa == 2 && Hn(s, S), S.uc) for (A = (T = s).D.M, t(T.D.uc), S = T.yb; S < T.Hb; ++S) {
															C = S, w = A;
															var j = (M = (z = T).D).Nb;
															x = z.R;
															var M = M.wa[M.Y + C], N = z.sa, P = z.ta + 16 * j * x + 16 * C, F = M.dd, I = M.tc;
															if (I != 0) if (t(3 <= I), z.L == 1) 0 < C && Or(N, P, x, I + 4), M.La && Ar(N, P, x, I), 0 < w && Dr(N, P, x, I + 4), M.La && kr(N, P, x, I);
															else {
																var ee = z.B, L = z.qa, R = z.ra + 8 * j * ee + 8 * C, te = z.Ha, z = z.Ia + 8 * j * ee + 8 * C;
																j = M.ld, 0 < C && (br(N, P, x, I + 4, F, j), Sr(L, R, te, z, ee, I + 4, F, j)), M.La && (wr(N, P, x, I, F, j), Er(L, R, te, z, ee, I, F, j)), 0 < w && (yr(N, P, x, I + 4, F, j), xr(L, R, te, z, ee, I + 4, F, j)), M.La && (Cr(N, P, x, I, F, j), Tr(L, R, te, z, ee, I, F, j));
															}
														}
														if (s.ia && alert("todo:DitherRow"), c.put != null) {
															if (S = 16 * D, D = 16 * (D + 1), k ? (c.y = s.sa, c.O = s.ta + b, c.f = s.qa, c.N = s.ra + E, c.ea = s.Ha, c.W = s.Ia + E) : (S -= y, c.y = p, c.O = m, c.f = h, c.N = d, c.ea = g, c.W = _), v || (D -= y), D > c.o && (D = c.o), c.F = null, c.J = null, s.Fa != null && 0 < s.Fa.length && S < D && (c.J = bn(s, c, S, D - S), c.F = s.mb, c.F == null && c.F.length == 0)) {
																l = at(s, 3, "Could not decode alpha data.");
																break e;
															}
															S < c.j && (y = c.j - S, S = c.j, t(!(1 & y)), c.O += s.R * y, c.N += s.B * (y >> 1), c.W += s.B * (y >> 1), c.F != null && (c.J += c.width * y)), S < D && (c.O += c.v, c.N += c.v >> 1, c.W += c.v >> 1, c.F != null && (c.J += c.v), c.ka = S - c.j, c.U = c.va - c.v, c.T = D - S, l = c.put(c));
														}
														o + 1 != s.Ic || v || (r(s.sa, s.ta - u, p, m + 16 * s.R, u), r(s.qa, s.ra - f, h, d + 8 * s.B, f), r(s.Ha, s.Ia - f, g, _ + 8 * s.B, f));
													}
													if (!l) return at(e, 6, "Output aborted.");
												}
												return 1;
											}(e, n), n.bc != null && n.bc(n), s &= 1;
										}
										return s ? (e.cb = 0, s) : 0;
									})(e, c) || (n = e.a);
								}
							} else n = e.a;
						}
						n == 0 && d.Oa != null && d.Oa.fd && (n = Gn(d.ba));
					}
					d = n;
				}
				u = d == 0 ? 11 > u ? f.f.RGBA.eb : f.f.kb.y : null;
			} else u = null;
			return u;
		};
		var Ji = [
			3,
			4,
			3,
			4,
			4,
			2,
			2,
			4,
			4,
			4,
			2,
			1,
			1
		];
	};
	function l(e, t) {
		for (var n = "", r = 0; r < 4; r++) n += String.fromCharCode(e[t++]);
		return n;
	}
	function u(e, t) {
		return e[t + 0] | e[t + 1] << 8;
	}
	function d(e, t) {
		return (e[t + 0] | e[t + 1] << 8 | e[t + 2] << 16) >>> 0;
	}
	function f(e, t) {
		return (e[t + 0] | e[t + 1] << 8 | e[t + 2] << 16 | e[t + 3] << 24) >>> 0;
	}
	new c();
	var p = [0], m = [0], h = [], g = new c(), _ = e, v = function(e, t) {
		var n = {}, r = 0, i = !1, a = 0, o = 0;
		if (n.frames = [], !function(e, t) {
			for (var n = 0; n < 4; n++) if (e[t + n] != "RIFF".charCodeAt(n)) return !0;
			return !1;
		}(e, t)) {
			for (f(e, t += 4), t += 8; t < e.length;) {
				var s = l(e, t), c = f(e, t += 4);
				t += 4;
				var p = c + (1 & c);
				switch (s) {
					case "VP8 ":
					case "VP8L":
						n.frames[r] === void 0 && (n.frames[r] = {}), (g = n.frames[r]).src_off = i ? o : t - 8, g.src_size = a + c + 8, r++, i && (i = !1, a = 0, o = 0);
						break;
					case "VP8X":
						(g = n.header = {}).feature_flags = e[t];
						var m = t + 4;
						g.canvas_width = 1 + d(e, m), m += 3, g.canvas_height = 1 + d(e, m), m += 3;
						break;
					case "ALPH":
						i = !0, a = p + 8, o = t - 8;
						break;
					case "ANIM":
						(g = n.header).bgcolor = f(e, t), m = t + 4, g.loop_count = u(e, m), m += 2;
						break;
					case "ANMF":
						var h, g;
						(g = n.frames[r] = {}).offset_x = 2 * d(e, t), t += 3, g.offset_y = 2 * d(e, t), t += 3, g.width = 1 + d(e, t), t += 3, g.height = 1 + d(e, t), t += 3, g.duration = d(e, t), t += 3, h = e[t++], g.dispose = 1 & h, g.blend = h >> 1 & 1;
				}
				s != "ANMF" && (t += p);
			}
			return n;
		}
	}(_, 0);
	v.response = _, v.rgbaoutput = !0, v.dataurl = !1;
	var y = v.header ? v.header : null, b = v.frames ? v.frames : null;
	if (y) {
		y.loop_counter = y.loop_count, p = [y.canvas_height], m = [y.canvas_width];
		for (var x = 0; x < b.length && b[x].blend != 0; x++);
	}
	var S = b[0], C = g.WebPDecodeRGBA(_, S.src_off, S.src_size, m, p);
	S.rgba = C, S.imgwidth = m[0], S.imgheight = p[0];
	for (var w = 0; w < m[0] * p[0] * 4; w++) h[w] = C[w];
	return this.width = m, this.height = p, this.data = h, this;
}
function tS() {
	var e, t = this.internal.__metadata__.metadata, n = unescape(encodeURIComponent(t));
	e = this.internal.__metadata__.rawXml ? n : "<x:xmpmeta xmlns:x=\"adobe:ns:meta/\"><rdf:RDF xmlns:rdf=\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\"><rdf:Description rdf:about=\"\" xmlns:jspdf=\"" + this.internal.__metadata__.namespaceUri + "\"><jspdf:metadata>" + n.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;") + "</jspdf:metadata></rdf:Description></rdf:RDF></x:xmpmeta>", this.internal.__metadata__.metadataObjectNumber = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + e.length + " >>"), this.internal.write("stream"), this.internal.write(e), this.internal.write("endstream"), this.internal.write("endobj");
}
function nS() {
	this.internal.__metadata__.metadataObjectNumber && this.internal.write("/Metadata " + this.internal.__metadata__.metadataObjectNumber + " 0 R");
}
(function(e) {
	var t, n, r, i, a, o, s, c, l, u = function(e) {
		return e ||= {}, this.isStrokeTransparent = e.isStrokeTransparent || !1, this.strokeOpacity = e.strokeOpacity || 1, this.strokeStyle = e.strokeStyle || "#000000", this.fillStyle = e.fillStyle || "#000000", this.isFillTransparent = e.isFillTransparent || !1, this.fillOpacity = e.fillOpacity || 1, this.font = e.font || "10px sans-serif", this.textBaseline = e.textBaseline || "alphabetic", this.textAlign = e.textAlign || "left", this.lineWidth = e.lineWidth || 1, this.lineJoin = e.lineJoin || "miter", this.lineCap = e.lineCap || "butt", this.path = e.path || [], this.transform = e.transform === void 0 ? new c() : e.transform.clone(), this.globalCompositeOperation = e.globalCompositeOperation || "normal", this.globalAlpha = e.globalAlpha || 1, this.clip_path = e.clip_path || [], this.currentPoint = e.currentPoint || new o(), this.miterLimit = e.miterLimit || 10, this.lastPoint = e.lastPoint || new o(), this.lineDashOffset = e.lineDashOffset || 0, this.lineDash = e.lineDash || [], this.margin = e.margin || [
			0,
			0,
			0,
			0
		], this.prevPageLastElemOffset = e.prevPageLastElemOffset || 0, this.ignoreClearRect = typeof e.ignoreClearRect != "boolean" || e.ignoreClearRect, this;
	};
	e.events.push(["initialized", function() {
		this.context2d = new d(this), t = this.internal.f2, n = this.internal.getCoordinateString, r = this.internal.getVerticalCoordinateString, i = this.internal.getHorizontalCoordinate, a = this.internal.getVerticalCoordinate, o = this.internal.Point, s = this.internal.Rectangle, c = this.internal.Matrix, l = new u();
	}]);
	var d = function(e) {
		Object.defineProperty(this, "canvas", { get: function() {
			return {
				parentNode: !1,
				style: !1
			};
		} });
		var t = e;
		Object.defineProperty(this, "pdf", { get: function() {
			return t;
		} });
		var n = !1;
		Object.defineProperty(this, "pageWrapXEnabled", {
			get: function() {
				return n;
			},
			set: function(e) {
				n = !!e;
			}
		});
		var r = !1;
		Object.defineProperty(this, "pageWrapYEnabled", {
			get: function() {
				return r;
			},
			set: function(e) {
				r = !!e;
			}
		});
		var i = 0;
		Object.defineProperty(this, "posX", {
			get: function() {
				return i;
			},
			set: function(e) {
				isNaN(e) || (i = e);
			}
		});
		var a = 0;
		Object.defineProperty(this, "posY", {
			get: function() {
				return a;
			},
			set: function(e) {
				isNaN(e) || (a = e);
			}
		}), Object.defineProperty(this, "margin", {
			get: function() {
				return l.margin;
			},
			set: function(e) {
				var t;
				typeof e == "number" ? t = [
					e,
					e,
					e,
					e
				] : ((t = [
					,
					,
					,
					,
				])[0] = e[0], t[1] = e.length >= 2 ? e[1] : t[0], t[2] = e.length >= 3 ? e[2] : t[0], t[3] = e.length >= 4 ? e[3] : t[1]), l.margin = t;
			}
		});
		var o = !1;
		Object.defineProperty(this, "autoPaging", {
			get: function() {
				return o;
			},
			set: function(e) {
				o = e;
			}
		});
		var s = 0;
		Object.defineProperty(this, "lastBreak", {
			get: function() {
				return s;
			},
			set: function(e) {
				s = e;
			}
		});
		var c = [];
		Object.defineProperty(this, "pageBreaks", {
			get: function() {
				return c;
			},
			set: function(e) {
				c = e;
			}
		}), Object.defineProperty(this, "ctx", {
			get: function() {
				return l;
			},
			set: function(e) {
				e instanceof u && (l = e);
			}
		}), Object.defineProperty(this, "path", {
			get: function() {
				return l.path;
			},
			set: function(e) {
				l.path = e;
			}
		});
		var d = [];
		Object.defineProperty(this, "ctxStack", {
			get: function() {
				return d;
			},
			set: function(e) {
				d = e;
			}
		}), Object.defineProperty(this, "fillStyle", {
			get: function() {
				return this.ctx.fillStyle;
			},
			set: function(e) {
				var t = f(e);
				this.ctx.fillStyle = t.style, this.ctx.isFillTransparent = t.a === 0, this.ctx.fillOpacity = t.a, this.pdf.setFillColor(t.r, t.g, t.b, { a: t.a }), this.pdf.setTextColor(t.r, t.g, t.b, { a: t.a });
			}
		}), Object.defineProperty(this, "strokeStyle", {
			get: function() {
				return this.ctx.strokeStyle;
			},
			set: function(e) {
				var t = f(e);
				this.ctx.strokeStyle = t.style, this.ctx.isStrokeTransparent = t.a === 0, this.ctx.strokeOpacity = t.a, t.a === 0 ? this.pdf.setDrawColor(255, 255, 255) : (t.a, this.pdf.setDrawColor(t.r, t.g, t.b));
			}
		}), Object.defineProperty(this, "lineCap", {
			get: function() {
				return this.ctx.lineCap;
			},
			set: function(e) {
				[
					"butt",
					"round",
					"square"
				].indexOf(e) !== -1 && (this.ctx.lineCap = e, this.pdf.setLineCap(e));
			}
		}), Object.defineProperty(this, "lineWidth", {
			get: function() {
				return this.ctx.lineWidth;
			},
			set: function(e) {
				isNaN(e) || (this.ctx.lineWidth = e, this.pdf.setLineWidth(e));
			}
		}), Object.defineProperty(this, "lineJoin", {
			get: function() {
				return this.ctx.lineJoin;
			},
			set: function(e) {
				[
					"bevel",
					"round",
					"miter"
				].indexOf(e) !== -1 && (this.ctx.lineJoin = e, this.pdf.setLineJoin(e));
			}
		}), Object.defineProperty(this, "miterLimit", {
			get: function() {
				return this.ctx.miterLimit;
			},
			set: function(e) {
				isNaN(e) || (this.ctx.miterLimit = e, this.pdf.setMiterLimit(e));
			}
		}), Object.defineProperty(this, "textBaseline", {
			get: function() {
				return this.ctx.textBaseline;
			},
			set: function(e) {
				this.ctx.textBaseline = e;
			}
		}), Object.defineProperty(this, "textAlign", {
			get: function() {
				return this.ctx.textAlign;
			},
			set: function(e) {
				[
					"right",
					"end",
					"center",
					"left",
					"start"
				].indexOf(e) !== -1 && (this.ctx.textAlign = e);
			}
		});
		var p = null, m = null, h = null;
		Object.defineProperty(this, "fontFaces", {
			get: function() {
				return h;
			},
			set: function(e) {
				p = null, m = null, h = e;
			}
		}), Object.defineProperty(this, "font", {
			get: function() {
				return this.ctx.font;
			},
			set: function(e) {
				var t;
				if (this.ctx.font = e, (t = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z0-9]+?)\s*$/i.exec(e)) !== null) {
					var n = t[1];
					t[2];
					var r = t[3], i = t[4];
					t[5];
					var a = t[6], o = /^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(i)[2];
					i = Math.floor(o === "px" ? parseFloat(i) * this.pdf.internal.scaleFactor : o === "em" ? parseFloat(i) * this.pdf.getFontSize() : parseFloat(i) * this.pdf.internal.scaleFactor), this.pdf.setFontSize(i);
					var s = function(e) {
						var t, n, r = [], i = e.trim();
						if (i === "") return Rx;
						if (i in Ox) return [Ox[i]];
						for (; i !== "";) {
							switch (n = null, t = (i = Ax(i)).charAt(0)) {
								case "\"":
								case "'":
									n = jx(i.substring(1), t);
									break;
								default: n = Mx(i);
							}
							if (n === null || (r.push(n[0]), (i = Ax(n[1])) !== "" && i.charAt(0) !== ",")) return Rx;
							i = i.replace(/^,/, "");
						}
						return r;
					}(a);
					if (this.fontFaces) {
						var c = function(e, t, n) {
							for (var r = (n ||= {}).defaultFontFamily || "times", i = Object.assign({}, Dx, n.genericFontFamilies || {}), a = null, o = null, s = 0; s < t.length; ++s) if (i[(a = Tx(t[s])).family] && (a.family = i[a.family]), e.hasOwnProperty(a.family)) {
								o = e[a.family];
								break;
							}
							if (!(o ||= e[r])) throw Error("Could not find a font-family for the rule '" + kx(a) + "' and default family '" + r + "'.");
							if (o = function(e, t) {
								if (t[e]) return t[e];
								var n = Sx[e], r = Ex(t, xx, n, n <= Sx.normal ? -1 : 1);
								if (!r) throw Error("Could not find a matching font-stretch value for " + e);
								return r;
							}(a.stretch, o), o = function(e, t) {
								if (t[e]) return t[e];
								for (var n = bx[e], r = 0; r < n.length; ++r) if (t[n[r]]) return t[n[r]];
								throw Error("Could not find a matching font-style for " + e);
							}(a.style, o), !(o = function(e, t) {
								if (t[e]) return t[e];
								if (e === 400 && t[500]) return t[500];
								if (e === 500 && t[400]) return t[400];
								var n = wx[e], r = Ex(t, Cx, n, e < 400 ? -1 : 1);
								if (!r) throw Error("Could not find a matching font-weight for value " + e);
								return r;
							}(a.weight, o))) throw Error("Failed to resolve a font for the rule '" + kx(a) + "'.");
							return o;
						}(function(e, t) {
							var n = e.getFontList(), r = JSON.stringify(n);
							return (p === null || m !== r) && (p = function(e) {
								for (var t = {}, n = 0; n < e.length; ++n) {
									var r = Tx(e[n]), i = r.family, a = r.stretch, o = r.style, s = r.weight;
									t[i] = t[i] || {}, t[i][a] = t[i][a] || {}, t[i][a][o] = t[i][a][o] || {}, t[i][a][o][s] = r;
								}
								return t;
							}(function(e) {
								var t = [];
								return Object.keys(e).forEach(function(n) {
									e[n].forEach(function(e) {
										var r = null;
										switch (e) {
											case "bold":
												r = {
													family: n,
													weight: "bold"
												};
												break;
											case "italic":
												r = {
													family: n,
													style: "italic"
												};
												break;
											case "bolditalic":
												r = {
													family: n,
													weight: "bold",
													style: "italic"
												};
												break;
											case "":
											case "normal": r = { family: n };
										}
										r !== null && (r.ref = {
											name: n,
											style: e
										}, t.push(r));
									});
								}), t;
							}(n).concat(t)), m = r), p;
						}(this.pdf, this.fontFaces), s.map(function(e) {
							return {
								family: e,
								stretch: "normal",
								weight: r,
								style: n
							};
						}));
						this.pdf.setFont(c.ref.name, c.ref.style);
					} else {
						var l = "";
						(r === "bold" || parseInt(r, 10) >= 700 || n === "bold") && (l = "bold"), n === "italic" && (l += "italic"), l.length === 0 && (l = "normal");
						for (var u = "", d = {
							arial: "Helvetica",
							Arial: "Helvetica",
							verdana: "Helvetica",
							Verdana: "Helvetica",
							helvetica: "Helvetica",
							Helvetica: "Helvetica",
							"sans-serif": "Helvetica",
							fixed: "Courier",
							monospace: "Courier",
							terminal: "Courier",
							cursive: "Times",
							fantasy: "Times",
							serif: "Times"
						}, f = 0; f < s.length; f++) {
							if (this.pdf.internal.getFont(s[f], l, {
								noFallback: !0,
								disableWarning: !0
							}) !== void 0) {
								u = s[f];
								break;
							}
							if (l === "bolditalic" && this.pdf.internal.getFont(s[f], "bold", {
								noFallback: !0,
								disableWarning: !0
							}) !== void 0) u = s[f], l = "bold";
							else if (this.pdf.internal.getFont(s[f], "normal", {
								noFallback: !0,
								disableWarning: !0
							}) !== void 0) {
								u = s[f], l = "normal";
								break;
							}
						}
						if (u === "") {
							for (var h = 0; h < s.length; h++) if (d[s[h]]) {
								u = d[s[h]];
								break;
							}
						}
						u = u === "" ? "Times" : u, this.pdf.setFont(u, l);
					}
				}
			}
		}), Object.defineProperty(this, "globalCompositeOperation", {
			get: function() {
				return this.ctx.globalCompositeOperation;
			},
			set: function(e) {
				this.ctx.globalCompositeOperation = e;
			}
		}), Object.defineProperty(this, "globalAlpha", {
			get: function() {
				return this.ctx.globalAlpha;
			},
			set: function(e) {
				this.ctx.globalAlpha = e;
			}
		}), Object.defineProperty(this, "lineDashOffset", {
			get: function() {
				return this.ctx.lineDashOffset;
			},
			set: function(e) {
				this.ctx.lineDashOffset = e, ee.call(this);
			}
		}), Object.defineProperty(this, "lineDash", {
			get: function() {
				return this.ctx.lineDash;
			},
			set: function(e) {
				this.ctx.lineDash = e, ee.call(this);
			}
		}), Object.defineProperty(this, "ignoreClearRect", {
			get: function() {
				return this.ctx.ignoreClearRect;
			},
			set: function(e) {
				this.ctx.ignoreClearRect = !!e;
			}
		});
	};
	d.prototype.setLineDash = function(e) {
		this.lineDash = e;
	}, d.prototype.getLineDash = function() {
		return this.lineDash.length % 2 ? this.lineDash.concat(this.lineDash) : this.lineDash.slice();
	}, d.prototype.fill = function() {
		b.call(this, "fill", !1);
	}, d.prototype.stroke = function() {
		b.call(this, "stroke", !1);
	}, d.prototype.beginPath = function() {
		this.path = [{ type: "begin" }];
	}, d.prototype.moveTo = function(e, t) {
		if (isNaN(e) || isNaN(t)) throw eb.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), /* @__PURE__ */ Error("Invalid arguments passed to jsPDF.context2d.moveTo");
		var n = this.ctx.transform.applyToPoint(new o(e, t));
		this.path.push({
			type: "mt",
			x: n.x,
			y: n.y
		}), this.ctx.lastPoint = new o(e, t);
	}, d.prototype.closePath = function() {
		var e = new o(0, 0), t = 0;
		for (t = this.path.length - 1; t !== -1; t--) if (this.path[t].type === "begin" && Fa(this.path[t + 1]) === "object" && typeof this.path[t + 1].x == "number") {
			e = new o(this.path[t + 1].x, this.path[t + 1].y);
			break;
		}
		this.path.push({ type: "close" }), this.ctx.lastPoint = new o(e.x, e.y);
	}, d.prototype.lineTo = function(e, t) {
		if (isNaN(e) || isNaN(t)) throw eb.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), /* @__PURE__ */ Error("Invalid arguments passed to jsPDF.context2d.lineTo");
		var n = this.ctx.transform.applyToPoint(new o(e, t));
		this.path.push({
			type: "lt",
			x: n.x,
			y: n.y
		}), this.ctx.lastPoint = new o(n.x, n.y);
	}, d.prototype.clip = function() {
		this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), b.call(this, null, !0);
	}, d.prototype.quadraticCurveTo = function(e, t, n, r) {
		if (isNaN(n) || isNaN(r) || isNaN(e) || isNaN(t)) throw eb.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), /* @__PURE__ */ Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
		var i = this.ctx.transform.applyToPoint(new o(n, r)), a = this.ctx.transform.applyToPoint(new o(e, t));
		this.path.push({
			type: "qct",
			x1: a.x,
			y1: a.y,
			x: i.x,
			y: i.y
		}), this.ctx.lastPoint = new o(i.x, i.y);
	}, d.prototype.bezierCurveTo = function(e, t, n, r, i, a) {
		if (isNaN(i) || isNaN(a) || isNaN(e) || isNaN(t) || isNaN(n) || isNaN(r)) throw eb.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), /* @__PURE__ */ Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
		var s = this.ctx.transform.applyToPoint(new o(i, a)), c = this.ctx.transform.applyToPoint(new o(e, t)), l = this.ctx.transform.applyToPoint(new o(n, r));
		this.path.push({
			type: "bct",
			x1: c.x,
			y1: c.y,
			x2: l.x,
			y2: l.y,
			x: s.x,
			y: s.y
		}), this.ctx.lastPoint = new o(s.x, s.y);
	}, d.prototype.arc = function(e, t, n, r, i, a) {
		if (isNaN(e) || isNaN(t) || isNaN(n) || isNaN(r) || isNaN(i)) throw eb.error("jsPDF.context2d.arc: Invalid arguments", arguments), /* @__PURE__ */ Error("Invalid arguments passed to jsPDF.context2d.arc");
		if (a = !!a, !this.ctx.transform.isIdentity) {
			var s = this.ctx.transform.applyToPoint(new o(e, t));
			e = s.x, t = s.y;
			var c = this.ctx.transform.applyToPoint(new o(0, n)), l = this.ctx.transform.applyToPoint(new o(0, 0));
			n = Math.sqrt((c.x - l.x) ** 2 + (c.y - l.y) ** 2);
		}
		Math.abs(i - r) >= 2 * Math.PI && (r = 0, i = 2 * Math.PI), this.path.push({
			type: "arc",
			x: e,
			y: t,
			radius: n,
			startAngle: r,
			endAngle: i,
			counterclockwise: a
		});
	}, d.prototype.arcTo = function(e, t, n, r, i) {
		throw Error("arcTo not implemented.");
	}, d.prototype.rect = function(e, t, n, r) {
		if (isNaN(e) || isNaN(t) || isNaN(n) || isNaN(r)) throw eb.error("jsPDF.context2d.rect: Invalid arguments", arguments), /* @__PURE__ */ Error("Invalid arguments passed to jsPDF.context2d.rect");
		this.moveTo(e, t), this.lineTo(e + n, t), this.lineTo(e + n, t + r), this.lineTo(e, t + r), this.lineTo(e, t), this.lineTo(e + n, t), this.lineTo(e, t);
	}, d.prototype.fillRect = function(e, t, n, r) {
		if (isNaN(e) || isNaN(t) || isNaN(n) || isNaN(r)) throw eb.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), /* @__PURE__ */ Error("Invalid arguments passed to jsPDF.context2d.fillRect");
		if (!p.call(this)) {
			var i = {};
			this.lineCap !== "butt" && (i.lineCap = this.lineCap, this.lineCap = "butt"), this.lineJoin !== "miter" && (i.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect(e, t, n, r), this.fill(), i.hasOwnProperty("lineCap") && (this.lineCap = i.lineCap), i.hasOwnProperty("lineJoin") && (this.lineJoin = i.lineJoin);
		}
	}, d.prototype.strokeRect = function(e, t, n, r) {
		if (isNaN(e) || isNaN(t) || isNaN(n) || isNaN(r)) throw eb.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), /* @__PURE__ */ Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
		m.call(this) || (this.beginPath(), this.rect(e, t, n, r), this.stroke());
	}, d.prototype.clearRect = function(e, t, n, r) {
		if (isNaN(e) || isNaN(t) || isNaN(n) || isNaN(r)) throw eb.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), /* @__PURE__ */ Error("Invalid arguments passed to jsPDF.context2d.clearRect");
		this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect(e, t, n, r));
	}, d.prototype.save = function(e) {
		e = typeof e != "boolean" || e;
		for (var t = this.pdf.internal.getCurrentPageInfo().pageNumber, n = 0; n < this.pdf.internal.getNumberOfPages(); n++) this.pdf.setPage(n + 1), this.pdf.internal.out("q");
		if (this.pdf.setPage(t), e) {
			this.ctx.fontSize = this.pdf.internal.getFontSize();
			var r = new u(this.ctx);
			this.ctxStack.push(this.ctx), this.ctx = r;
		}
	}, d.prototype.restore = function(e) {
		e = typeof e != "boolean" || e;
		for (var t = this.pdf.internal.getCurrentPageInfo().pageNumber, n = 0; n < this.pdf.internal.getNumberOfPages(); n++) this.pdf.setPage(n + 1), this.pdf.internal.out("Q");
		this.pdf.setPage(t), e && this.ctxStack.length !== 0 && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin, this.lineDash = this.ctx.lineDash, this.lineDashOffset = this.ctx.lineDashOffset);
	}, d.prototype.toDataURL = function() {
		throw Error("toDataUrl not implemented.");
	};
	var f = function(e) {
		var t, n, r, i;
		if (!0 === e.isCanvasGradient && (e = e.getColor()), !e) return {
			r: 0,
			g: 0,
			b: 0,
			a: 0,
			style: e
		};
		if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(e)) t = 0, n = 0, r = 0, i = 0;
		else {
			var a = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(e);
			if (a !== null) t = parseInt(a[1]), n = parseInt(a[2]), r = parseInt(a[3]), i = 1;
			else if ((a = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(e)) !== null) t = parseInt(a[1]), n = parseInt(a[2]), r = parseInt(a[3]), i = parseFloat(a[4]);
			else {
				if (i = 1, typeof e == "string" && e.charAt(0) !== "#") {
					var o = new ab(e);
					e = o.ok ? o.toHex() : "#000000";
				}
				e.length === 4 ? (t = e.substring(1, 2), t += t, n = e.substring(2, 3), n += n, r = e.substring(3, 4), r += r) : (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7)), t = parseInt(t, 16), n = parseInt(n, 16), r = parseInt(r, 16);
			}
		}
		return {
			r: t,
			g: n,
			b: r,
			a: i,
			style: e
		};
	}, p = function() {
		return this.ctx.isFillTransparent || this.globalAlpha == 0;
	}, m = function() {
		return !!(this.ctx.isStrokeTransparent || this.globalAlpha == 0);
	};
	d.prototype.fillText = function(e, t, n, r) {
		if (isNaN(t) || isNaN(n) || typeof e != "string") throw eb.error("jsPDF.context2d.fillText: Invalid arguments", arguments), /* @__PURE__ */ Error("Invalid arguments passed to jsPDF.context2d.fillText");
		if (r = isNaN(r) ? void 0 : r, !p.call(this)) {
			var i = P(this.ctx.transform.rotation), a = this.ctx.transform.scaleX;
			O.call(this, {
				text: e,
				x: t,
				y: n,
				scale: a,
				angle: i,
				align: this.textAlign,
				maxWidth: r
			});
		}
	}, d.prototype.strokeText = function(e, t, n, r) {
		if (isNaN(t) || isNaN(n) || typeof e != "string") throw eb.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), /* @__PURE__ */ Error("Invalid arguments passed to jsPDF.context2d.strokeText");
		if (!m.call(this)) {
			r = isNaN(r) ? void 0 : r;
			var i = P(this.ctx.transform.rotation), a = this.ctx.transform.scaleX;
			O.call(this, {
				text: e,
				x: t,
				y: n,
				scale: a,
				renderingMode: "stroke",
				angle: i,
				align: this.textAlign,
				maxWidth: r
			});
		}
	}, d.prototype.measureText = function(e) {
		if (typeof e != "string") throw eb.error("jsPDF.context2d.measureText: Invalid arguments", arguments), /* @__PURE__ */ Error("Invalid arguments passed to jsPDF.context2d.measureText");
		var t = this.pdf, n = this.pdf.internal.scaleFactor, r = t.internal.getFontSize(), i = t.getStringUnitWidth(e) * r / t.internal.scaleFactor;
		return new function(e) {
			var t = (e ||= {}).width || 0;
			return Object.defineProperty(this, "width", { get: function() {
				return t;
			} }), this;
		}({ width: i *= Math.round(96 * n / 72 * 1e4) / 1e4 });
	}, d.prototype.scale = function(e, t) {
		if (isNaN(e) || isNaN(t)) throw eb.error("jsPDF.context2d.scale: Invalid arguments", arguments), /* @__PURE__ */ Error("Invalid arguments passed to jsPDF.context2d.scale");
		var n = new c(e, 0, 0, t, 0, 0);
		this.ctx.transform = this.ctx.transform.multiply(n);
	}, d.prototype.rotate = function(e) {
		if (isNaN(e)) throw eb.error("jsPDF.context2d.rotate: Invalid arguments", arguments), /* @__PURE__ */ Error("Invalid arguments passed to jsPDF.context2d.rotate");
		var t = new c(Math.cos(e), Math.sin(e), -Math.sin(e), Math.cos(e), 0, 0);
		this.ctx.transform = this.ctx.transform.multiply(t);
	}, d.prototype.translate = function(e, t) {
		if (isNaN(e) || isNaN(t)) throw eb.error("jsPDF.context2d.translate: Invalid arguments", arguments), /* @__PURE__ */ Error("Invalid arguments passed to jsPDF.context2d.translate");
		var n = new c(1, 0, 0, 1, e, t);
		this.ctx.transform = this.ctx.transform.multiply(n);
	}, d.prototype.transform = function(e, t, n, r, i, a) {
		if (isNaN(e) || isNaN(t) || isNaN(n) || isNaN(r) || isNaN(i) || isNaN(a)) throw eb.error("jsPDF.context2d.transform: Invalid arguments", arguments), /* @__PURE__ */ Error("Invalid arguments passed to jsPDF.context2d.transform");
		var o = new c(e, t, n, r, i, a);
		this.ctx.transform = this.ctx.transform.multiply(o);
	}, d.prototype.setTransform = function(e, t, n, r, i, a) {
		e = isNaN(e) ? 1 : e, t = isNaN(t) ? 0 : t, n = isNaN(n) ? 0 : n, r = isNaN(r) ? 1 : r, i = isNaN(i) ? 0 : i, a = isNaN(a) ? 0 : a, this.ctx.transform = new c(e, t, n, r, i, a);
	};
	var h = function() {
		return this.margin[0] > 0 || this.margin[1] > 0 || this.margin[2] > 0 || this.margin[3] > 0;
	};
	d.prototype.drawImage = function(e, t, n, r, i, a, o, l, u) {
		var d = this.pdf.getImageProperties(e), f = 1, p = 1, m = 1, _ = 1;
		r !== void 0 && l !== void 0 && (m = l / r, _ = u / i, f = d.width / r * l / r, p = d.height / i * u / i), a === void 0 && (a = t, o = n, t = 0, n = 0), r !== void 0 && l === void 0 && (l = r, u = i), r === void 0 && l === void 0 && (l = d.width, u = d.height);
		var b = this.ctx.transform.decompose(), S = P(b.rotate.shx), C = new c(), w = (C = (C = (C = C.multiply(b.translate)).multiply(b.skew)).multiply(b.scale)).applyToRectangle(new s(a - t * m, o - n * _, r * f, i * p));
		if (this.autoPaging) {
			for (var T, E = g.call(this, w), D = [], O = 0; O < E.length; O += 1) D.indexOf(E[O]) === -1 && D.push(E[O]);
			y(D);
			for (var k = D[0], A = D[D.length - 1], j = k; j < A + 1; j++) {
				this.pdf.setPage(j);
				var M = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], N = j === 1 ? this.posY + this.margin[0] : this.margin[0], F = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], I = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], ee = j === 1 ? 0 : F + (j - 2) * I;
				if (this.ctx.clip_path.length !== 0) {
					var L = this.path;
					T = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = v(T, this.posX + this.margin[3], -ee + N + this.ctx.prevPageLastElemOffset), x.call(this, "fill", !0), this.path = L;
				}
				var R = JSON.parse(JSON.stringify(w));
				R = v([R], this.posX + this.margin[3], -ee + N + this.ctx.prevPageLastElemOffset)[0];
				var te = (j > k || j < A) && h.call(this);
				te && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], M, I, null).clip().discardPath()), this.pdf.addImage(e, "JPEG", R.x, R.y, R.w, R.h, null, null, S), te && this.pdf.restoreGraphicsState();
			}
		} else this.pdf.addImage(e, "JPEG", w.x, w.y, w.w, w.h, null, null, S);
	};
	var g = function(e, t, n) {
		var r = [];
		t ||= this.pdf.internal.pageSize.width, n ||= this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2];
		var i = this.posY + this.ctx.prevPageLastElemOffset;
		switch (e.type) {
			default:
			case "mt":
			case "lt":
				r.push(Math.floor((e.y + i) / n) + 1);
				break;
			case "arc":
				r.push(Math.floor((e.y + i - e.radius) / n) + 1), r.push(Math.floor((e.y + i + e.radius) / n) + 1);
				break;
			case "qct":
				var a = F(this.ctx.lastPoint.x, this.ctx.lastPoint.y, e.x1, e.y1, e.x, e.y);
				r.push(Math.floor((a.y + i) / n) + 1), r.push(Math.floor((a.y + a.h + i) / n) + 1);
				break;
			case "bct":
				var o = I(this.ctx.lastPoint.x, this.ctx.lastPoint.y, e.x1, e.y1, e.x2, e.y2, e.x, e.y);
				r.push(Math.floor((o.y + i) / n) + 1), r.push(Math.floor((o.y + o.h + i) / n) + 1);
				break;
			case "rect": r.push(Math.floor((e.y + i) / n) + 1), r.push(Math.floor((e.y + e.h + i) / n) + 1);
		}
		for (var s = 0; s < r.length; s += 1) for (; this.pdf.internal.getNumberOfPages() < r[s];) _.call(this);
		return r;
	}, _ = function() {
		var e = this.fillStyle, t = this.strokeStyle, n = this.font, r = this.lineCap, i = this.lineWidth, a = this.lineJoin;
		this.pdf.addPage(), this.fillStyle = e, this.strokeStyle = t, this.font = n, this.lineCap = r, this.lineWidth = i, this.lineJoin = a;
	}, v = function(e, t, n) {
		for (var r = 0; r < e.length; r++) switch (e[r].type) {
			case "bct": e[r].x2 += t, e[r].y2 += n;
			case "qct": e[r].x1 += t, e[r].y1 += n;
			default: e[r].x += t, e[r].y += n;
		}
		return e;
	}, y = function(e) {
		return e.sort(function(e, t) {
			return e - t;
		});
	}, b = function(e, t) {
		var n = this.fillStyle, r = this.strokeStyle, i = this.lineCap, a = this.lineWidth, o = Math.abs(a * this.ctx.transform.scaleX), s = this.lineJoin;
		if (this.autoPaging) {
			for (var c, l, u = JSON.parse(JSON.stringify(this.path)), d = JSON.parse(JSON.stringify(this.path)), f = [], p = 0; p < d.length; p++) if (d[p].x !== void 0) for (var m = g.call(this, d[p]), b = 0; b < m.length; b += 1) f.indexOf(m[b]) === -1 && f.push(m[b]);
			for (var S = 0; S < f.length; S++) for (; this.pdf.internal.getNumberOfPages() < f[S];) _.call(this);
			y(f);
			for (var C = f[0], w = f[f.length - 1], T = C; T < w + 1; T++) {
				this.pdf.setPage(T), this.fillStyle = n, this.strokeStyle = r, this.lineCap = i, this.lineWidth = o, this.lineJoin = s;
				var E = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], D = T === 1 ? this.posY + this.margin[0] : this.margin[0], O = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], k = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], A = T === 1 ? 0 : O + (T - 2) * k;
				if (this.ctx.clip_path.length !== 0) {
					var j = this.path;
					c = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = v(c, this.posX + this.margin[3], -A + D + this.ctx.prevPageLastElemOffset), x.call(this, e, !0), this.path = j;
				}
				if (l = JSON.parse(JSON.stringify(u)), this.path = v(l, this.posX + this.margin[3], -A + D + this.ctx.prevPageLastElemOffset), !1 === t || T === 0) {
					var M = (T > C || T < w) && h.call(this);
					M && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], E, k, null).clip().discardPath()), x.call(this, e, t), M && this.pdf.restoreGraphicsState();
				}
				this.lineWidth = a;
			}
			this.path = u;
		} else this.lineWidth = o, x.call(this, e, t), this.lineWidth = a;
	}, x = function(e, t) {
		if ((e !== "stroke" || t || !m.call(this)) && (e === "stroke" || t || !p.call(this))) {
			for (var n, r, i = [], a = this.path, o = 0; o < a.length; o++) {
				var s = a[o];
				switch (s.type) {
					case "begin":
						i.push({ begin: !0 });
						break;
					case "close":
						i.push({ close: !0 });
						break;
					case "mt":
						i.push({
							start: s,
							deltas: [],
							abs: []
						});
						break;
					case "lt":
						var c = i.length;
						if (a[o - 1] && !isNaN(a[o - 1].x) && (n = [s.x - a[o - 1].x, s.y - a[o - 1].y], c > 0)) {
							for (; c >= 0; c--) if (!0 !== i[c - 1].close && !0 !== i[c - 1].begin) {
								i[c - 1].deltas.push(n), i[c - 1].abs.push(s);
								break;
							}
						}
						break;
					case "bct":
						n = [
							s.x1 - a[o - 1].x,
							s.y1 - a[o - 1].y,
							s.x2 - a[o - 1].x,
							s.y2 - a[o - 1].y,
							s.x - a[o - 1].x,
							s.y - a[o - 1].y
						], i[i.length - 1].deltas.push(n);
						break;
					case "qct":
						var l = a[o - 1].x + 2 / 3 * (s.x1 - a[o - 1].x), u = a[o - 1].y + 2 / 3 * (s.y1 - a[o - 1].y), d = s.x + 2 / 3 * (s.x1 - s.x), f = s.y + 2 / 3 * (s.y1 - s.y), h = s.x, g = s.y;
						n = [
							l - a[o - 1].x,
							u - a[o - 1].y,
							d - a[o - 1].x,
							f - a[o - 1].y,
							h - a[o - 1].x,
							g - a[o - 1].y
						], i[i.length - 1].deltas.push(n);
						break;
					case "arc": i.push({
						deltas: [],
						abs: [],
						arc: !0
					}), Array.isArray(i[i.length - 1].abs) && i[i.length - 1].abs.push(s);
				}
			}
			r = t ? null : e === "stroke" ? "stroke" : "fill";
			for (var _ = !1, v = 0; v < i.length; v++) if (i[v].arc) for (var y = i[v].abs, b = 0; b < y.length; b++) {
				var x = y[b];
				x.type === "arc" ? w.call(this, x.x, x.y, x.radius, x.startAngle, x.endAngle, x.counterclockwise, void 0, t, !_) : k.call(this, x.x, x.y), _ = !0;
			}
			else if (!0 === i[v].close) this.pdf.internal.out("h"), _ = !1;
			else if (!0 !== i[v].begin) {
				var S = i[v].start.x, C = i[v].start.y;
				A.call(this, i[v].deltas, S, C), _ = !0;
			}
			r && T.call(this, r), t && E.call(this);
		}
	}, S = function(e) {
		var t = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor, n = t * (this.pdf.internal.getLineHeightFactor() - 1);
		switch (this.ctx.textBaseline) {
			case "bottom": return e - n;
			case "top": return e + t - n;
			case "hanging": return e + t - 2 * n;
			case "middle": return e + t / 2 - n;
			default: return e;
		}
	}, C = function(e) {
		return e + this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor * (this.pdf.internal.getLineHeightFactor() - 1);
	};
	d.prototype.createLinearGradient = function() {
		var e = function() {};
		return e.colorStops = [], e.addColorStop = function(e, t) {
			this.colorStops.push([e, t]);
		}, e.getColor = function() {
			return this.colorStops.length === 0 ? "#000000" : this.colorStops[0][1];
		}, e.isCanvasGradient = !0, e;
	}, d.prototype.createPattern = function() {
		return this.createLinearGradient();
	}, d.prototype.createRadialGradient = function() {
		return this.createLinearGradient();
	};
	var w = function(e, t, n, r, i, a, o, s, c) {
		for (var l = M.call(this, n, r, i, a), u = 0; u < l.length; u++) {
			var d = l[u];
			u === 0 && (c ? D.call(this, d.x1 + e, d.y1 + t) : k.call(this, d.x1 + e, d.y1 + t)), j.call(this, e, t, d.x2, d.y2, d.x3, d.y3, d.x4, d.y4);
		}
		s ? E.call(this) : T.call(this, o);
	}, T = function(e) {
		switch (e) {
			case "stroke":
				this.pdf.internal.out("S");
				break;
			case "fill": this.pdf.internal.out("f");
		}
	}, E = function() {
		this.pdf.clip(), this.pdf.discardPath();
	}, D = function(e, t) {
		this.pdf.internal.out(n(e) + " " + r(t) + " m");
	}, O = function(e) {
		var t;
		switch (e.align) {
			case "right":
			case "end":
				t = "right";
				break;
			case "center":
				t = "center";
				break;
			default: t = "left";
		}
		var n, r, i, a = this.pdf.getTextDimensions(e.text), l = S.call(this, e.y), u = C.call(this, l) - a.h, d = this.ctx.transform.applyToPoint(new o(e.x, l));
		if (this.autoPaging) {
			var f = this.ctx.transform.decompose(), p = new c();
			p = (p = (p = p.multiply(f.translate)).multiply(f.skew)).multiply(f.scale);
			for (var m = this.ctx.transform.applyToRectangle(new s(e.x, l, a.w, a.h)), _ = p.applyToRectangle(new s(e.x, u, a.w, a.h)), b = g.call(this, _), w = [], T = 0; T < b.length; T += 1) w.indexOf(b[T]) === -1 && w.push(b[T]);
			y(w);
			for (var E = w[0], D = w[w.length - 1], O = E; O < D + 1; O++) {
				this.pdf.setPage(O);
				var k = O === 1 ? this.posY + this.margin[0] : this.margin[0], A = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], j = this.pdf.internal.pageSize.height - this.margin[2], M = j - this.margin[0], N = this.pdf.internal.pageSize.width - this.margin[1], P = N - this.margin[3], F = O === 1 ? 0 : A + (O - 2) * M;
				if (this.ctx.clip_path.length !== 0) {
					var I = this.path;
					n = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = v(n, this.posX + this.margin[3], -1 * F + k), x.call(this, "fill", !0), this.path = I;
				}
				var ee = v([JSON.parse(JSON.stringify(_))], this.posX + this.margin[3], -F + k + this.ctx.prevPageLastElemOffset)[0];
				e.scale >= .01 && (r = this.pdf.internal.getFontSize(), this.pdf.setFontSize(r * e.scale), i = this.lineWidth, this.lineWidth = i * e.scale);
				var L = this.autoPaging !== "text";
				if (L || ee.y + ee.h <= j) {
					if (L || ee.y >= k && ee.x <= N) {
						var R = L ? e.text : this.pdf.splitTextToSize(e.text, e.maxWidth || N - ee.x)[0], te = v([JSON.parse(JSON.stringify(m))], this.posX + this.margin[3], -F + k + this.ctx.prevPageLastElemOffset)[0], z = L && (O > E || O < D) && h.call(this);
						z && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], P, M, null).clip().discardPath()), this.pdf.text(R, te.x, te.y, {
							angle: e.angle,
							align: t,
							renderingMode: e.renderingMode
						}), z && this.pdf.restoreGraphicsState();
					}
				} else ee.y < j && (this.ctx.prevPageLastElemOffset += j - ee.y);
				e.scale >= .01 && (this.pdf.setFontSize(r), this.lineWidth = i);
			}
		} else e.scale >= .01 && (r = this.pdf.internal.getFontSize(), this.pdf.setFontSize(r * e.scale), i = this.lineWidth, this.lineWidth = i * e.scale), this.pdf.text(e.text, d.x + this.posX, d.y + this.posY, {
			angle: e.angle,
			align: t,
			renderingMode: e.renderingMode,
			maxWidth: e.maxWidth
		}), e.scale >= .01 && (this.pdf.setFontSize(r), this.lineWidth = i);
	}, k = function(e, t, i, a) {
		i ||= 0, a ||= 0, this.pdf.internal.out(n(e + i) + " " + r(t + a) + " l");
	}, A = function(e, t, n) {
		return this.pdf.lines(e, t, n, null, null);
	}, j = function(e, n, r, o, s, c, l, u) {
		this.pdf.internal.out([
			t(i(r + e)),
			t(a(o + n)),
			t(i(s + e)),
			t(a(c + n)),
			t(i(l + e)),
			t(a(u + n)),
			"c"
		].join(" "));
	}, M = function(e, t, n, r) {
		for (var i = 2 * Math.PI, a = Math.PI / 2; t > n;) t -= i;
		var o = Math.abs(n - t);
		o < i && r && (o = i - o);
		for (var s = [], c = r ? -1 : 1, l = t; o > 1e-5;) {
			var u = l + c * Math.min(o, a);
			s.push(N.call(this, e, l, u)), o -= Math.abs(u - l), l = u;
		}
		return s;
	}, N = function(e, t, n) {
		var r = (n - t) / 2, i = e * Math.cos(r), a = e * Math.sin(r), o = i, s = -a, c = o * o + s * s, l = c + o * i + s * a, u = 4 / 3 * (Math.sqrt(2 * c * l) - l) / (o * a - s * i), d = o - u * s, f = s + u * o, p = d, m = -f, h = r + t, g = Math.cos(h), _ = Math.sin(h);
		return {
			x1: e * Math.cos(t),
			y1: e * Math.sin(t),
			x2: d * g - f * _,
			y2: d * _ + f * g,
			x3: p * g - m * _,
			y3: p * _ + m * g,
			x4: e * Math.cos(n),
			y4: e * Math.sin(n)
		};
	}, P = function(e) {
		return 180 * e / Math.PI;
	}, F = function(e, t, n, r, i, a) {
		var o = e + .5 * (n - e), c = t + .5 * (r - t), l = i + .5 * (n - i), u = a + .5 * (r - a), d = Math.min(e, i, o, l), f = Math.max(e, i, o, l), p = Math.min(t, a, c, u), m = Math.max(t, a, c, u);
		return new s(d, p, f - d, m - p);
	}, I = function(e, t, n, r, i, a, o, c) {
		var l, u, d, f, p, m, h, g, _, v, y, b, x, S, C = n - e, w = r - t, T = i - n, E = a - r, D = o - i, O = c - a;
		for (u = 0; u < 41; u++) _ = (h = (d = e + (l = u / 40) * C) + l * ((p = n + l * T) - d)) + l * (p + l * (i + l * D - p) - h), v = (g = (f = t + l * w) + l * ((m = r + l * E) - f)) + l * (m + l * (a + l * O - m) - g), u == 0 ? (y = _, b = v, x = _, S = v) : (y = Math.min(y, _), b = Math.min(b, v), x = Math.max(x, _), S = Math.max(S, v));
		return new s(Math.round(y), Math.round(b), Math.round(x - y), Math.round(S - b));
	}, ee = function() {
		if (this.prevLineDash || this.ctx.lineDash.length || this.ctx.lineDashOffset) {
			var e, t, n = (e = this.ctx.lineDash, t = this.ctx.lineDashOffset, JSON.stringify({
				lineDash: e,
				lineDashOffset: t
			}));
			this.prevLineDash !== n && (this.pdf.setLineDash(this.ctx.lineDash, this.ctx.lineDashOffset), this.prevLineDash = n);
		}
	};
})(jb.API), function(e) {
	var t = function(e) {
		var t, n, r, i, a, o, s, c, l, u;
		for (/[^\x00-\xFF]/.test(e), n = [], r = 0, i = (e += t = "\0\0\0\0".slice(e.length % 4 || 4)).length; i > r; r += 4) (a = (e.charCodeAt(r) << 24) + (e.charCodeAt(r + 1) << 16) + (e.charCodeAt(r + 2) << 8) + e.charCodeAt(r + 3)) === 0 ? n.push(122) : (o = (a = ((a = ((a = ((a = (a - (u = a % 85)) / 85) - (l = a % 85)) / 85) - (c = a % 85)) / 85) - (s = a % 85)) / 85) % 85, n.push(o + 33, s + 33, c + 33, l + 33, u + 33));
		return function(e, t) {
			for (var n = t; n > 0; n--) e.pop();
		}(n, t.length), String.fromCharCode.apply(String, n) + "~>";
	}, n = function(e) {
		var t, n, r, i, a, o = String, s = "length", c = 255, l = "charCodeAt", u = "slice", d = "replace";
		for (e[u](-2), e = e[u](0, -2)[d](/\s/g, "")[d]("z", "!!!!!"), r = [], i = 0, a = (e += t = "uuuuu"[u](e[s] % 5 || 5))[s]; a > i; i += 5) n = 52200625 * (e[l](i) - 33) + 614125 * (e[l](i + 1) - 33) + 7225 * (e[l](i + 2) - 33) + 85 * (e[l](i + 3) - 33) + (e[l](i + 4) - 33), r.push(c & n >> 24, c & n >> 16, c & n >> 8, c & n);
		return function(e, t) {
			for (var n = t; n > 0; n--) e.pop();
		}(r, t[s]), o.fromCharCode.apply(o, r);
	}, r = function(e) {
		return e.split("").map(function(e) {
			return ("0" + e.charCodeAt().toString(16)).slice(-2);
		}).join("") + ">";
	}, i = function(e) {
		var t = /* @__PURE__ */ new RegExp(/^([0-9A-Fa-f]{2})+$/);
		if ((e = e.replace(/\s/g, "")).indexOf(">") !== -1 && (e = e.substr(0, e.indexOf(">"))), e.length % 2 && (e += "0"), !1 === t.test(e)) return "";
		for (var n = "", r = 0; r < e.length; r += 2) n += String.fromCharCode("0x" + (e[r] + e[r + 1]));
		return n;
	}, a = function(e) {
		for (var t = new Uint8Array(e.length), n = e.length; n--;) t[n] = e.charCodeAt(n);
		return (t = xo(t)).reduce(function(e, t) {
			return e + String.fromCharCode(t);
		}, "");
	};
	e.processDataByFilters = function(e, o) {
		var s = 0, c = e || "", l = [];
		for (typeof (o ||= []) == "string" && (o = [o]), s = 0; s < o.length; s += 1) switch (o[s]) {
			case "ASCII85Decode":
			case "/ASCII85Decode":
				c = n(c), l.push("/ASCII85Encode");
				break;
			case "ASCII85Encode":
			case "/ASCII85Encode":
				c = t(c), l.push("/ASCII85Decode");
				break;
			case "ASCIIHexDecode":
			case "/ASCIIHexDecode":
				c = i(c), l.push("/ASCIIHexEncode");
				break;
			case "ASCIIHexEncode":
			case "/ASCIIHexEncode":
				c = r(c), l.push("/ASCIIHexDecode");
				break;
			case "FlateEncode":
			case "/FlateEncode":
				c = a(c), l.push("/FlateDecode");
				break;
			default: throw Error("The filter: \"" + o[s] + "\" is not implemented");
		}
		return {
			data: c,
			reverseChain: l.reverse().join(" ")
		};
	};
}(jb.API), function(e) {
	e.loadFile = function(e, t, n) {
		return function(e, t, n) {
			t = !1 !== t, n = typeof n == "function" ? n : function() {};
			var r = void 0;
			try {
				r = function(e, t, n) {
					var r = new XMLHttpRequest(), i = 0, a = function(e) {
						var t = e.length, n = [], r = String.fromCharCode;
						for (i = 0; i < t; i += 1) n.push(r(255 & e.charCodeAt(i)));
						return n.join("");
					};
					if (r.open("GET", e, !t), r.overrideMimeType("text/plain; charset=x-user-defined"), !1 === t && (r.onload = function() {
						r.status === 200 ? n(a(this.responseText)) : n(void 0);
					}), r.send(null), t && r.status === 200) return a(r.responseText);
				}(e, t, n);
			} catch {}
			return r;
		}(e, t, n);
	}, e.allowFsRead = void 0, e.loadImageFile = e.loadFile;
}(jb.API), function(e) {
	function t() {
		return (Qy.html2canvas ? Promise.resolve(Qy.html2canvas) : Promise.resolve().then(() => /* @__PURE__ */ u(vf()))).catch(function(e) {
			return Promise.reject(/* @__PURE__ */ Error("Could not load html2canvas: " + e));
		}).then(function(e) {
			return e.default ? e.default : e;
		});
	}
	function n() {
		return (Qy.DOMPurify ? Promise.resolve(Qy.DOMPurify) : Promise.resolve().then(() => (Up(), yf))).catch(function(e) {
			return Promise.reject(/* @__PURE__ */ Error("Could not load dompurify: " + e));
		}).then(function(e) {
			return e.default ? e.default : e;
		});
	}
	var r = function(e) {
		var t = Fa(e);
		return t === "undefined" ? "undefined" : t === "string" || e instanceof String ? "string" : t === "number" || e instanceof Number ? "number" : t === "function" || e instanceof Function ? "function" : e && e.constructor === Array ? "array" : e && e.nodeType === 1 ? "element" : t === "object" ? "object" : "unknown";
	}, i = function(e, t) {
		var n = document.createElement(e);
		for (var r in t.className && (n.className = t.className), t.innerHTML && t.dompurify && (n.innerHTML = t.dompurify.sanitize(t.innerHTML)), t.style) n.style[r] = t.style[r];
		return n;
	}, a = function e(t, n) {
		for (var r = t.nodeType === 3 ? document.createTextNode(t.nodeValue) : t.cloneNode(!1), i = t.firstChild; i; i = i.nextSibling) !0 !== n && i.nodeType === 1 && i.nodeName === "SCRIPT" || r.appendChild(e(i, n));
		return t.nodeType === 1 && (t.nodeName === "CANVAS" ? (r.width = t.width, r.height = t.height, r.getContext("2d").drawImage(t, 0, 0)) : t.nodeName !== "TEXTAREA" && t.nodeName !== "SELECT" || (r.value = t.value), r.addEventListener("load", function() {
			r.scrollTop = t.scrollTop, r.scrollLeft = t.scrollLeft;
		}, !0)), r;
	}, o = function e(t) {
		var n = Object.assign(e.convert(Promise.resolve()), JSON.parse(JSON.stringify(e.template))), r = e.convert(Promise.resolve(), n);
		return (r = r.setProgress(1, e, 1, [e])).set(t);
	};
	(o.prototype = Object.create(Promise.prototype)).constructor = o, o.convert = function(e, t) {
		return e.__proto__ = t || o.prototype, e;
	}, o.template = {
		prop: {
			src: null,
			container: null,
			overlay: null,
			canvas: null,
			img: null,
			pdf: null,
			pageSize: null,
			callback: function() {}
		},
		progress: {
			val: 0,
			state: null,
			n: 0,
			stack: []
		},
		opt: {
			filename: "file.pdf",
			margin: [
				0,
				0,
				0,
				0
			],
			enableLinks: !0,
			x: 0,
			y: 0,
			html2canvas: {},
			jsPDF: {},
			backgroundColor: "transparent"
		}
	}, o.prototype.from = function(e, t) {
		return this.then(function() {
			switch (t ||= function(e) {
				switch (r(e)) {
					case "string": return "string";
					case "element": return e.nodeName.toLowerCase() === "canvas" ? "canvas" : "element";
					default: return "unknown";
				}
			}(e), t) {
				case "string": return this.then(n).then(function(t) {
					return this.set({ src: i("div", {
						innerHTML: e,
						dompurify: t
					}) });
				});
				case "element": return this.set({ src: e });
				case "canvas": return this.set({ canvas: e });
				case "img": return this.set({ img: e });
				default: return this.error("Unknown source type.");
			}
		});
	}, o.prototype.to = function(e) {
		switch (e) {
			case "container": return this.toContainer();
			case "canvas": return this.toCanvas();
			case "img": return this.toImg();
			case "pdf": return this.toPdf();
			default: return this.error("Invalid target.");
		}
	}, o.prototype.toContainer = function() {
		return this.thenList([function() {
			return this.prop.src || this.error("Cannot duplicate - no source HTML.");
		}, function() {
			return this.prop.pageSize || this.setPageSize();
		}]).then(function() {
			var e = {
				position: "relative",
				display: "inline-block",
				width: (typeof this.opt.width != "number" || isNaN(this.opt.width) || typeof this.opt.windowWidth != "number" || isNaN(this.opt.windowWidth) ? Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) : this.opt.windowWidth) + "px",
				left: 0,
				right: 0,
				top: 0,
				margin: "auto",
				backgroundColor: this.opt.backgroundColor
			}, t = a(this.prop.src, this.opt.html2canvas.javascriptEnabled);
			t.tagName === "BODY" && (e.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = i("div", {
				className: "html2pdf__overlay",
				style: {
					position: "fixed",
					overflow: "hidden",
					zIndex: 1e3,
					left: "-100000px",
					right: 0,
					bottom: 0,
					top: 0
				}
			}), this.prop.container = i("div", {
				className: "html2pdf__container",
				style: e
			}), this.prop.container.appendChild(t), this.prop.container.firstChild.appendChild(i("div", { style: {
				clear: "both",
				border: "0 none transparent",
				margin: 0,
				padding: 0,
				height: 0
			} })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
		});
	}, o.prototype.toCanvas = function() {
		return this.thenList([function() {
			return document.body.contains(this.prop.container) || this.toContainer();
		}]).then(t).then(function(e) {
			var t = Object.assign({}, this.opt.html2canvas);
			return delete t.onrendered, e(this.prop.container, t);
		}).then(function(e) {
			(this.opt.html2canvas.onrendered || function() {})(e), this.prop.canvas = e, document.body.removeChild(this.prop.overlay);
		});
	}, o.prototype.toContext2d = function() {
		return this.thenList([function() {
			return document.body.contains(this.prop.container) || this.toContainer();
		}]).then(t).then(function(e) {
			var t = this.opt.jsPDF, n = this.opt.fontFaces, r = typeof this.opt.width != "number" || isNaN(this.opt.width) || typeof this.opt.windowWidth != "number" || isNaN(this.opt.windowWidth) ? 1 : this.opt.width / this.opt.windowWidth, i = Object.assign({
				async: !0,
				allowTaint: !0,
				scale: r,
				scrollX: this.opt.scrollX || 0,
				scrollY: this.opt.scrollY || 0,
				backgroundColor: "#ffffff",
				imageTimeout: 15e3,
				logging: !0,
				proxy: null,
				removeContainer: !0,
				foreignObjectRendering: !1,
				useCORS: !1
			}, this.opt.html2canvas);
			if (delete i.onrendered, t.context2d.autoPaging = this.opt.autoPaging === void 0 || this.opt.autoPaging, t.context2d.posX = this.opt.x, t.context2d.posY = this.opt.y, t.context2d.margin = this.opt.margin, t.context2d.fontFaces = n, n) for (var a = 0; a < n.length; ++a) {
				var o = n[a], s = o.src.find(function(e) {
					return e.format === "truetype";
				});
				s && t.addFont(s.url, o.ref.name, o.ref.style);
			}
			return i.windowHeight = i.windowHeight || 0, i.windowHeight = i.windowHeight == 0 ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : i.windowHeight, t.context2d.save(!0), e(this.prop.container, i);
		}).then(function(e) {
			this.opt.jsPDF.context2d.restore(!0), (this.opt.html2canvas.onrendered || function() {})(e), this.prop.canvas = e, document.body.removeChild(this.prop.overlay);
		});
	}, o.prototype.toImg = function() {
		return this.thenList([function() {
			return this.prop.canvas || this.toCanvas();
		}]).then(function() {
			var e = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
			this.prop.img = document.createElement("img"), this.prop.img.src = e;
		});
	}, o.prototype.toPdf = function() {
		return this.thenList([function() {
			return this.toContext2d();
		}]).then(function() {
			this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
		});
	}, o.prototype.output = function(e, t, n) {
		return (n ||= "pdf").toLowerCase() === "img" || n.toLowerCase() === "image" ? this.outputImg(e, t) : this.outputPdf(e, t);
	}, o.prototype.outputPdf = function(e, t) {
		return this.thenList([function() {
			return this.prop.pdf || this.toPdf();
		}]).then(function() {
			return this.prop.pdf.output(e, t);
		});
	}, o.prototype.outputImg = function(e) {
		return this.thenList([function() {
			return this.prop.img || this.toImg();
		}]).then(function() {
			switch (e) {
				case void 0:
				case "img": return this.prop.img;
				case "datauristring":
				case "dataurlstring": return this.prop.img.src;
				case "datauri":
				case "dataurl": return document.location.href = this.prop.img.src;
				default: throw "Image output type \"" + e + "\" is not supported.";
			}
		});
	}, o.prototype.save = function(e) {
		return this.thenList([function() {
			return this.prop.pdf || this.toPdf();
		}]).set(e ? { filename: e } : null).then(function() {
			this.prop.pdf.save(this.opt.filename);
		});
	}, o.prototype.doCallback = function() {
		return this.thenList([function() {
			return this.prop.pdf || this.toPdf();
		}]).then(function() {
			this.prop.callback(this.prop.pdf);
		});
	}, o.prototype.set = function(e) {
		if (r(e) !== "object") return this;
		var t = Object.keys(e || {}).map(function(t) {
			if (t in o.template.prop) return function() {
				this.prop[t] = e[t];
			};
			switch (t) {
				case "margin": return this.setMargin.bind(this, e.margin);
				case "jsPDF": return function() {
					return this.opt.jsPDF = e.jsPDF, this.setPageSize();
				};
				case "pageSize": return this.setPageSize.bind(this, e.pageSize);
				default: return function() {
					this.opt[t] = e[t];
				};
			}
		}, this);
		return this.then(function() {
			return this.thenList(t);
		});
	}, o.prototype.get = function(e, t) {
		return this.then(function() {
			var n = e in o.template.prop ? this.prop[e] : this.opt[e];
			return t ? t(n) : n;
		});
	}, o.prototype.setMargin = function(e) {
		return this.then(function() {
			switch (r(e)) {
				case "number": e = [
					e,
					e,
					e,
					e
				];
				case "array": if (e.length === 2 && (e = [
					e[0],
					e[1],
					e[0],
					e[1]
				]), e.length === 4) break;
				default: return this.error("Invalid margin array.");
			}
			this.opt.margin = e;
		}).then(this.setPageSize);
	}, o.prototype.setPageSize = function(e) {
		function t(e, t) {
			return Math.floor(e * t / 72 * 96);
		}
		return this.then(function() {
			(e ||= jb.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (e.inner = {
				width: e.width - this.opt.margin[1] - this.opt.margin[3],
				height: e.height - this.opt.margin[0] - this.opt.margin[2]
			}, e.inner.px = {
				width: t(e.inner.width, e.k),
				height: t(e.inner.height, e.k)
			}, e.inner.ratio = e.inner.height / e.inner.width), this.prop.pageSize = e;
		});
	}, o.prototype.setProgress = function(e, t, n, r) {
		return e != null && (this.progress.val = e), t != null && (this.progress.state = t), n != null && (this.progress.n = n), r != null && (this.progress.stack = r), this.progress.ratio = this.progress.val / this.progress.state, this;
	}, o.prototype.updateProgress = function(e, t, n, r) {
		return this.setProgress(e ? this.progress.val + e : null, t || null, n ? this.progress.n + n : null, r ? this.progress.stack.concat(r) : null);
	}, o.prototype.then = function(e, t) {
		var n = this;
		return this.thenCore(e, t, function(e, t) {
			return n.updateProgress(null, null, 1, [e]), Promise.prototype.then.call(this, function(t) {
				return n.updateProgress(null, e), t;
			}).then(e, t).then(function(e) {
				return n.updateProgress(1), e;
			});
		});
	}, o.prototype.thenCore = function(e, t, n) {
		n ||= Promise.prototype.then;
		var r = this;
		e &&= e.bind(r), t &&= t.bind(r);
		var i = Promise.toString().indexOf("[native code]") !== -1 && Promise.name === "Promise" ? r : o.convert(Object.assign({}, r), Promise.prototype), a = n.call(i, e, t);
		return o.convert(a, r.__proto__);
	}, o.prototype.thenExternal = function(e, t) {
		return Promise.prototype.then.call(this, e, t);
	}, o.prototype.thenList = function(e) {
		var t = this;
		return e.forEach(function(e) {
			t = t.thenCore(e);
		}), t;
	}, o.prototype.catch = function(e) {
		e &&= e.bind(this);
		var t = Promise.prototype.catch.call(this, e);
		return o.convert(t, this);
	}, o.prototype.catchExternal = function(e) {
		return Promise.prototype.catch.call(this, e);
	}, o.prototype.error = function(e) {
		return this.then(function() {
			throw Error(e);
		});
	}, o.prototype.using = o.prototype.set, o.prototype.saveAs = o.prototype.save, o.prototype.export = o.prototype.output, o.prototype.run = o.prototype.then, jb.getPageSize = function(e, t, n) {
		if (Fa(e) === "object") {
			var r = e;
			e = r.orientation, t = r.unit || t, n = r.format || n;
		}
		t ||= "mm", n ||= "a4", e = ("" + (e || "P")).toLowerCase();
		var i, a = ("" + n).toLowerCase(), o = {
			a0: [2383.94, 3370.39],
			a1: [1683.78, 2383.94],
			a2: [1190.55, 1683.78],
			a3: [841.89, 1190.55],
			a4: [595.28, 841.89],
			a5: [419.53, 595.28],
			a6: [297.64, 419.53],
			a7: [209.76, 297.64],
			a8: [147.4, 209.76],
			a9: [104.88, 147.4],
			a10: [73.7, 104.88],
			b0: [2834.65, 4008.19],
			b1: [2004.09, 2834.65],
			b2: [1417.32, 2004.09],
			b3: [1000.63, 1417.32],
			b4: [708.66, 1000.63],
			b5: [498.9, 708.66],
			b6: [354.33, 498.9],
			b7: [249.45, 354.33],
			b8: [175.75, 249.45],
			b9: [124.72, 175.75],
			b10: [87.87, 124.72],
			c0: [2599.37, 3676.54],
			c1: [1836.85, 2599.37],
			c2: [1298.27, 1836.85],
			c3: [918.43, 1298.27],
			c4: [649.13, 918.43],
			c5: [459.21, 649.13],
			c6: [323.15, 459.21],
			c7: [229.61, 323.15],
			c8: [161.57, 229.61],
			c9: [113.39, 161.57],
			c10: [79.37, 113.39],
			dl: [311.81, 623.62],
			letter: [612, 792],
			"government-letter": [576, 756],
			legal: [612, 1008],
			"junior-legal": [576, 360],
			ledger: [1224, 792],
			tabloid: [792, 1224],
			"credit-card": [153, 243]
		};
		switch (t) {
			case "pt":
				i = 1;
				break;
			case "mm":
				i = 72 / 25.4;
				break;
			case "cm":
				i = 72 / 2.54;
				break;
			case "in":
				i = 72;
				break;
			case "px":
				i = .75;
				break;
			case "pc":
			case "em":
				i = 12;
				break;
			case "ex":
				i = 6;
				break;
			default: throw "Invalid unit: " + t;
		}
		var s, c = 0, l = 0;
		if (o.hasOwnProperty(a)) c = o[a][1] / i, l = o[a][0] / i;
		else try {
			c = n[1], l = n[0];
		} catch {
			throw Error("Invalid format: " + n);
		}
		if (e === "p" || e === "portrait") e = "p", l > c && (s = l, l = c, c = s);
		else {
			if (e !== "l" && e !== "landscape") throw "Invalid orientation: " + e;
			e = "l", c > l && (s = l, l = c, c = s);
		}
		return {
			width: l,
			height: c,
			unit: t,
			k: i,
			orientation: e
		};
	}, e.html = function(e, t) {
		(t ||= {}).callback = t.callback || function() {}, t.html2canvas = t.html2canvas || {}, t.html2canvas.canvas = t.html2canvas.canvas || this.canvas, t.jsPDF = t.jsPDF || this, t.fontFaces = t.fontFaces ? t.fontFaces.map(Tx) : null;
		var n = new o(t);
		return t.worker ? n : n.from(e).doCallback();
	};
}(jb.API), jb.API.addJS = function(e) {
	var t, n, r = function(e) {
		for (var t = "", n = 0; n < e.length; n++) {
			var r = e[n];
			if (r === "(" || r === ")") {
				for (var i = 0, a = n - 1; a >= 0 && e[a] === "\\"; a--) i++;
				t += i % 2 == 0 ? "\\" + r : r;
			} else t += r;
		}
		return t;
	}(e);
	return this.internal.events.subscribe("postPutResources", function() {
		t = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + (t + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), n = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + r + ")"), this.internal.out(">>"), this.internal.out("endobj");
	}), this.internal.events.subscribe("putCatalog", function() {
		t !== void 0 && n !== void 0 && this.internal.out("/Names <</JavaScript " + t + " 0 R>>");
	}), this;
}, function(e) {
	var t;
	e.events.push(["postPutResources", function() {
		var e = this, n = /^(\d+) 0 obj$/;
		if (this.outline.root.children.length > 0) for (var r = e.outline.render().split(/\r\n/), i = 0; i < r.length; i++) {
			var a = r[i], o = n.exec(a);
			if (o != null) {
				var s = o[1];
				e.internal.newObjectDeferredBegin(s, !1);
			}
			e.internal.write(a);
		}
		if (this.outline.createNamedDestinations) {
			var c = this.internal.pages.length, l = [];
			for (i = 0; i < c; i++) {
				var u = e.internal.newObject();
				l.push(u);
				var d = e.internal.getPageInfo(i + 1);
				e.internal.write("<< /D[" + d.objId + " 0 R /XYZ null null null]>> endobj");
			}
			var f = e.internal.newObject();
			for (e.internal.write("<< /Names [ "), i = 0; i < l.length; i++) e.internal.write("(page_" + (i + 1) + ")" + l[i] + " 0 R");
			e.internal.write(" ] >>", "endobj"), t = e.internal.newObject(), e.internal.write("<< /Dests " + f + " 0 R"), e.internal.write(">>", "endobj");
		}
	}]), e.events.push(["putCatalog", function() {
		var e = this;
		e.outline.root.children.length > 0 && (e.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && e.internal.write("/Names " + t + " 0 R"));
	}]), e.events.push(["initialized", function() {
		var e = this;
		e.outline = {
			createNamedDestinations: !1,
			root: { children: [] }
		}, e.outline.add = function(e, t, n) {
			var r = {
				title: t,
				options: n,
				children: []
			};
			return e ??= this.root, e.children.push(r), r;
		}, e.outline.render = function() {
			return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = e, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
		}, e.outline.genIds_r = function(t) {
			t.id = e.internal.newObjectDeferred();
			for (var n = 0; n < t.children.length; n++) this.genIds_r(t.children[n]);
		}, e.outline.renderRoot = function(e) {
			this.objStart(e), this.line("/Type /Outlines"), e.children.length > 0 && (this.line("/First " + this.makeRef(e.children[0])), this.line("/Last " + this.makeRef(e.children[e.children.length - 1]))), this.line("/Count " + this.count_r({ count: 0 }, e)), this.objEnd();
		}, e.outline.renderItems = function(t) {
			for (var n = this.ctx.pdf.internal.getVerticalCoordinateString, r = 0; r < t.children.length; r++) {
				var i = t.children[r];
				this.objStart(i), this.line("/Title " + this.makeString(i.title)), this.line("/Parent " + this.makeRef(t)), r > 0 && this.line("/Prev " + this.makeRef(t.children[r - 1])), r < t.children.length - 1 && this.line("/Next " + this.makeRef(t.children[r + 1])), i.children.length > 0 && (this.line("/First " + this.makeRef(i.children[0])), this.line("/Last " + this.makeRef(i.children[i.children.length - 1])));
				var a = this.count = this.count_r({ count: 0 }, i);
				if (a > 0 && this.line("/Count " + a), i.options && i.options.pageNumber) {
					var o = e.internal.getPageInfo(i.options.pageNumber);
					this.line("/Dest [" + o.objId + " 0 R /XYZ 0 " + n(0) + " 0]");
				}
				this.objEnd();
			}
			for (var s = 0; s < t.children.length; s++) this.renderItems(t.children[s]);
		}, e.outline.line = function(e) {
			this.ctx.val += e + "\r\n";
		}, e.outline.makeRef = function(e) {
			return e.id + " 0 R";
		}, e.outline.makeString = function(t) {
			return "(" + e.internal.pdfEscape(t) + ")";
		}, e.outline.objStart = function(e) {
			this.ctx.val += "\r\n" + e.id + " 0 obj\r\n<<\r\n";
		}, e.outline.objEnd = function() {
			this.ctx.val += ">> \r\nendobj\r\n";
		}, e.outline.count_r = function(e, t) {
			for (var n = 0; n < t.children.length; n++) e.count++, this.count_r(e, t.children[n]);
			return e.count;
		};
	}]);
}(jb.API), function(e) {
	var t = [
		192,
		193,
		194,
		195,
		196,
		197,
		198,
		199
	];
	e.processJPEG = function(e, n, r, i, a, o) {
		var s, c = this.decode.DCT_DECODE, l = null;
		if (typeof e == "string" || this.__addimage__.isArrayBuffer(e) || this.__addimage__.isArrayBufferView(e)) {
			switch (e = a || e, e = this.__addimage__.isArrayBuffer(e) ? new Uint8Array(e) : e, s = function(e) {
				for (var n, r = 256 * e.charCodeAt(4) + e.charCodeAt(5), i = e.length, a = {
					width: 0,
					height: 0,
					numcomponents: 1
				}, o = 4; o < i; o += 2) {
					if (o += r, t.indexOf(e.charCodeAt(o + 1)) !== -1) {
						n = 256 * e.charCodeAt(o + 5) + e.charCodeAt(o + 6), a = {
							width: 256 * e.charCodeAt(o + 7) + e.charCodeAt(o + 8),
							height: n,
							numcomponents: e.charCodeAt(o + 9)
						};
						break;
					}
					r = 256 * e.charCodeAt(o + 2) + e.charCodeAt(o + 3);
				}
				return a;
			}(e = this.__addimage__.isArrayBufferView(e) ? this.__addimage__.arrayBufferToBinaryString(e) : e), s.numcomponents) {
				case 1:
					o = this.color_spaces.DEVICE_GRAY;
					break;
				case 4:
					o = this.color_spaces.DEVICE_CMYK;
					break;
				case 3: o = this.color_spaces.DEVICE_RGB;
			}
			l = {
				data: e,
				width: s.width,
				height: s.height,
				colorSpace: o,
				bitsPerComponent: 8,
				filter: c,
				index: n,
				alias: r
			};
		}
		return l;
	};
}(jb.API), jb.API.processPNG = function(e, t, n, r) {
	if (this.__addimage__.isArrayBuffer(e) && (e = new Uint8Array(e)), this.__addimage__.isArrayBufferView(e)) {
		var i, a = _f(e, { checkCrc: !0 }), o = a.width, s = a.height, c = a.channels, l = a.palette, u = a.depth;
		i = l && c === 1 ? function(e) {
			for (var t = e.width, n = e.height, r = e.data, i = e.palette, a = e.depth, o = !1, s = [], c = [], l = void 0, u = !1, d = 0, f = 0; f < i.length; f++) {
				var p = Oo(i[f], 4), m = p[0], h = p[1], g = p[2], _ = p[3];
				s.push(m, h, g), _ != null && (_ === 0 ? (d++, c.length < 1 && c.push(f)) : _ < 255 && (u = !0));
			}
			if (u || d > 1) {
				o = !0, c = void 0;
				var v = t * n;
				l = new Uint8Array(v);
				for (var y = new DataView(r.buffer), b = 0; b < v; b++) {
					var x = Oo(i[qx(y, b, a)], 4)[3];
					l[b] = x;
				}
			} else d === 0 && (c = void 0);
			return {
				colorSpace: "Indexed",
				colorsPerPixel: 1,
				sMaskBitsPerComponent: o ? 8 : void 0,
				colorBytes: r,
				alphaBytes: l,
				needSMask: o,
				palette: s,
				mask: c
			};
		}(a) : c === 2 || c === 4 ? function(e) {
			for (var t = e.data, n = e.width, r = e.height, i = e.channels, a = e.depth, o = i === 2 ? "DeviceGray" : "DeviceRGB", s = i - 1, c = n * r, l = s, u = c * l, d = 1 * c, f = Math.ceil(u * a / 8), p = Math.ceil(d * a / 8), m = new Uint8Array(f), h = new Uint8Array(p), g = new DataView(t.buffer), _ = new DataView(m.buffer), v = new DataView(h.buffer), y = !1, b = 0; b < c; b++) {
				for (var x = b * i, S = 0; S < l; S++) Jx(_, qx(g, x + S, a), b * l + S, a);
				var C = qx(g, x + l, a);
				C < (1 << a) - 1 && (y = !0), Jx(v, C, 1 * b, a);
			}
			return {
				colorSpace: o,
				colorsPerPixel: s,
				sMaskBitsPerComponent: y ? a : void 0,
				colorBytes: m,
				alphaBytes: h,
				needSMask: y
			};
		}(a) : function(e) {
			var t = e.data, n = e.channels === 1 ? "DeviceGray" : "DeviceRGB";
			return {
				colorSpace: n,
				colorsPerPixel: n === "DeviceGray" ? 1 : 3,
				colorBytes: t instanceof Uint16Array ? function(e) {
					for (var t = e.length, n = new Uint8Array(2 * t), r = new DataView(n.buffer, n.byteOffset, n.byteLength), i = 0; i < t; i++) r.setUint16(2 * i, e[i], !1);
					return n;
				}(t) : t,
				needSMask: !1
			};
		}(a);
		var d, f, p, m = i, h = m.colorSpace, g = m.colorsPerPixel, _ = m.sMaskBitsPerComponent, v = m.colorBytes, y = m.alphaBytes, b = m.needSMask, x = m.palette, S = m.mask, C = null;
		return r !== jb.API.image_compression.NONE && typeof xo == "function" ? (C = function(e) {
			var t;
			switch (e) {
				case jb.API.image_compression.FAST:
					t = 11;
					break;
				case jb.API.image_compression.MEDIUM:
					t = 13;
					break;
				case jb.API.image_compression.SLOW:
					t = 14;
					break;
				default: t = 12;
			}
			return t;
		}(r), d = this.decode.FLATE_DECODE, f = `/Predictor ${C} /Colors ${g} /BitsPerComponent ${u} /Columns ${o}`, e = zx(v, Math.ceil(o * g * u / 8), g, u, r), b && (p = zx(y, Math.ceil(o * _ / 8), 1, _, r))) : (d = void 0, f = void 0, e = v, b && (p = y)), (this.__addimage__.isArrayBuffer(e) || this.__addimage__.isArrayBufferView(e)) && (e = this.__addimage__.arrayBufferToBinaryString(e)), (p && this.__addimage__.isArrayBuffer(p) || this.__addimage__.isArrayBufferView(p)) && (p = this.__addimage__.arrayBufferToBinaryString(p)), {
			alias: n,
			data: e,
			index: t,
			filter: d,
			decodeParameters: f,
			transparency: S,
			palette: x,
			sMask: p,
			predictor: C,
			width: o,
			height: s,
			bitsPerComponent: u,
			sMaskBitsPerComponent: _,
			colorSpace: h
		};
	}
}, function(e) {
	e.processGIF89A = function(t, n, r, i) {
		var a = new Xx(t), o = a.width, s = a.height, c = [];
		a.decodeAndBlitFrameRGBA(0, c);
		var l = {
			data: c,
			width: o,
			height: s
		}, u = new Qx(100).encode(l, 100);
		return e.processJPEG.call(this, u, n, r, i);
	}, e.processGIF87A = e.processGIF89A;
}(jb.API), $x.prototype.parseHeader = function() {
	if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.bitPP === 16 && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
		var e = this.colors === 0 ? 1 << this.bitPP : this.colors;
		this.palette = Array(e);
		for (var t = 0; t < e; t++) {
			var n = this.datav.getUint8(this.pos++, !0), r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0);
			this.palette[t] = {
				red: i,
				green: r,
				blue: n,
				quad: a
			};
		}
	}
	this.height < 0 && (this.height *= -1, this.bottom_up = !1);
}, $x.prototype.parseBGR = function() {
	this.pos = this.offset;
	var e = "bit" + this.bitPP, t = this.width * this.height * 4;
	if (t > 536870912) throw Error("Image dimensions exceed 512MB, which is too large.");
	this.data = new Uint8Array(t);
	try {
		this[e]();
	} catch (e) {
		eb.log("bit decode error:" + e);
	}
}, $x.prototype.bit1 = function() {
	var e, t = Math.ceil(this.width / 8), n = t % 4;
	for (e = this.height - 1; e >= 0; e--) {
		for (var r = this.bottom_up ? e : this.height - 1 - e, i = 0; i < t; i++) for (var a = this.datav.getUint8(this.pos++, !0), o = r * this.width * 4 + 8 * i * 4, s = 0; s < 8 && 8 * i + s < this.width; s++) {
			var c = this.palette[a >> 7 - s & 1];
			this.data[o + 4 * s] = c.blue, this.data[o + 4 * s + 1] = c.green, this.data[o + 4 * s + 2] = c.red, this.data[o + 4 * s + 3] = 255;
		}
		n !== 0 && (this.pos += 4 - n);
	}
}, $x.prototype.bit4 = function() {
	for (var e = Math.ceil(this.width / 2), t = e % 4, n = this.height - 1; n >= 0; n--) {
		for (var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < e; i++) {
			var a = this.datav.getUint8(this.pos++, !0), o = r * this.width * 4 + 2 * i * 4, s = a >> 4, c = 15 & a, l = this.palette[s];
			if (this.data[o] = l.blue, this.data[o + 1] = l.green, this.data[o + 2] = l.red, this.data[o + 3] = 255, 2 * i + 1 >= this.width) break;
			l = this.palette[c], this.data[o + 4] = l.blue, this.data[o + 4 + 1] = l.green, this.data[o + 4 + 2] = l.red, this.data[o + 4 + 3] = 255;
		}
		t !== 0 && (this.pos += 4 - t);
	}
}, $x.prototype.bit8 = function() {
	for (var e = this.width % 4, t = this.height - 1; t >= 0; t--) {
		for (var n = this.bottom_up ? t : this.height - 1 - t, r = 0; r < this.width; r++) {
			var i = this.datav.getUint8(this.pos++, !0), a = n * this.width * 4 + 4 * r;
			if (i < this.palette.length) {
				var o = this.palette[i];
				this.data[a] = o.red, this.data[a + 1] = o.green, this.data[a + 2] = o.blue, this.data[a + 3] = 255;
			} else this.data[a] = 255, this.data[a + 1] = 255, this.data[a + 2] = 255, this.data[a + 3] = 255;
		}
		e !== 0 && (this.pos += 4 - e);
	}
}, $x.prototype.bit15 = function() {
	for (var e = this.width % 3, t = 31, n = this.height - 1; n >= 0; n--) {
		for (var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < this.width; i++) {
			var a = this.datav.getUint16(this.pos, !0);
			this.pos += 2;
			var o = (a & t) / t * 255 | 0, s = (a >> 5 & t) / t * 255 | 0, c = (a >> 10 & t) / t * 255 | 0, l = a >> 15 ? 255 : 0, u = r * this.width * 4 + 4 * i;
			this.data[u] = c, this.data[u + 1] = s, this.data[u + 2] = o, this.data[u + 3] = l;
		}
		this.pos += e;
	}
}, $x.prototype.bit16 = function() {
	for (var e = this.width % 3, t = 31, n = 63, r = this.height - 1; r >= 0; r--) {
		for (var i = this.bottom_up ? r : this.height - 1 - r, a = 0; a < this.width; a++) {
			var o = this.datav.getUint16(this.pos, !0);
			this.pos += 2;
			var s = (o & t) / t * 255 | 0, c = (o >> 5 & n) / n * 255 | 0, l = (o >> 11) / t * 255 | 0, u = i * this.width * 4 + 4 * a;
			this.data[u] = l, this.data[u + 1] = c, this.data[u + 2] = s, this.data[u + 3] = 255;
		}
		this.pos += e;
	}
}, $x.prototype.bit24 = function() {
	for (var e = this.height - 1; e >= 0; e--) {
		for (var t = this.bottom_up ? e : this.height - 1 - e, n = 0; n < this.width; n++) {
			var r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = t * this.width * 4 + 4 * n;
			this.data[o] = a, this.data[o + 1] = i, this.data[o + 2] = r, this.data[o + 3] = 255;
		}
		this.pos += this.width % 4;
	}
}, $x.prototype.bit32 = function() {
	for (var e = this.height - 1; e >= 0; e--) for (var t = this.bottom_up ? e : this.height - 1 - e, n = 0; n < this.width; n++) {
		var r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), s = t * this.width * 4 + 4 * n;
		this.data[s] = a, this.data[s + 1] = i, this.data[s + 2] = r, this.data[s + 3] = o;
	}
}, $x.prototype.getData = function() {
	return this.data;
}, function(e) {
	e.processBMP = function(t, n, r, i) {
		var a = new $x(t, !1), o = a.width, s = a.height, c = {
			data: a.getData(),
			width: o,
			height: s
		}, l = new Qx(100).encode(c, 100);
		return e.processJPEG.call(this, l, n, r, i);
	};
}(jb.API), eS.prototype.getData = function() {
	return this.data;
}, function(e) {
	e.processWEBP = function(t, n, r, i) {
		var a = new eS(t), o = a.width, s = a.height, c = {
			data: a.getData(),
			width: o,
			height: s
		}, l = new Qx(100).encode(c, 100);
		return e.processJPEG.call(this, l, n, r, i);
	};
}(jb.API), jb.API.processRGBA = function(e, t, n) {
	for (var r = e.data, i = r.length, a = new Uint8Array(i / 4 * 3), o = new Uint8Array(i / 4), s = 0, c = 0, l = 0; l < i; l += 4) {
		var u = r[l], d = r[l + 1], f = r[l + 2], p = r[l + 3];
		a[s++] = u, a[s++] = d, a[s++] = f, o[c++] = p;
	}
	var m = this.__addimage__.arrayBufferToBinaryString(a);
	return {
		alpha: this.__addimage__.arrayBufferToBinaryString(o),
		data: m,
		index: t,
		alias: n,
		colorSpace: "DeviceRGB",
		bitsPerComponent: 8,
		width: e.width,
		height: e.height
	};
}, jb.API.setLanguage = function(e) {
	return this.internal.languageSettings === void 0 && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), {
		af: "Afrikaans",
		sq: "Albanian",
		ar: "Arabic (Standard)",
		"ar-DZ": "Arabic (Algeria)",
		"ar-BH": "Arabic (Bahrain)",
		"ar-EG": "Arabic (Egypt)",
		"ar-IQ": "Arabic (Iraq)",
		"ar-JO": "Arabic (Jordan)",
		"ar-KW": "Arabic (Kuwait)",
		"ar-LB": "Arabic (Lebanon)",
		"ar-LY": "Arabic (Libya)",
		"ar-MA": "Arabic (Morocco)",
		"ar-OM": "Arabic (Oman)",
		"ar-QA": "Arabic (Qatar)",
		"ar-SA": "Arabic (Saudi Arabia)",
		"ar-SY": "Arabic (Syria)",
		"ar-TN": "Arabic (Tunisia)",
		"ar-AE": "Arabic (U.A.E.)",
		"ar-YE": "Arabic (Yemen)",
		an: "Aragonese",
		hy: "Armenian",
		as: "Assamese",
		ast: "Asturian",
		az: "Azerbaijani",
		eu: "Basque",
		be: "Belarusian",
		bn: "Bengali",
		bs: "Bosnian",
		br: "Breton",
		bg: "Bulgarian",
		my: "Burmese",
		ca: "Catalan",
		ch: "Chamorro",
		ce: "Chechen",
		zh: "Chinese",
		"zh-HK": "Chinese (Hong Kong)",
		"zh-CN": "Chinese (PRC)",
		"zh-SG": "Chinese (Singapore)",
		"zh-TW": "Chinese (Taiwan)",
		cv: "Chuvash",
		co: "Corsican",
		cr: "Cree",
		hr: "Croatian",
		cs: "Czech",
		da: "Danish",
		nl: "Dutch (Standard)",
		"nl-BE": "Dutch (Belgian)",
		en: "English",
		"en-AU": "English (Australia)",
		"en-BZ": "English (Belize)",
		"en-CA": "English (Canada)",
		"en-IE": "English (Ireland)",
		"en-JM": "English (Jamaica)",
		"en-NZ": "English (New Zealand)",
		"en-PH": "English (Philippines)",
		"en-ZA": "English (South Africa)",
		"en-TT": "English (Trinidad & Tobago)",
		"en-GB": "English (United Kingdom)",
		"en-US": "English (United States)",
		"en-ZW": "English (Zimbabwe)",
		eo: "Esperanto",
		et: "Estonian",
		fo: "Faeroese",
		fj: "Fijian",
		fi: "Finnish",
		fr: "French (Standard)",
		"fr-BE": "French (Belgium)",
		"fr-CA": "French (Canada)",
		"fr-FR": "French (France)",
		"fr-LU": "French (Luxembourg)",
		"fr-MC": "French (Monaco)",
		"fr-CH": "French (Switzerland)",
		fy: "Frisian",
		fur: "Friulian",
		gd: "Gaelic (Scots)",
		"gd-IE": "Gaelic (Irish)",
		gl: "Galacian",
		ka: "Georgian",
		de: "German (Standard)",
		"de-AT": "German (Austria)",
		"de-DE": "German (Germany)",
		"de-LI": "German (Liechtenstein)",
		"de-LU": "German (Luxembourg)",
		"de-CH": "German (Switzerland)",
		el: "Greek",
		gu: "Gujurati",
		ht: "Haitian",
		he: "Hebrew",
		hi: "Hindi",
		hu: "Hungarian",
		is: "Icelandic",
		id: "Indonesian",
		iu: "Inuktitut",
		ga: "Irish",
		it: "Italian (Standard)",
		"it-CH": "Italian (Switzerland)",
		ja: "Japanese",
		kn: "Kannada",
		ks: "Kashmiri",
		kk: "Kazakh",
		km: "Khmer",
		ky: "Kirghiz",
		tlh: "Klingon",
		ko: "Korean",
		"ko-KP": "Korean (North Korea)",
		"ko-KR": "Korean (South Korea)",
		la: "Latin",
		lv: "Latvian",
		lt: "Lithuanian",
		lb: "Luxembourgish",
		mk: "North Macedonia",
		ms: "Malay",
		ml: "Malayalam",
		mt: "Maltese",
		mi: "Maori",
		mr: "Marathi",
		mo: "Moldavian",
		nv: "Navajo",
		ng: "Ndonga",
		ne: "Nepali",
		no: "Norwegian",
		nb: "Norwegian (Bokmal)",
		nn: "Norwegian (Nynorsk)",
		oc: "Occitan",
		or: "Oriya",
		om: "Oromo",
		fa: "Persian",
		"fa-IR": "Persian/Iran",
		pl: "Polish",
		pt: "Portuguese",
		"pt-BR": "Portuguese (Brazil)",
		pa: "Punjabi",
		"pa-IN": "Punjabi (India)",
		"pa-PK": "Punjabi (Pakistan)",
		qu: "Quechua",
		rm: "Rhaeto-Romanic",
		ro: "Romanian",
		"ro-MO": "Romanian (Moldavia)",
		ru: "Russian",
		"ru-MO": "Russian (Moldavia)",
		sz: "Sami (Lappish)",
		sg: "Sango",
		sa: "Sanskrit",
		sc: "Sardinian",
		sd: "Sindhi",
		si: "Singhalese",
		sr: "Serbian",
		sk: "Slovak",
		sl: "Slovenian",
		so: "Somani",
		sb: "Sorbian",
		es: "Spanish",
		"es-AR": "Spanish (Argentina)",
		"es-BO": "Spanish (Bolivia)",
		"es-CL": "Spanish (Chile)",
		"es-CO": "Spanish (Colombia)",
		"es-CR": "Spanish (Costa Rica)",
		"es-DO": "Spanish (Dominican Republic)",
		"es-EC": "Spanish (Ecuador)",
		"es-SV": "Spanish (El Salvador)",
		"es-GT": "Spanish (Guatemala)",
		"es-HN": "Spanish (Honduras)",
		"es-MX": "Spanish (Mexico)",
		"es-NI": "Spanish (Nicaragua)",
		"es-PA": "Spanish (Panama)",
		"es-PY": "Spanish (Paraguay)",
		"es-PE": "Spanish (Peru)",
		"es-PR": "Spanish (Puerto Rico)",
		"es-ES": "Spanish (Spain)",
		"es-UY": "Spanish (Uruguay)",
		"es-VE": "Spanish (Venezuela)",
		sx: "Sutu",
		sw: "Swahili",
		sv: "Swedish",
		"sv-FI": "Swedish (Finland)",
		"sv-SV": "Swedish (Sweden)",
		ta: "Tamil",
		tt: "Tatar",
		te: "Teluga",
		th: "Thai",
		tig: "Tigre",
		ts: "Tsonga",
		tn: "Tswana",
		tr: "Turkish",
		tk: "Turkmen",
		uk: "Ukrainian",
		hsb: "Upper Sorbian",
		ur: "Urdu",
		ve: "Venda",
		vi: "Vietnamese",
		vo: "Volapuk",
		wa: "Walloon",
		cy: "Welsh",
		xh: "Xhosa",
		ji: "Yiddish",
		zu: "Zulu"
	}[e] !== void 0 && (this.internal.languageSettings.languageCode = e, !1 === this.internal.languageSettings.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
		this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
	}), this.internal.languageSettings.isSubscribed = !0)), this;
}, Nx = jb.API, Px = Nx.getCharWidthsArray = function(e, t) {
	var n, r, i = (t ||= {}).font || this.internal.getFont(), a = t.fontSize || this.internal.getFontSize(), o = t.charSpace || this.internal.getCharSpace(), s = t.widths ? t.widths : i.metadata.Unicode.widths, c = s.fof ? s.fof : 1, l = t.kerning ? t.kerning : i.metadata.Unicode.kerning, u = l.fof ? l.fof : 1, d = !1 !== t.doKerning, f = 0, p = e.length, m = 0, h = s[0] || c, g = [];
	for (n = 0; n < p; n++) r = e.charCodeAt(n), typeof i.metadata.widthOfString == "function" ? g.push((i.metadata.widthOfGlyph(i.metadata.characterToGlyph(r)) + 1e3 / a * o || 0) / 1e3) : (f = d && Fa(l[r]) === "object" && !isNaN(parseInt(l[r][m], 10)) ? l[r][m] / u : 0, g.push((s[r] || h) / c + f)), m = r;
	return g;
}, Fx = Nx.getStringUnitWidth = function(e, t) {
	var n = (t ||= {}).fontSize || this.internal.getFontSize(), r = t.font || this.internal.getFont(), i = t.charSpace || this.internal.getCharSpace();
	return Nx.processArabic && (e = Nx.processArabic(e)), typeof r.metadata.widthOfString == "function" ? r.metadata.widthOfString(e, n, i) / n : Px.apply(this, arguments).reduce(function(e, t) {
		return e + t;
	}, 0);
}, Ix = function(e, t, n, r) {
	for (var i = [], a = 0, o = e.length, s = 0; a !== o && s + t[a] < n;) s += t[a], a++;
	i.push(e.slice(0, a));
	var c = a;
	for (s = 0; a !== o;) s + t[a] > r && (i.push(e.slice(c, a)), s = 0, c = a), s += t[a], a++;
	return c !== a && i.push(e.slice(c, a)), i;
}, Lx = function(e, t, n) {
	n ||= {};
	var r, i, a, o, s, c, l, u = [], d = [u], f = n.textIndent || 0, p = 0, m = 0, h = e.split(" "), g = Px.apply(this, [" ", n])[0];
	if (c = n.lineIndent === -1 ? h[0].length + 2 : n.lineIndent || 0) {
		var _ = Array(c).join(" "), v = [];
		h.map(function(e) {
			(e = e.split(/\s*\n/)).length > 1 ? v = v.concat(e.map(function(e, t) {
				return (t && e.length ? "\n" : "") + e;
			})) : v.push(e[0]);
		}), h = v, c = Fx.apply(this, [_, n]);
	}
	for (a = 0, o = h.length; a < o; a++) {
		var y = 0;
		if (r = h[a], c && r[0] == "\n" && (r = r.substr(1), y = 1), f + p + (m = (i = Px.apply(this, [r, n])).reduce(function(e, t) {
			return e + t;
		}, 0)) > t || y) {
			if (m > t) {
				for (s = Ix.apply(this, [
					r,
					i,
					t - (f + p),
					t
				]), u.push(s.shift()), u = [s.pop()]; s.length;) d.push([s.shift()]);
				m = i.slice(r.length - (u[0] ? u[0].length : 0)).reduce(function(e, t) {
					return e + t;
				}, 0);
			} else u = [r];
			d.push(u), f = m + c, p = g;
		} else u.push(r), f += p + m, p = g;
	}
	return l = c ? function(e, t) {
		return (t ? _ : "") + e.join(" ");
	} : function(e) {
		return e.join(" ");
	}, d.map(l);
}, Nx.splitTextToSize = function(e, t, n) {
	var r, i = (n ||= {}).fontSize || this.internal.getFontSize(), a = function(e) {
		if (e.widths && e.kerning) return {
			widths: e.widths,
			kerning: e.kerning
		};
		var t = this.internal.getFont(e.fontName, e.fontStyle), n = "Unicode";
		return t.metadata[n] ? {
			widths: t.metadata[n].widths || { 0: 1 },
			kerning: t.metadata[n].kerning || {}
		} : {
			font: t.metadata,
			fontSize: this.internal.getFontSize(),
			charSpace: this.internal.getCharSpace()
		};
	}.call(this, n);
	r = Array.isArray(e) ? e : String(e).split(/\r?\n/);
	var o = 1 * this.internal.scaleFactor * t / i;
	a.textIndent = n.textIndent ? 1 * n.textIndent * this.internal.scaleFactor / i : 0, a.lineIndent = n.lineIndent;
	var s, c, l = [];
	for (s = 0, c = r.length; s < c; s++) l = l.concat(Lx.apply(this, [
		r[s],
		o,
		a
	]));
	return l;
}, function(e) {
	e.__fontmetrics__ = e.__fontmetrics__ || {};
	for (var t = "0123456789abcdef", n = "klmnopqrstuvwxyz", r = {}, i = {}, a = 0; a < 16; a++) r[n[a]] = t[a], i[t[a]] = n[a];
	var o = function(e) {
		return "0x" + parseInt(e, 10).toString(16);
	}, s = e.__fontmetrics__.compress = function(e) {
		var t, n, r, a, c = ["{"];
		for (var l in e) {
			if (t = e[l], isNaN(parseInt(l, 10)) ? n = "'" + l + "'" : (l = parseInt(l, 10), n = (n = o(l).slice(2)).slice(0, -1) + i[n.slice(-1)]), typeof t == "number") t < 0 ? (r = o(t).slice(3), a = "-") : (r = o(t).slice(2), a = ""), r = a + r.slice(0, -1) + i[r.slice(-1)];
			else {
				if (Fa(t) !== "object") throw Error("Don't know what to do with value type " + Fa(t) + ".");
				r = s(t);
			}
			c.push(n + r);
		}
		return c.push("}"), c.join("");
	}, c = e.__fontmetrics__.uncompress = function(e) {
		if (typeof e != "string") throw Error("Invalid argument passed to uncompress.");
		for (var t, n, i, a, o = {}, s = 1, c = o, l = [], u = "", d = "", f = e.length - 1, p = 1; p < f; p += 1) (a = e[p]) == "'" ? t ? (i = t.join(""), t = void 0) : t = [] : t ? t.push(a) : a == "{" ? (l.push([c, i]), c = {}, i = void 0) : a == "}" ? ((n = l.pop())[0][n[1]] = c, i = void 0, c = n[0]) : a == "-" ? s = -1 : i === void 0 ? r.hasOwnProperty(a) ? (u += r[a], i = parseInt(u, 16) * s, s = 1, u = "") : u += a : r.hasOwnProperty(a) ? (d += r[a], c[i] = parseInt(d, 16) * s, s = 1, i = void 0, d = "") : d += a;
		return o;
	}, l = {
		codePages: ["WinAnsiEncoding"],
		WinAnsiEncoding: c("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")
	}, u = { Unicode: {
		Courier: l,
		"Courier-Bold": l,
		"Courier-BoldOblique": l,
		"Courier-Oblique": l,
		Helvetica: l,
		"Helvetica-Bold": l,
		"Helvetica-BoldOblique": l,
		"Helvetica-Oblique": l,
		"Times-Roman": l,
		"Times-Bold": l,
		"Times-BoldItalic": l,
		"Times-Italic": l
	} }, d = { Unicode: {
		"Courier-Oblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
		"Times-BoldItalic": c("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),
		"Helvetica-Bold": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
		Courier: c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
		"Courier-BoldOblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
		"Times-Bold": c("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),
		Symbol: c("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),
		Helvetica: c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),
		"Helvetica-BoldOblique": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
		ZapfDingbats: c("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),
		"Courier-Bold": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
		"Times-Italic": c("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),
		"Times-Roman": c("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),
		"Helvetica-Oblique": c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")
	} };
	e.events.push(["addFont", function(e) {
		var t = e.font, n = d.Unicode[t.postScriptName];
		n && (t.metadata.Unicode = {}, t.metadata.Unicode.widths = n.widths, t.metadata.Unicode.kerning = n.kerning);
		var r = u.Unicode[t.postScriptName];
		r && (t.metadata.Unicode.encoding = r, t.encoding = r.codePages[0]);
	}]);
}(jb.API), function(e) {
	var t = function(e) {
		for (var t = e.length, n = new Uint8Array(t), r = 0; r < t; r++) n[r] = e.charCodeAt(r);
		return n;
	};
	e.API.events.push(["addFont", function(n) {
		var r = void 0, i = n.font, a = n.instance;
		if (!i.isStandardFont) {
			if (a === void 0) throw Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
			if (typeof (r = !1 === a.existsFileInVFS(i.postScriptName) ? a.loadFile(i.postScriptName) : a.getFileFromVFS(i.postScriptName)) != "string") throw Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + i.postScriptName + "').");
			(function(n, r) {
				r = /^\x00\x01\x00\x00/.test(r) ? t(r) : t(ob(r)), n.metadata = e.API.TTFFont.open(r), n.metadata.Unicode = n.metadata.Unicode || {
					encoding: {},
					kerning: {},
					widths: []
				}, n.metadata.glyIdsUsed = [0];
			})(i, r);
		}
	}]);
}(jb), jb.API.addSvgAsImage = function(e, t, n, r, i, a, o, s) {
	if (isNaN(t) || isNaN(n)) throw eb.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), /* @__PURE__ */ Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
	if (isNaN(r) || isNaN(i)) throw eb.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), /* @__PURE__ */ Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
	var c = document.createElement("canvas");
	c.width = r, c.height = i;
	var l = c.getContext("2d");
	l.fillStyle = "#fff", l.fillRect(0, 0, c.width, c.height);
	var u = {
		ignoreMouse: !0,
		ignoreAnimation: !0,
		ignoreDimensions: !0
	}, d = this;
	return (Qy.canvg ? Promise.resolve(Qy.canvg) : Promise.resolve().then(() => (Zy(), N_))).catch(function(e) {
		return Promise.reject(/* @__PURE__ */ Error("Could not load canvg: " + e));
	}).then(function(e) {
		return e.default ? e.default : e;
	}).then(function(t) {
		return t.fromString(l, e, u);
	}, function() {
		return Promise.reject(/* @__PURE__ */ Error("Could not load canvg."));
	}).then(function(e) {
		return e.render(u);
	}).then(function() {
		d.addImage(c.toDataURL("image/jpeg", 1), t, n, r, i, o, s);
	});
}, jb.API.putTotalPages = function(e) {
	var t, n = 0;
	parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (t = new RegExp(e, "g"), n = this.internal.getNumberOfPages()) : (t = new RegExp(this.pdfEscape16(e, this.internal.getFont()), "g"), n = this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
	for (var r = 1; r <= this.internal.getNumberOfPages(); r++) for (var i = 0; i < this.internal.pages[r].length; i++) this.internal.pages[r][i] = this.internal.pages[r][i].replace(t, n);
	return this;
}, jb.API.viewerPreferences = function(e, t) {
	var n;
	e ||= {}, t ||= !1;
	var r, i, a, o = {
		HideToolbar: {
			defaultValue: !1,
			value: !1,
			type: "boolean",
			explicitSet: !1,
			valueSet: [!0, !1],
			pdfVersion: 1.3
		},
		HideMenubar: {
			defaultValue: !1,
			value: !1,
			type: "boolean",
			explicitSet: !1,
			valueSet: [!0, !1],
			pdfVersion: 1.3
		},
		HideWindowUI: {
			defaultValue: !1,
			value: !1,
			type: "boolean",
			explicitSet: !1,
			valueSet: [!0, !1],
			pdfVersion: 1.3
		},
		FitWindow: {
			defaultValue: !1,
			value: !1,
			type: "boolean",
			explicitSet: !1,
			valueSet: [!0, !1],
			pdfVersion: 1.3
		},
		CenterWindow: {
			defaultValue: !1,
			value: !1,
			type: "boolean",
			explicitSet: !1,
			valueSet: [!0, !1],
			pdfVersion: 1.3
		},
		DisplayDocTitle: {
			defaultValue: !1,
			value: !1,
			type: "boolean",
			explicitSet: !1,
			valueSet: [!0, !1],
			pdfVersion: 1.4
		},
		NonFullScreenPageMode: {
			defaultValue: "UseNone",
			value: "UseNone",
			type: "name",
			explicitSet: !1,
			valueSet: [
				"UseNone",
				"UseOutlines",
				"UseThumbs",
				"UseOC"
			],
			pdfVersion: 1.3
		},
		Direction: {
			defaultValue: "L2R",
			value: "L2R",
			type: "name",
			explicitSet: !1,
			valueSet: ["L2R", "R2L"],
			pdfVersion: 1.3
		},
		ViewArea: {
			defaultValue: "CropBox",
			value: "CropBox",
			type: "name",
			explicitSet: !1,
			valueSet: [
				"MediaBox",
				"CropBox",
				"TrimBox",
				"BleedBox",
				"ArtBox"
			],
			pdfVersion: 1.4
		},
		ViewClip: {
			defaultValue: "CropBox",
			value: "CropBox",
			type: "name",
			explicitSet: !1,
			valueSet: [
				"MediaBox",
				"CropBox",
				"TrimBox",
				"BleedBox",
				"ArtBox"
			],
			pdfVersion: 1.4
		},
		PrintArea: {
			defaultValue: "CropBox",
			value: "CropBox",
			type: "name",
			explicitSet: !1,
			valueSet: [
				"MediaBox",
				"CropBox",
				"TrimBox",
				"BleedBox",
				"ArtBox"
			],
			pdfVersion: 1.4
		},
		PrintClip: {
			defaultValue: "CropBox",
			value: "CropBox",
			type: "name",
			explicitSet: !1,
			valueSet: [
				"MediaBox",
				"CropBox",
				"TrimBox",
				"BleedBox",
				"ArtBox"
			],
			pdfVersion: 1.4
		},
		PrintScaling: {
			defaultValue: "AppDefault",
			value: "AppDefault",
			type: "name",
			explicitSet: !1,
			valueSet: ["AppDefault", "None"],
			pdfVersion: 1.6
		},
		Duplex: {
			defaultValue: "",
			value: "none",
			type: "name",
			explicitSet: !1,
			valueSet: [
				"Simplex",
				"DuplexFlipShortEdge",
				"DuplexFlipLongEdge",
				"none"
			],
			pdfVersion: 1.7
		},
		PickTrayByPDFSize: {
			defaultValue: !1,
			value: !1,
			type: "boolean",
			explicitSet: !1,
			valueSet: [!0, !1],
			pdfVersion: 1.7
		},
		PrintPageRange: {
			defaultValue: "",
			value: "",
			type: "array",
			explicitSet: !1,
			valueSet: null,
			pdfVersion: 1.7
		},
		NumCopies: {
			defaultValue: 1,
			value: 1,
			type: "integer",
			explicitSet: !1,
			valueSet: null,
			pdfVersion: 1.7
		}
	}, s = Object.keys(o), c = [], l = 0, u = 0, d = 0;
	function f(e, t) {
		var n, r = !1;
		for (n = 0; n < e.length; n += 1) e[n] === t && (r = !0);
		return r;
	}
	if (this.internal.viewerpreferences === void 0 && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(o)), this.internal.viewerpreferences.isSubscribed = !1), n = this.internal.viewerpreferences.configuration, e === "reset" || !0 === t) {
		var p = s.length;
		for (d = 0; d < p; d += 1) n[s[d]].value = n[s[d]].defaultValue, n[s[d]].explicitSet = !1;
	}
	if (Fa(e) === "object") {
		for (i in e) if (a = e[i], f(s, i) && a !== void 0) {
			if (n[i].type === "boolean" && typeof a == "boolean") n[i].value = a;
			else if (n[i].type === "name" && f(n[i].valueSet, a)) n[i].value = a;
			else if (n[i].type === "integer" && Number.isInteger(a)) n[i].value = a;
			else if (n[i].type === "array") {
				for (l = 0; l < a.length; l += 1) if (r = !0, a[l].length === 1 && typeof a[l][0] == "number") c.push(String(a[l] - 1));
				else if (a[l].length > 1) {
					for (u = 0; u < a[l].length; u += 1) typeof a[l][u] != "number" && (r = !1);
					!0 === r && c.push([a[l][0] - 1, a[l][1] - 1].join(" "));
				}
				n[i].value = "[" + c.join(" ") + "]";
			} else n[i].value = n[i].defaultValue;
			n[i].explicitSet = !0;
		}
	}
	return !1 === this.internal.viewerpreferences.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
		var e, t = [];
		for (e in n) !0 === n[e].explicitSet && (n[e].type === "name" ? t.push("/" + e + " /" + n[e].value) : t.push("/" + e + " " + n[e].value));
		t.length !== 0 && this.internal.write("/ViewerPreferences\n<<\n" + t.join("\n") + "\n>>");
	}), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = n, this;
}, jb.API.addMetadata = function(e, t) {
	return this.internal.__metadata__ === void 0 && (this.internal.__metadata__ = {
		metadata: e,
		namespaceUri: t ?? "http://jspdf.default.namespaceuri/",
		rawXml: typeof t == "boolean" && t
	}, this.internal.events.subscribe("putCatalog", nS), this.internal.events.subscribe("postPutResources", tS)), this;
}, function(e) {
	var t = e.API, n = t.pdfEscape16 = function(e, t) {
		for (var n, r = t.metadata.Unicode.widths, i = [
			"",
			"0",
			"00",
			"000",
			"0000"
		], a = [""], o = 0, s = e.length; o < s; ++o) {
			if (n = t.metadata.characterToGlyph(e.charCodeAt(o)), t.metadata.glyIdsUsed.push(n), t.metadata.toUnicode[n] = e.charCodeAt(o), r.indexOf(n) == -1 && (r.push(n), r.push([parseInt(t.metadata.widthOfGlyph(n), 10)])), n == "0") return a.join("");
			n = n.toString(16), a.push(i[4 - n.length], n);
		}
		return a.join("");
	}, r = function(e) {
		var t, n, r, i, a, o, s;
		for (a = "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange", r = [], o = 0, s = (n = Object.keys(e).sort(function(e, t) {
			return e - t;
		})).length; o < s; o++) t = n[o], r.length >= 100 && (a += "\n" + r.length + " beginbfchar\n" + r.join("\n") + "\nendbfchar", r = []), e[t] !== void 0 && e[t] !== null && typeof e[t].toString == "function" && (i = ("0000" + e[t].toString(16)).slice(-4), t = ("0000" + (+t).toString(16)).slice(-4), r.push("<" + t + "><" + i + ">"));
		return r.length && (a += "\n" + r.length + " beginbfchar\n" + r.join("\n") + "\nendbfchar\n"), a + "endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
	};
	t.events.push(["putFont", function(t) {
		(function(t) {
			var n = t.font, i = t.out, a = t.newObject, o = t.putStream;
			if (n.metadata instanceof e.API.TTFFont && n.encoding === "Identity-H") {
				for (var s = n.metadata.Unicode.widths, c = n.metadata.subset.encode(n.metadata.glyIdsUsed, 1), l = "", u = 0; u < c.length; u++) l += String.fromCharCode(c[u]);
				var d = a();
				o({
					data: l,
					addLength1: !0,
					objectId: d
				}), i("endobj");
				var f = a();
				o({
					data: r(n.metadata.toUnicode),
					addLength1: !0,
					objectId: f
				}), i("endobj");
				var p = a();
				i("<<"), i("/Type /FontDescriptor"), i("/FontName /" + Tb(n.fontName)), i("/FontFile2 " + d + " 0 R"), i("/FontBBox " + e.API.PDFObject.convert(n.metadata.bbox)), i("/Flags " + n.metadata.flags), i("/StemV " + n.metadata.stemV), i("/ItalicAngle " + n.metadata.italicAngle), i("/Ascent " + n.metadata.ascender), i("/Descent " + n.metadata.decender), i("/CapHeight " + n.metadata.capHeight), i(">>"), i("endobj");
				var m = a();
				i("<<"), i("/Type /Font"), i("/BaseFont /" + Tb(n.fontName)), i("/FontDescriptor " + p + " 0 R"), i("/W " + e.API.PDFObject.convert(s)), i("/CIDToGIDMap /Identity"), i("/DW 1000"), i("/Subtype /CIDFontType2"), i("/CIDSystemInfo"), i("<<"), i("/Supplement 0"), i("/Registry (Adobe)"), i("/Ordering (" + n.encoding + ")"), i(">>"), i(">>"), i("endobj"), n.objectNumber = a(), i("<<"), i("/Type /Font"), i("/Subtype /Type0"), i("/ToUnicode " + f + " 0 R"), i("/BaseFont /" + Tb(n.fontName)), i("/Encoding /" + n.encoding), i("/DescendantFonts [" + m + " 0 R]"), i(">>"), i("endobj"), n.isAlreadyPutted = !0;
			}
		})(t);
	}]), t.events.push(["putFont", function(t) {
		(function(t) {
			var n = t.font, i = t.out, a = t.newObject, o = t.putStream;
			if (n.metadata instanceof e.API.TTFFont && n.encoding === "WinAnsiEncoding") {
				for (var s = n.metadata.rawData, c = "", l = 0; l < s.length; l++) c += String.fromCharCode(s[l]);
				var u = a();
				o({
					data: c,
					addLength1: !0,
					objectId: u
				}), i("endobj");
				var d = a();
				o({
					data: r(n.metadata.toUnicode),
					addLength1: !0,
					objectId: d
				}), i("endobj");
				var f = a();
				i("<<"), i("/Descent " + n.metadata.decender), i("/CapHeight " + n.metadata.capHeight), i("/StemV " + n.metadata.stemV), i("/Type /FontDescriptor"), i("/FontFile2 " + u + " 0 R"), i("/Flags 96"), i("/FontBBox " + e.API.PDFObject.convert(n.metadata.bbox)), i("/FontName /" + Tb(n.fontName)), i("/ItalicAngle " + n.metadata.italicAngle), i("/Ascent " + n.metadata.ascender), i(">>"), i("endobj"), n.objectNumber = a();
				for (var p = 0; p < n.metadata.hmtx.widths.length; p++) n.metadata.hmtx.widths[p] = parseInt(n.metadata.hmtx.widths[p] * (1e3 / n.metadata.head.unitsPerEm));
				i("<</Subtype/TrueType/Type/Font/ToUnicode " + d + " 0 R/BaseFont/" + Tb(n.fontName) + "/FontDescriptor " + f + " 0 R/Encoding/" + n.encoding + " /FirstChar 29 /LastChar 255 /Widths " + e.API.PDFObject.convert(n.metadata.hmtx.widths) + ">>"), i("endobj"), n.isAlreadyPutted = !0;
			}
		})(t);
	}]);
	var i = function(e) {
		var t, r = e.text || "", i = e.x, a = e.y, o = e.options || {}, s = e.mutex || {}, c = s.pdfEscape, l = s.activeFontKey, u = s.fonts, d = l, f = "", p = 0, m = "", h = u[d].encoding;
		if (u[d].encoding !== "Identity-H") return {
			text: r,
			x: i,
			y: a,
			options: o,
			mutex: s
		};
		for (m = r, d = l, Array.isArray(r) && (m = r[0]), p = 0; p < m.length; p += 1) u[d].metadata.hasOwnProperty("cmap") && (t = u[d].metadata.cmap.unicode.codeMap[m[p].charCodeAt(0)]), t || m[p].charCodeAt(0) < 256 && u[d].metadata.hasOwnProperty("Unicode") ? f += m[p] : f += "";
		var g = "";
		return parseInt(d.slice(1)) < 14 || h === "WinAnsiEncoding" ? g = c(f, d).split("").map(function(e) {
			return e.charCodeAt(0).toString(16);
		}).join("") : h === "Identity-H" && (g = n(f, u[d])), s.isHex = !0, {
			text: g,
			x: i,
			y: a,
			options: o,
			mutex: s
		};
	};
	t.events.push(["postProcessText", function(e) {
		var t = e.text || "", n = [], r = {
			text: t,
			x: e.x,
			y: e.y,
			options: e.options,
			mutex: e.mutex
		};
		if (Array.isArray(t)) {
			var a = 0;
			for (a = 0; a < t.length; a += 1) Array.isArray(t[a]) && t[a].length === 3 ? n.push([
				i(Object.assign({}, r, { text: t[a][0] })).text,
				t[a][1],
				t[a][2]
			]) : n.push(i(Object.assign({}, r, { text: t[a] })).text);
			e.text = n;
		} else e.text = i(Object.assign({}, r, { text: t })).text;
	}]);
}(jb), function(e) {
	var t = function() {
		return this.internal.vFS === void 0 && (this.internal.vFS = {}), !0;
	};
	e.existsFileInVFS = function(e) {
		return t.call(this), this.internal.vFS[e] !== void 0;
	}, e.addFileToVFS = function(e, n) {
		return t.call(this), this.internal.vFS[e] = n, this;
	}, e.getFileFromVFS = function(e) {
		return t.call(this), this.internal.vFS[e] === void 0 ? null : this.internal.vFS[e];
	};
}(jb.API), function(e) {
	e.__bidiEngine__ = e.prototype.__bidiEngine__ = function(e) {
		var n, r, i, a, o, s, c, l = t, u = [
			[
				0,
				3,
				0,
				1,
				0,
				0,
				0
			],
			[
				0,
				3,
				0,
				1,
				2,
				2,
				0
			],
			[
				0,
				3,
				0,
				17,
				2,
				0,
				1
			],
			[
				0,
				3,
				5,
				5,
				4,
				1,
				0
			],
			[
				0,
				3,
				21,
				21,
				4,
				0,
				1
			],
			[
				0,
				3,
				5,
				5,
				4,
				2,
				0
			]
		], d = [
			[
				2,
				0,
				1,
				1,
				0,
				1,
				0
			],
			[
				2,
				0,
				1,
				1,
				0,
				2,
				0
			],
			[
				2,
				0,
				2,
				1,
				3,
				2,
				0
			],
			[
				2,
				0,
				2,
				33,
				3,
				1,
				1
			]
		], f = {
			L: 0,
			R: 1,
			EN: 2,
			AN: 3,
			N: 4,
			B: 5,
			S: 6
		}, p = {
			0: 0,
			5: 1,
			6: 2,
			7: 3,
			32: 4,
			251: 5,
			254: 6,
			255: 7
		}, m = /* @__PURE__ */ "(.).(.<.>.<.[.].[.{.}.{.«.».«.‹.›.‹.⁅.⁆.⁅.⁽.⁾.⁽.₍.₎.₍.≤.≥.≤.〈.〉.〈.﹙.﹚.﹙.﹛.﹜.﹛.﹝.﹞.﹝.﹤.﹥.﹤".split("."), h = /* @__PURE__ */ new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/), g = !1, _ = 0;
		this.__bidiEngine__ = {};
		var v = function(e) {
			var t = e.charCodeAt(), n = t >> 8, r = p[n];
			return r === void 0 ? n === 252 || n === 253 ? "AL" : h.test(n) ? "L" : n === 8 ? "R" : "N" : l[256 * r + (255 & t)];
		}, y = function(e) {
			for (var t, n = 0; n < e.length; n++) {
				if ((t = v(e.charAt(n))) === "L") return !1;
				if (t === "R") return !0;
			}
			return !1;
		}, b = function(e, t, o, s) {
			var c, l, u, d, f = t[s];
			switch (f) {
				case "L":
				case "R":
				case "LRE":
				case "RLE":
				case "LRO":
				case "RLO":
				case "PDF":
					g = !1;
					break;
				case "N":
				case "AN": break;
				case "EN":
					g && (f = "AN");
					break;
				case "AL":
					g = !0, f = "R";
					break;
				case "WS":
				case "BN":
					f = "N";
					break;
				case "CS":
					s < 1 || s + 1 >= t.length || (c = o[s - 1]) !== "EN" && c !== "AN" || (l = t[s + 1]) !== "EN" && l !== "AN" ? f = "N" : g && (l = "AN"), f = l === c ? l : "N";
					break;
				case "ES":
					f = (c = s > 0 ? o[s - 1] : "B") === "EN" && s + 1 < t.length && t[s + 1] === "EN" ? "EN" : "N";
					break;
				case "ET":
					if (s > 0 && o[s - 1] === "EN") {
						f = "EN";
						break;
					}
					if (g) {
						f = "N";
						break;
					}
					for (u = s + 1, d = t.length; u < d && t[u] === "ET";) u++;
					f = u < d && t[u] === "EN" ? "EN" : "N";
					break;
				case "NSM":
					if (i && !a) {
						for (d = t.length, u = s + 1; u < d && t[u] === "NSM";) u++;
						if (u < d) {
							var p = e[s], m = p >= 1425 && p <= 2303 || p === 64286;
							if (c = t[u], m && (c === "R" || c === "AL")) {
								f = "R";
								break;
							}
						}
					}
					f = s < 1 || (c = t[s - 1]) === "B" ? "N" : o[s - 1];
					break;
				case "B":
					g = !1, n = !0, f = _;
					break;
				case "S": r = !0, f = "N";
			}
			return f;
		}, x = function(e, t, n) {
			var r = e.split("");
			return n && S(r, n, { hiLevel: _ }), r.reverse(), t && t.reverse(), r.join("");
		}, S = function(e, t, i) {
			var a, o, s, c, l, p = -1, m = e.length, h = 0, y = [], x = _ ? d : u, S = [];
			for (g = !1, n = !1, r = !1, o = 0; o < m; o++) S[o] = v(e[o]);
			for (s = 0; s < m; s++) {
				if (l = h, y[s] = b(e, S, y, s), a = 240 & (h = x[l][f[y[s]]]), h &= 15, t[s] = c = x[h][5], a > 0) if (a === 16) {
					for (o = p; o < s; o++) t[o] = 1;
					p = -1;
				} else p = -1;
				if (x[h][6]) p === -1 && (p = s);
				else if (p > -1) {
					for (o = p; o < s; o++) t[o] = c;
					p = -1;
				}
				S[s] === "B" && (t[s] = 0), i.hiLevel |= c;
			}
			r && function(e, t, n) {
				for (var r = 0; r < n; r++) if (e[r] === "S") {
					t[r] = _;
					for (var i = r - 1; i >= 0 && e[i] === "WS"; i--) t[i] = _;
				}
			}(S, t, m);
		}, C = function(e, t, r, i, a) {
			if (!(a.hiLevel < e)) {
				if (e === 1 && _ === 1 && !n) return t.reverse(), void (r && r.reverse());
				for (var o, s, c, l, u = t.length, d = 0; d < u;) {
					if (i[d] >= e) {
						for (c = d + 1; c < u && i[c] >= e;) c++;
						for (l = d, s = c - 1; l < s; l++, s--) o = t[l], t[l] = t[s], t[s] = o, r && (o = r[l], r[l] = r[s], r[s] = o);
						d = c;
					}
					d++;
				}
			}
		}, w = function(e, t, n) {
			var r = e.split(""), i = { hiLevel: _ };
			return n ||= [], S(r, n, i), function(e, t, n) {
				if (n.hiLevel !== 0 && c) for (var r, i = 0; i < e.length; i++) t[i] === 1 && (r = m.indexOf(e[i])) >= 0 && (e[i] = m[r + 1]);
			}(r, n, i), C(2, r, t, n, i), C(1, r, t, n, i), r.join("");
		};
		return this.__bidiEngine__.doBidiReorder = function(e, t, n) {
			if (function(e, t) {
				if (t) for (var n = 0; n < e.length; n++) t[n] = n;
				a === void 0 && (a = y(e)), s === void 0 && (s = y(e));
			}(e, t), i || !o || s) if (i && o && a ^ s) _ = +!!a, e = x(e, t, n);
			else if (!i && o && s) _ = +!!a, e = w(e, t, n), e = x(e, t);
			else if (!i || a || o || s) {
				if (i && !o && a ^ s) e = x(e, t), a ? (_ = 0, e = w(e, t, n)) : (_ = 1, e = w(e, t, n), e = x(e, t));
				else if (i && a && !o && s) _ = 1, e = w(e, t, n), e = x(e, t);
				else if (!i && !o && a ^ s) {
					var r = c;
					a ? (_ = 1, e = w(e, t, n), _ = 0, c = !1, e = w(e, t, n), c = r) : (_ = 0, e = w(e, t, n), e = x(e, t), _ = 1, c = !1, e = w(e, t, n), c = r, e = x(e, t));
				}
			} else _ = 0, e = w(e, t, n);
			else _ = +!!a, e = w(e, t, n);
			return e;
		}, this.__bidiEngine__.setOptions = function(e) {
			e && (i = e.isInputVisual, o = e.isOutputVisual, a = e.isInputRtl, s = e.isOutputRtl, c = e.isSymmetricSwapping);
		}, this.__bidiEngine__.setOptions(e), this.__bidiEngine__;
	};
	var t = /* @__PURE__ */ "BN.BN.BN.BN.BN.BN.BN.BN.BN.S.B.S.WS.B.BN.BN.BN.BN.BN.BN.BN.BN.BN.BN.BN.BN.BN.BN.B.B.B.S.WS.N.N.ET.ET.ET.N.N.N.N.N.ES.CS.ES.CS.CS.EN.EN.EN.EN.EN.EN.EN.EN.EN.EN.CS.N.N.N.N.N.N.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.N.N.N.N.N.N.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.N.N.N.N.BN.BN.BN.BN.BN.BN.B.BN.BN.BN.BN.BN.BN.BN.BN.BN.BN.BN.BN.BN.BN.BN.BN.BN.BN.BN.BN.BN.BN.BN.BN.BN.BN.CS.N.ET.ET.ET.ET.N.N.N.N.L.N.N.BN.N.N.ET.ET.EN.EN.N.L.N.N.N.EN.L.N.N.N.N.N.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.N.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.N.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.N.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.N.N.L.L.L.L.L.L.L.N.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.N.L.N.N.N.N.N.ET.N.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.R.NSM.R.NSM.NSM.R.NSM.NSM.R.NSM.N.N.N.N.N.N.N.N.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.N.N.N.N.N.R.R.R.R.R.N.N.N.N.N.N.N.N.N.N.N.AN.AN.AN.AN.AN.AN.N.N.AL.ET.ET.AL.CS.AL.N.N.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.AL.AL.N.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.AN.AN.AN.AN.AN.AN.AN.AN.AN.AN.ET.AN.AN.AL.AL.AL.NSM.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.NSM.NSM.NSM.NSM.NSM.NSM.NSM.AN.N.NSM.NSM.NSM.NSM.NSM.NSM.AL.AL.NSM.NSM.N.NSM.NSM.NSM.NSM.AL.AL.EN.EN.EN.EN.EN.EN.EN.EN.EN.EN.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.N.AL.AL.NSM.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.N.N.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.AL.N.N.N.N.N.N.N.N.N.N.N.N.N.N.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.R.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.R.R.N.N.N.N.R.N.N.N.N.N.WS.WS.WS.WS.WS.WS.WS.WS.WS.WS.WS.BN.BN.BN.L.R.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.WS.B.LRE.RLE.PDF.LRO.RLO.CS.ET.ET.ET.ET.ET.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.CS.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.WS.BN.BN.BN.BN.BN.N.LRI.RLI.FSI.PDI.BN.BN.BN.BN.BN.BN.EN.L.N.N.EN.EN.EN.EN.EN.EN.ES.ES.N.N.N.L.EN.EN.EN.EN.EN.EN.EN.EN.EN.EN.ES.ES.N.N.N.N.L.L.L.L.L.L.L.L.L.L.L.L.L.N.N.N.ET.ET.ET.ET.ET.ET.ET.ET.ET.ET.ET.ET.ET.ET.ET.ET.ET.ET.ET.ET.ET.ET.ET.ET.ET.ET.ET.ET.ET.ET.ET.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.L.L.L.L.L.L.L.N.N.N.N.N.N.N.N.N.N.N.N.L.L.L.L.L.N.N.N.N.N.R.NSM.R.R.R.R.R.R.R.R.R.R.ES.R.R.R.R.R.R.R.R.R.R.R.R.R.N.R.R.R.R.R.N.R.N.R.R.N.R.R.N.R.R.R.R.R.R.R.R.R.R.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.NSM.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.CS.N.CS.N.N.CS.N.N.N.N.N.N.N.N.N.ET.N.N.ES.ES.N.N.N.N.N.ET.ET.N.N.N.N.N.AL.AL.AL.AL.AL.N.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.AL.N.N.BN.N.N.N.ET.ET.ET.N.N.N.N.N.ES.CS.ES.CS.CS.EN.EN.EN.EN.EN.EN.EN.EN.EN.EN.CS.N.N.N.N.N.N.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.N.N.N.N.N.N.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.N.N.N.N.N.N.N.N.N.N.N.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.L.N.N.N.L.L.L.L.L.L.N.N.L.L.L.L.L.L.N.N.L.L.L.L.L.L.N.N.L.L.L.N.N.N.ET.ET.N.N.N.ET.ET.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N.N".split("."), n = new e.__bidiEngine__({ isInputVisual: !0 });
	e.API.events.push(["postProcessText", function(e) {
		var t = e.text;
		e.x, e.y;
		var r = e.options || {};
		e.mutex, r.lang;
		var i = [];
		if (r.isInputVisual = typeof r.isInputVisual != "boolean" || r.isInputVisual, n.setOptions(r), Object.prototype.toString.call(t) === "[object Array]") {
			var a = 0;
			for (i = [], a = 0; a < t.length; a += 1) Object.prototype.toString.call(t[a]) === "[object Array]" ? i.push([
				n.doBidiReorder(t[a][0]),
				t[a][1],
				t[a][2]
			]) : i.push([n.doBidiReorder(t[a])]);
			e.text = i;
		} else e.text = n.doBidiReorder(t);
		n.setOptions({ isInputVisual: !0 });
	}]);
}(jb), jb.API.TTFFont = function() {
	function e(e) {
		var t;
		if (this.rawData = e, t = this.contents = new iS(e), this.contents.pos = 4, t.readString(4) === "ttcf") throw Error("TTCF not supported.");
		t.pos = 0, this.parse(), this.subset = new CS(this), this.registerTTF();
	}
	return e.open = function(t) {
		return new e(t);
	}, e.prototype.parse = function() {
		return this.directory = new aS(this.contents), this.head = new cS(this), this.name = new hS(this), this.cmap = new uS(this), this.toUnicode = {}, this.hhea = new dS(this), this.maxp = new gS(this), this.hmtx = new _S(this), this.post = new pS(this), this.os2 = new fS(this), this.loca = new SS(this), this.glyf = new yS(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [
			this.head.xMin,
			this.head.yMin,
			this.head.xMax,
			this.head.yMax
		];
	}, e.prototype.registerTTF = function() {
		var e, t, n, r, i;
		if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = function() {
			var t, n, r, i;
			for (i = [], t = 0, n = (r = this.bbox).length; t < n; t++) e = r[t], i.push(Math.round(e * this.scaleFactor));
			return i;
		}.call(this), this.stemV = 0, this.post.exists ? (n = 255 & (r = this.post.italic_angle), 32768 & (t = r >> 16) && (t = -(1 + (65535 ^ t))), this.italicAngle = +(t + "." + n)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = (i = this.familyClass) === 1 || i === 2 || i === 3 || i === 4 || i === 5 || i === 7, this.isScript = this.familyClass === 10, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), this.italicAngle !== 0 && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw Error("No unicode cmap for font");
	}, e.prototype.characterToGlyph = function(e) {
		return this.cmap.unicode?.codeMap[e] || 0;
	}, e.prototype.widthOfGlyph = function(e) {
		var t;
		return t = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(e).advance * t;
	}, e.prototype.widthOfString = function(e, t, n) {
		var r, i, a, o;
		for (a = 0, i = 0, o = (e = "" + e).length; 0 <= o ? i < o : i > o; i = 0 <= o ? ++i : --i) r = e.charCodeAt(i), a += this.widthOfGlyph(this.characterToGlyph(r)) + 1e3 / t * n || 0;
		return t / 1e3 * a;
	}, e.prototype.lineHeight = function(e, t) {
		var n;
		return t ??= !1, n = t ? this.lineGap : 0, (this.ascender + n - this.decender) / 1e3 * e;
	}, e;
}();
var rS, iS = function() {
	function e(e) {
		this.data = e ?? [], this.pos = 0, this.length = this.data.length;
	}
	return e.prototype.readByte = function() {
		return this.data[this.pos++];
	}, e.prototype.writeByte = function(e) {
		return this.data[this.pos++] = e;
	}, e.prototype.readUInt32 = function() {
		return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
	}, e.prototype.writeUInt32 = function(e) {
		return this.writeByte(e >>> 24 & 255), this.writeByte(e >> 16 & 255), this.writeByte(e >> 8 & 255), this.writeByte(255 & e);
	}, e.prototype.readInt32 = function() {
		var e;
		return (e = this.readUInt32()) >= 2147483648 ? e - 4294967296 : e;
	}, e.prototype.writeInt32 = function(e) {
		return e < 0 && (e += 4294967296), this.writeUInt32(e);
	}, e.prototype.readUInt16 = function() {
		return this.readByte() << 8 | this.readByte();
	}, e.prototype.writeUInt16 = function(e) {
		return this.writeByte(e >> 8 & 255), this.writeByte(255 & e);
	}, e.prototype.readInt16 = function() {
		var e;
		return (e = this.readUInt16()) >= 32768 ? e - 65536 : e;
	}, e.prototype.writeInt16 = function(e) {
		return e < 0 && (e += 65536), this.writeUInt16(e);
	}, e.prototype.readString = function(e) {
		var t, n;
		for (n = [], t = 0; 0 <= e ? t < e : t > e; t = 0 <= e ? ++t : --t) n[t] = String.fromCharCode(this.readByte());
		return n.join("");
	}, e.prototype.writeString = function(e) {
		var t, n, r;
		for (r = [], t = 0, n = e.length; 0 <= n ? t < n : t > n; t = 0 <= n ? ++t : --t) r.push(this.writeByte(e.charCodeAt(t)));
		return r;
	}, e.prototype.readShort = function() {
		return this.readInt16();
	}, e.prototype.writeShort = function(e) {
		return this.writeInt16(e);
	}, e.prototype.readLongLong = function() {
		var e, t, n, r, i, a, o, s;
		return e = this.readByte(), t = this.readByte(), n = this.readByte(), r = this.readByte(), i = this.readByte(), a = this.readByte(), o = this.readByte(), s = this.readByte(), 128 & e ? -1 * (72057594037927940 * (255 ^ e) + 281474976710656 * (255 ^ t) + 1099511627776 * (255 ^ n) + 4294967296 * (255 ^ r) + 16777216 * (255 ^ i) + 65536 * (255 ^ a) + 256 * (255 ^ o) + (255 ^ s) + 1) : 72057594037927940 * e + 281474976710656 * t + 1099511627776 * n + 4294967296 * r + 16777216 * i + 65536 * a + 256 * o + s;
	}, e.prototype.writeLongLong = function(e) {
		var t, n;
		return t = Math.floor(e / 4294967296), n = 4294967295 & e, this.writeByte(t >> 24 & 255), this.writeByte(t >> 16 & 255), this.writeByte(t >> 8 & 255), this.writeByte(255 & t), this.writeByte(n >> 24 & 255), this.writeByte(n >> 16 & 255), this.writeByte(n >> 8 & 255), this.writeByte(255 & n);
	}, e.prototype.readInt = function() {
		return this.readInt32();
	}, e.prototype.writeInt = function(e) {
		return this.writeInt32(e);
	}, e.prototype.read = function(e) {
		var t, n;
		for (t = [], n = 0; 0 <= e ? n < e : n > e; n = 0 <= e ? ++n : --n) t.push(this.readByte());
		return t;
	}, e.prototype.write = function(e) {
		var t, n, r, i;
		for (i = [], n = 0, r = e.length; n < r; n++) t = e[n], i.push(this.writeByte(t));
		return i;
	}, e;
}(), aS = function() {
	var e;
	function t(e) {
		var t, n, r;
		for (this.scalarType = e.readInt(), this.tableCount = e.readShort(), this.searchRange = e.readShort(), this.entrySelector = e.readShort(), this.rangeShift = e.readShort(), this.tables = {}, n = 0, r = this.tableCount; 0 <= r ? n < r : n > r; n = 0 <= r ? ++n : --n) t = {
			tag: e.readString(4),
			checksum: e.readInt(),
			offset: e.readInt(),
			length: e.readInt()
		}, this.tables[t.tag] = t;
	}
	return t.prototype.encode = function(t) {
		var n, r, i, a, o, s, c, l, u, d, f, p, m;
		for (m in f = Object.keys(t).length, s = Math.log(2), u = 16 * Math.floor(Math.log(f) / s), a = Math.floor(u / s), l = 16 * f - u, (r = new iS()).writeInt(this.scalarType), r.writeShort(f), r.writeShort(u), r.writeShort(a), r.writeShort(l), i = 16 * f, c = r.pos + i, o = null, p = [], t) for (d = t[m], r.writeString(m), r.writeInt(e(d)), r.writeInt(c), r.writeInt(d.length), p = p.concat(d), m === "head" && (o = c), c += d.length; c % 4;) p.push(0), c++;
		return r.write(p), n = 2981146554 - e(r.data), r.pos = o + 8, r.writeUInt32(n), r.data;
	}, e = function(e) {
		var t, n, r, i;
		for (e = vS.call(e); e.length % 4;) e.push(0);
		for (r = new iS(e), n = 0, t = 0, i = e.length; t < i; t = t += 4) n += r.readUInt32();
		return 4294967295 & n;
	}, t;
}(), oS = {}.hasOwnProperty, sS = function(e, t) {
	for (var n in t) oS.call(t, n) && (e[n] = t[n]);
	function r() {
		this.constructor = e;
	}
	return r.prototype = t.prototype, e.prototype = new r(), e.__super__ = t.prototype, e;
};
rS = function() {
	function e(e) {
		var t;
		this.file = e, t = this.file.directory.tables[this.tag], this.exists = !!t, t && (this.offset = t.offset, this.length = t.length, this.parse(this.file.contents));
	}
	return e.prototype.parse = function() {}, e.prototype.encode = function() {}, e.prototype.raw = function() {
		return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
	}, e;
}();
var cS = function() {
	function e() {
		return e.__super__.constructor.apply(this, arguments);
	}
	return sS(e, rS), e.prototype.tag = "head", e.prototype.parse = function(e) {
		return e.pos = this.offset, this.version = e.readInt(), this.revision = e.readInt(), this.checkSumAdjustment = e.readInt(), this.magicNumber = e.readInt(), this.flags = e.readShort(), this.unitsPerEm = e.readShort(), this.created = e.readLongLong(), this.modified = e.readLongLong(), this.xMin = e.readShort(), this.yMin = e.readShort(), this.xMax = e.readShort(), this.yMax = e.readShort(), this.macStyle = e.readShort(), this.lowestRecPPEM = e.readShort(), this.fontDirectionHint = e.readShort(), this.indexToLocFormat = e.readShort(), this.glyphDataFormat = e.readShort();
	}, e.prototype.encode = function(e) {
		var t;
		return (t = new iS()).writeInt(this.version), t.writeInt(this.revision), t.writeInt(this.checkSumAdjustment), t.writeInt(this.magicNumber), t.writeShort(this.flags), t.writeShort(this.unitsPerEm), t.writeLongLong(this.created), t.writeLongLong(this.modified), t.writeShort(this.xMin), t.writeShort(this.yMin), t.writeShort(this.xMax), t.writeShort(this.yMax), t.writeShort(this.macStyle), t.writeShort(this.lowestRecPPEM), t.writeShort(this.fontDirectionHint), t.writeShort(e), t.writeShort(this.glyphDataFormat), t.data;
	}, e;
}(), lS = function() {
	function e(e, t) {
		var n, r, i, a, o, s, c, l, u, d, f, p, m, h, g, _, v;
		switch (this.platformID = e.readUInt16(), this.encodingID = e.readShort(), this.offset = t + e.readInt(), u = e.pos, e.pos = this.offset, this.format = e.readUInt16(), this.length = e.readUInt16(), this.language = e.readUInt16(), this.isUnicode = this.platformID === 3 && this.encodingID === 1 && this.format === 4 || this.platformID === 0 && this.format === 4, this.codeMap = {}, this.format) {
			case 0:
				for (s = 0; s < 256; ++s) this.codeMap[s] = e.readByte();
				break;
			case 4: for (f = e.readUInt16(), d = f / 2, e.pos += 6, i = function() {
				var t, n;
				for (n = [], s = t = 0; 0 <= d ? t < d : t > d; s = 0 <= d ? ++t : --t) n.push(e.readUInt16());
				return n;
			}(), e.pos += 2, m = function() {
				var t, n;
				for (n = [], s = t = 0; 0 <= d ? t < d : t > d; s = 0 <= d ? ++t : --t) n.push(e.readUInt16());
				return n;
			}(), c = function() {
				var t, n;
				for (n = [], s = t = 0; 0 <= d ? t < d : t > d; s = 0 <= d ? ++t : --t) n.push(e.readUInt16());
				return n;
			}(), l = function() {
				var t, n;
				for (n = [], s = t = 0; 0 <= d ? t < d : t > d; s = 0 <= d ? ++t : --t) n.push(e.readUInt16());
				return n;
			}(), r = (this.length - e.pos + this.offset) / 2, o = function() {
				var t, n;
				for (n = [], s = t = 0; 0 <= r ? t < r : t > r; s = 0 <= r ? ++t : --t) n.push(e.readUInt16());
				return n;
			}(), s = g = 0, v = i.length; g < v; s = ++g) for (h = i[s], n = _ = p = m[s]; p <= h ? _ <= h : _ >= h; n = p <= h ? ++_ : --_) l[s] === 0 ? a = n + c[s] : (a = o[l[s] / 2 + (n - p) - (d - s)] || 0) !== 0 && (a += c[s]), this.codeMap[n] = 65535 & a;
		}
		e.pos = u;
	}
	return e.encode = function(e, t) {
		var n, r, i, a, o, s, c, l, u, d, f, p, m, h, g, _, v, y, b, x, S, C, w, T, E, D, O, k, A, j, M, N, P, F, I, ee, L, R, te, z, ne, re, ie, ae, B, oe;
		switch (k = new iS(), a = Object.keys(e).sort(function(e, t) {
			return e - t;
		}), t) {
			case "macroman":
				for (m = 0, h = function() {
					var e = [];
					for (p = 0; p < 256; ++p) e.push(0);
					return e;
				}(), _ = { 0: 0 }, i = {}, A = 0, P = a.length; A < P; A++) _[ie = e[r = a[A]]] ?? (_[ie] = ++m), i[r] = {
					old: e[r],
					new: _[e[r]]
				}, h[r] = _[e[r]];
				return k.writeUInt16(1), k.writeUInt16(0), k.writeUInt32(12), k.writeUInt16(0), k.writeUInt16(262), k.writeUInt16(0), k.write(h), {
					charMap: i,
					subtable: k.data,
					maxGlyphID: m + 1
				};
			case "unicode":
				for (D = [], u = [], v = 0, _ = {}, n = {}, g = c = null, j = 0, F = a.length; j < F; j++) _[b = e[r = a[j]]] ?? (_[b] = ++v), n[r] = {
					old: b,
					new: _[b]
				}, o = _[b] - r, g != null && o === c || (g && u.push(g), D.push(r), c = o), g = r;
				for (g && u.push(g), u.push(65535), D.push(65535), T = 2 * (w = D.length), C = 2 * (Math.log(w) / Math.LN2) ** 2, d = Math.log(C / 2) / Math.LN2, S = 2 * w - C, s = [], x = [], f = [], p = M = 0, I = D.length; M < I; p = ++M) {
					if (E = D[p], l = u[p], E === 65535) {
						s.push(0), x.push(0);
						break;
					}
					if (E - (O = n[E].new) >= 32768) for (s.push(0), x.push(2 * (f.length + w - p)), r = N = E; E <= l ? N <= l : N >= l; r = E <= l ? ++N : --N) f.push(n[r].new);
					else s.push(O - E), x.push(0);
				}
				for (k.writeUInt16(3), k.writeUInt16(1), k.writeUInt32(12), k.writeUInt16(4), k.writeUInt16(16 + 8 * w + 2 * f.length), k.writeUInt16(0), k.writeUInt16(T), k.writeUInt16(C), k.writeUInt16(d), k.writeUInt16(S), ne = 0, ee = u.length; ne < ee; ne++) r = u[ne], k.writeUInt16(r);
				for (k.writeUInt16(0), re = 0, L = D.length; re < L; re++) r = D[re], k.writeUInt16(r);
				for (ae = 0, R = s.length; ae < R; ae++) o = s[ae], k.writeUInt16(o);
				for (B = 0, te = x.length; B < te; B++) y = x[B], k.writeUInt16(y);
				for (oe = 0, z = f.length; oe < z; oe++) m = f[oe], k.writeUInt16(m);
				return {
					charMap: n,
					subtable: k.data,
					maxGlyphID: v + 1
				};
		}
	}, e;
}(), uS = function() {
	function e() {
		return e.__super__.constructor.apply(this, arguments);
	}
	return sS(e, rS), e.prototype.tag = "cmap", e.prototype.parse = function(e) {
		var t, n, r;
		for (e.pos = this.offset, this.version = e.readUInt16(), r = e.readUInt16(), this.tables = [], this.unicode = null, n = 0; 0 <= r ? n < r : n > r; n = 0 <= r ? ++n : --n) t = new lS(e, this.offset), this.tables.push(t), t.isUnicode && this.unicode == null && (this.unicode = t);
		return !0;
	}, e.encode = function(e, t) {
		var n, r;
		return t ??= "macroman", n = lS.encode(e, t), (r = new iS()).writeUInt16(0), r.writeUInt16(1), n.table = r.data.concat(n.subtable), n;
	}, e;
}(), dS = function() {
	function e() {
		return e.__super__.constructor.apply(this, arguments);
	}
	return sS(e, rS), e.prototype.tag = "hhea", e.prototype.parse = function(e) {
		return e.pos = this.offset, this.version = e.readInt(), this.ascender = e.readShort(), this.decender = e.readShort(), this.lineGap = e.readShort(), this.advanceWidthMax = e.readShort(), this.minLeftSideBearing = e.readShort(), this.minRightSideBearing = e.readShort(), this.xMaxExtent = e.readShort(), this.caretSlopeRise = e.readShort(), this.caretSlopeRun = e.readShort(), this.caretOffset = e.readShort(), e.pos += 8, this.metricDataFormat = e.readShort(), this.numberOfMetrics = e.readUInt16();
	}, e;
}(), fS = function() {
	function e() {
		return e.__super__.constructor.apply(this, arguments);
	}
	return sS(e, rS), e.prototype.tag = "OS/2", e.prototype.parse = function(e) {
		if (e.pos = this.offset, this.version = e.readUInt16(), this.averageCharWidth = e.readShort(), this.weightClass = e.readUInt16(), this.widthClass = e.readUInt16(), this.type = e.readShort(), this.ySubscriptXSize = e.readShort(), this.ySubscriptYSize = e.readShort(), this.ySubscriptXOffset = e.readShort(), this.ySubscriptYOffset = e.readShort(), this.ySuperscriptXSize = e.readShort(), this.ySuperscriptYSize = e.readShort(), this.ySuperscriptXOffset = e.readShort(), this.ySuperscriptYOffset = e.readShort(), this.yStrikeoutSize = e.readShort(), this.yStrikeoutPosition = e.readShort(), this.familyClass = e.readShort(), this.panose = function() {
			var t, n;
			for (n = [], t = 0; t < 10; ++t) n.push(e.readByte());
			return n;
		}(), this.charRange = function() {
			var t, n;
			for (n = [], t = 0; t < 4; ++t) n.push(e.readInt());
			return n;
		}(), this.vendorID = e.readString(4), this.selection = e.readShort(), this.firstCharIndex = e.readShort(), this.lastCharIndex = e.readShort(), this.version > 0 && (this.ascent = e.readShort(), this.descent = e.readShort(), this.lineGap = e.readShort(), this.winAscent = e.readShort(), this.winDescent = e.readShort(), this.codePageRange = function() {
			var t, n;
			for (n = [], t = 0; t < 2; t = ++t) n.push(e.readInt());
			return n;
		}(), this.version > 1)) return this.xHeight = e.readShort(), this.capHeight = e.readShort(), this.defaultChar = e.readShort(), this.breakChar = e.readShort(), this.maxContext = e.readShort();
	}, e;
}(), pS = function() {
	function e() {
		return e.__super__.constructor.apply(this, arguments);
	}
	return sS(e, rS), e.prototype.tag = "post", e.prototype.parse = function(e) {
		var t, n, r;
		switch (e.pos = this.offset, this.format = e.readInt(), this.italicAngle = e.readInt(), this.underlinePosition = e.readShort(), this.underlineThickness = e.readShort(), this.isFixedPitch = e.readInt(), this.minMemType42 = e.readInt(), this.maxMemType42 = e.readInt(), this.minMemType1 = e.readInt(), this.maxMemType1 = e.readInt(), this.format) {
			case 65536:
			case 196608: break;
			case 131072:
				var i;
				for (n = e.readUInt16(), this.glyphNameIndex = [], i = 0; 0 <= n ? i < n : i > n; i = 0 <= n ? ++i : --i) this.glyphNameIndex.push(e.readUInt16());
				for (this.names = [], r = []; e.pos < this.offset + this.length;) t = e.readByte(), r.push(this.names.push(e.readString(t)));
				return r;
			case 151552: return n = e.readUInt16(), this.offsets = e.read(n);
			case 262144: return this.map = function() {
				var t, n, r;
				for (r = [], i = t = 0, n = this.file.maxp.numGlyphs; 0 <= n ? t < n : t > n; i = 0 <= n ? ++t : --t) r.push(e.readUInt32());
				return r;
			}.call(this);
		}
	}, e;
}(), mS = function(e, t) {
	this.raw = e, this.length = e.length, this.platformID = t.platformID, this.encodingID = t.encodingID, this.languageID = t.languageID;
}, hS = function() {
	function e() {
		return e.__super__.constructor.apply(this, arguments);
	}
	return sS(e, rS), e.prototype.tag = "name", e.prototype.parse = function(e) {
		var t, n, r, i, a, o, s, c, l, u, d;
		for (e.pos = this.offset, e.readShort(), t = e.readShort(), o = e.readShort(), n = [], i = 0; 0 <= t ? i < t : i > t; i = 0 <= t ? ++i : --i) n.push({
			platformID: e.readShort(),
			encodingID: e.readShort(),
			languageID: e.readShort(),
			nameID: e.readShort(),
			length: e.readShort(),
			offset: this.offset + o + e.readShort()
		});
		for (s = {}, i = l = 0, u = n.length; l < u; i = ++l) r = n[i], e.pos = r.offset, c = e.readString(r.length), a = new mS(c, r), s[d = r.nameID] ?? (s[d] = []), s[r.nameID].push(a);
		this.strings = s, this.copyright = s[0], this.fontFamily = s[1], this.fontSubfamily = s[2], this.uniqueSubfamily = s[3], this.fontName = s[4], this.version = s[5];
		try {
			this.postscriptName = s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
		} catch {
			this.postscriptName = s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
		}
		return this.trademark = s[7], this.manufacturer = s[8], this.designer = s[9], this.description = s[10], this.vendorUrl = s[11], this.designerUrl = s[12], this.license = s[13], this.licenseUrl = s[14], this.preferredFamily = s[15], this.preferredSubfamily = s[17], this.compatibleFull = s[18], this.sampleText = s[19];
	}, e;
}(), gS = function() {
	function e() {
		return e.__super__.constructor.apply(this, arguments);
	}
	return sS(e, rS), e.prototype.tag = "maxp", e.prototype.parse = function(e) {
		return e.pos = this.offset, this.version = e.readInt(), this.numGlyphs = e.readUInt16(), this.maxPoints = e.readUInt16(), this.maxContours = e.readUInt16(), this.maxCompositePoints = e.readUInt16(), this.maxComponentContours = e.readUInt16(), this.maxZones = e.readUInt16(), this.maxTwilightPoints = e.readUInt16(), this.maxStorage = e.readUInt16(), this.maxFunctionDefs = e.readUInt16(), this.maxInstructionDefs = e.readUInt16(), this.maxStackElements = e.readUInt16(), this.maxSizeOfInstructions = e.readUInt16(), this.maxComponentElements = e.readUInt16(), this.maxComponentDepth = e.readUInt16();
	}, e;
}(), _S = function() {
	function e() {
		return e.__super__.constructor.apply(this, arguments);
	}
	return sS(e, rS), e.prototype.tag = "hmtx", e.prototype.parse = function(e) {
		var t, n, r, i, a, o, s;
		for (e.pos = this.offset, this.metrics = [], t = 0, o = this.file.hhea.numberOfMetrics; 0 <= o ? t < o : t > o; t = 0 <= o ? ++t : --t) this.metrics.push({
			advance: e.readUInt16(),
			lsb: e.readInt16()
		});
		for (r = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = function() {
			var n, i;
			for (i = [], t = n = 0; 0 <= r ? n < r : n > r; t = 0 <= r ? ++n : --n) i.push(e.readInt16());
			return i;
		}(), this.widths = function() {
			var e, t, n, r;
			for (r = [], e = 0, t = (n = this.metrics).length; e < t; e++) i = n[e], r.push(i.advance);
			return r;
		}.call(this), n = this.widths[this.widths.length - 1], s = [], t = a = 0; 0 <= r ? a < r : a > r; t = 0 <= r ? ++a : --a) s.push(this.widths.push(n));
		return s;
	}, e.prototype.forGlyph = function(e) {
		return e in this.metrics ? this.metrics[e] : {
			advance: this.metrics[this.metrics.length - 1].advance,
			lsb: this.leftSideBearings[e - this.metrics.length]
		};
	}, e;
}(), vS = [].slice, yS = function() {
	function e() {
		return e.__super__.constructor.apply(this, arguments);
	}
	return sS(e, rS), e.prototype.tag = "glyf", e.prototype.parse = function() {
		return this.cache = {};
	}, e.prototype.glyphFor = function(e) {
		var t, n, r, i, a, o, s, c, l, u;
		return e in this.cache ? this.cache[e] : (i = this.file.loca, t = this.file.contents, n = i.indexOf(e), (r = i.lengthOf(e)) === 0 ? this.cache[e] = null : (t.pos = this.offset + n, a = (o = new iS(t.read(r))).readShort(), c = o.readShort(), u = o.readShort(), s = o.readShort(), l = o.readShort(), this.cache[e] = a === -1 ? new xS(o, c, u, s, l) : new bS(o, a, c, u, s, l), this.cache[e]));
	}, e.prototype.encode = function(e, t, n) {
		var r, i, a, o, s;
		for (a = [], i = [], o = 0, s = t.length; o < s; o++) r = e[t[o]], i.push(a.length), r && (a = a.concat(r.encode(n)));
		return i.push(a.length), {
			table: a,
			offsets: i
		};
	}, e;
}(), bS = function() {
	function e(e, t, n, r, i, a) {
		this.raw = e, this.numberOfContours = t, this.xMin = n, this.yMin = r, this.xMax = i, this.yMax = a, this.compound = !1;
	}
	return e.prototype.encode = function() {
		return this.raw.data;
	}, e;
}(), xS = function() {
	function e(e, t, n, r, i) {
		var a, o;
		for (this.raw = e, this.xMin = t, this.yMin = n, this.xMax = r, this.yMax = i, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], a = this.raw; o = a.readShort(), this.glyphOffsets.push(a.pos), this.glyphIDs.push(a.readUInt16()), 32 & o;) a.pos += 1 & o ? 4 : 2, 128 & o ? a.pos += 8 : 64 & o ? a.pos += 4 : 8 & o && (a.pos += 2);
	}
	return e.prototype.encode = function() {
		var e, t, n;
		for (t = new iS(vS.call(this.raw.data)), e = 0, n = this.glyphIDs.length; e < n; ++e) t.pos = this.glyphOffsets[e];
		return t.data;
	}, e;
}(), SS = function() {
	function e() {
		return e.__super__.constructor.apply(this, arguments);
	}
	return sS(e, rS), e.prototype.tag = "loca", e.prototype.parse = function(e) {
		var t, n;
		return e.pos = this.offset, t = this.file.head.indexToLocFormat, this.offsets = t === 0 ? function() {
			var t, r;
			for (r = [], n = 0, t = this.length; n < t; n += 2) r.push(2 * e.readUInt16());
			return r;
		}.call(this) : function() {
			var t, r;
			for (r = [], n = 0, t = this.length; n < t; n += 4) r.push(e.readUInt32());
			return r;
		}.call(this);
	}, e.prototype.indexOf = function(e) {
		return this.offsets[e];
	}, e.prototype.lengthOf = function(e) {
		return this.offsets[e + 1] - this.offsets[e];
	}, e.prototype.encode = function(e, t) {
		for (var n = new Uint32Array(this.offsets.length), r = 0, i = 0, a = 0; a < n.length; ++a) if (n[a] = r, i < t.length && t[i] == a) {
			++i, n[a] = r;
			var o = this.offsets[a], s = this.offsets[a + 1] - o;
			s > 0 && (r += s);
		}
		for (var c = Array(4 * n.length), l = 0; l < n.length; ++l) c[4 * l + 3] = 255 & n[l], c[4 * l + 2] = (65280 & n[l]) >> 8, c[4 * l + 1] = (16711680 & n[l]) >> 16, c[4 * l] = (4278190080 & n[l]) >> 24;
		return c;
	}, e;
}(), CS = function() {
	function e(e) {
		this.font = e, this.subset = {}, this.unicodes = {}, this.next = 33;
	}
	return e.prototype.generateCmap = function() {
		var e, t, n, r, i;
		for (t in r = this.font.cmap.tables[0].codeMap, e = {}, i = this.subset) n = i[t], e[t] = r[n];
		return e;
	}, e.prototype.glyphsFor = function(e) {
		var t, n, r, i, a, o, s;
		for (r = {}, a = 0, o = e.length; a < o; a++) r[i = e[a]] = this.font.glyf.glyphFor(i);
		for (i in t = [], r) (n = r[i]) != null && n.compound && t.push.apply(t, n.glyphIDs);
		if (t.length > 0) for (i in s = this.glyphsFor(t)) n = s[i], r[i] = n;
		return r;
	}, e.prototype.encode = function(e, t) {
		var n, r, i, a, o, s, c, l, u, d, f, p, m, h, g;
		for (r in n = uS.encode(this.generateCmap(), "unicode"), a = this.glyphsFor(e), f = { 0: 0 }, g = n.charMap) f[(s = g[r]).old] = s.new;
		for (p in d = n.maxGlyphID, a) p in f || (f[p] = d++);
		return l = function(e) {
			var t, n;
			for (t in n = {}, e) n[e[t]] = t;
			return n;
		}(f), u = Object.keys(l).sort(function(e, t) {
			return e - t;
		}), m = function() {
			var e, t, n;
			for (n = [], e = 0, t = u.length; e < t; e++) o = u[e], n.push(l[o]);
			return n;
		}(), i = this.font.glyf.encode(a, m, f), c = this.font.loca.encode(i.offsets, m), h = {
			cmap: this.font.cmap.raw(),
			glyf: i.table,
			loca: c,
			hmtx: this.font.hmtx.raw(),
			hhea: this.font.hhea.raw(),
			maxp: this.font.maxp.raw(),
			post: this.font.post.raw(),
			name: this.font.name.raw(),
			head: this.font.head.encode(t)
		}, this.font.os2.exists && (h["OS/2"] = this.font.os2.raw()), this.font.directory.encode(h);
	}, e;
}();
jb.API.PDFObject = function() {
	var e;
	function t() {}
	return e = function(e, t) {
		return (Array(t + 1).join("0") + e).slice(-t);
	}, t.convert = function(n) {
		var r, i, a, o;
		if (Array.isArray(n)) return "[" + function() {
			var e, i, a;
			for (a = [], e = 0, i = n.length; e < i; e++) r = n[e], a.push(t.convert(r));
			return a;
		}().join(" ") + "]";
		if (typeof n == "string") return "/" + n;
		if (n?.isString) return "(" + n + ")";
		if (n instanceof Date) return "(D:" + e(n.getUTCFullYear(), 4) + e(n.getUTCMonth(), 2) + e(n.getUTCDate(), 2) + e(n.getUTCHours(), 2) + e(n.getUTCMinutes(), 2) + e(n.getUTCSeconds(), 2) + "Z)";
		if ({}.toString.call(n) === "[object Object]") {
			for (i in a = ["<<"], n) o = n[i], a.push("/" + i + " " + t.convert(o));
			return a.push(">>"), a.join("\n");
		}
		return "" + n;
	}, t;
}();
//#endregion
//#region node_modules/cssesc/cssesc.js
var wS = /* @__PURE__ */ s(((e, t) => {
	var n = {}.hasOwnProperty, r = function(e, t) {
		if (!e) return t;
		var r = {};
		for (var i in t) r[i] = n.call(e, i) ? e[i] : t[i];
		return r;
	}, i = /[ -,\.\/:-@\[-\^`\{-~]/, a = /[ -,\.\/:-@\[\]\^`\{-~]/, o = /(^|\\+)?(\\[A-F0-9]{1,6})\x20(?![a-fA-F0-9\x20])/g, s = function e(t, n) {
		n = r(n, e.options), n.quotes != "single" && n.quotes != "double" && (n.quotes = "single");
		for (var s = n.quotes == "double" ? "\"" : "'", c = n.isIdentifier, l = t.charAt(0), u = "", d = 0, f = t.length; d < f;) {
			var p = t.charAt(d++), m = p.charCodeAt(), h = void 0;
			if (m < 32 || m > 126) {
				if (m >= 55296 && m <= 56319 && d < f) {
					var g = t.charCodeAt(d++);
					(g & 64512) == 56320 ? m = ((m & 1023) << 10) + (g & 1023) + 65536 : d--;
				}
				h = "\\" + m.toString(16).toUpperCase() + " ";
			} else h = n.escapeEverything ? i.test(p) ? "\\" + p : "\\" + m.toString(16).toUpperCase() + " " : /[\t\n\f\r\x0B]/.test(p) ? "\\" + m.toString(16).toUpperCase() + " " : p == "\\" || !c && (p == "\"" && s == p || p == "'" && s == p) || c && a.test(p) ? "\\" + p : p;
			u += h;
		}
		return c && (/^-[-\d]/.test(u) ? u = "\\-" + u.slice(1) : /\d/.test(l) && (u = "\\3" + l + " " + u.slice(1))), u = u.replace(o, function(e, t, n) {
			return t && t.length % 2 ? e : (t || "") + n;
		}), !c && n.wrap ? s + u + s : u;
	};
	s.options = {
		escapeEverything: !1,
		isIdentifier: !1,
		quotes: "single",
		wrap: !1
	}, s.version = "3.0.0", t.exports = s;
})), TS = /* @__PURE__ */ s(((e, t) => {
	var n = /[a-z0-9_-]/i, r = /[\s\t]/, i = function(e) {
		for (var t = !0, i = 0, a = "", o = 0, s, c, l = [];;) {
			if (c = e[o], i === 0) {
				if (!c && t) break;
				if (!c && !t) throw Error("Parse error");
				if (c === "\"" || c === "'") s = c, i = 1, t = !1;
				else if (!r.test(c)) if (n.test(c)) i = 3, t = !1, o--;
				else throw Error("Parse error");
			} else if (i === 1) if (c) c === "\\" ? i = 2 : c === s ? (l.push(a), a = "", i = 4) : a += c;
			else throw Error("Parse Error");
			else if (i === 2) if (c === s || c === "\\") a += c, i = 1;
			else throw Error("Parse error");
			else if (i === 3) if (c) n.test(c) ? a += c : c === "," ? (l.push(a), a = "", i = 0) : r.test(c) ? i = 5 : c === "\\" && (i = 6);
			else {
				l.push(a);
				break;
			}
			else if (i === 6) {
				if (/[0-9a-f]/i.test(c)) throw Error("Parse error");
				a += c, i = 3;
			} else if (i === 5) {
				if (!c) {
					l.push(a);
					break;
				} else if (n.test(c)) a += " " + c, i = 3;
				else if (c === ",") l.push(a), a = "", i = 0;
				else if (!r.test(c)) throw Error("Parse error");
			} else if (i === 4) {
				if (!c) break;
				if (c === ",") i = 0;
				else if (!r.test(c)) throw Error("Parse error");
			}
			o++;
		}
		return l;
	}, a = /[^a-z0-9_-]/i;
	t.exports = {
		parse: i,
		stringify: function(e, t) {
			var n = t && t.quote || "\"";
			if (n !== "\"" && n !== "'") throw Error("Quote must be `'` or `\"`");
			for (var r = new RegExp(n, "g"), i = [], o = 0; o < e.length; ++o) {
				var s = e[o];
				a.test(s) && (s = s.replace(/\\/g, "\\\\").replace(r, "\\" + n), s = n + s + n), i.push(s);
			}
			return i.join(", ");
		}
	};
})), ES = /* @__PURE__ */ s(((e, t) => {
	var n = {
		a: 7,
		c: 6,
		h: 1,
		l: 2,
		m: 2,
		r: 4,
		q: 4,
		s: 4,
		t: 2,
		v: 1,
		z: 0
	}, r = [
		5760,
		6158,
		8192,
		8193,
		8194,
		8195,
		8196,
		8197,
		8198,
		8199,
		8200,
		8201,
		8202,
		8239,
		8287,
		12288,
		65279
	];
	function i(e) {
		return e === 10 || e === 13 || e === 8232 || e === 8233 || e === 32 || e === 9 || e === 11 || e === 12 || e === 160 || e >= 5760 && r.indexOf(e) >= 0;
	}
	function a(e) {
		switch (e | 32) {
			case 109:
			case 122:
			case 108:
			case 104:
			case 118:
			case 99:
			case 115:
			case 113:
			case 116:
			case 97:
			case 114: return !0;
		}
		return !1;
	}
	function o(e) {
		return (e | 32) == 97;
	}
	function s(e) {
		return e >= 48 && e <= 57;
	}
	function c(e) {
		return e >= 48 && e <= 57 || e === 43 || e === 45 || e === 46;
	}
	function l(e) {
		this.index = 0, this.path = e, this.max = e.length, this.result = [], this.param = 0, this.err = "", this.segmentStart = 0, this.data = [];
	}
	function u(e) {
		for (; e.index < e.max && i(e.path.charCodeAt(e.index));) e.index++;
	}
	function d(e) {
		var t = e.path.charCodeAt(e.index);
		if (t === 48) {
			e.param = 0, e.index++;
			return;
		}
		if (t === 49) {
			e.param = 1, e.index++;
			return;
		}
		e.err = "SvgPath: arc flag can be 0 or 1 only (at pos " + e.index + ")";
	}
	function f(e) {
		var t = e.index, n = t, r = e.max, i = !1, a = !1, o = !1, c = !1, l;
		if (n >= r) {
			e.err = "SvgPath: missed param (at pos " + n + ")";
			return;
		}
		if (l = e.path.charCodeAt(n), (l === 43 || l === 45) && (n++, l = n < r ? e.path.charCodeAt(n) : 0), !s(l) && l !== 46) {
			e.err = "SvgPath: param should start with 0..9 or `.` (at pos " + n + ")";
			return;
		}
		if (l !== 46) {
			if (i = l === 48, n++, l = n < r ? e.path.charCodeAt(n) : 0, i && n < r && l && s(l)) {
				e.err = "SvgPath: numbers started with `0` such as `09` are illegal (at pos " + t + ")";
				return;
			}
			for (; n < r && s(e.path.charCodeAt(n));) n++, a = !0;
			l = n < r ? e.path.charCodeAt(n) : 0;
		}
		if (l === 46) {
			for (c = !0, n++; s(e.path.charCodeAt(n));) n++, o = !0;
			l = n < r ? e.path.charCodeAt(n) : 0;
		}
		if (l === 101 || l === 69) {
			if (c && !a && !o) {
				e.err = "SvgPath: invalid float exponent (at pos " + n + ")";
				return;
			}
			if (n++, l = n < r ? e.path.charCodeAt(n) : 0, (l === 43 || l === 45) && n++, n < r && s(e.path.charCodeAt(n))) for (; n < r && s(e.path.charCodeAt(n));) n++;
			else {
				e.err = "SvgPath: invalid float exponent (at pos " + n + ")";
				return;
			}
		}
		e.index = n, e.param = parseFloat(e.path.slice(t, n)) + 0;
	}
	function p(e) {
		var t = e.path[e.segmentStart], r = t.toLowerCase(), i = e.data;
		if (r === "m" && i.length > 2 && (e.result.push([
			t,
			i[0],
			i[1]
		]), i = i.slice(2), r = "l", t = t === "m" ? "l" : "L"), r === "r") e.result.push([t].concat(i));
		else for (; i.length >= n[r] && (e.result.push([t].concat(i.splice(0, n[r]))), n[r]););
	}
	function m(e) {
		var t = e.max, r, i, s, l, m;
		if (e.segmentStart = e.index, r = e.path.charCodeAt(e.index), i = o(r), !a(r)) {
			e.err = "SvgPath: bad command " + e.path[e.index] + " (at pos " + e.index + ")";
			return;
		}
		if (l = n[e.path[e.index].toLowerCase()], e.index++, u(e), e.data = [], !l) {
			p(e);
			return;
		}
		for (s = !1;;) {
			for (m = l; m > 0; m--) {
				if (i && (m === 3 || m === 4) ? d(e) : f(e), e.err.length) {
					p(e);
					return;
				}
				e.data.push(e.param), u(e), s = !1, e.index < t && e.path.charCodeAt(e.index) === 44 && (e.index++, u(e), s = !0);
			}
			if (!s && (e.index >= e.max || !c(e.path.charCodeAt(e.index)))) break;
		}
		p(e);
	}
	t.exports = function(e) {
		var t = new l(e), n = t.max;
		for (u(t); t.index < n && !t.err.length;) m(t);
		return t.result.length && ("mM".indexOf(t.result[0][0]) < 0 ? (t.err = "SvgPath: string should start with `M` or `m`", t.result = []) : t.result[0][0] = "M"), {
			err: t.err,
			segments: t.result
		};
	};
})), DS = /* @__PURE__ */ s(((e, t) => {
	function n(e, t) {
		return [
			e[0] * t[0] + e[2] * t[1],
			e[1] * t[0] + e[3] * t[1],
			e[0] * t[2] + e[2] * t[3],
			e[1] * t[2] + e[3] * t[3],
			e[0] * t[4] + e[2] * t[5] + e[4],
			e[1] * t[4] + e[3] * t[5] + e[5]
		];
	}
	function r() {
		if (!(this instanceof r)) return new r();
		this.queue = [], this.cache = null;
	}
	r.prototype.matrix = function(e) {
		return e[0] === 1 && e[1] === 0 && e[2] === 0 && e[3] === 1 && e[4] === 0 && e[5] === 0 ? this : (this.cache = null, this.queue.push(e), this);
	}, r.prototype.translate = function(e, t) {
		return (e !== 0 || t !== 0) && (this.cache = null, this.queue.push([
			1,
			0,
			0,
			1,
			e,
			t
		])), this;
	}, r.prototype.scale = function(e, t) {
		return (e !== 1 || t !== 1) && (this.cache = null, this.queue.push([
			e,
			0,
			0,
			t,
			0,
			0
		])), this;
	}, r.prototype.rotate = function(e, t, n) {
		var r, i, a;
		return e !== 0 && (this.translate(t, n), r = e * Math.PI / 180, i = Math.cos(r), a = Math.sin(r), this.queue.push([
			i,
			a,
			-a,
			i,
			0,
			0
		]), this.cache = null, this.translate(-t, -n)), this;
	}, r.prototype.skewX = function(e) {
		return e !== 0 && (this.cache = null, this.queue.push([
			1,
			0,
			Math.tan(e * Math.PI / 180),
			1,
			0,
			0
		])), this;
	}, r.prototype.skewY = function(e) {
		return e !== 0 && (this.cache = null, this.queue.push([
			1,
			Math.tan(e * Math.PI / 180),
			0,
			1,
			0,
			0
		])), this;
	}, r.prototype.toArray = function() {
		if (this.cache) return this.cache;
		if (!this.queue.length) return this.cache = [
			1,
			0,
			0,
			1,
			0,
			0
		], this.cache;
		if (this.cache = this.queue[0], this.queue.length === 1) return this.cache;
		for (var e = 1; e < this.queue.length; e++) this.cache = n(this.cache, this.queue[e]);
		return this.cache;
	}, r.prototype.calc = function(e, t, n) {
		var r;
		return this.queue.length ? (this.cache ||= this.toArray(), r = this.cache, [e * r[0] + t * r[2] + (n ? 0 : r[4]), e * r[1] + t * r[3] + (n ? 0 : r[5])]) : [e, t];
	}, t.exports = r;
})), OS = /* @__PURE__ */ s(((e, t) => {
	var n = DS(), r = {
		matrix: !0,
		scale: !0,
		rotate: !0,
		translate: !0,
		skewX: !0,
		skewY: !0
	}, i = /\s*(matrix|translate|scale|rotate|skewX|skewY)\s*\(\s*(.+?)\s*\)[\s,]*/, a = /[\s,]+/;
	t.exports = function(e) {
		var t = new n(), o, s;
		return e.split(i).forEach(function(e) {
			if (e.length) {
				if (r[e] !== void 0) {
					o = e;
					return;
				}
				switch (s = e.split(a).map(function(e) {
					return +e || 0;
				}), o) {
					case "matrix":
						s.length === 6 && t.matrix(s);
						return;
					case "scale":
						s.length === 1 ? t.scale(s[0], s[0]) : s.length === 2 && t.scale(s[0], s[1]);
						return;
					case "rotate":
						s.length === 1 ? t.rotate(s[0], 0, 0) : s.length === 3 && t.rotate(s[0], s[1], s[2]);
						return;
					case "translate":
						s.length === 1 ? t.translate(s[0], 0) : s.length === 2 && t.translate(s[0], s[1]);
						return;
					case "skewX":
						s.length === 1 && t.skewX(s[0]);
						return;
					case "skewY":
						s.length === 1 && t.skewY(s[0]);
						return;
				}
			}
		}), t;
	};
})), kS = /* @__PURE__ */ s(((e, t) => {
	var n = Math.PI * 2;
	function r(e, t, n, r) {
		var i = e * r - t * n < 0 ? -1 : 1, a = e * n + t * r;
		return a > 1 && (a = 1), a < -1 && (a = -1), i * Math.acos(a);
	}
	function i(e, t, i, a, o, s, c, l, u, d) {
		var f = d * (e - i) / 2 + u * (t - a) / 2, p = -u * (e - i) / 2 + d * (t - a) / 2, m = c * c, h = l * l, g = f * f, _ = p * p, v = m * h - m * _ - h * g;
		v < 0 && (v = 0), v /= m * _ + h * g, v = Math.sqrt(v) * (o === s ? -1 : 1);
		var y = v * c / l * p, b = v * -l / c * f, x = d * y - u * b + (e + i) / 2, S = u * y + d * b + (t + a) / 2, C = (f - y) / c, w = (p - b) / l, T = (-f - y) / c, E = (-p - b) / l, D = r(1, 0, C, w), O = r(C, w, T, E);
		return s === 0 && O > 0 && (O -= n), s === 1 && O < 0 && (O += n), [
			x,
			S,
			D,
			O
		];
	}
	function a(e, t) {
		var n = 4 / 3 * Math.tan(t / 4), r = Math.cos(e), i = Math.sin(e), a = Math.cos(e + t), o = Math.sin(e + t);
		return [
			r,
			i,
			r - i * n,
			i + r * n,
			a + o * n,
			o - a * n,
			a,
			o
		];
	}
	t.exports = function(e, t, r, o, s, c, l, u, d) {
		var f = Math.sin(d * n / 360), p = Math.cos(d * n / 360), m = p * (e - r) / 2 + f * (t - o) / 2, h = -f * (e - r) / 2 + p * (t - o) / 2;
		if (m === 0 && h === 0 || l === 0 || u === 0) return [];
		l = Math.abs(l), u = Math.abs(u);
		var g = m * m / (l * l) + h * h / (u * u);
		g > 1 && (l *= Math.sqrt(g), u *= Math.sqrt(g));
		var _ = i(e, t, r, o, s, c, l, u, f, p), v = [], y = _[2], b = _[3], x = Math.max(Math.ceil(Math.abs(b) / (n / 4)), 1);
		b /= x;
		for (var S = 0; S < x; S++) v.push(a(y, b)), y += b;
		return v.map(function(e) {
			for (var t = 0; t < e.length; t += 2) {
				var n = e[t + 0], r = e[t + 1];
				n *= l, r *= u;
				var i = p * n - f * r, a = f * n + p * r;
				e[t + 0] = i + _[0], e[t + 1] = a + _[1];
			}
			return e;
		});
	};
})), AS = /* @__PURE__ */ s(((e, t) => {
	var n = 1e-10, r = Math.PI / 180;
	function i(e, t, n) {
		if (!(this instanceof i)) return new i(e, t, n);
		this.rx = e, this.ry = t, this.ax = n;
	}
	i.prototype.transform = function(e) {
		var t = Math.cos(this.ax * r), i = Math.sin(this.ax * r), a = [
			this.rx * (e[0] * t + e[2] * i),
			this.rx * (e[1] * t + e[3] * i),
			this.ry * (-e[0] * i + e[2] * t),
			this.ry * (-e[1] * i + e[3] * t)
		], o = a[0] * a[0] + a[2] * a[2], s = a[1] * a[1] + a[3] * a[3], c = ((a[0] - a[3]) * (a[0] - a[3]) + (a[2] + a[1]) * (a[2] + a[1])) * ((a[0] + a[3]) * (a[0] + a[3]) + (a[2] - a[1]) * (a[2] - a[1])), l = (o + s) / 2;
		if (c < n * l) return this.rx = this.ry = Math.sqrt(l), this.ax = 0, this;
		var u = a[0] * a[1] + a[2] * a[3];
		c = Math.sqrt(c);
		var d = l + c / 2, f = l - c / 2;
		return this.ax = Math.abs(u) < n && Math.abs(d - s) < n ? 90 : Math.atan(Math.abs(u) > Math.abs(d - s) ? (d - o) / u : u / (d - s)) * 180 / Math.PI, this.ax >= 0 ? (this.rx = Math.sqrt(d), this.ry = Math.sqrt(f)) : (this.ax += 90, this.rx = Math.sqrt(f), this.ry = Math.sqrt(d)), this;
	}, i.prototype.isDegenerate = function() {
		return this.rx < n * this.ry || this.ry < n * this.rx;
	}, t.exports = i;
})), jS = /* @__PURE__ */ s(((e, t) => {
	var n = ES(), r = OS(), i = DS(), a = kS(), o = AS();
	function s(e) {
		if (!(this instanceof s)) return new s(e);
		var t = n(e);
		this.segments = t.segments, this.err = t.err, this.__stack = [];
	}
	s.from = function(e) {
		if (typeof e == "string") return new s(e);
		if (e instanceof s) {
			var t = new s("");
			return t.err = e.err, t.segments = e.segments.map(function(e) {
				return e.slice();
			}), t.__stack = e.__stack.map(function(e) {
				return i().matrix(e.toArray());
			}), t;
		}
		throw Error("SvgPath.from: invalid param type " + e);
	}, s.prototype.__matrix = function(e) {
		var t = this, n;
		e.queue.length && this.iterate(function(r, i, a, s) {
			var c, l, u, d;
			switch (r[0]) {
				case "v":
					c = e.calc(0, r[1], !0), l = c[0] === 0 ? ["v", c[1]] : [
						"l",
						c[0],
						c[1]
					];
					break;
				case "V":
					c = e.calc(a, r[1], !1), l = c[0] === e.calc(a, s, !1)[0] ? ["V", c[1]] : [
						"L",
						c[0],
						c[1]
					];
					break;
				case "h":
					c = e.calc(r[1], 0, !0), l = c[1] === 0 ? ["h", c[0]] : [
						"l",
						c[0],
						c[1]
					];
					break;
				case "H":
					c = e.calc(r[1], s, !1), l = c[1] === e.calc(a, s, !1)[1] ? ["H", c[0]] : [
						"L",
						c[0],
						c[1]
					];
					break;
				case "a":
				case "A":
					var f = e.toArray(), p = o(r[1], r[2], r[3]).transform(f);
					if (f[0] * f[3] - f[1] * f[2] < 0 && (r[5] = r[5] ? "0" : "1"), c = e.calc(r[6], r[7], r[0] === "a"), r[0] === "A" && r[6] === a && r[7] === s || r[0] === "a" && r[6] === 0 && r[7] === 0) {
						l = [
							r[0] === "a" ? "l" : "L",
							c[0],
							c[1]
						];
						break;
					}
					l = p.isDegenerate() ? [
						r[0] === "a" ? "l" : "L",
						c[0],
						c[1]
					] : [
						r[0],
						p.rx,
						p.ry,
						p.ax,
						r[4],
						r[5],
						c[0],
						c[1]
					];
					break;
				case "m":
					d = i > 0, c = e.calc(r[1], r[2], d), l = [
						"m",
						c[0],
						c[1]
					];
					break;
				default: for (u = r[0], l = [u], d = u.toLowerCase() === u, n = 1; n < r.length; n += 2) c = e.calc(r[n], r[n + 1], d), l.push(c[0], c[1]);
			}
			t.segments[i] = l;
		}, !0);
	}, s.prototype.__evaluateStack = function() {
		var e, t;
		if (this.__stack.length) {
			if (this.__stack.length === 1) {
				this.__matrix(this.__stack[0]), this.__stack = [];
				return;
			}
			for (e = i(), t = this.__stack.length; --t >= 0;) e.matrix(this.__stack[t].toArray());
			this.__matrix(e), this.__stack = [];
		}
	}, s.prototype.toString = function() {
		var e = "", t = "", n = !1;
		this.__evaluateStack();
		for (var r = 0, i = this.segments.length; r < i; r++) {
			var a = this.segments[r], o = a[0];
			o !== t || o === "m" || o === "M" ? (o === "m" && t === "z" && (e += " "), e += o, n = !1) : n = !0;
			for (var s = 1; s < a.length; s++) {
				var c = a[s];
				s === 1 ? n && c >= 0 && (e += " ") : c >= 0 && (e += " "), e += c;
			}
			t = o;
		}
		return e;
	}, s.prototype.translate = function(e, t) {
		return this.__stack.push(i().translate(e, t || 0)), this;
	}, s.prototype.scale = function(e, t) {
		return this.__stack.push(i().scale(e, !t && t !== 0 ? e : t)), this;
	}, s.prototype.rotate = function(e, t, n) {
		return this.__stack.push(i().rotate(e, t || 0, n || 0)), this;
	}, s.prototype.skewX = function(e) {
		return this.__stack.push(i().skewX(e)), this;
	}, s.prototype.skewY = function(e) {
		return this.__stack.push(i().skewY(e)), this;
	}, s.prototype.matrix = function(e) {
		return this.__stack.push(i().matrix(e)), this;
	}, s.prototype.transform = function(e) {
		return e.trim() && this.__stack.push(r(e)), this;
	}, s.prototype.round = function(e) {
		var t = 0, n = 0, r = 0, i = 0, a;
		return e ||= 0, this.__evaluateStack(), this.segments.forEach(function(o) {
			var s = o[0].toLowerCase() === o[0];
			switch (o[0]) {
				case "H":
				case "h":
					s && (o[1] += r), r = o[1] - o[1].toFixed(e), o[1] = +o[1].toFixed(e);
					return;
				case "V":
				case "v":
					s && (o[1] += i), i = o[1] - o[1].toFixed(e), o[1] = +o[1].toFixed(e);
					return;
				case "Z":
				case "z":
					r = t, i = n;
					return;
				case "M":
				case "m":
					s && (o[1] += r, o[2] += i), r = o[1] - o[1].toFixed(e), i = o[2] - o[2].toFixed(e), t = r, n = i, o[1] = +o[1].toFixed(e), o[2] = +o[2].toFixed(e);
					return;
				case "A":
				case "a":
					s && (o[6] += r, o[7] += i), r = o[6] - o[6].toFixed(e), i = o[7] - o[7].toFixed(e), o[1] = +o[1].toFixed(e), o[2] = +o[2].toFixed(e), o[3] = +o[3].toFixed(e + 2), o[6] = +o[6].toFixed(e), o[7] = +o[7].toFixed(e);
					return;
				default:
					a = o.length, s && (o[a - 2] += r, o[a - 1] += i), r = o[a - 2] - o[a - 2].toFixed(e), i = o[a - 1] - o[a - 1].toFixed(e), o.forEach(function(t, n) {
						n && (o[n] = +o[n].toFixed(e));
					});
					return;
			}
		}), this;
	}, s.prototype.iterate = function(e, t) {
		var n = this.segments, r = {}, i = !1, a = 0, o = 0, s = 0, c = 0, l, u, d;
		if (t || this.__evaluateStack(), n.forEach(function(t, n) {
			var l = e(t, n, a, o);
			Array.isArray(l) && (r[n] = l, i = !0);
			var u = t[0] === t[0].toLowerCase();
			switch (t[0]) {
				case "m":
				case "M":
					a = t[1] + (u ? a : 0), o = t[2] + (u ? o : 0), s = a, c = o;
					return;
				case "h":
				case "H":
					a = t[1] + (u ? a : 0);
					return;
				case "v":
				case "V":
					o = t[1] + (u ? o : 0);
					return;
				case "z":
				case "Z":
					a = s, o = c;
					return;
				default: a = t[t.length - 2] + (u ? a : 0), o = t[t.length - 1] + (u ? o : 0);
			}
		}), !i) return this;
		for (d = [], l = 0; l < n.length; l++) if (r[l] !== void 0) for (u = 0; u < r[l].length; u++) d.push(r[l][u]);
		else d.push(n[l]);
		return this.segments = d, this;
	}, s.prototype.abs = function() {
		return this.iterate(function(e, t, n, r) {
			var i = e[0], a = i.toUpperCase(), o;
			if (i !== a) switch (e[0] = a, i) {
				case "v":
					e[1] += r;
					return;
				case "a":
					e[6] += n, e[7] += r;
					return;
				default: for (o = 1; o < e.length; o++) e[o] += o % 2 ? n : r;
			}
		}, !0), this;
	}, s.prototype.rel = function() {
		return this.iterate(function(e, t, n, r) {
			var i = e[0], a = i.toLowerCase(), o;
			if (i !== a && !(t === 0 && i === "M")) switch (e[0] = a, i) {
				case "V":
					e[1] -= r;
					return;
				case "A":
					e[6] -= n, e[7] -= r;
					return;
				default: for (o = 1; o < e.length; o++) e[o] -= o % 2 ? n : r;
			}
		}, !0), this;
	}, s.prototype.unarc = function() {
		return this.iterate(function(e, t, n, r) {
			var i, o, s, c = [], l = e[0];
			return l !== "A" && l !== "a" ? null : (l === "a" ? (o = n + e[6], s = r + e[7]) : (o = e[6], s = e[7]), i = a(n, r, o, s, e[4], e[5], e[1], e[2], e[3]), i.length === 0 ? [[
				e[0] === "a" ? "l" : "L",
				e[6],
				e[7]
			]] : (i.forEach(function(e) {
				c.push([
					"C",
					e[2],
					e[3],
					e[4],
					e[5],
					e[6],
					e[7]
				]);
			}), c));
		}), this;
	}, s.prototype.unshort = function() {
		var e = this.segments, t, n, r, i, a;
		return this.iterate(function(o, s, c, l) {
			var u = o[0], d = u.toUpperCase(), f;
			s && (d === "T" ? (f = u === "t", r = e[s - 1], r[0] === "Q" ? (t = r[1] - c, n = r[2] - l) : r[0] === "q" ? (t = r[1] - r[3], n = r[2] - r[4]) : (t = 0, n = 0), i = -t, a = -n, f || (i += c, a += l), e[s] = [
				f ? "q" : "Q",
				i,
				a,
				o[1],
				o[2]
			]) : d === "S" && (f = u === "s", r = e[s - 1], r[0] === "C" ? (t = r[3] - c, n = r[4] - l) : r[0] === "c" ? (t = r[3] - r[5], n = r[4] - r[6]) : (t = 0, n = 0), i = -t, a = -n, f || (i += c, a += l), e[s] = [
				f ? "c" : "C",
				i,
				a,
				o[1],
				o[2],
				o[3],
				o[4]
			]));
		}), this;
	}, t.exports = s;
})), MS = /* @__PURE__ */ s(((e, t) => {
	t.exports = jS();
})), NS = /* @__PURE__ */ u(wS()), PS = /* @__PURE__ */ u(TS()), FS = /* @__PURE__ */ u(MS()), IS = function(e) {
	var t = e, n, r = {
		a: 0,
		b: 0,
		c: 0
	}, i = [];
	return n = function(n, a) {
		var o, s, c, l, u, d;
		if (n.test(t)) for (o = t.match(n), s = 0, c = o.length; s < c; s += 1) r[a] += 1, l = o[s], u = t.indexOf(l), d = l.length, i.push({
			selector: e.substr(u, d),
			type: a,
			index: u,
			length: d
		}), t = t.replace(l, Array(d + 1).join(" "));
	}, (function() {
		var e = function(e) {
			var n, r, i, a;
			if (e.test(t)) for (n = t.match(e), r = 0, i = n.length; r < i; r += 1) a = n[r], t = t.replace(a, Array(a.length + 1).join("A"));
		};
		e(/\\[0-9A-Fa-f]{6}\s?/g), e(/\\[0-9A-Fa-f]{1,5}\s/g), e(/\\./g);
	})(), (function() {
		var e = /{[^]*/gm, n, r, i, a;
		if (e.test(t)) for (n = t.match(e), r = 0, i = n.length; r < i; r += 1) a = n[r], t = t.replace(a, Array(a.length + 1).join(" "));
	})(), n(/(\[[^\]]+\])/g, "b"), n(/(#[^\#\s\+>~\.\[:\)]+)/g, "a"), n(/(\.[^\s\+>~\.\[:\)]+)/g, "b"), n(/(::[^\s\+>~\.\[:]+|:first-line|:first-letter|:before|:after)/gi, "c"), n(/(:(?!not|global|local)[\w-]+\([^\)]*\))/gi, "b"), n(/(:(?!not|global|local)[^\s\+>~\.\[:]+)/g, "b"), t = t.replace(/[\*\s\+>~]/g, " "), t = t.replace(/[#\.]/g, " "), t = t.replace(/:not/g, "    "), t = t.replace(/:local/g, "      "), t = t.replace(/:global/g, "       "), t = t.replace(/[\(\)]/g, " "), n(/([^\s\+>~\.\[:]+)/g, "c"), i.sort(function(e, t) {
		return e.index - t.index;
	}), {
		selector: e,
		specificity: "0," + r.a.toString() + "," + r.b.toString() + "," + r.c.toString(),
		specificityArray: [
			0,
			r.a,
			r.b,
			r.c
		],
		parts: i
	};
}, LS = function(e, t) {
	var n, r, i;
	if (typeof e == "string") {
		if (e.indexOf(",") !== -1) throw "Invalid CSS selector";
		n = IS(e).specificityArray;
	} else if (Array.isArray(e)) {
		if (e.filter(function(e) {
			return typeof e == "number";
		}).length !== 4) throw "Invalid specificity array";
		n = e;
	} else throw "Invalid CSS selector or specificity array";
	if (typeof t == "string") {
		if (t.indexOf(",") !== -1) throw "Invalid CSS selector";
		r = IS(t).specificityArray;
	} else if (Array.isArray(t)) {
		if (t.filter(function(e) {
			return typeof e == "number";
		}).length !== 4) throw "Invalid specificity array";
		r = t;
	} else throw "Invalid CSS selector or specificity array";
	for (i = 0; i < 4; i += 1) if (n[i] < r[i]) return -1;
	else if (n[i] > r[i]) return 1;
	return 0;
}, RS = function(e, t) {
	return RS = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
		e.__proto__ = t;
	} || function(e, t) {
		for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
	}, RS(e, t);
};
function zS(e, t) {
	if (typeof t != "function" && t !== null) throw TypeError("Class extends value " + String(t) + " is not a constructor or null");
	function n() {
		this.constructor = e;
	}
	RS(e, t), e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var BS = function() {
	return BS = Object.assign || function(e) {
		for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
		return e;
	}, BS.apply(this, arguments);
};
function VS(e, t, n, r) {
	return new (n ||= Promise)((function(i, a) {
		function o(e) {
			try {
				c(r.next(e));
			} catch (e) {
				a(e);
			}
		}
		function s(e) {
			try {
				c(r.throw(e));
			} catch (e) {
				a(e);
			}
		}
		function c(e) {
			var t;
			e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n((function(e) {
				e(t);
			}))).then(o, s);
		}
		c((r = r.apply(e, t || [])).next());
	}));
}
function HS(e, t) {
	var n, r, i, a, o = {
		label: 0,
		sent: function() {
			if (1 & i[0]) throw i[1];
			return i[1];
		},
		trys: [],
		ops: []
	};
	return a = {
		next: s(0),
		throw: s(1),
		return: s(2)
	}, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
		return this;
	}), a;
	function s(a) {
		return function(s) {
			return function(a) {
				if (n) throw TypeError("Generator is already executing.");
				for (; o;) try {
					if (n = 1, r && (i = 2 & a[0] ? r.return : a[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, a[1])).done) return i;
					switch (r = 0, i && (a = [2 & a[0], i.value]), a[0]) {
						case 0:
						case 1:
							i = a;
							break;
						case 4: return o.label++, {
							value: a[1],
							done: !1
						};
						case 5:
							o.label++, r = a[1], a = [0];
							continue;
						case 7:
							a = o.ops.pop(), o.trys.pop();
							continue;
						default:
							if (i = o.trys, !((i = i.length > 0 && i[i.length - 1]) || a[0] !== 6 && a[0] !== 2)) {
								o = 0;
								continue;
							}
							if (a[0] === 3 && (!i || a[1] > i[0] && a[1] < i[3])) {
								o.label = a[1];
								break;
							}
							if (a[0] === 6 && o.label < i[1]) {
								o.label = i[1], i = a;
								break;
							}
							if (i && o.label < i[2]) {
								o.label = i[2], o.ops.push(a);
								break;
							}
							i[2] && o.ops.pop(), o.trys.pop();
							continue;
					}
					a = t.call(e, o);
				} catch (e) {
					a = [6, e], r = 0;
				} finally {
					n = i = 0;
				}
				if (5 & a[0]) throw a[1];
				return {
					value: a[0] ? a[1] : void 0,
					done: !0
				};
			}([a, s]);
		};
	}
}
var US = function() {
	function e(e) {
		if (this.a = void 0, this.r = 0, this.g = 0, this.b = 0, this.simpleColors = {}, this.colorDefs = [], this.ok = !1, e) {
			for (var t in e.charAt(0) == "#" && (e = e.substr(1, 6)), e = (e = e.replace(/ /g, "")).toLowerCase(), this.simpleColors = {
				aliceblue: "f0f8ff",
				antiquewhite: "faebd7",
				aqua: "00ffff",
				aquamarine: "7fffd4",
				azure: "f0ffff",
				beige: "f5f5dc",
				bisque: "ffe4c4",
				black: "000000",
				blanchedalmond: "ffebcd",
				blue: "0000ff",
				blueviolet: "8a2be2",
				brown: "a52a2a",
				burlywood: "deb887",
				cadetblue: "5f9ea0",
				chartreuse: "7fff00",
				chocolate: "d2691e",
				coral: "ff7f50",
				cornflowerblue: "6495ed",
				cornsilk: "fff8dc",
				crimson: "dc143c",
				cyan: "00ffff",
				darkblue: "00008b",
				darkcyan: "008b8b",
				darkgoldenrod: "b8860b",
				darkgray: "a9a9a9",
				darkgrey: "a9a9a9",
				darkgreen: "006400",
				darkkhaki: "bdb76b",
				darkmagenta: "8b008b",
				darkolivegreen: "556b2f",
				darkorange: "ff8c00",
				darkorchid: "9932cc",
				darkred: "8b0000",
				darksalmon: "e9967a",
				darkseagreen: "8fbc8f",
				darkslateblue: "483d8b",
				darkslategray: "2f4f4f",
				darkslategrey: "2f4f4f",
				darkturquoise: "00ced1",
				darkviolet: "9400d3",
				deeppink: "ff1493",
				deepskyblue: "00bfff",
				dimgray: "696969",
				dimgrey: "696969",
				dodgerblue: "1e90ff",
				feldspar: "d19275",
				firebrick: "b22222",
				floralwhite: "fffaf0",
				forestgreen: "228b22",
				fuchsia: "ff00ff",
				gainsboro: "dcdcdc",
				ghostwhite: "f8f8ff",
				gold: "ffd700",
				goldenrod: "daa520",
				gray: "808080",
				grey: "808080",
				green: "008000",
				greenyellow: "adff2f",
				honeydew: "f0fff0",
				hotpink: "ff69b4",
				indianred: "cd5c5c",
				indigo: "4b0082",
				ivory: "fffff0",
				khaki: "f0e68c",
				lavender: "e6e6fa",
				lavenderblush: "fff0f5",
				lawngreen: "7cfc00",
				lemonchiffon: "fffacd",
				lightblue: "add8e6",
				lightcoral: "f08080",
				lightcyan: "e0ffff",
				lightgoldenrodyellow: "fafad2",
				lightgray: "d3d3d3",
				lightgrey: "d3d3d3",
				lightgreen: "90ee90",
				lightpink: "ffb6c1",
				lightsalmon: "ffa07a",
				lightseagreen: "20b2aa",
				lightskyblue: "87cefa",
				lightslateblue: "8470ff",
				lightslategray: "778899",
				lightslategrey: "778899",
				lightsteelblue: "b0c4de",
				lightyellow: "ffffe0",
				lime: "00ff00",
				limegreen: "32cd32",
				linen: "faf0e6",
				magenta: "ff00ff",
				maroon: "800000",
				mediumaquamarine: "66cdaa",
				mediumblue: "0000cd",
				mediumorchid: "ba55d3",
				mediumpurple: "9370d8",
				mediumseagreen: "3cb371",
				mediumslateblue: "7b68ee",
				mediumspringgreen: "00fa9a",
				mediumturquoise: "48d1cc",
				mediumvioletred: "c71585",
				midnightblue: "191970",
				mintcream: "f5fffa",
				mistyrose: "ffe4e1",
				moccasin: "ffe4b5",
				navajowhite: "ffdead",
				navy: "000080",
				oldlace: "fdf5e6",
				olive: "808000",
				olivedrab: "6b8e23",
				orange: "ffa500",
				orangered: "ff4500",
				orchid: "da70d6",
				palegoldenrod: "eee8aa",
				palegreen: "98fb98",
				paleturquoise: "afeeee",
				palevioletred: "d87093",
				papayawhip: "ffefd5",
				peachpuff: "ffdab9",
				peru: "cd853f",
				pink: "ffc0cb",
				plum: "dda0dd",
				powderblue: "b0e0e6",
				purple: "800080",
				red: "ff0000",
				rosybrown: "bc8f8f",
				royalblue: "4169e1",
				saddlebrown: "8b4513",
				salmon: "fa8072",
				sandybrown: "f4a460",
				seagreen: "2e8b57",
				seashell: "fff5ee",
				sienna: "a0522d",
				silver: "c0c0c0",
				skyblue: "87ceeb",
				slateblue: "6a5acd",
				slategray: "708090",
				slategrey: "708090",
				snow: "fffafa",
				springgreen: "00ff7f",
				steelblue: "4682b4",
				tan: "d2b48c",
				teal: "008080",
				thistle: "d8bfd8",
				tomato: "ff6347",
				turquoise: "40e0d0",
				violet: "ee82ee",
				violetred: "d02090",
				wheat: "f5deb3",
				white: "ffffff",
				whitesmoke: "f5f5f5",
				yellow: "ffff00",
				yellowgreen: "9acd32"
			}, this.simpleColors) e == t && (e = this.simpleColors[t]);
			this.colorDefs = [
				{
					re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
					example: ["rgb(123, 234, 45)", "rgb(255,234,245)"],
					process: function(e) {
						return [
							parseInt(e[1]),
							parseInt(e[2]),
							parseInt(e[3])
						];
					}
				},
				{
					re: /^rgb\(([0-9.]+)%,\s*([0-9.]+)%,\s*([0-9.]+)%\)$/,
					example: ["rgb(50.5%, 25.75%, 75.5%)", "rgb(100%,0%,0%)"],
					process: function(e) {
						return [
							Math.round(2.55 * parseFloat(e[1])),
							Math.round(2.55 * parseFloat(e[2])),
							Math.round(2.55 * parseFloat(e[3]))
						];
					}
				},
				{
					re: /^(\w{2})(\w{2})(\w{2})$/,
					example: ["#00ff00", "336699"],
					process: function(e) {
						return [
							parseInt(e[1], 16),
							parseInt(e[2], 16),
							parseInt(e[3], 16)
						];
					}
				},
				{
					re: /^(\w{1})(\w{1})(\w{1})$/,
					example: ["#fb0", "f0f"],
					process: function(e) {
						return [
							parseInt(e[1] + e[1], 16),
							parseInt(e[2] + e[2], 16),
							parseInt(e[3] + e[3], 16)
						];
					}
				}
			];
			for (var n = 0; n < this.colorDefs.length; n++) {
				var r = this.colorDefs[n].re, i = this.colorDefs[n].process, a = r.exec(e);
				if (a) {
					var o = i(a);
					this.r = o[0], this.g = o[1], this.b = o[2], this.ok = !0;
				}
			}
			this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b;
		}
	}
	return e.prototype.toRGB = function() {
		return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
	}, e.prototype.toRGBA = function() {
		return "rgba(" + this.r + ", " + this.g + ", " + this.b + ", " + (this.a || "1") + ")";
	}, e.prototype.toHex = function() {
		var e = this.r.toString(16), t = this.g.toString(16), n = this.b.toString(16);
		return e.length == 1 && (e = "0" + e), t.length == 1 && (t = "0" + t), n.length == 1 && (n = "0" + n), "#" + e + t + n;
	}, e.prototype.getHelpXML = function() {
		for (var t = [], n = 0; n < this.colorDefs.length; n++) for (var r = this.colorDefs[n].example, i = 0; i < r.length; i++) t[t.length] = r[i];
		for (var a in this.simpleColors) t[t.length] = a;
		var o = document.createElement("ul");
		for (o.setAttribute("id", "rgbcolor-examples"), n = 0; n < t.length; n++) try {
			var s = document.createElement("li"), c = new e(t[n]), l = document.createElement("div");
			l.style.cssText = "margin: 3px; border: 1px solid black; background:" + c.toHex() + "; color:" + c.toHex(), l.appendChild(document.createTextNode("test"));
			var u = document.createTextNode(" " + t[n] + " -> " + c.toRGB() + " -> " + c.toHex());
			s.appendChild(l), s.appendChild(u), o.appendChild(s);
		} catch {}
		return o;
	}, e;
}(), WS = function() {
	function e(e) {
		this.color = e;
	}
	return e.prototype.getFillData = function(e, t) {
		return VS(this, void 0, void 0, (function() {
			return HS(this, (function(e) {
				return [2, void 0];
			}));
		}));
	}, e;
}(), GS = function() {
	function e() {
		this.xmlSpace = "", this.whiteSpace = "", this.fill = null, this.fillOpacity = 1, this.fontFamily = "", this.fontSize = 16, this.fontStyle = "", this.fontWeight = "", this.opacity = 1, this.stroke = null, this.strokeDasharray = null, this.strokeDashoffset = 0, this.strokeLinecap = "", this.strokeLinejoin = "", this.strokeMiterlimit = 4, this.strokeOpacity = 1, this.strokeWidth = 1, this.alignmentBaseline = "", this.textAnchor = "", this.visibility = "", this.color = null, this.contextFill = null, this.contextStroke = null, this.fillRule = null;
	}
	return e.prototype.clone = function() {
		var t = new e();
		return t.xmlSpace = this.xmlSpace, t.whiteSpace = this.whiteSpace, t.fill = this.fill, t.fillOpacity = this.fillOpacity, t.fontFamily = this.fontFamily, t.fontSize = this.fontSize, t.fontStyle = this.fontStyle, t.fontWeight = this.fontWeight, t.opacity = this.opacity, t.stroke = this.stroke, t.strokeDasharray = this.strokeDasharray, t.strokeDashoffset = this.strokeDashoffset, t.strokeLinecap = this.strokeLinecap, t.strokeLinejoin = this.strokeLinejoin, t.strokeMiterlimit = this.strokeMiterlimit, t.strokeOpacity = this.strokeOpacity, t.strokeWidth = this.strokeWidth, t.textAnchor = this.textAnchor, t.alignmentBaseline = this.alignmentBaseline, t.visibility = this.visibility, t.color = this.color, t.fillRule = this.fillRule, t.contextFill = this.contextFill, t.contextStroke = this.contextStroke, t;
	}, e.default = function() {
		var t = new e();
		return t.xmlSpace = "default", t.whiteSpace = "normal", t.fill = new WS(new US("rgb(0, 0, 0)")), t.fillOpacity = 1, t.fontFamily = "times", t.fontSize = 16, t.fontStyle = "normal", t.fontWeight = "normal", t.opacity = 1, t.stroke = null, t.strokeDasharray = null, t.strokeDashoffset = 0, t.strokeLinecap = "butt", t.strokeLinejoin = "miter", t.strokeMiterlimit = 4, t.strokeOpacity = 1, t.strokeWidth = 1, t.alignmentBaseline = "baseline", t.textAnchor = "start", t.visibility = "visible", t.color = new US("rgb(0, 0, 0)"), t.fillRule = "nonzero", t.contextFill = null, t.contextStroke = null, t;
	}, e.getContextColors = function(e, t) {
		t === void 0 && (t = !1);
		var n = {};
		return e.attributeState.contextFill && (n.contextFill = e.attributeState.contextFill), e.attributeState.contextStroke && (n.contextStroke = e.attributeState.contextStroke), t && e.attributeState.color && (n.color = e.attributeState.color), n;
	}, e;
}(), KS = function() {
	function e(e, t) {
		var n, r;
		this.pdf = e, this.svg2pdfParameters = t.svg2pdfParameters, this.attributeState = t.attributeState ? t.attributeState.clone() : GS.default(), this.viewport = t.viewport, this.refsHandler = t.refsHandler, this.styleSheets = t.styleSheets, this.textMeasure = t.textMeasure, this.transform = t.transform ?? this.pdf.unitMatrix, this.withinClipPath = (n = t.withinClipPath) != null && n, this.withinUse = (r = t.withinUse) != null && r;
	}
	return e.prototype.clone = function(t) {
		return t === void 0 && (t = {}), new e(this.pdf, {
			svg2pdfParameters: this.svg2pdfParameters,
			attributeState: t.attributeState ? t.attributeState.clone() : this.attributeState.clone(),
			viewport: t.viewport ?? this.viewport,
			refsHandler: this.refsHandler,
			styleSheets: this.styleSheets,
			textMeasure: this.textMeasure,
			transform: t.transform ?? this.transform,
			withinClipPath: t.withinClipPath ?? this.withinClipPath,
			withinUse: t.withinUse ?? this.withinUse
		});
	}, e;
}(), qS = function() {
	function e(t) {
		this.renderedElements = {}, this.idMap = t, this.idPrefix = String(e.instanceCounter++);
	}
	return e.prototype.getRendered = function(e, t, n) {
		return VS(this, void 0, void 0, (function() {
			var r, i;
			return HS(this, (function(a) {
				switch (a.label) {
					case 0: return r = this.generateKey(e, t), this.renderedElements.hasOwnProperty(r) ? [2, this.renderedElements[e]] : (i = this.get(e), this.renderedElements[r] = i, [4, n(i)]);
					case 1: return a.sent(), [2, i];
				}
			}));
		}));
	}, e.prototype.get = function(e) {
		return this.idMap[(0, NS.default)(e, { isIdentifier: !0 })];
	}, e.prototype.generateKey = function(e, t) {
		var n = "";
		return t && (n = [
			"color",
			"contextFill",
			"contextStroke"
		].map((function(e) {
			return t[e]?.toRGBA() ?? "";
		})).join("|")), this.idPrefix + "|" + e + "|" + n;
	}, e.instanceCounter = 0, e;
}();
function JS(e, t) {
	return Math.atan2(t[1] - e[1], t[0] - e[0]);
}
var YS = 2 / 3;
function XS(e, t) {
	return [YS * (t[0] - e[0]) + e[0], YS * (t[1] - e[1]) + e[1]];
}
function ZS(e) {
	var t = Math.sqrt(e[0] * e[0] + e[1] * e[1]);
	return [e[0] / t, e[1] / t];
}
function QS(e, t) {
	return ZS([t[0] - e[0], t[1] - e[1]]);
}
function $S(e, t) {
	return [e[0] + t[0], e[1] + t[1]];
}
function eC(e, t) {
	var n = e[0], r = e[1];
	return [t.a * n + t.c * r + t.e, t.b * n + t.d * r + t.f];
}
var tC = function() {
	function e() {
		this.segments = [];
	}
	return e.prototype.moveTo = function(e, t) {
		return this.segments.push(new nC(e, t)), this;
	}, e.prototype.lineTo = function(e, t) {
		return this.segments.push(new rC(e, t)), this;
	}, e.prototype.curveTo = function(e, t, n, r, i, a) {
		return this.segments.push(new iC(e, t, n, r, i, a)), this;
	}, e.prototype.close = function() {
		return this.segments.push(new aC()), this;
	}, e.prototype.transform = function(e) {
		this.segments.forEach((function(t) {
			if (t instanceof nC || t instanceof rC || t instanceof iC) {
				var n = eC([t.x, t.y], e);
				t.x = n[0], t.y = n[1];
			}
			if (t instanceof iC) {
				var r = eC([t.x1, t.y1], e), i = eC([t.x2, t.y2], e);
				t.x1 = r[0], t.y1 = r[1], t.x2 = i[0], t.y2 = i[1];
			}
		}));
	}, e.prototype.draw = function(e) {
		var t = e.pdf;
		this.segments.forEach((function(e) {
			e instanceof nC ? t.moveTo(e.x, e.y) : e instanceof rC ? t.lineTo(e.x, e.y) : e instanceof iC ? t.curveTo(e.x1, e.y1, e.x2, e.y2, e.x, e.y) : t.close();
		}));
	}, e;
}(), nC = function(e, t) {
	this.x = e, this.y = t;
}, rC = function(e, t) {
	this.x = e, this.y = t;
}, iC = function(e, t, n, r, i, a) {
	this.x1 = e, this.y1 = t, this.x2 = n, this.y2 = r, this.x = i, this.y = a;
}, aC = function() {};
function oC(e, t) {
	return t.split(",").indexOf((e.nodeName || e.tagName).toLowerCase()) >= 0;
}
function Q(e, t, n, r) {
	return r === void 0 && (r = n), e.style?.getPropertyValue(r) || t.getPropertyValue(e, r) || e.hasAttribute(n) && e.getAttribute(n) || void 0;
}
function sC(e, t, n) {
	if (Q(e.element, n.styleSheets, "display") === "none") return !1;
	var r = t, i = Q(e.element, n.styleSheets, "visibility");
	return i && (r = i !== "hidden"), r;
}
function cC(e, t, n) {
	var r = sC(e, t, n);
	return e.element.childNodes.length !== 0 && (e.children.forEach((function(e) {
		e.isVisible(r, n) && (r = !0);
	})), r);
}
var lC = function() {
	function e() {
		this.markers = [];
	}
	return e.prototype.addMarker = function(e) {
		this.markers.push(e);
	}, e.prototype.draw = function(e) {
		return VS(this, void 0, void 0, (function() {
			var t, n, r, i, a, o, s, c;
			return HS(this, (function(l) {
				switch (l.label) {
					case 0: t = 0, l.label = 1;
					case 1: return t < this.markers.length ? (n = this.markers[t], r = void 0, i = n.angle, a = n.anchor, o = Math.cos(i), s = Math.sin(i), r = e.pdf.Matrix(o, s, -s, o, a[0], a[1]), r = e.pdf.matrixMult(e.pdf.Matrix(e.attributeState.strokeWidth, 0, 0, e.attributeState.strokeWidth, 0, 0), r), r = e.pdf.matrixMult(r, e.transform), e.pdf.saveGraphicsState(), c = GS.getContextColors(e), [4, e.refsHandler.getRendered(n.id, c, (function(t) {
						return t.apply(e);
					}))]) : [3, 4];
					case 2: l.sent(), e.pdf.doFormObject(e.refsHandler.generateKey(n.id, c), r), e.pdf.restoreGraphicsState(), l.label = 3;
					case 3: return t++, [3, 1];
					case 4: return [2];
				}
			}));
		}));
	}, e;
}(), uC = function(e, t, n, r) {
	r === void 0 && (r = !1), this.id = e, this.anchor = t, this.angle = n, this.isStartMarker = r;
}, dC = /url\(["']?#([^"']+)["']?\)/, fC = {
	bottom: "bottom",
	"text-bottom": "bottom",
	top: "top",
	"text-top": "top",
	hanging: "hanging",
	middle: "middle",
	central: "middle",
	center: "middle",
	mathematical: "middle",
	ideographic: "ideographic",
	alphabetic: "alphabetic",
	baseline: "alphabetic"
}, pC = "http://www.w3.org/2000/svg";
function mC(e, t) {
	var n;
	return (n = e && e.toString().match(/^([\-0-9.]+)em$/)) ? parseFloat(n[1]) * t : (n = e && e.toString().match(/^([\-0-9.]+)(px|)$/)) ? parseFloat(n[1]) : 0;
}
function hC(e) {
	return fC[e] || "alphabetic";
}
function gC(e) {
	for (var t, n = [], r = /[+-]?(?:(?:\d+\.?\d*)|(?:\d*\.?\d+))(?:[eE][+-]?\d+)?/g; t = r.exec(e);) n.push(parseFloat(t[0]));
	return n;
}
function _C(e, t) {
	if (e === "transparent") {
		var n = new US("rgb(0,0,0)");
		return n.a = 0, n;
	}
	if (t && e.toLowerCase() === "currentcolor") return t.color || new US("rgb(0,0,0)");
	if (t && e.toLowerCase() === "context-stroke") return t.contextStroke || new US("rgb(0,0,0)");
	if (t && e.toLowerCase() === "context-fill") return t.contextFill || new US("rgb(0,0,0)");
	var r = /\s*rgba\(((?:[^,\)]*,){3}[^,\)]*)\)\s*/.exec(e);
	if (r) {
		var i = gC(r[1]), a = new US("rgb(" + i.slice(0, 3).join(",") + ")");
		return a.a = i[3], a;
	}
	return new US(e);
}
var vC = {
	"sans-serif": "helvetica",
	verdana: "helvetica",
	arial: "helvetica",
	fixed: "courier",
	monospace: "courier",
	terminal: "courier",
	serif: "times",
	cursive: "times",
	fantasy: "times"
}, yC, bC = (yC = jb.version.split("."), parseFloat(yC[0]) === 2 && parseFloat(yC[1]) === 3);
function xC(e, t) {
	return bC ? t == 400 ? e == "italic" ? "italic" : "normal" : t == 700 && e !== "italic" ? "bold" : e + "" + t : t == 400 || t === "normal" ? e === "italic" ? "italic" : "normal" : t != 700 && t !== "bold" || e !== "normal" ? (t == 700 ? "bold" : t) + "" + e : "bold";
}
function SC(e, t) {
	if (Q(t.element, e.styleSheets, "display") === "none") return [
		0,
		0,
		0,
		0
	];
	var n = [];
	return t.children.forEach((function(t) {
		var r = t.getBoundingBox(e);
		if (r[0] !== 0 || r[1] !== 0 || r[2] !== 0 || r[3] !== 0) {
			var i = t.computeNodeTransform(e);
			r[0] = r[0] * i.sx + i.tx, r[1] = r[1] * i.sy + i.ty, r[2] *= i.sx, r[3] *= i.sy, n = n.length === 0 ? r : [
				Math.min(n[0], r[0]),
				Math.min(n[1], r[1]),
				Math.max(n[0] + n[2], r[0] + r[2]) - Math.min(n[0], r[0]),
				Math.max(n[1] + n[3], r[1] + r[3]) - Math.min(n[1], r[1])
			];
		}
	})), n.length === 0 ? [
		0,
		0,
		0,
		0
	] : n;
}
function CC(e, t) {
	var n = parseFloat, r = n(e.getAttribute("x1")) || n(Q(e, t.styleSheets, "x")) || n(Q(e, t.styleSheets, "cx")) - n(Q(e, t.styleSheets, "r")) || 0, i = n(e.getAttribute("x2")) || r + n(Q(e, t.styleSheets, "width")) || n(Q(e, t.styleSheets, "cx")) + n(Q(e, t.styleSheets, "r")) || 0, a = n(e.getAttribute("y1")) || n(Q(e, t.styleSheets, "y")) || n(Q(e, t.styleSheets, "cy")) - n(Q(e, t.styleSheets, "r")) || 0, o = n(e.getAttribute("y2")) || a + n(Q(e, t.styleSheets, "height")) || n(Q(e, t.styleSheets, "cy")) + n(Q(e, t.styleSheets, "r")) || 0;
	return [
		Math.min(r, i),
		Math.min(a, o),
		Math.max(r, i) - Math.min(r, i),
		Math.max(a, o) - Math.min(a, o)
	];
}
function wC(e, t, n, r, i, a, o, s) {
	s === void 0 && (s = !1);
	var c, l, u = t[0], d = t[1], f = t[2], p = t[3], m = i / f, h = a / p, g = e.getAttribute("preserveAspectRatio");
	if (g) {
		var _ = g.split(" ");
		_[0] === "defer" && (_ = _.slice(1)), c = _[0], l = _[1] || "meet";
	} else c = "xMidYMid", l = "meet";
	if (c !== "none" && (l === "meet" ? m = h = Math.min(m, h) : l === "slice" && (m = h = Math.max(m, h))), s) return o.pdf.Matrix(m, 0, 0, h, 0, 0);
	var v = n - u * m, y = r - d * h;
	c.indexOf("xMid") >= 0 ? v += (i - f * m) / 2 : c.indexOf("xMax") >= 0 && (v += i - f * m), c.indexOf("YMid") >= 0 ? y += (a - p * h) / 2 : c.indexOf("YMax") >= 0 && (y += a - p * h);
	var b = o.pdf.Matrix(1, 0, 0, 1, v, y), x = o.pdf.Matrix(m, 0, 0, h, 0, 0);
	return o.pdf.matrixMult(x, b);
}
function TC(e, t) {
	if (!e || e === "none") return t.pdf.unitMatrix;
	for (var n, r, i = /^[\s,]*matrix\(([^)]+)\)\s*/, a = /^[\s,]*translate\(([^)]+)\)\s*/, o = /^[\s,]*rotate\(([^)]+)\)\s*/, s = /^[\s,]*scale\(([^)]+)\)\s*/, c = /^[\s,]*skewX\(([^)]+)\)\s*/, l = /^[\s,]*skewY\(([^)]+)\)\s*/, u = t.pdf.unitMatrix; e.length > 0 && e.length !== r;) {
		r = e.length;
		var d = i.exec(e);
		if (d && (n = gC(d[1]), u = t.pdf.matrixMult(t.pdf.Matrix(n[0], n[1], n[2], n[3], n[4], n[5]), u), e = e.substr(d[0].length)), d = o.exec(e)) {
			n = gC(d[1]);
			var f = Math.PI * n[0] / 180;
			if (u = t.pdf.matrixMult(t.pdf.Matrix(Math.cos(f), Math.sin(f), -Math.sin(f), Math.cos(f), 0, 0), u), n[1] || n[2]) {
				var p = t.pdf.Matrix(1, 0, 0, 1, n[1], n[2]), m = t.pdf.Matrix(1, 0, 0, 1, -n[1], -n[2]);
				u = t.pdf.matrixMult(m, t.pdf.matrixMult(u, p));
			}
			e = e.substr(d[0].length);
		}
		(d = a.exec(e)) && (n = gC(d[1]), u = t.pdf.matrixMult(t.pdf.Matrix(1, 0, 0, 1, n[0], n[1] || 0), u), e = e.substr(d[0].length)), (d = s.exec(e)) && ((n = gC(d[1]))[1] || (n[1] = n[0]), u = t.pdf.matrixMult(t.pdf.Matrix(n[0], 0, 0, n[1], 0, 0), u), e = e.substr(d[0].length)), (d = c.exec(e)) && (n = parseFloat(d[1]), n *= Math.PI / 180, u = t.pdf.matrixMult(t.pdf.Matrix(1, 0, Math.tan(n), 1, 0, 0), u), e = e.substr(d[0].length)), (d = l.exec(e)) && (n = parseFloat(d[1]), n *= Math.PI / 180, u = t.pdf.matrixMult(t.pdf.Matrix(1, Math.tan(n), 0, 1, 0, 0), u), e = e.substr(d[0].length));
	}
	return u;
}
var EC = function() {
	function e(e, t) {
		this.element = e, this.children = t, this.parent = null;
	}
	return e.prototype.setParent = function(e) {
		this.parent = e;
	}, e.prototype.getParent = function() {
		return this.parent;
	}, e.prototype.getBoundingBox = function(e) {
		return Q(this.element, e.styleSheets, "display") === "none" ? [
			0,
			0,
			0,
			0
		] : this.getBoundingBoxCore(e);
	}, e.prototype.computeNodeTransform = function(e) {
		var t = this.computeNodeTransformCore(e), n = Q(this.element, e.styleSheets, "transform");
		return n ? e.pdf.matrixMult(t, TC(n, e)) : t;
	}, e;
}(), DC = function(e) {
	function t() {
		return e !== null && e.apply(this, arguments) || this;
	}
	return zS(t, e), t.prototype.render = function(e) {
		return Promise.resolve();
	}, t.prototype.getBoundingBoxCore = function(e) {
		return [];
	}, t.prototype.computeNodeTransformCore = function(e) {
		return e.pdf.unitMatrix;
	}, t;
}(EC), OC = function(e) {
	function t(t, n, r) {
		var i = e.call(this, n, r) || this;
		return i.pdfGradientType = t, i.contextColor = void 0, i;
	}
	return zS(t, e), t.prototype.apply = function(e) {
		return VS(this, void 0, void 0, (function() {
			var t, n, r, i, a, o;
			return HS(this, (function(s) {
				return (t = this.element.getAttribute("id")) ? (n = this.getStops(e.styleSheets), r = 0, i = !1, n.forEach((function(e) {
					var t = e.opacity;
					t && t !== 1 && (r += t, i = !0);
				})), i && (a = new Db({ opacity: r / n.length })), o = new kb(this.pdfGradientType, this.getCoordinates(), n, a), e.pdf.addShadingPattern(t, o), [2]) : [2];
			}));
		}));
	}, t.prototype.getStops = function(e) {
		var n = this;
		if (this.stops) return this.stops;
		if (this.contextColor === void 0) {
			this.contextColor = null;
			for (var r = this; r;) {
				var i = Q(r.element, e, "color");
				if (i) {
					this.contextColor = _C(i, null);
					break;
				}
				r = r.getParent();
			}
		}
		var a = [];
		return this.children.forEach((function(r) {
			if (r.element.tagName.toLowerCase() === "stop") {
				var i = Q(r.element, e, "color"), o = _C(Q(r.element, e, "stop-color") || "", i ? { color: _C(i, null) } : { color: n.contextColor }), s = parseFloat(Q(r.element, e, "stop-opacity") || "1");
				a.push({
					offset: t.parseGradientOffset(r.element.getAttribute("offset") || "0"),
					color: [
						o.r,
						o.g,
						o.b
					],
					opacity: s
				});
			}
		})), this.stops = a;
	}, t.prototype.getBoundingBoxCore = function(e) {
		return CC(this.element, e);
	}, t.prototype.computeNodeTransformCore = function(e) {
		return e.pdf.unitMatrix;
	}, t.prototype.isVisible = function(e, t) {
		return cC(this, e, t);
	}, t.parseGradientOffset = function(e) {
		var t = parseFloat(e);
		return !isNaN(t) && e.indexOf("%") >= 0 ? t / 100 : t;
	}, t;
}(DC), kC = function(e) {
	function t(t, n) {
		return e.call(this, "axial", t, n) || this;
	}
	return zS(t, e), t.prototype.getCoordinates = function() {
		return [
			parseFloat(this.element.getAttribute("x1") || "0"),
			parseFloat(this.element.getAttribute("y1") || "0"),
			parseFloat(this.element.getAttribute("x2") || "1"),
			parseFloat(this.element.getAttribute("y2") || "0")
		];
	}, t;
}(OC), AC = function(e) {
	function t(t, n) {
		return e.call(this, "radial", t, n) || this;
	}
	return zS(t, e), t.prototype.getCoordinates = function() {
		var e = this.element.getAttribute("cx"), t = this.element.getAttribute("cy"), n = this.element.getAttribute("fx"), r = this.element.getAttribute("fy");
		return [
			parseFloat(n || e || "0.5"),
			parseFloat(r || t || "0.5"),
			0,
			parseFloat(e || "0.5"),
			parseFloat(t || "0.5"),
			parseFloat(this.element.getAttribute("r") || "0.5")
		];
	}, t;
}(OC), jC = function() {
	function e(e, t) {
		this.key = e, this.gradient = t;
	}
	return e.prototype.getFillData = function(e, t) {
		return VS(this, void 0, void 0, (function() {
			var n, r, i;
			return HS(this, (function(a) {
				switch (a.label) {
					case 0: return [4, t.refsHandler.getRendered(this.key, null, (function(e) {
						return e.apply(new KS(t.pdf, {
							refsHandler: t.refsHandler,
							textMeasure: t.textMeasure,
							styleSheets: t.styleSheets,
							viewport: t.viewport,
							svg2pdfParameters: t.svg2pdfParameters
						}));
					}))];
					case 1: return a.sent(), this.gradient.element.hasAttribute("gradientUnits") && this.gradient.element.getAttribute("gradientUnits").toLowerCase() !== "objectboundingbox" ? n = t.pdf.unitMatrix : (r = e.getBoundingBox(t), n = t.pdf.Matrix(r[2], 0, 0, r[3], r[0], r[1])), i = TC(Q(this.gradient.element, t.styleSheets, "gradientTransform", "transform"), t), [2, {
						key: this.key,
						matrix: t.pdf.matrixMult(i, n)
					}];
				}
			}));
		}));
	}, e;
}(), MC = function(e) {
	function t() {
		return e !== null && e.apply(this, arguments) || this;
	}
	return zS(t, e), t.prototype.apply = function(e) {
		return VS(this, void 0, void 0, (function() {
			var t, n, r, i, a;
			return HS(this, (function(o) {
				switch (o.label) {
					case 0:
						if (!(t = this.element.getAttribute("id"))) return [2];
						n = this.getBoundingBox(e), r = new Ab([
							n[0],
							n[1],
							n[0] + n[2],
							n[1] + n[3]
						], n[2], n[3]), e.pdf.beginTilingPattern(r), i = 0, a = this.children, o.label = 1;
					case 1: return i < a.length ? [4, a[i].render(new KS(e.pdf, {
						attributeState: e.attributeState,
						refsHandler: e.refsHandler,
						styleSheets: e.styleSheets,
						viewport: e.viewport,
						svg2pdfParameters: e.svg2pdfParameters,
						textMeasure: e.textMeasure
					}))] : [3, 4];
					case 2: o.sent(), o.label = 3;
					case 3: return i++, [3, 1];
					case 4: return e.pdf.endTilingPattern(t, r), [2];
				}
			}));
		}));
	}, t.prototype.getBoundingBoxCore = function(e) {
		return CC(this.element, e);
	}, t.prototype.computeNodeTransformCore = function(e) {
		return e.pdf.unitMatrix;
	}, t.prototype.isVisible = function(e, t) {
		return cC(this, e, t);
	}, t;
}(DC), NC = function() {
	function e(e, t) {
		this.key = e, this.pattern = t;
	}
	return e.prototype.getFillData = function(e, t) {
		return VS(this, void 0, void 0, (function() {
			var n, r, i, a, o, s, c, l, u, d, f, p;
			return HS(this, (function(m) {
				switch (m.label) {
					case 0: return [4, t.refsHandler.getRendered(this.key, null, (function(e) {
						return e.apply(new KS(t.pdf, {
							refsHandler: t.refsHandler,
							textMeasure: t.textMeasure,
							styleSheets: t.styleSheets,
							viewport: t.viewport,
							svg2pdfParameters: t.svg2pdfParameters
						}));
					}))];
					case 1: return m.sent(), n = {
						key: this.key,
						boundingBox: void 0,
						xStep: 0,
						yStep: 0,
						matrix: void 0
					}, i = t.pdf.unitMatrix, this.pattern.element.hasAttribute("patternUnits") && this.pattern.element.getAttribute("patternUnits").toLowerCase() !== "objectboundingbox" || (r = e.getBoundingBox(t), i = t.pdf.Matrix(1, 0, 0, 1, r[0], r[1]), o = this.pattern.getBoundingBox(t), s = o[0] * r[0] || 0, c = o[1] * r[1] || 0, l = o[2] * r[2] || 0, u = o[3] * r[3] || 0, n.boundingBox = [
						s,
						c,
						s + l,
						c + u
					], n.xStep = l, n.yStep = u), a = t.pdf.unitMatrix, this.pattern.element.hasAttribute("patternContentUnits") && this.pattern.element.getAttribute("patternContentUnits").toLowerCase() === "objectboundingbox" && (r ||= e.getBoundingBox(t), a = t.pdf.Matrix(r[2], 0, 0, r[3], 0, 0), o = n.boundingBox || this.pattern.getBoundingBox(t), s = o[0] / r[0] || 0, c = o[1] / r[1] || 0, l = o[2] / r[2] || 0, u = o[3] / r[3] || 0, n.boundingBox = [
						s,
						c,
						s + l,
						c + u
					], n.xStep = l, n.yStep = u), d = t.pdf.unitMatrix, (f = Q(this.pattern.element, t.styleSheets, "patternTransform", "transform")) && (d = TC(f, t)), p = a, p = t.pdf.matrixMult(p, i), p = t.pdf.matrixMult(p, d), p = t.pdf.matrixMult(p, t.transform), n.matrix = p, [2, n];
				}
			}));
		}));
	}, e;
}();
function PC(e, t) {
	var n = dC.exec(e);
	if (n) {
		var r = n[1], i = t.refsHandler.get(r);
		return i && (i instanceof kC || i instanceof AC) ? function(e, t, n) {
			var r = t.getStops(n.styleSheets);
			if (r.length === 0) return null;
			if (r.length === 1) {
				var i = r[0].color, a = new US();
				return a.ok = !0, a.r = i[0], a.g = i[1], a.b = i[2], a.a = r[0].opacity, new WS(a);
			}
			return new jC(e, t);
		}(r, i, t) : i && i instanceof MC ? new NC(r, i) : new WS(new US("rgb(0, 0, 0)"));
	}
	var a = _C(e, t.attributeState);
	return a.ok ? new WS(a) : null;
}
function FC(e, t, n) {
	var r = n || t.element, i = Q(r, e.styleSheets, "color");
	if (i) {
		var a = _C(i, e.attributeState);
		a.ok ? e.attributeState.color = a : e.attributeState.color = new US("rgb(0,0,0)");
	}
	var o = Q(r, e.styleSheets, "visibility");
	o && (e.attributeState.visibility = o);
	var s = Q(r, e.styleSheets, "fill");
	s && (e.attributeState.fill = PC(s, e));
	var c = Q(r, e.styleSheets, "fill-opacity");
	c && (e.attributeState.fillOpacity = parseFloat(c));
	var l = Q(r, e.styleSheets, "stroke-opacity");
	l && (e.attributeState.strokeOpacity = parseFloat(l));
	var u = Q(r, e.styleSheets, "opacity");
	u && (e.attributeState.opacity = parseFloat(u));
	var d = Q(r, e.styleSheets, "stroke-width");
	d !== void 0 && d !== "" && (e.attributeState.strokeWidth = Math.abs(parseFloat(d)));
	var f = Q(r, e.styleSheets, "stroke");
	if (f) if (f === "none") e.attributeState.stroke = null;
	else {
		var p = _C(f, e.attributeState);
		p.ok && (e.attributeState.stroke = new WS(p));
	}
	f && e.attributeState.stroke instanceof WS && (e.attributeState.contextStroke = e.attributeState.stroke.color), s && e.attributeState.fill instanceof WS && (e.attributeState.contextFill = e.attributeState.fill.color);
	var m = Q(r, e.styleSheets, "stroke-linecap");
	m && (e.attributeState.strokeLinecap = m);
	var h = Q(r, e.styleSheets, "stroke-linejoin");
	h && (e.attributeState.strokeLinejoin = h);
	var g = Q(r, e.styleSheets, "stroke-dasharray");
	if (g) {
		var _ = parseInt(Q(r, e.styleSheets, "stroke-dashoffset") || "0");
		e.attributeState.strokeDasharray = gC(g), e.attributeState.strokeDashoffset = _;
	}
	var v = Q(r, e.styleSheets, "stroke-miterlimit");
	v !== void 0 && v !== "" && (e.attributeState.strokeMiterlimit = parseFloat(v));
	var y = r.getAttribute("xml:space");
	y && (e.attributeState.xmlSpace = y);
	var b = Q(r, e.styleSheets, "white-space");
	b && (e.attributeState.whiteSpace = b);
	var x = Q(r, e.styleSheets, "font-weight");
	x && (e.attributeState.fontWeight = x);
	var S = Q(r, e.styleSheets, "font-style");
	S && (e.attributeState.fontStyle = S);
	var C = Q(r, e.styleSheets, "font-family");
	if (C) {
		var w = PS.default.parse(C);
		e.attributeState.fontFamily = function(e, t, n) {
			var r = xC(e.fontStyle, e.fontWeight), i = n.pdf.getFontList(), a = "";
			return t.some((function(e) {
				var t = i[e];
				return t && t.indexOf(r) >= 0 ? (a = e, !0) : (e = e.toLowerCase(), !!vC.hasOwnProperty(e) && (a = e, !0));
			})) || (a = "times"), a;
		}(e.attributeState, w, e);
	}
	var T = Q(r, e.styleSheets, "font-size");
	if (T) {
		var E = e.pdf.getFontSize();
		e.attributeState.fontSize = mC(T, E);
	}
	var D = Q(r, e.styleSheets, "vertical-align") || Q(r, e.styleSheets, "alignment-baseline");
	if (D) {
		var O = D.match(/(baseline|text-bottom|alphabetic|ideographic|middle|central|mathematical|text-top|bottom|center|top|hanging)/);
		O && (e.attributeState.alignmentBaseline = O[0]);
	}
	var k = Q(r, e.styleSheets, "text-anchor");
	k && (e.attributeState.textAnchor = k);
	var A = Q(r, e.styleSheets, "fill-rule");
	A && (e.attributeState.fillRule = A);
}
function IC(e, t, n) {
	var r = 1, i = 1;
	r *= e.attributeState.fillOpacity, r *= e.attributeState.opacity, e.attributeState.fill instanceof WS && e.attributeState.fill.color.a !== void 0 && (r *= e.attributeState.fill.color.a), i *= e.attributeState.strokeOpacity, i *= e.attributeState.opacity, e.attributeState.stroke instanceof WS && e.attributeState.stroke.color.a !== void 0 && (i *= e.attributeState.stroke.color.a);
	var a, o, s = r < 1, c = i < 1;
	if (oC(n, "use") ? (s = !0, c = !0, r *= +!!e.attributeState.fill, i *= +!!e.attributeState.stroke) : e.withinUse && (e.attributeState.fill === t.attributeState.fill ? s && !e.attributeState.fill && (r = 0) : (s = !0, r *= +!!e.attributeState.fill), e.attributeState.stroke === t.attributeState.stroke ? c && !e.attributeState.stroke && (i = 0) : (c = !0, i *= +!!e.attributeState.stroke)), s || c) {
		var l = {};
		s && (l.opacity = r), c && (l["stroke-opacity"] = i), e.pdf.setGState(new Db(l));
	}
	if (e.attributeState.fill && e.attributeState.fill !== t.attributeState.fill && e.attributeState.fill instanceof WS && e.attributeState.fill.color.ok && !oC(n, "text") && e.pdf.setFillColor(e.attributeState.fill.color.r, e.attributeState.fill.color.g, e.attributeState.fill.color.b), e.attributeState.strokeWidth !== t.attributeState.strokeWidth && e.pdf.setLineWidth(e.attributeState.strokeWidth), e.attributeState.stroke !== t.attributeState.stroke && e.attributeState.stroke instanceof WS && e.pdf.setDrawColor(e.attributeState.stroke.color.r, e.attributeState.stroke.color.g, e.attributeState.stroke.color.b), e.attributeState.strokeLinecap !== t.attributeState.strokeLinecap && e.pdf.setLineCap(e.attributeState.strokeLinecap), e.attributeState.strokeLinejoin !== t.attributeState.strokeLinejoin && e.pdf.setLineJoin(e.attributeState.strokeLinejoin), e.attributeState.strokeDasharray === t.attributeState.strokeDasharray && e.attributeState.strokeDashoffset === t.attributeState.strokeDashoffset || !e.attributeState.strokeDasharray || e.pdf.setLineDashPattern(e.attributeState.strokeDasharray, e.attributeState.strokeDashoffset), e.attributeState.strokeMiterlimit !== t.attributeState.strokeMiterlimit && e.pdf.setLineMiterLimit(e.attributeState.strokeMiterlimit), e.attributeState.fontFamily !== t.attributeState.fontFamily && (a = vC.hasOwnProperty(e.attributeState.fontFamily) ? vC[e.attributeState.fontFamily] : e.attributeState.fontFamily), e.attributeState.fill && e.attributeState.fill !== t.attributeState.fill && e.attributeState.fill instanceof WS && e.attributeState.fill.color.ok) {
		var u = e.attributeState.fill.color;
		e.pdf.setTextColor(u.r, u.g, u.b);
	}
	e.attributeState.fontWeight === t.attributeState.fontWeight && e.attributeState.fontStyle === t.attributeState.fontStyle || (o = xC(e.attributeState.fontStyle, e.attributeState.fontWeight)), a === void 0 && o === void 0 || (a === void 0 && (a = vC.hasOwnProperty(e.attributeState.fontFamily) ? vC[e.attributeState.fontFamily] : e.attributeState.fontFamily), e.pdf.setFont(a, o)), e.attributeState.fontSize !== t.attributeState.fontSize && e.pdf.setFontSize(e.attributeState.fontSize * e.pdf.internal.scaleFactor);
}
function LC(e, t, n) {
	var r = dC.exec(e);
	if (r) {
		var i = r[1];
		return n.refsHandler.get(i) || void 0;
	}
}
function RC(e, t, n) {
	return VS(this, void 0, void 0, (function() {
		var r, i;
		return HS(this, (function(a) {
			switch (a.label) {
				case 0: return r = n.clone(), t.element.hasAttribute("clipPathUnits") && t.element.getAttribute("clipPathUnits").toLowerCase() === "objectboundingbox" && (i = e.getBoundingBox(n), r.transform = n.pdf.matrixMult(n.pdf.Matrix(i[2], 0, 0, i[3], i[0], i[1]), n.transform)), [4, t.apply(r)];
				case 1: return a.sent(), [2];
			}
		}));
	}));
}
var zC = function(e) {
	function t() {
		return e !== null && e.apply(this, arguments) || this;
	}
	return zS(t, e), t.prototype.render = function(e) {
		return VS(this, void 0, void 0, (function() {
			var t, n, r, i;
			return HS(this, (function(a) {
				switch (a.label) {
					case 0: return this.isVisible(e.attributeState.visibility !== "hidden", e) ? ((t = e.clone()).transform = t.pdf.matrixMult(this.computeNodeTransform(t), e.transform), FC(t, this), n = Q(this.element, t.styleSheets, "clip-path"), (r = n && n !== "none") ? (i = LC(n, 0, t)) ? i.isVisible(!0, t) ? (t.pdf.saveGraphicsState(), [4, RC(this, i, t)]) : [3, 2] : [3, 4] : [3, 5]) : [2];
					case 1: return a.sent(), [3, 3];
					case 2: return [2];
					case 3: return [3, 5];
					case 4: r = !1, a.label = 5;
					case 5: return t.withinClipPath || t.pdf.saveGraphicsState(), IC(t, e, this.element), [4, this.renderCore(t)];
					case 6: return a.sent(), t.withinClipPath || t.pdf.restoreGraphicsState(), r && t.pdf.restoreGraphicsState(), [2];
				}
			}));
		}));
	}, t;
}(EC), BC = function(e) {
	function t() {
		return e !== null && e.apply(this, arguments) || this;
	}
	return zS(t, e), t;
}(zC), VC = function(e) {
	function t(t, n, r) {
		var i = e.call(this, n, r) || this;
		return i.cachedPath = null, i.hasMarkers = t, i;
	}
	return zS(t, e), t.prototype.renderCore = function(e) {
		return VS(this, void 0, void 0, (function() {
			var t;
			return HS(this, (function(n) {
				switch (n.label) {
					case 0: return (t = this.getCachedPath(e)) === null || t.segments.length === 0 ? [2] : (e.withinClipPath ? t.transform(e.transform) : e.pdf.setCurrentTransformationMatrix(e.transform), t.draw(e), [4, this.fillOrStroke(e)]);
					case 1: return n.sent(), this.hasMarkers ? [4, this.drawMarkers(e, t)] : [3, 3];
					case 2: n.sent(), n.label = 3;
					case 3: return [2];
				}
			}));
		}));
	}, t.prototype.getCachedPath = function(e) {
		return this.cachedPath ||= this.getPath(e);
	}, t.prototype.drawMarkers = function(e, t) {
		return VS(this, void 0, void 0, (function() {
			return HS(this, (function(n) {
				switch (n.label) {
					case 0: return [4, this.getMarkers(t, e).draw(e.clone({ transform: e.pdf.unitMatrix }))];
					case 1: return n.sent(), [2];
				}
			}));
		}));
	}, t.prototype.fillOrStroke = function(e) {
		return VS(this, void 0, void 0, (function() {
			var t, n, r, i, a;
			return HS(this, (function(o) {
				switch (o.label) {
					case 0: return e.withinClipPath ? [2] : (t = e.attributeState.fill, n = e.attributeState.stroke && e.attributeState.strokeWidth !== 0, t ? [4, t.getFillData(this, e)] : [3, 2]);
					case 1: return i = o.sent(), [3, 3];
					case 2: i = void 0, o.label = 3;
					case 3: return r = i, a = e.attributeState.fillRule === "evenodd", t && n || e.withinUse ? a ? e.pdf.fillStrokeEvenOdd(r) : e.pdf.fillStroke(r) : t ? a ? e.pdf.fillEvenOdd(r) : e.pdf.fill(r) : n ? e.pdf.stroke() : e.pdf.discardPath(), [2];
				}
			}));
		}));
	}, t.prototype.getBoundingBoxCore = function(e) {
		var t = this.getCachedPath(e);
		if (!t || !t.segments.length) return [
			0,
			0,
			0,
			0
		];
		for (var n = Infinity, r = Infinity, i = -Infinity, a = -Infinity, o = 0, s = 0, c = 0; c < t.segments.length; c++) {
			var l = t.segments[c];
			(l instanceof nC || l instanceof rC || l instanceof iC) && (o = l.x, s = l.y), l instanceof iC ? (n = Math.min(n, o, l.x1, l.x2, l.x), i = Math.max(i, o, l.x1, l.x2, l.x), r = Math.min(r, s, l.y1, l.y2, l.y), a = Math.max(a, s, l.y1, l.y2, l.y)) : (n = Math.min(n, o), i = Math.max(i, o), r = Math.min(r, s), a = Math.max(a, s));
		}
		return [
			n,
			r,
			i - n,
			a - r
		];
	}, t.prototype.getMarkers = function(e, t) {
		var n = Q(this.element, t.styleSheets, "marker-start"), r = Q(this.element, t.styleSheets, "marker-mid"), i = Q(this.element, t.styleSheets, "marker-end"), a = new lC();
		if (n || r || i) {
			i &&= HC(i), n &&= HC(n), r &&= HC(r);
			for (var o = e.segments, s = [1, 0], c = void 0, l = !1, u = [1, 0], d = !1, f = function(e) {
				var t = o[e], f = n && (e === 1 || !(o[e] instanceof nC) && o[e - 1] instanceof nC);
				f && o.forEach((function(t, n) {
					if (!d && t instanceof aC && n > e) {
						var r = o[n - 1];
						d = (r instanceof nC || r instanceof rC || r instanceof iC) && r;
					}
				}));
				var p = i && (e === o.length - 1 || !(o[e] instanceof nC) && o[e + 1] instanceof nC), m = r && e > 0 && !(e === 1 && o[e - 1] instanceof nC), h = o[e - 1] || null;
				if (h instanceof nC || h instanceof rC || h instanceof iC) if (t instanceof iC) f && a.addMarker(new uC(n, [h.x, h.y], JS(d ? [d.x, d.y] : [h.x, h.y], [t.x1, t.y1]), !0)), p && a.addMarker(new uC(i, [t.x, t.y], JS([t.x2, t.y2], [t.x, t.y]))), m && (c = QS([h.x, h.y], [t.x1, t.y1]), c = h instanceof nC ? c : ZS($S(s, c)), a.addMarker(new uC(r, [h.x, h.y], Math.atan2(c[1], c[0])))), s = QS([t.x2, t.y2], [t.x, t.y]);
				else if (t instanceof nC || t instanceof rC) {
					if (c = QS([h.x, h.y], [t.x, t.y]), f) {
						var g = d ? QS([d.x, d.y], [t.x, t.y]) : c;
						a.addMarker(new uC(n, [h.x, h.y], Math.atan2(g[1], g[0]), !0));
					}
					p && a.addMarker(new uC(i, [t.x, t.y], Math.atan2(c[1], c[0]))), m && (g = t instanceof nC ? s : h instanceof nC ? c : ZS($S(s, c)), a.addMarker(new uC(r, [h.x, h.y], Math.atan2(g[1], g[0])))), s = c;
				} else t instanceof aC && (c = QS([h.x, h.y], [l.x, l.y]), m && (g = h instanceof nC ? c : ZS($S(s, c)), a.addMarker(new uC(r, [h.x, h.y], Math.atan2(g[1], g[0])))), p && (g = ZS($S(c, u)), a.addMarker(new uC(i, [l.x, l.y], Math.atan2(g[1], g[0])))), s = c);
				else {
					l = t instanceof nC && t;
					var _ = o[e + 1];
					(_ instanceof nC || _ instanceof rC || _ instanceof iC) && (u = QS([l.x, l.y], [_.x, _.y]));
				}
			}, p = 0; p < o.length; p++) f(p);
		}
		return a.markers.forEach((function(e) {
			var n = t.refsHandler.get(e.id);
			if (n) {
				var r = Q(n.element, t.styleSheets, "orient");
				r != null && (e.isStartMarker && r === "auto-start-reverse" && (e.angle += Math.PI), isNaN(Number(r)) || (e.angle = parseFloat(r) / 180 * Math.PI));
			}
		})), a;
	}, t;
}(BC);
function HC(e) {
	var t = dC.exec(e);
	return t && t[1] || void 0;
}
var UC = function(e) {
	function t(t, n) {
		return e.call(this, !0, t, n) || this;
	}
	return zS(t, e), t.prototype.getPath = function(e) {
		if (e.withinClipPath || e.attributeState.stroke === null) return null;
		var t = parseFloat(this.element.getAttribute("x1") || "0"), n = parseFloat(this.element.getAttribute("y1") || "0"), r = parseFloat(this.element.getAttribute("x2") || "0"), i = parseFloat(this.element.getAttribute("y2") || "0");
		return t || r || n || i ? new tC().moveTo(t, n).lineTo(r, i) : null;
	}, t.prototype.computeNodeTransformCore = function(e) {
		return e.pdf.unitMatrix;
	}, t.prototype.isVisible = function(e, t) {
		return sC(this, e, t);
	}, t.prototype.fillOrStroke = function(t) {
		return VS(this, void 0, void 0, (function() {
			return HS(this, (function(n) {
				switch (n.label) {
					case 0: return t.attributeState.fill = null, [4, e.prototype.fillOrStroke.call(this, t)];
					case 1: return n.sent(), [2];
				}
			}));
		}));
	}, t;
}(VC), WC = function(e) {
	function t() {
		return e !== null && e.apply(this, arguments) || this;
	}
	return zS(t, e), t.prototype.apply = function(e) {
		return VS(this, void 0, void 0, (function() {
			var t, n, r, i, a;
			return HS(this, (function(o) {
				switch (o.label) {
					case 0: return this.isVisible(e.attributeState.visibility !== "hidden", e) ? ((t = e.clone()).transform = t.pdf.unitMatrix, FC(t, this), n = Q(this.element, t.styleSheets, "clip-path"), n && n !== "none" && (r = LC(n, 0, t)) ? r.isVisible(!0, t) ? [4, RC(this, r, t)] : [3, 2] : [3, 3]) : [2];
					case 1: return o.sent(), [3, 3];
					case 2: return [2];
					case 3: IC(t, e, this.element), i = 0, a = this.children, o.label = 4;
					case 4: return i < a.length ? [4, a[i].render(t)] : [3, 7];
					case 5: o.sent(), o.label = 6;
					case 6: return i++, [3, 4];
					case 7: return [2];
				}
			}));
		}));
	}, t.prototype.getBoundingBoxCore = function(e) {
		return SC(e, this);
	}, t.prototype.isVisible = function(e, t) {
		return cC(this, e, t);
	}, t.prototype.computeNodeTransformCore = function(e) {
		var t = parseFloat(Q(this.element, e.styleSheets, "x") || "0"), n = parseFloat(Q(this.element, e.styleSheets, "y") || "0"), r = this.element.getAttribute("viewBox");
		if (r) {
			var i = gC(r), a = parseFloat(Q(this.element, e.styleSheets, "width") || Q(this.element.ownerSVGElement, e.styleSheets, "width") || r[2]), o = parseFloat(Q(this.element, e.styleSheets, "height") || Q(this.element.ownerSVGElement, e.styleSheets, "height") || r[3]);
			return wC(this.element, i, t, n, a, o, e);
		}
		return e.pdf.Matrix(1, 0, 0, 1, t, n);
	}, t;
}(DC), GC = function(e, t) {
	this.width = e, this.height = t;
}, KC = function(e) {
	function t() {
		return e !== null && e.apply(this, arguments) || this;
	}
	return zS(t, e), t.prototype.renderCore = function(e) {
		return VS(this, void 0, void 0, (function() {
			var n, r, i, a, o, s, c, l, u, d, f, p, m;
			return HS(this, (function(h) {
				switch (h.label) {
					case 0: return n = parseFloat, (r = this.element.getAttribute("href") || this.element.getAttribute("xlink:href")) ? (i = r.substring(1), a = e.refsHandler.get(i), o = oC(a.element, "symbol,svg") && a.element.hasAttribute("viewBox"), s = n(Q(this.element, e.styleSheets, "x") || "0"), c = n(Q(this.element, e.styleSheets, "y") || "0"), l = void 0, u = void 0, o ? (l = n(Q(this.element, e.styleSheets, "width") || Q(a.element, e.styleSheets, "width") || "0"), u = n(Q(this.element, e.styleSheets, "height") || Q(a.element, e.styleSheets, "height") || "0"), s += n(Q(a.element, e.styleSheets, "x") || "0"), c += n(Q(a.element, e.styleSheets, "y") || "0"), f = gC(a.element.getAttribute("viewBox")), d = wC(a.element, f, s, c, l, u, e)) : d = e.pdf.Matrix(1, 0, 0, 1, s, c), p = GS.getContextColors(e, !0), m = new KS(e.pdf, {
						refsHandler: e.refsHandler,
						styleSheets: e.styleSheets,
						withinUse: !0,
						viewport: o ? new GC(l, u) : e.viewport,
						svg2pdfParameters: e.svg2pdfParameters,
						textMeasure: e.textMeasure,
						attributeState: Object.assign(GS.default(), p)
					}), [4, e.refsHandler.getRendered(i, p, (function(e) {
						return t.renderReferencedNode(e, i, m);
					}))]) : [2];
					case 1: return h.sent(), e.pdf.saveGraphicsState(), e.pdf.setCurrentTransformationMatrix(e.transform), o && Q(a.element, e.styleSheets, "overflow") !== "visible" && (e.pdf.rect(s, c, l, u), e.pdf.clip().discardPath()), e.pdf.doFormObject(e.refsHandler.generateKey(i, p), d), e.pdf.restoreGraphicsState(), [2];
				}
			}));
		}));
	}, t.renderReferencedNode = function(e, t, n) {
		return VS(this, void 0, void 0, (function() {
			var r;
			return HS(this, (function(i) {
				switch (i.label) {
					case 0: return r = [
						(r = e.getBoundingBox(n))[0] - .5 * r[2],
						r[1] - .5 * r[3],
						2 * r[2],
						2 * r[3]
					], n.pdf.beginFormObject(r[0], r[1], r[2], r[3], n.pdf.unitMatrix), e instanceof WC ? [4, e.apply(n)] : [3, 2];
					case 1: return i.sent(), [3, 4];
					case 2: return [4, e.render(n)];
					case 3: i.sent(), i.label = 4;
					case 4: return n.pdf.endFormObject(n.refsHandler.generateKey(t, n.attributeState)), [2];
				}
			}));
		}));
	}, t.prototype.getBoundingBoxCore = function(e) {
		return CC(this.element, e);
	}, t.prototype.isVisible = function(e, t) {
		return sC(this, e, t);
	}, t.prototype.computeNodeTransformCore = function(e) {
		return e.pdf.unitMatrix;
	}, t;
}(BC), qC = function(e) {
	function t(t, n) {
		return e.call(this, !1, t, n) || this;
	}
	return zS(t, e), t.prototype.getPath = function(e) {
		var t = parseFloat(Q(this.element, e.styleSheets, "width") || "0"), n = parseFloat(Q(this.element, e.styleSheets, "height") || "0");
		if (!isFinite(t) || t <= 0 || !isFinite(n) || n <= 0) return null;
		var r = Q(this.element, e.styleSheets, "rx"), i = Q(this.element, e.styleSheets, "ry"), a = Math.min(parseFloat(r || i || "0"), .5 * t), o = Math.min(parseFloat(i || r || "0"), .5 * n), s = parseFloat(Q(this.element, e.styleSheets, "x") || "0"), c = parseFloat(Q(this.element, e.styleSheets, "y") || "0"), l = 4 / 3 * (Math.SQRT2 - 1);
		return a === 0 && o === 0 ? new tC().moveTo(s, c).lineTo(s + t, c).lineTo(s + t, c + n).lineTo(s, c + n).close() : new tC().moveTo(s += a, c).lineTo(s += t - 2 * a, c).curveTo(s + a * l, c, s + a, c + (o - o * l), s += a, c += o).lineTo(s, c += n - 2 * o).curveTo(s, c + o * l, s - a * l, c + o, s -= a, c += o).lineTo(s += 2 * a - t, c).curveTo(s - a * l, c, s - a, c - o * l, s -= a, c -= o).lineTo(s, c += 2 * o - n).curveTo(s, c - o * l, s + a * l, c - o, s += a, c -= o).close();
	}, t.prototype.computeNodeTransformCore = function(e) {
		return e.pdf.unitMatrix;
	}, t.prototype.isVisible = function(e, t) {
		return sC(this, e, t);
	}, t;
}(VC), JC = function(e) {
	function t(t, n) {
		return e.call(this, !1, t, n) || this;
	}
	return zS(t, e), t.prototype.getPath = function(e) {
		var t = this.getRx(e), n = this.getRy(e);
		if (!isFinite(t) || n <= 0 || !isFinite(n) || n <= 0) return null;
		var r = parseFloat(Q(this.element, e.styleSheets, "cx") || "0"), i = parseFloat(Q(this.element, e.styleSheets, "cy") || "0"), a = 4 / 3 * (Math.SQRT2 - 1) * t, o = 4 / 3 * (Math.SQRT2 - 1) * n;
		return new tC().moveTo(r + t, i).curveTo(r + t, i - o, r + a, i - n, r, i - n).curveTo(r - a, i - n, r - t, i - o, r - t, i).curveTo(r - t, i + o, r - a, i + n, r, i + n).curveTo(r + a, i + n, r + t, i + o, r + t, i);
	}, t.prototype.computeNodeTransformCore = function(e) {
		return e.pdf.unitMatrix;
	}, t.prototype.isVisible = function(e, t) {
		return sC(this, e, t);
	}, t;
}(VC), YC = function(e) {
	function t(t, n) {
		return e.call(this, t, n) || this;
	}
	return zS(t, e), t.prototype.getRx = function(e) {
		return parseFloat(Q(this.element, e.styleSheets, "rx") || "0");
	}, t.prototype.getRy = function(e) {
		return parseFloat(Q(this.element, e.styleSheets, "ry") || "0");
	}, t;
}(JC);
function XC(e) {
	var t = "invisible", n = e.stroke && e.strokeWidth !== 0, r = e.fill;
	return r && n ? t = "fillThenStroke" : r ? t = "fill" : n && (t = "stroke"), t;
}
function ZC(e) {
	return e.replace(/[\n\r]/g, "");
}
function QC(e) {
	return e.replace(/[\t]/g, " ");
}
function $C(e) {
	return e.replace(/ +/g, " ");
}
function ew(e, t, n) {
	switch (Q(e, n.styleSheets, "text-transform")) {
		case "uppercase": return t.toUpperCase();
		case "lowercase": return t.toLowerCase();
		default: return t;
	}
}
var tw = function() {
	function e(e, t, n, r) {
		this.textNode = e, this.texts = [], this.textNodes = [], this.contexts = [], this.textAnchor = t, this.originX = n, this.originY = r, this.textMeasures = [];
	}
	return e.prototype.setX = function(e) {
		this.originX = e;
	}, e.prototype.setY = function(e) {
		this.originY = e;
	}, e.prototype.add = function(e, t, n) {
		this.texts.push(t), this.textNodes.push(e), this.contexts.push(n);
	}, e.prototype.rightTrimText = function() {
		for (var e = this.texts.length - 1; e >= 0; e--) if (this.contexts[e].attributeState.xmlSpace === "preserve" || this.contexts[e].attributeState.whiteSpace === "pre" || (this.texts[e] = this.texts[e].replace(/\s+$/, "")), this.texts[e].match(/[^\s]/)) return !1;
		return !0;
	}, e.prototype.measureText = function(e) {
		for (var t = 0; t < this.texts.length; t++) this.textMeasures.push({
			width: e.textMeasure.measureTextWidth(this.texts[t], this.contexts[t].attributeState),
			length: this.texts[t].length
		});
	}, e.prototype.put = function(t, n) {
		var r, i, a, o, s = [], c = [], l = [], u = this.originX, d = this.originY, f = u, p = u;
		for (r = 0; r < this.textNodes.length; r++) {
			i = this.textNodes[r], a = this.contexts[r], o = this.textMeasures[r] || {
				width: t.textMeasure.measureTextWidth(this.texts[r], this.contexts[r].attributeState),
				length: this.texts[r].length
			};
			var m = u, h = d;
			if (i.nodeName !== "#text" && !s.includes(i)) {
				s.push(i);
				var g = e.resolveRelativePositionAttribute(i, "dx");
				g !== null && (m += mC(g, a.attributeState.fontSize));
				var _ = e.resolveRelativePositionAttribute(i, "dy");
				_ !== null && (h += mC(_, a.attributeState.fontSize));
			}
			c[r] = m, l[r] = h, u = m + o.width + o.length * n, d = h, f = Math.min(f, m), p = Math.max(p, u);
		}
		var v = 0;
		switch (this.textAnchor) {
			case "start":
				v = 0;
				break;
			case "middle":
				v = (p - f) / 2;
				break;
			case "end": v = p - f;
		}
		for (r = 0; r < this.textNodes.length; r++) if (i = this.textNodes[r], a = this.contexts[r], i.nodeName === "#text" || a.attributeState.visibility !== "hidden") {
			t.pdf.saveGraphicsState(), IC(a, t, i);
			var y = a.attributeState.alignmentBaseline, b = XC(a.attributeState);
			t.pdf.text(this.texts[r], c[r] - v, l[r], {
				baseline: hC(y),
				angle: t.transform,
				renderingMode: b === "fill" ? void 0 : b,
				charSpace: n === 0 ? void 0 : n
			}), t.pdf.restoreGraphicsState();
		}
		return [u, d];
	}, e.resolveRelativePositionAttribute = function(e, t) {
		for (var n = e; n && oC(n, "tspan");) {
			if (n.hasAttribute(t)) return n.getAttribute(t);
			if (e.parentElement?.firstChild !== e) break;
			n = n.parentElement;
		}
		return null;
	}, e;
}(), nw = function(e) {
	function t() {
		var t = e !== null && e.apply(this, arguments) || this;
		return t.boundingBox = [], t;
	}
	return zS(t, e), t.prototype.processTSpans = function(e, t, n, r, i, a) {
		for (var o = n.pdf.getFontSize(), s = n.attributeState.xmlSpace === "preserve" || n.attributeState.whiteSpace === "pre", c = !0, l = !1, u = 0; u < t.childNodes.length; u++) {
			var d = t.childNodes[u];
			if (d.textContent) {
				var f = d.textContent;
				if (d.nodeName === "#text") {
					var p = ZC(f);
					p = QC(p), s || (p = $C(p), c && p.match(/^\s/) && (l = !0), p.match(/[^\s]/) && (c = !1), a.prevText.match(/\s$/) && (p = p.replace(/^\s+/, "")));
					var m = ew(t, p, n);
					i.add(t, m, n), a.prevText = f, a.prevContext = n;
				} else if (!oC(d, "title") && oC(d, "tspan")) {
					var h = d, g = h.getAttribute("x");
					if (g !== null) {
						var _ = mC(g, o);
						i = new tw(this, Q(h, n.styleSheets, "text-anchor") || n.attributeState.textAnchor, _, 0), r.push({
							type: "y",
							chunk: i
						});
					}
					var v = h.getAttribute("y");
					if (v !== null) {
						var y = mC(v, o);
						i = new tw(this, Q(h, n.styleSheets, "text-anchor") || n.attributeState.textAnchor, 0, y), r.push({
							type: "x",
							chunk: i
						});
					}
					var b = n.clone();
					FC(b, e, h), this.processTSpans(e, h, b, r, i, a);
				}
			}
		}
		return l;
	}, t.prototype.renderCore = function(e) {
		return VS(this, void 0, void 0, (function() {
			var t, n, r, i, a, o, s, c, l, u, d, f, p, m, h, g, _, v, y, b, x, S, C;
			return HS(this, (function(w) {
				if (e.pdf.saveGraphicsState(), t = 0, n = 0, r = 1, i = e.pdf.getFontSize(), a = mC(this.element.getAttribute("x"), i), o = mC(this.element.getAttribute("y"), i), s = mC(this.element.getAttribute("dx"), i), c = mC(this.element.getAttribute("dy"), i), l = parseFloat(this.element.getAttribute("textLength") || "0"), u = e.attributeState.visibility, this.element.childElementCount === 0) d = this.element.textContent || "", f = function(e, t) {
					return e = QC(e = ZC(e)), t.xmlSpace === "preserve" || t.whiteSpace === "pre" || (e = $C(e = e.trim())), e;
				}(d, e.attributeState), p = ew(this.element, f, e), t = e.textMeasure.getTextOffset(p, e.attributeState), l > 0 && (m = e.textMeasure.measureTextWidth(p, e.attributeState), !(e.attributeState.xmlSpace === "preserve" || e.attributeState.whiteSpace === "pre") && d.match(/^\s/) && (r = 0), n = (l - m) / (p.length - r) || 0), u === "visible" && (h = e.attributeState.alignmentBaseline, g = XC(e.attributeState), e.pdf.text(p, a + s - t, o + c, {
					baseline: hC(h),
					angle: e.transform,
					renderingMode: g === "fill" ? void 0 : g,
					charSpace: n === 0 ? void 0 : n
				}), this.boundingBox = [
					a + s - t,
					o + c + .1 * i,
					e.textMeasure.measureTextWidth(p, e.attributeState),
					i
				]);
				else {
					for (_ = [], v = new tw(this, e.attributeState.textAnchor, a + s, o + c), _.push({
						type: "",
						chunk: v
					}), y = this.processTSpans(this, this.element, e, _, v, {
						prevText: " ",
						prevContext: e
					}), r = +!y, b = !0, x = _.length - 1; x >= 0; x--) b &&= _[x].chunk.rightTrimText();
					l > 0 && (S = 0, C = 0, _.forEach((function(t) {
						var n = t.chunk;
						n.measureText(e), n.textMeasures.forEach((function(e) {
							var t = e.width, n = e.length;
							S += t, C += n;
						}));
					})), n = (l - S) / (C - r)), _.reduce((function(t, r) {
						var i = r.type, a = r.chunk;
						return i === "x" ? a.setX(t[0]) : i === "y" && a.setY(t[1]), a.put(e, n);
					}), [0, 0]);
				}
				return e.pdf.restoreGraphicsState(), [2];
			}));
		}));
	}, t.prototype.isVisible = function(e, t) {
		return cC(this, e, t);
	}, t.prototype.getBoundingBoxCore = function(e) {
		return this.boundingBox.length > 0 ? this.boundingBox : CC(this.element, e);
	}, t.prototype.computeNodeTransformCore = function(e) {
		return e.pdf.unitMatrix;
	}, t;
}(BC), rw = function(e) {
	function t(t, n) {
		return e.call(this, !0, t, n) || this;
	}
	return zS(t, e), t.prototype.computeNodeTransformCore = function(e) {
		return e.pdf.unitMatrix;
	}, t.prototype.isVisible = function(e, t) {
		return sC(this, e, t);
	}, t.prototype.getPath = function(e) {
		var t, n, r = new FS.default(Q(this.element, e.styleSheets, "d") || "").unshort().unarc().abs(), i = new tC();
		return r.iterate((function(e) {
			switch (e[0]) {
				case "M":
					i.moveTo(e[1], e[2]);
					break;
				case "L":
					i.lineTo(e[1], e[2]);
					break;
				case "H":
					i.lineTo(e[1], n);
					break;
				case "V":
					i.lineTo(t, e[1]);
					break;
				case "C":
					i.curveTo(e[1], e[2], e[3], e[4], e[5], e[6]);
					break;
				case "Q":
					var r = XS([t, n], [e[1], e[2]]), a = XS([e[3], e[4]], [e[1], e[2]]);
					i.curveTo(r[0], r[1], a[0], a[1], e[3], e[4]);
					break;
				case "Z": i.close();
			}
			switch (e[0]) {
				case "M":
				case "L":
					t = e[1], n = e[2];
					break;
				case "H":
					t = e[1];
					break;
				case "V":
					n = e[1];
					break;
				case "C":
					t = e[5], n = e[6];
					break;
				case "Q": t = e[3], n = e[4];
			}
		})), i;
	}, t;
}(VC), iw = /^\s*data:(([^/,;]+\/[^/,;]+)(?:;([^,;=]+=[^,;=]+))?)?(?:;(base64))?,((?:.|\s)*)$/i, aw = function(e) {
	function t(n, r) {
		var i = e.call(this, n, r) || this;
		return i.imageLoadingPromise = null, i.imageUrl = i.element.getAttribute("xlink:href") || i.element.getAttribute("href"), i.imageUrl && (i.imageLoadingPromise = t.fetchImageData(i.imageUrl)), i;
	}
	return zS(t, e), t.prototype.renderCore = function(e) {
		return VS(this, void 0, void 0, (function() {
			var n, r, i, a, o, s, c, l, u, d, f, p, m, h, g, _, v, y;
			return HS(this, (function(b) {
				switch (b.label) {
					case 0: return this.imageLoadingPromise ? (e.pdf.setCurrentTransformationMatrix(e.transform), n = parseFloat(Q(this.element, e.styleSheets, "width") || "0"), r = parseFloat(Q(this.element, e.styleSheets, "height") || "0"), i = parseFloat(Q(this.element, e.styleSheets, "x") || "0"), a = parseFloat(Q(this.element, e.styleSheets, "y") || "0"), !isFinite(n) || n <= 0 || !isFinite(r) || r <= 0 ? [2] : [4, this.imageLoadingPromise]) : [2];
					case 1: return o = b.sent(), s = o.data, (c = o.format).indexOf("svg") === 0 ? (l = new DOMParser(), u = l.parseFromString(s, "image/svg+xml").firstElementChild, (!(d = this.element.getAttribute("preserveAspectRatio")) || d.indexOf("defer") < 0 || !u.getAttribute("preserveAspectRatio")) && u.setAttribute("preserveAspectRatio", d || ""), u.setAttribute("x", String(i)), u.setAttribute("y", String(a)), u.setAttribute("width", String(n)), u.setAttribute("height", String(r)), [4, _w(u, f = {}).render(new KS(e.pdf, {
						refsHandler: new qS(f),
						styleSheets: e.styleSheets,
						viewport: new GC(n, r),
						svg2pdfParameters: e.svg2pdfParameters,
						textMeasure: e.textMeasure
					}))]) : [3, 3];
					case 2: return b.sent(), [2];
					case 3: p = `data:image/${c};base64,${btoa(s)}`, b.label = 4;
					case 4: return b.trys.push([
						4,
						6,
						,
						7
					]), [4, t.getImageDimensions(p)];
					case 5: return m = b.sent(), h = m[0], g = m[1], _ = [
						0,
						0,
						h,
						g
					], v = wC(this.element, _, i, a, n, r, e), e.pdf.setCurrentTransformationMatrix(v), e.pdf.addImage(p, "", 0, 0, h, g), [3, 7];
					case 6: return y = b.sent(), typeof console == "object" && console.warn && console.warn(`Could not load image ${this.imageUrl}. 
${y}`), [3, 7];
					case 7: return [2];
				}
			}));
		}));
	}, t.prototype.getBoundingBoxCore = function(e) {
		return CC(this.element, e);
	}, t.prototype.computeNodeTransformCore = function(e) {
		return e.pdf.unitMatrix;
	}, t.prototype.isVisible = function(e, t) {
		return sC(this, e, t);
	}, t.fetchImageData = function(e) {
		return VS(this, void 0, void 0, (function() {
			var n, r, i, a, o;
			return HS(this, (function(s) {
				switch (s.label) {
					case 0:
						if (!(i = e.match(iw))) return [3, 1];
						if (a = i[2], (o = a.split("/"))[0] !== "image") throw Error(`Unsupported image URL: ${e}`);
						return r = o[1], n = i[5], i[4] === "base64" ? (n = n.replace(/\s/g, ""), n = atob(n)) : n = decodeURIComponent(n), [3, 3];
					case 1: return [4, t.fetchImage(e)];
					case 2: n = s.sent(), r = e.substring(e.lastIndexOf(".") + 1), s.label = 3;
					case 3: return [2, {
						data: n,
						format: r
					}];
				}
			}));
		}));
	}, t.fetchImage = function(e) {
		return new Promise((function(t, n) {
			var r = new XMLHttpRequest();
			r.open("GET", e, !0), r.responseType = "arraybuffer", r.onload = function() {
				if (r.status !== 200) throw Error(`Error ${r.status}: Failed to load image '${e}'`);
				for (var n = new Uint8Array(r.response), i = "", a = 0; a < n.length; a++) i += String.fromCharCode(n[a]);
				t(i);
			}, r.onerror = n, r.onabort = n, r.send(null);
		}));
	}, t.getMimeType = function(e) {
		switch (e = e.toLowerCase()) {
			case "jpg":
			case "jpeg": return "image/jpeg";
			default: return `image/${e}`;
		}
	}, t.getImageDimensions = function(e) {
		return new Promise((function(t, n) {
			var r = new Image();
			r.onload = function() {
				t([r.width, r.height]);
			}, r.onerror = n, r.src = e;
		}));
	}, t;
}(BC), ow = function(e) {
	function t(t, n, r) {
		var i = e.call(this, !0, n, r) || this;
		return i.closed = t, i;
	}
	return zS(t, e), t.prototype.getPath = function(e) {
		if (!this.element.hasAttribute("points") || this.element.getAttribute("points") === "") return null;
		var n = t.parsePointsString(this.element.getAttribute("points")), r = new tC();
		if (n.length < 1) return r;
		r.moveTo(n[0][0], n[0][1]);
		for (var i = 1; i < n.length; i++) r.lineTo(n[i][0], n[i][1]);
		return this.closed && r.close(), r;
	}, t.prototype.isVisible = function(e, t) {
		return sC(this, e, t);
	}, t.prototype.computeNodeTransformCore = function(e) {
		return e.pdf.unitMatrix;
	}, t.parsePointsString = function(e) {
		for (var t = gC(e), n = [], r = 0; r < t.length - 1; r += 2) {
			var i = t[r], a = t[r + 1];
			n.push([i, a]);
		}
		return n;
	}, t;
}(VC), sw = function(e) {
	function t(t, n) {
		return e.call(this, !0, t, n) || this;
	}
	return zS(t, e), t;
}(ow), cw = function(e) {
	function t() {
		return e !== null && e.apply(this, arguments) || this;
	}
	return zS(t, e), t.prototype.render = function(e) {
		return Promise.resolve();
	}, t.prototype.getBoundingBoxCore = function(e) {
		return [
			0,
			0,
			0,
			0
		];
	}, t.prototype.computeNodeTransformCore = function(e) {
		return e.pdf.unitMatrix;
	}, t.prototype.isVisible = function(e, t) {
		return sC(this, e, t);
	}, t;
}(EC), lw = function(e) {
	function t() {
		return e !== null && e.apply(this, arguments) || this;
	}
	return zS(t, e), t.prototype.apply = function(e) {
		return VS(this, void 0, void 0, (function() {
			var t, n, r, i, a, o;
			return HS(this, (function(s) {
				switch (s.label) {
					case 0: t = this.computeNodeTransform(e), n = this.getBoundingBox(e), e.pdf.beginFormObject(n[0], n[1], n[2], n[3], t), r = GS.getContextColors(e), function(e) {
						var t = e.attributeState, n = e.pdf, r = 1, i = 1;
						r *= t.fillOpacity, r *= t.opacity, t.fill instanceof WS && t.fill.color.a !== void 0 && (r *= t.fill.color.a), i *= t.strokeOpacity, i *= t.opacity, t.stroke instanceof WS && t.stroke.color.a !== void 0 && (i *= t.stroke.color.a);
						var a, o = {};
						if (o.opacity = r, o["stroke-opacity"] = i, n.setGState(new Db(o)), t.fill && t.fill instanceof WS && t.fill.color.ok ? n.setFillColor(t.fill.color.r, t.fill.color.g, t.fill.color.b) : n.setFillColor(0, 0, 0), n.setLineWidth(t.strokeWidth), t.stroke instanceof WS ? n.setDrawColor(t.stroke.color.r, t.stroke.color.g, t.stroke.color.b) : n.setDrawColor(0, 0, 0), n.setLineCap(t.strokeLinecap), n.setLineJoin(t.strokeLinejoin), t.strokeDasharray ? n.setLineDashPattern(t.strokeDasharray, t.strokeDashoffset) : n.setLineDashPattern([], 0), n.setLineMiterLimit(t.strokeMiterlimit), a = vC.hasOwnProperty(t.fontFamily) ? vC[t.fontFamily] : t.fontFamily, t.fill && t.fill instanceof WS && t.fill.color.ok) {
							var s = t.fill.color;
							n.setTextColor(s.r, s.g, s.b);
						} else n.setTextColor(0, 0, 0);
						var c = "";
						t.fontWeight === "bold" && (c = "bold"), t.fontStyle === "italic" && (c += "italic"), c === "" && (c = "normal"), a !== void 0 || c !== void 0 ? (a === void 0 && (a = vC.hasOwnProperty(t.fontFamily) ? vC[t.fontFamily] : t.fontFamily), n.setFont(a, c)) : n.setFont("helvetica", c), n.setFontSize(t.fontSize * n.internal.scaleFactor);
					}(i = new KS(e.pdf, {
						refsHandler: e.refsHandler,
						styleSheets: e.styleSheets,
						viewport: e.viewport,
						svg2pdfParameters: e.svg2pdfParameters,
						textMeasure: e.textMeasure,
						attributeState: Object.assign(GS.default(), r)
					})), a = 0, o = this.children, s.label = 1;
					case 1: return a < o.length ? [4, o[a].render(i)] : [3, 4];
					case 2: s.sent(), s.label = 3;
					case 3: return a++, [3, 1];
					case 4: return e.pdf.endFormObject(i.refsHandler.generateKey(this.element.getAttribute("id"), r)), [2];
				}
			}));
		}));
	}, t.prototype.getBoundingBoxCore = function(e) {
		var t, n = this.element.getAttribute("viewBox");
		return n && (t = gC(n)), [
			t && t[0] || 0,
			t && t[1] || 0,
			t && t[2] || parseFloat(this.element.getAttribute("markerWidth") || "3"),
			t && t[3] || parseFloat(this.element.getAttribute("markerHeight") || "3")
		];
	}, t.prototype.computeNodeTransformCore = function(e) {
		var t, n = parseFloat(this.element.getAttribute("refX") || "0"), r = parseFloat(this.element.getAttribute("refY") || "0"), i = this.element.getAttribute("viewBox");
		if (i) {
			var a = gC(i);
			t = wC(this.element, a, 0, 0, parseFloat(this.element.getAttribute("markerWidth") || "3"), parseFloat(this.element.getAttribute("markerHeight") || "3"), e, !0), t = e.pdf.matrixMult(e.pdf.Matrix(1, 0, 0, 1, -n, -r), t);
		} else t = e.pdf.Matrix(1, 0, 0, 1, -n, -r);
		return t;
	}, t.prototype.isVisible = function(e, t) {
		return cC(this, e, t);
	}, t;
}(DC), uw = function(e) {
	function t(t, n) {
		return e.call(this, t, n) || this;
	}
	return zS(t, e), t.prototype.getR = function(e) {
		return this.r ??= parseFloat(Q(this.element, e.styleSheets, "r") || "0");
	}, t.prototype.getRx = function(e) {
		return this.getR(e);
	}, t.prototype.getRy = function(e) {
		return this.getR(e);
	}, t;
}(JC), dw = function(e) {
	function t(t, n) {
		return e.call(this, !1, t, n) || this;
	}
	return zS(t, e), t;
}(ow), fw = function(e) {
	function t() {
		return e !== null && e.apply(this, arguments) || this;
	}
	return zS(t, e), t.prototype.renderCore = function(e) {
		return VS(this, void 0, void 0, (function() {
			var t, n;
			return HS(this, (function(r) {
				switch (r.label) {
					case 0: t = 0, n = this.children, r.label = 1;
					case 1: return t < n.length ? [4, n[t].render(e)] : [3, 4];
					case 2: r.sent(), r.label = 3;
					case 3: return t++, [3, 1];
					case 4: return [2];
				}
			}));
		}));
	}, t.prototype.getBoundingBoxCore = function(e) {
		return SC(e, this);
	}, t;
}(zC), pw = function(e) {
	function t() {
		return e !== null && e.apply(this, arguments) || this;
	}
	return zS(t, e), t.prototype.isVisible = function(e, t) {
		return cC(this, e, t);
	}, t.prototype.render = function(t) {
		return VS(this, void 0, void 0, (function() {
			var n, r, i, a, o;
			return HS(this, (function(s) {
				switch (s.label) {
					case 0: return this.isVisible(t.attributeState.visibility !== "hidden", t) ? (n = this.getX(t), r = this.getY(t), i = this.getWidth(t), a = this.getHeight(t), t.pdf.saveGraphicsState(), o = t.transform, this.element.hasAttribute("transform") && (o = t.pdf.matrixMult(TC(this.element.getAttribute("transform"), t), o)), t.pdf.setCurrentTransformationMatrix(o), t.withinUse || Q(this.element, t.styleSheets, "overflow") === "visible" || t.pdf.rect(n, r, i, a).clip().discardPath(), [4, e.prototype.render.call(this, t.clone({
						transform: t.pdf.unitMatrix,
						viewport: t.withinUse ? t.viewport : new GC(i, a)
					}))]) : [2];
					case 1: return s.sent(), t.pdf.restoreGraphicsState(), [2];
				}
			}));
		}));
	}, t.prototype.computeNodeTransform = function(e) {
		return this.computeNodeTransformCore(e);
	}, t.prototype.computeNodeTransformCore = function(e) {
		if (e.withinUse) return e.pdf.unitMatrix;
		var t, n = this.getX(e), r = this.getY(e), i = this.getViewBox();
		if (i) {
			var a = this.getWidth(e), o = this.getHeight(e);
			t = wC(this.element, i, n, r, a, o, e);
		} else t = e.pdf.Matrix(1, 0, 0, 1, n, r);
		return t;
	}, t.prototype.getWidth = function(e) {
		if (this.width !== void 0) return this.width;
		var t, n, r = e.svg2pdfParameters;
		if (this.isOutermostSvg(e)) if (r.width != null) t = r.width;
		else if (n = Q(this.element, e.styleSheets, "width")) t = parseFloat(n);
		else {
			var i = this.getViewBox();
			if (i && (r.height != null || Q(this.element, e.styleSheets, "height"))) {
				var a = i[2] / i[3];
				t = this.getHeight(e) * a;
			} else t = Math.min(300, e.viewport.width, 2 * e.viewport.height);
		}
		else t = (n = Q(this.element, e.styleSheets, "width")) ? parseFloat(n) : e.viewport.width;
		return this.width = t;
	}, t.prototype.getHeight = function(e) {
		if (this.height !== void 0) return this.height;
		var t, n, r = e.svg2pdfParameters;
		if (this.isOutermostSvg(e)) if (r.height != null) t = r.height;
		else if (n = Q(this.element, e.styleSheets, "height")) t = parseFloat(n);
		else {
			var i = this.getViewBox();
			if (i) {
				var a = i[2] / i[3];
				t = this.getWidth(e) / a;
			} else t = Math.min(150, e.viewport.width / 2, e.viewport.height);
		}
		else t = (n = Q(this.element, e.styleSheets, "height")) ? parseFloat(n) : e.viewport.height;
		return this.height = t;
	}, t.prototype.getX = function(e) {
		if (this.x !== void 0) return this.x;
		if (this.isOutermostSvg(e)) return this.x = 0;
		var t = Q(this.element, e.styleSheets, "x");
		return this.x = t ? parseFloat(t) : 0;
	}, t.prototype.getY = function(e) {
		if (this.y !== void 0) return this.y;
		if (this.isOutermostSvg(e)) return this.y = 0;
		var t = Q(this.element, e.styleSheets, "y");
		return this.y = t ? parseFloat(t) : 0;
	}, t.prototype.getViewBox = function() {
		if (this.viewBox !== void 0) return this.viewBox;
		var e = this.element.getAttribute("viewBox");
		return this.viewBox = e ? gC(e) : void 0;
	}, t.prototype.isOutermostSvg = function(e) {
		return e.svg2pdfParameters.element === this.element;
	}, t;
}(fw), mw = function(e) {
	function t() {
		return e !== null && e.apply(this, arguments) || this;
	}
	return zS(t, e), t.prototype.isVisible = function(e, t) {
		return cC(this, e, t);
	}, t.prototype.computeNodeTransformCore = function(e) {
		return e.pdf.unitMatrix;
	}, t;
}(fw), hw = function(e) {
	function t() {
		return e !== null && e.apply(this, arguments) || this;
	}
	return zS(t, e), t.prototype.renderCore = function(t) {
		return VS(this, void 0, void 0, (function() {
			var n, r, i, a;
			return HS(this, (function(o) {
				switch (o.label) {
					case 0: return [4, e.prototype.renderCore.call(this, t)];
					case 1: return o.sent(), (n = Q(this.element, t.styleSheets, "href")) && (r = this.getBoundingBox(t), i = t.pdf.internal.scaleFactor, a = t.pdf.internal.pageSize.getHeight(), t.pdf.link(i * (r[0] * t.transform.sx + t.transform.tx), a - i * (r[1] * t.transform.sy + t.transform.ty), i * r[2], i * r[3], { url: n })), [2];
				}
			}));
		}));
	}, t;
}(mw), gw = function(e) {
	function t() {
		return e !== null && e.apply(this, arguments) || this;
	}
	return zS(t, e), t.prototype.apply = function(e) {
		return VS(this, void 0, void 0, (function() {
			var t, n, r, i, a;
			return HS(this, (function(o) {
				switch (o.label) {
					case 0:
						if (!this.isVisible(!0, e)) return [2];
						t = e.pdf.matrixMult(this.computeNodeTransform(e), e.transform), e.pdf.setCurrentTransformationMatrix(t), n = 0, r = this.children, o.label = 1;
					case 1: return n < r.length ? [4, r[n].render(new KS(e.pdf, {
						refsHandler: e.refsHandler,
						styleSheets: e.styleSheets,
						viewport: e.viewport,
						withinClipPath: !0,
						svg2pdfParameters: e.svg2pdfParameters,
						textMeasure: e.textMeasure
					}))] : [3, 4];
					case 2: o.sent(), o.label = 3;
					case 3: return n++, [3, 1];
					case 4: return i = this.children.length > 0 && !!Q(this.children[0].element, e.styleSheets, "clip-rule"), a = i ? this.getClipRuleAttr(this.children[0].element, e.styleSheets) : this.getClipRuleAttr(this.element, e.styleSheets), e.pdf.clip(a).discardPath(), e.pdf.setCurrentTransformationMatrix(t.inversed()), [2];
				}
			}));
		}));
	}, t.prototype.getBoundingBoxCore = function(e) {
		return SC(e, this);
	}, t.prototype.isVisible = function(e, t) {
		return cC(this, e, t);
	}, t.prototype.getClipRuleAttr = function(e, t) {
		return Q(e, t, "clip-rule") === "evenodd" ? "evenodd" : void 0;
	}, t;
}(DC);
function _w(e, t) {
	var n, r = [];
	switch (function(e, t) {
		for (var n = [], r = 0; r < e.childNodes.length; r++) {
			var i = e.childNodes[r];
			i.nodeName.charAt(0) !== "#" && n.push(i);
		}
		for (r = 0; r < n.length; r++) t(r, n[r]);
	}(e, (function(e, n) {
		return r.push(_w(n, t));
	})), e.tagName.toLowerCase()) {
		case "a":
			n = new hw(e, r);
			break;
		case "g":
			n = new mw(e, r);
			break;
		case "circle":
			n = new uw(e, r);
			break;
		case "clippath":
			n = new gw(e, r);
			break;
		case "ellipse":
			n = new YC(e, r);
			break;
		case "lineargradient":
			n = new kC(e, r);
			break;
		case "image":
			n = new aw(e, r);
			break;
		case "line":
			n = new UC(e, r);
			break;
		case "marker":
			n = new lw(e, r);
			break;
		case "path":
			n = new rw(e, r);
			break;
		case "pattern":
			n = new MC(e, r);
			break;
		case "polygon":
			n = new sw(e, r);
			break;
		case "polyline":
			n = new dw(e, r);
			break;
		case "radialgradient":
			n = new AC(e, r);
			break;
		case "rect":
			n = new qC(e, r);
			break;
		case "svg":
			n = new pw(e, r);
			break;
		case "symbol":
			n = new WC(e, r);
			break;
		case "text":
			n = new nw(e, r);
			break;
		case "use":
			n = new KC(e, r);
			break;
		default: n = new cw(e, r);
	}
	if (t != null && n.element.hasAttribute("id")) {
		var i = (0, NS.default)(n.element.id, { isIdentifier: !0 });
		t[i] = t[i] || n;
	}
	return n.children.forEach((function(e) {
		return e.setParent(n);
	})), n;
}
var vw = function() {
	function e(e, t) {
		this.rootSvg = e, this.loadExternalSheets = t, this.styleSheets = [];
	}
	return e.prototype.load = function() {
		return VS(this, void 0, void 0, (function() {
			var e;
			return HS(this, (function(t) {
				switch (t.label) {
					case 0: return [4, this.collectStyleSheetTexts()];
					case 1: return e = t.sent(), this.parseCssSheets(e), [2];
				}
			}));
		}));
	}, e.prototype.collectStyleSheetTexts = function() {
		return VS(this, void 0, void 0, (function() {
			var t, n, r, i, a;
			return HS(this, (function(o) {
				switch (o.label) {
					case 0:
						if (t = [], this.loadExternalSheets && this.rootSvg.ownerDocument) for (i = 0; i < this.rootSvg.ownerDocument.childNodes.length; i++) (n = this.rootSvg.ownerDocument.childNodes[i]).nodeName === "xml-stylesheet" && typeof n.data == "string" && t.push(e.loadSheet(n.data.match(/href=["'].*?["']/)[0].split("=")[1].slice(1, -1)));
						for (r = this.rootSvg.querySelectorAll("style,link"), i = 0; i < r.length; i++) oC(a = r[i], "style") ? t.push(a.textContent) : this.loadExternalSheets && oC(a, "link") && a.getAttribute("rel") === "stylesheet" && a.hasAttribute("href") && t.push(e.loadSheet(a.getAttribute("href")));
						return [4, Promise.all(t)];
					case 1: return [2, o.sent().filter((function(e) {
						return e !== null;
					}))];
				}
			}));
		}));
	}, e.prototype.parseCssSheets = function(t) {
		for (var n = document.implementation.createHTMLDocument(""), r = 0, i = t; r < i.length; r++) {
			var a = i[r], o = n.createElement("style");
			o.textContent = a, n.body.appendChild(o);
			var s = o.sheet;
			if (s instanceof CSSStyleSheet) {
				for (var c = s.cssRules.length - 1; c >= 0; c--) {
					var l = s.cssRules[c];
					if (l instanceof CSSStyleRule) {
						var u = l;
						if (u.selectorText.indexOf(",") >= 0) {
							s.deleteRule(c);
							for (var d = u.cssText.substring(u.selectorText.length), f = e.splitSelectorAtCommas(u.selectorText), p = 0; p < f.length; p++) s.insertRule(f[p] + d, c + p);
						}
					} else s.deleteRule(c);
				}
				this.styleSheets.push(s);
			}
		}
	}, e.splitSelectorAtCommas = function(e) {
		for (var t, n = /,|["']/g, r = /[^\\]["]/g, i = /[^\\][']/g, a = [], o = "initial", s = -1, c = r, l = 0; l < e.length;) switch (o) {
			case "initial":
				n.lastIndex = l, (t = n.exec(e)) ? (t[0] === "," ? (a.push(e.substring(s + 1, n.lastIndex - 1).trim()), s = n.lastIndex - 1) : (o = "withinQuotes", c = t[0] === "\"" ? r : i), l = n.lastIndex) : (a.push(e.substring(s + 1).trim()), l = e.length);
				break;
			case "withinQuotes": c.lastIndex = l, (t = c.exec(e)) && (l = c.lastIndex, o = "initial");
		}
		return a;
	}, e.loadSheet = function(e) {
		return new Promise((function(t, n) {
			var r = new XMLHttpRequest();
			r.open("GET", e, !0), r.responseType = "text", r.onload = function() {
				r.status !== 200 && n(/* @__PURE__ */ Error(`Error ${r.status}: Failed to load '${e}'`)), t(r.responseText);
			}, r.onerror = n, r.onabort = n, r.send(null);
		})).catch((function() {
			return null;
		}));
	}, e.prototype.getPropertyValue = function(e, t) {
		for (var n = [], r = 0, i = this.styleSheets; r < i.length; r++) for (var a = i[r], o = 0; o < a.cssRules.length; o++) {
			var s = a.cssRules[o];
			s.style.getPropertyValue(t) && e.matches(s.selectorText) && n.push(s);
		}
		if (n.length !== 0) return n.reduce((function(e, n) {
			return (i = n, (a = (r = e).style.getPropertyPriority(t)) === i.style.getPropertyPriority(t) ? LS(r.selectorText, i.selectorText) : a === "important" ? 1 : -1) === 1 ? e : n;
			var r, i, a;
		})).style.getPropertyValue(t) || void 0;
	}, e;
}(), yw = function() {
	function e() {
		this.measureMethods = {};
	}
	return e.prototype.getTextOffset = function(e, t) {
		var n = t.textAnchor;
		if (n === "start") return 0;
		var r = this.measureTextWidth(e, t), i = 0;
		switch (n) {
			case "end":
				i = r;
				break;
			case "middle": i = r / 2;
		}
		return i;
	}, e.prototype.measureTextWidth = function(e, t) {
		if (e.length === 0) return 0;
		var n = t.fontFamily;
		return this.getMeasureFunction(n).call(this, e, t.fontFamily, t.fontSize + "px", t.fontStyle, t.fontWeight);
	}, e.prototype.getMeasurementTextNode = function() {
		if (!this.textMeasuringTextElement) {
			this.textMeasuringTextElement = document.createElementNS(pC, "text");
			var e = document.createElementNS(pC, "svg");
			e.appendChild(this.textMeasuringTextElement), e.style.setProperty("position", "absolute"), e.style.setProperty("visibility", "hidden"), document.body.appendChild(e);
		}
		return this.textMeasuringTextElement;
	}, e.prototype.canvasTextMeasure = function(e, t, n, r, i) {
		var a = document.createElement("canvas").getContext("2d");
		return a == null ? 0 : (a.font = [
			r,
			i,
			n,
			t
		].join(" "), a.measureText(e).width);
	}, e.prototype.svgTextMeasure = function(e, t, n, r, i, a) {
		a === void 0 && (a = this.getMeasurementTextNode());
		var o = a;
		return o.setAttribute("font-family", t), o.setAttribute("font-size", n), o.setAttribute("font-style", r), o.setAttribute("font-weight", i), o.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), o.textContent = e, o.getBBox().width;
	}, e.prototype.getMeasureFunction = function(t) {
		var n = this.measureMethods[t];
		if (!n) {
			var r = "16px", i = "normal", a = "normal", o = this.canvasTextMeasure(e.testString, t, r, i, a), s = this.svgTextMeasure(e.testString, t, r, i, a);
			n = Math.abs(o - s) < e.epsilon ? this.canvasTextMeasure : this.svgTextMeasure, this.measureMethods[t] = n;
		}
		return n;
	}, e.prototype.cleanupTextMeasuring = function() {
		if (this.textMeasuringTextElement) {
			var e = this.textMeasuringTextElement.parentNode;
			e && document.body.removeChild(e), this.textMeasuringTextElement = void 0;
		}
	}, e.testString = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ 0123456789!\"$%&/()=?'\\+*-_.:,;^}][{#~|<>", e.epsilon = .1, e;
}();
function bw(e, t) {
	return VS(this, arguments, void 0, (function(e, t, n) {
		var r, i, a, o, s, c, l, u, d, f, p, m;
		return n === void 0 && (n = {}), HS(this, (function(h) {
			switch (h.label) {
				case 0: return r = n.x ?? 0, i = n.y ?? 0, a = (m = n.loadExternalStyleSheets) != null && m, s = new qS(o = {}), [4, (c = new vw(e, a)).load()];
				case 1: return h.sent(), l = new GC(t.internal.pageSize.getWidth(), t.internal.pageSize.getHeight()), u = BS(BS({}, n), { element: e }), d = new yw(), f = new KS(t, {
					refsHandler: s,
					styleSheets: c,
					viewport: l,
					svg2pdfParameters: u,
					textMeasure: d
				}), t.advancedAPI(), t.saveGraphicsState(), t.setCurrentTransformationMatrix(t.Matrix(1, 0, 0, 1, r, i)), t.setLineWidth(f.attributeState.strokeWidth), p = f.attributeState.fill.color, t.setFillColor(p.r, p.g, p.b), t.setFont(f.attributeState.fontFamily), t.setFontSize(f.attributeState.fontSize * t.internal.scaleFactor), [4, _w(e, o).render(f)];
				case 2: return h.sent(), t.restoreGraphicsState(), t.compatAPI(), f.textMeasure.cleanupTextMeasuring(), [2, t];
			}
		}));
	}));
}
jb.API.svg = function(e, t) {
	return t === void 0 && (t = {}), bw(e, this, t);
};
//#endregion
//#region packages/svgcanvas/core/svg-exec.js
var { InsertElementCommand: xw, RemoveElementCommand: Sw, ChangeElementCommand: Cw, BatchCommand: ww } = et, $ = null, Tw = (e) => {
	$ = e, $.setSvgString = Ow, $.importSvgString = kw, $.uniquifyElems = Fw, $.setUseData = Iw, $.convertGradients = Rw, $.removeUnusedDefElems = Lw, $.svgCanvasToString = Ew, $.svgToString = Dw, $.embedImage = Aw, $.rasterExport = Nw, $.exportPDF = Pw;
}, Ew = () => {
	for (; $.removeUnusedDefElems() > 0;);
	$.pathActions.clear(!0), $.getSvgContent().childNodes.forEach((e, t) => {
		t && e.nodeType === 8 && e.data.includes("Created with") && $.getSvgContent().firstChild.before(e);
	}), $.getCurrentGroup() && (qn(), $.selectOnly([$.getCurrentGroup()]));
	let e = [], t = $.getSvgContent().querySelectorAll("g[data-gsvg]");
	Array.prototype.forEach.call(t, (t) => {
		let n = t.attributes, r = n.length;
		for (let e = 0; e < r; e++) (n[e].nodeName === "id" || n[e].nodeName === "style") && r--;
		if (r <= 0) {
			let n = t.firstChild;
			e.push(n), t.replaceWith(n);
		}
	});
	let n = $.svgToString($.getSvgContent(), 0);
	return e.length && Array.prototype.forEach.call(e, (e) => {
		$.groupSvgElem(e);
	}), n;
}, Dw = (e, t) => {
	let n = $.getCurConfig(), r = $.getNsMap(), i = [], a = n.baseUnit, o = RegExp(`^-?[\\d\\.]+${a}$`);
	if (e) {
		Ge(e);
		let s = [...e.attributes], c = e.childNodes;
		s.sort((e, t) => e.name > t.name ? -1 : 1);
		for (let e = 0; e < t; e++) i.push(" ");
		if (i.push("<"), i.push(e.localName), e.id === "svgcontent") {
			let t = $.getResolution(), o = "";
			n.dynamicOutput ? (o = e.getAttribute("viewBox"), o ||= [
				0,
				0,
				t.w,
				t.h
			].join(" "), i.push(` viewBox="${o}" xmlns="${A.SVG}"`)) : (a !== "px" && (t.w = E(t.w, a) + a, t.h = E(t.h, a) + a), i.push(" width=\"" + t.w + "\" height=\"" + t.h + "\" xmlns=\"" + A.SVG + "\""));
			let c = {}, l = e.querySelectorAll("*"), u = Array.prototype.slice.call(l);
			u.push(e), Array.prototype.forEach.call(u, (e) => {
				let t = e.namespaceURI;
				if (t && !c[t] && r[t] && r[t] !== "xmlns" && r[t] !== "xml" && (c[t] = !0, i.push(` xmlns:${r[t]}="${t}"`)), e.attributes.length > 0) for (let [, t] of Object.entries(e.attributes)) {
					let e = t.namespaceURI;
					e && !c[e] && r[e] !== "xmlns" && r[e] !== "xml" && (c[e] = !0, i.push(` xmlns:${r[e]}="${e}"`));
				}
			});
			let d = s.length, f = [
				"width",
				"height",
				"xmlns",
				"x",
				"y",
				"viewBox",
				"id",
				"overflow"
			];
			for (; d--;) {
				let e = s[d], t = pe(e.value);
				e.nodeName.startsWith("xmlns:") || t !== "" && !f.includes(e.localName) && (!e.namespaceURI || r[e.namespaceURI]) && (i.push(" "), i.push(e.nodeName), i.push("=\""), i.push(t), i.push("\""));
			}
		} else {
			if (e.nodeName === "defs" && !e.firstChild) return "";
			let t = ["-moz-math-font-style", "_moz-math-font-style"];
			for (let n = s.length - 1; n >= 0; n--) {
				let c = s[n], l = pe(c.value);
				if (!t.includes(c.localName)) {
					if (l === "null") {
						let t = c.localName.replace(/-[a-z]/g, (e) => e[1].toUpperCase());
						if (Object.prototype.hasOwnProperty.call(e.style, t)) continue;
					}
					if (l !== "") {
						if (l.startsWith("pointer-events") || c.localName === "class" && l.startsWith("se_")) continue;
						if (i.push(" "), c.localName === "d" && (l = $.pathActions.convertPath(e, !0)), isNaN(l) ? o.test(l) && (l = T(l) + a) : l = T(l), $.getSvgOptionApply() && e.nodeName === "image" && c.localName === "href" && $.getSvgOptionImages() && $.getSvgOptionImages() === "embed") {
							let e = $.getEncodableImages(l);
							e && (l = e);
						}
						(!c.namespaceURI || c.namespaceURI === A.SVG || r[c.namespaceURI]) && (i.push(c.nodeName), i.push("=\""), i.push(l), i.push("\""));
					}
				}
			}
		}
		if (e.hasChildNodes()) {
			i.push(">"), t++;
			let n = !1;
			for (let e = 0; e < c.length; e++) {
				let r = c.item(e);
				switch (r.nodeType) {
					case 1:
						i.push("\n"), i.push($.svgToString(r, t));
						break;
					case 3: {
						let e = r.nodeValue.replace(/^\s+|\s+$/g, "");
						e !== "" && (n = !0, i.push(String(pe(e))));
						break;
					}
					case 4:
						i.push("\n"), i.push(Array(t + 1).join(" ")), i.push("<![CDATA["), i.push(r.nodeValue), i.push("]]>");
						break;
					case 8:
						i.push("\n"), i.push(Array(t + 1).join(" ")), i.push("<!--"), i.push(r.data), i.push("-->");
						break;
				}
			}
			if (t--, !n) {
				i.push("\n");
				for (let e = 0; e < t; e++) i.push(" ");
			}
			i.push("</"), i.push(e.localName), i.push(">");
		} else i.push("/>");
	}
	return i.join("");
}, Ow = (e, t) => {
	let n = $.getCurConfig(), r = $.getDataStorage();
	try {
		let i = be(e);
		if (i.firstElementChild && i.firstElementChild.namespaceURI !== A.SVG) return !1;
		$.prepareSvg(i);
		let a = new ww("Change Source"), { nextSibling: o } = $.getSvgContent();
		$.getSvgContent().remove();
		let s = $.getSvgContent();
		a.addSubCommand(new Sw(s, o, $.getSvgRoot())), $.getDOMDocument().adoptNode ? $.setSvgContent($.getDOMDocument().adoptNode(i.documentElement)) : $.setSvgContent($.getDOMDocument().importNode(i.documentElement, !0)), $.getSvgRoot().append($.getSvgContent());
		let c = $.getSvgContent();
		$.current_drawing_ = new jn($.getSvgContent(), $.getIdPrefix());
		let l = $.getCurrentDrawing().getNonce();
		l ? $.call("setnonce", l) : $.call("unsetnonce");
		let u = c.querySelectorAll("image");
		Array.prototype.forEach.call(u, (e) => {
			qe(e);
			let t = $.getHref(e);
			if (t) {
				if (t.startsWith("data:")) {
					let n = t.match(/svgedit_url=(.*?);/);
					if (n) {
						let r = decodeURIComponent(n[1]), i = new Image();
						i.addEventListener("load", () => {
							Ee(e, t);
						}), i.src = r;
					}
				}
				$.embedImage(t);
			}
		});
		let d = c.querySelectorAll("[id]"), f = {}, p = d.length;
		for (let e = 0; e < p; e++) {
			let t = d[e].id ? d[e].id : "undefined";
			isNaN(f[t]) && (f[t] = 0), f[t]++;
		}
		Object.entries(f).forEach(([e, t]) => {
			if (t > 1) {
				let t = c.querySelectorAll(`[id="${e}"]`);
				for (let e = 1; e < t.length; e++) t[e].setAttribute("id", $.getNextId());
			}
		});
		let m = c.querySelectorAll("svg");
		if (Array.prototype.forEach.call(m, (e) => {
			if (se(e.parentNode, "defs")) return;
			$.uniquifyElems(e);
			let t = e.parentNode;
			t.childNodes.length === 1 && t.nodeName === "g" ? (r.put(t, "gsvg", e), t.id = t.id || $.getNextId()) : $.groupSvgElem(e);
		}), or()) {
			let e = De(), t = c.querySelectorAll("linearGradient, radialGradient, pattern");
			Array.prototype.forEach.call(t, (t) => {
				e.appendChild(t);
			});
		}
		$.setUseData(c), $.convertGradients(c);
		let h = {
			id: "svgcontent",
			overflow: n.show_outside_canvas ? "visible" : "hidden"
		}, g = !1;
		if (c.getAttribute("viewBox")) {
			let e = c.getAttribute("viewBox").split(/[ ,]+/), t = Number(e[2]), n = Number(e[3]);
			Number.isFinite(t) && (h.width = t), Number.isFinite(n) && (h.height = n);
		} else ["width", "height"].forEach((e) => {
			let t = c.getAttribute(e) || "100%";
			String(t).slice(-1) === "%" ? g = !0 : h[e] = O(e, t);
		});
		Fn();
		let _ = c.children;
		if (Array.prototype.forEach.call(_, (e) => {
			let t = e.querySelectorAll($.getVisElems());
			Array.prototype.forEach.call(t, (e) => {
				e.id ||= $.getNextId();
			});
		}), g) {
			let e = Re();
			e && typeof e == "object" ? (h.width = e.width + e.x, h.height = e.height + e.y) : ((h.width === null || h.width === void 0) && (h.width = 100), (h.height === null || h.height === void 0) && (h.height = 100));
		}
		(!Number.isFinite(h.width) || h.width <= 0) && (h.width = 100), (!Number.isFinite(h.height) || h.height <= 0) && (h.height = 100);
		for (let [e, t] of Object.entries(h)) c.setAttribute(e, t);
		$.contentW = h.width, $.contentH = h.height, a.addSubCommand(new xw($.getSvgContent()));
		let v = {
			width: c.getAttribute("width"),
			height: c.getAttribute("height")
		};
		a.addSubCommand(new Cw($.getSvgRoot(), v)), $.setZoom(1), $.clearSelection(), fn(), $.getSvgRoot().append($.selectorManager.selectorParentGroup), t || $.addCommandToHistory(a), $.call("sourcechanged", [$.getSvgContent()]);
	} catch (e) {
		return h("Error setting SVG string", e, "svg-exec"), !1;
	}
	return !0;
}, kw = (e, t) => {
	let n = $.getDataStorage(), r, i, a;
	try {
		let o = ge(e), s = !1;
		$.getImportIds(o) && $.getImportIds(o).symbol && ce($.getImportIds(o).symbol, "#svgroot")?.length && (s = !0);
		let c = new ww("Import Image"), l;
		if (s) l = $.getImportIds(o).symbol, i = $.getImportIds(o).xform;
		else {
			let t = be(e);
			$.prepareSvg(t);
			let n = $.getDOMDocument().adoptNode ? $.getDOMDocument().adoptNode(t.documentElement) : $.getDOMDocument().importNode(t.documentElement, !0);
			$.uniquifyElems(n);
			let a = O("width", n.getAttribute("width")), s = O("height", n.getAttribute("height")), u = n.getAttribute("viewBox"), d = u ? u.split(/[ ,]+/) : [
				0,
				0,
				a,
				s
			];
			for (r = 0; r < 4; ++r) d[r] = Number(d[r]);
			let f = Number($.getSvgContent().getAttribute("height")), p = Number.isFinite(f) && f > 0 ? f : Number($.getCurConfig().dimensions?.[1]) || 100, m = d[2], h = d[3], g = Number.isFinite(m) && m > 0 ? m : a > 0 ? a : 100, _ = Number.isFinite(h) && h > 0 ? h : s > 0 ? s : 100, v = Number.isFinite(g) && g > 0 ? g : 100, y = Number.isFinite(_) && _ > 0 ? _ : 100;
			i = y > v ? "scale(" + p / 3 / y + ")" : "scale(" + p / 3 / v + ")", i = `translate(0) ${i} translate(0)`, l = $.getDOMDocument().createElementNS(A.SVG, "symbol");
			let b = De();
			if (or()) {
				let e = n.querySelectorAll("linearGradient, radialGradient, pattern");
				Array.prototype.forEach.call(e, (e) => {
					b.appendChild(e);
				});
			}
			for (; n.firstChild;) {
				let e = n.firstChild;
				l.append(e);
			}
			let x = n.attributes;
			for (let e of x) l.setAttribute(e.nodeName, e.value);
			l.id = $.getNextId(), $.setImportIds(o, {
				symbol: l,
				xform: i
			}), De().append(l), c.addSubCommand(new xw(l));
		}
		a = $.getDOMDocument().createElementNS(A.SVG, "use"), a.id = $.getNextId(), $.setHref(a, "#" + l.id), ($.getCurrentGroup() || $.getCurrentDrawing().getCurrentLayer()).append(a), c.addSubCommand(new xw(a)), $.clearSelection(), t || (a.setAttribute("transform", i), Qi(a)), n.put(a, "symbol", l), n.put(a, "ref", l), $.addToSelection([a]), $.addCommandToHistory(c), $.call("changed", [$.getSvgContent()]);
	} catch (e) {
		return h("Error importing SVG string", e, "svg-exec"), null;
	}
	return a;
}, Aw = (e) => new Promise((t, n) => {
	let r = new Image();
	r.addEventListener("load", (n) => {
		let r = document.createElement("canvas");
		r.width = n.currentTarget.width, r.height = n.currentTarget.height, r.getContext("2d").drawImage(n.currentTarget, 0, 0);
		try {
			let t = ";svgedit_url=" + encodeURIComponent(e);
			t = r.toDataURL().replace(";base64", t + ";base64"), $.setEncodableImages(e, t);
		} catch {
			$.setEncodableImages(e, !1);
		}
		$.setGoodImage(e), t($.getEncodableImages(e));
	}), r.addEventListener("error", (e) => {
		n(/* @__PURE__ */ Error(`error loading image: ${e.currentTarget.attributes.src.value}`));
	}), r.setAttribute("src", e);
}), jw = () => {
	let e = $.getUIStrings();
	$.clearSelection();
	let t = [], n = [], r = {
		feGaussianBlur: e.NoBlur,
		foreignObject: e.NoforeignObject,
		"[stroke-dasharray]": e.NoDashArray
	}, i = $.getSvgContent();
	"font" in document.querySelector("CANVAS").getContext("2d") || (r.text = e.NoText);
	for (let [e, a] of Object.entries(r)) i.querySelectorAll(e).length && (n.push(e), t.push(a));
	return {
		issues: t,
		issueCodes: n
	};
}, Mw = async (e) => {
	let t = e.querySelectorAll("image"), n = Array.from(t).map(async (e) => {
		let t = e.getAttribute("xlink:href") || e.getAttribute("href");
		if (t && !t.startsWith("data:")) try {
			let n = await (await fetch(t)).blob(), r = new FileReader();
			return new Promise((t) => {
				r.onload = () => {
					Ee(e, r.result), t();
				}, r.readAsDataURL(n);
			});
		} catch (e) {
			h("Failed to fetch image", e, "svg-exec");
		}
	});
	await Promise.all(n);
}, Nw = (e = "PNG", t = 1, n = "Exported Image", r = {}) => new Promise((i, a) => {
	let o = `image/${(e === "ICO" ? "BMP" : e).toLowerCase()}`, { issues: s, issueCodes: c } = jw(), l = $.getSvgContent().cloneNode(!0);
	Mw(l).then(() => {
		let u = new XMLSerializer().serializeToString(l), d = new Blob([u], { type: "image/svg+xml;charset=utf-8" }), f = URL.createObjectURL(d), p = document.createElement("canvas"), m = p.getContext("2d");
		if (!m) {
			a(/* @__PURE__ */ Error("Canvas 2D context not available"));
			return;
		}
		let h = $.getResolution(), g = h.w, _ = h.h;
		p.width = g, p.height = _;
		let v = new Image();
		v.onload = () => {
			m.drawImage(v, 0, 0, g, _), URL.revokeObjectURL(f);
			let a = p.toDataURL(o, t), l, d = (l) => {
				let d = {
					datauri: a,
					bloburl: l,
					svg: u,
					issues: s,
					issueCodes: c,
					type: e,
					mimeType: o,
					quality: t,
					windowName: n
				};
				r.avoidEvent || $.call("exported", d), i(d);
			};
			p.toBlob((e) => {
				l = URL.createObjectURL(e), d(l);
			}, o, t);
		}, v.onerror = (e) => {
			console.error("Failed to load SVG into image element:", e), a(e);
		}, v.src = f;
	}).catch(a);
}), Pw = (e = "svg.pdf", t = sr() ? "save" : "dataurlstring") => new Promise((n, r) => {
	let i = $.getResolution(), a = i.w > i.h ? "landscape" : "portrait", o = $.getSvgContent().cloneNode(!0);
	Mw(o).then(() => {
		let s = new XMLSerializer().serializeToString(o), c = new Blob([s], { type: "image/svg+xml;charset=utf-8" }), l = URL.createObjectURL(c), u = document.createElement("canvas"), d = u.getContext("2d");
		u.width = i.w, u.height = i.h;
		let f = new Image();
		f.onload = () => {
			d.drawImage(f, 0, 0, i.w, i.h), URL.revokeObjectURL(l);
			let r = u.toDataURL("image/png"), o = new jb({
				orientation: a,
				unit: "pt",
				format: [i.w, i.h]
			}), s = $.getDocumentTitle();
			o.setProperties({ title: s }), o.addImage(r, "PNG", 0, 0, i.w, i.h);
			let { issues: c, issueCodes: p } = jw(), m = {
				issues: c,
				issueCodes: p,
				windowName: e,
				outputType: t
			};
			m.output = o.output(t, t === "save" ? e : void 0), $.call("exportedPDF", m), n(m);
		}, f.onerror = (e) => {
			h("Failed to load SVG into image element", e, "svg-exec"), r(e);
		}, f.src = l;
	}).catch(r);
}), Fw = (e) => {
	let t = {}, n = [
		"filter",
		"linearGradient",
		"pattern",
		"radialGradient",
		"symbol",
		"textPath",
		"use"
	];
	Se(e, (e) => {
		if (e.nodeType === 1) {
			e.id && (e.id in t || (t[e.id] = {
				elem: null,
				attrs: [],
				hrefs: []
			}), t[e.id].elem = e), $.getrefAttrs().forEach((n) => {
				let r = e.getAttributeNode(n);
				if (r) {
					let e = $.getUrlFromAttr(r.value), n = e ? e.substr(1) : null;
					n && (n in t || (t[n] = {
						elem: null,
						attrs: [],
						hrefs: []
					}), t[n].attrs.push(r));
				}
			});
			let r = $.getHref(e);
			if (r && n.includes(e.nodeName)) {
				let n = r.substr(1);
				n && (n in t || (t[n] = {
					elem: null,
					attrs: [],
					hrefs: []
				}), t[n].hrefs.push(e));
			}
		}
	});
	for (let e in t) {
		if (!e) continue;
		let { elem: n } = t[e];
		if (n) {
			let r = $.getNextId();
			n.id = r;
			let { attrs: i } = t[e], a = i.length;
			for (; a--;) {
				let e = i[a];
				e.ownerElement.setAttribute(e.name, `url(#${r})`);
			}
			let o = t[e].hrefs, s = o.length;
			for (; s--;) {
				let e = o[s];
				$.setHref(e, "#" + r);
			}
		}
	}
}, Iw = (e) => {
	let t = e;
	e.tagName !== "use" && (t = t.querySelectorAll("use")), Array.prototype.forEach.call(t, (e, t) => {
		let n = $.getDataStorage(), r = $.getHref(e);
		if (!r || !r.startsWith("#")) return;
		let i = r.substr(1), a = $.getElement(i);
		a && (n.put(e, "ref", a), (a.tagName === "symbol" || a.tagName === "svg") && (n.put(e, "symbol", a), n.put(e, "ref", a)));
	});
}, Lw = () => {
	let e = $.getSvgContent().getElementsByTagNameNS(A.SVG, "defs");
	if (!e || !e.length) return 0;
	let t = [], n = 0, r = [
		"fill",
		"stroke",
		"filter",
		"marker-start",
		"marker-mid",
		"marker-end"
	], i = r.length, a = $.getSvgContent().getElementsByTagNameNS(A.SVG, "*"), o = a.length, s, c;
	for (s = 0; s < o; s++) {
		let e = a[s];
		for (c = 0; c < i; c++) {
			let n = $.getUrlFromAttr(e.getAttribute(r[c]));
			n && t.push(n.substr(1));
		}
		let n = Te(e);
		n && n.startsWith("#") && t.push(n.substr(1));
	}
	return Array.prototype.forEach.call(e, (e, r) => {
		let i = e.querySelectorAll("linearGradient, radialGradient, filter, marker, svg, symbol");
		for (r = i.length; r--;) {
			let e = i[r], { id: a } = e;
			t.includes(a) || ($.setRemovedElements(a, e), e.remove(), n++);
		}
	}), n;
}, Rw = (e) => {
	let t = e.querySelectorAll("linearGradient, radialGradient");
	!t.length && ar() && (t = Array.prototype.filter.call(e.querySelectorAll("*"), (e) => e.tagName.includes("Gradient"))), Array.prototype.forEach.call(t, (e) => {
		if (e.getAttribute("gradientUnits") === "userSpaceOnUse") {
			let t = $.getSvgContent(), n = t.querySelectorAll("[fill=\"url(#" + e.id + ")\"],[stroke=\"url(#" + e.id + ")\"]");
			if (!n.length) {
				let r = t.querySelectorAll("[*|href=\"#" + e.id + "\"]");
				if (!r.length) return;
				if ((r[0].tagName === "linearGradient" || r[0].tagName === "radialGradient") && r[0].getAttribute("gradientUnits") === "userSpaceOnUse") n = t.querySelectorAll("[fill=\"url(#" + r[0].id + ")\"],[stroke=\"url(#" + r[0].id + ")\"]");
				else return;
			}
			let r = H(n[0]);
			if (!r) return;
			if (e.tagName === "linearGradient") {
				let t = {
					x1: e.getAttribute("x1"),
					y1: e.getAttribute("y1"),
					x2: e.getAttribute("x2"),
					y2: e.getAttribute("y2")
				}, n = I(e);
				if (n?.numberOfItems > 0) {
					let r = z(n).matrix, i = F(t.x1, t.y1, r), a = F(t.x2, t.y2, r);
					t.x1 = i.x, t.y1 = i.y, t.x2 = a.x, t.y2 = a.y, e.removeAttribute("gradientTransform");
				}
				e.setAttribute("x1", (t.x1 - r.x) / r.width), e.setAttribute("y1", (t.y1 - r.y) / r.height), e.setAttribute("x2", (t.x2 - r.x) / r.width), e.setAttribute("y2", (t.y2 - r.y) / r.height), e.removeAttribute("gradientUnits");
			} else if (e.tagName === "radialGradient") {
				let t = (e, t) => {
					let n = Number(e);
					return Number.isFinite(n) ? n : t;
				}, n = t(e.getAttribute("cx"), .5), i = t(e.getAttribute("cy"), .5), a = t(e.getAttribute("r"), .5), o = t(e.getAttribute("fx"), n), s = t(e.getAttribute("fy"), i), c = I(e);
				if (c?.numberOfItems > 0) {
					let t = z(c).matrix, r = F(n, i, t), l = F(o, s, t), u = F(n + a, i, t);
					n = r.x, i = r.y, o = l.x, s = l.y, a = Math.hypot(u.x - r.x, u.y - r.y), e.removeAttribute("gradientTransform");
				}
				if (!r.width || !r.height) return;
				e.setAttribute("cx", (n - r.x) / r.width), e.setAttribute("cy", (i - r.y) / r.height), e.setAttribute("fx", (o - r.x) / r.width), e.setAttribute("fy", (s - r.y) / r.height), e.setAttribute("r", a / Math.max(r.width, r.height)), e.removeAttribute("gradientUnits");
			}
		}
	});
}, zw, Bw = window.ontouchstart ? 10 : 4, Vw = class {
	#e = null;
	init(e) {
		zw = e, this.#e = new Uw();
	}
	getSelectorManager() {
		return this.#e;
	}
}, Hw = class e {
	constructor(e, t, n) {
		this.id = e, this.selectedElement = t, this.locked = !0, this.selectorGroup = zw.createSVGElement({
			element: "g",
			attr: { id: `selectorGroup${this.id}` }
		}), this.selectorRect = zw.createSVGElement({
			element: "path",
			attr: {
				id: `selectedBox${this.id}`,
				fill: "none",
				stroke: "#22C",
				"stroke-width": "1",
				"stroke-dasharray": "5,5",
				style: "pointer-events:none"
			}
		}), this.selectorGroup.append(this.selectorRect), this.gripCoords = {
			nw: null,
			n: null,
			ne: null,
			e: null,
			se: null,
			s: null,
			sw: null,
			w: null
		}, this.reset(this.selectedElement, n);
	}
	reset(e, t) {
		this.locked = !0, this.selectedElement = e, this.resize(t), this.selectorGroup.setAttribute("display", "inline");
	}
	showGrips(t) {
		let n = t ? "inline" : "none";
		Ww.getSelectorManager().selectorGripsGroup.setAttribute("display", n);
		let r = this.selectedElement;
		this.hasGrips = t, r && t && (this.selectorGroup.append(Ww.getSelectorManager().selectorGripsGroup), e.updateGripCursors(Be(r)));
	}
	resize(e) {
		let t = zw.getDataStorage(), n = this.selectorRect, r = Ww.getSelectorManager(), i = r.selectorGrips, a = this.selectedElement, o = zw.getZoom(), s = 1 / o, c = a.getAttribute("stroke-width");
		a.getAttribute("stroke") !== "none" && !isNaN(c) && (s += c / 2);
		let { tagName: l } = a;
		l === "text" && (s += 2 / o);
		let u = document.createElementNS(A.SVG, "svg").createSVGMatrix(), d = a;
		for (; d.parentNode;) d.parentNode && d.parentNode.tagName === "g" && d.parentNode.transform && d.parentNode.transform.baseVal.numberOfItems && (u = L(z(I(d.parentNode)).matrix, u)), d = d.parentNode;
		let f = I(a), p = u ? L(u, z(f).matrix) : z(f).matrix;
		if (p.e *= o, p.f *= o, e ||= H(a), l === "g" && !t.has(a, "gsvg")) {
			let t = Ie([a.childNodes]);
			t && (e = t);
		}
		if (e) {
			let t = e.x, c = e.y, l = e.width, u = e.height;
			s *= o;
			let d = te(t * o, c * o, l * o, u * o, p), { aabox: f } = d, m = f.x - s, h = f.y - s, g = f.width + s * 2, _ = f.height + s * 2, v = m + g / 2, y = h + _ / 2, b = Be(a);
			if (b) {
				let e = zw.getSvgRoot().createSVGTransform();
				e.setRotate(-b, v, y);
				let t = e.matrix;
				d.tl = F(d.tl.x, d.tl.y, t), d.tr = F(d.tr.x, d.tr.y, t), d.bl = F(d.bl.x, d.bl.y, t), d.br = F(d.br.x, d.br.y, t);
				let { tl: n } = d, r = n.x, i = n.y, a = n.x, o = n.y, { min: c, max: l } = Math;
				r = c(r, c(d.tr.x, c(d.bl.x, d.br.x))) - s, i = c(i, c(d.tr.y, c(d.bl.y, d.br.y))) - s, a = l(a, l(d.tr.x, l(d.bl.x, d.br.x))) + s, o = l(o, l(d.tr.y, l(d.bl.y, d.br.y))) + s, m = r, h = i, g = a - r, _ = o - i;
			}
			let x = `M${m},${h} L${m + g},${h} ${m + g},${h + _} ${m},${h + _}z`, S = b ? "rotate(" + [
				b,
				v,
				y
			].join(",") + ")" : "";
			this.gripCoords = {
				nw: [m, h],
				ne: [m + g, h],
				sw: [m, h + _],
				se: [m + g, h + _],
				n: [m + g / 2, h],
				w: [m, h + _ / 2],
				e: [m + g, h + _ / 2],
				s: [m + g / 2, h + _]
			}, n.setAttribute("d", x), this.selectorGroup.setAttribute("transform", S), Object.entries(this.gripCoords).forEach(([e, t]) => {
				i[e].setAttribute("cx", t[0]), i[e].setAttribute("cy", t[1]);
			}), r.rotateGripConnector.setAttribute("x1", m + g / 2), r.rotateGripConnector.setAttribute("y1", h), r.rotateGripConnector.setAttribute("x2", m + g / 2), r.rotateGripConnector.setAttribute("y2", h - Bw * 5), r.rotateGrip.setAttribute("cx", m + g / 2), r.rotateGrip.setAttribute("cy", h - Bw * 5);
		}
	}
	static updateGripCursors(e) {
		let t = Object.keys(Ww.getSelectorManager().selectorGrips), n = Math.round(e / 45);
		for (n < 0 && (n += 8); n > 0;) t.push(t.shift()), n--;
		Object.values(Ww.getSelectorManager().selectorGrips).forEach((e, n) => {
			e.setAttribute("style", `cursor:${t[n]}-resize`);
		});
	}
}, Uw = class {
	constructor() {
		this.selectorParentGroup = null, this.rubberBandBox = null, this.selectors = [], this.selectorMap = {}, this.selectorGrips = {
			nw: null,
			n: null,
			ne: null,
			e: null,
			se: null,
			s: null,
			sw: null,
			w: null
		}, this.selectorGripsGroup = null, this.rotateGripConnector = null, this.rotateGrip = null, this.initGroup();
	}
	initGroup() {
		let e = zw.getDataStorage();
		if (this.selectorParentGroup?.parentNode && this.selectorParentGroup.remove(), this.selectorParentGroup = zw.createSVGElement({
			element: "g",
			attr: { id: "selectorParentGroup" }
		}), this.selectorGripsGroup = zw.createSVGElement({
			element: "g",
			attr: { display: "none" }
		}), this.selectorParentGroup.append(this.selectorGripsGroup), zw.getSvgRoot().append(this.selectorParentGroup), this.selectorMap = {}, this.selectors = [], this.rubberBandBox = null, Object.keys(this.selectorGrips).forEach((t) => {
			let n = zw.createSVGElement({
				element: "circle",
				attr: {
					id: `selectorGrip_resize_${t}`,
					fill: "#22C",
					r: Bw,
					style: `cursor:${t}-resize`,
					"stroke-width": 2,
					"pointer-events": "all"
				}
			});
			e.put(n, "dir", t), e.put(n, "type", "resize"), this.selectorGrips[t] = n, this.selectorGripsGroup.append(n);
		}), this.rotateGripConnector = zw.createSVGElement({
			element: "line",
			attr: {
				id: "selectorGrip_rotateconnector",
				stroke: "#22C",
				"stroke-width": "1"
			}
		}), this.selectorGripsGroup.append(this.rotateGripConnector), this.rotateGrip = zw.createSVGElement({
			element: "circle",
			attr: {
				id: "selectorGrip_rotate",
				fill: "lime",
				r: Bw,
				stroke: "#22C",
				"stroke-width": 2,
				style: `cursor:url(${zw.curConfig.imgPath}/rotate.svg) 12 12, auto;`
			}
		}), this.selectorGripsGroup.append(this.rotateGrip), e.put(this.rotateGrip, "type", "rotate"), document.getElementById("canvasBackground")) return;
		let [t, n] = zw.curConfig.dimensions, r = zw.createSVGElement({
			element: "svg",
			attr: {
				id: "canvasBackground",
				width: t,
				height: n,
				x: 0,
				y: 0,
				overflow: ar() ? "none" : "visible",
				style: "pointer-events:none"
			}
		}), i = zw.createSVGElement({
			element: "rect",
			attr: {
				width: "100%",
				height: "100%",
				x: 0,
				y: 0,
				"stroke-width": 1,
				stroke: "#000",
				fill: "#FFF",
				style: "pointer-events:none"
			}
		});
		r.append(i), zw.getSvgRoot().insertBefore(r, zw.getSvgContent());
	}
	requestSelector(e, t) {
		if (!e) return null;
		let n = this.selectors.length;
		if (typeof this.selectorMap[e.id] == "object") return this.selectorMap[e.id].locked = !0, this.selectorMap[e.id];
		for (let r = 0; r < n; ++r) if (!this.selectors[r]?.locked) return this.selectors[r].locked = !0, this.selectors[r].reset(e, t), this.selectorMap[e.id] = this.selectors[r], this.selectors[r];
		return this.selectors[n] = new Hw(n, e, t), this.selectorParentGroup.append(this.selectors[n].selectorGroup), this.selectorMap[e.id] = this.selectors[n], this.selectors[n];
	}
	releaseSelector(e) {
		if (!e) return;
		let t = this.selectors.length, n = this.selectorMap[e.id];
		n?.locked || g("WARNING! selector was released but was already unlocked", null, "select");
		for (let r = 0; r < t; ++r) if (this.selectors[r] && this.selectors[r] === n) {
			delete this.selectorMap[e.id], n.locked = !1, n.selectedElement = null, n.showGrips(!1);
			try {
				n.selectorGroup.setAttribute("display", "none");
			} catch {}
			break;
		}
	}
	getRubberBandBox() {
		return this.rubberBandBox || (this.rubberBandBox = zw.createSVGElement({
			element: "rect",
			attr: {
				id: "selectorRubberBand",
				fill: "#22C",
				"fill-opacity": .15,
				stroke: "#22C",
				"stroke-width": .5,
				display: "none",
				style: "pointer-events:none"
			}
		}), this.selectorParentGroup.append(this.rubberBandBox)), this.rubberBandBox;
	}
}, Ww = new Vw(), Gw = (e) => {
	Ww.init(e);
}, Kw = () => Ww.getSelectorManager(), qw = null, Jw = (e) => {
	qw = e;
}, Yw = () => {
	let e = qw.getCurConfig(), { dimensions: t } = e, n = qw.getSvgContent();
	for (; n.firstChild;) n.removeChild(n.firstChild);
	for (let e of Array.from(n.attributes)) e.namespaceURI ? n.removeAttributeNS(e.namespaceURI, e.localName) : n.removeAttribute(e.name);
	let r = qw.getSvgRoot();
	n.setAttribute("id", "svgcontent"), n.setAttribute("width", t[0]), n.setAttribute("height", t[1]), n.setAttribute("x", t[0]), n.setAttribute("y", t[1]), n.setAttribute("overflow", e.show_outside_canvas ? "visible" : "hidden"), n.setAttribute("xmlns", A.SVG), n.setAttribute("xmlns:se", A.SE), n.setAttribute("xmlns:xlink", A.XLINK), n.parentNode !== r && r.appendChild(n);
	let i = qw.getDOMDocument().createComment(" Created with SVG-edit - https://github.com/SVG-Edit/svgedit");
	n.append(i);
}, Xw = "a,circle,ellipse,foreignObject,g,image,line,path,polygon,polyline,rect,svg,text,tspan,use", Zw = [
	"clip-path",
	"fill",
	"filter",
	"marker-end",
	"marker-mid",
	"marker-start",
	"mask",
	"stroke"
], Qw = .8, $w = 10, eT = "svgedit_clipboard", tT = class e {
	constructor(t, n) {
		this.initializeSvgCanvasMethods(), C(this);
		let { pathActions: r } = Nt;
		this.saveOptions = { round_digits: 2 }, this.importIds = {}, this.extensions = {}, this.removedElements = {}, this.started = !1, this.startTransform = null, this.currentMode = "select", this.currentResizeMode = "none", this.justSelected = null, this.rubberBox = null, this.curBBoxes = [], this.lastClickPoint = null, this.events = {}, this.rootSctm = null, this.drawnPath = null, this.freehand = {
			minx: null,
			miny: null,
			maxx: null,
			maxy: null
		}, this.dAttr = null, this.startX = null, this.startY = null, this.rStartX = null, this.rStartY = null, this.initBbox = {}, this.sumDistance = 0, this.controllPoint2 = {
			x: 0,
			y: 0
		}, this.controllPoint1 = {
			x: 0,
			y: 0
		}, this.start = {
			x: 0,
			y: 0
		}, this.end = {
			x: 0,
			y: 0
		}, this.bSpline = {
			x: 0,
			y: 0
		}, this.nextPos = {
			x: 0,
			y: 0
		}, this.idprefix = "svg_", this.encodableImages = {}, this.curConfig = {
			show_outside_canvas: !0,
			selectNew: !0,
			dimensions: [640, 480]
		}, n && (this.curConfig = e.mergeDeep(this.curConfig, n)), this.lastGoodImgUrl = `${this.curConfig.imgPath}/logo.svg`;
		let { dimensions: i } = this.curConfig;
		this.svgdoc = window.document, this.container = t, this.svgroot = nr(this.svgdoc, i), t.append(this.svgroot), this.svgContent = this.svgdoc.createElementNS(A.SVG, "svg"), tr(this), Jw(this), this.clearSvgContentElement(), this.current_drawing_ = new jn(this.svgContent, this.idprefix), this.zoom = 1, this.currentGroup = null;
		let a = { shape: {
			fill: (this.curConfig.initFill.color === "none" ? "" : "#") + this.curConfig.initFill.color,
			fill_paint: null,
			fill_opacity: this.curConfig.initFill.opacity,
			stroke: (this.curConfig.initStroke.color === "none" ? "" : "#") + this.curConfig.initStroke.color,
			stroke_paint: null,
			stroke_opacity: this.curConfig.initStroke.opacity,
			stroke_width: this.curConfig.initStroke.width,
			stroke_dasharray: "none",
			stroke_linejoin: "miter",
			stroke_linecap: "butt",
			opacity: this.curConfig.initOpacity
		} };
		a.text = e.mergeDeep({}, a.shape), a.text = e.mergeDeep(a.text, {
			fill: "#000000",
			stroke_width: this.curConfig.text?.stroke_width,
			font_size: this.curConfig.text?.font_size,
			font_family: this.curConfig.text?.font_family
		}), this.curText = a.text, this.curShape = a.shape, this.curProperties = this.curShape, this.selectedElements = [], Yr(this), fe(this), Ki(this), Xi(this), Gw(this), fr(this), yr(this), this.nsMap = j(), this.selectorManager = Kw(), this.pathActions = r, Ut(this), this.uiStrings = {}, this.opacAni = document.createElementNS(A.SVG, "animate"), this.opacAni.setAttribute("attributeName", "opacity"), this.opacAni.setAttribute("begin", "indefinite"), this.opacAni.setAttribute("dur", 1), this.opacAni.setAttribute("fill", "freeze"), this.svgroot.appendChild(this.opacAni), Lr(this), jr(this), Tw(this), Pn(this), Qr(this), t.addEventListener("mousedown", this.mouseDownEvent), t.addEventListener("mousemove", this.mouseMoveEvent), $e(t, (e) => (e.preventDefault(), !1)), t.addEventListener("dblclick", this.dblClickEvent), t.addEventListener("mouseup", this.mouseUpEvent), t.addEventListener("mouseleave", this.mouseOutEvent), t.addEventListener("mousewheel", this.DOMMouseScrollEvent), t.addEventListener("DOMMouseScroll", this.DOMMouseScrollEvent), this.linkControlPoints = r.linkControlPoints, this.curCommand = null, this.filter = null, this.filterHidden = !1, wa(this), ia(this), window.addEventListener("storage", (e) => {
			e.newValue && (e.key === `${eT}_startup` ? (localStorage.removeItem(`${eT}_startup`), this.flashStorage()) : e.key === eT && sessionStorage.setItem(eT, e.newValue));
		}, !1), localStorage.setItem(`${eT}_startup`, Math.random()), Qn(this), this.contentW = this.getResolution().w, this.contentH = this.getResolution().h, this.clear(), this.modeChangeEvent();
	}
	getSvgOption() {
		return this.saveOptions;
	}
	setSvgOption(e, t) {
		this.saveOptions[e] = t;
	}
	getSelectedElements() {
		return this.selectedElements;
	}
	setSelectedElements(e, t) {
		this.selectedElements[e] = t;
	}
	setEmptySelectedElements() {
		this.selectedElements = [];
	}
	getSvgRoot() {
		return this.svgroot;
	}
	getDOMDocument() {
		return this.svgdoc;
	}
	getDOMContainer() {
		return this.container;
	}
	getCurConfig() {
		return this.curConfig;
	}
	setIdPrefix(e) {
		this.idprefix = e;
	}
	getCurrentDrawing() {
		return this.current_drawing_;
	}
	getCurShape() {
		return this.curShape;
	}
	getCurrentGroup() {
		return this.currentGroup;
	}
	getBaseUnit() {
		return this.curConfig.baseUnit;
	}
	getHeight() {
		return this.svgContent.getAttribute("height") / this.zoom;
	}
	getWidth() {
		return this.svgContent.getAttribute("width") / this.zoom;
	}
	getRoundDigits() {
		return this.saveOptions.round_digits;
	}
	getSnappingStep() {
		return this.curConfig.snappingStep;
	}
	getGridSnapping() {
		return this.curConfig.gridSnapping;
	}
	getStartTransform() {
		return this.startTransform;
	}
	setStartTransform(e) {
		this.startTransform = e;
	}
	getZoom() {
		return this.zoom;
	}
	round(e) {
		return Number.parseInt(e * this.zoom) / this.zoom;
	}
	createSVGElement(e) {
		return this.addSVGElementsFromJson(e);
	}
	getContainer() {
		return this.container;
	}
	setStarted(e) {
		this.started = e;
	}
	getRubberBox() {
		return this.rubberBox;
	}
	setRubberBox(e) {
		return this.rubberBox = e, this.rubberBox;
	}
	addPtsToSelection({ closedSubpath: e, grips: t }) {
		this.pathActions.canDeleteNodes = !0, this.pathActions.closed_subpath = e, this.call("pointsAdded", {
			closedSubpath: e,
			grips: t
		}), this.call("selected", t);
	}
	endChanges({ cmd: e, elem: t }) {
		this.addCommandToHistory(e), this.call("changed", [t]);
	}
	getCurrentMode() {
		return this.currentMode;
	}
	setCurrentMode(e) {
		return this.currentMode = e, this.currentMode;
	}
	getDrawnPath() {
		return this.drawnPath;
	}
	setDrawnPath(e) {
		return this.drawnPath = e, this.drawnPath;
	}
	setCurrentGroup(e) {
		this.currentGroup = e;
	}
	changeSvgContent() {
		this.call("changed", [this.svgContent]);
	}
	getStarted() {
		return this.started;
	}
	getCanvas() {
		return this;
	}
	getrootSctm() {
		return this.rootSctm;
	}
	getStartX() {
		return this.startX;
	}
	setStartX(e) {
		this.startX = e;
	}
	getStartY() {
		return this.startY;
	}
	setStartY(e) {
		this.startY = e;
	}
	getRStartX() {
		return this.rStartX;
	}
	getRStartY() {
		return this.rStartY;
	}
	getInitBbox() {
		return this.initBbox;
	}
	getCurrentResizeMode() {
		return this.currentResizeMode;
	}
	getJustSelected() {
		return this.justSelected;
	}
	getOpacAni() {
		return this.opacAni;
	}
	getParameter() {
		return this.parameter;
	}
	getNextParameter() {
		return this.nextParameter;
	}
	getStepCount() {
		return $w;
	}
	getThreSholdDist() {
		return Qw;
	}
	getSumDistance() {
		return this.sumDistance;
	}
	getStart(e) {
		return this.start[e];
	}
	getEnd(e) {
		return this.end[e];
	}
	getbSpline(e) {
		return this.bSpline[e];
	}
	getNextPos(e) {
		return this.nextPos[e];
	}
	getControllPoint1(e) {
		return this.controllPoint1[e];
	}
	getControllPoint2(e) {
		return this.controllPoint2[e];
	}
	getFreehand(e) {
		return this.freehand[e];
	}
	getDrawing() {
		return this.getCurrentDrawing();
	}
	getDAttr() {
		return this.dAttr;
	}
	getLastGoodImgUrl() {
		return this.lastGoodImgUrl;
	}
	getCurText(e) {
		return this.curText[e];
	}
	setDAttr(e) {
		this.dAttr = e;
	}
	setEnd(e, t) {
		this.end[e] = t;
	}
	setControllPoint1(e, t) {
		this.controllPoint1[e] = t;
	}
	setControllPoint2(e, t) {
		this.controllPoint2[e] = t;
	}
	setJustSelected(e) {
		this.justSelected = e;
	}
	setParameter(e) {
		this.parameter = e;
	}
	setStart(e) {
		this.start = e;
	}
	setRStartX(e) {
		this.rStartX = e;
	}
	setRStartY(e) {
		this.rStartY = e;
	}
	setSumDistance(e) {
		this.sumDistance = e;
	}
	setbSpline(e) {
		this.bSpline = e;
	}
	setNextPos(e) {
		this.nextPos = e;
	}
	setNextParameter(e) {
		this.nextParameter = e;
	}
	setCurText(e, t) {
		this.curText[e] = t;
	}
	setFreehand(e, t) {
		this.freehand[e] = t;
	}
	setCurBBoxes(e) {
		this.curBBoxes = e;
	}
	getCurBBoxes() {
		return this.curBBoxes;
	}
	setInitBbox(e) {
		this.initBbox = e;
	}
	setRootSctm(e) {
		this.rootSctm = e;
	}
	setCurrentResizeMode(e) {
		this.currentResizeMode = e;
	}
	getLastClickPoint(e) {
		return this.lastClickPoint[e];
	}
	setLastClickPoint(e) {
		this.lastClickPoint = e;
	}
	getId() {
		return this.getCurrentDrawing().getId();
	}
	getUIStrings() {
		return this.uiStrings;
	}
	getNsMap() {
		return this.nsMap;
	}
	getSvgOptionApply() {
		return this.saveOptions.apply;
	}
	getSvgOptionImages() {
		return this.saveOptions.images;
	}
	getEncodableImages(e) {
		return this.encodableImages[e];
	}
	setEncodableImages(e, t) {
		this.encodableImages[e] = t;
	}
	getVisElems() {
		return Xw;
	}
	getIdPrefix() {
		return this.idprefix;
	}
	getDataStorage() {
		return xn;
	}
	setZoom(e) {
		this.zoom = e;
	}
	getImportIds(e) {
		return this.importIds[e];
	}
	setImportIds(e, t) {
		this.importIds[e] = t;
	}
	setRemovedElements(e, t) {
		this.removedElements[e] = t;
	}
	setSvgContent(e) {
		this.svgContent = e;
	}
	getrefAttrs() {
		return Zw;
	}
	setCanvas(e, t) {
		this[e] = t;
	}
	setCurProperties(e, t) {
		this.curProperties[e] = t;
	}
	getCurProperties(e) {
		return this.curProperties[e];
	}
	setCurShape(e, t) {
		this.curShape[e] = t;
	}
	gettingSelectorManager() {
		return this.selectorManager;
	}
	getContentW() {
		return this.contentW;
	}
	getContentH() {
		return this.contentH;
	}
	getClipboardID() {
		return eT;
	}
	getSvgContent() {
		return this.svgContent;
	}
	getExtensions() {
		return this.extensions;
	}
	getSelector() {
		return Hw;
	}
	getMode() {
		return this.currentMode;
	}
	getNextId() {
		return this.getCurrentDrawing().getNextId();
	}
	getCurCommand() {
		return this.curCommand;
	}
	setCurCommand(e) {
		this.curCommand = e;
	}
	getFilter() {
		return this.filter;
	}
	setFilter(e) {
		this.filter = e;
	}
	getFilterHidden() {
		return this.filterHidden;
	}
	setFilterHidden(e) {
		this.filterHidden = e;
	}
	setMode(e) {
		this.pathActions.clear(!0), this.textActions.clear(), this.curProperties = this.selectedElements[0]?.nodeName === "text" ? this.curText : this.curShape, this.currentMode = e, this.modeEvent && document.dispatchEvent(this.modeEvent);
	}
	clear() {
		this.call("beforeClear"), this.pathActions.clear(), this.clearSelection(), this.clearSvgContentElement(), this.current_drawing_ = new jn(this.svgContent), this.createLayer(), this.undoMgr.resetUndoStack(), this.selectorManager.initGroup(), this.rubberBox = this.selectorManager.getRubberBandBox(), this.call("afterClear");
	}
	async addExtension(e, t, { importLocale: n }) {
		if (typeof t != "function") throw TypeError("Function argument expected for `svgcanvas.addExtension`");
		if (e in this.extensions) throw Error("Cannot add extension \"" + e + "\", an extension by that name already exists.");
		let r = await t({
			importLocale: n,
			svgroot: this.svgroot,
			svgContent: this.svgContent,
			nonce: this.getCurrentDrawing().getNonce(),
			selectorManager: this.selectorManager
		});
		return r && (r.name = e), this.extensions[e] = r, this.call("extension_added", r);
	}
	addCommandToHistory(e) {
		this.undoMgr.addCommandToHistory(e);
	}
	restoreRefElements(e) {
		let t = {};
		Zw.forEach((n, r) => {
			t[n] = e.getAttribute(n);
		}), Object.values(t).forEach((e) => {
			if (e?.startsWith("url(")) {
				let t = we(e).slice(1);
				Ue(t) || (De().append(this.removedElements[t]), delete this.removedElements[t]);
			}
		});
		let n = e.getElementsByTagName("*");
		if (n.length) for (let e = 0, t = n.length; e < t; e++) this.restoreRefElements(n[e]);
	}
	call(e, t) {
		if (this.events[e]) return this.events[e](window, t);
	}
	bind(e, t) {
		let n = this.events[e];
		return this.events[e] = t, n;
	}
	flashStorage() {
		let e = sessionStorage.getItem(eT);
		localStorage.setItem(eT, e), setTimeout(() => {
			localStorage.removeItem(eT);
		}, 1);
	}
	selectOnly(e, t) {
		this.clearSelection(!0), this.addToSelection(e, t);
	}
	removeFromSelection(e) {
		if (!this.selectedElements[0] || !e.length) return;
		let t = [], n = this.selectedElements.length;
		for (let r = 0; r < n; ++r) {
			let n = this.selectedElements[r];
			n && (e.includes(n) ? this.selectorManager.releaseSelector(n) : t.push(n));
		}
		this.selectedElements = t;
	}
	selectAllInCurrentLayer() {
		let e = this.getCurrentDrawing().getCurrentLayer();
		e && (this.currentMode = "select", this.currentGroup ? this.selectOnly(this.currentGroup.children) : this.selectOnly(e.children));
	}
	getOpacity() {
		return this.curShape.opacity;
	}
	getSnapToGrid() {
		return this.curConfig.gridSnapping;
	}
	getVersion() {
		return "svgcanvas.js ($Rev$)";
	}
	setUiStrings(e) {
		Object.assign(this.uiStrings, e.notification), Lt(e);
	}
	setConfig(e) {
		Object.assign(this.curConfig, e);
	}
	getDocumentTitle() {
		return this.getTitle(this.svgContent);
	}
	getOffset() {
		return {
			x: Number(this.svgContent.getAttribute("x")),
			y: Number(this.svgContent.getAttribute("y"))
		};
	}
	getColor(e) {
		return this.curProperties[e];
	}
	setStrokePaint(e) {
		this.setPaint("stroke", e);
	}
	setFillPaint(e) {
		this.setPaint("fill", e);
	}
	getStrokeWidth() {
		return this.curProperties.stroke_width;
	}
	getStyle() {
		return this.curShape;
	}
	setOpacity(e) {
		this.curShape.opacity = e, this.changeSelectedAttribute("opacity", e);
	}
	getFillOpacity() {
		return this.curShape.fill_opacity;
	}
	getStrokeOpacity() {
		return this.curShape.stroke_opacity;
	}
	setPaintOpacity(e, t, n) {
		this.curShape[`${e}_opacity`] = t, n ? this.changeSelectedAttributeNoUndo(`${e}-opacity`, t) : this.changeSelectedAttribute(`${e}-opacity`, t);
	}
	getPaintOpacity(e) {
		return e === "fill" ? this.getFillOpacity() : this.getStrokeOpacity();
	}
	getBlur(e) {
		let t = 0;
		if (e) {
			let n = e.getAttribute("filter");
			if (n) {
				let r = Ue(`${e.id}_blur`);
				if (r) t = r.firstChild.getAttribute("stdDeviation");
				else {
					let e = He(Ve(n));
					e !== null && (t = e.getAttribute("stdDeviation"));
				}
			}
		}
		return t;
	}
	setGoodImage(e) {
		this.lastGoodImgUrl = e;
	}
	getSvgString() {
		return this.saveOptions.apply = !1, this.svgCanvasToString();
	}
	randomizeIds(e) {
		arguments.length > 0 && e === !1 ? Mn(!1, this.getCurrentDrawing()) : Mn(!0, this.getCurrentDrawing());
	}
	convertToPath(e, t) {
		if (!e) {
			this.selectedElements.forEach((e) => {
				e && this.convertToPath(e);
			});
			return;
		}
		return t ? je(e, this.addSVGElementsFromJson, this.pathActions) : Me(e, {
			fill: this.curShape.fill,
			"fill-opacity": this.curShape.fill_opacity,
			stroke: this.curShape.stroke,
			"stroke-width": this.curShape.stroke_width,
			"stroke-dasharray": this.curShape.stroke_dasharray,
			"stroke-linejoin": this.curShape.stroke_linejoin,
			"stroke-linecap": this.curShape.stroke_linecap,
			"stroke-opacity": this.curShape.stroke_opacity,
			opacity: this.curShape.opacity,
			visibility: "hidden"
		}, this);
	}
	cutSelectedElements() {
		this.copySelectedElements(), this.deleteSelectedElements();
	}
	initializeSvgCanvasMethods() {
		this.getJsonFromSvgElements = Xr, this.addSVGElementsFromJson = Zr, this.clearSvgContentElement = Yw, this.textActions = Mr, this.getStrokedBBox = Re, this.getVisibleElements = Le, this.stringToHTML = Je, this.insertChildAtIndex = Ye, this.getClosest = se, this.getParents = ce, this.isLayer = vn.isLayer, this.matrixMultiply = L, this.hasMatrixTransform = R, this.transformListToTransform = z, this.convertToNum = O, this.convertUnit = E, this.findDefs = De, this.getUrlFromAttr = we, this.getHref = Te, this.setHref = Ee, this.getBBox = H, this.getRotationAngle = Be, this.getElement = Ue, this.getRefElem = Ve, this.assignAttributes = We, this.cleanupElement = Ge, this.remapElement = Ji, this.recalculateDimensions = Qi, this.sanitizeSvg = Pa, this.pasteElements = $n, this.identifyLayers = Fn, this.createLayer = Ln, this.cloneLayer = Rn, this.deleteCurrentLayer = zn, this.setCurrentLayer = Bn, this.renameCurrentLayer = Vn, this.setCurrentLayerPosition = Hn, this.indexCurrentLayer = In, this.setLayerVisibility = Un, this.moveSelectedToLayer = Wn, this.mergeLayer = Gn, this.mergeAllLayers = Kn, this.leaveContext = qn, this.setContext = Jn, this.changeSelectedAttributeNoUndo = hr, this.changeSelectedAttribute = gr, this.setBlurNoUndo = Ea, this.setBlurOffsets = Oa, this.setBlur = J, this.smoothControlPoints = tn, this.getTypeMap = w, this.history = et, this.NS = A, this.$id = Xe, this.$qq = Ze, this.$qa = Qe, this.$click = $e, this.encode64 = me, this.decode64 = he, this.mergeDeep = oe;
	}
	modeChangeEvent() {
		let e = new CustomEvent("modeChange", { detail: { getMode: () => this.getMode() } });
		this.modeEvent = e;
	}
};
tT.$id = Xe, tT.$qq = Ze, tT.$qa = Qe, tT.$click = $e, tT.encode64 = me, tT.decode64 = he, tT.mergeDeep = oe, tT.getClosest = se, tT.getParents = ce, tT.blankPageObjectURL = ye, tT.Paint = d, tT.getTypeMap = w, tT.convertToNum = O, tT.isValidUnit = k, tT.convertUnit = E;
//#endregion
export { tT as default };

//# sourceMappingURL=svgcanvas.js.map